webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/1Cn5kMb/%3F1737195674968&title=Eerdmans%20Commentary%20on%20the%20Bible&summary=No%20one%20familiar%20with%20the%20Bible%20needs%20to%20be%20told%20that%20it%20is%20a%20truly%20remarkable%20work.%20But%20it%20takes%20help%20to%20understand%20this%20ancient%20collection%20of%20diverse%20forms%20of%20literature%20written%20by%20different%20people%20across%20many%20centuries.%20The%26%23160%3BEerdmans%20Commentar&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/1Cn5kMb/%3F1737195674968",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=No%20one%20familiar%20with%20the%20Bible%20needs%20to%20be%20told%20that%20it%20is%20a%20truly%20remarkable%20work.%20But%20it%20takes%20help%20to%20understand%20this%20ancient%20collection%20o%0Dhttps://textcafe.co/books/1Cn5kMb/%3F1737195674968&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/1Cn5kMb/%3F1737195674968&posttype=link&caption=No%20one%20familiar%20with%20the%20Bible%20needs%20to%20be%20told%20that%20it%20is%20a%20truly%20remarkable%20work.%20But%20it%20takes%20help%20to%20understand%20this%20ancient%20collection%20of%20diverse%20forms%20of%20literature%20written%20by%20different%20people%20across%20many%20centuries.%20The%26%23160%3BEerdmans%20Commentar",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/1Cn5kMb/%3F1737195674968&description=No%20one%20familiar%20with%20the%20Bible%20needs%20to%20be%20told%20that%20it%20is%20a%20truly%20remarkable%20work.%20But%20it%20takes%20help%20to%20understand%20this%20ancient%20collection%20of%20diverse%20forms%20of%20literature%20written%20by%20different%20people%20across%20many%20centuries.%20The%26%23160%3BEerdmans%20Commentar&media=https://textcafe.co/books/1Cn5kMb/tc-custom/9781467426824.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/dp/B08WRDS62L?tag=mobilebookcom-20&ref=nosim',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=exidDwAAQBAJ&amp;rdid=book-exidDwAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }, {
        title: 'Kobo',
        img: 'https://textcafe.co/global-css/img/kobo_appicon.svg',
        url: 'https://www.kobo.com/us/en/search?Query=9781467426824',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781467426824').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/1Cn5kMb/tc-custom/9781467426824.jpg?1737195674968',
        alt: 'Eerdmans Commentary on the Bible'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "xhtml/contents", "xhtml/preface", "xhtml/contributors", "xhtml/abbreviations", "xhtml/chapter001", "xhtml/chapter002", "xhtml/chapter003", "xhtml/chapter004", "xhtml/chapter005", "xhtml/chapter006", "xhtml/chapter007", "xhtml/chapter008", "xhtml/chapter009", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/1Cn5kMb/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_xhtml_title__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_xhtml_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_xhtml_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_xhtml_copyright__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_xhtml_copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_xhtml_copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_xhtml_contents__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_xhtml_contents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_xhtml_contents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_xhtml_preface__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_xhtml_preface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_xhtml_preface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_xhtml_contributors__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_xhtml_contributors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_xhtml_contributors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_xhtml_abbreviations__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_xhtml_abbreviations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_xhtml_abbreviations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_xhtml_chapter001__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_xhtml_chapter001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_xhtml_chapter001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_xhtml_chapter002__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_xhtml_chapter002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_xhtml_chapter002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_xhtml_chapter003__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_xhtml_chapter003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_xhtml_chapter003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_xhtml_chapter004__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_xhtml_chapter004___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_xhtml_chapter004__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_xhtml_chapter005__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_xhtml_chapter005___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_xhtml_chapter005__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_xhtml_chapter006__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_xhtml_chapter006___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_xhtml_chapter006__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_xhtml_chapter007__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_xhtml_chapter007___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_xhtml_chapter007__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_xhtml_chapter008__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_xhtml_chapter008___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_xhtml_chapter008__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_xhtml_chapter009__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_xhtml_chapter009___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_xhtml_chapter009__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_xhtml_chapter010__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_xhtml_chapter010___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_xhtml_chapter010__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_xhtml_chapter011__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_xhtml_chapter011___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_xhtml_chapter011__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_xhtml_chapter012__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_xhtml_chapter012___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_xhtml_chapter012__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_xhtml_chapter013__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_xhtml_chapter013___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_xhtml_chapter013__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_xhtml_chapter014__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_xhtml_chapter014___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_xhtml_chapter014__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_xhtml_chapter015__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_xhtml_chapter015___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_xhtml_chapter015__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_xhtml_chapter016__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_xhtml_chapter016___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_xhtml_chapter016__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_xhtml_chapter017__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_xhtml_chapter017___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_xhtml_chapter017__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_xhtml_chapter018__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_xhtml_chapter018___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_xhtml_chapter018__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_xhtml_chapter019__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_xhtml_chapter019___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_xhtml_chapter019__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_xhtml_chapter020__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_xhtml_chapter020___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_xhtml_chapter020__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_xhtml_chapter021__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_xhtml_chapter021___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_xhtml_chapter021__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_xhtml_chapter022__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_xhtml_chapter022___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_xhtml_chapter022__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_xhtml_chapter023__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_xhtml_chapter023___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_xhtml_chapter023__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_xhtml_chapter024__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_xhtml_chapter024___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_xhtml_chapter024__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_xhtml_chapter025__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_xhtml_chapter025___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_xhtml_chapter025__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_xhtml_chapter026__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_xhtml_chapter026___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_xhtml_chapter026__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_xhtml_chapter027__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_xhtml_chapter027___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_xhtml_chapter027__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_xhtml_chapter028__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_xhtml_chapter028___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_xhtml_chapter028__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_xhtml_chapter029__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_xhtml_chapter029___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_xhtml_chapter029__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_xhtml_chapter030__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_xhtml_chapter030___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_xhtml_chapter030__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_xhtml_chapter031__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_xhtml_chapter031___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_xhtml_chapter031__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_xhtml_chapter032__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_xhtml_chapter032___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_xhtml_chapter032__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_xhtml_chapter033__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_xhtml_chapter033___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_xhtml_chapter033__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_xhtml_chapter034__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_xhtml_chapter034___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_xhtml_chapter034__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_xhtml_chapter035__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_xhtml_chapter035___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_xhtml_chapter035__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_xhtml_chapter036__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_xhtml_chapter036___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_xhtml_chapter036__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_xhtml_chapter037__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_xhtml_chapter037___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_xhtml_chapter037__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_xhtml_chapter038__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_xhtml_chapter038___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_xhtml_chapter038__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_xhtml_chapter039__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_xhtml_chapter039___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_xhtml_chapter039__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_xhtml_chapter040__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_xhtml_chapter040___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_xhtml_chapter040__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_xhtml_chapter041__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_xhtml_chapter041___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_xhtml_chapter041__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_xhtml_chapter042__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_xhtml_chapter042___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_xhtml_chapter042__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_xhtml_chapter043__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_xhtml_chapter043___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_xhtml_chapter043__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_xhtml_chapter044__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_xhtml_chapter044___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_xhtml_chapter044__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_xhtml_chapter045__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_xhtml_chapter045___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_xhtml_chapter045__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_xhtml_chapter046__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_xhtml_chapter046___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_xhtml_chapter046__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_xhtml_chapter047__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_xhtml_chapter047___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_xhtml_chapter047__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_xhtml_chapter048__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_xhtml_chapter048___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_xhtml_chapter048__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_xhtml_chapter049__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_xhtml_chapter049___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_xhtml_chapter049__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_xhtml_chapter050__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_xhtml_chapter050___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_xhtml_chapter050__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_xhtml_chapter051__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_xhtml_chapter051___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_xhtml_chapter051__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_xhtml_chapter052__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_xhtml_chapter052___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__components_xhtml_chapter052__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_xhtml_chapter053__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_xhtml_chapter053___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__components_xhtml_chapter053__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_xhtml_chapter054__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_xhtml_chapter054___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_xhtml_chapter054__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_xhtml_chapter055__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_xhtml_chapter055___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__components_xhtml_chapter055__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_xhtml_chapter056__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_xhtml_chapter056___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__components_xhtml_chapter056__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_xhtml_chapter057__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_xhtml_chapter057___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__components_xhtml_chapter057__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_xhtml_chapter058__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_xhtml_chapter058___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__components_xhtml_chapter058__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_xhtml_chapter059__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_xhtml_chapter059___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__components_xhtml_chapter059__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_xhtml_chapter060__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_xhtml_chapter060___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__components_xhtml_chapter060__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_xhtml_chapter061__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_xhtml_chapter061___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__components_xhtml_chapter061__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_xhtml_chapter062__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_xhtml_chapter062___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__components_xhtml_chapter062__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_xhtml_chapter063__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_xhtml_chapter063___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__components_xhtml_chapter063__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_xhtml_chapter064__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_xhtml_chapter064___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__components_xhtml_chapter064__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_xhtml_chapter065__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_xhtml_chapter065___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__components_xhtml_chapter065__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_xhtml_chapter066__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_xhtml_chapter066___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__components_xhtml_chapter066__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_xhtml_chapter067__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_xhtml_chapter067___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__components_xhtml_chapter067__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_xhtml_chapter068__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_xhtml_chapter068___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__components_xhtml_chapter068__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_xhtml_chapter069__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_xhtml_chapter069___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__components_xhtml_chapter069__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_xhtml_chapter070__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_xhtml_chapter070___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__components_xhtml_chapter070__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_xhtml_chapter071__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_xhtml_chapter071___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__components_xhtml_chapter071__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_xhtml_chapter072__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_xhtml_chapter072___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__components_xhtml_chapter072__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_xhtml_chapter073__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_xhtml_chapter073___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__components_xhtml_chapter073__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_xhtml_chapter074__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_xhtml_chapter074___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__components_xhtml_chapter074__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_xhtml_chapter075__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_xhtml_chapter075___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__components_xhtml_chapter075__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_xhtml_chapter076__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_xhtml_chapter076___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__components_xhtml_chapter076__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_xhtml_chapter077__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_xhtml_chapter077___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__components_xhtml_chapter077__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_xhtml_chapter078__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_xhtml_chapter078___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__components_xhtml_chapter078__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_xhtml_chapter079__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_xhtml_chapter079___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__components_xhtml_chapter079__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_xhtml_chapter080__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_xhtml_chapter080___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__components_xhtml_chapter080__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_xhtml_chapter081__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_xhtml_chapter081___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__components_xhtml_chapter081__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_xhtml_chapter082__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_xhtml_chapter082___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__components_xhtml_chapter082__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_xhtml_chapter083__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_xhtml_chapter083___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__components_xhtml_chapter083__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_xhtml_chapter084__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_xhtml_chapter084___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__components_xhtml_chapter084__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_xhtml_chapter085__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_xhtml_chapter085___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__components_xhtml_chapter085__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_xhtml_chapter086__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_xhtml_chapter086___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__components_xhtml_chapter086__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_xhtml_chapter087__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_xhtml_chapter087___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__components_xhtml_chapter087__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_xhtml_index001__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_xhtml_index001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__components_xhtml_index001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_last__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__components_last__);
/*jshint esversion: 6 */






































































































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/xhtml/contents",
    "name": "xhtml/contents",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_xhtml_contents___default.a
  }, {
    "path": "/xhtml/preface",
    "name": "xhtml/preface",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_xhtml_preface___default.a
  }, {
    "path": "/xhtml/contributors",
    "name": "xhtml/contributors",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_xhtml_contributors___default.a
  }, {
    "path": "/xhtml/abbreviations",
    "name": "xhtml/abbreviations",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_xhtml_abbreviations___default.a
  }, {
    "path": "/xhtml/chapter001",
    "name": "xhtml/chapter001",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_xhtml_chapter001___default.a
  }, {
    "path": "/xhtml/chapter002",
    "name": "xhtml/chapter002",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_xhtml_chapter002___default.a
  }, {
    "path": "/xhtml/chapter003",
    "name": "xhtml/chapter003",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_xhtml_chapter003___default.a
  }, {
    "path": "/xhtml/chapter004",
    "name": "xhtml/chapter004",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_xhtml_chapter004___default.a
  }, {
    "path": "/xhtml/chapter005",
    "name": "xhtml/chapter005",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_xhtml_chapter005___default.a
  }, {
    "path": "/xhtml/chapter006",
    "name": "xhtml/chapter006",
    "component": __WEBPACK_IMPORTED_MODULE_16__components_xhtml_chapter006___default.a
  }, {
    "path": "/xhtml/chapter007",
    "name": "xhtml/chapter007",
    "component": __WEBPACK_IMPORTED_MODULE_17__components_xhtml_chapter007___default.a
  }, {
    "path": "/xhtml/chapter008",
    "name": "xhtml/chapter008",
    "component": __WEBPACK_IMPORTED_MODULE_18__components_xhtml_chapter008___default.a
  }, {
    "path": "/xhtml/chapter009",
    "name": "xhtml/chapter009",
    "component": __WEBPACK_IMPORTED_MODULE_19__components_xhtml_chapter009___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_99__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James D. G. Dunn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" "), _c('B', [_vm._v("James D. G. Dunn")]), _vm._v(" (1939–2020) was a renowned New Testament scholar and the longtime Lightfoot Professor of Divinity at Durham University. His numerous books include "), _c('I', [_vm._v("The Theology of Paul the Apostle")]), _vm._v(", "), _c('I', [_vm._v("Jesus according to the New Testament")]), _vm._v(", and the magisterial "), _c('I', [_vm._v("Christianity in the Making")]), _vm._v(" trilogy.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1Cn5kMb/tc-custom/9781467426824.jpg?1737195674968",
      "alt": "This image is the cover for the book Eerdmans Commentary on the Bible"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Eerdmans Commentary on the Bible\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("No one familiar with the Bible needs to be told that it is a truly remarkable work. But it takes help to understand this ancient collection of diverse forms of literature written by different people across many centuries. The "), _c('i', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(" ("), _c('i', [_vm._v("ECB")]), _vm._v(") is the finest single-volume Bible handbook available."), _c('br'), _c('br'), _vm._v(" Written by world-class Bible scholars, the "), _c('i', [_vm._v("ECB")]), _vm._v(" encapsulates in nontechnical language the best of modern scholarship on the sixty-six biblical books plus the Apocrypha. The only one-volume Bible commentary to cover "), _c('i', [_vm._v("all")]), _vm._v(" the texts (even including 1 Enoch) regarded by one or more Christian churches as canonical, the "), _c('i', [_vm._v("ECB")]), _vm._v(" provides reader-friendly treatments and succinct summaries of each section of the text that will be valuable to scholars, students, and general readers alike."), _c('br'), _c('br'), _vm._v(" The primary objective of this work is to clarify the meaning of each section of the Bible. Rather than attempting a verse-by-verse analysis (virtually impossible in a one-volume work), the "), _c('i', [_vm._v("ECB")]), _vm._v(" focuses on principal units of meaning—narrative, parable, prophetic oracle, section of argument, and so on—highlighting their interconnectedness with the rest of the biblical text. The volume also addresses and answers major issues—including the range of possible interpretations—and refers readers to the best fuller discussions. Beyond providing reliable, informative commentary, this hefty volume also includes thirteen introductory and context-setting articles that do justice to the biblical documents both as historical sources and as scriptures."), _c('br'), _c('br'), _vm._v(" The sixty-seven contributors to the "), _c('i', [_vm._v("ECB")]), _vm._v(" come from a wide variety of backgrounds and are acknowledged leaders in the field of biblical studies. Their contributions stand out either for their fresh interpretations of the evidence, or for their way of asking new questions of the text, or for their new angles of approach. While the translation of choice is the New Revised Standard Version, many of the contributors offer their own vivid translations of the original Hebrew or Greek."), _c('br'), _c('br'), _vm._v(" Cutting-edge, comprehensive, and ecumenical, the "), _c('i', [_vm._v("ECB")]), _vm._v(" is both a fitting climax to the rich body of interconfessional work undertaken in the latter part of the twentieth century and a worthy launching pad for biblical study in the twenty-first.")]), _c('p', [_vm._v("Special Features of the "), _c('i', [_vm._v("ECB")])]), _vm._v("The only one-volume commentary to cover "), _c('i', [_vm._v("all")]), _vm._v(" the texts (including the Apocrypha and 1 Enoch) regarded by one or more Christian churches as canonicalThirteen major essays that introduce each section of Scripture and its studyEncapsulates in nontechnical language the best of modern scholarshipIncludes superb bibliographies and an extensive subject indexWritten by sixty-seven first-rate Bible scholarsDesigned for use by scholars, students, pastors, and general readers \n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("James D. G. Dunn and John W. Rogerson")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "con"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contributors#con"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_vm._v("OLD TESTAMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("The History of the Tradition: Old Testament and Apocrypha")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("John W. Rogerson")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002"
    }
  }, [_vm._v("Premodern, Modern, and Postmodern in Old Testament Study")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002"
    }
  }, [_vm._v("John A. Goldingay")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003"
    }
  }, [_vm._v("Syro-Palestinian and Biblical Archeology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003"
    }
  }, [_vm._v("Deborah A. Appler and Julye Bidmead")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004"
    }
  }, [_vm._v("The Pentateuch")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004"
    }
  }, [_vm._v("David Noel Freedman")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005"
    }
  }, [_vm._v("GENESIS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005"
    }
  }, [_vm._v("Gordon J. Wenham")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006"
    }
  }, [_vm._v("EXODUS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006"
    }
  }, [_vm._v("William D. Johnstone")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007"
    }
  }, [_vm._v("LEVITICUS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007"
    }
  }, [_vm._v("Walter J. Houston")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-008"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008"
    }
  }, [_vm._v("NUMBERS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008"
    }
  }, [_vm._v("Philip J. Budd")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-009"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter009#ch009"
    }
  }, [_vm._v("DEUTERONOMY")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter009#ch009"
    }
  }, [_vm._v("John W. Rogerson")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOSHUA")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("K. Lawson Younger Jr.")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUDGES")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P. Deryn Guest")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#ch012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RUTH")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#ch012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gerald West")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#ch013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 AND 2 SAMUEL")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#ch013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Graeme Auld")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#ch014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 AND 2 KINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#ch014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roger Tomes")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015#ch015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 AND 2 CHRONICLES")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015#ch015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richard J. Coggins")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-016"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016#ch016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EZRA")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016#ch016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lester L. Grabbe")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-017"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter017#ch017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NEHEMIAH")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter017#ch017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lester L. Grabbe")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-018"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018#ch018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ESTHER")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018#ch018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sidnie White Crawford")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-019"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter019#ch019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOB")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter019#ch019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Katharine J. Dell")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-020"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter020#ch020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PSALMS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter020#ch020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willem S. Prinsloo")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-021"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter021#ch021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROVERBS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter021#ch021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ronald E. Clements")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-022"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter022#ch022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ECCLESIASTES")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter022#ch022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Jarick")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-023"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter023#ch023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SONG OF SONGS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter023#ch023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John W. Rogerson")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-024"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter024#ch024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to Prophetic Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter024#ch024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul L. Redditt")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-025"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter025#ch025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISAIAH")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter025#ch025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Margaret Barker")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-026"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter026#ch026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JEREMIAH")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter026#ch026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. R. Pete Diamond")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-027"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter027#ch027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LAMENTATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter027#ch027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David J. A. Clines")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-028"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter028#ch028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EZEKIEL")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter028#ch028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John A. Goldingay")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-029"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter029#ch029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DANIEL")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter029#ch029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Iain Provan")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-030"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter030#ch030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOSEA")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter030#ch030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grace I. Emmerson")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-031"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter031#ch031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOEL")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter031#ch031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anthony Gelston")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-032"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter032#ch032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AMOS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter032#ch032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M. Daniel Carroll R.")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-033"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter033#ch033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OBADIAH")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter033#ch033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anthony Gelston")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-034"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter034#ch034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JONAH")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter034#ch034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David Gunn")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-035"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter035#ch035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MICAH")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter035#ch035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John W. Rogerson")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-036"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter036#ch036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NAHUM")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter036#ch036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John W. Rogerson")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-037"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter037#ch037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HABAKKUK")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter037#ch037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anthony Gelston")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-038"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter038#ch038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ZEPHANIAH")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter038#ch038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anthony Gelston")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-039"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter039#ch039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HAGGAI")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter039#ch039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John W. Rogerson")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-040"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter040#ch040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ZECHARIAH")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter040#ch040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John W. Rogerson")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-041"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter041#ch041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MALACHI")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter041#ch041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M. Daniel Carroll R.")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OLD TESTAMENT APOCRYPHA")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-042"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter042#ch042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TOBIT")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter042#ch042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lester L. Grabbe")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-043"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter043#ch043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUDITH")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter043#ch043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gerald West")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-044"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter044#ch044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GREEK ESTHER")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter044#ch044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Jarick")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-045"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter045#ch045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE WISDOM OF SOLOMON")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter045#ch045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Peter Hayman")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-046"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter046#ch046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIRACH")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter046#ch046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Snaith")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-047"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter047#ch047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BARUCH")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter047#ch047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John J. Schmitt")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-048"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter048#ch048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ADDITIONS TO DANIEL")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter048#ch048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John W. Rogerson")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-049"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter049#ch049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 MACCABEES")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter049#ch049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John R. Bartlett")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-050"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter050#ch050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 MACCABEES")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter050#ch050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John R. Bartlett")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-051"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter051#ch051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 ESDRAS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter051#ch051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hugh G. M. Williamson")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-052"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter052#ch052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PRAYER OF MANASSEH")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter052#ch052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philip R. Davies")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-053"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter053#ch053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PSALM")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter053#ch053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alison Salvesen")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-054"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter054#ch054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 MACCABEES")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter054#ch054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philip S. Alexander")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-055"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter055#ch055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 ESDRAS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter055#ch055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John J. Schmitt")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-056"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter056#ch056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 MACCABEES")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter056#ch056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David A. deSilva")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PSEUDEPIGRAPHA")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-057"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter057#ch057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to the Pseudepigrapha")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter057#ch057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James R. Mueller")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-058"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter058#ch058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 ENOCH")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter058#ch058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daniel C. Olson")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-059"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter059#ch059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hebrew Bible in the Dead Sea Scrolls")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter059#ch059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daniel C. Harlow")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NEW TESTAMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-060"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter060#ch060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The History of the Tradition: New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter060#ch060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James D. G. Dunn")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-061"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter061#ch061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hermeneutical Approaches to the New Testament Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter061#ch061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joel B. Green")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-062"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter062#ch062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to the Gospels")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter062#ch062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christopher M. Tuckett")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-063"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter063#ch063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MATTHEW")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter063#ch063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anthony J. Saldarini")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-064"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter064#ch064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MARK")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter064#ch064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Craig A. Evans")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-065"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter071#ch071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LUKE")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter065#ch065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David L. Balch")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-066"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter066#ch066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOHN")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter066#ch066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J. Martin C. Scott")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-067"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter067#ch067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACTS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter067#ch067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John T. Squires")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-068"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter068#ch068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letters in the New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter068#ch068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Victor P. Furnish")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-069"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter069#ch069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROMANS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter069#ch069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Reumann")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-070"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter070#ch070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 CORINTHIANS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter070#ch070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stephen C. Barton")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-071"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter071#ch071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 CORINTHIANS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter071#ch071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Barclay")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-072"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter072#ch072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GALATIANS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter072#ch072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beverly R. Gaventa")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-073"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter073#ch073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPHESIANS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter073#ch073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. Howard Marshall")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-074"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter074#ch074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PHILIPPIANS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter074#ch074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles A. Wanamaker")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-075"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter075#ch075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COLOSSIANS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter075#ch075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Morna D. Hooker")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-076"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter076#ch076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 AND 2 THESSALONIANS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter076#ch076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Robert Jewett")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-077"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter077#ch077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE PASTORAL EPISTLES: 1 AND 2 TIMOTHY AND TITUS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter077#ch077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pheme Perkins")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-078"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter078#ch078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PHILEMON")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter078#ch078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Morna D. Hooker")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-079"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter079#ch079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HEBREWS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter079#ch079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anthony C. Thiselton")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-080"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter080#ch080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAMES")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter080#ch080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richard Bauckham")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-081"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter081#ch081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 PETER")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter081#ch081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Graham N. Stanton")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-082"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter082#ch082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 PETER")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter082#ch082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scot McKnight")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-083"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter083#ch083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1, 2, AND 3 JOHN")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter083#ch083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Painter")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-084"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter084#ch084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUDE")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter084#ch084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scot McKnight")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-085"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter085#ch085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REVELATION")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter085#ch085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Loren T. Stuckenbruck")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch-086"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter086#ch086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Testament Apocrypha")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter086#ch086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Robert E. Van Voorst")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-087"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter087#ch087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dead Sea Scrolls and the New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter087#ch087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daniel C. Harlow")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("No one familiar with the Bible in any degree needs to be told that it is a remarkable volume. Its documents and traditions span a period of at least a thousand years. It contains the sacred scriptures of two of the world’s major religions, Judaism (what Christians call “the Old Testament”) and Christianity, and is the lifeblood of each. In and through its words hundreds of thousands have heard, and still hear, the Word of God addressing them personally. The Bible has informed and infused Western culture to such an extent that the foundations, formative traditions, character, and values of Western society cannot be understood without it. Nations have been built on foundational principles drawn from it. Much of the world’s greatest art, music, and literature cannot be adequately appreciated without a good knowledge of the Bible. It has been the source and inspiration for countless acts of quiet heroism and lives of sacrificial service—though, paradoxically, many of its texts have also been used to justify acts of unimaginable horror and systems of barbarous intolerance. And in many parts of the world, particularly in Africa and South America, where the Christian churches are growing rapidly, the Bible is being rediscovered and read in new and exciting ways.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A striking and equally familiar feature of the Bible is the rich diversity of types of writing within it—law codes, historical narratives, poetry, psalms and proverbs, prophetic oracles, apocalyptic visions, gospels, and epistles. Each of these genres requires detailed study to unfold its riches, and all of the sixty-six individual writings—not to mention the Apocrypha and Pseudepigrapha—have given rise to numerous commentaries and special studies. Indeed, a further measure of the Bible’s importance is that it has resulted in far more secondary literature than has any other single or composite volume in history. In consequence, the beginning student or study group that wants to give the Bible serious attention can quickly be overwhelmed by such an embarrassing abundance of riches. The sheer disparity between the Bible’s one volume and all that has been written about it is mind-boggling. At the same time, many briefer treatments of biblical books and themes are written at an overly simplistic level; they neither wrestle with the complexity of many texts, nor penetrate very far into the profundity of others, nor show enough awareness of the diversity of interpretations possible at many points or of the challenges and benefits of much modern scholarship. Despite its age, biblical studies is a fast-moving discipline with new discoveries, angles of approach, and insights constantly calling for fresh assessment of older assumptions simply taken for granted, whether at a fine-detail or whole-picture level.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is essential, then, that each new generation should have a guide enabling serious students of the Bible to see the forest without getting lost in the trees. Since the Bible too easily becomes the province only of the technical expert, it is desirable that a single volume should sum up the best of modern scholarship and direct interested readers to appropriate further reading. And since the twentieth century witnessed huge strides in the way the Bible is read and heard, with many new translations and ways of approaching the Bible under constant discussion, it is appropriate that students of the Bible should have a handbook which provides authoritative summing up of the best fruits of the last century’s scholarship and clear guidance on into the twenty-first century.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The "), _c('i', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(" is just such a volume.")]), _vm._v(" "), _c('p', {
    staticClass: "BL1"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("It draws on and encapsulates the best of modern and international scholarship on the books of the Bible.")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("It is the only one-volume Bible commentary to cover all the texts (including the Apocrypha and "), _c('i', [_vm._v("1 Enoch")]), _vm._v(") regarded by one or more Christian churches as canonical.")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("It deals with the text in nontechnical language, and provides both reader-friendly treatments for beginning use of the Bible and succinct summaries of the essence or thrust of each section for those further along the way.")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("It focuses on the principal unit of meaning—narrative, prophetic oracle, parable, section of argument, etc.—rather than attempting verse-by-verse analysis.")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The primary objective is to clarify the meaning (and possible meanings) of each unit and to bring out its interconnectedness with the rest of the text.")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("It thus avoids the problems (common in many commentaries) either of losing the reader in a mass of detail, or of simply rephrasing what the text itself says.")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("It summarizes succinctly major issues unable to be discussed in full detail and refers the reader to fuller discussions.")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Editors provide two major context-setting articles—“The History of the Tradition: Old Testament and Apocrypha” and “The History of the Tradition: New Testament.”")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The commentary includes several “behind the text” and “in front of the text” articles, on background and interpretation, and overview articles which enable the reader to maintain perspective.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("The sixty-seven contributors include world-class scholars from a wide variety of backgrounds and faith "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("traditions. Their contributions stand out either for their fresh interpretations of the evidence, or for their way of asking new questions of the text, or for their new angles of approach, or for taking what was once the province of the technical expert and making it manageable for the busy pastor, teacher, student, or layperson. While the translation of choice is the New Revised Standard Version, many of the contributors offer their own vivid translations of the original Hebrew or Greek.")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The project has been long in the making. The volume now goes forth with our heartfelt desire and prayer that it may open the windows of many minds and may reward attentive hearing with many fresh insights and a new appreciation of the Bible’s manifold riches.")]), _vm._v(" "), _c('table', {
    staticClass: "Table1A",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdleftA"
  }, [_c('p', {
    staticClass: "AuthorSb1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(" D. G. D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNN")]), _c('br'), _c('i', [_vm._v("General Editor")]), _c('br'), _c('i', [_vm._v("and New Testament Editor")])])]), _vm._v(" "), _c('td', {
    staticClass: "tdleftA"
  }, [_c('p', {
    staticClass: "RightSb1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" W. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OGERSON")]), _c('br'), _c('i', [_vm._v("Editor of the Old Testament")]), _c('br'), _c('i', [_vm._v("and Apocrypha")])])])])])])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "con"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#con"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILIP")]), _vm._v(" S. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDER")]), _c('br'), _vm._v("Professor of Post-Biblical Literature"), _c('br'), _vm._v("Co-Director, Center for Jewish Studies"), _c('br'), _vm._v("University of Manchester"), _c('br'), _vm._v("Manchester, England"), _c('br'), _c('i', [_vm._v("3 Maccabees")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EBORAH")]), _vm._v(" A. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPLER")]), _c('br'), _vm._v("Assistant Professor of Old Testament"), _c('br'), _vm._v("Moravian Theological Seminary"), _c('br'), _vm._v("Bethlehem, Pennsylvania"), _c('br'), _c('i', [_vm._v("Syro-Palestinian and Biblical Archeology")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAEME")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULD")]), _c('br'), _vm._v("Professor of Hebrew Bible"), _c('br'), _vm._v("University of Edinburgh"), _c('br'), _vm._v("Edinburgh, Scotland"), _c('br'), _c('i', [_vm._v("1 and 2 Samuel")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID")]), _vm._v(" L. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALCH")]), _c('br'), _vm._v("Professor of New Testament"), _c('br'), _vm._v("Interim Director of Ph.D. Studies"), _c('br'), _vm._v("Brite Divinity School"), _c('br'), _vm._v("Texas Christian University"), _c('br'), _vm._v("Fort Worth, Texas"), _c('br'), _c('i', [_vm._v("Luke")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARCLAY")]), _c('br'), _vm._v("Lightfoot Professor of Divinity"), _c('br'), _vm._v("University of Durham"), _c('br'), _vm._v("Durham, England"), _c('br'), _c('i', [_vm._v("2 Corinthians")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARGARET")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARKER")]), _c('br'), _vm._v("Independent Scholar"), _c('br'), _vm._v("Former President of the Society for Old Testament Study"), _c('br'), _vm._v("Derbyshire, England"), _c('br'), _c('i', [_vm._v("Isaiah")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" R. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTLETT")]), _c('br'), _vm._v("Fellow Emeritus"), _c('br'), _vm._v("Trinity College"), _c('br'), _vm._v("Dublin, Republic of Ireland"), _c('br'), _c('i', [_vm._v("1 and 2 Maccabees")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TEPHEN")]), _vm._v(" C. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTON")]), _c('br'), _vm._v("Reader in New Testament"), _c('br'), _vm._v("Department of Theology"), _c('br'), _vm._v("University of Durham"), _c('br'), _vm._v("Durham, England"), _c('br'), _c('i', [_vm._v("1 Corinthians")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICHARD")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUCKHAM")]), _c('br'), _vm._v("Professor of New Testament and"), _c('br'), _vm._v("Bishop Wardlaw Professor"), _c('br'), _vm._v("St. Mary’s College"), _c('br'), _vm._v("University of St. Andrews"), _c('br'), _vm._v("St. Andrews, Scotland"), _c('br'), _c('i', [_vm._v("James")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULYE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDMEAD")]), _c('br'), _vm._v("Assistant Professor of Biblical Studies"), _c('br'), _vm._v("Department of Religion and Philosophy"), _c('br'), _vm._v("James Madison University"), _c('br'), _vm._v("Harrisonburg, Virginia"), _c('br'), _c('i', [_vm._v("Syro-Palestinian and Biblical Archeology")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILIP")]), _vm._v(" J. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDD")]), _c('br'), _vm._v("Formerly Senior Lecturer"), _c('br'), _vm._v("The Westminster Institute of Education"), _c('br'), _vm._v("Oxford Brookes University"), _c('br'), _vm._v("Oxford, England"), _c('br'), _c('i', [_vm._v("Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("M. D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANIEL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARROLL")]), _vm._v(" R. (R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODAS")]), _vm._v(")"), _c('br'), _vm._v("Professor of Old Testament"), _c('br'), _vm._v("Denver Seminary"), _c('br'), _vm._v("Denver, Colorado"), _c('br'), _vm._v("Adjunct Professor of Old Testament"), _c('br'), _vm._v("Seminario Teológico Centroamericano"), _c('br'), _vm._v("Guatemala City, Guatemala"), _c('br'), _c('i', [_vm._v("Amos")]), _vm._v(" and "), _c('i', [_vm._v("Malachi")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONALD")]), _vm._v(" E. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEMENTS")]), _c('br'), _vm._v("Emeritus Professor of Old Testament Studies"), _c('br'), _vm._v("King’s College"), _c('br'), _vm._v("University of London"), _c('br'), _vm._v("London, England"), _c('br'), _c('i', [_vm._v("Proverbs")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID")]), _vm._v(" J. A. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LINES")]), _c('br'), _vm._v("Research Professor"), _c('br'), _vm._v("Department of Biblical Studies"), _c('br'), _vm._v("University of Sheffield"), _c('br'), _vm._v("Sheffield, England"), _c('br'), _c('i', [_vm._v("Lamentations")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICHARD")]), _vm._v(" J. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OGGINS")]), _c('br'), _vm._v("Formerly Senior Lecturer in Old Testament Studies"), _c('br'), _vm._v("King’s College"), _c('br'), _vm._v("University of London"), _c('br'), _vm._v("London, England"), _c('br'), _c('i', [_vm._v("1 and 2 Chronicles")])])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('p', {
    staticClass: "ConSb"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDNIE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HITE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAWFORD")]), _c('br'), _vm._v("Professor of Hebrew and"), _c('br'), _vm._v("Chair, Classics and Religious Studies"), _c('br'), _vm._v("University of Nebraska-Lincoln"), _c('br'), _vm._v("Lincoln, Nebraska"), _c('br'), _c('i', [_vm._v("Esther")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILIP")]), _vm._v(" R. D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVIES")]), _c('br'), _vm._v("Professor of Biblical Studies"), _c('br'), _vm._v("University of Sheffield"), _c('br'), _vm._v("Sheffield, England"), _c('br'), _c('i', [_vm._v("Prayer of Manasseh")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATHARINE")]), _vm._v(" J. D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELL")]), _c('br'), _vm._v("Senior Lecturer"), _c('br'), _vm._v("University of Cambridge and"), _c('br'), _vm._v("Fellow"), _c('br'), _vm._v("St. Catharine’s College"), _c('br'), _vm._v("Cambridge, England"), _c('br'), _c('i', [_vm._v("Job")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID")]), _vm._v(" A. "), _c('span', {
    staticClass: "small"
  }, [_vm._v("DE")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILVA")]), _c('br'), _vm._v("Professor of New Testament and Greek"), _c('br'), _vm._v("Ashland Theological Seminary"), _c('br'), _vm._v("Ashland, Ohio"), _c('br'), _c('i', [_vm._v("4 Maccabees")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("A. R. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IAMOND")]), _c('br'), _vm._v("Educational Consultant"), _c('br'), _vm._v("Santa Barbara, California"), _c('br'), _c('i', [_vm._v("Jeremiah")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(" D. G. D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNN")]), _c('br'), _vm._v("Lightfoot Professor Emeritus of Divinity"), _c('br'), _vm._v("University of Durham"), _c('br'), _vm._v("Durham, England"), _c('br'), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENERAL")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTAMENT")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")]), _c('br'), _c('i', [_vm._v("Preface")]), _vm._v(" and "), _c('i', [_vm._v("The History of the Tradition: New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACE")]), _vm._v(" I. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MMERSON")]), _c('br'), _vm._v("Visiting Lecturer in Theology"), _c('br'), _vm._v("University of Birmingham"), _c('br'), _vm._v("Birmingham, England"), _c('br'), _c('i', [_vm._v("Hosea")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAIG")]), _vm._v(" A. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VANS")]), _c('br'), _vm._v("Payzant Professor of New Testament"), _c('br'), _vm._v("Acadia Divinity School"), _c('br'), _vm._v("Wolfville, Nova Scotia, Canada"), _c('br'), _c('i', [_vm._v("Mark")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OEL")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEDMAN")]), _c('br'), _vm._v("Endowed Chair for Hebrew Biblical Studies"), _c('br'), _vm._v("University of California, San Diego"), _c('br'), _vm._v("La Jolla, California"), _c('br'), _c('i', [_vm._v("The Pentateuch")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICTOR")]), _vm._v(" P. F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URNISH")]), _c('br'), _vm._v("University Distinguished Professor Emeritus of New Testament"), _c('br'), _vm._v("Perkins School of Theology"), _c('br'), _vm._v("Southern Methodist University"), _c('br'), _vm._v("Dallas, Texas"), _c('br'), _c('i', [_vm._v("Letters in the New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVERLY")]), _vm._v(" R. G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVENTA")]), _c('br'), _vm._v("Helen H. P. Manson Professor of New Testament Literature and Exegesis"), _c('br'), _vm._v("Princeton Theological Seminary"), _c('br'), _vm._v("Princeton, NewJersey"), _c('br'), _c('i', [_vm._v("Galatians")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTHONY")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELSTON")]), _c('br'), _vm._v("Emeritus Reader in Theology"), _c('br'), _vm._v("University of Durham"), _c('br'), _vm._v("Durham, England"), _c('br'), _c('i', [_vm._v("Joel, Obadiah, Habakkuk")]), _vm._v(", and "), _c('i', [_vm._v("Zephaniah")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" A. G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLDINGAY")]), _c('br'), _vm._v("David Allan Hubbard Professor of Old Testament"), _c('br'), _vm._v("Fuller Theological Seminary"), _c('br'), _vm._v("Pasadena, California"), _c('br'), _c('i', [_vm._v("Premodern, Modern, and Postmodern in Old Testament Study")]), _c('br'), _vm._v("and "), _c('i', [_vm._v("Ezekiel")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTER")]), _vm._v(" L. G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RABBE")]), _c('br'), _vm._v("Professor of HebrewBible and Early Judaism"), _c('br'), _vm._v("University of Hull"), _c('br'), _vm._v("Hull, England"), _c('br'), _c('i', [_vm._v("Ezra, Nehemiah")]), _vm._v(", and "), _c('i', [_vm._v("Tobit")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OEL")]), _vm._v(" B. G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEN")]), _c('br'), _vm._v("Dean of Academic Affairs and"), _c('br'), _vm._v("Professor of NewT estament Interpretation"), _c('br'), _vm._v("Asbury Theological Seminary"), _c('br'), _vm._v("Wilmore, Kentucky"), _c('br'), _c('i', [_vm._v("Hermeneutical Approaches to the New Testament Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("P. D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERYN")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UEST")]), _c('br'), _vm._v("Lecturer in Biblical Hermeneutics"), _c('br'), _vm._v("University of Birmingham"), _c('br'), _vm._v("Birmingham, England"), _c('br'), _c('i', [_vm._v("Judges")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNN")]), _c('br'), _vm._v("A. A. Bradford Chair of Religion"), _c('br'), _vm._v("Texas Christian University"), _c('br'), _vm._v("Fort Worth, Texas"), _c('br'), _c('i', [_vm._v("Jonah")])])]), _c('p', {
    staticClass: "ConSb"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANIEL")]), _vm._v(" C. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLOW")]), _c('br'), _vm._v("Assistant Professor of Religion"), _c('br'), _vm._v("Calvin College"), _c('br'), _vm._v("Grand Rapids, Michigan"), _c('br'), _c('i', [_vm._v("The Hebrew Bible in the Dead Sea Scrolls")]), _vm._v(" and"), _c('br'), _c('i', [_vm._v("The Dead Sea Scrolls and the New Testament")])])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "ConSb"
  }, [_vm._v("A. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETER")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYMAN")]), _c('br'), _vm._v("Senior Lecturer in Hebrew and Jewish Studies"), _c('br'), _vm._v("School of Divinity"), _c('br'), _vm._v("University of Edinburgh"), _c('br'), _vm._v("Edinburgh, Scotland"), _c('br'), _c('i', [_vm._v("Wisdom of Solomon")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORNA")]), _vm._v(" D. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKER")]), _c('br'), _vm._v("Lady Margaret’s Professor of Divinity Emerita"), _c('br'), _vm._v("University of Cambridge"), _c('br'), _vm._v("Life Fellow"), _c('br'), _vm._v("Robinson College"), _c('br'), _vm._v("Cambridge, England"), _c('br'), _c('i', [_vm._v("Colossians")]), _vm._v(" and "), _c('i', [_vm._v("Philemon")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALTER")]), _vm._v(" J. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUSTON")]), _c('br'), _vm._v("Chaplain Fellow and Director of Ministerial Training"), _c('br'), _vm._v("Mansfield College"), _c('br'), _vm._v("Oxford, England"), _c('br'), _c('i', [_vm._v("Leviticus")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARICK")]), _c('br'), _vm._v("Old Testament Tutor"), _c('br'), _vm._v("St. Stephen’s House"), _c('br'), _vm._v("Oxford, England"), _c('br'), _c('i', [_vm._v("Ecclesiastes and Greek Esther")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OBERT")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EWETT")]), _c('br'), _vm._v("Guest Professor of New Testament"), _c('br'), _vm._v("University of Heidelberg"), _c('br'), _vm._v("Heidelberg, Germany"), _c('br'), _c('i', [_vm._v("1 and 2 Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIAM")]), _vm._v(" D. J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHNSTONE")]), _c('br'), _vm._v("Professor Emeritus of Hebrew and Semitic Languages"), _c('br'), _vm._v("University of Aberdeen"), _c('br'), _vm._v("Aberdeen, Scotland"), _c('br'), _c('i', [_vm._v("Exodus")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("I. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWARD")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARSHALL")]), _c('br'), _vm._v("Honorary Research Professor of New Testament"), _c('br'), _vm._v("University of Aberdeen"), _c('br'), _vm._v("Aberdeen, Scotland"), _c('br'), _c('i', [_vm._v("Ephesians")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("COT")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v("K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIGHT")]), _c('br'), _vm._v("Karl A. Olsson Professor in Religious Studies"), _c('br'), _vm._v("North Park Seminary"), _c('br'), _vm._v("Libertyville, Illinois"), _c('br'), _c('i', [_vm._v("2 Peter")]), _vm._v(" and "), _c('i', [_vm._v("Jude")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(" R. M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UELLER")]), _c('br'), _vm._v("Associate Professor of Religion"), _c('br'), _vm._v("University of Florida"), _c('br'), _vm._v("Gainesville, Florida"), _c('br'), _c('i', [_vm._v("Introduction to the Pseudepigrapha")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANIEL")]), _vm._v(" C. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LSON")]), _c('br'), _vm._v("Doctoral Student"), _c('br'), _vm._v("Graduate Theological Union"), _c('br'), _vm._v("Berkeley, California"), _c('br'), _c('i', [_vm._v("1 Enoch")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AINTER")]), _c('br'), _vm._v("Professor of Theology"), _c('br'), _vm._v("St. Mark’s National Theological Centre"), _c('br'), _vm._v("Charles Sturt University, Canberra Campus"), _c('br'), _vm._v("Barton, Australian Capital Territory"), _c('br'), _c('i', [_vm._v("1, 2, and 3 John")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEME")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERKINS")]), _c('br'), _vm._v("Professor of New Testament"), _c('br'), _vm._v("Boston College"), _c('br'), _vm._v("Boston, Massachusetts"), _c('br'), _c('i', [_vm._v("1 and 2 Timothy")]), _vm._v(" and "), _c('i', [_vm._v("Titus")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLEM")]), _vm._v(" S. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINSLOO")]), _vm._v(" ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("DECEASED")]), _vm._v(")"), _c('br'), _vm._v("Dean and Head of the Department of Old Testament Theology and Exegesis"), _c('br'), _vm._v("Faculty of Theology"), _c('br'), _vm._v("University of Pretoria, South Africa"), _c('br'), _c('i', [_vm._v("Psalms")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AIN")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROVAN")]), _c('br'), _vm._v("Professor of Old Testament"), _c('br'), _vm._v("Regent College"), _c('br'), _vm._v("Vancouver, British Columbia"), _c('br'), _vm._v("Canada"), _c('br'), _c('i', [_vm._v("Daniel")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDDITT")]), _c('br'), _vm._v("Chair, Department of Religion"), _c('br'), _vm._v("Georgetown College"), _c('br'), _vm._v("Georgetown, Kentucky"), _c('br'), _c('i', [_vm._v("Introduction to Prophetic Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EUMANN")]), _c('br'), _vm._v("Ministerium of Pennsylvania and Professor Emeritus of New Testament"), _c('br'), _vm._v("Lutheran Theological College"), _c('br'), _vm._v("Philadelphia, Pennsylvania"), _c('br'), _c('i', [_vm._v("Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" W. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OGERSON")]), _c('br'), _vm._v("Professor Emeritus of Biblical Studies"), _c('br'), _vm._v("University of Sheffield"), _c('br'), _vm._v("Sheffield, England"), _c('br'), _vm._v("Editor of the Old Testament and Apocrypha"), _c('br'), _c('i', [_vm._v("Preface, The History of the Tradition: Old Testament and")]), _c('br'), _c('i', [_vm._v("Apocrypha, Deuteronomy, Song of Songs, Micah, Nahum")]), _vm._v(","), _c('br'), _c('i', [_vm._v("Haggai, Zechariah")]), _vm._v(", and "), _c('i', [_vm._v("Additions to Daniel")])])]), _c('p', {
    staticClass: "ConSb"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTHONY")]), _vm._v(" J. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALDARINI")]), _vm._v(" ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("DECEASED")]), _vm._v(")"), _c('br'), _vm._v("Professor of Theology"), _c('br'), _vm._v("Boston College"), _c('br'), _vm._v("Boston, Massachusetts"), _c('br'), _c('i', [_vm._v("Matthew")])])]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('p', {
    staticClass: "ConSb"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LISON")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVESEN")]), _c('br'), _vm._v("Hebrew Centre Lecturer"), _c('br'), _vm._v("The Oriental Institute"), _c('br'), _vm._v("University of Oxford"), _c('br'), _vm._v("Oxford, England"), _c('br'), _c('i', [_vm._v("Psalm 151")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" J. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHMITT")]), _c('br'), _vm._v("Associate Professor of Biblical Studies"), _c('br'), _vm._v("Marquette University"), _c('br'), _vm._v("Milwaukee, Wisconsin"), _c('br'), _c('i', [_vm._v("Baruch")]), _vm._v(" and "), _c('i', [_vm._v("2 Esdras")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J. M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTIN")]), _vm._v(" C. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("COTT")]), _c('br'), _vm._v("Senior Vocational Guidance Officer"), _c('br'), _vm._v("Board of Ministry"), _c('br'), _vm._v("Church of Scotland"), _c('br'), _vm._v("Edinburgh, Scotland"), _c('br'), _c('i', [_vm._v("John")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NAITH")]), _c('br'), _vm._v("Formerly Lecturer in Hebrew and Aramaic"), _c('br'), _vm._v("University of Cambridge"), _c('br'), _vm._v("Cambridge, England"), _c('br'), _c('i', [_vm._v("Sirach (Ecclesiasticus)")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" T. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("QUIRES")]), _c('br'), _vm._v("Academic Dean and Lecturer in Biblical Studies"), _c('br'), _vm._v("United Theological College"), _c('br'), _vm._v("School of Theology"), _c('br'), _vm._v("Charles Sturt University"), _c('br'), _vm._v("Australia"), _c('br'), _c('i', [_vm._v("Acts")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAHAM")]), _vm._v(" N. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TANTON")]), _c('br'), _vm._v("Lady Margaret’s Professor of Divinity"), _c('br'), _vm._v("University of Cambridge"), _c('br'), _vm._v("Cambridge, England"), _c('br'), _c('i', [_vm._v("1 Peter")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OREN")]), _vm._v(" T. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TUCKENBRUCK")]), _c('br'), _vm._v("Professor of New Testament"), _c('br'), _vm._v("University of Durham"), _c('br'), _vm._v("Durham, England"), _c('br'), _c('i', [_vm._v("Revelation")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTHONY")]), _vm._v(" C. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HISELTON")]), _c('br'), _vm._v("Emeritus Professor of Christian Theology in Residence"), _c('br'), _vm._v("University of Nottingham, and"), _c('br'), _vm._v("Canon Theologian of Leicester Cathedral and of Southwell Minster"), _c('br'), _vm._v("Nottingham, England"), _c('br'), _c('i', [_vm._v("Hebrews")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OGER")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMES")]), _c('br'), _vm._v("Honorary Research Fellow"), _c('br'), _vm._v("University of Manchester"), _c('br'), _vm._v("Manchester, England"), _c('br'), _c('i', [_vm._v("1 and 2 Kings")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTOPHER")]), _vm._v(" M. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UCKETT")]), _c('br'), _vm._v("Professor of New Testament Studies"), _c('br'), _vm._v("University of Oxford"), _c('br'), _vm._v("Oxford, England"), _c('br'), _c('i', [_vm._v("Introduction to the Gospels")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OBERT")]), _vm._v(" E. V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AN")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OORST")]), _c('br'), _vm._v("Professor of New Testament"), _c('br'), _vm._v("Western Theological Seminary"), _c('br'), _vm._v("Holland, Michigan"), _c('br'), _c('i', [_vm._v("New Testament Apocrypha")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARLES")]), _vm._v(" A. W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANAMAKER")]), _c('br'), _vm._v("Associate Professor of Religious Studies"), _c('br'), _vm._v("University of Cape Town"), _c('br'), _vm._v("Cape Town, South Africa"), _c('br'), _c('i', [_vm._v("Philippians")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORDON")]), _vm._v(" J. W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENHAM")]), _c('br'), _vm._v("Professor of Old Testament"), _c('br'), _vm._v("University of Gloucestershire"), _c('br'), _vm._v("Gloucestershire, England"), _c('br'), _c('i', [_vm._v("Genesis")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERALD")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EST")]), _c('br'), _vm._v("Head of the School of Theology"), _c('br'), _vm._v("Director of the Institute for the Study of the Bible and Worker Ministry"), _c('br'), _vm._v("Project Pietermaritzburg, South Africa"), _c('br'), _c('i', [_vm._v("Ruth")]), _vm._v(" and "), _c('i', [_vm._v("Judith")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGH")]), _vm._v(" G. M. W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIAMSON")]), _c('br'), _vm._v("Regius Professor of Hebrew"), _c('br'), _vm._v("University of Oxford"), _c('br'), _vm._v("Oxford, England"), _c('br'), _c('i', [_vm._v("1 Esdras")])]), _vm._v(" "), _c('p', {
    staticClass: "ConSb"
  }, [_vm._v("K. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AWSON")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNGER")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v("."), _c('br'), _vm._v("Professor of Old Testament, Semitic Languages, and Ancient Near Eastern History"), _c('br'), _vm._v("Trinity International University—Divinity School"), _c('br'), _vm._v("Deerfield, Illinois"), _c('br'), _c('i', [_vm._v("Joshua")])])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "H1a"
  }, [_vm._v("PERIODICALS, REFERENCE WORKS, AND SERIALS")]), _vm._v(" "), _c('table', {
    staticClass: "abbre",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("AB")]), _c('td', [_vm._v("Anchor Bible")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("ABD")])]), _c('td', [_vm._v("D. N. Freedman (ed.), "), _c('i', [_vm._v("Anchor Bible Dictionary")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ABRL")]), _c('td', [_vm._v("Anchor Bible Reference Library")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ADPV")]), _c('td', [_vm._v("Abhandlungen des deutschen Palästina-Vereins")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("AGJU")]), _c('td', [_vm._v("Arbeiten zur Geschichte des antiken Judentums und des Urchristentums")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("AJA")])]), _c('td', [_c('i', [_vm._v("American Journal of Archaeology")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("AJBI")])]), _c('td', [_c('i', [_vm._v("Annual of the Japanese Biblical Institute")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("AJP")])]), _c('td', [_c('i', [_vm._v("American Journal of Philology")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("AJT")])]), _c('td', [_c('i', [_vm._v("American Journal of Theology")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("AnBib")]), _c('td', [_vm._v("Analecta biblica")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("ANEP")])]), _c('td', [_vm._v("J. B. Pritchard (ed.), "), _c('i', [_vm._v("Ancient Near East in Pictures")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("ANET")])]), _c('td', [_vm._v("J. B. Pritchard (ed.), "), _c('i', [_vm._v("Ancient Near Eastern Texts")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("ANRW")])]), _c('td', [_c('i', [_vm._v("Aufstieg und Niedergang der römischen Welt")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ANTC")]), _c('td', [_vm._v("Abingdon New Testament Commentary")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("AOAT")]), _c('td', [_vm._v("Alter Orient und Altes Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("APOT")])]), _c('td', [_vm._v("R. H. Charles (ed.), "), _c('i', [_vm._v("Apocrypha and Pseudepigrapha of the Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ASV")]), _c('td', [_vm._v("American Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ATANT")]), _c('td', [_vm._v("Abhandlungen zur Theologie des Alten und Neuen Testaments")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ATD")]), _c('td', [_vm._v("Das Alte Testament Deutsch")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ATDA")]), _c('td', [_vm._v("Das Alte Testament Deutsch Apokryphen")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ATLAMS")]), _c('td', [_vm._v("American Theological Library Association Monograph Series")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("ATR")])]), _c('td', [_c('i', [_vm._v("Anglican Theological Review")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("AusBR")])]), _c('td', [_c('i', [_vm._v("Australian Biblical Review")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("AV")]), _c('td', [_vm._v("Authorized Version")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("BA")])]), _c('td', [_c('i', [_vm._v("Biblical Archaeologist")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("BAGD")]), _c('td', [_vm._v("W. Bauer, W. F. Arndt, F. W. Gingrich, and F. W. Danker, "), _c('i', [_vm._v("Greek-English Lexicon of the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("BAR")])]), _c('td', [_c('i', [_vm._v("Biblical Archaeology Review")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("BASOR")])]), _c('td', [_c('i', [_vm._v("Bulletin of the American Schools of Oriental Research")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("BBB")]), _c('td', [_vm._v("Bonner biblische Beiträge")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("BBR")])]), _c('td', [_vm._v("Bulletin for Biblical Research")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("BDB")]), _c('td', [_vm._v("F. Brown, S. R. Driver, and C. A. Briggs, "), _c('i', [_vm._v("Hebrew and English Lexicon of the Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("BETL")]), _c('td', [_vm._v("Bibliotheca ephemeridum theologicarum lovaniensium")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("BHS")])]), _c('td', [_c('i', [_vm._v("Biblia hebraica stuttgartensia")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Bib")])]), _c('td', [_c('i', [_vm._v("Biblica")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("BibRev")])]), _c('td', [_c('i', [_vm._v("Bible Review")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("BJRL")])]), _c('td', [_c('i', [_vm._v("Bulletin of the John Rylands University Library of Manchester")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("BJS")]), _c('td', [_vm._v("Brown Judaic Studies")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("BKAT")]), _c('td', [_vm._v("Biblischer Kommentar: Altes Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("BNTC")]), _c('td', [_vm._v("Black New Testament Commentary")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("BR")])]), _c('td', [_c('i', [_vm._v("Biblical Research")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("BT")])]), _c('td', [_c('i', [_vm._v("The Bible Translator")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("BTB")])]), _c('td', [_c('i', [_vm._v("Biblical Theology Bulletin")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("BWANT")]), _c('td', [_vm._v("Beiträge zur Wissenschaft vom Alten und Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("BZ")])]), _c('td', [_c('i', [_vm._v("Biblische Zeitschrift")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("BZAW")]), _c('td', [_vm._v("Beihefte zur "), _c('i', [_vm._v("ZAW")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("BZNW")]), _c('td', [_vm._v("Beihefte zur "), _c('i', [_vm._v("ZNW")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CBC")]), _c('td', [_vm._v("Cambridge Bible Commentary")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("CBQ")])]), _c('td', [_c('i', [_vm._v("Catholic Biblical Quarterly")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CBQMS")]), _c('td', [_vm._v("Catholic Biblical Quarterly—Monograph Series")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CBSC")]), _c('td', [_vm._v("Cambridge Bible for Schools and Colleges")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("CIG")])]), _c('td', [_c('i', [_vm._v("Corpus inscriptionum graecarum")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CNT")]), _c('td', [_vm._v("Commentaire du Nouveau Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ConBNT")]), _c('td', [_vm._v("Coniectanea biblica, New Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ConBOT")]), _c('td', [_vm._v("Coniectanea biblica, Old Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("CP")])]), _c('td', [_c('i', [_vm._v("Classical Philology")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("CPJ")])]), _c('td', [_c('i', [_vm._v("Corpus Papyrorum Judaicarum")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("CR:BS")])]), _c('td', [_c('i', [_vm._v("Currents in Research: Biblical Studies")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CRINT")]), _c('td', [_vm._v("Compendia rerum iudaicarum ad novum testamentum")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("DJD")]), _c('td', [_vm._v("Discoveries in the Judaean Desert")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("DLNTD")])]), _c('td', [_c('i', [_vm._v("Dictionary of the Later New Testament and Its Developments")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("DOTT")])]), _c('td', [_vm._v("D. W. Thomas (ed.), "), _c('i', [_vm._v("Documents from Old Testament Times")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("DPL")])]), _c('td', [_c('i', [_vm._v("Dictionary of Paul and His Letters")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ebib")]), _c('td', [_vm._v("Etudes bibliques")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("EDNT")])]), _c('td', [_c('i', [_vm._v("Exegetical Dictionary of the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("EKKNT")]), _c('td', [_vm._v("Evangelisch-katholischer Kommentar zum Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ErIsr")]), _c('td', [_vm._v("Eretz Israel")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("EstBíb")])]), _c('td', [_c('i', [_vm._v("Estudios bíblicos")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ESV")]), _c('td', [_vm._v("English Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("ETL")])]), _c('td', [_c('i', [_vm._v("Ephemerides theologicae lovanienses")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("EvQ")])]), _c('td', [_c('i', [_vm._v("Evangelical Quarterly")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("EvT")])]), _c('td', [_c('i', [_vm._v("Evangelische Theologie")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("ExpTim")])]), _c('td', [_c('i', [_vm._v("Expository Times")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("FAT")]), _c('td', [_vm._v("Forschungen zur Altes Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("FOTL")]), _c('td', [_vm._v("Forms of the Old Testament Literature")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_vm._v("FRLANT")])]), _c('td', [_vm._v("Forschungen zur Religion und Literatur des Alten und Neuen Testaments")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("GNB")]), _c('td', [_vm._v("Good News Bible")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("GNS")]), _c('td', [_vm._v("Good New Studies")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("HAR")])]), _c('td', [_c('i', [_vm._v("Hebrew Annual Review")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("HAT")]), _c('td', [_vm._v("Handbuch zum Alten Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("HBT")])]), _c('td', [_c('i', [_vm._v("Horizons in Biblical Theology")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("HDR")]), _c('td', [_vm._v("Harvard Dissertations in Religion")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("HeyJ")])]), _c('td', [_c('i', [_vm._v("Heythrop Journal")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("HNT")]), _c('td', [_vm._v("Handbuch zum Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("HNTC")]), _c('td', [_vm._v("Harper’s New Testament Commentaries")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("HR")])]), _c('td', [_c('i', [_vm._v("History of Religions")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("HSM")]), _c('td', [_vm._v("Harvard Semitic Monographs")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("HSS")]), _c('td', [_vm._v("Harvard Semitic Studies")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("HTKNT")]), _c('td', [_vm._v("Herders theologischer Kommentar zum Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("HTR")])]), _c('td', [_c('i', [_vm._v("Harvard Theological Review")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("HTS")]), _c('td', [_vm._v("Harvard Theological Studies")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("HUT")]), _c('td', [_vm._v("Hermeneutische Untersuchungen zur Theologie")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("IB")])]), _c('td', [_c('i', [_vm._v("Interpreter’s Bible")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("IBC")]), _c('td', [_vm._v("Interpretation: A Bible Commentary for Teaching and Preaching")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("IBS")])]), _c('td', [_c('i', [_vm._v("Irish Biblical Studies")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ICC")]), _c('td', [_vm._v("International Critical Commentary")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("IDB")])]), _c('td', [_vm._v("G. A. Buttrick (ed.), "), _c('i', [_vm._v("Interpreter’s Dictionary of the Bible")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("IDBSup")])]), _c('td', [_vm._v("Supplementary volume to "), _c('i', [_vm._v("IDB")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("IEJ")])]), _c('td', [_c('i', [_vm._v("Israel Exploration Journal")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Int")])]), _c('td', [_c('i', [_vm._v("Interpretation")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ITC")]), _c('td', [_vm._v("International Theological Commentary")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("ITQ")])]), _c('td', [_c('i', [_vm._v("Irish Theological Quarterly")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("JAC")]), _c('td', [_vm._v("Jahrbuch für Antike und Christentum")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JANESCU")])]), _c('td', [_c('i', [_vm._v("Journal of the Ancient Near Eastern Society of Columbia University")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JAOS")])]), _c('td', [_c('i', [_vm._v("Journal of the American Oriental Society")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("JB")]), _c('td', [_vm._v("A. Jones (ed.), "), _c('i', [_vm._v("Jerusalem Bible")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JBC")])]), _c('td', [_vm._v("R. E. Brown et al. (eds.), "), _c('i', [_vm._v("The Jerome Biblical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JBL")])]), _c('td', [_c('i', [_vm._v("Journal of Biblical Literature")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JEA")])]), _c('td', [_c('i', [_vm._v("Journal of Egyptian Archaeology")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JETS")])]), _c('td', [_c('i', [_vm._v("Journal of the Evangelical Theological Society")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JIGRE")])]), _c('td', [_c('i', [_vm._v("Jewish Inscriptions in Greco-Roman Egypt")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JJS")])]), _c('td', [_c('i', [_vm._v("Journal of Jewish Studies")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JNES")])]), _c('td', [_c('i', [_vm._v("Journal of Near Eastern Studies")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JOTTL")])]), _c('td', [_c('i', [_vm._v("Journal of Translation and Textlinguistics")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("JPS")]), _c('td', [_vm._v("Jewish Publication Society")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JR")])]), _c('td', [_c('i', [_vm._v("Journal of Religion")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("JSHRZ")]), _c('td', [_vm._v("Jüdische Schriften aus hellenistischrömischer Zeit")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JSJ")])]), _c('td', [_c('i', [_vm._v("Journal for the Study of Judaism in the Persian, Hellenistic, and Roman Period")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("JSJSup")]), _c('td', [_vm._v("Journal for the Study of Judaism Supplement Series")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JSNT")])]), _c('td', [_c('i', [_vm._v("Journal for the Study of the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("JSNTSup")]), _c('td', [_vm._v("Journal for the Study of the New Testament—Supplement Series")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JSOT")])]), _c('td', [_c('i', [_vm._v("Journal for the Study of the Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("JSOTSup")]), _c('td', [_vm._v("Journal for the Study of the Old Testament—Supplement Series")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JSP")])]), _c('td', [_c('i', [_vm._v("Journal for the Study of the Pseudepigrapha")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JSS")])]), _c('td', [_c('i', [_vm._v("Journal of Semitic Studies")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JTC")])]), _c('td', [_c('i', [_vm._v("Journal for Theology and the Church")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JTS")])]), _c('td', [_c('i', [_vm._v("Journal of Theological Studies")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("KAT")]), _c('td', [_vm._v("Kommentar zum Alten Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("KJV")]), _c('td', [_vm._v("King James Version")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("KS")])]), _c('td', [_c('i', [_vm._v("Kirjath-Sepher")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("LCC")]), _c('td', [_vm._v("Library of Christian Classics")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("LEC")]), _c('td', [_vm._v("Library of Early Christianity")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("MNTC")]), _c('td', [_vm._v("Moffatt New Testament Commentary")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NAB")]), _c('td', [_vm._v("New American Bible")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NAC")]), _c('td', [_vm._v("New American Commentary")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NASB")]), _c('td', [_vm._v("New American Standard Bible")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NABRNT")]), _c('td', [_vm._v("New American Bible with Revised Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NCB")]), _c('td', [_vm._v("New Century Bible")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NCBC")]), _c('td', [_vm._v("New Century Bible Commentary")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NEB")]), _c('td', [_vm._v("New English Bible")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Neot")])]), _c('td', [_c('i', [_vm._v("Neotestamentica")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NIBC")]), _c('td', [_vm._v("New International Biblical Commentary")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NICNT")]), _c('td', [_vm._v("New International Commentary on the New Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NICOT")]), _c('td', [_vm._v("New International Commentary on the Old Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("NIDNTT")])]), _c('td', [_c('i', [_vm._v("New International Dictionary of New Testament Theology")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("NIDOTTE")])]), _c('td', [_c('i', [_vm._v("New International Dictionary of Old Testament Theology and Exegesis")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NIGTC")]), _c('td', [_vm._v("The New International Greek Testament Commentary")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NIV")]), _c('td', [_vm._v("New International Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NIVAC")]), _c('td', [_vm._v("New International Version Application Commentary")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NJB")]), _c('td', [_vm._v("H. Wansbrough (ed.), "), _c('i', [_vm._v("New Jerusalem Bible")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("NJBC")])]), _c('td', [_vm._v("R. E. Brown et al. (ed.), "), _c('i', [_vm._v("The New Jerome Biblical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NJPS")]), _c('td', [_vm._v("New Jewish Publication Society")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("NovT")])]), _c('td', [_c('i', [_vm._v("Novum Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NovTSup")]), _c('td', [_vm._v("Novum Testamentum, Supplements")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NRSV")]), _c('td', [_vm._v("New Revised Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NTD")]), _c('td', [_vm._v("Das Neue Testament Deutsch")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NTG")]), _c('td', [_vm._v("New Testament Guides")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NTM")]), _c('td', [_vm._v("Norsk tidsskrift for misjon")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("NTS")])]), _c('td', [_c('i', [_vm._v("New Testament Studies")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NTSup")]), _c('td', [_vm._v("New Testament Supplements")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("OBO")]), _c('td', [_vm._v("Orbis biblicus et orientalis")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("OBT")]), _c('td', [_vm._v("Overtures to Biblical Theology")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ÖTKNT")]), _c('td', [_vm._v("Ökumenischer Taschenbuchkommentar zum Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("OTL")]), _c('td', [_vm._v("Old Testament Library")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("OTP")])]), _c('td', [_vm._v("J. H. Charlesworth (ed.), "), _c('i', [_vm._v("The Old Testament Pseudepigrapha")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("PEQ")])]), _c('td', [_c('i', [_vm._v("Palestine Exploration Quarterly")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("PNTC")]), _c('td', [_vm._v("Pillar New Testament Commentary")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("QD")]), _c('td', [_vm._v("Quaestiones disputatae")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("QL")]), _c('td', [_vm._v("Qumran Literature")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("RB")])]), _c('td', [_c('i', [_vm._v("Revue biblique")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("REB")])]), _c('td', [_vm._v("Revised English Bible")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("RelSRev")])]), _c('td', [_c('i', [_vm._v("Religious Studies Review")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("ResQ")])]), _c('td', [_c('i', [_vm._v("Restoration Quarterly")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("RevQ")])]), _c('td', [_c('i', [_vm._v("Revue de Qumran")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("RNT")]), _c('td', [_vm._v("Regensburger Neues Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("RSV")]), _c('td', [_vm._v("Revised Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("RTP")])]), _c('td', [_c('i', [_vm._v("Revue de théologie et de philosophie")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("RTR")])]), _c('td', [_c('i', [_vm._v("Reformed Theological Review")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SacPag")]), _c('td', [_vm._v("Sacra pagina")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("SBFLA")])]), _c('td', [_c('i', [_vm._v("Studii biblici Franciscani liber annuus")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SBLDS")]), _c('td', [_vm._v("SBL Dissertation Series")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SBLEJL")]), _c('td', [_vm._v("SBL Early Judaism and Its Literature")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SBLMS")]), _c('td', [_vm._v("SBL Monograph Series")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SBLRBS")]), _c('td', [_vm._v("SBL Resources for Biblical Study")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SBLSBS")]), _c('td', [_vm._v("SBL Sources for Biblical Study")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SBLSCS")]), _c('td', [_vm._v("SBL Septuagint and Cognate Studies")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SBLSP")]), _c('td', [_vm._v("SBL Seminar Papers")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SBLSS")]), _c('td', [_vm._v("SBL Symposium Series")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SBT")]), _c('td', [_vm._v("Studies in Biblical Theology")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("ScEs")])]), _c('td', [_c('i', [_vm._v("Science et esprit")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SD")]), _c('td', [_vm._v("Studies and Documents")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Sem")])]), _c('td', [_c('i', [_vm._v("Semitica")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("SIG")])]), _c('td', [_c('i', [_vm._v("Sylloge Inscriptionum Graecarum")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SJLA")]), _c('td', [_vm._v("Studies in Judaism in Late Antiquity")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("SJT")])]), _c('td', [_c('i', [_vm._v("Scottish Journal of Theology")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SNT")]), _c('td', [_vm._v("Studien zum Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SNTSMS")]), _c('td', [_vm._v("Society for New Testament Studies Monograph Series")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SO")]), _c('td', [_vm._v("Symbolae osloenses")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SOTSMS")]), _c('td', [_vm._v("Society for Old Testament Study Monograph Series")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SPB")]), _c('td', [_vm._v("Studia postbiblica")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SPS")]), _c('td', [_vm._v("Salzburger patristische Studien")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("ST")])]), _c('td', [_c('i', [_vm._v("Studia theologica")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("StudBib")]), _c('td', [_vm._v("Studia Biblica")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SUNT")]), _c('td', [_vm._v("Studien zur Umwelt des Neuen Testaments")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SVTP")]), _c('td', [_vm._v("Studia in Veteris Testamenti pseudepigrapha")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("TBu")]), _c('td', [_vm._v("Theologische Bücherei")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("TCGNT")])]), _c('td', [_vm._v("B. M. Metzger, "), _c('i', [_vm._v("A Textual Commentary on the Greek New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("TDNT")])]), _c('td', [_vm._v("G. Kittel and G. Friedrich (eds.), "), _c('i', [_vm._v("Theological Dictionary of the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("TLNT")])]), _c('td', [_c('i', [_vm._v("Theological Lexicon of the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("TNTC")]), _c('td', [_vm._v("Tyndale New Testament Commentaries")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("TOTC")]), _c('td', [_vm._v("Tyndale Old Testament Commentaries")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("TS")])]), _c('td', [_c('i', [_vm._v("Theological Studies")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("TTZ")])]), _c('td', [_c('i', [_vm._v("Trierer theologische Zeitschrift")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("TU")]), _c('td', [_vm._v("Texte und Untersuchungen")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("TynBul")])]), _c('td', [_c('i', [_vm._v("Tyndale Bulletin")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("UF")])]), _c('td', [_c('i', [_vm._v("Ugarit-Forschungen")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("USQR")])]), _c('td', [_c('i', [_vm._v("Union Seminary Quarterly Review")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("VC")])]), _c('td', [_c('i', [_vm._v("Vigiliae christianae")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("VT")])]), _c('td', [_c('i', [_vm._v("Vetus Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("VTSup")]), _c('td', [_vm._v("Vetus Testamentum, Supplements")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("WA")]), _c('td', [_vm._v("M. Luther, Kristische Gesamtausgabe (= “Weimar” edition)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("WBC")]), _c('td', [_vm._v("Word Biblical Commentary")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("WMANT")]), _c('td', [_vm._v("Wissenschaftliche Monographien zum Alten und Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("WTJ")])]), _c('td', [_c('i', [_vm._v("Westminster Theological Journal")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("WUNT")]), _c('td', [_vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("WWSup")])]), _c('td', [_c('i', [_vm._v("Word and World Supplement")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("ZAW")])]), _c('td', [_c('i', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ZBKNT")]), _c('td', [_vm._v("Zürcher Bibelkommentare, Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("ZNW")])]), _c('td', [_c('i', [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("ZTK")])]), _c('td', [_c('i', [_vm._v("Zeitschrift für Theologie und Kirche")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("GENERAL")]), _vm._v(" "), _c('table', {
    staticClass: "abbre",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("AD")])]), _c('td', [_c('i', [_vm._v("anno Domini")]), _vm._v(", in the year of our Lord")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Aram.")]), _c('td', [_vm._v("Aramaic")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("b.")]), _c('td', [_vm._v("born")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("b.")])]), _c('td', [_vm._v("Babylonian Talmud")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("BC")])]), _c('td', [_vm._v("before Christ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("c.")]), _c('td', [_c('i', [_vm._v("circa")]), _vm._v(", around")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("cent.")]), _c('td', [_vm._v("century")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("cf.")]), _c('td', [_c('i', [_vm._v("confer")]), _vm._v(", compare")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ch(s).")]), _c('td', [_vm._v("chapter(s)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("col.")]), _c('td', [_vm._v("column")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("d.")]), _c('td', [_vm._v("died")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("diss.")]), _c('td', [_vm._v("dissertation")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("DSS")]), _c('td', [_vm._v("Dead Sea Scrolls")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ed.")]), _c('td', [_vm._v("editor, edition")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("e.g.")]), _c('td', [_c('i', [_vm._v("exempli gratia")]), _vm._v(", for example")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("esp.")]), _c('td', [_vm._v("especially")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ET")]), _c('td', [_vm._v("English Translation")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("etc.")]), _c('td', [_c('i', [_vm._v("et cetera")]), _vm._v(", and the others")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("frg.")]), _c('td', [_vm._v("fragment")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Gk.")]), _c('td', [_vm._v("Greek")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("HB")]), _c('td', [_vm._v("Hebrew Bible")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Heb.")]), _c('td', [_vm._v("Hebrew")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("i.e.")]), _c('td', [_c('i', [_vm._v("id est")]), _vm._v(", that is")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("km.")]), _c('td', [_vm._v("kilometer")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("lit.")]), _c('td', [_vm._v("literally")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("LXX")]), _c('td', [_vm._v("Septuagint")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("m.")])]), _c('td', [_vm._v("Mishnah")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("mg.")]), _c('td', [_vm._v("margin")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("mss.")]), _c('td', [_vm._v("manuscripts")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Mt.")]), _c('td', [_vm._v("Mount")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("MT")]), _c('td', [_vm._v("Masoretic Text")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NT")]), _c('td', [_vm._v("New Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("OT")]), _c('td', [_vm._v("Old Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("p.")])]), _c('td', [_vm._v("Palestinian (Talmud)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("par.")]), _c('td', [_vm._v("parallel")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("para(s).")]), _c('td', [_vm._v("paragraph(s)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("pp.")]), _c('td', [_vm._v("pages (used only when necessary)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("pt.")]), _c('td', [_vm._v("part")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Q")]), _c('td', [_vm._v("Quelle (“sayings”) source for the Synoptic Gospels")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("repr.")]), _c('td', [_vm._v("reprinted")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("rev.")]), _c('td', [_vm._v("revised")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("t.")])]), _c('td', [_vm._v("Tosefta")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("trans.")]), _c('td', [_vm._v("translated by")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("v. (vv.)")]), _c('td', [_vm._v("verse, verses")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Vg")]), _c('td', [_vm._v("Vulgate")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("vs.")]), _c('td', [_vm._v("versus")])])])]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("BIBLICAL BOOKS (WITH THE APOCRYPHA)")]), _vm._v(" "), _c('table', {
    staticClass: "abbre",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Gen")]), _c('td', [_vm._v("Genesis")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Exod")]), _c('td', [_vm._v("Exodus")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Lev")]), _c('td', [_vm._v("Leviticus")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Num")]), _c('td', [_vm._v("Numbers")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Deut")]), _c('td', [_vm._v("Deuteronomy")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Josh")]), _c('td', [_vm._v("Joshua")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Judg")]), _c('td', [_vm._v("Judges")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-2 Sam")]), _c('td', [_vm._v("1-2 Samuel")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-2 Kgs")]), _c('td', [_vm._v("1-2 Kings")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Isa")]), _c('td', [_vm._v("Isaiah")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Jer")]), _c('td', [_vm._v("Jeremiah")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ezek")]), _c('td', [_vm._v("Ezekiel")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hos")]), _c('td', [_vm._v("Hosea")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Joel")]), _c('td', [_vm._v("Joel")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Amos")]), _c('td', [_vm._v("Amos")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Obad")]), _c('td', [_vm._v("Obadiah")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Jonah")]), _c('td', [_vm._v("Jonah")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Mic")]), _c('td', [_vm._v("Micah")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Nah")]), _c('td', [_vm._v("Nahum")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hab")]), _c('td', [_vm._v("Habakkuk")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Zeph")]), _c('td', [_vm._v("Zephaniah")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hag")]), _c('td', [_vm._v("Haggai")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Zech")]), _c('td', [_vm._v("Zechariah")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Mal")]), _c('td', [_vm._v("Malachi")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ps ("), _c('i', [_vm._v("pl.:")]), _vm._v(" Pss)")]), _c('td', [_vm._v("Psalm(s)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Job")]), _c('td', [_vm._v("Job")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Prov")]), _c('td', [_vm._v("Proverbs")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ruth")]), _c('td', [_vm._v("Ruth")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cant")]), _c('td', [_vm._v("Canticles")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Eccl ("), _c('i', [_vm._v("or")]), _vm._v(" Qoh)")]), _c('td', [_vm._v("Ecclesiastes ("), _c('i', [_vm._v("or")]), _vm._v(" Qoheleth)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Lam")]), _c('td', [_vm._v("Lamentations")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Esth")]), _c('td', [_vm._v("Esther")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Dan")]), _c('td', [_vm._v("Daniel")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ezra")]), _c('td', [_vm._v("Ezra")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Neh")]), _c('td', [_vm._v("Nehemiah")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-2 Chr")]), _c('td', [_vm._v("1-2 Chronicles")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-2-3-4 Kgdms")]), _c('td', [_vm._v("1-2-3-4 Kingdoms")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Add Esth")]), _c('td', [_vm._v("Additions to Esther")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bar")]), _c('td', [_vm._v("Baruch")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bel")]), _c('td', [_vm._v("Bel and the Dragon")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-2 Esdr")]), _c('td', [_vm._v("1-2 Esdras")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4 Ezra")]), _c('td', [_vm._v("4 Ezra")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Jdt")]), _c('td', [_vm._v("Judith")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ep Jer")]), _c('td', [_vm._v("Epistle of Jeremiah")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-2-3-4 Macc")]), _c('td', [_vm._v("1-2-3-4 Maccabees")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pr Azar")]), _c('td', [_vm._v("Prayer of Azariah")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pr Man")]), _c('td', [_vm._v("Prayer of Manasseh")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sir")]), _c('td', [_vm._v("Sirach")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sus")]), _c('td', [_vm._v("Susanna")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Tob")]), _c('td', [_vm._v("Tobit")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Wis")]), _c('td', [_vm._v("Wisdom of Solomon")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Matt")]), _c('td', [_vm._v("Matthew")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Mark")]), _c('td', [_vm._v("Mark")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Luke")]), _c('td', [_vm._v("Luke")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("John")]), _c('td', [_vm._v("John")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Acts")]), _c('td', [_vm._v("Acts")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Rom")]), _c('td', [_vm._v("Romans")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-2 Cor")]), _c('td', [_vm._v("1-2 Corinthians")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Gal")]), _c('td', [_vm._v("Galatians")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Eph")]), _c('td', [_vm._v("Ephesians")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Phil")]), _c('td', [_vm._v("Philippians")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Col")]), _c('td', [_vm._v("Colossians")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-2 Thess")]), _c('td', [_vm._v("1-2 Thessalonians")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-2 Tim")]), _c('td', [_vm._v("1-2 Timothy")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Titus")]), _c('td', [_vm._v("Titus")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Phlm")]), _c('td', [_vm._v("Philemon")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Heb")]), _c('td', [_vm._v("Hebrews")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Jas")]), _c('td', [_vm._v("James")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-2 Pet")]), _c('td', [_vm._v("1-2 Peter")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1-2-3 John")]), _c('td', [_vm._v("1-2-3 John")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Jude")]), _c('td', [_vm._v("Jude")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Rev")]), _c('td', [_vm._v("Revelation")])])])]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("ANCIENT WORKS")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Pseudepigraphical Books")]), _vm._v(" "), _c('table', {
    staticClass: "abbre0",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('i', [_vm._v("Apoc. Abr.")])]), _c('td', [_c('i', [_vm._v("Apocalypse of Abraham")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("2-3 Apoc. Bar.")])]), _c('td', [_vm._v("Syrian, Greek "), _c('i', [_vm._v("Apocalypse of Baruch")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Apoc. Elijah")])]), _c('td', [_c('i', [_vm._v("Apocalypse of Elijah")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Apoc. Mos.")])]), _c('td', [_c('i', [_vm._v("Apocalypse of Moses")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Apoc. Zeph.")])]), _c('td', [_c('i', [_vm._v("Apocalypse of Zephaniah")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("As. Mos.")])]), _c('td', [_c('i', [_vm._v("Assumption of Moses")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Asc. Isa.")])]), _c('td', [_c('i', [_vm._v("Ascension of Isaiah")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("1-2-3 Enoch")])]), _c('td', [_vm._v("Ethiopic, Slavonic, Hebrew Enoch")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Ep. Arist.")])]), _c('td', [_c('i', [_vm._v("Epistle of Aristeas")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Jos. Asen.")])]), _c('td', [_c('i', [_vm._v("Joseph and Aseneth")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Jub.")])]), _c('td', [_c('i', [_vm._v("Jubilees")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Mart. Isa.")])]), _c('td', [_c('i', [_vm._v("Martyrdom of Isaiah")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Para. Jer.")])]), _c('td', [_c('i', [_vm._v("Paraleipomena Jeremiah")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Pss. Sol.")])]), _c('td', [_c('i', [_vm._v("Psalms of Solomon")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Sib. Or.")])]), _c('td', [_c('i', [_vm._v("Sibylline Oracles")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("T. Job")])]), _c('td', [_c('i', [_vm._v("Testament of Job")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("T. Moses")])]), _c('td', [_c('i', [_vm._v("Testament of Moses")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("T. 12 Patr.")])]), _c('td', [_c('i', [_vm._v("Testaments of the Twelve Patriarchs")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("T. Ash.")])]), _c('td', [_c('i', [_vm._v("Testament of Asher")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("T. Benj.")])]), _c('td', [_c('i', [_vm._v("Testament of Benjamin")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("T. Dan")])]), _c('td', [_c('i', [_vm._v("Testament of Dan")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("T. Iss.")])]), _c('td', [_c('i', [_vm._v("Testament of Issachar")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("T. Jos.")])]), _c('td', [_c('i', [_vm._v("Testament of Joseph")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("T. Jud.")])]), _c('td', [_c('i', [_vm._v("Testament of Judah")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("T. Levi")])]), _c('td', [_c('i', [_vm._v("Testament of Levi")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("T. Naph.")])]), _c('td', [_c('i', [_vm._v("Testament of Naphtali")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("T. Reub.")])]), _c('td', [_c('i', [_vm._v("Testament of Reuben")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("T. Sol.")])]), _c('td', [_c('i', [_vm._v("Testament of Solomon")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Early Patristic Books")]), _vm._v(" "), _c('table', {
    staticClass: "abbre0",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('i', [_vm._v("Apost. Const.")])]), _c('td', [_c('i', [_vm._v("Apostolic Constitutions")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Barn.")])]), _c('td', [_c('i', [_vm._v("Barnabas")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Clem.")]), _c('td', [_vm._v("Clement")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Strom.")])]), _c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Stromateis")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("1-2 Clem.")])]), _c('td', [_c('i', [_vm._v("1-2 Clement")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Did.")])]), _c('td', [_c('i', [_vm._v("Didache")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Diogn.")])]), _c('td', [_c('i', [_vm._v("Diognetus")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_c('i', [_vm._v("Ep. ad Flor.")])])]), _c('td', [_c('i', [_vm._v("Letter to Florinus")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Eusebius")]), _c('td', [_vm._v("Eusebius")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Hist. Eccl.")])]), _c('td', {
    staticClass: "td2"
  }, [_c('i', [_vm._v("Historia ecclesiastica")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Praep. Evang.")])]), _c('td', {
    staticClass: "td2"
  }, [_c('i', [_vm._v("Praeparatio evangelica")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Gos. Naz.")])]), _c('td', [_c('i', [_vm._v("Gospel of the Nazarenes")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Herm.")]), _c('td', [_vm._v("Hermas")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Sim.")])]), _c('td', {
    staticClass: "td2"
  }, [_c('i', [_vm._v("Similitude(s)")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ign.")]), _c('td', [_vm._v("Ignatius")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Eph.")])]), _c('td', {
    staticClass: "td2"
  }, [_c('i', [_vm._v("Letter to the Ephesians")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Magn.")])]), _c('td', {
    staticClass: "td2"
  }, [_c('i', [_vm._v("Letter to the Magnesians")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Phld.")])]), _c('td', {
    staticClass: "td2"
  }, [_c('i', [_vm._v("Letter to the Philadelphians")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Pol.")])]), _c('td', {
    staticClass: "td2"
  }, [_c('i', [_vm._v("Letter to Polycarp")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Trall.")])]), _c('td', {
    staticClass: "td2"
  }, [_c('i', [_vm._v("Letter to the Trallians")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Iren.")]), _c('td', [_vm._v("Irenaeus")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Adv. Haer.")])]), _c('td', {
    staticClass: "td2"
  }, [_c('i', [_vm._v("Adversus haereses")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Justin")]), _c('td', [_vm._v("Justin")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Dial. Tryph.")])]), _c('td', {
    staticClass: "td2"
  }, [_c('i', [_vm._v("Dialogus contra Tryphonem")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("1 Apol.")])]), _c('td', {
    staticClass: "td2"
  }, [_c('i', [_vm._v("First Apology")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Origen")]), _c('td', [_vm._v("Origen")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("In Jerem. hom. Lat.")])]), _c('td', {
    staticClass: "td2"
  }, [_c('i', [_vm._v("Latinae homiliae in Jeremiam")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pol.")]), _c('td', [_vm._v("Polycarp")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Phil.")])]), _c('td', {
    staticClass: "td2"
  }, [_c('i', [_vm._v("Letter to the Philippians")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Ps.-Clem.")])]), _c('td', [_c('i', [_vm._v("Pseudo-Clementine Recognitions")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ps.-Philo")]), _c('td', [_vm._v("Pseudo-Philo")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Bib. Ant.")])]), _c('td', {
    staticClass: "td2"
  }, [_c('i', [_vm._v("Biblical Antiquities")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Tertullian")]), _c('td', [_vm._v("Tertullian")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Adv. Marc.")])]), _c('td', {
    staticClass: "td2"
  }, [_c('i', [_vm._v("Adversus Marcionum")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Dead Sea Scrolls and Related Texts")]), _vm._v(" "), _c('table', {
    staticClass: "abbre0",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("CD")]), _c('td', [_vm._v("Cairo (Genizah text of the) "), _c('i', [_vm._v("Damascus (Document)")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1Q, 2Q, 3Q, etc.")]), _c('td', [_vm._v("Numbered caves of Qumran, yielding written material; followed by abbreviation of biblical or apocryphal book")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1QapGen")]), _c('td', [_c('i', [_vm._v("Genesis Apocryphon")]), _vm._v(" of Qumran Cave 1")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1QH")]), _c('td', [_c('i', [_vm._v("Hodayot (Thanksgiving Hymns)")]), _vm._v(" from Qumran Cave 1")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1QIsa"), _c('sup', [_vm._v("﻿a")])]), _c('td', [_vm._v("First copy of Isaiah from Qumran Cave 1")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1QIsa"), _c('sup', [_vm._v("﻿b")])]), _c('td', [_vm._v("Second copy of Isaiah from Qumran Cave 1")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1QpHab")]), _c('td', [_c('i', [_vm._v("Pesher on Habakkuk")]), _vm._v(" from Qumran Cave 1")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1QM")]), _c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("Milḥamah")]), _vm._v(" (War Scroll)")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1QS")]), _c('td', [_c('i', [_vm._v("Serek hayyahad (Rule of the Community, Manual of Discipline)")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1QSa")]), _c('td', [_vm._v("Appendix A "), _c('i', [_vm._v("(Rule of the Congregation)")]), _vm._v(" to 1QS")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4QDibHam")]), _c('td', [_c('i', [_vm._v("Words of the Luminaries")]), _vm._v(" from Qumran Cave 4")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4QFlor")]), _c('td', [_c('i', [_vm._v("Florilegium")]), _vm._v(" (or "), _c('i', [_vm._v("Eschatological Midrashim")]), _vm._v(") from Qumran Cave 4")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4QMMT")]), _c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("Miqṣat Maʿase ha-Torah")])]), _vm._v(" from Qumran Cave 4")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4QpHab")]), _c('td', [_c('i', [_vm._v("Pesher on Habakkuk")]), _vm._v(" from Qumran Cave 4")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4QPrNab")]), _c('td', [_c('i', [_vm._v("Prayer of Nabonidus")]), _vm._v(" from Qumran Cave 4")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4QpsDan ar"), _c('sup', [_vm._v("﻿a")])]), _c('td', [_c('i', [_vm._v("Apocryphon of Daniel")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("11QMelch")]), _c('td', [_c('i', [_vm._v("Melchizedek")]), _vm._v(" text from Qumran Cave 11")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("11QTemple")]), _c('td', [_c('i', [_vm._v("Temple Scroll")]), _vm._v(" from Qumran Cave 11")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("11QPs"), _c('sup', [_vm._v("﻿a")])]), _c('td', [_c('i', [_vm._v("Psalms Scroll")]), _vm._v(" from Qumran Cave 11")])])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Targumic Material")]), _vm._v(" "), _c('table', {
    staticClass: "abbre0",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('i', [_vm._v("Tg. Neb.")])]), _c('td', [_c('i', [_vm._v("Targum of the Prophets")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Tg. Neof.")])]), _c('td', [_c('i', [_vm._v("Targum")]), _vm._v(" Neofiti")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Tg. Isa")])]), _c('td', [_c('i', [_vm._v("Targum of Isaiah")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Tg. Hos")])]), _c('td', [_c('i', [_vm._v("Targum of Hosea")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Tg. Ps.-Jon.")])]), _c('td', [_c('i', [_vm._v("Targum of Pseudo-Jonathan")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Orders and Tractates in Mishnaic and Related Literature")]), _vm._v(" "), _c('table', {
    staticClass: "abbre0",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("Abot")])]), _c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("Abot")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("B. Bat.")])]), _c('td', [_c('i', [_vm._v("Baba Batra")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Ber.")])]), _c('td', [_c('i', [_vm._v("Berakhot")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("Ed.")])]), _c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("Eduyyot")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("Erub.")])]), _c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("Erubin")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("Giṭ.")])])]), _c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("Giṭṭin")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("Ḥag")]), _vm._v(".")])]), _c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("Ḥagigah")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Hor.")])]), _c('td', [_c('i', [_vm._v("Horayot")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Kelim")])]), _c('td', [_c('i', [_vm._v("Kelim")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Ker.")])]), _c('td', [_c('i', [_vm._v("Keritot")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Ma"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("as.")])]), _c('td', [_c('i', [_vm._v("Ma"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("aserot")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Mak.")])]), _c('td', [_c('i', [_vm._v("Makkot")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Meg.")])]), _c('td', [_c('i', [_vm._v("Megillah")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Ned.")])]), _c('td', [_c('i', [_vm._v("Nedarim")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Nid.")])]), _c('td', [_c('i', [_vm._v("Niddah")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("Pesaḥ.")])])]), _c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("Pesaḥim")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Sanh.")])]), _c('td', [_c('i', [_vm._v("Sanhedrin")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Shab.")])]), _c('td', [_c('i', [_vm._v("Shabbat")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Sheqal.")])]), _c('td', [_c('i', [_vm._v("Sheqalim")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("oṭa")])])]), _c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("Soṭa")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Suk.")])]), _c('td', [_c('i', [_vm._v("Sukkah")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Ta"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("an")])]), _c('td', [_c('i', [_vm._v("Ta"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("anit")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("Ṭohar")]), _vm._v(".")])]), _c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("Ṭoharot")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Yoma")])]), _c('td', [_c('i', [_vm._v("Yoma")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Other Rabbinic Works")]), _vm._v(" "), _c('table', {
    staticClass: "abbre0",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("Abot R. Nat.")])]), _c('td', [_c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("Abot de-Rabbi Nathan")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Mek.")])]), _c('td', [_c('i', [_vm._v("Mekilta")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Midr.")])]), _c('td', [_c('i', [_vm._v("Midrash")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Pesiq. R.")])]), _c('td', [_c('i', [_vm._v("Pesiqta Rabbati")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Pesiq. Rab. Kah.")])]), _c('td', [_c('i', [_vm._v("Pesiqta de Rab Kahana")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Pirqe R. El.")])]), _c('td', [_c('i', [_vm._v("Pirqe Rabbi Eliezer")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Rab.")])]), _c('td', [_c('i', [_vm._v("Rabbah")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("Sipre")])]), _c('td', [_c('i', [_vm._v("Sipre")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Other Ancient Works")]), _vm._v(" "), _c('table', {
    staticClass: "abbre0",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Aeschylus")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Agam.")])]), _c('td', [_c('i', [_vm._v("Agamemnon")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Aristotle")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Nic. Eth.")])]), _c('td', [_c('i', [_vm._v("Nicomachean Ethics")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Rhet.")])]), _c('td', [_c('i', [_vm._v("On Rhetoric")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Cicero")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Tusc. disp.")])]), _c('td', [_c('i', [_vm._v("Tusculanae disputationes")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Demosthenes")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Orat.")])]), _c('td', [_c('i', [_vm._v("Orations")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Dio Chrysostom")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Ep.")])]), _c('td', [_c('i', [_vm._v("Epistles")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Orat.")])]), _c('td', [_c('i', [_vm._v("Orations")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Dionysius of Halicarnassus")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Rom. Ant.")])]), _c('td', [_c('i', [_vm._v("Antiquitates Romanae")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Epictetus")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Disc.")])]), _c('td', [_c('i', [_vm._v("Discourses")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_c('i', [_vm._v("Diss.")])])]), _c('td', [_c('i', [_vm._v("Dissertations")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Epimenides")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Strom.")])]), _c('td', [_c('i', [_vm._v("Stromateis")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Herodotus")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Hist.")])]), _c('td', [_c('i', [_vm._v("Histories")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Josephus")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Ag. Ap.")])]), _c('td', [_c('i', [_vm._v("Against Apion")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Ant.")])]), _c('td', [_c('i', [_vm._v("Antiquities")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("J.W.")])]), _c('td', [_c('i', [_vm._v("Jewish Wars")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Life")])]), _c('td', [_c('i', [_vm._v("Life of Flavius Josephus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Juvenal")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Sat.")])]), _c('td', [_c('i', [_vm._v("Satires")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Livy")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Hist.")])]), _c('td', [_c('i', [_vm._v("Histories")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Lucian")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Peregr.")])]), _c('td', [_c('i', [_vm._v("The Passing of Peregrinus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Musonius")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Orat.")])]), _c('td', [_c('i', [_vm._v("Orations")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Philo")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Abr.")])]), _c('td', [_c('i', [_vm._v("De Abrahamo")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Agr.")])]), _c('td', [_c('i', [_vm._v("De agricultura")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Cher.")])]), _c('td', [_c('i', [_vm._v("De cherubim")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Conf. ling.")])]), _c('td', [_c('i', [_vm._v("De confusione linguarum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Congr.")])]), _c('td', [_c('i', [_vm._v("De congressu eruditionis gratia")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Decal.")])]), _c('td', [_c('i', [_vm._v("De decalogo")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Det. pot. ins.")])]), _c('td', [_c('i', [_vm._v("Quod deterius potiori insidiari soleat")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Ebr.")])]), _c('td', [_c('i', [_vm._v("De ebrietate")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Flacc.")])]), _c('td', [_c('i', [_vm._v("In Flaccum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Fug.")])]), _c('td', [_c('i', [_vm._v("De fuga et inventione")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Gig.")])]), _c('td', [_c('i', [_vm._v("De gigantibus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Her.")])]), _c('td', [_c('i', [_vm._v("Quis rerum divinarum heres sit")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Hypoth.")])]), _c('td', [_c('i', [_vm._v("Hypothetica")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Leg. all.")])]), _c('td', [_c('i', [_vm._v("Legum allegoriae")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Legat.")])]), _c('td', [_c('i', [_vm._v("Legatio ad Gaium")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Migr. Abr.")])]), _c('td', [_c('i', [_vm._v("De migratione Abrahami")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Mut. nom.")])]), _c('td', [_c('i', [_vm._v("De mutatione nominum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Opif.")])]), _c('td', [_c('i', [_vm._v("De opificio mundi")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Post.")])]), _c('td', [_c('i', [_vm._v("De posteritate Caini")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Prob.")])]), _c('td', [_c('i', [_vm._v("Quod omnis probus liber sit")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Quaest. Exod.")])]), _c('td', [_c('i', [_vm._v("Quaestiones et solutiones in Exodum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Quaest Gen.")])]), _c('td', [_c('i', [_vm._v("Quaestiones et solutiones in Genesim")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Sacr.")])]), _c('td', [_c('i', [_vm._v("De sacrificiis Abelis et Caini")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Somn.")])]), _c('td', [_c('i', [_vm._v("De somniis")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Spec. leg.")])]), _c('td', [_c('i', [_vm._v("De specialibus legibus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Virt.")])]), _c('td', [_c('i', [_vm._v("De virtutibus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Vit. Mos.")])]), _c('td', [_c('i', [_vm._v("De vita Mosis")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Philostratus")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Vita Ap.")])]), _c('td', [_c('i', [_vm._v("Vita Apollonius")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Plato")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Apol.")])]), _c('td', [_c('i', [_vm._v("Apology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Gorg.")])]), _c('td', [_c('i', [_vm._v("Gorgias")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Rep.")])]), _c('td', [_c('i', [_vm._v("Republic")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Sym.")])]), _c('td', [_c('i', [_vm._v("Symposium")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Pliny")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Ep.")])]), _c('td', [_c('i', [_vm._v("Epistles")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Nat. Hist.")])]), _c('td', [_c('i', [_vm._v("Natural History")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Plutarch")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Mor.")])]), _c('td', [_c('i', [_vm._v("Moralia")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Polybius")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Hist.")])]), _c('td', [_c('i', [_vm._v("History")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Quintilian")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Inst.")])]), _c('td', [_c('i', [_vm._v("Institutio oratoria")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Rhet. Her.")])]), _c('td', [_c('i', [_vm._v("Rhetorica ad Herennium")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Seneca")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Benef.")])]), _c('td', [_c('i', [_vm._v("De beneficiis")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Ep. Mor.")])]), _c('td', [_c('i', [_vm._v("Epistulae morales")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Strabo")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Geog.")])]), _c('td', [_c('i', [_vm._v("Geography")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Tacitus")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Ann.")])]), _c('td', [_c('i', [_vm._v("Annales")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Hist.")])]), _c('td', [_c('i', [_vm._v("Historiae")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Thucydides")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Hist.")])]), _c('td', [_c('i', [_vm._v("Histories")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Xenophon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Apol.")])]), _c('td', [_c('i', [_vm._v("Apologia Socratis")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Cyr.")])]), _c('td', [_c('i', [_vm._v("Cyropaedia")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Mem.")])]), _c('td', [_c('i', [_vm._v("Memorabilia")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('i', [_vm._v("Symp.")])]), _c('td', [_c('i', [_vm._v("Symposium")])])])])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT",
    attrs: {
      "id": "ch001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-001"
    }
  }, [_c('i', [_vm._v("The History of the Tradition: Old Testament and Apocrypha")])])]), _vm._v(" "), _c('p', {
    staticClass: "CA"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-001"
    }
  }, [_vm._v("John W. Rogerson")])]), _vm._v(" "), _c('p', {
    staticClass: "H1a"
  }, [_vm._v("1. The History and Purpose of the Old Testament and Apocrypha")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("How, when, and why were the Old Testament (OT) and the Apocrypha written? The obvious place to look for answers to these questions is in the texts themselves. Exod 24:7 refers to “the book of the covenant” which Moses read to the people at Mt. Sinai, while Exod 34:28 reports that Moses wrote “the words of the covenant, the ten commandments” on stone tablets according to God’s instructions. Many of the regulations concerning priesthood and sacrifice in Leviticus and Numbers begin with the formulae “the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" said/spoke to Moses/Aaron,” implying their divine origin as well as their mediation through Moses and Aaron. Deuteronomy is an address by Moses to the Israelites gathered in the plains of Moab. In 1 Sam 10:25 Samuel writes in a book “the rights and duties of the kingship,” while 1 Kgs 4:32 attributes 3,000 proverbs and 1,005 songs to Solomon. The prophet Isaiah is told to seal the testimony and the teaching (i.e., to write them down) among his disciples, while Jeremiah dictates two sets of prophecies to Baruch, the first of which is destroyed by King Jehoiakim (Jeremiah 36). In the Apocrypha the grandson of the author of the original Hebrew of Sirach (Ecclesiasticus) and its translator into Greek tells us something about himself and his grandfather (Sirach, Prologue), while Bar 1:1–2 claims as its author the Baruch who was Jeremiah’s scribe. The Letter of Jeremiah (Baruch 6) is “a copy of a letter that Jeremiah sent.…” 2 Maccabees describes itself as a condensation of a five-volume work by Jason of Cyrene (2 Macc 2:23), while 2 Esdras claims to be the work of Ezra (2 Esdr 1:1–3).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the history of interpretation far more attention has been paid to the claims made about authorship in the OT than in the Apocrypha; indeed, in Protestant circles that rejected the Apocrypha as Scripture some of the claims to authorship in the Apocrypha were subjected to critical scrutiny in order to show that they were false and that the Apocrypha were therefore discredited. Out of the hints found in the OT a view of its authorship emerged perhaps as early as the second century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" and was recorded in "), _c('i', [_vm._v("b. B. Bat.")]), _vm._v(" 14b–15a. Those who held this view attributed “his book” (presumably most of Genesis to Deuteronomy) and Job to Moses, the book of Joshua and eight verses of the Torah (presumably Deut 34:5–12, recording the death of Moses) to Joshua, the books of Judges, Ruth, and 1 and 2 Samuel to Samuel, and the Psalms to David assisted by ten elders, including the first Adam, Melchizedek, and Abraham. Jeremiah was credited with 1 and 2 Kings, Jeremiah, and Lamentations, and Hezekiah and his helpers (cf. Prov 25:1) with Isaiah, Proverbs, Canticles, and Ecclesiastes. The remainder were attributed to the “Men of the Great Synagogue” and Ezra.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Positions similar to, but not identical with, these were to establish themselves in Christian scholarship and to last into the nineteenth century. They can still be found in the young churches of the developing world which are innocent of biblical criticism. The traditional views of authorship had two strengths. First, they provided a clear account of the origin of the faith of Israel. It was divine revelation communicated directly to individuals such as Moses. Secondly, if the authors of OT books were known, it became possible to regard them as writers inspired by God. The seemingly neutral question, “Who wrote this book?” became closely tied up with theories about the authority and inspiration of the OT such that to question traditional views of the authorship of a book could be regarded as an attack on that book’s status as inspired Scripture. This difficulty is still felt by Christians who are not necessarily “fundamentalists.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This is not the place to describe how and why the traditional positions on authorship were abandoned from the late eighteenth century onward. This abandonment did, however, have serious consequences for the study of the OT. The traditional views accounted for the origin of the faith of Israel. Where, however, did this faith come from if it was no longer possible to accept at face value statements such as “the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" spoke to Moses, saying …?” If, as is often maintained, much of the priestly and sacrificial legislation in Leviticus and Numbers is a late development rather than something revealed to Israel at the outset, how is the history of Israel’s faith to be reconstructed?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This question must now be addressed because it is fundamental to any attempt to sketch the origin and formation of the traditions and books that make up the OT and Apocrypha; and it must be said at the outset that only some broad indications can be given. As a first step, we will consider several attempts to account for the origin of the faith of Israel and the traditions witnessing to it. Some or all of them may be familiar to readers, and their strengths and weaknesses are informative.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A consensus that emerged in the latter part of the nineteenth century was that the prophets of Israel, especially those of the eighth century (Isaiah of Jerusalem, "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Hosea, Amos, and Micah), were the main force behind the formation of Israel’s faith. Reacting to Canaanite fertility cults and despotic rulers, the prophets proclaimed ethical monotheism and social justice and challenged Israel to look beyond national interests to God’s universal rule. Failure to respond to these challenges would bring divine punishment upon the people, who had been chosen by God for responsibility and not for complacency. The sixth-century prophets (Jeremiah, Ezekiel, and Deutero-Isaiah) enabled Judah to survive the Babylonian captivity and to learn new and deeper lessons about sin, punishment, and vicarious suffering. Some of these insights were consolidated into the developing sacrificial rituals of the postexilic Jerusalem temple with its emphasis on expiation. At the same time, personal piety found expression in the composition and use of the Psalms, while contact with Hellenism from the late fourth century resulted in the OT “wisdom” traditions (Proverbs, Job, and Ecclesiastes), including those in the Apocrypha (Wisdom of Solomon and Sirach).")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("This consensus was set in the context of various developmental and evolutionary schemes. One approach, influential in Britain, traced in the OT a progressive development of religious belief from animism, polytheism, and henotheism (belief that the God of Israel was supreme among the gods) to monotheism (belief that the God of Israel was the only God). It also held that Israel had experienced a progressive moral and ethical development. The OT thus became the record of a progressive revelation or education. Other approaches focused on Israel’s social development: from a “nomadic” people to one surrounded by fertility cults in a settled land; from a loose association of tribes to a dynastic state ruling other small states. A popular source for Israel’s faith was the supposed clarity and purity of the desert in which there were no shades of grey and where God’s moral being and ethical demands could be more readily apprehended than elsewhere.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A major factor highlighted by this consensus was that if appeal was no longer made to divine revelation communicated to known individuals as the origin of the faith of Israel, alternative explanations had to be found; and these were likely to be taken from secular theories that were popular at the time, such as those influenced by social Darwinism.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the twentieth century two notable attempts were made to correct or modify the nineteenth-century consensus and to offer alternative explanations of the origins of Israel’s faith. The first, associated with W. F. Albright and his students John Bright and G. E. Wright, believed that archeology supported a mildly critical, traditional reading of the OT. The ancestors (Abraham, Isaac, and Jacob) were located in second-millennium Mesopotamia and Syria/Palestine, and the exodus was dated in the thirteenth century. The faith of Israel derived from acts of God in history such as the exodus, events which could be dated and reconstructed with the aid of historical and archeological research but which inspired witnesses who experienced them had perceived to be acts of God. Wright’s books "), _c('i', [_vm._v("Biblical Archaeology")]), _vm._v(" and "), _c('i', [_vm._v("God Who Acts: Biblical Theology as Recital")]), _vm._v(" were classic statements of this position.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The second approach, that of G. von Rad, was more skeptical about what could be known about figures such as Moses and the ancestors and events associated with them in the biblical record. It did not so much search for the origins of Israel’s faith as concern itself with proclamations of that faith which were held to be connected with two great festivals, one which celebrated the occupation of the land and one which celebrated the giving of the law at Mt. Sinai. The datum, in other words, was the faith that was confessed rather than the revelations or events that gave rise to the faith. Those parts of the confession that referred to revelatory events such as the exodus referred to happenings beyond the scope of historical research, either because the necessary evidence was not available or because theological reflection on the events and the celebratory retelling of them had altered them beyond recognition in the tradition. According to von Rad, the core of the Pentateuch was to be found in the “creed” recited at the festival of first fruits, according to Deut 26:5–9:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("“A wandering Aramean was my ancestor; he went down into Egypt and lived there as an alien, few in number, and there he became a great nation, mighty and populous. When the Egyptians treated us harshly and afflicted us, by imposing hard labor on us, we cried to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", the God of our ancestors; the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" heard our voice and saw our affliction, our toil, and our oppression. The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" brought us out of Egypt with a mighty hand and an outstretched arm, with a terrifying display of power, and with signs and wonders; and he brought us into this place.…”")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Two other features of von Rad’s position were important: belief in the “Solomonic Enlightenment,” a period in the tenth century during the reign of Solomon in which the traditions relating to Israel’s faith began to be written down; and acceptance of A. Alt’s attempt to identify the “God of the fathers” (i.e., the ancestors) by means of comparative studies. According to Alt, the “God of the fathers” (a common phrase in the tradition) identified a manifestation of the divine to a particular person, whose descendants then worshiped that manifestation as, for example, the God of Abraham or the God of Nahor (Gen 31:53), Abraham and Nahor being the names of ancestors to whom, it was believed, the deity had been manifested. This accounted for the traditions about Abraham and the other ancestors.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Since the work of Wright and von Rad (both of whom died in the early 1970s) OT studies have undergone a transformation in radical directions which has completely changed the landscape of the discipline. New literary-critical study of the Pentateuch and the “historical” books (Joshua to 2 Kings) has suggested later dates for their composition. The nineteenth-century consensus dated the sources for these books from the tenth/ninth to the seventh/sixth centuries. There is now a tendency to regard all of them as postexilic. Von Rad’s “Solomonic Enlightenment” has been abandoned. At the same time, archeological research has produced an account of the history of Syria/Palestine that suggests that Israel, Judah, Moab, Ammon, and Edom did not begin to ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("emerge as “states” until the ninth-eighth centuries "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". The biblical accounts of the empires of David and Solomon hardly fit in with this picture, although it is going too far to deny the existence of David and Solomon. Events such as the exodus or the time of the ancestors are now so remote compared with the proposed dates for the traditions about them that they have become invisible as far as any historical attempt to recover them is concerned. At the same time, much more has become known about the popular religion of Israel thanks to the researches of Othmar Keel and his associates on cylinder seals, amulets, and the like.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The task not only of writing a history of Israel but also of accounting for the faith of Israel and the origin and growth of the OT traditions has become more formidable than ever. OT specialists are faced with accounting for a faith that developed within a nation, in circles that often came into conflict with the rulers and ordinary people of that nation. Furthermore, the “history” of the nation that these circles produced was not a history in the modern sense. Although the writers used historical sources such as royal chronicles, their aim was not to present a chronological account of the nation’s fortunes but to write what has been called a “decision history”—a story containing incidents with outcomes that would challenge readers/hearers to faith in God. Also, the religious beliefs and practices of the postexilic community were explained in terms of an overall story that was projected back to the creation of the world. In what follows, we will attempt to sketch the origins of Israel’s faith and the growth of its Scripture in the light of present OT studies, while taking into account the dynamics indicated in the preceding sentences.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("“Israel is laid waste, its seed is no more.” These words from the twenty-seventh line of an inscription from the reign of the Egyptian pharaoh Merneptah (variously dated 1224 to 1214 or 1212 to 1202) are the earliest known reference to Israel or an Israel. Through its determinative (a sign that precedes a name and indicates whether the name is that of a god, a person, or a country) the name indicates a group organized along tribal lines. Thus, toward the end of the thirteenth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" there existed, probably in ancient Palestine (see Görg 1997: 60), a people that was sufficiently distinct for it to be recognized and named by a foreign invader. To what extent this Israel corresponded to a later group or groups bearing the same name has become a battleground of recent OT scholarship.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is interesting that, however the first part of the name “Israel” is to be understood (it has been connected with "), _c('i', [_vm._v("sara"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")])]), _vm._v(", “to fight,” “to rule,” or “to heal” or with "), _c('i', [_vm._v("yashar")]), _vm._v(", “upright”), the second part is “El,” the common Semitic word for God. The group is thus named according to the general Semitic term for God rather than the distinctive name for the God of Israel, YHWH, thought to have been pronounced Yahweh. The earliest nonbiblical reference to Yahweh in connection with Israel is in the Inscription of Mesha, king of Moab in the first half of the ninth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". Lines 17 and 18 read, “I took from there [i.e., Nebo] the [vessels of] Yhwh.” This indicates that the kingdom of Israel ruled by Omri (who is named in the inscription in lines 4–5) had outposts in Transjordan, with holy places at which Yahweh was worshiped.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("To the question “How and when did Yahweh become the God of Israel?” no definite answer can be given if appeal is made to nonbiblical sources only. However, attention has been drawn to the occurrence of what is probably a shortened form of the name, Yhw, in Egyptian sources from the time of Amenophis III (1391–1353) (Knauf 1988: 46), one reference being to “Yhw in "), _c('i', [_vm._v("Shasu")]), _vm._v("-land.” This may be a reference to a sacred mountain or mountain god, which has been tentatively located in Seir or ancient Edom. The mention of "), _c('i', [_vm._v("shasu")]), _vm._v(" draws attention to a nomadic people living in this and other regions. This information can be compared with the OT claims that the name Yahweh was revealed to Moses at the mountain of God in the Sinai wilderness (Exod 3:1–12) as well as with references in poetic parts of the OT to a “coming” of Yahweh from Seir. Thus the “Song of Deborah” states, “"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LORD")]), _vm._v(" [i.e., Yahweh], when you went out from Seir, when you marched from the region of Edom, the earth trembled.…” (Judg 5:4; cf. Ps 68:7–8).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Comparisons of biblical texts with extrabiblical evidence must be handled carefully. They do not prove that the biblical texts are “true” in a strictly historical sense. Exod 3:1–12 is no doubt a postexilic and sophisticated theoretical reflection in its present form. The comparisons do, however, provide a plausible, and necessarily provisional, larger context into which biblical texts can be placed. On the basis of the above and similar comparisons as well as recent archeological research we can sketch a tentative picture of Israel’s origins and faith as follows.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the second half of the thirteenth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" there was a migration of peoples from northern Transjordan to the central hill country of Palestine, the area of the later Northern Kingdom, Israel. The reasons for the migration are unknown; they may have had political or environmental causes, or both. The migratory groups could well have included the entity, or part of it, that is mentioned as Israel in the Merneptah Stele of 1219 or 1207. This group may then have been joined by a group of "), _c('i', [_vm._v("shasu")]), _vm._v(" (see Görg: 61, where objections to this view are considered but not regarded as decisive) who brought with them faith in a God, Yahweh, who had helped them to escape from Egyptian slavery. Faith in Yahweh as the God of Israel then became one of the distinguishing features of Israel as it struggled for survival with the Canaanites and the Philistines in Palestine and with neighboring peoples in Transjordan.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("An important moment of crisis in the formation of the people came with the arrival of the Philistines, who established themselves in the coastal plain in southern Palestine, probably in the last third of the twelth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". They were part of the larger movement of “sea peoples” who migrated by sea and land from somewhere in the northeastern Mediterranean region and who are mentioned in Egyptian sources from Ramesses III. Toward the end of the eleventh century they began to expand into the central hill country of Palestine, at the expense of the tribes there who constituted Israel.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("At this point another puzzle presents itself. No mention ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("has been made so far of Judah, the kingdom whose first king was David and whose capital, Jerusalem, became the capital of the United Kingdom under David and Solomon—the kingdom which, in effect, became Israel after the destruction of the Northern Kingdom of that name by the Assyrians in 722/721 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". The origin, exact form, and meaning of the name Judah are unknown. Biblical and extrabiblical texts vary the form between "), _c('i', [_vm._v("Yehud")]), _vm._v(" and "), _c('i', [_vm._v("Yehudah")]), _vm._v(", among others. Whether the name is a personal name or a place name is disputed; suggested meanings range from “praise” (Gen 29:35; 49:8) to “may Yahweh be victorious.” According to the present state of archeological research, it appears that Judah (i.e., the southern hill country) was settled later and less densely than the northern hill country and Galilee, where Israel was established. There are good environmental reasons for this. Rainfall increases in Palestine as one goes northward, and Judah lacks the fertile valleys that become increasingly evident the farther north one goes toward the Jezreel valley. It is true that the Shephelah, or lowlands, a transitional set of hills between the coastal plain and the Judean hills, is a much more fertile region; but the Philistines bordered, and no doubt controlled, this area. A major puzzle is how, if the biblical account is correct, this small, less favored region came, under David and Solomon, to dominate the much larger and potentially more powerful kingdom of Israel. It may be possible for us to give an answer if we handle the biblical material carefully.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In 1 Samuel the Philistine attempt to expand into the central hill country is given as the reason for the institution of kingship, with Saul as the first king. Although this connection is no doubt too simple (Saul may have been more of a paramount chief than a king and the Philistine threat only the sufficient cause), it will serve here. The Philistine expansion destabilized the area of Judah and Israel and united the Israelites against the invader. The emergence of a national leader from the territory most immediately threatened (Benjamin) was a natural consequence. However, an interesting feature of the narrative in 1 Samuel is its insistence that Saul had the backing of, or was even a member of, ecstatic prophetic groups that were zealous in their devotion to Yahweh. Twice comes the proverb “Is Saul also among the prophets?” (1 Sam 10:11–12; 19:24), and Samuel, the apparent leader of the prophets, is instrumental in promoting and deposing Saul as king. In the final form of the tradition, Samuel has become a composite figure combining the features of priest and judge with that of ecstatic prophet. It is arguable, however, that the latter role brings us closest to the historical figure of Samuel. If the association of ecstatic prophetic activity with the appointment of Saul is correct, the rise of the kingship must be seen as more than a political response to the threat of an invader. There was a strong religious element also; and the tradition in 1 and 2 Samuel, which is not exactly sympathetic to Saul in its final form, retains evidence that Saul had tried to carry out religious reforms during his reign (1 Sam 28:3b; 2 Sam 21:1–2).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("David, who succeeded where Saul failed, is an enigmatic figure. If the genealogy of 2 Sam 17:24 and other pieces of information (2 Sam 10:1–2) are authentic, David’s mother would seem to have been at one time the wife of the Ammonite king Nahash. Certainly David seems to have taken advantage of the Philistine crisis to establish himself as a kind of freebooter heading a group of adventurers who were fiercely loyal to his charismatic leadership. Temporarily allied with Saul, David aroused the latter’s suspicions and was forced by his active hostility to desert to the Philistines. While confined to the area of southern Judah, David adopted the dual strategy of forging diplomatic links with the villagers of Judah while raiding the Amalekites in the Negev. After Saul had been defeated by the Philistines, David became king of Judah and then of Israel before defeating the Philistines and setting up his capital in Jerusalem (2 Samuel 5).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These processes can best be understood if we set them in the context of a world where borders between states were not lines drawn on maps, and where rulers had little centralized control over the areas that they claimed to rule. Philistine “control” of Israel would have amounted to the occupation of frontier and strategic cities from which demands for food and labor could be imposed upon the surrounding villages (cf. 1 Sam 13:17). Nonetheless, this was an affront to the Israelites and especially to the ecstatic prophetic groups. Since warfare was essentially battle for control of border or strategic towns, a charismatic leader with a brave and accomplished army could dislodge an enemy from these sites within his own country and even seek to expand beyond it by capturing the key cities of neighboring peoples. If David did indeed create a small “empire,” it was in the sense of capturing border and strategic towns that enabled him to claim authority over a whole territory. The actual control of such territory would be strictly limited.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This historical sketch has been a necessary diversion from the religious questions that this introduction is seeking to address. It has drawn attention to the ecstatic prophetic groups; now we must ask what can be guessed about the religion of David. The tradition in 2 Samuel 6 credits David with bringing to Jerusalem the ark of the covenant, a cult object that had apparently at one point been captured by the Philistines. In 1 Sam 4:4 the ark is called the “ark of the covenant of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" of hosts,” and in Num 10:35–36 it is associated with the earthly and heavenly armies of Yahweh by way of words that also occur in Psalm 68, which, as mentioned earlier, speak of Yahweh coming in a warlike manner from the south. The words are:")]), _vm._v(" "), _c('p', {
    staticClass: "PF"
  }, [_vm._v("“Arise, O L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", let your enemies be scattered,")]), _vm._v(" "), _c('p', {
    staticClass: "PM1"
  }, [_vm._v("and your foes flee before you.”")]), _vm._v(" "), _c('p', {
    staticClass: "PS"
  }, [_vm._v("(Num 10:35–36; cf. Ps 68:1)")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("The ark was therefore possibly a visible symbol of the warlike presence of Yahweh among his people, which had been brought to Palestine by "), _c('i', [_vm._v("shasu")]), _vm._v(" groups who settled in Israel. Indeed, the adoption of Yahweh by Israel may have resulted from the belief that the ark had assisted them in their struggles with their neighbors to establish their independence. That David should have reinstated this cult object that had temporarily failed the ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("people is perhaps an indication that his own faith was a soldier’s belief in a God who was his helper in war. At any rate, the stories of Saul and the ecstatic prophets, and of David and the ark, established two features that were to be formative in the development of Israel’s faith and thus in the production of the OT: a northern prophetic element, and the establishment of the worship of Yahweh in Jerusalem.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("We have suggested that when David captured Jerusalem he found there an established priesthood in the person of Zadok and a cult that contained “Canaanite” elements. Hints of this preexisting religion have been found in psalms such as 110, where the king is made a priest “after the order of Melchizedek,” and 91, where God is named “the Most High” and “the Almighty” as well as Yahweh. Psalm 46, which speaks of the river that flows beneath the city of God, is another possible allusion to “Canaanite” beliefs. It should, however, be noted that current scholarship is divided about how much of the city of Jerusalem existed at the time of David, while Niehr has argued that the “Canaanite” features of the Jerusalem cult are late developments rather than beliefs and practices that Israelite faith incorporated from a pre-Davidic Jerusalem cult. Only time will tell which of these views is more likely to be correct.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The delineation of the ecstatic prophets in the north and the Jerusalem cult in the south is only a preliminary step in tracing the faith of Israel. The prophetic groups lived on the margins of society, while the Jerusalem cult was that of a royal rather than a national temple. To discover the religious situation of the people in general, we must consider the evidence from personal names, extrabiblical inscriptions, and artistic representations on seals and amulets. The evidence from personal names is not easy to handle because of textual variations between parallel passages (King Abijam in 1 Kgs 14:31; 15:1, etc. is Abijah in the parallel account in 2 Chr 12:16; 13:1, etc.) and differences between the Hebrew and the Septuagint (LXX). The list of names of the thirty heroes of David in 2 Sam 23:24–39 bristles with such difficulties. Bearing all these problems in mind, we nevertheless find it striking that the recorded names of the kings of Israel and Judah begin by having no element of the name Yahweh, and that this element develops only gradually. The first northern king whose name has an element of Yahweh is Ahaziah (853–852 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("), and the first southern king (assuming that Abijam rather than Abijah is correct) is Jehoshaphat (871–848). Of the nineteen kings of the Northern Kingdom, Israel, only seven contain an element of Yahweh, while of the twenty kings of Judah (not counting David and Solomon) fourteen contain this element. The greater presence of Yahweh elements in Judah is probably due to the close connection between the king and the cult of Yahweh in Jerusalem, while of the seven names with Yahweh elements in the Northern Kingdom, five follow one after the other from 853 to 782, the period of major political activity of the prophetic groups led by Elijah and Elisha which resulted in a coup d’état by the Yahweh loyalist Jehu.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Hebrew inscriptions, bearing in mind that their survival and discovery is haphazard, indicate the presence of personal names combined with Yahweh from the eighth century onward (practically no Hebrew inscriptions are known from before this time). From the information in Davies 1991, there are roughly thirteen such names from sites in Judah in the eighth century, eight from the seventh century, and twenty from the late seventh to early sixth centuries. (These figures do not include names ending in -"), _c('i', [_vm._v("yah")]), _vm._v(" or -"), _c('i', [_vm._v("iyah")]), _vm._v(".) On the other hand, the Samaria Ostraca, dating from the second half of the eighth century (see Renz and Röllig 1995: 79–109), contain seven personal names with the element "), _c('i', [_vm._v("ba"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("al")]), _vm._v(", the name of the “Canaanite” god of the storm. This supports the view presented in the books of Kings that the Northern Kingdom, Israel, or at any rate its capital Samaria (the Samaria Ostraca derive from places close to, and linked to, Samaria), was open to Canaanite influences.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Much interest has been aroused by the discovery in 1975/76 of two inscribed jars at Kuntillet-Ajrud, a kind of caravansary fifty kilometers south of Kadesh-barnea, in the Negev. Dated around 800 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", they were evidently written and painted on by travelers (see Renz and Röllig 1995: 48–50), and among the inscriptions are references to “Yahweh of Samaria,” “Yahweh of Teman,” and “Yahweh and his Asherah.” The references seem to indicate that, for the travelers at any rate, Yahweh was worshiped as a localized deity in Samaria and in the south of Edom (see above for the connection between Yahweh and this region). The reference to Yahweh’s Asherah is probably to the sacred pole or tree that represented Asherah because it is not possible (as far as it is known) to add a suffix with the meaning “his” to a proper name in Hebrew in the way that “his” is added to “Asherah” in the inscription. What this indicates is that popular religion associated a fertility symbol, the Asherah pole or tree, with the worship of Yahweh, a practice strongly condemned in the OT (1 Kgs 15:13). The iconography of Israel and Judah shows the influence of Egyptian and Assyrian religious symbols on Israelite popular religion; but it also shows that, at the end of the seventh century, officials in Judah put forth a strenuous effort to avoid “pagan” symbols. The seals from around this time are without idols and contain simply the names of officials concerned (see Keel: 410–14). Their presence confirms the account of the cultic reform carried out by Josiah from 622 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" onward (2 Kings 22–23).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The consideration of such things as personal names, inscriptions, and iconography (for the latter see above all Keel) generally confirms the picture given in the books of Kings, according to which the religion of Israel in the period 950–587 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" was syncretistic. The worship of Yahweh was carried on at many sites called, derogatively, “high places” in the OT; but other deities were worshiped, including Baal, and fertility practices were associated with Yahweh in the form of the Asherah pole or tree. The situation in Israel and Judah can be described in terms of three interacting levels of religion: those of official Yahwism (the religion of the court), popular Yahwism (the religion of the ordinary people), and prophetic Yahwism (the religion of prophetic groups probably on the margins of society). However, there were no doubt important differences between Israel and Judah.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Israel was more open to syncretism at the level of official religion, with the result that the prophetic groups frequently clashed with the kings of Israel and encouraged soldiers and administrators with prophetic sympathies either to subvert official policies or to attempt coups d’état. An instance of the former is the high official Obadiah’s concealment of prophets during the reign of Ahab (873–853) when the king’s foreign-born wife promoted her own religion and tried to eliminate the Yahweh prophets (1 Kgs 18:3–4). An instance of the latter is the coup d’état of Jehu (841–813) instigated by Elisha (2 Kings 9).")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In Judah, which was much smaller territorially and where Jerusalem’s influence became increasingly dominant, prophets such as Hosea and Amos directed their attention to Israel. However, Micah was bitterly critical of Jerusalem toward the end of the eighth century, as were Jeremiah and Ezekiel just over a century later. The two slightly different manifestations of Yahwism, in Israel and Judah at the royal and prophetic levels, were brought together following the destruction of the Northern Kingdom, Israel, by the Assyrians in 722/721 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". Royal chronicles and other written or oral traditions were brought from the north to Judah by groups, including prophetic groups, seeking refuge in the one remaining country where Yahweh was officially worshiped.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It was most likely at this time, during the reign of Hezekiah (727–698 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("), that the first steps were taken toward the production of the OT as we know it. Hezekiah had the necessary scribal resources (Jamieson-Drake 1991; cf. Prov 25:1) and motivation (the presence of the northern prophetic groups plus a desire to resist Assyria and extend his jurisdiction over as much of the former Northern Kingdom as possible) to put in train the production of the initial account of the history of the people from the time of Abraham onward. His scribes made use of royal chronicles, stories emanating from prophetic groups, and stories of local and popular heroes and heroines. Abraham and Isaac were most likely Judahite heroes, their stories being set in southern Judah (Hebron) and the Negev, while Jacob was a northern hero, his story centering in Bethel, Shechem, Transjordan, and Haran. The fact that the Judahite Abraham precedes the Israelite Jacob, whose name is changed to Israel and who becomes the ancestor of the twelve tribes (Gen 29; 32:22–32), is best explained by the supposition that the stories were put together when Judah was the predominant political force.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("How the overall story was continued down to Hezekiah’s time can only be guessed at. We are on firmest ground with the royal chronicles, described in the books of Kings as the “Book of the Annals of the Kings of Judah/Israel” (see 1 Kgs 14:19, 29). Their general accuracy can be checked against Egyptian and Assyrian records from time to time, from the invasion by Sheshonq I of Egypt in 925 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" (cf. 1 Kgs 14:25–28; Görg: 90–91) through the mention of Omri (in the Inscription of Mesha; see above), Ahab ("), _c('i', [_vm._v("ANET")]), _vm._v(", 279), Jehu ("), _c('i', [_vm._v("ANET")]), _vm._v(", 280–81), and Azariah (Uzziah; "), _c('i', [_vm._v("ANET")]), _vm._v(", 282–83) to Hezekiah himself ("), _c('i', [_vm._v("ANET")]), _vm._v(", 287–88). This does not mean, of course, that every detail is correct from a modern historical point of view. The stories of Elijah and Elisha, which dominate the books of Kings from 1 Kings 17 to 2 Kings 10, contain legendary elements and narratives that sometimes cannot be fitted into the historical scheme; but the general framework can be trusted. What cannot be known is how much of the story from Jacob to the time of David existed in this initial draft. Because tradition abhors a vacuum, it is likely that the story included the exodus (cf. Hos 11:1), Moses, Joshua, and some or most of the “judges,” ending with Samuel and Saul. The difficulty is that it is almost impossible to work back from the final forms of these accounts to the form that they might have had in the initial version.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This initial version was the product of official Yahwism as represented in Jerusalem under the patronage of a king (Hezekiah) who allowed himself to be advised by a prophet, Isaiah. Its aim was to legitimize Jerusalem and its Davidic dynasty as chosen by Yahweh, as well as to assert that the whole land of Israel, north and south, had been promised to the descendants of the Judahite ancestor, Abraham. However, the account also no doubt stressed the importance of loyalty to Yahweh over against other deities and used stories as object lessons to point out the consequences of disloyalty. It is also likely that the reign of Hezekiah was the time in which the laws found in Exodus 21–23 were officially promulgated. These restricted the period of slavery to six years and were generally supportive of the poor and disadvantaged (e.g., Exod 22:21–27).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The promise of Hezekiah’s reign was cruelly disappointed. Invaded by the Assyrian king Sennacherib in 701, Judah was devastated and Hezekiah was forced to pay tribute (2 Kgs 18:13–16). For the next sixty years Judah was a vassal state of Assyria and “pagan” religion flourished at the official and popular levels (Keel 1992: 322–406). In 640, by which time Assyrian power had declined to the point of no return (the Assyrian Empire would last for no more than a further thirty years), parties favorable to prophetic Yahwism were able to intervene in the politics of Judah and place on the throne the eight-year-old Josiah (2 Kgs 21:19–22:2). His reign (640–609 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") produced a religious reorganization in Judah that turned Jerusalem from a royal to a national sanctuary. All other sanctuaries were closed down, and all traces of “paganism” were purged from the Jerusalem cult. The Passover was declared to be a national festival, to be observed only at the national sanctuary, Jerusalem. In terms of the threefold distinction between official, popular, and prophetic religion, we can say that official religion, inspired by the prophetic, sought to control popular religion as never before in Judah or Israel, a move made possible by the increasing administrative control of Jerusalem over Judah. This controlling of popular religion is instanced in making the Passover a national festival to be observed only in Jerusalem. The origins of the Passover are obscure and its exact form of observance prior to Josiah unknown; but it was probably a local or family observance of some kind, originating in the Northern Kingdom.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Josiah’s reform had a major impact on the formation of the OT. It was inspired by or gave rise to the Deuteronomistic movement, a combination of high official and ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("prophetic circles. These produced a first draft of Deuteronomy and edited the existing story of Israel from the time of Abraham, bringing it down to the time of Josiah (2 Kgs 23:24–25) and adding Deuteronomistic frameworks to books such as Judges. Deuteronomy was probably modeled on the types of vassal treaty that were current in the Near East at the time. These contained a historical prologue setting the context for the treaty (cf. Deut 4:44–11:31), stipulations required to be observed by the vassal (cf. Deuteronomy 12–26), and details of penalties that would be exacted if the vassal was disloyal (cf. Deuteronomy 28, with interesting parallels with the vassal treaties of the Assyrian king Esarhaddon from 681 to 669 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("; see especially Steymans). One of the features of Deuteronomistic theology deriving from the vassal treaty scheme was a recasting of past history to show that disasters that had befallen Israel were divine punishments resulting from disloyalty to Yahweh. In particular, disloyalty to Yahweh was understood in terms of worshiping other gods.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Another feature of the Deuteronomic reform was the introduction of new social measures to counteract poverty and to support the officials whose shrines had been closed down. For example, a three-year tithe was enjoined whose produce was to be distributed locally to Levites (dispossessed local cultic officials) and to the disadvantaged (Deut 14:28–29). Further, a seven-year system of release was commanded in which loans (or the interest on loans) to fellow Israelites were written off (Deut 15:1–6). Women slaves were given the same right of release as men slaves (Deut 15:12–18; cf. Exod 21:7–11, where women slaves do not have this right).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Deuteronomic reform was brought to an end by Josiah’s death in 609 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" at the hands of the Egyptian pharaoh Necho II, and for the remainder of the existence of Judah (to 587) the kingdom was in effect a vassal state, first to Egypt and then to Babylonia. These reverses allowed popular religion to be freed from official control. The books of Jeremiah and Ezekiel contain abundant evidence that ordinary people turned to pagan deities and away from the austere official and prophetic Yahwism that had apparently failed, given Judah’s loss of independence.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("From the destruction of the temple in 587 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" to the end of the Persian period (333 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") Israelite history enters a phase about which little information has survived and yet in which the OT and its faith came near to reaching the forms in which we know them. It can be surmised that in this period, priestly, scribal, and prophetic interests combined in the context of a small, temple-based community in Jerusalem to consolidate trends that had been apparent for a considerable amount of time. However, the loss of the Jerusalem temple and the Babylonian exile made a lasting impression on this closing stage of the formulation of the faith and its writings.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the first place, in the absence of political rule (the last Davidic king was Jehoiachin, who died sometime after 560 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("), religious rule by priests took on new importance, while prophetic activity became primarily concerned with the editing and expanding of teaching deriving from the prophets of earlier generations. Secondly, there was much less scope for popular religion in a temple-based community centered in a Judah that was now smaller than it had been up to 587. The southern part of Judah, for example, had been occupied by Edomites. Thirdly, official religion in the sense of the religion of the court no longer existed, nor did prophetic religion in the sense of the religion of marginal groups fiercely loyal to Yahweh who intervened in politics from time to time. In fact, religion in Judah was now well on the way to becoming a faith based on writings that were regarded as Scripture.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("To the Persian period (539–333 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") can be assigned the editing of the Pentateuch into its final form and the substantial completion of the prophets, which included the books of Joshua, Judges, Samuel, and Kings as well as Isaiah, Jeremiah, Ezekiel, and the twelve Minor Prophets. The story beginning with Abraham was prefaced by the primeval history (Genesis 1–11) and supplemented by the ritual and priestly material now found in Exodus, Leviticus, and Numbers. In the former prophets (Joshua to Kings) the story was brought down to the destruction of the temple and the release from prison of the last king, Jehoiachin, in 560 (2 Kgs 25:27–30). In addition, sections were edited or expanded to meet situations arising from the destruction of the temple in 587 and the Babylonian exile. For example, Solomon’s prayer of dedication of the temple in 1 Kings contains sections which imply that there are Jews in the diaspora (i.e., not living in Palestine) for whom the temple will be a place toward which they pray (1 Kgs 8:46–53). It says nothing about the temple as a place of sacrifice. A good example of the work on the latter prophets is Isaiah, where sayings deriving from at least three prophets, Isaiah of Jerusalem (8th cent.), Deutero-Isaiah (mid-6th cent.), and Trito Isaiah (late 6th cent.) were brought together, along with attempts to give the work some unity by thematically linking the closing chapters with the opening ones.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The third section of the Hebrew Bible, the Writings, was less complete by the end of the Persian period. The Psalms, some of which dated from the First Temple period, were probably in their present form as far as Psalm 106. The Proverbs, many of which dated from the time of Hezekiah or earlier, were prefaced by chs. 1–9, which set them in an explicitly Yahwistic theological framework, albeit one which was closer to official Yahwism than to prophetic Yahwism. Also complete by the middle of the fourth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" were the so-called Chronicler’s history (Chronicles, Ezra, and Nehemiah—not necessarily by the same author) and books such as Lamentations (most likely occasioned by the destruction of Jerusalem) and Ruth. It is difficult to determine whether works such as Job, Ecclesiastes, Canticles (the Song of Songs), and Esther were complete by 333 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(".")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("This uncertainty stems mostly from lack of knowledge about social conditions in Judah in the first half of the fourth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" and whether changes were beginning to occur before Alexander the Great defeated the Persians and incorporated Syria/Palestine into the Hellenistic environment that would profoundly affect it up to and well beyond the coming of Roman rule in 63 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". Certainly, the advent of the Greek language, the founding of ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("free Greek cities, especially in Transjordan, and the general spread of Greek culture had a noticeable effect upon the last stages of the genesis of the OT, and of the writing of the Apocrypha. Returning for a moment to Job, Ecclesiastes, and Canticles, while these could all have been written in the fourth or even fifth centuries, a case can be made for saying that Job and Ecclesiastes, at any rate, were produced in response to a skepticism that developed in Judah from the end of the fourth century onward. This skepticism was produced not only by the need to respond to Greek philosophy but by a growing individualism among members of an aristocracy that lacked power and a questioning of aspects of official Yahwism. It has also been argued that Canticles draws upon elements of “pagan” mythology, which became increasingly popular with Hellenization (Müller 1976).")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Whatever the truth of these arguments, Hellenization was responsible for the need to translate the OT into Greek from the mid-third century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", for the benefit of Jews living in Egypt. There was also the clash with Hellenism which resulted in the Maccabean revolt against the Seleucid ruler of Judah, Antiochus IV, from 168/167 to 164. This resulted in the writing of the book of Daniel (in Hebrew and Aramaic) and the production of the books of 1 and 2 Maccabees, the former in Hebrew and the latter in Greek.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If the content of the Apocrypha is compared with that of the OT, the trend toward individualism and toward Greek is clearly discernible. The Apocrypha has no prophetic books, only one psalm, and proportionately more novelistic writings than the OT, in the form of Tobit, Judith, and Additions to Daniel (Susanna and Bel and the Dragon). Works originally composed in Greek include 2-4 Maccabees, Wisdom of Solomon, and Additions to Esther and Daniel.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Apocrypha also demonstrates that what was said above about the OT books being completed in the Persian period needs to be qualified, while the Additions to Daniel and Esther show how the tradition could be supplemented. The Apocrypha contains 1 Esdras, a work based on part of 2 Chronicles 35–36, Ezra 1:1–10:44, and Neh 7:72–8:13a, but evidently using a Hebrew text differing from that which has become traditional for those books. 1 Esdras also contains two sections (1:23–24 and 3:1–5:6) which have no parallel in the OT. Overall, it provides a more integrated and interesting version of material, most of which is in the OT. The Additions to Esther have the effect of making it a much more “religious” book, with prayers added at crucial points in the story in a book which, notoriously in its Hebrew version, does not mention God. The Additions to Daniel add both hymns and prayers (Greek Daniel 3:24–91) and stories to supplement those about Daniel in the opening chapters of the Hebrew.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is now time to compare the point which we have reached with what we said in the opening pages. There we pointed out that the OT’s view of how Israel’s faith originated is that it was revealed by God supremely to Moses but also to other people such as Abraham and the prophets. The outline we have given above has indicated something much more complicated—a series of interactions between official, popular, and prophetic Yahwism in the context of the historical ups and downs of a small people surrounded by, and often victim to, the ambitions of powerful empires. Also, our brief consideration of the Apocrypha has indicated that the processes of formation and development of Israel’s faith and the production of its Scriptures was ongoing. The discovery of the Dead Sea Scrolls, for example, has shown how, in the first century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", there were diverse and competing strands within the broad stream of the Judaism of the time. In a way, the Qumran group might be compared with the prophetic religion of earlier times, seeing that it lived on the margins of society and was fiercely critical of the official Judaism of the time.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Qumran group is also instructive with regard to its attitudes to Scripture. On the assumption that the "), _c('i', [_vm._v("Temple Scroll")]), _vm._v(" and the biblical commentaries were the work of the same group, the Qumran sectarians regarded certain works as sacred and therefore susceptible of interpretation. This is seen in the commentaries on books such as Habakkuk and Nahum, the prophecies of which are interpreted in terms of the group’s history and leaders. On the other hand, the "), _c('i', [_vm._v("Temple Scroll")]), _vm._v(" is an attempt to fill a gap in the Bible. There is no record in the OT of explicit instructions from God about the form and dimensions of the Jerusalem temple. Exodus 35–40 contain an account of God’s instructions for the construction of the portable tabernacle which served the Israelites in the wilderness. 1 Kings 6–7 describe how Hiram built the Jerusalem temple for Solomon. No doubt the description of the tabernacle in Exodus is dependent on the later Second Temple. The point is that the OT contains no specific instructions from God about the construction of the Jerusalem temple; and it is this lack which the "), _c('i', [_vm._v("Temple Scroll")]), _vm._v(" remedies, in the form of a direct address of God to Moses about the building of a temple. Thus, as late as the first century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" there was a group within Judaism that claimed and attributed revelations of God to Moses regarding vital matters of religion.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If modern scholarship proposes a gradual development of the faith of Israel as opposed to an initial revelation to a founder such as Moses, this does not mean that we are left with vagaries. However the faith of Israel may have developed (and subsequent research and discoveries may modify or alter the sketch we have proposed in this introduction), the end result was that the texts that were produced and the faith that they implied had what has been called a family likeness. The main features of this “family likeness” were:")]), _vm._v(" "), _c('p', {
    staticClass: "BL1"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("belief in Yahweh as the God of Israel and as the only God, the creator of the universe")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("belief in Israel as the people chosen and called by Yahweh to service and obedience, which would lead to Yahweh being acknowledged by the other nations")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("belief in Jerusalem as the place chosen by Yahweh for a temple to honor his name, and belief in Yahweh’s choice of the house of David to rule over Israel")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("belief in Yahweh’s laws as revealed to Moses")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("belief in a re-creation of the heavens and the earth when Yahweh would establish a peace and justice longed for by the nations.")])])]), _c('p', {
    staticClass: "Body1"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Not all of these features are to be found in every book of the OT, but they are implied. Ecclesiastes, for example, always uses the general Hebrew word for God rather than the name Yahweh and makes no mention of Israel or of its being specially chosen and commissioned by Yahweh. But its view, that humans live in a world created by God, who is also the creator of individual humans and to whom their spirits return at death, would be impossible without the general background of belief outlined above. Indeed, the skepticism in Ecclesiastes and Job comes precisely from the problems arising from the need to relate Israelite monotheism to the sufferings of innocent people and the many injustices that go unpunished, at a time when Israelite monotheism had not yet developed a belief in the afterlife. Again, a book such as Esther, which in its Hebrew version notoriously fails to mention God, nonetheless depicts the Jews as a distinct entity singled out for hatred and destruction by Haman, thus implying a unique Jewish national self-consciousness and praxis which could arouse hostile feelings against the Jewish people.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Readers of the list of features making up the “family likeness” may be surprised by the omission of belief in the coming of the Messiah. Of course, by the beginning of the common era various types of messianic belief had developed, including the coming of a “prophet like unto Moses” (Deut 18:15), a return of Elijah (Mal 4:5), and a royal (Davidic) or priestly anointed one (which is what “Messiah” means). However, in the OT and Apocrypha only the elements of these later expectations are present, and they are subordinate to the view that God himself will redeem his people and renew the created order.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("2. Methods in the Study of the Old Testament and Apocrypha")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The attempted reconstruction of the origins of the faith of Israel and its Scriptures in this introduction has depended on the methods of historical criticism. In their modern form these methods go back to the second half of the eighteenth century; but they are based in turn upon observations about the OT in particular that go back much earlier than the eighteenth century. A good example is the apparent discrepancy in regulations about observing the Passover in Exod 12:1–49 as compared with Deut 16:1–8. In the former text the Passover is observed in Egypt in the houses of the Israelites, one of the main purposes of the ritual being that the blood of the Passover lamb sprinkled upon the lintel and doorposts of the Israelite houses will protect them from the divine destroyer when he comes to kill the firstborn males and animals. Exod 12:24–27 implies that the Passover will continue to be observed in this way in the following generations. However, in Deut 16:1–8 the Passover lamb can be killed only at the central sanctuary (i.e., Jerusalem, which is not, however, mentioned in Deuteronomy), to which families must travel if they wish to observe the festival; in that case it becomes impossible to sprinkle the lamb’s blood on the lintel and doorposts of houses far away from the central sanctuary, something that is in any case not enjoined by Deut 16:1–8. Jewish scholarship has long since been aware of these and other discrepancies, and explained them in various ways, including making a distinction between the Passover of Egypt and the Passover of the land. Modern biblical criticism developed out of the wrongly called precritical era of scholarship when scholars abandoned the various theological schemes that had protected the Bible from historical investigation “like any other book.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Modern methods can be divided into two groups: (a) those that are concerned with the historical and social background in which the OT and Apocrypha originated, and the methods of composition used in the production of the texts; and (b) methods that are primarily concerned with interpreting the texts. This latter category can be subdivided into methods that investigate how the texts were interpreted in ancient times and how they can be interpreted today. However, any attempt to isolate and classify methods of study is artificial and arbitrary. In practice, methods overlap and slide in and out of each other.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Category (a) methods begin with those which are exterior to the text—archeological explorations, the study of extrabiblical inscriptions and iconography, the study of the history and religion of Israel’s neighbors, especially Egypt, Syria, and Mesopotamia, and the study of social and anthropological theory. They then pass to dealing with the texts themselves: establishing the best textual tradition where words or phrases make little sense and there are divergences between the Hebrew tradition and the ancient translations of the Hebrew into Greek, Latin, and Syriac. This also involves the study of ancient Semitic languages akin to Hebrew, such as Aramaic, Akkadian, Ugaritic, and classical Arabic.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Source criticism inquires whether the biblical writers based their work on existing sources. In one case, it is widely, although not universally, accepted that the writer(s) of the books of Chronicles used Samuel and Kings as a source. In other cases, such as the Pentateuch, priestly sources can be separated from non-priestly sources by the identification of distinctive vocabulary and subject matter. Form criticism inquires about the types of literary form and genre used in the literature. The most easily identifiable are two-line proverbs in the book of Proverbs; but in the Psalms, recurring structural features can be found in psalms of lament, such as Psalms 3–7, where an opening address to God detailing the complaint or distress of the psalmist ends with an affirmation of confidence and trust. Prophetic oracles are sometimes highly schematized, beginning with the identification of the speaker (Yahweh), the ground of complaint or praise, and either a threat of judgment or a promise of deliverance. A good example is Jer 35:12–19, which combines praise and promise for the Rechabites with condemnation and judgment on the people of Judah and Jerusalem. Other forms found in prophetic literature include funeral dirges (Amos 5:1–3) and love songs (Isa 5:1–7). Redaction criticism is a method that tries to gain an idea of the overall intention or purpose of a work by examining key passages or concluding formulae. In the so-called Deuteronomistic History, for example (Joshua to 2 Kings), there ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("are key speeches or passages in Joshua 24, 1 Samuel 12, and 2 Kings 17 and 21:10–15 which give an indication of the tenor of the work in its final form.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The first branch of category (b) methods, those dealing with ancient interpretation, concern themselves objectively with the ancient translations of the Hebrew Bible (HB) into Greek and Aramaic in particular. They also deal with ancient works which interpreted or expanded the HB.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Although the Septuagint (LXX) is a translation of the HB into Greek, it is also sometimes an interpretation, making theological points and expanding the text to make it more understandable. Two examples can be given. The Hebrew of Exod 24:10 says that Moses, Aaron, Nadab, Abihu, and seventy elders, having ascended the mountain, “saw the God of Israel.” The translators into Greek softened this bold statement into “they saw the place where the God of Israel stood,” no doubt bearing in mind the statement that no one can see God and live (Exod 33:20). In Isa 40:1, commands are given that God’s people should be comforted, but there is no indication as to who is being told to give these commands. The Greek version adds the word “priests” before “speak tenderly to Jerusalem” in order to meet this difficulty. An example of expansion and interpretation in the Aramaic targums can be found at Ezek 16:2–3. The Hebrew has, speaking of Jerusalem, “Your origin and your birth are of the land of the Canaanites; your father was a Amorite, and your mother a Hittite.” The targum has, “Your origin and your birth are from the land of the Canaanites. There I revealed myself to Abraham your father between the pieces [of the covenant; cf. Gen 15:17] and made known to him that you would go down to Egypt. With an uplifted arm I redeemed you, and for the sake of your fathers I drove out from before you the Amorites and destroyed the Hittites.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, examination of translations, especially the Greek, provides information not only about how passages were interpreted in antiquity; they also give indications of how the biblical books were composed. The Greek version of Jeremiah is "), _c('i', [_vm._v("shorter")]), _vm._v(" than the Hebrew versions, the additions in the Hebrew amounting to amplifications and clarifications. A good example is Jeremiah 27:19–22 (ch. 34:19–22 in the Greek). In what follows, material common to both versions is in normal type; what is found in the Hebrew only is in italics:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("19. For thus says the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" "), _c('i', [_vm._v("of hosts concerning the pillars, the sea, the stands")]), _vm._v(", and the rest of the vessels that are left in this city, 20. which "), _c('i', [_vm._v("Nebuchadnezzar")]), _vm._v(" king of Babylon did not take away when he took into exile from Jerusalem "), _c('i', [_vm._v("to Babylon")]), _vm._v(" Jeconiah "), _c('i', [_vm._v("the son of Jehoiakim, king of Judah, and all the nobles of Judah and Jerusalem")]), _vm._v("—21. "), _c('i', [_vm._v("thus says the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" of hosts, the God of Israel, concerning the vessels which are left in the house of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", in the house of the king of Judah, and in Jerusalem:")]), _vm._v(" 22. They shall be carried to Babylon "), _c('i', [_vm._v("and remain there until the day when I give attention to them")]), _vm._v(", says the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(". "), _c('i', [_vm._v("Then I will bring them back and restore them to this place")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This example shows how the biblical tradition grew by expansion and interpretation, and some recent work on the OT, especially the prophets, has assumed that prophecies have been subjected to what is called “inner biblical interpretation.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Turning to other texts, the Apocrypha provides evidence of early biblical interpretation. We have already pointed out that 1 Esdras is a version of the conclusion of 2 Chronicles and of material from Ezra and Nehemiah that adds material and makes the action more coherent. The Additions to Esther make that book more overtly religious, while the Prayer of Manasseh fills the gap left by 2 Chr 33:19, which refers in passing to Manasseh’s prayer, “and how God heard his entreaty.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Works outside the Apocrypha that interpret the OT include the commentaries found at Qumran and works such as "), _c('i', [_vm._v("Jubilees")]), _vm._v(". An interesting text is the "), _c('i', [_vm._v("Genesis Apocryphon")]), _vm._v(" (1QapGen), found in Cave 1 at Qumran. The beginning, which is lost, apparently dealt with the creation and the story of Adam and Eve. What survives begins with Noah and goes as far as Genesis 15. At one point it seeks to justify Abraham’s “deceit” in saying that his wife Sarah was his sister when they went down to Egypt. Abraham feared that he would be killed and that Sarah would be taken for the pharaoh’s harem on account of her beauty. Her beauty is described in the "), _c('i', [_vm._v("Genesis Apocryphon")]), _vm._v(" in extravagant terms (see Vermes 1997: 454), while Abraham’s action is justified in terms of a dream that he has and which Sarah interprets. The text goes on to describe Abraham’s anguish when Sarah is taken into the harem, and records the prayer that he prays to God regarding the matter.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The study of ancient interpretation rarely helps modern interpretation directly, for all that it is of interest in itself. However, it indicates that ancient interpreters were aware of moral and other difficulties contained in the text. The same is true of later interpreters such as Augustine ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" 354–430) or the great Jewish scholar Maimonides ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" 1135–1204). Their critical acumen was at least as great as that of modern scholars and gives the lie to the belief that biblical criticism is a recent invention.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Methods of interpretation that try to relate the text to today’s world can broadly be divided into two groups, bearing in mind the warning above that such divisions are arbitrary and sometimes misleading. First, there are methods that use the tools of historical criticism to reconstruct social and political conditions in ancient Israel in order to make persuasive analogies with today’s world. Second, there are methods which are primarily literary and which read OT texts from the standpoint of various literary strategies.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("A pioneering instance of the first group is Norman Gottwald’s "), _c('i', [_vm._v("The Tribes of Yahweh")]), _vm._v(" (1979). Gottwald reconstructed the origins of ancient Israel and its faith in terms of a peasant revolt against Canaanite urban centers, from which emerged an egalitarian tribal society in the thirteenth to eleventh centuries "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". His work demonstrates both the strengths and weaknesses of such approaches. On the one hand, "), _c('i', [_vm._v("The Tribes of Yahweh")]), _vm._v(" uses anthropological and social theory to consider issues that have not usually been considered in such depth in OT studies. On the other hand, it is hostage to progress in research in the discipline, especially to the recent skepticism about what can ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("be known of Israel’s earliest history, and it privileges a particular type of social organization (an egalitarian segmentary society) over other forms of social organization in ancient Israel (e.g., the monarchy) in seeking to suggest what might be appropriate for today’s world. To be fair to Gottwald, it must be pointed out that the OT itself contains strands that are hostile to monarchy (e.g., 1 Sam 8:10–17), and that other approaches that try to draw examples from ancient Israel for today’s world are open to the same criticisms. An example from a scholar representing an evangelical position would be Christopher Wright’s "), _c('i', [_vm._v("Walking in the Ways of the Lord")]), _vm._v(" (1995), which contrasts Israelite society favorably with Canaanite society from the point of view of social justice and compassion. That such methods share the weaknesses that their reconstructions of ancient Israel can be challenged and that hermeneutical justification is needed for privileging certain types of social organization over others does not mean that writers should not use the OT in this way. Such approaches contribute valuable insights to the understanding of ancient Israel and, by emphasizing positive aspects of OT laws and prophetic witness, counter the common view that the OT is a text about a barbaric people who believed in a wrathful and capricious God.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Probably the best-known exponents of this kind of approach are liberation theologians and some of the feminist interpreters, and it needs to be recognized that, underlying their work, are widely differing agendas (Schottroff/Schroer/Wacker). Some liberationists and feminists see the OT as an essentially oppressive text both in itself and in the way that it has been used in general and ecclesiastical history; and it is undeniable that the OT has been used to support the institution of slavery and the superiority of men over women. Other liberationists and feminists believe that the OT can contribute powerfully to their cause, and, in particular, liberationists have drawn on the story of the exodus to advance the view that redemption should involve economic and social emancipation, and not just the promise of a better life in the hereafter. Feminist and liberation scholarship has concentrated on reconstructing the social position of women and the poor in ancient Israel, to the great benefit of scholarship in general.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The employment of reading strategies from modern literary and philosophical studies has been the other main trend in the contemporary interpretation of the OT (Clines 1998). This approach has shifted attention away from concentration on the text and more toward its readers/users. Reader-response criticism, for example, has emphasized the subjective element supplied by the situatednesses of readers and the interests that they represent. It has led in turn to a twofold examination of the ideological factors in interpretation—those of the interpreters and those of the writers of the texts. The term “ideological” is notoriously difficult to define, ranging in meaning from the leading ideas of a text to a concealed and perhaps unrecognized position which blinds interpreters and writers to their “real” interests (Clines 1995). In modern OT study “ideological” is used in a number of different ways (see the criticism of Barr 2000), with the sternest criticism often being reserved for the biblical writers and their supposed deliberate or innocent veiling of their class, gender, or theological interests.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Other uses of literary methods have included the formal study of Hebrew poetry, the use of plot, character, and narrative structure in texts (Berlin 1983), and “deconstruction”—a modified version of the theory that texts contain elements that contradict and undermine their apparent communicative intention. As in the case of liberation and feminist hermeneutics, many and varied agendas are in operation when literary methods are used, from positive attempts to value OT poetry and narrative as artistic achievements to barely concealed anti-theological attempts to undermine the OT as a text to which due regard might be paid.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The advent of literary methods has also raised the question whether traditional historical-critical methods which are concerned with discovery, where possible, of the original intentions of the OT writers/editors should continue to occupy the predominant place in OT studies, or whether literary methods, some of which deny that texts have meanings intended by authors, should be regarded as primary.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A convincing answer to this discussion is provided by sociologist Anthony Giddens, who argues that all acts of communication, including written texts (the present introduction included!), have a communicative intention within a set of nonlinguistic conventions that also affect the communication. Where speakers/writers are available, they can be questioned about what they meant and can argue that they have been misunderstood. Where they are not available, the techniques of historical-critical study can attempt to recover the original communicative intention.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As texts become separated in time and space from their original milieu of production, the closure that they originally possessed (their communicative intention) is supplemented by an openness to legitimate interpretations of their latent meaning that may involve understandings never envisaged by the writers/editors. A good example of this in the OT would be Isa 52:13–53:12, the so-called Fourth Servant Song. Here an unnamed chorus, using the personal pronoun “we,” describes how the sufferings of the Servant in some way became the vicarious bearing of their burdens, which led to their healing. The writer of Isa 52:13–53:12 no doubt had in mind something that had happened in the world of his experience. Centuries later, Christian interpretation of this passage saw it as a prophecy of the sufferings of Christ.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("A proper appreciation of the relationship between the original communicative intention of a text and the legitimate ways in which it may be used when separated from its original milieu of production is necessary to address the subjects of OT Theology and Biblical Theology. For much of the history of the Christian interpretation of the OT, the OT was part of an agenda that derived from the NT. It played an important role in sustaining Christian theology because it was believed to prove the inspiration of the Bible by containing prophecies that were fulfilled in the NT and which could only have been given, centuries before Christ, by divine inspiration. An example has already been given from Isa 52:13–53:12. Another important ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("example is Isa 7:14, which was understood in Matt 1:22–23 to be a prophecy of the virgin birth of Jesus.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The rise of modern historical criticism from the mid-eighteenth century progressively destroyed the theological scheme that united the OT and NT, divorcing the Bible from subservience to dogmatic theology and raising the question how OT Theology and Biblical Theology could be attempted. Three answers can be given to this question, along the lines laid down by Giddens’s general view of the production of texts and their subsequent use. First, OT theology can be descriptive in the sense that it attempts to portray the beliefs that were held by the writers of the OT texts. These beliefs will be set in their social and historical contexts, and their development and divergences will be explored. Some writers would prefer to call this a history of Israelite religion or even the ideology of the OT rather than OT Theology.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A second method would involve dealing with some of the questions raised by the first method but would tackle the matter more formally by addressing to the OT questions that would not have been in the mind of the OT writers in precisely these forms. Thus it would assemble material about the nature and being of God or about human fallibility into sections entitled “Doctrine of God” or “Theological Anthropology.” It has been objected that this type of procedure imposes alien structures on the OT, but this objection is valid only if texts possess only an original communicative intention and no latent meaning. The fact that texts can be legitimately understood in ways not envisaged by their original authors/editors is a way in to using the OT theologically to address matters that concern today’s world. This is not, of course, the only way to link the OT and today’s world, as liberation and feminist scholarship has shown.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A third way of doing theology would be to read the OT and NT together in the light of a theological principle that was not derived from the texts themselves but which legitimately illuminated them. Thus, from a Christian trinitarian perspective, the Psalms could be interpreted in terms of the assumption that the God of the psalmist was the God ultimately revealed as Father, Son, and Holy Spirit. This would not involve an explicit reading back of Christian ideas into the Psalms; but it would involve understanding the spiritual experiences and language found in the Psalms from a Christian perspective, and would be a way into constructing a theology of both Testaments.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Readers will have noticed that the Apocrypha has been conspicuously absent from the last few pages. This is because, apart from treatments such as the use of the story of Judith and Holofernes or of Susanna and the elders in art, the Apocrypha has not yet been subjected to the degree of modern literary or hermeneutical study that the OT has, but has remained much more the province of historical-critical scholarship. No doubt this derives from the fact that, until the end of the last century, Roman Catholic scholars were not encouraged to engage in historical-critical research. Biblical scholarship was thus a Protestant preserve, with its traditional downgrading of the Apocrypha. It remains to be seen whether the creative contribution to contemporary scholarship made by Catholic scholars will bring the Apocrypha into the arena of liberation and feminist hermeneutics or the deployment of modern literary strategies. Perhaps the inclusion of the enlarged Apocrypha in this commentary, including "), _c('i', [_vm._v("Enoch")]), _vm._v(", will set a trend.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Alt, A. 1959, “Der Gott der Väter,” in Alt, "), _c('i', [_vm._v("Kleine Schriften zur Geschichte des Volkes Israel")]), _vm._v(", Munich: Beck, 1:1–78 • "), _c('i', [_vm._v("ANET")]), _vm._v(", 1955, "), _c('i', [_vm._v("Ancient Near Eastern Texts Relating to the Old Testament")]), _vm._v(", ed. J. B. Pritchard, Princeton: Princeton University • Barr, J. 2000, "), _c('i', [_vm._v("History and Ideology in the Old Testament: Biblical Studies at the End of a Millennium")]), _vm._v(", Oxford: Oxford University • Berlin, A. 1983, "), _c('i', [_vm._v("Poetics and Interpretation of Biblical Narrative")]), _vm._v(", Sheffield: Almond • Clines, D. J. A. 1995, "), _c('i', [_vm._v("Interested Parties: The Ideology of Writers and Readers of the Hebrew Bible")]), _vm._v(", JSOTSup 205, Sheffield: Sheffield Academic • Clines, D. J. A. 1998, “Methods in Old Testament Study,” in J. W. Rogerson, "), _c('i', [_vm._v("Beginning Old Testament Study")]), _vm._v(", London: SPCK, 25–48 • Davies, G. I. 1991, "), _c('i', [_vm._v("Ancient Hebrew Inscriptions: Corpus and Concordance")]), _vm._v(", Cambridge: Cambridge University • Finkelstein, I., and N. Na’aman, eds. 1994, "), _c('i', [_vm._v("From Nomadism to Monarchy: Archaeological and Historical Aspects of Early Israel")]), _vm._v(", Jerusalem: Israel Exploration Society • Giddens, A. 1987, “Structuralism, Poststructuralism and the Production of Culture,” in A. Giddens and J. Turner, eds., "), _c('i', [_vm._v("Social Theory Today")]), _vm._v(", Cambridge: Polity, 195–223 • Görg, M. 1997, "), _c('i', [_vm._v("Die Beziehungen zwischen dem Alten Israel und Ägypten, von den Anfängen bis zum Exil")]), _vm._v(", Darmstadt: Wissenschaftliche Buchgesellschaft • Gottwald, N. 1979, "), _c('i', [_vm._v("The Tribes of Yahweh: A Sociology of Liberated Israel, 1250–1050 B.C.E.")]), _vm._v(", London: SCM • Gutiérrez, G. 1974, "), _c('i', [_vm._v("A Theology of Liberation: History, Politics and Salvation")]), _vm._v(", London: SCM • Jamieson-Drake, D. W. 1991, "), _c('i', [_vm._v("Scribes and Schools in Monarchic Judah: A Socio-Historical Approach")]), _vm._v(", JSOTSup 109, Sheffield: Almond • Keel, O. 1992, "), _c('i', [_vm._v("Göttinnen, Götter und Gottessymbole: Neue Erkentnisse zur Religionsgeschichte Kanaans und Israels aufgrund bislang unerschlossener ikonographischer Quellen")]), _vm._v(", QD 134, Freiburg: Herder • Knauf, E. A. 1988, "), _c('i', [_vm._v("Midian: Untersuchungen zur Geschichte Palästinas und Nordarabiens am Ende des 2. Jahrtausends v. Chr.")]), _vm._v(", ADPV, Wiesbaden: Harrassowitz • Müller, H.-P. 1976, “Die lyrische Reproduktion des Mythischen im Hld,” "), _c('i', [_vm._v("ZTK")]), _vm._v(" 73:23–41 • Niehr, H. N. 1990, "), _c('i', [_vm._v("Der höchste Gott: Alttestamentlicher JHWH-Glaube im Kontext syrischkanaanäischer Religion des 1. Jahrtausends v. Chr.")]), _vm._v(", BZAW 190, Berlin: W. de Gruyter • Renz, J., and W. Röllig. 1995, "), _c('i', [_vm._v("Handbuch der Althebräischen Epigraphik I")]), _vm._v(", Darmstadt: Wissenschaftliche Buchgesellschaft • Rogerson, J. W. 1998, "), _c('i', [_vm._v("Beginning Old Testament Study")]), _vm._v(", London: SPCK and St. Louis: Chalice • Rogerson, J. W. 1998, “An Outline of the History of Old Testament Study,” in Rogerson, "), _c('i', [_vm._v("Beginning Old Testament Study")]), _vm._v(", 6–24 • Schottroff, L. et al. 1998, "), _c('i', [_vm._v("Feminist Interpretation: The Bible in Women’s Perspective")]), _vm._v(", Minneapolis: Fortress • Steymans, H. U. 1995, "), _c('i', [_vm._v("Deuteronomium 28 und die")]), _vm._v(" adê "), _c('i', [_vm._v("zur Thronfolgeregelung; Asarhaddons. Segen und Fluch im Alten Orient und in Israel")]), _vm._v(", OBO 145, Freiburg: Universitäts and Göttingen: Vandenhoeck & Ruprecht • von Rad, G. 1958, “Das formgeschichtliche Problem des Hexateuch,” in von Rad, "), _c('i', [_vm._v("Gesammelte Studien zum Alten Testament")]), _vm._v(", TBü 8, Munich: Kaiser, 9–86 • Vermes, G. 1997, "), _c('i', [_vm._v("The Complete Dead Sea Scrolls in English")]), _vm._v(", London: Allen Lane • Wright, C. C. J. 1995, "), _c('i', [_vm._v("Walking in the Ways of the Lord: The Ethical Authority of the Old Testament")]), _vm._v(", Leicester: Inter-Varsity • Wright, G. E. 1952, "), _c('i', [_vm._v("God Who Acts: Biblical Theology as Recital")]), _vm._v(", SBT 8, London: SCM • Wright, G. E. 1962, "), _c('i', [_vm._v("Biblical Archaeology")]), _vm._v(", Philadelphia: Westminster and London: Duckworth.")])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT",
    attrs: {
      "id": "ch002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-002"
    }
  }, [_c('i', [_vm._v("Premodern, Modern, and Postmodern in Old Testament Study")])])]), _vm._v(" "), _c('p', {
    staticClass: "CA"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-002"
    }
  }, [_vm._v("John A. Goldingay")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("G. W. F. Hegel suggested a three-stage model for understanding the history of thought. Some theory or thesis is accepted. Subsequently, a counterthesis or antithesis gains acceptance. Then a synthesis combines the truths in the first two. Current conventional wisdom implies a Hegelian understanding of the history of biblical interpretation. In the first millennium there was premodern interpretation, the second millennium saw the development of modern interpretation, and in the third there is postmodern interpretation. Calling this the conventional wisdom implies a recognition that it may look silly in a few years’ time. Associating it with Hegel implies a recognition that it imposes categories on the history—for instance, we will see that some aspects of Jewish interpretation in the first millennium had features in common with the modern as well as the premodern. Using Hegel’s scheme also reflects our need to understand matters in a way that provides them with structure and provides history with closure. But it is still a helpful framework. I want to consider aspects of the way these three ages approach the nature of the OT text, its origin, its historical reference, and its exegesis, and to suggest ways our postmodern context might change our aims and practice in OT study and enable us to appropriate the strengths of the premodern and modern stages while sidestepping their respective weaknesses.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("Premodern")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Text")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The NT illustrates the nature of premodern attitudes to the text of the OT. While assuming that these Scriptures are the inspired words of God, it quotes them in ways that show that it did not infer a need to be inflexible over the details of the text.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The NT’s first two quotations illustrate the point. Isaiah 7:14 says, “There, the maiden is pregnant and is giving birth to a son, and you are to call his name ‘God-is-with-us.’ ” The verb is second person singular—that is, the prophet is there addressing the woman (other aspects of the translation and interpretation of Isaiah’s words of course raise issues, but we can leave these for the moment). Matthew’s text (1:23) corresponds to the fairly literal LXX version except for reading “they will call.” In his second quotation (2:6) Matthew says that it stands written, “You, Bethlehem in the land of Judah, are by no mean least among the rulers of Judah, for from you will come out a ruler who will shepherd my people Israel.” Mic 5:2 (MT 1) itself says, “You, Bethlehem in Ephrathah, small to be in the clans of Judah, from you will come out for me one to be ruler in Israel.” The LXX again translates fairly literally. Matthew’s change from “clans” to “rulers” could indicate free translation or a different reading of an ambiguous text, but this is not true of the replacement of Ephrathah by Judah, nor of the addition of “my people.” Further, Matthew reverses Micah’s point about Bethlehem’s insignificance and adds the “for” that reworks the link between Micah’s clauses.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These opening NT quotations illustrate how it can quote the scriptural text with relative precision, or with small changes, or with far-reaching adaptations. It can be translated from the original or quoted from an existing Greek translation. The NT shows no concern to quote Scripture with precision.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The textual data presented by the NT may be compared with those presented by the Qumran scrolls. One Isaiah scroll, for instance (1QIsa"), _c('sup', [_vm._v("﻿b")]), _vm._v(") presents a text very close to the Masoretic, but another (1QIsa"), _c('sup', [_vm._v("﻿a")]), _vm._v(") presents a text with many more detailed differences. None of these differences changes the nature of the gospel; in substance the texts are the same. But they are different in many details. The Qumran community, like the early Christian community, did not sense that their commitment to the Scriptures entailed a concern for a single text form.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Origin")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Premodern works may be explicit about their authorship, or may be anonymous, or may be pseudonymous. Paul and John include their names in letters and in Revelation. Genesis–Kings and at least two of the Gospels are anonymous, though the communities that treasured these works came to link them with famous names. The Pentateuch became the Five Books of Moses, and two anonymous Gospels came to be associated with Matthew and Mark, while Hebrews came to be Paul’s. There are thus a number of pseudonymous works and no anonymous works in the King James Version of the NT.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("What was going on here? Why should the authorship of a work be of interest? First, it may buttress the work’s authority. The authority of Paul’s writings derives in part from his being an apostle and from his specific relationship with churches he founded. Second, it can put flesh on the bones of a document. We can imagine Solomon contemplating his achievements and possessions in the testimony in Ecclesiastes, and imagine Paul interacting "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("with the churches he visited. The instincts that made people associate anonymous works with a known person will have had a similar background, though the logic or dynamic was different. Hebrews became an authoritative document because of its contents; attributing it to Paul then buttressed or symbolized its authority. Moses, Joshua, and Matthew were in a position to tell the story of the exodus, the conquest of Canaan, and the story of Jesus, so they were appropriate people to link with works that were already authoritative. Papias’s story about Mark writing down Jesus’ story as Peter told it also undergirds that Gospel’s authority, while additionally providing readers with a vivid and attractive picture of the Gospel’s origin. One attributes a document to someone whose name will enhance it; choosing an unknown person would defeat the object of the exercise. Readers can feel that the Bible came from important people who had lived close to God and could speak reliably about God’s ways. Thus Jeremiah becomes the author of Lamentations and Solomon of the Song of Songs, Proverbs, and Ecclesiastes. First books gain the community’s assent and recognition as the word of God; then they are linked with an appropriate human author.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("I imagine that the same instincts had earlier led to material becoming pseudonymous in the form in which it appears within Scripture. The authors of the Book of the Covenant, the Priestly Code, and the Deuteronomic Code saw these as expounding the significance of Mosaic faith for their various times. When the Qumran community attributed a document to Moses, it was declaring the conviction that it had Mosaic authority. While its authors might have been making a cynical claim, more likely they, too, believed their work expressed Mosaic faith. In the ancient world there were, in fact, a variety of reasons for attributing a work to someone different from the person who wrote it (see Metzger 1972). It is difficult to be sure of the original significance of the expression "), _c('i', [_vm._v("l"), _c('sup', [_vm._v("﻿e﻿")]), _vm._v("dawid")]), _vm._v(" in the headings to certain psalms, but it came to be understood as an indication of authorship, and this made it possible to imagine David writing individual psalms in concrete situations in which he needed to reach out to God. Convictions about authorship thus become hermeneutical keys to understanding the books. A further conviction can also be involved. Why did second-century visionaries ascribe their visions to Daniel, a figure from centuries before them? The link of content suggests that Daniel’s visions had inspired theirs. The Holy Spirit brought into being the visions in Daniel 7–12 by inspiring people’s reflection on Daniel’s own vision in Daniel 2 and on other scriptures. Something similar is true about the inclusion in the book of Isaiah of much material that did not issue from Isaiah ben Amoz. There, too, the Holy Spirit inspired much of that material by encouraging people to reflect on the oracles of Isaiah to see what God had to say to later centuries in light of what Isaiah said.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Reference")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Until the eighteenth century, readers understood the OT narratives in a “realistic” way, treating them as true accounts of God’s involvement in Israel’s life over the centuries, though they did this unreflectively. They took for granted that the biblical story corresponds to what actually happened, as well as to the story of their own lives, in the sense that they judged the story of their lives by the Bible’s story. In the eighteenth century both of these assumptions came apart (see Frei 1974). People now evaluated the Bible’s story by their own story, as they still do, asking whether it is relevant, not whether we are. In addition, they became preoccupied with the difference between the history of Israel and the story the OT tells. It requires some effort of the imagination to put ourselves back into a context where this was not so. Today when someone says, “Jonah was three days and nights in the sea monster’s belly,” he or she will have a view on whether the statement refers to something that happened historically or that happened in a story. When Jesus said those words, neither he nor his hearers need have worked with that antithesis.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The etymology of the words “history” and “story” tells an instructive tale in this connection. Both derive from a Greek root that provides parts of the defective verb "), _c('i', [_vm._v("oida")]), _vm._v(", “to know” (e.g., "), _c('i', [_vm._v("iste")]), _vm._v(" “you know”). A "), _c('i', [_vm._v("histor")]), _vm._v(" is a person who knows, a wise person, "), _c('i', [_vm._v("historein")]), _vm._v(" refers to learning by investigating something and then to narrating what one has learned, and "), _c('i', [_vm._v("historia")]), _vm._v(" is an inquiry or its results, specifically a narrative. The biblical narratives are thus instances of "), _c('i', [_vm._v("historia")]), _vm._v(". They offer insight in narrative form that results from inquiry. That itself might suggest that the material their authors have investigated includes factual material but need not be confined to that. And this corresponds to the nature of history writing in the ancient world.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The point may be illustrated further by considering the nature of much of the scriptural story as midrash—Chronicles being in part a midrash on Kings, and Matthew on Mark and Chronicles. As midrash it retells a story to show what it now means for people, in light of other scriptures and other convictions regarding God’s word to people now. When this retelling involved changing words attributed to Solomon or Jesus, the authors presumably realized that what they were writing was not actual history. They and their readers could apparently live happily with that—perhaps rather like Shakespeare and the people who watch his plays, or the scriptwriter and viewers of (say) "), _c('i', [_vm._v("Erin Brokovitch")]), _vm._v(" or "), _c('i', [_vm._v("A Beautiful Mind")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Exegesis")])])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Actual interpretation, interaction with the text’s meaning, in the premodern period is again conveniently illustrated for us by the NT’s interpretation of the OT. The OT scriptures decisively shaped and resourced Jesus’ self-understanding and the early Christians’ understanding of Jesus and of the church, in an imaginative and intuitive rather than an analytic and systematic fashion. Matthew wants to understand the surprising story of Jesus’ birth and early life, and does so by putting verses from the scriptures alongside incidents within the story of Jesus in such a way as to give him and his community some insight regarding what on earth that was about and what it meant (see Matt 1:18–2:23). Paul wants to provide a rationale for the material support of apostles or to shake a congregation into living more uprightly or to underline ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("how Jesus must reign over everything, and one of the ways he does so is by incorporating passages from the scriptures into his argument (see 1 Cor 9:9; 10:1–13; 15:27). Premodern interpretation can thus generate powerful application of scripture directly addressing new contexts and the questions arising there. The understanding of Jesus and of the church that we derive from the NT could not have existed without this use of the scriptures. God used it to mediate key insights for Jesus himself as his Father addressed him in words from Psalm 2, Genesis 22, and Isaiah 42, “You are my Son, my Beloved, with whom I am well pleased” (Mark 1:11), to set before him crucial insights on his identity and vocation.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Such use of scripture suggests some theological principles: the Scriptures are the Spirit-inspired words of God to Israel, Jesus is the climax of Israel’s story, and a Christian congregation is a local embodiment of what Israel was called to be. But this use of Scripture did not emerge from such a conscious hermeneutical/theological framework since it did not emerge from exegetical principles. Premodern interpretation was intuitive. It started from present context and faith convictions and moved back to the Scriptures. The serendipitous way in which the NT quotes from the text, to which I have already referred, is one of the symbols of that. The writers’ angle of vision did not predetermine what people saw there, though it did determine the "), _c('i', [_vm._v("kind")]), _vm._v(" of thing they saw. And it meant that their interpretation would hardly convince someone who did not accept their starting point—it was not designed to do that. It was part of the whole picture of Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("New Testament interpretation of Genesis 1–3 provides many examples of the interpretation of Scripture in light of current issues and convictions and sometimes troubles Christians, particularly those of a feminist persuasion. Most notoriously, 1 Timothy 2 supports the requirement that women should keep silent in church with a reference to the fact that Adam was formed before Eve and that it was Eve, not Adam, who was deceived and became the transgressor. The passage “uses data from Genesis 2–3 selectively to suit the needs of the argument at hand” (Scholer 1986: 211). It does not work within a modern framework.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("Modern")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Modern interpretation came into existence in the West through the collocation of the Renaissance, the Reformation, and the Enlightenment. The Renaissance gave birth to an interest in the human side of texts from the past and to a desire to understand them in their own right. The Reformation took up this emphasis and declined to allow the interpretation of Scripture to be determined from outside itself—specifically, by the authority of the church. The Enlightenment urged that nothing be accepted on the basis of tradition. Everything should be tested and can be questioned.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Text")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Whereas the Qumran community happily treasured manuscripts that differed from each other (see, e.g., 1QIsa"), _c('sup', [_vm._v("﻿a")]), _vm._v(" and 1QIsa"), _c('sup', [_vm._v("﻿b")]), _vm._v("), during the first millennium the Masoretes made it their business to establish "), _c('i', [_vm._v("the")]), _vm._v(" one true text of Scripture. The premodern context of this work was reflected in their assumption that the true text was the one that truly represented the tradition—the “Masoretes” "), _c('i', [_vm._v("were")]), _vm._v(" the “traditioners.” With the Renaissance, this concern for the true text took a new form when scholars came to assume that the "), _c('i', [_vm._v("true")]), _vm._v(" text was the "), _c('i', [_vm._v("original")]), _vm._v(" text. Seeking to establish the original text became the first stage of critical study of the OT.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This concern gained an extra level of theological importance for evangelicals in the context of the novel development of the doctrine of Scripture by Charles Hodge and B. B. Warfield in the form of their doctrine of Scripture’s inerrancy (they actually used the word “infallibility,” but “inerrancy” is the more recent equivalent). One of their strategies for coping with apparent mistakes in Scripture was to attribute infallibility to Scripture “as originally given,” to the original text that textual criticism sought to establish. Evangelical study thus accepted the same aim as liberal study, and added another level of theological importance to it.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Origin")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("With the development of modernity biblical critics asked what was the evidence, for example, for the tradition that Moses wrote the Pentateuch, and concluded that it was poor. The books make no statement about authorship, and it is almost a thousand years after Moses’ day that he comes to be connected with them. They refer to circumstances from centuries after Moses’ day and manifest repetitions and changes in the way they handle questions that suggest that they were compiled from several successive versions rather than written by one person over a short period. So scholarship looked for alternative understandings of the books’ origin and eventually settled into a consensus that held until the late twentieth century, that they issued from the interweaving of several versions of the story of Israel’s origins from the early monarchy, the seventh century, and the exile or later. This provided a more coherent account of the data, one that corresponds to the way we know books such as Tatian’s “Harmony of the Gospels” were written. It sometimes made it possible to link the Torah with specific historical contexts. And it provided grounds for dating the material that did not depend on faith.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("The study of the prophetic books went through a parallel process, operating on the assumption that their authority stemmed from links with great figures such as Isaiah and Jeremiah. Study therefore focused on getting behind the books to the words of the prophets themselves, where authority lay. As an undergraduate I remember being puzzled by the random-looking choice of chapters in Isaiah for exegetical study, eventually realizing that they were chapters that some professor had thought really came from Isaiah ben Amoz. The link with the prophet himself made them of paramount importance. Modern evangelical study believed with liberalism that the books’ authority was tied up with their being written by the people tradition said, and therefore it tried to find evidence that it was still reasonable to believe ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("that. It thus added another level of theological importance to research into authorship and sought to use modern methods to support premodern convictions.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Reference")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Perceiving the difference between the history the OT tells and the actual history of Israel presented scholarship with a fateful choice. In which history would it now interest itself? In the context of modernity there was no contest. “History is God nowadays” (Reumann 1966–67: 147). Scholarship abandoned the history the OT tells in order to investigate the history behind it. In some sense the theology of the OT story depends on its historical factuality, and the critical approach opened up the possibility of establishing historical factuality without presupposing faith, though in practice the results of the venture were discouraging. Modern evangelical study thus agreed with modern liberal study that the historical nature of the OT was vital to its authority, and tried to find evidence that it was still reasonable to believe that the narrative itself was thoroughly historical.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Modern interpretation further assumed that the key to understanding the meaning of Scripture was to project oneself back into the time of its authors. The meaning of Scripture lay in what the authors intended to say. Biblical criticism declined to be bound by the church’s tradition regarding Scripture’s meaning, whether this was more Catholic tradition or more Protestant/evangelical tradition. That opened up new possibilities of entering into what was going on between (say) Jeremiah and God and of escaping from the interpretations of the Christian tradition that had overlaid God’s word, especially in the OT.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It also took further a Reformation principle, for the Reformation was, among other things, an argument about the interpretation of Scripture. The Reformation did not take place against the background of the church’s ignoring Scripture. Rather, the Reformers thought the church misinterpreted it, treating it as if it had a wax nose that could be twisted to any shape you wanted (so Luther). They affirmed that it must be read in accordance with its intrinsic meaning. The Reformation thus brought into focus the problem of conflicts of interpretation—what happens when people disagree on the meaning of texts, as Catholics, Protestants, and Anabaptists did?")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("Postmodern")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("“Postmodern” is of course a notoriously polyvalent term. I am not here concerned with the broader postmodernity of which “deconstruction” is a “virtual synonym” (Brummitt and Sherwood 2002: 5) but with postmodern attitudes to the areas already outlined. Postmodern attitudes are formulated in reaction to modern ones. They start from the difficulties of modern attitudes even as modern attitudes had started from the difficulties of premodern ones. They remain aware of the difficulties of premodern views, so they do not imply a reversion to premodern ones as if those were right all along and what we need to do is forget the aberration that comprises modernity. Postmodern study starts from the fact that liberal modern study cannot find any alternative answers to the questions that emerge from premodernity, only more and more questions, and that evangelical modern study cannot find any more evidence for its convictions but can only reassure you that traditional views are as good as any other. Postmodern study seeks to combine premodernity and modernity in a new way. It recognizes that one of the traditions of which we now need to be critical is the tradition of the academy, which is part of modernity. A commitment to “believing criticism” can now be seen as involving the attempt to be pre-modern and modern at the same time, which is easier now that postmodernity has dawned. The “believing” part implies the premodern conviction that the whole of the Bible is true, the whole of it is given by God, and the whole of it makes demands on us. The “criticism” part implies recognition that the church’s interpretation of Scripture and the academy’s interpretation of Scripture are fallible and that we should never assume that what we have been told about the Bible by the church or by scholars is right. We are critical about what anyone says the Bible says.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Text")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("In the third millennium the aim of textual criticism neither need nor can be the establishing of the original text of the Scriptures.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The discovery of the Qumran scrolls had paradoxically conflicting implications for textual criticism. It reinforced the conviction that nothing too disastrous had happened to the text of the Masoretic tradition in the thousand years between the copying of the scrolls and the production of the great Masoretic codices around "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" 1000. In 1945 our oldest complete Hebrew texts were only a thousand years old and were thus nearer to us in age than to anyone who lived in OT times. In 1950 we had substantial texts of Isaiah and other books that were two thousand years old and were thus nearer to their authors’ age than to us, and these texts are substantially the same as the Masoretic texts. But the many small differences between, for example, 1QIsa"), _c('sup', [_vm._v("﻿a")]), _vm._v(" and 1QIsa"), _c('sup', [_vm._v("﻿b")]), _vm._v(" also reinforced the suspicion that since pre-Christian times there have been several textual traditions. We have no basis for guessing whether any of them is closer to the original text.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Indeed, it has become unclear what we mean by the original text of an OT book. Textual history collapses into redactional history. What do we mean by the original text of Isaiah? More pressingly, what do we mean by the original text of Jeremiah, given the possibility that the shorter LXX text is older than the longer MT text? Should we see the authoritative form of the text as the canonical one (virtually a tautology, that) (see Childs 1979: 84–106; 1984: 518–30)? If Roger Beckwith is right and we define the canonical Scriptures as the works deposited in the temple (Beckwith 1985), is this the text that textual criticism seeks to establish? But how would we know what that text was? It would be wonderful if the temple scrolls were the ones taken up in the Masoretic tradition, but is there any evidence that this ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("was so? And in trying to identify such a single tradition, are we imposing categories on the process? Further, we are ignoring the implication in the NT that there is no need to reckon that the OT’s authority requires that there be only one text-form.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("A postmodern attitude to textual criticism will be quite at home with pluralism, as we are at home with a plurality of translations. The implication of the NT’s attitude is that the Holy Spirit could be involved in the process whereby different texts of the Scriptures developed, as the Holy Spirit was involved in generating the first versions of stories, psalms, sayings, and oracles, and then in the redactional process whereby they were collected, supplemented, and updated. We have no basis for determining what is the one text of the OT, nor any need to do so. We can treat both MT Jeremiah and LXX Jeremiah as inspired and look for edification in each. Instead of being either-or people, we can be both-and people.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I do not think that this argument points toward recognition of the LXX canon; while some NT writers have read and been influenced by books in the longer canon, they never refer to them as Scripture or quote them. Nor does it imply accepting all textual variants as equally valid, as we do not accept all prophecy as equally valid. The question is, Where may we see the Holy Spirit’s work in the development of the text? That may lie in deliberate reworking or in misunderstandings and mistakes that generate edifying readings. Alongside a premodern openness to seeing divine involvement in textual development we will maintain a modern spirit that asks questions about the nature of this development. Textual criticism thus remains a critical task, one that involves spiritual discernment. Its critical principles include, for example, what is oldest and what makes sense to the modern critical scholar, but also, for example, Augustine’s interpretive criterion, what encourages love?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Here are examples. In Ps 1:5, the MT declares that the faithless will not stand in the judgment when the “company of the true” assembles. It apparently refers to an event in the present life of the community. But in the LXX people will not rise "), _c('i', [_vm._v("again")]), _vm._v(" at the judgment, so that the LXX refers the psalm to the Last Judgment. Ps 5:8 MT prays, “Direct your way before me,” be purposeful and focused in your action, while in some LXX mss. the psalm prays, “Direct "), _c('i', [_vm._v("my")]), _vm._v(" way before "), _c('i', [_vm._v("you")]), _vm._v(". Ps 7:11 MT declares that God is always expressing anger, which is good news because it means that God consistently acts against oppressors, while the LXX declares that God is "), _c('i', [_vm._v("not")]), _vm._v(" always expressing anger, which is good news because it means that God is merciful to us. In each case the LXX says something edifying and encouraging or appropriately challenging within the readers’ framework. One can see the Holy Spirit’s work in that. On the other hand, precisely in doing that, in each case it conforms the text to its readers’ expectations. It makes it say something they would be less likely to find surprising. This does not sound like the work of the Holy Spirit because being surprising is one of the Spirit’s characteristics. We do not need the Holy Spirit to say things we would have thought of anyway. Postmodern textual criticism is simultaneously affirming and questioning.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Origin")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Modern study was predicated on the assumption that we could discover when books were written. We now have to face the fact that there are virtually no assured results of modern criticism. We know very little about the dating of most OT books. Opinions differ, and presuppositions and fashion are very influential on what scholars think. Scholarly writing makes much use of statements such as “it seems likely,” implying “there is no hard evidence for this,” and of statements such as “most scholars think,” implying “this is a view that will soon be outdated.” Current interest in interpreting the OT against its sociological background only relocates the problem since we have no more basis for knowledge about the sociological than about the historical. Current interest in interpreting the OT against the historical and social background of the Persian period raises similar questions since we know very little of either and there is no more evidence for dating the books against this background than there was against the alleged “Solomonic enlightenment.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I say “virtually no assured results” because I must not exaggerate the point. In particular, there is a difference between the Prophets and the other books. It is an assured result of modern criticism that Isaiah 40–55 needs interpreting against the background of the late sixth century as well as that Daniel’s visions need interpreting against the background of the second century, and I still enjoy inviting students to read Genesis 1 against the background of the exile. But we do not know when most of the OT was written, "), _c('i', [_vm._v("and we never will know")]), _vm._v(". Another recurrent word in scholarly writing is “yet,” as in “we are not yet clear,” “scholars are not yet sure.” This gives the impression that OT research is like medical research and that one day we will know the answers to questions that currently puzzle us. There are grounds for this confidence in medical research; this process has happened in the past. There are virtually no such grounds in OT research. None of the major problems that scholars discussed in the nineteenth century has been solved.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This does not mean that readers can revert to premodern views because the data that led to the modern theories are still there. We can know that Moses did not write the Torah and that there are several collections of teaching and compilations of stories brought together there that represent ways God guided people over the centuries. But we can have no theory about the nature of this process to replace the premodern one that Moses wrote it, or the modern Wellhausenian consensus. And we thus cannot build OT interpretation on convictions about date and authorship. We do not make progress by trying to understand Job, Jonah, or Ruth against their historical context or in light of their author’s intentions, except insofar as talking about the author’s intentions is another way of talking about the actual content of the books (what the author intended was to say what the book says). And apparently the same is true about, for example, the Pentateuch. The communities that generated and preserved the Scriptures declined to incorporate the kind of data that would help us fix them historically. Modernity thought we needed this, but God does not seem to have agreed.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("So postmodern study concludes that in general the question about authorship and dating must be the wrong question. In the postmodern era we simply (?) read the books without knowing who wrote them or when. We thus focus on what can be known from the text rather than on questions that run into the sand.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("But with modernity, we do not take for granted that we know what the text says and that it says what we have been told it says. In this sense we approach it critically. We seek to read it with open eyes; we do not revert to what tradition says it says. This aspect of criticism is at least as important as it ever was. We use whatever keys seem to unlock aspects of the text, trying different ones until one opens the lock without forcing it.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Reference")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("In the aftermath of the Enlightenment, “history” and “story” with their common etymology separated. “History” came to refer to the facts, the events that (might) lie behind a narrative. “Story” came to refer to the narrative, with the implication that it had little value except insofar as it spoke of events that did happen. It was history that now came to count, so that Thucydides and Exodus were valued only for the factual material they contained. Liberals and evangelicals agreed that if Exodus is not factual, its authenticity or value disappears.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Modern historical study has presupposed that we are in a better position to determine where the facts lie than the authors of the narratives were, as well as having the motivation to do that, but this other aspect of a historical approach to the OT also produces disappointing results. It would be pleasant to think that current skepticism about Israelite history issued from end-of-millennium malaise and/or postmodern convictions and that in a decade or two things will settle down (cf Zevit 2001: 1–80; Dever 2001: 245–62—though even Dever is skeptical about Israel’s ancestors and the exodus; his confidence starts only with David). But more likely OT study went through a loss of (false) innocence at the end of the second millennium. In seeking to discover the events that lie behind the story, we are again asking questions the text will not answer. If end-of-millennium malaise allowed this fact to emerge, now that it has emerged, it cannot be evaded. This is not just a temporary problem. The twentieth-century consensus was always just a consensus. Once the boy has commented that the emperor has no clothes, the clothes can never be restored. We cannot abandon the idea that the OT story needs to be basically historical. But we have to trust God that it has the historical value it needs to have, on the basis, for instance, that Jesus would hardly have relied on this book as he did if it did not have the historical value it needed to have, and would hardly have therefore encouraged us to base our thinking and lives on it. But we cannot prove that this is so by using critical methods.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Ziony Zevit defines history as “a true story about the past” of the kind that a law court seeks to establish, concerned with facts (Zevit 2001: 27). This definition fits the history Zevit seeks to write. But for the OT “histories,” Jan Huizinga’s definition is more illuminating: “History is the intellectual form in which a civilization renders account to itself of its past” (Huizinga 1936: 9; as quoted by Hallo 1999: 83; I do not think it matters if the way people use Huizinga’s definition does not exactly correspond to its meaning in the context of his work, as Lawson Younger Jr. 1990: 26–27 implies). Such an account of the past needs to have some relationship with historical events, but a civilization’s “past” includes more than the events in which it has been involved, and “giving account of the past” has naturally included—indeed, focused on—the passing on of its traditions in general, which have varied relationships to actual events. Like Western dramatists and scriptwriters, even when telling the story of a historical person ancient “historians” were at home including material of a “fictional” kind—both traditional material (“legends”) and material newly created by the author. Genesis 1 is not the last piece of true imaginative fiction in the Bible. The inclusion of such imaginative fictions fits with the nature of history writing in the ancient world. God’s inspiring the biblical historians did not make them write as if they were modern historians but write as really good ancient historians.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There is then a paradox here. Moderns and postmoderns are quite happy with the interweaving of fact and fiction in Shakespeare and in movies, and as theatergoers we are not so different from premodern readers. Conversely, perhaps premodern reading of Scripture was not so different from our own. Some readers would assume that narratives indeed related what actually happened, like viewers assuming that soap opera characters are real people. Other readers would know that there was probably some difference between the narrative and the actual events and might sometimes be able to guess where it lay, but would mostly focus on the narrative, like a theatergoer watching a Shakespeare play or a film based on facts. It was the context of modernity that made Gerhard von Rad describe the substantial divergence between the OT narrative and the actual course of Israel’s history as a grievous burden (von Rad 1962: 108). In a postmodern context, that seems an understandable but extreme view. The considerations about the nature of history writing I have just pointed to do not eliminate the burden but they do reduce it so that it becomes bearable.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There are disadvantages to our uncertainty about the precise historical value of the OT, but it also brings such significant advantages that I might be prepared to see it as a result of divine providence rather than divine oversight. If we cannot establish what events lie behind the OT, that pushes us to focus more on the text itself. Adopting modernity’s understanding of history as the privileged lens through which to view the OT has skewed the perceptions of both liberal and evangelical study. Even if we could establish exactly what actually happened in these events, and even if these were identical with the text itself, the proper subject of OT study would still be the OT, not the history. It would still be the text with its selectivity and arrangement. The narrative gives us the truth and not merely the facts.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("In the premodern era the church believed that it lived its life in the context of God’s story with Israel, and in the modern era scholarship invited readers to be critical of ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("the tradition of interpretation they had received. Evangelical tradition says it is really important that the events of OT history happened but that they are then of no further relevance to our thinking or life today. What matters is that God is involved in my personal life. Modern interpretation supported this view by seeing biblical narrative as history, with the high boredom potential of that designation. Postmodern interpretation assumes that biblical narrative is story, and mostly the story of a community, and that we need to enter into it as story, into the life of the community, the lives of the characters and the unfolding of the scene, and find our own corporate and individual place there. It invites the church to be self-critical about its assumption that we evaluate the relevance of the OT story by our story and to start living by the OT story.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Premodernity and modernity made two quite different assumptions about the way a text comes to speak to people. It was not quite that one was intuitive, and the other rational; both involved the intuitive and the rational. Premodernity assumed that the royal road to good interpretation was the assumption that the text spoke to our current concerns. It then found that it did so, though it was limited to seeing what spoke to its existent concerns, and its nature did not encourage the broadening out of these so that they matched the text’s concerns. Modernity assumed that the royal road to good interpretation was the setting aside of our concerns in order to focus on the text’s, but there were problems with its practice. To begin with, it did not work, as countless dull biblical commentaries by both liberal and evangelical writers testify. And one reason was that modernity did not live by its own principles. The text was concerned to feed a community’s self-understanding by reminding it of God’s involvement with it, but modernity was preoccupied with questions about history that it naively treated as if they were also the text’s preoccupation. It never reached the text’s agenda.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Perhaps it is partly as a consequence that premodern interpretation persists and is still the dominant form of interpretation in the church, which is virtually unscathed by critical interpretation. This appears in the use of Scripture in lectionaries and in the proof-text approach to Scripture in ecumenical documents. It appears in the use of the Bible in preaching and in people’s spiritual reading. Worse, God uses Scripture that way. As an ordinand I went through a period of spiritual uncertainty—not over whether the Christian faith was true but over whether it applied to me. I was no longer sure whether I belonged to the elect. What brought me reassurance was the impact of the reading of Deuteronomy 17 in chapel one day, in particular the phrase relating to the Israelites’ having come out of Egypt: “You shall not return that way again.” That came to me as a promise that God had taken hold of me and would not let me go. The irony is that in context it is a challenge not a promise. God used the text unhistorically, atomistically, and directly. God had no need to do that and could have given me this reassurance via the intrinsic meaning of some other passage of Scripture. God’s using Scripture that way implies that when texts become part of Scripture as a whole they become semi-independent of the historical and literary specificity of their origin. They are open to being read as part of this larger whole and as having a meaning that derives from that larger whole. They have a new level of literal meaning. And they speak to people without going by way of an analytic process.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Modernity’s understandable mistake was to attempt to sideline this form of interpretation in order to promote its own. But sidelining simply drove it underground (and not very far underground). Paradoxically, if we want the positive aspects of modern interpretation to have an impact on regular Christian interpretation, we need also to work with premodern interpretation and not against it. The prospect and the challenge of postmodern interpretation are to bring together the strengths of premodern and modern in such a way as to sidestep the limitations of each. We are the victims of a split between academic study and person-involving study. Our postmodern context gives us the opportunity to put these two back together.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Postmodern interpretation will be enthusiastic over the way the Holy Spirit inspires imaginative leaps in the use of Scripture that give the words a significance that may have little to do with their meaning in their grammatical and historical context. But it will not make that a default assumption about the nature of interpretation, for reasons that emerged in the context of the Reformation and the Enlightenment. Such use of Scripture can be a means of making affirmations that are actually unscriptural, and we need ways of being able to argue about whether what someone says is indeed a word from the Lord. If it does not correspond to the text’s original meaning, we need to treat it again as we would a purported prophecy—be open to the possibility that it came from the Spirit, but not assume that this is so. We also need to keep in mind that most prophecy is either false or trivial. A bigger problem with “free” interpretation is that it often simply confirms us in what we already believe rather than allowing God to break through. Studying Scripture in a modern way is extremely important because we need to distance ourselves from Scripture as we are familiar with it, in order to let it say what it has to say in its own terms. Our present understanding is probably wrong at some points, and we need to be delivered from our framework of interpretation. We need to understand Scripture historically. But we also need to be open to leaps of inspired imagination.")])]), _c('p', {
    staticClass: "Bib1"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". I adapted some of the above paragraphs from "), _c('i', [_vm._v("An Ignatian Approach to Reading the Old Testament")]), _vm._v(" (Cambridge, U.K.: Grove, 2002): 3–7 and from "), _c('i', [_vm._v("Old Testament Theology")]), _vm._v(", vol. 1 (Downers Grove, Ill.: InterVarsity, 2003). See also Beckwith, R. 1985 and 1986, "), _c('i', [_vm._v("The Old Testament Canon of the New Testament Church and Its Background in Early Judaism")]), _vm._v(", London: SPCK/Grand Rapids: Eerdmans • Brummitt, M., and Sherwood, Y. 2002, “The Tenacity of the Word,” in "), _c('i', [_vm._v("Sense and Sensitivity")]), _vm._v(", Robert Carroll Memorial Volume, ed. A. G. Hunter and P. R. Davies, JSOTSup 348, London/New York: Sheffield Academic, ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("• Childs, B. S. 1979, “Text and Canon,” in "), _c('i', [_vm._v("Introduction to the Old Testament as Scripture")]), _vm._v(", London: SCM/Philadelphia: Fortress, 84–106 • Childs, B. S. 1984 and 1985, “The Hermeneutical Problem of New Testament Criticism,” in "), _c('i', [_vm._v("The New Testament as Canon")]), _vm._v(", London: SCM/Philadelphia: Fortress, 518–30 • Dever, W. G. 2001, "), _c('i', [_vm._v("What Did the Biblical Writers Know and When Did They Know It?")]), _vm._v(" Grand Rapids/Cambridge: Eerdmans, 2001 • Frei, H. 1974, "), _c('i', [_vm._v("The Eclipse of Biblical Narrative")]), _vm._v(", New Haven/London: Yale University • Hallo, W. W. 1999, “Biblical History in Its Near Eastern Setting,” in "), _c('i', [_vm._v("Israel’s Past in Present Research")]), _vm._v(", ed. V. P. Long, Winona Lake, Ind.: Eisenbrauns, 77–97 • Huizinga, J. 1936, “A Definition of the Concept of History,” in "), _c('i', [_vm._v("Philosophy and History: Essays Presented to Ernst Cassirer")]), _vm._v(", ed. R. Klibansky and H. J. Paton, Oxford: Oxford University, 1–10 • Younger, Y. L. 1990, "), _c('i', [_vm._v("Ancient Conquest Accounts")]), _vm._v(", JSOTSup 98, Sheffield: Sheffield Academic • Metzger, B. 1972, “Literary Forgeries and Canonical Pseudepigrapha,” "), _c('i', [_vm._v("JBL")]), _vm._v(" 91:3–25 • Reumann, J. 1966–67, “"), _c('i', [_vm._v("Oikonomia")]), _vm._v("-Terms in Paul in Comparison with Lucan "), _c('i', [_vm._v("Heilsgeschichte")]), _vm._v(",” "), _c('i', [_vm._v("NTS")]), _vm._v(" 13:147–67 • Scholer, D. M. 1986, “1 Timothy 2:9–15 and the Place of Women in the Church’s Ministry,” in "), _c('i', [_vm._v("Women, Authority and the Bible")]), _vm._v(", ed. A. Mickelsen, Downers Grove, Ill.: Inter-Varsity, 193–219 • von Rad, G. 1962 and 1965, "), _c('i', [_vm._v("Old Testament Theology")]), _vm._v(", 2 vols., Edinburgh: Oliver and Boyd/New York: Harper • Zevit, Z. 2001, "), _c('i', [_vm._v("The Religions of Ancient Israel")]), _vm._v(", London/New York: Continuum.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT",
    attrs: {
      "id": "ch003"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-003"
    }
  }, [_c('i', [_vm._v("Syro-Palestinian and Biblical Archeology")])])]), _vm._v(" "), _c('p', {
    staticClass: "CA"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-003"
    }
  }, [_vm._v("Deborah A. Appler and Julye Bidmead")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("William Dever defines an archeologist as an “anthropologist who deals with the ethnicity of the dead” (2001: 54). In essence, archeologists dig beneath the dirt to uncover the material culture (architecture, pottery, bones, tools, jewelry, religious artifacts) of an ancient society in order to reconstruct its history and culture. Syro-Palestinian archeologists limit their research to the geographic area that encompasses the lands of the Bible, which include the modern state of Israel (including the West Bank and Gaza), Jordan, Syria, and Lebanon. Related disciplines, which also shed light on the biblical text, cover ancient Egypt, Mesopotamia, and the Mediterranean.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Recent land disputes between the Israelis and Palestinians have caused practitioners of Syro-Palestinian archeology to seek an alternative name for the discipline that is less politically charged (see Dever 2003). However, as of now no new name has been universally embraced.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The area of Syro-Palestine has been politically charged ever since the United Nations created the state of Israel in 1948. Archeology and politics have continued to coincide. For example, Yigael Yadin not only served as an officer in the Israeli army but he also made a career out of archeology and excavated such historically relevant sites as Qumran and Megiddo. These discoveries provided modern Israelis with a link to their ancestors who earlier dominated the land. Lawrence protected the British and Arabs from the Ottoman Turks while simultaneously excavating ancient Egypt. In the late twentieth century when Palestinian territories received autonomy from Israel, they made the creation of a department of archeology a priority so that they, too, could establish a link to their ancestors in the land that they hoped to reclaim. Consequently, Albert Glock (1925–92) created such a department at Birzeit University. This program remains a stronghold for Palestinian archeology.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Though Syro-Palestinian archeology concerns itself with territories contained in the Hebrew and Christian Scriptures, this discipline should not be confused with the subdiscipline “Biblical Archeology,” a primarily U.S. endeavor spearheaded by William Foxwell Albright of Johns Hopkins University during the middle of the twentieth century. While Syro-Palestinian archeology is a secular endeavor that, in theory, relies on material culture alone to reconstruct ancient societies, Biblical Archeology unabashedly treats the biblical text as further data for these same reconstructions. The majority of archeologists presently excavating in “biblical regions,” regardless of religious orientation, seek to collect and interpret their data as impartial scientists. Yet this field finds its roots with those scholars who sought a connection between the biblical text and artifacts.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("Roots of the Discipline")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("While interest in biblical sites existed long before the nineteenth century, first evidenced by the biblical writer describing the ruins of Ai (Josh 8:28) and later by Queen Helena’s quest to preserve sites associated with Jesus Christ ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" 326–328) and Napoleon’s search for ancient Egypt (eighteenth century), archeology as a modern discipline is a recent phenomenon. The emergence of the Enlightenment led many nineteenth-century biblical scholars to apply new historical-critical methods to the Bible, with results that often challenged the historicity of the text. Consequently, the new discipline of Biblical Archeology emerged, whose earliest proponents sought to verify the “truth” of the Bible by producing scientific data (artifacts and material culture) that corroborated the content of this text. With this goal in mind, Edward Robinson, an expert in biblical Hebrew and history, and Eli Smith (1838), versed in the Arabic language, set off for Palestine and identified over a hundred biblical sites. However, it was Sir William Flinders Petrie’s work at Tell el-Hesi (biblical Eglon) in the 1880s that initiated a methodical study of the holy lands.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Petrie was the first to recognize the importance of the mounds dotting Syria, Palestine, and Jordan, which he identified as “tells” (Arabic; "), _c('i', [_vm._v("tel")]), _vm._v(" in Hebrew) from the Hebrew and Akkadian "), _c('i', [_vm._v("(tillu)")]), _vm._v(" meaning “ruin,” or “heap.” A tell is a mound or small hill that has been built up over several centuries of occupation. It is formed through the accumulation of remains of repeated building activities. As towns and villages were built, destroyed, and then rebuilt, each new settlement placed its foundation on top of what the earlier dwellers left behind. As Petrie dug through these tells, he noticed that pottery changed over time and could be used to establish a chronology for dating each of these layers of occupation (stratum). Relative dating based on pottery typology continues to be the archeologist’s best method for establishing chronology. Later William Foxwell Albright would refine this methodology and provide a more exact pottery chronology for the time periods associated with the biblical material.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Archeological Method")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Choosing a Site")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The choice of an excavation site often results from regional surveys in which archeologists sweep a geographical area, collect and sort its surface pottery, and note architectural remains and other signs that the area was occupied during their historical period of interest. Some archeologists choose to conduct small-scale excavations (probes) to further determine if the site has potential for a full-scale excavation. With the advent of new technology, some excavated sites, such as Megiddo, are re-excavated to verify or correct previous results. Other tools an archeologist might employ to find a good site include the Proton Magnetometer, which works like a metal detector to identify magnetic activity that might be emitted from buried objects, and Soil Sounding Radar, which bounces radio waves off these same items. Yet in Syro-Palestine where sites abound, the place of preference is the tell, because it is often identified with a biblical site and is located at a strategic geographical point.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In ancient times, just as in rural areas today, people want to live in areas with easy access to water, a favorable climate, good agricultural conditions, close proximity to trade routes, and a good location for defense. In sites with these ideal conditions, settlements grew and then were attacked, conquered, destroyed, or simply abandoned. New peoples arrived and built their own cities on this site using materials such as foundations, building stones, fortifications, and walls from the previous occupiers. In this way tells were gradually built up over the centuries. Megiddo, for example, has approximately twenty identifiable occupation levels (“strata”) spanning more than six millennia (7,000 to 500 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Excavations focused on tells are more easily funded because these mounds tend to yield the artifacts and architecture that encourage further donations. Recently, however, the focus on tell archeology has come under fire by such archeologists as Carol Meyers, who argues that tells represented the world of rich and urban dwellers, roughly 10 percent of the population (1988: 24–46). Therefore, the material culture of those in rural areas, who made up the majority of the people in the region, was often ignored. Moreover, tells were predominantly occupied by monarchs and other political heavyweights who made up the male elite. This focus on military prowess and political structures often leads archeologists to conclude erroneously that men were the only major agents in the ancient world (Meyers 1997: 274–76). To remedy such tunnel vision, archeologists are supplementing tells with regional surveys, settlement patterns, comparative site analysis, and a focus on agrarian domestic rather than monumental urban settlements.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("How to Pick a Site")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Since tells are large areas, archeologists employ both science and art to determine where to place the first pickax. As a scientist, an archeologist does some of the following: incorporates the discoveries from the survey and begins where the largest concentration of pottery and evidence of architecture exists, examines aerial photographs including infrared and satellite imagery that may reveal architecture and other areas of interest not easily detected by the naked eye, or employs comparative site analysis. For instance, city gates are traditionally located on the east side of the tell, usually facing a road or a water source, whereas dumps are almost always located downwind and lower on the mound. Yet most archeologists, perhaps from years of experience, tend to rely on their gut instinct and know just where to dig.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Site Preparation")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Most preparation is done in the weeks and months prior to the excavation. For example, funds must be secured, the professional staff must be assembled, and logistics, such as living quarters and an educational program, must be planned. The team usually consists of some or all of the following: a botanist, a paleobotanist, ceramicists, a bone expert, a surveyor, a draftsperson, an architect, a photographer, an epigrapher, a small finds expert, a registrar (to record artifacts), a team member coordinator, a computer expert, a physicist, a chemist, an art historian, historians, biblical scholars, geologists, and social scientists. All of these staff members work interdisciplinarily to arrive at more accurate results.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("When the excavation site is located, one of the first steps is to map out the site and establish a grid on the surface (X and Y coordinates to mark geographic location). Prior to the excavation, surveyors prepare topographical maps that show elevation contours and divide the tell into fields or areas that are given alpha or numeric designations. Areas are separated into squares, most commonly five meters by five meters, that are numbered on an X Y axis. Archeologists determine how many squares are dug in any given area based on the personnel, seasonal goals, and other factors that enter in for them.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Hitting the Dirt")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("While the media tend to paint a romantic picture of the archeologist who goes to a site and sweeps great artifacts off the floor as the enemy attacks (Indiana Jones and Laura Croft come to mind!), the real work is a little more taxing. Archeologists and their team members move piles of dirt, often with little to elicit excitement. Common tools for such endeavors are pickaxes, to break up larger amounts of dirt, hoes to scrape it up, and buckets to haul the dirt away. Smaller tools—small pickaxes trowels, brushes, dustpans, and dental tools—are used to excavate and define installations (e.g., walls, buildings, ovens, floors, skeletons). Sifters are used to uncover small artifacts, such as beads, scarabs, and seeds.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("The very act of digging a site destroys it for future generations. Therefore, archeologists take great pains to record every detail in order that any archeologist can reconstruct the original mound. For example, each area supervisor has a map of the dig area with the grid superimposed on it that will serve as the initial top plan, a daily schematic diagram drawn to scale (anywhere between 1:25 to 1:100) that records the architecture and artifacts unearthed. To measure the location of artifacts, architecture, and how much dirt was removed, precise measurements must be taken and recorded based on a predetermined ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("specific coordinate, the benchmark, which will serve as a point of reference from which all future coordinates will be measured. The top plan records the exact location of architecture, artifacts, and pottery baskets, serving as a visual daily diary for any archeologist to reconstruct the site.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("As archeologists excavate vertically in a particular area or square, an artificial wall, called a baulk/balk, is left around the perimeter of the square. The balk is one of the most crucial tools for archeological interpretation because it keeps track of finds by providing a visual record of the strata, which are the discernible layers of occupation. The analysis of the sequence of strata in the formation of the tell is called stratigraphy. The tell’s stratigraphy is recorded in the face of the balk, also known as a section. This section is measured precisely, both horizontally and vertically, and is carefully photographed and drawn to show all significant features, such as changes in dirt texture and color. The earliest biblical excavators practiced a wide-scale exposure technique in which they dug horizontally across large areas of the tell. One major drawback of this technique was that all evidence of the different strata disappeared, leaving no point of reference. Consequently, Kathleen Kenyon developed a new method that incorporated the wide-scale technique (horizontal) that allowed architecture to be exposed, juxtaposed with the balk technique (vertical) that preserved the stratigraphy. This method, known as the Wheeler-Kenyon method, takes its name from Kenyon and her mentor, Mortimer Wheeler, and is the method of choice for most Syro-Palestinian archeologists.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Each square has at least one locus. A locus is an arbitrary working area defined by some noticeable change of soil, features (walls, architecture, ovens), or any unit that the archeologist wishes to isolate from the larger square in order to determine whether it is a new stratum. Information in each locus is individually tracked and recorded as each locus receives its own pottery bucket and artifact record. It is not unusual to have four or five loci open simultaneously in any given square because it is easier, when information is being interpreted, to combine the information of the various loci than to try to separate one locus into several components (or occupation levels). Each pottery bucket has a tag that notes the area, square, locus, date, and bucket number for the pottery. Each bucket also contains a ventilated bag for bones, another for flint, and one for seeds, and a piece of foil to wrap charcoal. All information on the tag is also recorded in the registrar’s notebook or palm pilot to be entered into the archeologist’s data base.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The most common artifact found is a potsherd. A potsherd is a broken piece of pottery that can tell archeologists a good deal about a site. As Petrie and Albright showed us, pottery is one of the most useful finds in archeology. Found in the poorest of homes as well as in the richest of palaces and temple, its use in ancient Israel was commonplace and indispensable. Although pottery vessels are themselves fragile and easily broken, the hardened clay out of which they are made does not deteriorate and so can endure for thousands of years. Probably the most important use of pottery, however, is in dating the stratum with which it is associated. This is so because articles made of pottery, like oil lamps, have very distinct sizes, shapes, and decorations, which can be closely related to specific time periods. These subtle changes have now been charted for pottery as early as the Neolithic Period (6,000 to 5,000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("). Archeologists are able to determine simply from looking at the broken sherds from which time period they arise. Pottery reading and reconstruction is analogous to putting together a complicated jigsaw puzzle—at first all the tiny pieces look identical, but eventually one is able to distinguish color patterns, shapes, and forms from the different fragments. Though this task is not as simplistic as a jigsaw puzzle, ceramic experts do have basic criteria for analyzing sherds.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The form and function of a vessel is one of its first differentiating features; a cooking pot looks different from an oil lamp, for example. The pieces of the sherd are shaped differently. Other forms, such as jugs, vessels, chalices, pitchers, storage jars, plates, and vessels for storing oil, are all found in sites. Once the form of the pottery is determined, the variants are noted. Decoration on pottery also varies with time. During some periods the pottery was burnished or painted; in other periods decoration was completely lacking. Painting can also reveal cultural differences; for instance, Philistine pottery is often decorated with red-and-black paint, spirals, and other unique designs. How the pottery was manufactured is also a significant feature in dating. In the early periods pottery was handmade; later the potter’s wheel was used. Differences in material, types of clay, and firing techniques can reveal much about the period and location in which it was manufactured.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Other artifacts and features discovered on a typical dig are grinding stones, loom weights, tools, jewelry, flint, bones (mostly animal), and cultic objects. These finds help to illuminate these ancient cultures by offering clues as to how the ancients created textiles, prepared food, ate, used weapons, and so on. Architectural remains shed light on the economic, religious, and political systems that existed. If an artifact is significant (like a seal, cymbals, tablets, and so forth), a photograph and a drawing may be made of the find "), _c('i', [_vm._v("in situ")]), _vm._v(" (in its pre-removal state). However, for most artifacts simple measurements will suffice. After measuring the location, the level (height) of the artifact is taken using a transit and meter stick. Each layer, find, feature, and artifact is given a level number.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("Relationship between Archeology and Biblical Studies")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Though archeology and biblical studies are two separate disciplines, to some degree they rely on each other. Archeology can illuminate the culture and historical setting of the world of ancient Israel. It can also give us information about the cultural, geographic, and material setting in which the stories of the Bible were written down and recorded and help us understand the environment and the life settings of these stories. Archeology provides the background of the biblical world. In other ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("words, archeology can shed light on the material culture of ancient Israel as well as on the events described in the Bible.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Archeological finds and artifacts cannot be understood in isolation. Like many other scientific disciplines, archeology must work in tandem with other disciplines such as history, chemistry, botany, geology, anthropology, epigraphy, and biblical studies to develop the fullest picture of the ancient world. Though most modern archeologists will not use the Bible as a guide as often was the case in earlier expeditions, the biblical text can provide helpful information. The Bible, therefore, can act as a cultural artifact in conjunction with archeology to illuminate both disciplines.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("Archeological Finds and the Bible")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Many artifacts relating to the Bible have come from Mesopotamian archeology. Early Mesopotamian archeologists such as T. Botta (1842) and A. Laynard identified and excavated Nineveh, one of the capital cities of the ancient Assyrian Empire, unearthing over twenty thousand cuneiform tablets from the library of Assyrian king Ashurbanipal. Other Mesopotamian sites were subsequently excavated, revealing elaborate palaces and temples laden with carved monuments, reliefs, and numerous statues. Since many of the Mesopotamian cities were known previously only from the biblical texts, public and scholarly interest in the excavations of Mesopotamia fueled. The decipherment of cuneiform texts generated the most attention. When one of the cuneiform tablets from Nineveh contained an account of a flood similar to that of Genesis 6–9, even greater public interest was aroused. Leonard Woolley (1929) later claimed to have found evidence of the flood at Ur in southern Mesopotamia. Excavations throughout the ancient Near East at cities such as Mari, Nuzi, and Ebla also produced tablets that illuminated customs and traditions in the biblical ancestral period. The Code of Hammurapi, an eight-foot black diorite stele from eighteenth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", records 282 case laws that often parallel the biblical laws. Annals and victory stelae from Assyrian and Babylonian kings Shalmaneser III, Sennacherib, Nebuchadrezzar, and Nabonidus mention various Israelite kings and biblical events. Despite the fervor to “prove the Bible” among many early Mesopotamian archeological expeditions, the discovery of the artifacts and cuneiform texts has proved a valuable source in biblical studies.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Similar royal dedicatory inscriptions have been found in the Transjordan. The Moabite stele of King Mesha (c. 850 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("), a thirty-four-line inscription, honors the Moabite deity Chemosh and commemorates the king’s victory over the Israelite king. In 1994 excavators at Tell Dan in northern Israel discovered an inscribed basalt stele that has generated controversy among archeologists and biblical scholars. One line of the thirteen-line Aramaic inscription reads “btdvd.” If read as “the house of David,” the Tell Dan stele could be the earliest extrabiblical evidence of the mention of King David. Scholars, however, debate this translation. Some other significant finds are the Gezer Calendar, a small limestone tablet dated to approximately 925 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" that gives an early picture of agricultural practices in ancient Israel. The Lachish ostraca, discovered in the 1930s, are a collection of twenty-one letters written on pottery sherds that record correspondence between military commanders. These letters were written just before the city of Lachish fell to the Babylonians (c. 588 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("). Many important archeological finds relating to the Bible have been discovered accidentally. The Dead Sea Scrolls, found by a bedouin in 1947 outside of Qumran on the Dead Sea, have produced the oldest copies of most of the texts of the Hebrew Bible, as well as valuable documents that reveal societal concerns and structures of first-century Palestine and early Judaism.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Dever, W. 2001, "), _c('i', [_vm._v("What Did the Biblical Writers Know and When Did They Know It?")]), _vm._v(" Grand Rapids: Eerdmans • Dever, W. 2003, “Whatchamacallit: Why It’s So Hard to Name Our Field,” "), _c('i', [_vm._v("BAR")]), _vm._v(" 29/4: 56–61 • Meyers, C. 1988, "), _c('i', [_vm._v("Discovering Eve: Ancient Israelite Women in Context")]), _vm._v(", New York: Oxford University • Meyers, C. 1997, “Recovering Objects, Re-Visioning Subjects: Archaeology and Feminist Biblical Study,” in "), _c('i', [_vm._v("Reading the Bible: Approaches, Methods, and Strategies")]), _vm._v(", ed. A. Brenner and C. Fontaine, Sheffield: Sheffield Academic, 270–84 • Gilchrist, R. 1999, “Gender Archaeology: Contesting the Past,” London: Routledge • Kapitan, T., ed. 1999, "), _c('i', [_vm._v("Archaeology, History and Culture in Palestine and the Near East")]), _vm._v(", Atlanta: Scholars.")])])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT",
    attrs: {
      "id": "ch004"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-004"
    }
  }, [_c('i', [_vm._v("The Pentateuch")])])]), _vm._v(" "), _c('p', {
    staticClass: "CA"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-004"
    }
  }, [_vm._v("David Noel Freedman")])]), _vm._v(" "), _c('p', {
    staticClass: "H1a"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The Pentateuch, also known as the Torah or Five Books of Moses, constitutes the first and most important division of the Hebrew Bible (Old Testament). It holds pride of place in the Jewish canon, and was regarded as having the highest authority, higher even than that of the Prophets and the Writings, since it was traditionally thought to be the work of Moses, who alone of the biblical heroes spoke with God face-to-face (cf. Exod 33:11; Deut 34:10–12).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Pentateuch itself is the first part of a larger literary complex which we may designate the Primary History. This comprises the books from Genesis through 2 Kings but omits Ruth (which in the Hebrew Bible is to be found among the Writings). The Primary History recounts the story of Israel in the context of the total human experience from the beginning (i.e., creation) to the collapse of the kingdom of Judah and the Babylonian exile. It is to be distinguished from the Chronicler’s history (1 and 2 Chronicles-Ezra-Nehemiah), which, while covering the same general subject matter, omits most of the earlier narratives and focuses on the kingdom of David and Solomon and their successors. It continues down to the Persian period and the reconstitution of the Jewish community under the leadership of Ezra and Nehemiah. It is apparent from an examination of the two histories that they not only reflect drastically different points of view but are also products of vastly different periods in Israel’s history. The inconclusive endings point toward a date of composition shortly after the events with which the story closes (i.e., before the next significant occurrence). Thus it is difficult to suppose that the return from Babylon would not have been mentioned had the Primary History been completed subsequent to that momentous event. By contrast, the Chronicler’s account includes this datum and brings the narrative down to the reforms of Ezra and Nehemiah (late fifth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("). Since his story ends at this point somewhat inconclusively, it is a reasonable inference that the Chronicler’s history was compiled about this time, or in any case not later than the early fourth century.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("Composition")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The date of composition of the Primary History may be fixed by the final entry in 2 Kings, itself a footnote to the story of the fall of Jerusalem and the exile. This note refers to the favor shown the shadow-king Jehoiachin by Evil-merodach, the Babylonian emperor, in the year 561 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". Since the death of Jehoiachin is hinted at in these verses (2 Kgs 25:29–30), we may date the work of the editor (RPH) in the decade following. By 550 the Primary History in substantially its present form was completed.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The compilation of this sacred history was itself a remarkable achievement. It reflected the determination of the exilic community to remain alive and to retain its identity as the people of God in spite of a series of catastrophic blows culminating in the loss of king and land, temple and priesthood. Nor could they minimize the significance of the disaster by attributing it to a hostile fate, or the changing fortunes of war, or the superiority of alien gods or peoples; rather, it was a deliberate act of judgment by their own God, the covenant God of Israel, who was Lord of heaven and earth and the disposer of the affairs of men. Soberly the exiles reviewed their history in order to discern the meaning of their fate: What had happened between God and his people in the past, from the start? How had they come to their present unhappy state, and what, if anything, might the future hold for them? They could delineate throughout the course of history a consistent pattern of divine grace and favor: a special commitment by God to Abraham and his descendants, fulfilled in the mighty deeds of exodus and conquest surrounding the covenant-making mystery of Sinai, wherein God had declared Israel to be his people and they had claimed him as their God. Successive generations saw the unfolding of this relationship of promise and demand, of grace and obligation, of hope and threat, through the tumultuous period of the judges until it reached fruition in the kingdom of David and Solomon. At the same time the unity and cohesion of the nation were flawed by disobedience to the terms of the covenant and defiance of the will of God, so that the state divided under pressure from within and finally collapsed in ruins from the attacks of foreigners. Thus had a singularly blessed, but persistently sinful, people reaped an inevitable judgment. Nevertheless, the end was not the end. Before and beyond the law of sin and death, there was an unconditional commitment and an eternal relationship of love (cf. Jer 31:3). The God who had summoned Abraham from the east would call his seed to a new pilgrimage westward. And the God who had saved his people from Pharaoh would deliver them again from bondage. Out of the momentous past, and in view of the present agony, the serious student could read sobering lessons for himself and his people. This history was not only a record of what had happened but also words of life and hope for today and tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Here was Israel’s legacy to Israel: the remains of the old age and a foundation for the new. Old Israel perished "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("in the furnace of exile, but a new Israel was to emerge. The authoritative guide of postexilic Judaism was the Pentateuch. The division of the Primary History into Pentateuch and Former Prophets (Joshua–2 Kings) was occasioned by the needs and insights of the postexilic community: the law of Moses and the social and cultic pattern of the wilderness society were to be normative for the Persian province of Judea. It may well have been Ezra who permanently fixed the authority of the Pentateuch in the Jewish community, although the books themselves had long since been written. There can be little doubt as to the relative antiquity of the text of the Pentateuch (and the Former Prophets) as compared with the other books of the HB. Not only do we have distinct recensions—for example, the Masoretic Text (MT), the Greek Septuagint (LXX), the Samaritan Pentateuch (Sam)—but also a long, traceable history of textual transmission. The Hebrew source of the LXX text goes back at least to the third century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", and almost certainly to the fourth, while the Samaritan is almost as old. The MT, on the other hand, may be even older. All three are represented in ancient manuscripts from Qumran.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("If the Pentateuch was a finished product by the fifth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" (probably it was already complete in the sixth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", as part of the Primary History), is it possible to trace the earlier history of this great work and the sources which contributed to its compilation? Such questions have exercised the minds of biblical scholars for hundreds of years, and the results of their inquiries have varied considerably. While there is as yet no consensus, and the “assured results” of critical analysis are no longer so sure, certain conclusions may be regarded as highly probable, and others as likely. The documentary hypothesis, commonly associated with the name of Julius Wellhausen but actually the product of the labor of many eminent biblical scholars of the past two hundred years, remains the point of departure for the scientific study of the Pentateuch. Its minute source analysis, which was one of the crowning achievements of nineteeth-century biblical criticism, grew out of repeated efforts to deal with the difficulties apparent in the received text. Inconsistencies in content, duplicate or parallel narratives, and significant variations in diction and style militated against the traditional view of unity of authorship. Obvious anachronisms and shifts in the historical and geographical perspective likewise indicated that a Mosaic date for the composition of the Pentateuch was untenable.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In its standard form the documentary hypothesis rested on arguments of two kinds: those based on literary and linguistic evidence, which resulted in the division of the Pentateuchal material into various written sources; and those based on historical evidence for the evolution of religious institutions and ideas in Israel, which produced an analytical description of the interrelationships among the documents and a chronological arrangement to account for them. Literary investigation isolated four primary written sources: J, E, D, and P. D was the simplest to identify since it stands out as a literary unit (i.e., the bulk of the book of Deuteronomy—hence the designation D), with a distinctive style and viewpoint. The separation of P (for “Priestly document”) from the remaining narrative material was also a comparatively routine undertaking, and scholars have achieved practical unanimity in defining the contents of this work. It consists chiefly of archival and institutional data spread out on an elaborate genealogical framework. What remains is the general narrative, itself manifestly composite. Thus the separation of the two creation stories in Genesis (1:1–2:4a; 2:4b–5) and the assignment of the former, with its schematized and formulaic pattern, to P and the latter to the narrative source (in this case J) are easily seen. On the other hand, the disentanglement of the narrative strands has proved much more difficult. The Joseph story (Genesis 37; 39–50) is clearly composite. In the episode describing the brothers’ treachery against Joseph (37:12–36), there are two accounts of what happened, which have been blended into confusion. In one, Joseph was thrown into a pit and left there to die. He was found by Midianites, brought to Egypt, and sold there. In the other, he was sold to a passing band of Ishmaelites. Reuben figures prominently as the intercessor for Joseph in one, Judah in the other. Only such a separation offers an intelligible account of the episode.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Two principal narrative sources were identified: J (so-called because of its standard use of the name Jehovah [YHWH] for God; it has also been associated with the Southern Kingdom, Judah) and E (because of its use of Elohim for God, though with less consistency beyond the book of Genesis; it has been connected with the Northern Kingdom, Ephraim). The details of the division are not nearly so certain as in the case of D and P; in many passages where J and E have been fused, the analysis is disputed (e.g., Exodus 32–34). Sometime before they were integrated into the Primary History, J and E were combined into a single narrative (J﻿﻿E).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("D was the starting point in the determination of the chronological relationships of the sources among themselves and with respect to the history of Israel. D was identified with the law code discovered in the Jerusalem temple in the eighteenth year of Josiah (622 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("); its composition has generally been dated in the seventh century. With regard both to narrative and to legal material, D proved to be later than and dependent upon J﻿﻿E; J﻿﻿E therefore belonged to the monarchic period (tenth-eighth centuries). More precise examination of J﻿﻿E established the priority of J tenth-ninth centuries perhaps) over E (ninth-eighth centuries). This decision was based in part on the opinion that J was more primitive in his theology (i.e., grossly anthropomorphic), but more exuberant and naive in his storytelling. E, on the other hand, was more subtle and sophisticated, and therefore of a later date. Traditionally D has been considered independent of and prior to P, and many still assign P to the exilic period or later. However, a growing number of scholars are arguing for a preexilic P, its earliest editions coming even before D.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("The major conclusions of the documentary hypothesis with regard to source analysis and the relative dating of the documents stand fairly firm. Some of the premises are less certain, particularly the theory of a simple evolutionary development of Israel’s religious institutions and ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("ideas. And the details of the analysis are open to question in a number of instances. In addition, important new areas of interest have been opened up in the continuing quest for knowledge about the Pentateuch. (See the bibliography.)")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("A synthesis of what appear to be the soundest insights of scholars who have worked and are now working in the field follows:")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("J and E")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("J and E, the familiar narrative sources of classic Pentateuchal analysis, are prose compositions, probably derived from older oral and written sources, but with a significant amount of original material as well. In the Tetrateuch at least, J and E follow the same basic pattern and order of events, and thus presuppose a common source. At the same time they are distinct compositions, with diverging concerns and attitudes, and they differ strikingly in numerous details. On the basis of a minute analysis of these sources, as far as they can be extricated from the Hexateuch, scholars have concluded that J has a southern orientation, as against E, which is northern; that J is concerned with David as king and with his dynasty, while E has marked affinities with and interest in the prophetic movement, especially as it was related to political developments in the north. In general, J has been regarded as a product of the United Monarchy (c. tenth century), and E of the Northern Kingdom (c. ninth-eighth centuries). Subsequent editions (e.g., J﻿"), _c('sub', [_vm._v("2")]), _vm._v(" and E﻿"), _c('sub', [_vm._v("2")]), _vm._v(") would be dated still later.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The distinctive historical character of Israel’s religion made it inevitable that the story would be rewritten repeatedly so as to include the most recent events which resulted from Yahweh’s dealings with his people. Unlike pagan myth, which was timeless and self-completing, and which required only to be rehearsed and reenacted in the cult, Israelite traditions could not finally be contained in this fashion; and reenactment did not exhaust the historical significance or future possibilities of the tradition. In like manner the pagan epic was a self-enclosed entity describing a distinct era of the past: the age of the heroes and their great deeds. But Israel, even with an “epic” tradition, could not simply look back to the glorious past, but was concerned with the continuing actions of God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("While scholarly agreement on the scope of J and E has never been reached, and end points for both have been fixed all the way from the end of Numbers on into Samuel and Kings, it is likely that the end point is determined roughly by the date of the writer. The interpretation herein adheres to the common, if somewhat conservative, view that J dates from the United Monarchy (i.e., tenth century), and that E is northern and is to be dated in the late ninth or early eighth century. This means that both J and E are not simply prose abstracts of an earlier tradition, but rather separate historical accounts based on that tradition, carrying the story beyond its original limits to their own time. Thus J finds the complete fulfillment of the promise to the fathers not in the original settlement under Joshua but in the conquests and kingdom of David. Without attempting to pin down precisely the J material in Judges and Samuel, one may nevertheless point to the two sources of 1 Samuel and identify the earlier, pro-monarchy source with J. The transference of the Abrahamic covenant (Genesis 15—and old tradition) to David and his house (2 Samuel 7) is also to be attributed to J. Whether J extends beyond this point is debatable (the so-called Court History—2 Samuel 9–20; 1 Kings 1–2—may or may not be a separate source); its possible ending, which would put it in the reign of Solomon, could be 1 Kgs 4:20–21 (Heb. 4:20–5:1): “Judah and Israel were as many as the sand by the sea; they ate and drank and were happy. Solomon ruled over all the kingdoms from the Euphrates to the land of the Philistines and to the border of Egypt; they brought tribute and served Solomon all the days of his life.” Subsequent editions of J may well have carried further the story of the fortunes of the house of David and the kingdom of Judah.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("E is more difficult to fix as to date and extent. On the basis of a northern provenience and demonstrable interest in the prophetic movement, E may be regarded as a product of the religious enthusiasm stimulated by Elijah and Elisha, and his work may be placed in the age of Jehu and his successors (c. 842–745 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("). A clue to the character of E may be found in the evaluation of Jehu’s revolution in 2 Kgs 10:28, 30: “Thus Jehu wiped out Baal from Israel.… And the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" said to Jehu, ‘Because you have done well in carrying out what is right in my eyes, and have done to the house of Ahab according to all that was in my heart, your sons of the fourth generation shall sit on the throne of Israel.’ ” This material is embedded in a typically hostile Deuteronomic estimate of the same king (vv. 29, 31) and must therefore derive from a different, and sympathetic, northern source. The reference to the descendants of Jehu to the fourth generation would bring us down to Jeroboam II, whose dominion might be regarded more suitably as a fulfillment both of promise and of prophecy. The assertion that Jeroboam’s victories were achieved as fulfillment of the word of the prophet (Jonah son of Amittai) is particularly instructive: “He restored the border of Israel from the entrance of Hamath as far as the Sea of the Arabah, according to the word of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", the God of Israel, which he spoke by his servant Jonah the son of Amittai, the prophet” (2 Kgs 14:25). E reconstructed the story of Israel in the light of the prophetic movement, beginning with Abraham, anachronistically described (by E) as a prophet and similarly identifying Miriam, Deborah(?), Samuel, and other ancient figures by the same term. If we remove the Deuteronomic framework and commentary, what remains of Kings (through 2 Kings 14, essentially E) is predominantly the story of the prophets and their impact on the history of the Northern Kingdom; for it was the prophets who were the successors to the judges and the Northern Kingdom which inherited the traditions of the tribal league and its cult center. Thus E was the defender of the older tradition against the claims of the Davidic dynasty. It may be concluded that E was composed in the eighth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", in the north, and represented an attempt, in the prophetic tradition, to relate the ancient traditions to the history of the Northern Kingdom and to establish ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("the latter’s claim to be the true successor and heir of “all Israel.”")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("J﻿﻿E is the product of a literary merger. At some time after the completion of J and E as separate entities, they were blended into a continuous narrative by an editor or redactor, RJE. Analysis of the surviving material in the Pentateuch indicates that the editor used a variety of methods in weaving the narratives together. First, the dominant strand is clearly J, which, in fact, formed the basic narrative. E has actually been broken up and inserted piecemeal into the overall structure of J. On occasion there are parallel accounts (J and E) of the same episode; sometimes one version has been suppressed in favor of the other (where apparently they were practically identical); elsewhere they have been woven together into a single narrative. On the face of it, J﻿﻿E is the work of a southern (Judahite or Jerusalemite) editor whose object was to preserve the traditions of the north and to harmonize them with the J narrative to form a single composite history of the people of God. The logical occasion for this work would have been the destruction of Samaria and the collapse of the Northern Kingdom (722–721 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("). Its purpose was to win the surviving population of Ephraim to allegiance to the temple in Jerusalem and the Davidic king of Judah. Since this was the announced policy of Hezekiah, according to the account in 2 Chr 30:1–31:1, in which a determined effort was made to establish Jerusalem as the center of worship for northerners as well as southerners, we may plausibly connect the compilation of J﻿﻿E with the movement toward religious reunion initiated by Hezekiah. We may date R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("JE")]), _vm._v(" in the early seventh century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" and hold that his work included the major part of J and selected material from E, and closed with the reformation of Hezekiah and the attempt to unite “all Israel” in the worship at Jerusalem.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("D and DH")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The next major subdivision in the classic analysis of the Pentateuch is D, identified with the document found in the temple in the eighteenth year of Josiah (622 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") and corresponding roughly to the present book of Deuteronomy (perhaps chs. 5–26; 28). Scholars have been divided on the questions of the date of composition and provenience of this document, though there is increasing agreement that D, like E, has northern affinities, and that it was composed during the century preceding its discovery. Its nucleus is a legal corpus, preserving many ancient laws and customs derived from the days of the confederation (e.g., the law of holy war) and reflecting the traditions of the cult center at Shechem and its priesthood. In their present form, chs. 5–26; 28 constitute a series of warnings and exhortations uttered by Moses just before his death. A date of composition in the reign of Hezekiah or later is practically required by the emphasis on centralization of worship in a single sanctuary, presumably the temple at Jerusalem. The tradition of the central sanctuary is very old, going back to the premonarchic period. But the principle of exclusiveness—that is, the single, central sanctuary—is new. It reflects the circumstances of Hezekiah’s time: the fall of the Northern Kingdom and the emergence of the Jerusalem temple as the only “independent” cult center. The temple at Bethel apparently survived, but it was under constant attack from the south as heterodox and had suffered considerable loss of prestige with the fall of Samaria. It was finally wrecked by Josiah (cf. 2 Kgs 23:15ff.). Furthermore, the sermonic addresses anticipate or more probably presuppose the destruction of the Northern Kingdom and the captivity of its inhabitants, thus pointing likewise to a date c. 700. A date in the reign of Manasseh is also possible but less likely, while the idea that D was composed in the reign of Josiah and deliberately planted in the temple in order to be discovered there may be dismissed as a fantasy.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The principal concern of D is the Horeb (Sinai) covenant and its significance for the life of Israel. The covenant is a guarantee of life to those who obey its stipulations (the Ten Commandments and subsequent legislation), but for those who forget, ignore, or defy its demands there is certain disaster. Placed in the mouth of Moses, these sermons are not only a reminder of the solemn bond between God and Israel—an explanation of the requirements of the covenant, with its promise of security and threat of destruction—but also a prophetic anticipation of the culmination of Israel’s history. For D, Moses is the true prophet (18:15ff.; cf. 34:9–10, which is secondary), who, long before the great prophets of more recent times, foresaw the threatened catastrophe of military invasion and conquest, intensified by that peculiarly inhuman practice of mass deportation. The only hope of Israel, or what survived of it, lay in strict adherence to the covenant obligations beginning with the first commandment, which requires the exclusive worship of Yahweh, and which, on the Deuteronomist’s reasoning, restricts worship to the one place he has chosen for his name.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The effect on Josiah and Judah of the discovery of D in the temple is familiar to all. The great reformation of national life and religion is described in detail in 2 Kgs 22:3–23:25 (cf. 2 Chr 34:8–35:19). The so-called Deuteronomic History (DH) probably owes its inspiration and composition to the reformation stimulated by the discovery of D. It is a single work including the books from Deuteronomy through 2 Kings. Beginning with the Mosaic sermons (to which he has prefixed an introduction, Deuteronomy 1–4), the Deuteronomic Historian has traced the Horeb covenant through the history of Israel, interpreting it in the light of the covenant requirements and evaluating kings and people according to their adherence or defiance of them. He has incorporated much older material practically untouched, while providing for the whole a chronological and theological framework. Thus in the book of Judges he has organized chronologically and classified theologically a heterogeneous group of ancient heroes and the folk tales handed down about them. In the books of Kings he has inserted from the official court records the necessary chronological data of accessions, reigns, deaths, and successions; he has also interspersed a theological commentary grading each king in relation to his good or evil deeds.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("It used to be thought that the Deuteronomic History was compiled during the exile (i.e., after the last date in 2 Kings), but more recently scholars have argued cogently ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("that the first edition of this work was issued earlier, during the reign of Josiah. Clearly the description of the Josianic reform in 2 Kings 22–23 is the climax of this history, while what follows is a melancholy epilogue. Note especially the fulfillment of the prophecy concerning Bethel (from 1 Kgs 13:1–3) in 2 Kgs 23:15–18, with particular reference to the name of Josiah (which is anticipated in the prophecy), and the conclusion in 23:25: “Before him there was no king like him, who turned to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" with all his heart and with all his soul and with all his might, according to all the law of Moses; nor did any like him arise after him.” This, together with the formal summary of his reign in v. 28, looks like the original ending of the historical work. It is interesting that the notice of his defeat and death at Megiddo follows the summary.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The Deuteronomic Historian was inspired by the conviction that Josiah was the long-awaited scion of David, who in his work and life would fulfill the ideals of kingship, restore the empire of his illustrious ancestor, and lead his people to renewal of life in obedience to the terms of the ancient Mosaic covenant. The entire history aims at this conclusion, the happy climax of the biblical story. At the same time the Deuteronomic discourses of Moses and the disastrous experience of the Northern Kingdom served as a warning of another denouement, so that the catastrophe which actually ensued was not entirely unprepared. All along there had been two possibilities. With the tragic death of Josiah, it became clearer which alternative was the more likely. It is probable that the Deuteronomic History originally ended with the successful reformation of Josiah, and was subsequently revised to accord with the somber facts of history (cf. the pathetic attempt at reinterpretation, 2 Kgs 23:26: “Still the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" did not turn from the fierceness of his great wrath, by which his anger was kindled against Judah, because of all the provocations with which Manasseh had provoked him”).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Concerning the scope of DH, the question must be raised whether Deuteronomy 1 actually constitutes the beginning. In other words, does Deuteronomy 1–4 serve simply as an introduction to DH, or is it rather a bridge between the narrative of the Tetrateuch (J﻿﻿E) and DH? When it is remembered that D is explicitly attributed to Moses, then the necessity for placing these addresses in the context of the J﻿﻿E narrative becomes clear. Unless J﻿﻿E is to be cut off at the end of Numbers plus a few verses on the death of Moses, it is not possible to argue that DH is an entirely independent work. Not only does such a view leave J﻿﻿E a hopeless torso in the Tetrateuch, but it offers no explanation for the beginning of DH in the fortieth year of the wanderings. If, in the course of D, Moses actually reviewed the previous sequence of mighty deeds, then we could recognize here an imitation of epic style. But there is specific recapitulation only as far back as the Horeb (Sinai) experience, while the antecedent history is dealt with in the vaguest possible way. In short, J﻿﻿E is assumed because it was attached. If J and E actually carried the story down into the period of the monarchy, then DH must have used them, as he used D and other sources. And if he made use of J﻿﻿E for the post-Mosaic period, he could hardly have dismissed or ignored it in the pre-Mosaic and Mosaic eras.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is likely, therefore, that DH compiled his history along the same lines as J and E (or J﻿﻿E, which is presumably all that was available to him)—that is, he began with Genesis and carried the story down to the reign and reformation of Josiah. However, the fulcrum of his account was the major prophetic exhortations of Moses, the new document, D, found in the temple. DH had little or nothing to add to the J﻿﻿E narrative in the Tetrateuch, though there may be traces of his work there. His creative enterprise begins with Deuteronomy 1–4, which constitutes an introduction to the history which follows but also serves as a bridge connecting it with what has gone before. It is clear that DH did not think that Israelite history began with Moses, whatever may be the opinion of scholars since Wellhausen.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("We conclude that the Deuteronomic History was originally composed before the fall of Jerusalem, and that it consisted of J﻿﻿E and D, plus other materials of a narrative and archival nature, covering the period from creation down to the reign and reformation of Josiah.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("P")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("It remains to deal with P, the last of the sources identified in classic Pentateuchal analysis. P consists mainly of archival data of different kinds: genealogical tables, tribal lists, including a pair of census tabulations, and priestly data and regulations—concerning, for example, the tabernacle, the priesthood, sacrifices, and questions of clean and unclean. Embedded in P are also legal prescriptions which form part of the complex legal corpus of the Pentateuch (e.g., the Book of the Covenant and Exodus 34, usually associated with J﻿﻿E; the law code in D; and H, the so-called Holiness Code of Leviticus 17–26). The principal questions concerning P are: (a) Is P an independent source, or is it merely supplemental to J﻿﻿E in the Hexateuch (or Tetrateuch)? Put another way, is P himself the compiler of the Pentateuch, incorporating into the narrative such archival data as seemed desirable? (b) What is the extent of P? It is generally agreed that P is to be found in the books through Numbers, and not in Deuteronomy (except for a couple of verses). But what about Joshua?")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("The two questions are linked, and the answer given to one will influence one’s view of the other. It would seem that the meticulous analysis of earlier scholars and their conclusions concerning the nature of P have not been overthrown by more recent advocates. It still appears that the case for P as an independent source is stronger than the case against it. If P was a self-contained entity, what were its character and scope? That P in Exodus-Numbers is primarily concerned to fix in detail the cultic practice of the wilderness encampment and to establish it as a permanent norm for Israel through the unquestioned authority of Moses is clear. Here there is essentially a static treatment of ancient materials, with a concern, not, as in the older sources, for the movement of God in history, but for the original pattern of worship, which is binding forever. The particular historical event has partly given way to the timeless and unchangeable pattern of heavenly things. If P were limited to Exodus–Numbers, ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("then the question of its independent status would not figure seriously, and its incorporation into the narrative as essentially supplementary data would be understandable. But the presence of P in Genesis, where it provides the chronological framework and some narrative details, suggests a broader, at least partly historical, concern. If this is true, and it can hardly be doubted, then we must recognize in P the old traditions present in the other historical works and preserved in the festivals which are a principal interest of P. P’s interest in the patriarchs, however, requires a corresponding concern with the settlement in the promised land. While Moses and the pattern of life and worship in the wilderness are central to P, the prelude in Genesis can be balanced only by the fulfillment in Numbers and Joshua; but it is only in Joshua that the specific expectations of P in the patriarchal narratives are fulfilled. In no way can Moses and the wanderings or even Sinai be regarded as the resolution of patriarchal anticipation. The divine promise can be realized only in the occupation of the land (which is explicitly not Transjordan and for P does not even include it). Therefore, if P is an independent source, and is found in Genesis as well as in Exodus–Numbers, then we should expect to find it in Joshua also.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("It is probable that P was incorporated by the final redactor (R"), _c('sub', [_vm._v("PH")]), _vm._v(") into the so-called Deuteronomic History (including J﻿﻿E, as already pointed out) during the exile. Apparently R"), _c('sub', [_vm._v("PH")]), _vm._v(" added the final reference to Jehoiachin, and this points to the completion of the work in the decade 560–550 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". Thus by the middle of the sixth century the Primary History was complete, and it has been preserved substantially without change. Subsequent to the completion of this work, the Pentateuch was abstracted, and not later than the time of Ezra it was firmly established as the Holy Scripture of Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("Form and Contents")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The separation of the Pentateuch from the Primary History, and its assignment to a unique place of honor and authority in Israel, was a development of the greatest importance. The factors responsible for the division between Deuteronomy and Joshua were neither literary nor historical, but primarily theological; they arose out of the concerns and needs of the exilic community. Classic critical scholarship identified the Hexateuch as the basic literary compilation, recognizing the close connection between the occupation of the land described in Joshua and the preceding stories of the Pentateuch. More recent scholarship has identified the Deuteronomic History as a single literary work, thus dividing the Primary History at the end of the book of Numbers and connecting Deuteronomy with the following books. It will be seen that neither approach allows for a normal break at the end of Deuteronomy. At the same time, the ultimate sources, oral and documentary, cut across the same dividing line. The conclusion seems inescapable that the isolation of the Pentateuch from the Primary History was the last stage in the process, and that it was occasioned by the special interest of the exilic community in the person of Moses and the experience of Israel in the wilderness. A subtle shift in emphasis from the historical pattern of the older sources to the more static pattern of P is discernible in the new arrangement. Where the Primary History is essentially the record of God’s dealings with his people and their experience together through more than twelve hundred years, the Pentateuch, while retaining a chronological framework and, of course, sharing the same narrative for the first half of this era, nevertheless has its central interest not in the mighty deeds of God, nor in the historical vicissitudes of Israel, but rather in the description of an eternal, perfect, and unchangeable pattern of community life, first and fully revealed at Sinai and successfully achieved by Israel in the wilderness. For the Pentateuch, the desert encampment governed by all the laws, civil and criminal, cultic and dietary, was the first true realization of the anticipations outlined in Genesis and the embodiment of the kingdom of God. The pattern of the desert constituted the authoritative example and model for the postexilic community. History has been subordinated to revelation, and mighty deeds to eternal words. Essentially what was required of Israel was conformity to the Sinai pattern; in this would be found the guarantee of its survival and the promise of its security. To a considerable extent, the Pentateuch defined and also restricted the future hope of the postexilic community. While Pentateuchal passages could be pressed into service for messianic purposes, such expectations were more at home in the prophetic literature. The themes of a second Moses, a second exodus, and the perfect realization of the Sinai pattern reflect the shadow cast by the Pentateuch on all hopes and speculations about the future. Alongside the controlling pattern of community life is the figure of Moses, who dominates the Pentateuch. His life constitutes the frame and thread of the story from the beginning of Exodus to the end of Deuteronomy (to which may be added the traditional view that he was the author of all five books). Not only is he the charismatic hero of the J﻿﻿E narrative, but he is also the prophet “nonpareil” of D and Israel’s sole lawgiver of P. Thus all the sources and strands of the four latter books of the Pentateuch are drawn together around the superhuman figure of Moses (cf. Exod 34:29–35), while Genesis serves as prologue to the great drama. The chief emphases of the Pentateuch are on the intricate but ultimate pattern of laws governing the life of the people of God, and the mediator of these laws, Moses, who at the same time receives a full biographical treatment.")])]), _c('p', {
    staticClass: "Bib1"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('b', [_c('i', [_vm._v("Select Bibliography")])]), _vm._v(". Bentzen, A. 2d ed. 1952, "), _c('i', [_vm._v("Introduction to the Old Testament")]), _vm._v(", Copenhagen: Gad • Blenkinsopp, J. 1992, "), _c('i', [_vm._v("The Pentateuch: An Introduction to the First Five Books of the Bible")]), _vm._v(", New York: Doubleday • Campbell, A. F., and M. A. O’Brien. 1973, "), _c('i', [_vm._v("Sources of the Pentateuch: Texts, Introductions, Annotations")]), _vm._v(", Minneapolis: Fortress • Carpenter, J. E., and G. Harford-Battersby. 1900, "), _c('i', [_vm._v("The Hexateuch According to the Revised Version")]), _vm._v(", 2 vols., London: Longmans, Green • Driver, S. R. 9th ed. 1913, "), _c('i', [_vm._v("Introduction to the Literature of the Old Testament")]), _vm._v(", Edinburgh: T&T Clark • Eissfeldt, O. 2d ed. 1956, "), _c('i', [_vm._v("Einleitung in das Alte Testament")]), _vm._v(", Tübingen: Mohr; ET 1965, "), _c('i', [_vm._v("The Old Testament: An Introduction")]), _vm._v(", trans. P. R. Ackroyd, New York: Harper & ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Row • Friedman, R. E. 1981, "), _c('i', [_vm._v("The Exile and Biblical Narrative: The Formation of the Deuteronomistic and Priestly Works")]), _vm._v(", Chico, Calif.: Scholars • Friedman, R. E. 1992, “Torah (Pentateuch),” "), _c('i', [_vm._v("ABD")]), _vm._v(", 6:605–22 • Friedman, R. E. rev. ed. 1997, "), _c('i', [_vm._v("Who Wrote the Bible?")]), _vm._v(" San Francisco: HarperSanFrancisco • Friedman, R. E. 1998, "), _c('i', [_vm._v("The Hidden Book in the Bible")]), _vm._v(", San Francisco: HarperSanFrancisco • Hahn, H. F. 1954, "), _c('i', [_vm._v("The Old Testament in Modern Research")]), _vm._v(", Philadelphia: Muhlenberg • Hayes, J. H. 1979, "), _c('i', [_vm._v("An Introduction to Old Testament Study")]), _vm._v(", Nashville: Abingdon • Hölscher, G. 1942, "), _c('i', [_vm._v("Die Anfänge der hebräischen Geschichtsschreibung")]), _vm._v(", Heidelberg: Winter • Hölscher, G. 1952, "), _c('i', [_vm._v("Geschichtsschreibung in Israel")]), _vm._v(", Lund: Gleerup • Kaufmann, Y. 1960, "), _c('i', [_vm._v("The Religion of Israel, from Its Beginnings to the Babylonian Exile")]), _vm._v(", Chicago: University of Chicago • Nicholson, E. 1998, "), _c('i', [_vm._v("The Pentateuch in the Twentieth Century: The Legacy of Julius Wellhausen")]), _vm._v(", Oxford: Clarendon • North, C. R. 1951, “Pentateuchal Criticism,” in "), _c('i', [_vm._v("The Old Testament and Modern Study")]), _vm._v(", ed. H. H. Rowley, Oxford: Clarendon, 48–83 • Noth, M. 1943, "), _c('i', [_vm._v("Überlieferungsgeschichtliche Studien")]), _vm._v(", vol. 1, Halle; ET 1981, "), _c('i', [_vm._v("The Deuteronomistic History")]), _vm._v(", Sheffield: JSOT • Noth, M. 1948, "), _c('i', [_vm._v("Überlieferungsgeschichte des Pentateuch")]), _vm._v(", Stuttgart: Kohlhammer; ET, 1972, "), _c('i', [_vm._v("A History of Pentateuchal Traditions")]), _vm._v(", trans. B. W. Anderson, Englewood Cliffs, N.J.: Prentice-Hall • Pedersen, J. 1931, “Die Auffassung vom Alten Testament,” "), _c('i', [_vm._v("ZAW")]), _vm._v(" 49: 161–81 • Pedersen, J. 1926–40, "), _c('i', [_vm._v("Israel: Its Life and Culture")]), _vm._v(", 2 vols., London: Oxford University • Pfeiffer, R. H. 2nd ed. 1953, "), _c('i', [_vm._v("Introduction to the Old Testament")]), _vm._v(", London: Black • Propp, W. H. C. 1997, “The Priestly Source Recovered Intact?” "), _c('i', [_vm._v("VT")]), _vm._v(" 46:458–78 • Rofe, A. 1999, "), _c('i', [_vm._v("Introduction to the Composition of the Pentateuch")]), _vm._v(", trans. H. N. Bock, Sheffield: Sheffield Academic • Rudolph, W. 1938, "), _c('i', [_vm._v("Der “Elohist” von Exodus bis Josua")]), _vm._v(", BZAW 68, Berlin: A. Topelmann • Volz, P., and W. Rudolph. 1933, "), _c('i', [_vm._v("Der Elohist als Erzähler: Ein Irrweg der Pentateuchkritik?")]), _vm._v(" BZAW 63 • von Rad, G. 1934, "), _c('i', [_vm._v("Die Priesterschrift im Hexateuch")]), _vm._v(", BWANT 13, Stuttgart: Kohlhammer • von Rad, G. 1938, "), _c('i', [_vm._v("Das formgeschichtliche Problem des Hexateuchs")]), _vm._v(", BWANT 26(78), Stuttgart: Kohlhammer; ET, 1984, "), _c('i', [_vm._v("The Problem of the Hexateuch")]), _vm._v(", London: SCM • von Rad, G. 1953, "), _c('i', [_vm._v("Studies in Deuteronomy")]), _vm._v(", trans. D. M. G. Stalker, SBT 9, London: SCM • von Rad, G. 1953, "), _c('i', [_vm._v("Das erste Buch Mose: Genesis")]), _vm._v(", ATD 2/4, Göttingen: Vandenhoeck & Ruprecht • von Rad, G. 1972, "), _c('i', [_vm._v("Genesis: A Commentary")]), _vm._v(", trans. J. H. Marks, London: SCM • Wellhausen, J. 1885, "), _c('i', [_vm._v("Prolegomena to the History of Ancient Israel")]), _vm._v(", trans. J. S. Black and A. Menzies, Edinburgh: Black • Wellhausen, J. 3d ed. 1899, "), _c('i', [_vm._v("Die Composition des Hexateuchs und der historischen Bücher des Altes Testaments")]), _vm._v(", Berlin • Whybray, R. N. 1987, "), _c('i', [_vm._v("The Making of the Pentateuch. A Methodological Study")]), _vm._v(", JSOTSup 53, Sheffield: Sheffield Academic • Zevit, Z. 1982, “Converging Lines of Evidence Bearing on the Date of P,” "), _c('i', [_vm._v("ZAW")]), _vm._v(" 94:502–9.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  })])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT",
    attrs: {
      "id": "ch005"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-005"
    }
  }, [_vm._v("Genesis")])]), _vm._v(" "), _c('p', {
    staticClass: "CA"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-005"
    }
  }, [_vm._v("Gordon J. Wenham")])]), _vm._v(" "), _c('p', {
    staticClass: "H1a"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Problem of Interpretation")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The interpretation of Genesis should be straightforward. Most readers of this commentary will be familiar with the contents of Genesis and will come to the text with a pre-understanding that they have acquired in church, Sunday school, or at their mother’s knee. They will therefore think that they know what the text means, and will tend to consult a commentary only regarding points they feel unsure about or to discover what modern scholars are saying about this ancient text.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Now some pre-understanding is necessary for reading any text. But it can also be dangerous: prejudice, especially unconscious prejudice, may distort or even obscure understanding. We often meet this problem in ordinary communication, and we try to eliminate it. However, with Genesis we are on sensitive ground. It is the first book of the Bible, and is therefore regarded by both Jews and Christians as in some sense the Word of God and therefore authoritative for both faith and practice. In Genesis we therefore hope to find our beliefs and moral stances endorsed or at least not contradicted. But because believers’ convictions vary, so do their interpretations of Genesis.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Ultimately there is no escape from the reader’s input to the interpretation of a text. We decide the questions that we put to the text. Yet we need to ask ourselves whether the questions we are posing are fair. Is it reasonable to look for solutions to problems raised by modern science or ideologies in a three-thousand-year-old text? The text was written at a particular time with a specific readership in mind. So the traditional approach of the commentator has been to attempt to read the text as the presumed first readers did, or, even better, as the author meant it. The recovery of the original sense of the text was the basic duty of the commentator. It is now universally recognized that there are many obstacles to achieving that goal. We know little about the circumstances in which the biblical texts were written, or who their authors were. Interpretation is also dependent on the wider context, as well as on the assumptions and interests of the interpreter.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These factors make interpretation far from straightforward. Nevertheless, this commentary endeavors to make its first priority the recovery of the earliest meaning of the text, however uncertain that may seem to be, and hopefully to let its voice speak. The alternative is to let our personal interests have free rein and impose our own views on the text however contrary they may be to the writer’s. Such a capricious approach may be interesting or dull, but it is certainly of passing value.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The believing Christian or Jewish reader will not be satisfied with recovering the original meaning of the text, however. They will want to relate the message of Genesis to their current situation. Here a commentary cannot offer as much because readers differ so much in the situations they face. Yet very often Genesis seems to address issues of perennial concern, so that readers of this commentary should be able to apply its message themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("To discover the primary meaning of Genesis we need to look at the following issues: Arrangement, Theme, Sources, Date, and Authorship.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Arrangement")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The book of Genesis consists of an introduction (1:1–2:3) followed by ten sections, each of which is headed by the title “These are the descendants of …” (2:4; 5:1; 6:8; 10:1; 11:10, 27; 25:12, 19; 36:1; 37:2). Though the Hebrew is the same in 2:4 and 37:2, the NRSV translates the word differently in these passages, “generations” (2:4) and “story of the family” (37:2). This highlights the problem of translation: “descendants” does not fit the context here. Literally the Hebrew term "), _c('i', [_vm._v("toledot")]), _vm._v(" means “what comes forth” or “what is generated,” so something like “subsequent history” would fit all the contexts reasonably well. Chapter 1 tells of the creation of the heavens and the earth, so 2:4 begins a section about the “subsequent history” of the heavens and earth. Chapters 2–4 introduce us to Adam and his family, so 5:1 tells of the subsequent history of that family. Similarly, Noah is introduced in 5:29, and 6:8 opens a section describing his subsequent life much more fully.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Furthermore, these headings sometimes introduce just a short section like a genealogy (e.g., 25:12) and sometimes a full narrative (e.g., 25:19). Usually short and long sections alternate: 2:4 (heaven and earth) long, 5:1 (Adam) short, 6:8 (Noah) long, 10:1 (sons of Noah) long, 11:10 (Shem) short, 11:27 (Terah) long, 25:12 (Ishmael) short, 25:19 (Isaac) long, 36:1 (Esau) short, and 37:2 (Jacob) long. The last forty chapters of Genesis consist of three long sections (Terah, Isaac, and Jacob), separated by the short genealogies of Ishmael and Esau. Isaac and Ishmael were brothers, as were Jacob and Esau. In each case the genealogy of the nonelect brother precedes the long account of the chosen brother.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This pattern shows the chief interest of the author of Genesis: he wants to trace the origins of the family of Jacob, "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("the ancestor of the nation of Israel. He barely mentions insignificant offshoots of this family (e.g., Ishmael and his descendants or Esau’s descendants), but records the acts of Jacob, his sons, and his father and grandfather rather fully. Chapters 1–11, which often attract the most attention of modern writers because of their universal vision, are quite short in comparison with the patriarchal stories and were obviously of less moment to the author of Genesis. They simply serve to set the scene for the emergence of the nation of Israel and its twelve tribes, the sons of Jacob.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Thus consideration of the arrangement of the book helps us to grasp its focus of interest. The title of the book, “Genesis,” means “origin,” and this sums up its central concern: to trace the origin of the people of Israel and its twelve tribes and their earliest settlement in the land of Canaan. The short genealogies which link the main patriarchal stories show the relationship of Israel to its nearest neighbors, Edom (ch. 36) and desert tribesmen (Ishmael, 25:12–18), while the Table of Nations (ch. 10) locates Israel’s position among the seventy peoples known to them in surrounding lands. The author of Genesis is thus an Israelite historian looking out on the world he knows and looking back into the past with a view to explaining his nation’s place in world history.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There are two problems with calling the author of Genesis a historian. First, he includes in his narrative not merely human actors but God, and he explains events not simply by reference to human decisions or natural circumstances but by relating them to the will of God. But modern historians, whether they believe in God or not, would not introduce him into their accounts of the past or invoke his will as an explanation of events. They adopt a secular approach to writing history not claiming to be able to relate events on earth to the mind of God in heaven.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But this divide between secular and religious writing was much less marked in ancient times than today. Many ancient Near Eastern texts, from building inscriptions to royal annals, mention the gods as active in history and determining its direction. So while divine explanations may be out of place in modern histories, it by no means follows that their presence in ancient texts means that they cannot be regarded as historical records.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, this raises the second problem with regarding Genesis as history: Is the author close enough to the events he mentions for his account to be regarded as history, or is it largely or wholly the product of his or others’ imaginations? Scholarly opinion on this issue has seesawed dramatically in recent years; we shall discuss it further under “Sources” and “Authorship” below.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Theme")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Genesis may therefore be described as a theological history of Israel’s origins. But why was the author so interested in the emergence of Israel? What was so significant about it? D. J. A. Clines (1978: 29) has given what is perhaps the best answer: “The theme of the Pentateuch is the partial fulfilment … of the promise to or blessing of the patriarchs.” Gen 12:1–3 is the first time the promise is made. It comprises four elements. First, it promises Abraham that he will have a land: “Go to the land … I will show you”; second, that he will have numerous descendants: “I will make of you a great nation”; third, that he will enjoy God’s protection and blessing: “I will bless those who bless you, and the one who curses you I will curse”; and fourth, that other nations will be blessed because of him: “in you all the families of the earth shall be blessed.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The promises are repeated throughout the book. They are not simply repeated, however, but are modified in subtle ways each time, making them more precise or wide-reaching. For example, “the land that I will show you” (12:1) becomes “this land” in 12:7, “all the land that you see” in 13:15, and “all the land of Canaan for a perpetual holding” in 17:8. All the promise passages in Genesis must therefore be read very carefully to see how the different aspects of the promise are progressively developed and made more emphatic (see 12:1–3, 7; 13:14–17; ch. 15; 16:10; ch. 17; 18:10; 21:12–13; 22:16–18; 25:23; 26:2–5, 24; 28:13–15; 35:11–12; 46:3–4). These promises set out the divine program for the family of Abraham and imply that its history is not merely of significance to Israelites but to the whole world.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The promises themselves, however, occupy a very small proportion of Genesis. Most of the book is narrative, stories about the patriarchs and their doings. These episodes are selected, indeed slanted, to show how the promises were gradually fulfilled. In Genesis the greatest amount of attention is devoted to the promise of descendants. The promise is first made to Abram and Sarai, an elderly and infertile couple, so it is not surprising that its fulfillment is difficult. In ch. 16 they resort to surrogate marriage so that Hagar, Sarai’s maid, can bear a child for them. But 17:16ff. makes clear that this is not God’s way, but that Sarah herself will bear a son. Again, however, it is a while before the promise is realized with the birth of Isaac in 21:1. In due course Isaac marries, but it is twenty years before his wife Rebekah manages to conceive. It is only with Jacob that a patriarch succeeds in fathering several sons, albeit by four different women, and he goes down to Egypt with almost seventy descendants. He is by no means the great nation promised to Abraham, but at least the hope is gradually being realized.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Similarly, the patriarchs are promised divine protection. The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" says to Abram, “I will bless those who bless you, and the one who curses you I will curse,” and to Isaac and Jacob he adds: “I will be with you” (12:3; 26:3; 28:15). The stories illustrate this divine protection in many different situations. When Abraham enters Egypt and fears for his life, while Sarah may have found herself in a difficult situation, both of them escape greatly enriched (12:10–20). Isaac and Rebekah escape from a potentially similar situation in Gerar (26:6–11). Jacob, though he flees from the murderous wrath of his brother into the arms of his rapacious uncle Laban, returns home eventually with two of Laban’s daughters as wives and large herds acquired from Laban, to be greeted by a forgiving embrace from his brother. Finally, even when sold into Egyptian slavery and imprisoned there, Joseph experiences that the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" is with him, as is demonstrated ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("by his rise to be ruler of all Egypt (39:2, 21). There is thus progression within Genesis: each cycle shows its patriarch being more richly blessed and enjoying greater divine protection than the previous one.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Progression is even more marked in the fulfillment of the promise that “in you all the families of the earth shall be blessed.” Apart from his rescue of the kings of the plain in ch. 14 and his attempt to intercede for Sodom (ch. 18), other nations do not appear to enjoy much blessing through Abraham. Through Jacob’s faithful husbandry of Laban’s flocks and herds, the latter was enriched (30:30), but through Joseph all the world was able to come to Egypt to buy grain and the Egyptians themselves were saved from utter destitution (41:57; 47:13–26).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These passages all illustrate how the patriarchal promises are gradually fulfilled. But how do the opening chapters (1–11) relate to this theme of the fulfillment of promises? On first reading they do not appear to have much to do with the promises. Whereas later in Genesis the promises are at least partially fulfilled and the sky brightens, the opening chapters paint a different picture. From the glorious conclusion of ch. 1, “God saw everything that he had made, and, indeed, it was very good,” things go rapidly downhill, so that in 6:7 God says, “I am sorry that I have made them.” After the flood there is a new start for mankind. Noah is presented as a second Adam, the new father of the human race, but he succumbs to drink; and with the tower of Babel the whole world again suffers judgment. Without a fresh breath of divine grace the prospects for his creation seem bleak. Mankind’s failure, so eloquently described in the opening chapters of Genesis, is thus the backdrop to the promises to Abraham and gives these apparently narrow words universal significance.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But there is a tighter link between the opening chapters and the theme of Genesis than this. God’s original commands to mankind, to multiply and to subdue the earth, and the creation of humans in God’s image, foreshadow the promises of descendants, land, and divine protection in Genesis 12. In Clines’ words (1978: 29), the patriarchal promises are “a re-affirmation of the primal divine intentions for man.” God’s plans for the whole human race enunciated in Genesis 1 will eventually be realized through Abraham and his descendants.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Sources")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Unlike some parts of the Bible, especially the books of Kings and Chronicles, Genesis makes almost no reference to the sources it is using. “This is the "), _c('i', [_vm._v("list")]), _vm._v(" of the descendants of Adam” (5:1) may be a reference to a source, but this is not clear. This has led to a variety of suggestions about how the book was written.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The oldest view is that Moses was the author of the entire Pentateuch, so that in some Bible translations Genesis is called “The First Book of Moses.” Whereas Moses could have been an eyewitness of most of the events described in the later books, however, this is clearly not the case with Genesis, which tells both about the patriarchs who lived half a millennium before Moses and about primordial events such as creation and the flood. How did Moses know about these things? Traditional commentators were not very interested in such questions: insofar as they considered them, they supposed that either Moses learned the stories of Genesis by direct inspiration or orally from his parents or other Israelite storytellers.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Serious modern critical discussion began with J. Astruc’s "), _c('i', [_vm._v("Conjectures on the Sources Moses May Have Used to Compile Genesis")]), _vm._v(" (1753). In this work he observes that there is duplication in Genesis, for example, in recounting the creation and the flood. He also notes that there are two main designations for God in Genesis, “God” "), _c('i', [_vm._v("(Elohim)")]), _vm._v(" and “the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("” "), _c('i', [_vm._v("(Yahweh)")]), _vm._v(". Using these two criteria, he was able to split Genesis into two main sources: the one using the word “God” was the original, which was later supplemented by the source using the word “"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LORD")]), _vm._v(".” He identified shorter independent sources as well. The phenomena of different divine names and doublets which Astruc highlighted have remained the foundation of critical theory about Genesis, though his belief that Moses was the final editor has almost entirely been abandoned. For the moment we shall defer discussion of the date of the sources and their redaction and focus on the different types of source analysis that have been propounded.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the early nineteenth century there were three major models of the growth of Genesis. The first was the fragmentary model, which holds that Genesis was compiled out of a variety of relatively short, independent sources, or fragments, that were used by one editor at one time. It did not undergo a prolonged period of growth during which the material was added to or the story line modified. It was put together by one author drawing on various sources in one fell swoop.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Another model of growth was the supplementary. This postulates that there was once a short version of Genesis, but that it went through a series of editions. Each time more material was added, until the present text of Genesis was created.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The third model was the documentary. This holds that Genesis is made up of three main sources which were originally independent, and each covered much the same history, though from different perspectives. The longest source is the Yahwistic source (J), which includes material from Genesis 2 to Genesis 50. The next longest source is the Elohistic (E), which comprises material found in Genesis 15 to 50. The shortest source, the Priestly (P), includes material found throughout Genesis. According to the commonest form of the documentary hypothesis J, the oldest source, after circulating on its own for about a century, was then combined with E to form a new text. Then after another couple of centuries this combined J﻿﻿E document was edited with P to form the present book of Genesis. (Here it may be pointed out that these sources are generally supposed to continue through the other books of the Pentateuch.)")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("In the early nineteenth century defenders of all three models of the composition of Genesis could be found. But by the end of the century most scholars had been persuaded that the documentary hypothesis best explained the data. This consensus persisted till the late 1970s, ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("when scholars again canvassed fresh alternatives. There is now a strong school of thought represented by J. Van Seters, R. Rendtorff, and E. Blum, among others, that holds that a supplementary hypothesis best explains Genesis. This is not to say that they each describe the growth of the book in exactly the same way, but they do agree that it grew by a series of editions, each of which expanded the previous one. R. N. Whybray, by contrast, has argued for a fragmentary hypothesis: he believes Genesis was written by a single author using a variety of sources.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Most of these writers challenging the documentary hypothesis also agree that the usual criteria for distinguishing between sources, divine names, repetition, style, and vocabulary are not always cogent. A single author may vary his style, use repetition, or employ different names of God for theological or personal reasons. These phenomena, first identified by Astruc as marks of different authorship, may not indicate any such thing. In other words, the scholarly consensus about the sources is not as solid as it used to be. This makes the writing of a brief commentary more problematic: the old consensus cannot be taken for granted, but spelling out all the modern alternatives would be too lengthy. For religious readers the uncertainties of source criticism do not matter much: it has always been the final text that has had canonical authority and been the focus of interpretation. This commentary will focus on the present text of Genesis, not its hypothetical precursors, but by use of the sigla J, E, and P we shall note to which source mainline critical theory has assigned the different parts of Genesis.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Date")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("It would be possible to believe in a fragmentary, supplementary, or documentary source explanation of Genesis and in Mosaic authorship, just as Astruc did. But as different explanations of the growth of Genesis were advanced, so were different dates of the sources and their progressive amalgamation. With the establishment of the documentary hypothesis as the scholarly solution to the source division went widespread agreement about the date and origin of the sources. J originated in Jerusalem in the late tenth or the ninth century. E was a document from the Northern Kingdom produced about a century later. P is usually supposed to have originated shortly before 500 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", and the whole was combined into a single book soon afterward.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These dates have been arrived at by reading the sources against the background of these eras. For example, J reflects the power and interests of the Davidic or Solomonic empire. Its picture of worship with patriarchs patronizing a variety of shrines matches the ethos of the period of the early monarchy, when worship was not confined to Jerusalem. P, on the other hand, with its concerns about sabbath observance and circumcision, fits the postexilic era when the importance of religious loyalty had become paramount. Though the postulated backgrounds for the different sources are quite possible, they are not compelling. Rendtorff noted that the dates traditionally assigned to pentateuchal sources rested more on scholarly consensus than on objective criteria. Among those rejecting the traditional documentary theory of the Pentateuch, there is often a preference for holding that the first major edition of Genesis (approximately the J material) dates not from the tenth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" but from the sixth century. It is argued that the promise of land, for example, is relevant to Israel in exile and that the movements of the patriarchs fit the archeological data of this later period. On this model the P material would have been incorporated into Genesis quite soon after the first edition. On the other hand, there are those who argue that P actually reflects not the religion of the postexilic period but that of the tabernacle, or first temple. These very diverse assessments of the date of the material in Genesis show how much depends on the interpretive input of the historical scholar. Hard data requiring a specific conclusion are unusual in biblical scholarship.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the midst of this Babel of conflicting views R. W. L. Moberly (1992a) has made some pertinent observations. The Pentateuch as a whole presupposes the normativeness of Mosaic Yahwism with its emphasis on exclusive loyalty to Yahweh, the abolition of foreign gods, and the demand for holiness. Yet Genesis, while tacitly acknowledging these norms, portrays the patriarchs as disregarding them at many points, worshiping at a variety of shrines, living fairly peaceably with the Canaanites, and apparently not concerned about the sabbath, the food laws, and some of the marriage laws. Though scholars have tended to read these patriarchal stories as oblique descriptions of the unorthodox religious and moral practices of later ages, Moberly argues that this is to misread Genesis. The author of Genesis disapproves of much of what the patriarchs do, but he records it nonetheless because it is part of the tradition which has been passed down to him. For Moberly the heterodoxy of the patriarchs is an indication of the great age of the stories about them.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There are many other signs in Genesis that we are dealing with old material that has been modernized to make it intelligible for a later age. Genesis 14 contains a number of glosses to help later readers, for example, “Bela (that is Zoar), … Siddim (that is, the Dead Sea)” (14:2, 3). Names of places and peoples, such as Dan, Ur of the Chaldees, and Philistines, and job descriptions like lord “over my house” (41:40) seem to be updated for the benefit of first-millennium readers. But these modernisms occur alongside archaisms, such as the names of the patriarchs themselves, the descriptions of Joseph’s role and investiture, and obsolete social customs, as well as ancient parallels to Genesis 1–11 which would appear to be more at home in the second than in the first millennium "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". Putting all these clues together, I would conclude that Genesis was compiled out of materials originating in the second millennium, which received its final revision in the period of the early monarchy.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Authorship")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("The brilliantly told narratives and tight structure of the book of Genesis make it difficult to believe that it simply ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("evolved out of oral tradition or was the compilation of a mere editor. It bears the stamp of a powerful creative author, but who that was we cannot know. If Moses was as significant as biblical tradition paints him, we may credit him with the first draft of the book. On the other hand, we may suppose that it was composed by some unknown in the period of David and Solomon, which was clearly a high point of Israelite literary culture. Others may prefer to posit a postexilic author writing the first volume of Israel’s history, which concluded with the Kings account of the fall of Jerusalem. But whoever wrote Genesis penned one of the greatest and most influential works of world literature.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography. Commentaries")])]), _vm._v(". Cassuto, U. (1961, 1964) • Rad, G. von (1972) • Sarna, N. M. (1989) • Wenham, G. J. (1987, 1994) • Westermann, C. (1984, 1986).")]), _vm._v(" "), _c('p', {
    staticClass: "Bib"
  }, [_c('b', [_c('i', [_vm._v("Introductory Issues")])]), _vm._v(". Moberly, R. W. L. 1992a, "), _c('i', [_vm._v("The Old Testament of the Old Testament")]), _vm._v(", Minneapolis: Fortress • Moberly, R. W. L. 1992b, "), _c('i', [_vm._v("Genesis 12–50")]), _vm._v(", Old Testament Guide, Sheffield: Sheffield Academic • Rogerson, J. W. 1991, "), _c('i', [_vm._v("Genesis 1–11")]), _vm._v(", Old Testament Guide, Sheffield: Sheffield Academic • Wenham, G. J. 1999, “Pondering the Pentateuch,” in D. W. Baker and B. T. Arnold, eds., "), _c('i', [_vm._v("The Face of the Old Testament")]), _vm._v(", Grand Rapids: Baker, 116–44 • Whybray, R. N. 1987, "), _c('i', [_vm._v("The Making of the Pentateuch")]), _vm._v(", Sheffield: JSOT.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib"
  }, [_c('b', [_c('i', [_vm._v("Theology")])]), _vm._v(". Alexander, T. D. 1997, "), _c('i', [_vm._v("From Paradise to Promised Land")]), _vm._v(", Carlisle: Paternoster • Clines, D. J. A. 1978, "), _c('i', [_vm._v("The Theme of the Pentateuch")]), _vm._v(", Sheffield: JSOT.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Near Eastern Parallels to Genesis 1–11")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("To appreciate the impact that Genesis 1–11 made on its earliest readers, it is necessary to understand the ideas about world origins and mankind’s earliest history that were current in the era in which Genesis was written. The creation and the flood are mentioned in many texts from the ancient world, for example, from Egypt, Ugarit, and Greece, but the accounts which seem closest to the biblical story come from Mesopotamia in the early second millennium "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Sumerian King List (c. 1900 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") tells of eight or ten kings who ruled before the flood, each for tens of thousands of years. Then, says the List, the flood swept over the earth, and afterward kingship was again lowered from heaven. Subsequent kings reigned over Mesopotamia for merely hundreds of years. This pattern of reigns finds parallels in Genesis 5 and 11. Genesis 5 tells of ten figures who lived nearly a thousand years each before the flood, whereas Genesis 11 tells of the postdiluvians who lived only a few hundred years each. Genesis 4 relates how the descendants of Cain developed arts and crafts such as music, agriculture, city building, and metal working. This seems to echo Babylonian and Phoenician traditions about seven "), _c('i', [_vm._v("apkallus")]), _vm._v(" (sages) who in earliest time taught man the arts of civilization. Indeed, the first of these sages, Adapa, has a name akin to Adam.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Three texts show even closer parallels to Genesis. The Sumerian Flood Story as reconstructed by Jacobsen (1981) recounts the history of the world from the creation of man to the flood. It describes first the plight of mankind with no fixed abode, no irrigation canals, and no clothes (cf. Genesis 2–3). The goddess Nintur plans to end human nomadism, but this is a failure (cf. Gen 4:1–16). However, the establishment of kingship leads to the building of the first cities (Gen 4:17–18) and the introduction of worship (Gen 4:26). Then follow a list of kings who reigned before the flood (cf. Genesis 5), a description of the noise that prompted the flood, and an account of the flood itself (Gen 6:1–9:29). The parallels between Genesis and the Sumerian Flood Story are not so close as to lead to the conclusion that either text knows the other. Rather, they both reflect beliefs about earliest times that were widespread in the ancient orient.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This conclusion is supported by a comparison of Genesis with the other two texts, the Atrahasis Epic and Gilgamesh Epic Tablet 11, whose account of the flood was probably drawn from the Atrahasis Epic. This begins with the lesser gods toiling away digging the canals and the ground to provide food for the great gods. But one day the lesser gods went on strike, depriving the great gods of their food. To break the strike the great gods created seven human couples out of clay and the blood of a dead god. However, the increase of human population on earth disturbed the tranquility of heaven. The gods, therefore, tried to destroy mankind by sending a plague and a drought. Both schemes were thwarted by a man offering a sacrifice to the plague god or the rain god. So the gods all agreed to wipe out the human race with a flood. However, one god, Ea, tipped off his worshiper (Atrahasis or Utnapishtim) to build an ark. He did so, and duly embarked with friends, animals, and valuables. Like the biblical Noah, Atrahasis sent out birds to check the flood level, and he eventually emerged from the ark. Then he offered a sacrifice, around which all the gods crowded hungry after the cessation of sacrifices during the flood, and Atrahasis was eventually granted immortality by the gods. (His other name, Utnapishtim, means “finder of life”).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Modern readers encountering the Mesopotamian stories for the first time are most often struck by the similarities between them and Genesis. However, if we are to appreciate the impact of Genesis on its first readers, we need to read them as background to Genesis and not as the reverse. These Mesopotamian texts come from the Old Babylonian period (1900–1600 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("), which on any view is earlier than Genesis. These Mesopotamian texts reflect the typical beliefs about origins current throughout the ancient world in the second millennium "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" and probably later. They would not have been seen as unusual then, whereas Genesis 1–11 stands out as distinctive. Its first readers then would not have noted the similarities between Genesis and other accounts so much as the differences.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("These first readers would have been struck that Genesis mentions only one God and no goddesses. There is no theogony whereby a whole tribe of gods came into being through sexual relations between the gods and goddesses, or even through divine masturbation. This one God, unlike other oriental deities, is sovereign in power and omniscient. He speaks and light, dry land, plants, ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("and animals appear at once. Even the sun, moon, and stars, often regarded as powerful gods in their own right in the ancient orient, are just creatures, according to Genesis. Though in some Egyptian texts a god creates by his mere word, creation often involves a great struggle. And the great gods of Mesopotamia are not always in control. After unleashing the flood they “cower in the corner like dogs,” whereas in Genesis it is when God remembers Noah that the flood starts to recede. After the flood Enlil, one of the three top gods, came to the sacrifice offered by Utnapishtim and was astonished to find human beings still alive. Unlike the God of Genesis Mesopotamian deities did not know everything that happened on earth.")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("It is not just that Genesis has only one God, who is both sovereign and omnipotent, but his relationship with mankind is quite different. Other cultures recognized that humans were both physical (from the clay or dust) and spiritual (containing the blood of a dead god, or breathed into by God), and believed that kings at least were the image of the god representing and ruling for him on earth. But Genesis affirms that every human being, male and female, is created in God’s image to represent him and exercise dominion on his behalf. What is more, far from mankind being a mere afterthought or even a stopgap in the divine plan, Genesis portrays the creation of man as the climax of creation. The works of the preceding five days all prepare the environment for man, and then when the human race itself is created all the angels are invited to participate in this master stroke of creation, as the Creator announces, “Let us make humankind in our image.” And whereas according to the Atrahasis epic man was created to provide the gods with food, Genesis notes that God supplied man with food: “See, I have given you every plant … for food” (1:29). This theme of God’s concern for human welfare is reemphasized in ch. 2, where God provides a garden full of fruit trees, animals as companions, and finally a wife for Adam. In this way Genesis portrays God’s care for man.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If this positive divine stance toward humanity was unusual in ancient theologies, so too was the stern moralism that comes through the Genesis accounts. Whereas according to Mesopotamian tradition the flood was prompted by the noise of the human race, according to Genesis it was man’s sin: “The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" saw that the wickedness of humankind was great in the earth … and it grieved him to the heart” (6:5–6). Whereas the Babylonians ascribed the flood to divine caprice, the Hebrews put it down to God’s anger at human violence. Adam and Eve were expelled from the garden merely for eating a fruit, and Cain was sentenced to perpetual nomadism for fratricide. After the flood Ham’s descendants are cursed for his lack of filial respect. Genesis 3–11 portray what von Rad has called “an avalanche of sin,” as one generation’s sins are ever more serious than the preceding, triggering off first the catastrophe of the flood and then later the confusion of languages and the dispersion of the nations. By contrast the Sumerian Flood Story “believes in progress. Things were not nearly as good to begin with as they have become since …” (Jacobsen 1981: 29).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Running through these opening chapters of Genesis is a persistent critique of the Mesopotamian theology of world origins. While Genesis shares a similar view of the sequence of primeval history to that of neighboring peoples, it may read as a definite polemic against the religious interpretation of them found in their myths. By affirming monotheism Genesis denies polytheism and its concomitant beliefs, such as theogony, divine ignorance, weakness, and caprice. Whereas the Babylonians looked on the creation of man as an afterthought for the gods’ benefit, Genesis affirms the centrality of man in the divine purpose and God’s concern for human welfare. But whereas other cultures were relatively sanguine about the likely progress of humanity both materially and spiritually, Genesis is emphatic that man’s natural tendency is toward waywardness and depravity, which invite divine retribution. The account of the “sons” of God marrying the daughters of men is probably another critique of a much-valued practice in the ancient Near East, sacred prostitution; but whereas many orientals supposed this ensured the fertility of the land and the womb, Genesis declares it was the last straw as far as the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" was concerned and prompted the flood (6:1–8). The ridiculing of Babylonian pretensions is even more apparent in the tower of Babel story (11:1–9). Far from its vaunted temple tower touching heaven and the name Babel (Babylon) meaning “gate of the god,” the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" had to come down from heaven to see the skyscraper—so far short of his dwelling did it reach; and its name means “confusion” or “folly.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In recasting these ancient tales Genesis is doing more than dismissing the misunderstandings of its ancient contemporaries; it is setting forth a vision of God which is fundamental to biblical theology throughout the Bible. There is one omnipotent, omniscient creator God responsible for all that exists. He is profoundly concerned for the welfare of his supreme creation man, but at the same time he cannot overlook human sin and folly. This prompts him to intervene, first as judge and then as savior, offering the human race new starts after sin has ruined the Creator’s plans.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Hess, R. S., and D. T. Tsumura. 1994, "), _c('i', [_vm._v("“I Studied Inscriptions from before the Flood”: Ancient Near Eastern, Literary, and Linguistic Approaches to Genesis 1–11")]), _vm._v(", Winona Lake: Eisenbrauns, is a collection of relevant essays by many writers on these chapters, including Jacobsen, T. 1981, “The Eridu Genesis.”")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("COMMENTARY")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Seven Days of Divine Activity (P) (1:1–2:3)")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("The first regular section of the book begins with 2:4, “These are the generations of the heavens and the earth” (cf. above, “Arrangement”). Preceding this, 1:1–2:3 constitutes the prologue to Genesis, or, in Westermann’s phrase, a “festive overture” written in an elevated prose style that sometimes is almost poetic. It describes six days of divine activity culminating in the creation of man, followed by a seventh day in which God rested ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("from his work. There are parallels between the first three days and the second three days:")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('table', {
    staticClass: "Table1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('p', {
    staticClass: "tdleft1"
  }, [_vm._v("Day 1: Creation of light")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_c('p', {
    staticClass: "tdleft2"
  }, [_vm._v("Day 4: Creation of “lights,” that is, sun, moon, and stars")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('p', {
    staticClass: "tdleft1"
  }, [_vm._v("Day 2: Creation of sea and sky")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_c('p', {
    staticClass: "tdleft2"
  }, [_vm._v("Day 5: Creation of fish in the sea and birds in the sky")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('p', {
    staticClass: "tdleft1"
  }, [_vm._v("Day 3: Creation of dry land and plants")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_c('p', {
    staticClass: "tdleft2"
  }, [_vm._v("Day 6: Creation of animals and man; plants given for food")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("The schematization of these parallels is clear, as is the repetitive use of various formulae, such as “And it was so,” “God saw that it was good,” and “There was evening and there was morning,” which occur a precise number of times. Also evident in this account is the focus on those realms that have most impact on human existence: as the days elapse, the description of God’s activity becomes fuller, because the things made later in the week tend to be the most vital for man. The fullness of the description of the sixth day with the doubling of various formulae and especially the last comment, “God saw everything that … it was very good,” highlight the place of man in the divine program. The creation of mankind is the climax of creation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The goal of creation, however, is the seventh day of rest (2:1–3). The isolation of the seventh day, which has no other day coupled with it, shows that it is unique. The implication is patent: if God the Creator rested on the seventh day, so should his creature man made in the divine image. Thus this opening chapter is more than a prologue to the book, or even just an aetiology for the sabbath; it gives the sabbath a premier place in the divine blueprint for human life.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("1:1–5")]), _vm._v(" The interpretation of these verses is difficult. The NRSV conflicts with the RSV and the majority of modern commentators. Traditionally v. 1, “In the beginning God created the heavens and the earth,” has been understood to refer to the very first act of creation, when God produced all the matter of the universe, “heavens and earth,” out of nothing. V. 2 then describes the disorganized state of the earth before God started arranging it in the subsequent six days. Many modern commentators accept this traditional translation of v. 1, but see it as a heading to the rest of the story in 1:2–2:3. In other words, what is meant by God’s creating the heavens and the earth is explained in the following verses, and since v. 2 presupposes the existence of matter before any of God’s creative activity, Genesis 1 does not teach creation "), _c('i', [_vm._v("ex nihilo")]), _vm._v(". A minority of recent commentators still prefer the older view. But very few would support the NRSV, which makes v. 1 a clause subordinate to v. 2. Theologically this has similar implications to the view that makes v. 1 the title of the whole chapter; to construe v. 1 as a subordinate clause, however, is unlikely grammar.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("1:2")]), _vm._v(" “[F]ormless void” translates two words; cf. RSV, “without form and void.” Etymology and parallel passages (cf. Jer 4:23) suggest (Tsumura 1989: 34–43) that “unproductive and uninhabited” might be the best translation. This contrasts with God’s acts on days 3 and 6, when vegetation, animals, and man were created. The before-and-after contrast is continued in “darkness covered the face of the deep.” In other words, the whole globe was dark until God said, “Let there be light” (day 1), and covered in water until he separated the seas and the dry land on day 3. “A wind from God swept” implies a primeval storm, which is probably reading too much into “swept”: “moving” (RSV) or “hovering” (cf. Deut 32:11, NIV) is preferable.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("1:3–5")]), _vm._v(" With the creation of light and time the week of divine activity begins. Light is not divine, as in some Egyptian theologies, but it is often associated with the presence of God (e.g., Exod 10:23) and its creation sets limits to the previously prevalent darkness (1:2). It also makes possible the alternation of light and darkness, day and night, and then the cycle of the week.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("1:6–8")]), _vm._v(" The sky is pictured as a dome suspended over the earth, which prevents the waters above the earth falling on it, unless the windows in the dome are opened (cf. Gen 7:11). Once again the narrative is insisting that the sky is not to be identified with God, or even with the corpse of a dead god, as in "), _c('i', [_vm._v("Enuma Elish")]), _vm._v(" (4.138; "), _c('i', [_vm._v("ANET")]), _vm._v(", p. 67).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("1:9–13")]), _vm._v(" The account of creation reaches a minor peak with the acts of separation and creation on the third day. Note how many of the formulae, for example, “It was so,” and “And God saw …,” are repeated. Both the land and vegetation are created on this day, and both are vital to human existence; hence the fuller description of these divine acts.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("1:14–19")]), _vm._v(" For the regulation of human life, however, the heavenly bodies are also indispensable; so once again their creation is recounted in some detail. They are to “be for signs and for seasons and for days and years.” However, there is probably another polemical touch here. Neighboring cultures often regarded the sun, moon, and stars as gods; but Genesis explicitly says that they were made by God, and even avoids calling them sun "), _c('i', [_vm._v("(shemesh)")]), _vm._v(" and moon "), _c('i', [_vm._v("(yareah)")]), _vm._v(", speaking instead of the greater and lesser lights, to avoid the suggestion that these were the sun god Shamash or the moon god Yarih (cf. Hasel 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("1:20–23")]), _vm._v(" In the sphere of action (sky and sea) day 5 matches day 2, just as 4 matches 1 and 6 matches 3, but in other ways the creatures of air and sea created on day 5 anticipate the creation of the animals and man on day 6. Both are described as “living creatures.” Both are said to be created "), _c('i', [_vm._v("(bara"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v(")")]), _vm._v(". Both are blessed "), _c('i', [_vm._v("(barek)")]), _vm._v(" and commanded to be fruitful and multiply and fill the earth. These verbal links set the animate creation apart from the inanimate. In a special way God’s life is manifested in the animate creation, allowing it to reproduce itself so long as it is sustained by divine blessing. “Blessing” is a key concept in Genesis, occurring more frequently in this book than in any other part of the OT. God’s blessing is shown in long life, peace, fertility, and material and spiritual success. It is at the heart of the promises to the patriarchs (cf. 12:1–3). Here Genesis suggests that God originally intended to bless the whole of creation—fish, birds, animals, and of course mankind.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('b', [_vm._v("1:24–31")]), _vm._v(" With the creation of the animals and man on the sixth day the creation story reaches its peak. Note the ")]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("repetition of many of the formulae (e.g., “God said/saw”), the much fuller account of this one day, and the climactic divine observation: “God saw everything that he had made, and indeed, it was very good” (1:31). Far from man’s being an afterthought in the divine plan as in the Atrahasis epic, Genesis declares he is the summit of God’s creation. Only man is created in God’s image and given dominion over the other living creatures. Furthermore, mankind was not created to provide food for the gods, as Babylonians believed, but God supplied him with food.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("It is not just the fullness of this part of the creation story and its contrasts with older accounts, however, but the terminology used to describe the creation of human beings and their role that set it apart. The act of creation is preceded by the exhortation, “Let "), _c('i', [_vm._v("us")]), _vm._v(" make humankind in "), _c('i', [_vm._v("our")]), _vm._v(" image.” What prompts God to speak in the plural here? The most likely explanation is that God is inviting the angels to watch man, the master stroke of creation, being produced. This is preferable to supposing it is a plural of self-encouragement. Understanding “us” as an address to the angels does not exclude later Christian, or fuller, readings, which see in it a trinitarian reference to the work of Christ in creation, but that cannot have been the understanding of the writer of Genesis.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Commentators and theologians have offered all sorts of explanations of the image of God as they have tried to identify those characteristics common to God and man. It is now known that it was widely held in the ancient orient that kings were the image of God, that is, that they were the god’s representative on earth and governed the earth on his behalf. This is clearly the idea here, with one great change, namely, that every human being, male and female, not just the king, is God’s representative who governs the rest of creation on God’s behalf. This is not a mandate to exploit the earth but to manage the earth for the benefit of all creation, for kings in the ancient world were supposed to care for their subjects, not exploit them (cf. Psalm 72). And more particularly God is always portrayed as solicitous for the welfare of his creation; so obviously his representative, man, should be too. Though Genesis does not define what constitutes the image of God in man, it implies that it is those human characteristics that enable him to fulfill his duty of ruling the earth and filling it with his own kind.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("2:1–3")]), _vm._v(" Though the seventh day stands apart from the other six days, which go in pairs and are very formulaic, it is linked to the opening verses of the chapter by verbal echoes (e.g., 2:3 with 1:1), and thus rounds off the creation story neatly. But it does more. Nonbiblical creation stories often mention the gods resting after their work, but Genesis ties God’s rest to the seventh day. It presents a pattern of six days of work followed by a day of rest. While the seventh day is not called the sabbath, perhaps to avoid confusion with the Babylonian "), _c('i', [_vm._v("shapattu")]), _vm._v(" day, it is both blessed and hallowed. In the Bible blessing is usually restricted to animate beings, and it is paradoxical that here a day of rest is blessed: inactivity is not usually seen as promoting fruitfulness and success. Yet this is what the blessing of the seventh day implies. Finally, the seventh day is hallowed, the first thing in Scripture to be called holy, that is, set apart for God and therefore sharing in his perfect life.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In other words, the seventh day is not merely an appendage to the week of creation; rather, it is its goal. The implication of its being blessed and hallowed is that it provides the energy for another week of fruitful labor in the service of God. Not that God needs to go on working in the way he did in creation, but man does. Though the text does not make the point explicitly, God’s working for six days and resting on the seventh is a pattern for man made in God’s image. Thus the whole creation story is a justification of sabbath observance as well as a celebration of the power and wisdom of the Creator.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Hasel, G. F. 1974, “The Polemic Nature of the Genesis Cosmology,” "), _c('i', [_vm._v("EvQ")]), _vm._v(" 46:81–102 • Hess, R. S., and D. T. Tsumura. 1994, essays by Bird, Lambert, Tsumura • Tsumura, D. T. 1989, "), _c('i', [_vm._v("The Earth and the Waters in Genesis 1 and 2")]), _vm._v(". Sheffield: Sheffield Academic.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Expulsion from Eden (J) (2:4–3:24)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The Garden of Eden story begins the main narrative of Genesis. 2:4 is the title to the first main section (2:4–4:26), which shows the disintegration of the created order established in ch. 1. It answers the question, Why, if God thought what he had made was very good and he had blessed his creatures, is there so much evil around today? The Eden story shows the situation before and after: ch. 2 develops the picture of God’s concern for human welfare already intimated in 1:26–31 and portrays an idyllic picture of relations between the sexes and between man and God, whereas ch. 3 shows the breakup of these relationships and the ongoing consequences of human disobedience. Chapter 4 echoes ch. 3 at many points and shows relationships deteriorating further.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Parallels with other oriental origin stories are less obvious in this section than elsewhere in Genesis 1–11. Motifs such as a paradise island, the creation of mankind from clay, and life-giving plants are known in other sources. Closest to the plot of Genesis 2–3 is the myth of Adapa, which tells how on a visit to heaven Adapa was offered the bread and water of life, but loyal to his god Ea he turned them down and lost the chance of immortality. Genesis 2–3 could be a transformation of this story, replacing an obedient Adapa with a disobedient Adam. This would fit in with Genesis’s emphasis on human sinfulness (cf. above, p. 37).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("2:5–17")]), _vm._v(" The first scene opens with a flashback to the state of the earth before man appeared: uninhabited and uncultivated, it was periodically flooded by the subterranean water, “a stream” (NRSV). The imagery here suggests a Mesopotamian background, where agriculture depends on human irrigation, as does the creation of man from clay and the geography of Eden. Genesis here implies that humans are both material, made from the ground to cultivate the ground (2:15; 3:17) and ultimately to return to the ground (3:19), and spiritual, filled with the breath of life (2:7).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("As in ch. 1, divine goodwill toward man is implied in ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("the narrative. Thoroughout most of this story God is called “the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" God,” a title used rarely elsewhere in the OT and combining God’s covenant name Yahweh (the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("), first revealed to Moses (Exod 6:3), and Elohim (God), the generic word for God used consistently in Genesis 1 of the Creator. This unusual combination suggests that God is both the almighty Creator and mankind’s covenant partner. His solicitude for his creature is demonstrated in his providing a garden well stocked with food (2:9; cf. 1:29), the animals as companions (2:19), and eventually a wife (2:22). The sequence of creative acts here (man-plants-animals-woman) clearly differs from that of ch. 1. If these chapters originated in different sources (P and J), this would partially explain the difference. However, if the purpose was to highlight God’s benevolence to man and to contrast the human situation before and after the fall, exact chronology may not have mattered to the narrator, so that he juxtaposed chs. 1 and 2 without sensing that they contradicted each other.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Eden may mean “well-watered place” (cf. 13:10; Tsumura 1989: 136) or “delight.” With its four great rivers (the Tigris and Euphrates are well known, but the identity of Pishon and Gihon is uncertain) Eden was certainly blessed with abundant water, which is both essential for life and associated with the presence of God (cf. Ezek 47:1–12). Other features of Eden, its pure gold, onyx, and bdellium stones, its trees of life and knowledge, and its east-facing entrance, all prefigure the later tabernacle and temple. In other words, Eden is depicted as an archetypal sanctuary, where God walks (3:8) and Adam acts like a priest (the words of 2:15, “tilling and keeping,” are used of the Levites in Num 3:7–8). It is apparently located somewhere near the head of the Persian Gulf, where Sumerian tradition also placed the paradise island of Dilmun.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But what is most important for Genesis is the divine command not to eat of the tree of knowledge. On the analogy of the tree of life (3:22), which gave life to those who ate from it, the tree of knowledge gave its eaters knowledge of good and evil. But what was this knowledge that God wished to withhold from man? Omniscience, sexual awareness, and moral discernment have been suggested. But more plausible is the view that it means moral autonomy, making decisions without reference to God. In Ps 19:7–9 the tree of knowledge is identified with the law; thus to eat of the tree of knowledge means to decide matters without being guided by the law.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("2:18–25")]), _vm._v(" The second scene begins with a surprising reflection from the Creator himself about a deficiency in his creation: man is lonely. So woman is created to be a helper “matching or corresponding to him” (better than NRSV, “as his partner”). The idea is that the sexes complement and support each other. The terminology of helping does not imply that man is superior to woman or vice versa, and the phrase “matching him” suggests complementarity, not identity.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, God first creates animals for the man. He then fulfills the mandate of 1:28 to rule over them by giving them names. That God created all the animals as potential partners for the man is striking and shows that he could have created any number of male or female partners for Adam. But in the event just one Eve is completely satisfactory; in other words, heterosexual monogamy is the Creator’s ideal. Furthermore, a wife is as it were part of her husband: “bone of my bones and flesh of my flesh” is a formula often used to describe close relatives (Gen 29:14). Indeed, a husband’s first concern should be for his wife. 2:24 does not describe a literal leaving of the man’s parents, for in Israel the bride left her parents to live in her husband’s extended family. Rather leaving father and mother and clinging to his wife means that a husband puts his wife’s welfare above even his obligations to his parents, which until marriage were paramount (Exod 20:12). Within this framework complete intimacy is natural and appropriate: they were “naked, and were not ashamed.” Thus in this brief scene the OT ideal of married life is beautifully sketched.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("3:1–5")]), _vm._v(" In this scene a snake appears. Though described as crafty, it is also unclean and therefore a fitting anti-God symbol. Its craftiness is evident from its speech with its subtle half-truths and insinuations. Note how he distances himself from the Creator by calling him “God” (3:1–5), not “the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" God,” which expresses God’s partnership with man (cf. comment on 2:5–17). He seduces by questioning rather than inciting. His assurances, “You will not die … your eyes will be opened and … be like God,” prove literally true according to 3:7, 22, but at the more profound symbolic level at which the story operates they are completely misleading. Their eyes will be opened, but all they will see is their own nakedness (3:7). Their likeness to God means exclusion from his presence and the fullness of life in the garden (3:22).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("3:6–8")]), _vm._v(" In this scene the couple do not merely disobey God: they usurp divine prerogatives by looking (cf. 1:4, 12, etc.), taking (2:21), and making (2:22). The woman’s inflated expectations—“good for food,” “delight to the eyes,” and “make one wise”—are swiftly punctured as they discover their nakedness, frantically sew themselves loincloths out of fig leaves, and then lurk in the bushes. Perhaps overfamiliarity with the story dulls our sense of the ridiculousness of their behavior. But it is a vivid picture of the immediate aftermath of sin. Particularly poignant is the reintroduction of the term “the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" God” twice in 3:8: they are hiding from the covenant partner of mankind instead of enjoying their accustomed intimacy with him.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("3:9–13")]), _vm._v(" Now follows a swift trial. The divine interrogation is not to elicit information but confession, and this discloses further effects of their disobedience. As the man blames the woman, and the woman blames the snake, the extent of the alienation becomes apparent: it is not just between man and God, but between husband and wife, and between the animal and the human world. The serenity of Eden has been lost.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('b', [_vm._v("3:14–19")]), _vm._v(" The story now reaches its peak as sentence is pronounced on the snake, the woman, and the man. Each is cursed in the sphere most central to its existence. Furthermore, these curses have an ongoing impact. They explain the nature of life as it is known as opposed to the perfection of ch. 2. Thus the snake is condemned to crawling, eating dust, and constant warfare with man. ")]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("The wife will suffer pain in childbirth and subjugation to her husband. And the man’s efforts at agriculture will be dogged, by weariness, weeds, and ultimately death. In each case God’s original purpose for his creatures is reasserted, but instead of being attended by joy it leads to frustration. Thus the man was appointed to till the garden, but now has to combat thorns and thistles. The woman was created as man’s helper and to bear children, but both roles are now blighted. And the snake, though it should have enjoyed a benevolent human rule (1:28; 2:20), now will find itself struck by Eve’s descendant.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Traditionally 3:15 has been called the Protoevangelium and understood as the first messianic prophecy. This understanding is as old as the Septuagint (3d cent. "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("), but it is usually dismissed by modern commentators. 3:15 simply refers to the struggle between snakes and humans. But this is too facile. In this highly symbolic story exploring the nature of sin and its consequences, the snake is the anti-God figure. Since 3:15 is a curse on the snake, it must surely come out worse in the human-snake war. This seems to be hinted at by the fact that the snake is struck on the head, while the woman’s offspring is struck on the heel. In other words, the curse is predicting victory for mankind over the snake, that is, over the anti-God forces. But how exactly this will be achieved is left obscure.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The curse on the woman is also problematic. The pain of childbearing clouds the joy of being fruitful and multiplying, the purpose of creating mankind in two sexes (1:27–28). But how does the curse affect relations between husband and wife? According to Genesis 2 relations ought to be characterized by supportiveness on the wife’s part (2:18), commitment to his wife’s welfare by the husband (2:24), and intimacy between them (2:25). But 3:16 suggests that relations will often be marred by the wife’s desire for independence (in the light of 4:7 the most likely interpretation of “desire”; so Foh), and the husband’s arrogance.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As for the curse on the man, Ecclesiastes offers the fullest commentary on the frustrations of all human existence, which ends in death (3:19; cf. Ecclesiastes 6, 9, 12; Rom 5:12–21).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("3:22–24")]), _vm._v(" The story closes with the ultimate penalty: expulsion from the garden means loss of the chance of eternal life and the enjoyment of perfect life in the immediate presence of God. Thus in the most significant sense Adam and Eve did die on the day that they ate of the tree (2:17). The human race is excluded from the divine sanctuary which is Eden and prevented from returning by the cherubim and a fiery sword. The cherubim are human-headed lions or bulls, which served as the guardians of Mesopotamian temples and decorated the Israelite ark of the covenant and its sanctuaries.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Genesis 2–3 may also be read as a paradigm of every sin: it describes what happens every time someone disobeys God. The essence of sin is rejecting God’s commands, preferring human wisdom to his. The immediate consequence of sin is disruption of relations, introducing alienation between God and man and between man and man. The long-term effects of sin are toil, pain, blighted relationships, and ultimately death.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Hess R. S., and D. T. Tsumura 1994, especially the articles by Speiser, Hauser, and Walsh • Foh, S. T. 1974/75, “What Is the Woman’s Desire?” "), _c('i', [_vm._v("WTJ")]), _vm._v(" 37:377–83 • Kempf, S. 1993, “Gen 3:14–19: Climax of the Discourse?” "), _c('i', [_vm._v("Journal of Translation and Textlinguistics")]), _vm._v(" 6:354–77 • Moberly, R. W. L. 1988, “Did the Serpent Get it Right?” "), _c('i', [_vm._v("JTS")]), _vm._v(" 39:1–27.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Family of Cain (J) (4:1–26)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Genesis 4 concludes the first section of the book (2:4–4:26). As elsewhere in the opening chapters, there are a number of allusions to other oriental accounts of origins, particularly the Sumerian Flood Story in 4:17–26. The first half of the chapter echoes ch. 3 at many points (e.g., 4:9 par. 3:9; 4:10 par. 3:13; 4:11 par. 3:14, 17; 4:15 par. 3:21; 4:16 par. 3:24). These parallels invite us to read the stories together. They point up the parallels between the sins of Adam and Cain, but the differences are just as significant.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Genesis 3 describes how sin disrupts relations between husband and wife and between God and man. Genesis 4 shows it producing hatred between brothers and deeper alienation from God. Cain is portrayed as a more hardened sinner than Adam. He rejects God’s plea not to sin, whereas Adam had to be tempted. Cain murders his brother; he does not just eat a fruit. Cain denies knowledge of his sin, but Adam acknowledges it. Adam accepts his sentence, whereas Cain protests. Genesis 4 pictures sin progressively mastering the human race and causing ever greater ills. Cain’s son Lamech is an even nastier character than his father. Not only does he go in for bigamy, a practice implicitly criticized in 2:18–24, but he boasts that he is more vicious than his father (4:23–24).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("4:1–16")]), _vm._v(" As in the previous story, the climax is found in the divine sentence passed on the sinner (4:10–15), while the opening section explains the background. Typically children are named by the mother to explain some circumstance peculiar to their birth (cf. 29:32–30:24), but Cain is the first human to be born, and he is given a name that is valid for every child: “I have produced a man with the help of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("” (4:1). Abel’s name means “breath” or “vanity,” anticipating his brief life (Ps 144:4). The likeliest explanation for God’s rejection of Cain’s sacrifice is its poor quality. He only brought “some [not “offering,” NRSV] of the fruit of the ground,” whereas Abel brought firstlings and their fat portions, that is, their best parts. Sacrifice must be costly and blemish-free to be fit for God (cf. Lev 22:20–22; 2 Sam 24:24).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("God’s offer of forgiveness to Cain goes unheeded. Instead he slays his brother. When he is interrogated by God, he first lies and then cracks a joke (4:9). Contrast Adam’s candor in 3:9–12. The idea that shed human blood pollutes the land and cries out to God for vengeance is a principle that informs OT attitudes to homicide. Unusually, Cain is not himself sentenced to death but to be a nomad (4:12). In the Sumerian Flood Story nomadism was a plight from which the gods saved mankind, not the punishment of the first murderer. Nevertheless even murderers’ prayers are heard, for God assures Cain that ")]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("he will not be executed. Cain is marked—quite how is obscure—in a way that serves both as a reminder of his sin and a promise of protection; cf. the clothing of Adam and Eve (3:21). However, he seems to end up further away from Eden and God than his parents, showing the more severe punishment of his sin.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("4:17–22")]), _vm._v(" Sumerian tradition told of sages who rose from the ocean and taught mankind the arts of civilization, such as metal working, city building, and music. By ascribing such arts to the line of Cain and Lamech, Genesis is intimating that for all their glory they are tainted by sin. The savage boast of Lamech of seventy-sevenfold vengeance suggests that even the young and able-bodied “man” / “young man” would be terrorized by villains like Lamech were it not for the protection of the law of talion (Exod 21:25 echoes the terminology of Gen 4:23), which prescribes punishment proportionate to the crime.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("4:25–26")]), _vm._v(" The section ends with a glimmer of hope, however, with the birth of Seth, who is the ancestor of the chosen line via Noah and Shem. It is characteristic of Genesis to deal with the non-elect line (here Cain before Shem) before recounting the chosen line. It also a regular feature of Genesis to have a trailer at the end of each major section to lead into the next section; for example, 6:5–8 appears before 6:9–9:29. Here 4:26 anticipates the genealogy of ch. 5. It also notes the first worship of the true God, another ray of hope, after the grim recital of the deeds of Cain and Lamech. “[I]nvoke the name of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("” (NRSV) is an overliteral translation: the Hebrew does not imply that worshipers actually used the name Yahweh (first revealed to Moses in Exod 6:3); as elsewhere in Genesis (e.g., 12:8; 13:4), it simply means people worshiped the God who later made himself known to Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Hess, R. S., and D. T. Tsumura. 1994, especially the articles by Jacobsen and Miller.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Descendants of Adam (5:1–6:8)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The heading “This is the list … Adam” marks this as the next main section of Genesis (cf. 2:4; 6:9; 11:27, etc.). It consists of the genealogy of Adam via Seth, already foreshadowed in 4:25–26, a note about the sons of God (6:1–4), and a trailer for the story of the flood (6:5–8).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("5:1–32 (P)")]), _vm._v(" It is a feature of Genesis that genealogies alternate with major narratives. Later in the book it is non-elect lines such as those of Ishmael (25:12–18) and Esau (36:1–43) whose history is summed up in a genealogy, but here the saved line of Seth is the focus. Scholars have noted that some of the names in this list are similar to the names in the line of Cain (e.g., Methuselah/Methushael) or even identical (Enoch and Lamech); so they have argued that the genealogies in chs. 4 and 5 are just variants of one original. However, the similarities may be as easily explained as assimilation of two originally divergent lists to each other (Bryan). Clearly the editor regarded them as distinct lines, for in the case of the two men with identical names Enoch and Lamech he includes a modest amount of biographical data in 5:21–24, 28–31 distinguishing them from their predecessors in 4:17, 19–24.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The ages of these antediluvians is problematic. Though they are modest compared with the tens of thousands of years that the comparable figures in the Sumerian King List reigned (see above on the introduction to Genesis 1–11), they can hardly be taken literally. Various suggestions have been offered to explain them, from gematria (assigning numerical values to words) to astronomy (e.g., Enoch’s age 365 = days in a year). Most probable is the suggestion of U. Cassuto (commentary) and Young that there must be a connection with Babylonian mathematics given the frequency of numbers related to 60 and its factors (e.g., 930 = 30"), _c('sup', [_vm._v("﻿2")]), _vm._v(" + 30), but they have not suggested a plausible symbolism that explains all the individual numbers. At present all that can be said is that they reflect the author’s belief that these people were real yet lived a long time ago.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("5:1–2 strongly echo the summary of the creation of man in 1:27–28. It leaves out the command to “be fruitful and multiply,” but the genealogy itself shows the fulfilment of this mandate (cf. 6:1). Verse 3 makes the point that every descendant of Adam is in his image and by implication in the image of God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Thereafter each rung of the genealogy is strongly formulaic; only the names and ages vary, except for the seventh, Enoch, and the ninth, Lamech. Enoch “walked with God” (vv. 22, 24). The repetition of this comment underlines his intimacy with God (cf. 6:9; 17:1; Mic 6:8; Mal 2:6), so it may be that his unusually brief life by the standards of this chapter and the mode of his translation to heaven, “he was no more, because God took him” (cf. 2 Kgs 2:1), are seen as a reward for his piety. Interestingly, according to Mesopotamian tradition the seventh sage, Utuabzu, is also said to have ascended to heaven.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("5:29")]), _vm._v(" Lamech’s naming of Noah also interrupts the tight genealogical formulae. His name expresses the hope that Noah will counteract the curse placed on mankind for Adam’s sin. Note the strong echoes of 3:17. “bring us relief” (Heb. "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("nḥm")])]), _vm._v(") involves a play on Noah’s name (Heb. "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("nḥ")])]), _vm._v(") that occurs again in 6:6–8. Paronomasia like this is common in Genesis, but here it serves to highlight the significance of Noah within the story. He is a second Adam, from whom the whole human race is descended. In his time the world is destroyed and then recreated. The description of his character in 6:8–9 leads the reader to hope with Lamech that his birth will bring in a new age for mankind.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Hess, R. S., and D. T. Tsumura. 1994, especially articles by Borger, Malamat, and Wilson • Bryan, D. T. 1987, “A Reevaluation of Genesis 4 and 5 in the Light of Recent Studies in Genealogical Fluidity,” "), _c('i', [_vm._v("ZAW")]), _vm._v(" 99:180–88 • Young, D. W. 1988. “On the Application of Numbers from Babylonian Mathematics to Biblical Life Spans and Epochs,” "), _c('i', [_vm._v("ZAW")]), _vm._v(" 100:331–61.")])]), _c('p', {
    staticClass: "Body1"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('b', [_vm._v("6:1–4")]), _vm._v(" Who are the sons of God, and whom did they marry? Among the answers offered by commentators ")]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("throughout the years are kings, the descendants of Seth, or the descendants of Cain. Corresponding to these identifications, their wives have been viewed as members of royal harems, women descended from Cain or from Seth. However, there is a consensus among modern commentators that concurs with the oldest Jewish and Christian interpretation that the sons of God are spirit beings and their consorts are ordinary human women. The OT pictures the one supreme God attended in heaven by a host of spirit beings. Some of them are called “sons of God” (Job 1:6; Pss 29:1; 82:1–6). Near Eastern and classical mythology related unions between the gods and human beings leading to the birth of semi-divine supermen such as Gilgamesh. They seem to be what 6:4 calls “the Nephilim, the heroes … of old,” mentioned only in Num 13:33 elsewhere in the OT.")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Though this episode seems very strange to modern demythologized readers, it is clearly of great moment in Genesis, for it triggers off God’s reflections in 6:5–7 to destroy the human race. What was so heinous about the divine-human intercourse, and why is mankind and not the spirit realm punished for it? Though v. 2 has been read as describing the rape of the women, in fact the verbs imply perfectly legitimate marital arrangements, which could be entered into only with the full consent of the girls’ fathers. It has been suggested that perhaps the practice of placing girls in temples to perform sacred marriages with the god is being alluded to here. Thereby the fertility of the ground and ordinary wives was supposedly secured. At any rate, only girls designated by their parents could serve as temple prostitutes, and this could explain why the human race was punished. The Creator had blessed procreation at the beginning (1:28), so this attempt to promote fecundity was totally misguided. It also transgresses the clear line that the OT draws between different species (mixed breeding is banned by various laws in Lev 19:19; 20:16; Deut 7:3; 22:9–11) and particularly between God and man (cf. Gen 3:22).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("6:3")]), _vm._v(" The limitation of human life to 120 years is gradually implemented in the Pentateuch. After Jacob only Aaron (123) exceeds it.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Gemeren, W. A. van. 1981, “The Sons of God in Gen 6:1–4,” "), _c('i', [_vm._v("WTJ")]), _vm._v(" 43:320–48.")]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('b', [_vm._v("6:5–8")]), _vm._v(" This brief paragraph is a trailer for the flood story, but it is much more. Generally regarded as the creation of the author of Genesis, it is a key to the book’s theology. It paints human sin and God’s reaction to it in the darkest colors. Sin infects every human thought (6:5). It is an outrage to God: “grieved to the heart” describes the strongest and bitterest human reactions to terrible deeds (34:7; 1 Sam 20:34; Isa 54:6). So strong is God’s reaction that he decides to wipe out all living creatures—not just man but animals and birds as well. "), _c('i', [_vm._v("How")]), _vm._v(" is not described yet.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, even the announcement of destruction is tinged with hope: hidden within the words “sorry” and “blot out” are letters like those in Noah’s name. And eventually we are told “Noah found favor”; even the word “favor” "), _c('i', [_vm._v("("), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ḥn")]), _vm._v(")")]), _vm._v(" in Hebrew is Noah spelled backward. In this way the closing paragraph introduces the theme of the next major section (6:9–9:29), the universal judgment in which only Noah and his family will be saved.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Noah and the Flood (J and P) (6:9–9:29)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The story of Noah and the flood has captured the human imagination for thousands of years. This constitutes the third section of Genesis introduced by the title “These are the descendants of” (cf. 2:4; 10:1). On first glance the coda about Noah’s drunkenness does not have much to do with what goes before, but it does serve to foreshadow the next section (ch. 10) and has a close parallel with the end of the other tale of universal destruction in Gen 19:30–38.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Older versions of the flood story (Sumerian, Atrahasis, and Gilgamesh) dating in their original forms from the early second millennium "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" are known. As already noted above (pp. 36–37), there are remarkable similarities between the Mesopotamian and biblical accounts of the flood, so close in some cases that it has been alleged that the biblical tale is based on the Mesopotamian. On balance direct dependence seems unlikely: more probably both versions are drawing on traditions about the flood that were common in the ancient orient. A comparison of the biblical and nonbiblical accounts highlights the very different theologies of the accounts. We have already mentioned the monotheistic moralism that informs the biblical narrative over against the caprice, self-interest, and weakness of the Mesopotamian gods and goddesses. Whereas they send the flood to curb the population explosion, the God of Genesis encourages mankind to multiply but is appalled by human sin. They cower at the flood they unleash and do not fully understand its consequences, but in Genesis it is totally under the Creator’s control. In the Mesopotamian epics Atrahasis (Utnapishtim = Noah) is glorified as a hero as his epic deeds in building and loading the ark are recounted in full, whereas Genesis simply says, “Noah did all that the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" commanded him.” Obedience to God, not human courage, is what Genesis celebrates. Other points of similarity and difference will be pointed out below.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("According to the documentary hypothesis, Genesis 6–9 is an example of the intertwining of two independent sources (J and P) to create the present account of the flood. As elsewhere in this commentary, I shall not discuss this here. Westermann and Ska have observed that if the basic analysis is accepted, P appears to be the basic source, which is supplemented by J. It should also be noted that the existing Genesis flood story looks more like the Gilgamesh version than either of the putative earlier versions J and P. It is also only the final version that has a full-scale mirror-image (chiasm, palistrophe) structure, where a feature at the beginning of the story is echoed at a matching point later on. Up to a point this is almost inevitable in telling a flood story: the waters rise and then fall, the animals enter the ark and later come out, and so on. But there are so many examples of this phenomenon in this tale that it can hardly be coincidence; ")]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("it must be a literary device. For example, the days in the story exhibit this pattern.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('table', {
    staticClass: "Table1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('p', {
    staticClass: "verse"
  }, [_vm._v("7 days")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_c('p', {
    staticClass: "tdleft2"
  }, [_vm._v("(7:4)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('p', {
    staticClass: "verse1"
  }, [_vm._v("7 days")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_c('p', {
    staticClass: "tdleft2"
  }, [_vm._v("(7:10)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('p', {
    staticClass: "verse2"
  }, [_vm._v("40 days")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_c('p', {
    staticClass: "tdleft2"
  }, [_vm._v("(7:17)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('p', {
    staticClass: "verse3"
  }, [_vm._v("150 days")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_c('p', {
    staticClass: "tdleft2"
  }, [_vm._v("(7:24)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('p', {
    staticClass: "verse4"
  }, [_vm._v("GOD REMEMBERED NOAH")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_c('p', {
    staticClass: "tdleft2"
  }, [_vm._v("(8:1)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('p', {
    staticClass: "verse3"
  }, [_vm._v("150 days")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_c('p', {
    staticClass: "tdleft2"
  }, [_vm._v("(8:3)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('p', {
    staticClass: "verse2"
  }, [_vm._v("40 days")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_c('p', {
    staticClass: "tdleft2"
  }, [_vm._v("(8:6)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('p', {
    staticClass: "verse1"
  }, [_vm._v("7 days")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_c('p', {
    staticClass: "tdleft2"
  }, [_vm._v("(8:10)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('p', {
    staticClass: "verse"
  }, [_vm._v("7 days")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_c('p', {
    staticClass: "tdleft2"
  }, [_vm._v("(8:12)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("Thus the shape of the story does not simply mirror the events it relates, but its center, “God remembered Noah,” focuses on the two key actors in the story and reminds us that God is in charge of this cosmic catastrophe. Indeed, within Genesis the flood is most important theologically, for it divides world history into two epochs, before and after the flood. The flood serves to undo the work of creation in Genesis 1. The waters are no longer held in check by the firmament as they burst through the dome of the sky, and the dry land is no longer separated from the seas as even the high mountains are covered. Finally, all God’s living creatures, from insects to birds, land animals, and man, are wiped out, except for those lucky enough to have embarked on the ark. The flood may therefore be viewed as a great act of de-creation: the frequent echoes of the phraseology of Genesis 1 in chs. 6 and 7 emphasize this.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, it is followed by an act of re-creation. When God remembers Noah, creation begins to be restored. The waters above the firmament are restrained. Gradually the dry land reappears. Eventually all the creatures in the ark disembark and are recommissioned to be fruitful and multiply and fill the earth (9:1). Noah is a second Adam, the father of the new human race.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Though creation is thus restored, the situation after the flood is not the same as it was before. The flood was prompted by the incorrigibility of the human heart, “every inclination of the thoughts of their hearts was only evil continually” (6:5). But God gives almost the same reason after the flood for never destroying mankind again, “for the inclination of the human heart is evil from youth” (8:21). In context it appears that God’s implacable anger against human sin is turned into forgiveness or at least toleration by the sacrifice of Noah (see 8:20). In the long divine speech that follows other differences between the situations before and after the flood are signaled. Originally the plants were assigned as the only food for man and beast (1:29–30); now animals may be eaten, as long as their blood is not consumed. But human life is sacrosanct: murderers must be executed, for man is made in God’s image (9:3–6). Homicide also conflicts with the creation mandate to be fruitful and multiply. Finally, the rainbow is designated the sign of the covenant, a guarantee of the preservation of future generations (9:8–17).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("6:9–21")]), _vm._v(" The first scene in the flood story is, like the last (8:20–9:17), essentially a divine monologue about the situation and what God proposes to do.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("6:9")]), _vm._v(" Noah is portrayed as a model Israelite. He is “righteous,” the normal term for a moral person who keeps the law. More than that he is “blameless,” that is, above reproach (like Job in Job 12:4; cf. 1:1, 8), and he walked with God, putting him on a par with Enoch (5:22). Throughout the story he does exactly what God tells him (6:22; 7:5, 9, 16). He is also in covenant with God (6:18; 9:9), distinguishes clean and unclean animals, keeps the sabbath (at least he works on a weekly cycle), and offers acceptable sacrifice (7:3; 8:10, 12, 20–21).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("6:11–13")]), _vm._v(" By contrast the earth is filled with violence, that is, antisocial behavior often involving force directed against the poor and weak of society. “All flesh,” animals and humans, are misbehaving in this way. Therefore, as they are corrupting the earth, so they will be destroyed (lit. “corrupted”) by God. This wordplay shows how the punishment fits the crime.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("6:14–20")]), _vm._v(" To allow Noah and a selection of animals to escape, he must build an ark. The ark of the Gilgamesh Epic was a perfect cube, 120 cubits each way, whereas Noah’s ark is recognizably boat-shaped, each deck of which was the same height as the tabernacle and three times the area of the tabernacle court. This leads Westermann to suggest that the biblical writers saw both tabernacle and ark as serving the preservation of humanity. “To a cubit above” (6:16) either leaves a gap of a cubit (18 in. or 45 cm.) between the roof and the side of the ark, or lets the roof overhang by a cubit.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("6:17–20")]), _vm._v(" further explain the building of the ark and why it must be victualed with food.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("6:22")]), _vm._v(" (= Scene 2), in contrast to the Gilgamesh Epic, sums up the vast work of building the ark and loading it in one sentence, thus emphasizing Noah’s total obedience.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("7:1–4")]), _vm._v(" constitutes the third scene, like the first a divine monologue, and focuses on the command to enter the ark and embark the animals. To ensure their survival a male and female of each species was necessary, but this left no spares for sacrifice. Hence extra clean (sacrificial) animals were taken. The Gilgamesh Epic allows only seven days to build the ark and seven days of rain, whereas Genesis stretches the event out much longer.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("7:5–16")]), _vm._v(", the fourth scene, colorfully describes how Noah and the animals obeyed the command to embark. The use of repetition, apposition, and expansive phraseology gives the description a special solemnity. Most striking is the precise dating of the different phases of the flood, which is most unusual in the OT. It underlines that the flood marks the end of one epoch and the beginning of another. Possibly the dates themselves have symbolic significance. If Genesis is using the “Jubilees” calendar, the flood began on a Sunday (= the 17th day of the 2d month; 7:11), and it stopped raining on a Friday 40 days later (7:12). Creation began on a Sunday and was completed on Friday according to Genesis 1, so the work of de-creation also ran from Sunday to Friday.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("7:16")]), _vm._v(" “The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" shut him in,” whereas according to the Gilgamesh Epic Utnapishtim himself shut the door. Genesis emphasizes that Noah was saved by grace, not by his own wisdom or effort.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('b', [_vm._v("7:17–24")]), _vm._v(" In this scene the narrative reaches its peak, with the waters triumphing over the earth and all flesh ")]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("dying. The lists of dead creatures (vv. 21, 23) hark back to Genesis 1, as does the submerging of the mountains, which leaves the earth covered with water as it was in 1:2. The work of creation has been undone.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("8:1–5")]), _vm._v(" “God remembered Noah” marks the turning point (cf. 30:22; 19:29) and ushers in the process of recreation. The wind blows (cf. 1:2), the rain stops (cf. 1:7), and the land reappears (cf. 1:9). “Ararat” is Urartu, a kingdom north of Assyria, roughly modern Armenia. Gilgamesh (11:140) grounds the ark on Mt. Nisir somewhat further south.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("8:6–14")]), _vm._v(" The bird scene, picturesque in itself, slows down the action and allows the reader to sense Noah’s impatience to disembark. In the Gilgamesh Epic a dove, a swallow, and a raven are sent out.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("8:15–19")]), _vm._v(" At last they are told to leave, and Noah, exact as ever in his obedience, disembarks.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("8:20–9:17")]), _vm._v(" The last scene, like the first (6:9–21), is essentially a divine monologue. The first was prompted by God’s reflections on human sinfulness, this by the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s reflections on Noah’s sacrifice. In the first God declares his intention to annihilate the human race; here he promises to preserve it. But this section does more than this: it sets out the terms of the covenant under which God will continue to ensure the continuation of life on earth, modifying in certain respects the mandates originally given at creation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In Gilgamesh Utnapishtim also offers a sacrifice when he comes out of the ark, and the gods crowd like flies around the sacrifice because they have gone hungry during the flood since the only surviving human beings, their food suppliers, have been cooped up in the ark! Not only does Genesis reject the idea that man feeds the gods (1:29; 9:3), but it sees a quite different role for sacrifice. It creates a “pleasing odor” (better, “soothing aroma”), which appeases God’s anger. Usually this phrase appears in connection with sacrifices offered in the tabernacle (e.g., Lev 1:9; 2:2), which atone for the worshiper. Here the second father of the human race offers a sacrifice which secures the survival of all his descendants.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("According to the Atrahasis Epic, after the flood the gods decided to put a brake on human population growth by making some women infertile and others to suffer stillbirth. But Genesis rejects this. Not only are the animals encouraged to reproduce (8:17), but three times Noah and his sons are urged to multiply (9:1, 7). Human life is to be protected from assault by man or beast on pain of the death penalty (9:5–6) and from the threat of destruction in another flood (8:22; 9:11). The rainbow in the sky is a sign of God’s covenant never to send another flood. Biblical signs usually serve to remind man of God’s promises; here most unusually the rainbow reminds God.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Noah’s Drunkenness (9:18–29)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("After the tranquil and positive conclusion to the flood story, this episode jars. Noah, we have been told, was “blameless in his generation.” His obedience has been exemplary, and his sacrifice led to the promise of future security. What is he doing drunk and cursing his grandson? In fact, though the flood story ended optimistically, it did not suggest that the future would be without problems. The human heart remains incorrigibly evil (8:21), and murders may be committed (9:5). Nevertheless, that Noah, the paragon of virtue, should succumb to wine is disappointing. Some commentators think that Genesis is not critical of Noah’s conduct, only Ham’s. Certainly the OT values wine as one of God’s gifts (Ps 104:15) and insists on its use with animal sacrifice (Num 15:5–10). However, priests had to abstain before officiating, and Nazirites were teetotal for the period of their vow, which indicates that drunkenness is incompatible with holiness (Lev 10:9; Num 6:3–4; 1 Sam 1:14). It thus seems likely that Noah’s overindulgence in wine is seen as parallel to Adam’s mistake in his garden. This is the fall of the second Adam.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, the offense of the son is much worse than that of the father (cf. Cain and Adam). But what exactly did Ham do wrong? Was it merely looking at his naked father and gossiping about it to his brothers? This has seemed unlikely to Western readers, who have posited Ham committing incest with his mother or something similar. But since Shem and Japheth remedy their brother’s mistake simply by covering Noah up without looking at him, it is unnecessary to posit any acts of sexual intercourse by Ham. Rather, this story gives an insight into the Hebrew sense of propriety (cf. Exod 20:26) and filial duty: sons were supposed to cover up their father’s follies, not publicize them.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Just how serious Ham’s offense is emerges from Noah’s curse on his grandson Canaan, Ham’s son. He is to be slave to his brothers; in other words, the Canaanites will be subject to the descendants of Shem and Japheth. This is at least a prophecy of the future conquest of Canaan by Israel, a descendant of Shem, but other aspects are obscure. Surely Ham deserved the curse, not Ham’s son? It may be that God’s blessing of Noah’s sons (9:1) precluded him from cursing Ham himself. It may be that the punishment mirrors the offense: Ham was Noah’s youngest son, so his youngest son Canaan is cursed. Or it may be that Ham’s attitude anticipates that of his descendants, such as the Egyptians and Canaanites, who by OT standards were notorious for sexual impropriety (Lev 18:3).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("9:27")]), _vm._v(" “Let Japheth live in the tents of Shem.” All sorts of improbable suggestions have been made about what this refers to. There is no obvious situation in which Shemites and Japhethites were in league against Canaan, unless perhaps Genesis 14 is its fulfillment. Elam descended from Shem (10:22) and Goiim (“coastland peoples”) from Japheth (10:5), and both conquered a league of Canaanites (14:1–2).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Though the precise referent of Noah’s prophecies is obscure, however, they do serve to suggest the future shape of relationships between groups of peoples, the subject of the next chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Hess, R. S., and D. T. Tsumura. 1994, articles by Anderson and Wenham • Ska, J. L. 1994, “El relato del diluvio,” "), _c('i', [_vm._v("EstBíb")]), _vm._v(" 52:37–62 • Wenham, G. J. 1991, “Method in Pentateuchal Source Criticism,” "), _c('i', [_vm._v("VT")]), _vm._v(" 41:84–109.")])]), _c('p', {
    staticClass: "H2"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("From Flood to Folly (J and P) (10:1–11:9)")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Like the second section of Genesis (5:1–6:8), this fourth section begins with a heading, “These are the descendants of,” and combines a longish genealogical list with a summary of universal judgment. It begins with a mention of the flood (Heb. "), _c('i', [_vm._v("mabbul")]), _vm._v(") and ends with the similar-sounding word Babel (here associated with “confusion” or “folly”); hence the attempted alliteration in my title of this section. As in 5:1–6:8, a positive account of the increase in human population (cf. 9:1, 7) is followed by a tale of man’s attempt to bridge the human-divine barrier, this time by building a skyscraper; in 6:1–4 marriage between gods and humans was the approach. This time judgment does not take the form of a flood, but of dispersion of the peoples over the globe and confusion of their languages.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This dispersal is already hinted at in the Table of Nations (10:1–32), which alludes to their spread across the world (10:5, 25, 32). As elsewhere in Genesis, the non-elect groups are treated before the group associated with the chosen line (here Japheth and Ham before Shem, in ch. 4 Cain before Seth, in ch. 25 Ishmael before Isaac, and in chs. 36–37 Esau before Jacob).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Ethnographically, this Table of Nations is without parallel in the ancient world. It is unique in setting out the relationship between Israel’s neighbors and its relation to them. To oversimplify the table, we may say that the Japhethite peoples are those on Israel’s geographical horizon with whom it had the least to do. The Hamites include Israel’s bitterest enemies, from Assyria in the east to the Egyptians in the west and the Canaanites and Philistines in between. From the Shemites Israel traced not only its own descent but also that of friendly nations such as the Arameans and Arabs. The positive evaluation of the Shemites on the one hand and the negative view of the Hamites on the other indicates how this Table of Nations shows the fulfillment of Noah’s blessings and curses in 9:25–27.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Linguists often speak of Semitic and Hamitic languages, but it should be noted that language is not the basis for the categorization of peoples in this table. Several of the Hamites speak Semitic languages (e.g., Canaan, Assyria), while at least one of the Shemites (Elam) speaks a non-Semitic language. Theological politics is the basis of these divisions, not linguistics. Many of these people or places cannot be identified with certainty, so degrees of doubt will be indicated in brackets. For further discussion of the identifications larger commentaries must be consulted.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Table of Nations (10:1–32)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('b', [_vm._v("10:2–5")]), _vm._v(" The Japhethites lived to the north and west of Israel. V. 2: Gomer (Cimmerians), Magog (in Anatolia?), Madai (Medes), Javan (Ionian Greeks), Tubal and Meshech (in Anatolia), Tiras (from Asia Minor). V. 3: Ashkenaz (Scythians), Riphat (near the Black Sea?), Togarmah (north of Carchemish). V. 4: Elishah (city in Crete?), Tarshish (Carthage?), Kittim (Cyprus), Rodanim (Rhodes?), but MT reads Dodanim (Dodona in Greece?)")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("10:6–20")]), _vm._v(" The Hamites include some of Israel’s most dangerous enemies, including Assyria, Egypt, and Canaan. The uniting factor is that the descendants of Ham are under the curse of 9:25.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("10:6–14")]), _vm._v(" V. 6: Cush (Ethiopia?), Put (Libya?). V. 7: These places may be in Arabia. Vv. 8–9: Nimrod seems to personify the fighting and hunting ideals of Mesopotamian kings. V. 10: Babel (Babylon), Erech (Uruk/Warka), Shinar (Babylonia). V. 11: Rehoboth-ir (suburb of Nineveh?), Calah (Nimrud). V. 12: Resen (Hamam Ali, south of Nineveh??). V. 13: These peoples must have lived in or near Egypt. V. 14: Pathrusim (southern Egyptians), Casluhim (one of the Sea Peoples??), Caphtorim (Cretans).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("10:15–20")]), _vm._v(" This is the first definition of the land of Canaan and its inhabitants in the OT. According to Egyptian texts and Numbers 34, the territory of Canaan comprised much of southern Lebanon, southwest Syria, and modern Israel. This seems to be the area envisaged here (Aharoni 1966: 69–70). It runs down the Mediterranean coast from Sidon to Gaza, across to the Dead Sea (Sodom, Gomorrah, Admah, Zeboiim and Lasha). Though not specified, the inclusion of the Zemarites (from Sumur) and Hamathites (Hamath) shows that Canaan included part of Syria. V. 15: Heth: The sons of Heth (Hittites) lived in Hebron (23:2–3). V. 16: Jebusites lived in Jerusalem (2 Sam 5:6). 10:17–18: Arkites, Sinites, Arvadites, Zemarites (inhabitants of Phoenician coastal cities).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("10:21–31")]), _vm._v(" Following the convention of Genesis, the family of the chosen line of Shem comes last. The longer genealogy of Shem to Abram (11:10–26) is anticipated too (10:22, 24, 25). Insofar as the names in Shem’s line can be identified, they seem to represent peoples well disposed to Israel. For example, Eber is the eponymous ancestor of all the Ibri or Hebrews (10:21).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("10:22")]), _vm._v(" Elam (east of Mesopotamia); Asshur, presumably not Assyria (cf. v. 11), but a Sinai tribe of that name (cf. Num 24:22; 2 Sam 2:9; Ps 83:8). Arpachshad (Kirkuk??), Lud (Lydia?). Aram: Israel had close relations with the Arameans who lived in Syria (cf. 25:20; 31:20; Deut 26:5), but their descendants (v. 23) are hard to locate. Vv. 26–29 are mostly names of places or tribes in southern Arabia or the Yemen. V. 30 presumably mentions places in southern Arabia.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Aharoni, Y. 1966, "), _c('i', [_vm._v("The Land of the Bible")]), _vm._v(", London: Burns & Oates • Hess, R. S., and D. T. Tsumura. 1994, articles by Simons, Speiser, and Wiseman.")]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('b', [_vm._v("11:1–9")]), _vm._v(" The conjunction of the tower of Babel and the Table of Nations illustrates again how human progress in populating the earth and building skyscraper-like ziggurats may lead to hubris and judgment. Babel is the scene of the last great universal judgment on mankind in primeval history. The attempt by man to reach up to heaven is thwarted by the divine decree confusing human languages, making cooperation by the human race on godless projects impossible. Throughout the Bible Babylon is viewed as the great anti-God power (cf. Isa 14:13–15; Dan 2:38; Rev 18:4, 20). Here her folly and impotence before the Almighty are strikingly revealed.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("No close oriental parallels to the tower of Babel story ")]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("are known. As with Genesis 2–3, it is more a case of familiar Mesopotamian motifs being reused in a final rejection of Babylonian religion and its pretensions. For example, Babel literally means “gate of the god,” that is, there you were closer to the gods than anywhere else on earth. It was a commonplace of Babylonian mythology that temples had their roots in the underworld and their tops reached up to heaven (cf. 11:4). But Genesis mocks these ideas. Far from the temple tower reaching heaven, the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" had to come down just to see it (11:5). Babel does not mean “gate of the god” but “confusion” or “folly” (the Hebrew words “let us confuse” [11:7] and “folly” are almost the same).")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("According to the Sumerian epic “Enmerkar and the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" of Aratta” there would come a time when all nations would speak one language—Sumerian—proof of the ultimate triumph of that culture and its religion. But as elsewhere, Genesis contradicts this Mesopotamian optimism; indeed, the home of such human arrogance is the place where it was judged. It was at Babel that God confused the one language of humanity, preventing future cooperation on such ventures and leading to the dispersal of races across the earth. Thus the diversity of human languages, like the pain of childbirth and the toil of agriculture, is a reminder of divine judgment on human sin. But Babel, symbol of universal judgment, is the setting for the beginning of the story of salvation, for Ur, the home of Abraham, is not far south of Babylon.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("11:2")]), _vm._v(" “Shinar”: cf. 10:10.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Hess, R. S., and D. T. Tsumura. 1994, articles by Kramer and Sasson.")]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('b', [_vm._v("11:10–26 (P)")]), _vm._v(" The genealogy of Shem is the fifth section in Genesis to be introduced by the formula, “These are the descendants of …” (cf. 2:4; 5:1; 6:9; 10:1). Five more follow, introducing each section of the patriarchal history (e.g., 11:27; 37:2). This genealogy is the first of three which preface the patriarchal narratives. This one precedes the story of Abraham (11:27–25:11), 25:12–18 precedes the story of Jacob and Esau (25:19–35:29), and 36:1–37:1 comes before the Joseph story (37:2–50:26).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("On the other hand, its form connects it most closely with what precedes, for it closely resembles the genealogy in ch. 5. The formulae of each rung of the genealogy are like those of the earlier one. There are ten generations from Shem to Abram, as there are from Adam to Noah. The penultimate father in each genealogy has three sons—Shem, Ham, and Japheth, and Abram, Nahor, and Haran. Both genealogies are briefly inaugurated in the preceding section (4:25–26; 10:24–25). In other words, the genealogy of Shem acts as a bridge tying the primeval history and the patriarchal together.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("When the genealogies in ch. 5 and 11 are compared, they reveal two obvious differences. First, the closing formulae, “Thus all the days of X were …” (e.g., 5:8, 11, 14), are missing in ch. 11. Second, the life spans of the later people are noticeably shorter. This contrast between the ante- and postdiluvians is also evident in the Sumerian King List. In Genesis it illustrates the gradual implementation of the threat to reduce the span of human life to 120 years (6:3).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Abraham Cycle (11:27–25:11)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("With the story of Abraham Genesis changes gears. The tales are no longer pan-oriental traditions retold from a monotheistic standpoint, but stories peculiar to Israel tracing the origins of the nation back to the early second millennium. The historicity of these patriarchal traditions has been much discussed, and there is little sign of the emergence of a firm scholarly consensus. In the mid-twentieth century mainline critics and more conservative scholars may have disagreed about the date of Genesis’s composition, but they were sure that many of the stories originated in the period in which they are set, namely, the second millennium "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". It was pointed out that the names of the patriarchs were old-fashioned names beloved of the Amorites. Many of the family customs attested in Genesis could be paralleled in legal texts from Babylon, Nuzi, and other early sites. The migrations of the patriarchs were compatible with the political situation of that time too. Thus whether these stories were committed to writing in the time of Moses, the age of Solomon, or much later, we could be confident that the patriarchs were historical figures (e.g., de Vaux, Bright, and Westermann).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, in the last quarter of the century skepticism about the historicity of the patriarchs became more common. It was pointed out that the arguments for the age of the traditions were at points shaky, especially those based on legal parallels and archeological remains. When these doubts were coupled with a tendency to date the earliest part of Genesis, the J source, to the late sixth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", the whole of the book could be regarded as fiction (so Thompson and Van Seters).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Space does not permit a review of these arguments here; it simply allows me to state a position. It may well be that the scholarly pendulum swung too far from excessive historical credulity to an equally unjustified skepticism. The way that Genesis portrays patriarchal religion as different from later Mosaic religion and the conflict between patriarchal practice and later law is hardly likely to have been created by a novelist who believed in the law and worship as prescribed in the Pentateuch. He surely would have wanted the fathers of the nation to conform to later orthodox practice if he were simply inventing them (Moberly).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But whether modern scholars regard these stories as historical or not, there is no doubt that the author of Genesis intended them to be read that way. And generations of readers have supposed them to be about real people, the earliest ancestors of Israel. To grasp the intention of the writers, therefore, we need to read them, at least to start with, this way as well.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("Other clues to the writers’ standpoint are apparent from a review of the material in Genesis. First, we should note the bulk of the material relating to the patriarchs, especially Jacob, whose life story spans chs. 25 to 50, more than half the book. Whereas Christian readers have often been most interested in the opening chapters of the book with their focus on creation, sin, and the fall and in Abraham as a model of faith, the book itself is most interested in Jacob. His name was later changed to Israel, and he fathered ")]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("the twelve tribes. This indicates the chief interest of the book, the origins of the nation of Israel and its place in the divine purpose. Chs. 1–11 serve to set the scene for the main plot, the story of the family of Jacob.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Second, the main narrative of the patriarchs is split into three major sections: 11:27–25:11 (the story of Abraham), 25:19–35:29 (the story of Jacob and Esau), and 37:2–50:26 (the story of Jacob’s sons). Each begins with the title, “These are the descendants of …” (or, better, as in 37:2), “This is the story of the family of.…” Though the Hebrew is the same, the NRSV varies the translation. Then, too, each section ends with the death and burial of the major figure by his surviving sons (Isaac and Ishmael bury Abraham, 25:9; Jacob and Esau bury Isaac, 35:29; and Jacob is buried by his sons, ch. 50). Between these major sections we have genealogies of the descendants outside the chosen family, Ishmael (25:12–18) and Esau (Edom) (36:1–37:1). These genealogies have the same title, “These are the descendants of …,” as the major sections. This alternation of long narratives and short genealogies is also the pattern of Genesis 2–11 (see above).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Third, within each major section there are similar topics: (A) the heroes leave home (12:1; 28:2; 37:28); (B) they quarrel with their brother(s) (13:7; 27:41; 37:4); (C) they go down to Egypt (12:10; 37:28; 46:6); (D) their wives are barren and quarrel (16:1–6; 29:31–30:8); and (E) the younger son is divinely favored (17:18–19; 25:23; 48:14; 49:8–12, 22–26). There is a similar sequence of topics toward the end of each section, namely: (A) divine promise (22:15–18; 35:9–14; 48:4); (B) journey (22:19; 35:16; 48:5); (C) birth of sons (22:20–24; 35:17–18; 48:5–6); (D) burial of wife (23:1–20; 35:18–20; 48:7); (E) son’s marriage (24:1–67; 35:21–22; 48:8–9; cf. 49:3–4); (F) list of descendants (25:1–6; 35:22–26; 49:3–28); and (G) patriarch’s death and burial (25:7–10; 35:27–29; 49:29–50:14). Some of these parallels are merely coincidental, but their frequency suggests that the writer was deliberately inviting the reader to compare the experience of one patriarch with that of another. Within chs. 12–25 there is a loose palistrophic structure (cf. flood story); for example, ch. 22 echoes ch. 12, chs. 18–19 echo chs. 13–14, and ch. 17 echoes ch. 15. This type of pattern is even clearer in the stories of Jacob and Esau in chs. 25–35, but it is not apparent in chs. 37–50, the Joseph story (see Rendsburg and Wenham, 1:262–63; 2:169).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Recurrent patterns and parallels highlight the constancy of God’s purposes on the one hand and human failings on the other. But a fourth feature of these cycles is the development of plot and characterization from one to another. In Genesis 1–11 God is the chief actor in almost all the stories, but in the patriarchal stories he progressively retreats into the background. He often speaks to Abraham, more rarely to Isaac and Jacob, and to Joseph only indirectly through dreams. This is not to say that God is absent from the Joseph story; indeed, the whole narrative has been termed a story of divine providence. But there is clearly a development in the way God speaks to man from one cycle to the next. At the narrative level the personalities of the patriarchs are more sharply defined from one cycle to the next. In the Abraham story we have a series of snapshots; with the Jacob and Esau stories we can almost construct a biography; but with Joseph and his brothers we have a well-integrated family tale whose personalities come vividly to life.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Finally, each patriarchal cycle begins with a divine revelation which sets out the program for the ensuing narrative: 12:1, “Go to the land”; 25:23, “The elder shall serve the younger”; and 37:5–11, Joseph’s dreams, which envisage his family bowing down to him. However, the first passage (12:1–3) is the most important in that it sets out not simply the program of Abraham’s career but the theme of the whole Pentateuch, which Clines has aptly defined as the partial fulfillment of the promises to the patriarchs. Here Abraham is promised a new land, descendants to inherit it, divine blessing and protection, and that through him all nations will find blessing. These promises are clarified, amplified, and made even more specific later on (see 12:7; 13:14–17; 15:4–21; 17:1–21; 22:16–18; 26:2–5; 28:13–15; 46:3–4), and all the narratives from Genesis 12 onward need to be read to see how the action in them promotes or hinders the fulfillment of these promises. But they also relate back to the narratives in Genesis 1–11, which show a world in dire need of divine blessing. These chapters tell of two false starts to human history, the first headed by Adam, the second by Noah. The first ends with universal judgment in the flood, the second with universal dispersal at Babel. The call of Abraham represents a third attempt to cure the human condition, but this time success is guaranteed, for “in you all the families of the earth shall be blessed” (12:3). When and how are not stated, but this and the associated promises should be constantly in the back of the reader’s mind as he or she tries to make sense of the rest of Genesis.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Clines. 1978 • Hess, R. S., P. E. Satterthwaite, and G. J. Wenham, eds. 1993, "), _c('i', [_vm._v("He Swore an Oath: Biblical Themes from Genesis 12–50")]), _vm._v(", Cambridge: Tyndale House • Moberly 1992a, 1992b • Rendsburg, G. A. 1986, "), _c('i', [_vm._v("The Redaction of Genesis")]), _vm._v(", Winona Lake: Eisenbrauns • Seters, J. Van. 1975, "), _c('i', [_vm._v("Abraham in History and Tradition")]), _vm._v(", New Haven: Yale University • Vaux, R. de. 1978, "), _c('i', [_vm._v("The Early History of Israel")]), _vm._v(", trans. D. Smith, London: Darton, Longman and Todd.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Call of Abram (J and P) (11:27–12:9)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This key section begins by explaining Abram’s family situation, which may be displayed as a family tree")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/image001.jpg"
    }
  })])]), _c('p', {
    staticClass: "Body1"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("Haran died before Terah and the rest of the family left Ur, so it appears that Lot was adopted by his uncle Abram, or at least joined his entourage. Note that this section is headed “These are the descendants of Terah.” Although Abra(ha)m is the central and most active person, ")]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("he was part of Terah’s extended family until Terah died 135 years after the birth of Abram just two years before the death of Sarai (11:26, 32; 23:1). Thus for most of the period covered by Genesis 12–25 Terah was head of the family. Similarly, the titles of 25:19 and 37:2 mention the head of the family, not the leading actors in the subsequent stories. 11:30 mentions Sarai’s infertility, another crucial element in the following story. Ur in southern Mesopotamia and Haran in the north were both centers of the moon god Sin, and it may not be coincidence that the names Terah, Sarai, and Milcah were all connected with this religion.")])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("12:1–3")]), _vm._v(" As already mentioned, these verses are not merely programatic for the Abraham stories, but they sum up the theme of the Pentateuch. The hard command to leave his home (12:1) is later echoed in the last divine command to Abraham in 22:2. In both cases there is an initial vagueness about what is required: the “land/mountain that I will show you.” But later speeches (e.g., 17:8; cf. 12:5) show that the land being promised was Canaan, a land defined by Egyptian texts as comprising roughly modern Israel, Lebanon, and part of Syria.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The command to go and the promise of land are followed by further promises of numerous descendants (cf. 13:16; 15:5), blessing, and fame, and yet more blessing. Blessing (Heb. "), _c('i', [_vm._v("brk")]), _vm._v(") occurs more frequently in Genesis than in any other book of the Bible. Lists of blessings (e.g., Lev 26:3–13; Deut 28:1–14) show that blessing meant long life, many children, good harvests, peace, and God’s presence. Indeed, the name Abraham is almost a pun on blessing, for it contains two of the same consonants. Here he is told that he will be a blessing, that is, people looking at him will say, “May God bless me like Abraham.” Further, the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" says that those who do this will themselves be blessed, and the few (NRSV, “one”) who disdain him will be cursed, that is, punished by God. But ultimately all the families (the term refers to quite large groups; 10:5, 18, 20) of the earth will find blessing in him.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("12:4–9")]), _vm._v(" records Abram’s radical obedience. Uprooting himself and his family, he shortly arrives in Canaan. He is rewarded by a fresh and more specific statement of the promise as “the land I will show you” becomes “this land.” Abram himself responds by building altars and invoking the name of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", that is, worships through the offering of prayer and sacrifice (cf. 4:26). Bethel and Ai, usually identified with Beitin and Et-Tell, are about ten miles north of Jerusalem.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Abram in Egypt (J) (12:10–20)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Radical obedience is now followed by craven unbelief. This is the first of three stories where a patriarch describes his wife as his sister and nearly loses her to a foreign king (cf. 20:1–18; 26:1–11). This episode foreshadows the later experience of the nation of Israel in that, when they became aliens in Egypt, the life of their males was endangered, the girls were spared, and they all escaped with the wealth of the Egyptians, though only after plagues had been inflicted on Pharaoh. However, in this case the behavior of Pharaoh is much less blameworthy than that of his successor. Here he sounds genuinely shocked at the way he has been misled (cf. 20:9; 26:10), whereas the Pharaoh of Moses’ day persisted in holding Israel despite repeated warnings. Nevertheless, Abram emerges from Egypt relatively unscathed, surely reflecting the divine promise of blessing.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, this does not justify his behavior in the writer’s eyes. Having been promised the land of Canaan in 12:7, he should not have contemplated settling in Egypt as an immigrant, as the Hebrew word "), _c('i', [_vm._v("ger")]), _vm._v(" (“alien”; v. 10) implies, nor, given the divine assurance of protection in v. 3, should he have been so worried about his safety, let alone assumed Egyptian immorality (cf. vv. 18–19).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Modern readers are most perplexed at how Sarai could be regarded as so attractive at age 65 (cf. 12:4; 17:17), and why Abram thought describing as his sister would save him from danger. There are no obvious solutions to these problems. Oriental men doubtless preferred well-endowed, matronly figures to slim girls, and it may be that the narrator considers that, if Sarah could give birth at ninety albeit miraculously, she must have still been attractive to men twenty-five years earlier. By describing Sarai as his sister Abram may have hoped to avoid offense by not refusing her hand to a would-be husband but to spin out any negotiations for her marriage for such a long time that nothing would happen. For other examples of such delaying tactics by brothers cf. 24:55; 34:13–17. Unfortunately this plan did not work with Pharaoh, who brooked no delay!")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Back to Canaan (J, P) (13:1–18)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Foreshadowing the later exodus from Egypt, Abram leaves with all his family and property and, like his successors, “journeys by stages” through the Sinai wilderness into the dry region of southern Canaan known as the Negeb. He eventually reaches Bethel, where once again he offers sacrifice and worships. His return to this place of promise (cf. 12:7) and his silence after the Pharaonic rebuke in 12:19 suggest that he is intent on making a new start.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("His changed attitude emerges more clearly in his generous treatment of his nephew Lot in the dispute about grazing rights. Abram allows Lot to pick the area he would like. Lot chooses the greenest area in the Jordan valley, near Sodom and Gomorrah, because it looked like Eden, “the garden of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(",” and more ominously like the land of Egypt. If Sodom and Gomorrah were on the east bank of the Dead Sea, at or near Bab ed-Dhra, this means that Lot was moving out of the land of Canaan promised to Abram. That this was an unwise choice is noted by the narrator, who anticipates the cities’ later destruction because of their wicked inhabitants (13:10, 13).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("Lot’s move is followed by a reaffirmation of the divine promises to Abram. They are introduced by the verbs “separate,” “raise your eyes,” and “look” used earlier of Abram’s invitation to Lot in vv. 9–10, implying that the promises are a response to Abram’s faith and generosity. But these promises are more than a restatement of what was said earlier; they go well beyond the formulations in ")]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("12:1–3, 7, “"), _c('i', [_vm._v("all")]), _vm._v(" the land … I will give to you and your offspring "), _c('i', [_vm._v("forever")]), _vm._v(".” What is more, Abram’s offspring will not just be a great nation but uncountable, “like the dust of the earth.” Finally, Abram is invited to “walk through the length and breadth of the land,” a symbolic gesture for taking possession of it.")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The episode closes with Abram settling in Hebron, about twenty miles south of Jerusalem. The traditional location of the oaks of Mamre is two miles north of Hebron. This is the setting of much of the subsequent Abraham story. Here the promises will be further elaborated, and here the patriarchs and their wives will be buried. But as usual Abram makes his campsite a sanctuary by building an altar and, though not said here, offering a sacrifice.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Abram Rescues Lot (pre-J?) (14:1–24)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This chapter is distinctive in its style, in its portrayal of Abraham, and in its historical and geographic detail. It thus poses peculiar problems for historical critics, who sharply disagree about its source and its historicity: some regard it as based on a very early document, while others see it as a late fictional midrash. These issues cannot be discussed fully here, and longer commentaries need to be consulted. Here the focus is on the place of this episode within the present book of Genesis.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This chapter tells of three military campaigns in Canaan by kings of the east. Lot is captured in the second, and this leads to Abraham’s intervention in the third. And it is the successful outcome of this campaign that forms the backdrop to the theologically most important scene, Abram’s encounter with Melchizedek, king of Salem, and Bera, king of Sodom. Their very different attitudes to Abram, one blessing him and the other disdaining him, presage their contrasting fates (cf. 12:3): Melchizedek represents the first of all the families of the earth who find blessing in Abraham, while the disdainful king of Sodom will experience the curse associated with despisers of Abram in the destruction of his city.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("14:1–4")]), _vm._v(" tell of the campaign of four eastern kings against five kings of the Dead Sea valley. The sites of Sodom, Gomorrah, Admah, Zeboiim, and Zoar are uncertain. They have often been supposed to lie beneath the southern shallow part of the Dead Sea, for in this region there is a smell of sulphur (cf. 19:24), and asphalt deposits are most abundant there (cf. 14:10). However, no cities have been found there. More recently five sites on the eastern shore occupied in the third millennium have been discovered; one of them, Bab ed-Dhra, was finally abandoned around 2100 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". This is rather early for the time of Abraham, but its destruction could be the basis of the story of Sodom.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("All sorts of identities have been proposed for the eastern kings and their countries of origin. Amraphel is not Hammurabi, but he does come from Babylonia, or “Shinar” (cf. 10:10). Arioch seems to be a Hurrian name "), _c('i', [_vm._v("(Ariwuku)")]), _vm._v(", and Ellasar may be Pontus in Asia Minor. Chedorlaomer sounds like a good Elamite name, and Elam (cf. 10:22) lies east of Mesopotamia in modern Iran. Tidal is probably Hittite "), _c('i', [_vm._v("tudhaliya")]), _vm._v(", but it is uncertain whether Goiim is a designation of the Hittites or a wider grouping of peoples. Unfortunately, though some individuals with these names are known, it is impossible to link them all together at the same time, let alone in the same campaigns, and so locate their campaign chronologically. This does not prove they did not happen, but extrabiblical evidence for this period is too sparse and this account does not allow us to fix the period of Abraham precisely.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("14:5–12")]), _vm._v(" The second campaign is described in more detail, partly because Lot was captured in it and partly to show the strength of the forces overcome by Abram. Led by Chedorlaomer, the kings struck southward, defeating a variety of peoples (Rephaim, Zuzim, and Emim) occupying towns on the King’s Highway, the main north-south route through Transjordan. When they reached El-Paran, probably Eilat at the head of the Red Sea, they swung westward through the northern Sinai peninsula to Kadesh, probably Ain Hudeirat, a large oasis on the borders of Canaan. They then headed northeast to Hazazon-tamar, which must lie somewhere between Kadesh and the Dead Sea.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The battle with the Dead Sea kings is described briefly, suggesting a rout. It is not clear whether the defeated kings hid in the bitumen pits or whether falling in means that they were trapped and died in the pits. In that the king of Sodom reappears in 14:17, it cannot imply his death. Because Lot now lived in Sodom (he was not in 13:12), he was carried away captive.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("14:13–16")]), _vm._v(" From Abram’s pursuit it is apparent that the kings were fleeing northward to Dan and then on beyond Damascus. His decisive defeat of them after their series of triumphs over all their other opponents demonstrates that God is on his side. It is striking that Abram could raise 318 fighting men from his group, which would imply that there were at least a thousand people in his clan. However, the quarrel with Lot over grazing rights, his treaty with Abimelech (21:22–34), his title “mighty prince” (23:6), and the mention of his concubines (25:6) all point to his heading a sizable clan.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("14:17–24")]), _vm._v(" Abram’s reception by Melchizedek and the king of Sodom is the climax of the episode. Its theological significance has already been briefly addressed, but details deserve further comment. Salem is probably Jerusalem (cf. Pss 76:2; 110:2–4). Melchizedek treats Abraham to a royal banquet of bread and wine and then blesses him in the name of El Elyon. El was the high creator God in the Canaanite pantheon, as the epithet “maker of heaven and earth” shows. In response Abram gives Melchizedek a tithe of all his booty. If Melchizedek is viewed as a representative of Jerusalem, this episode bodes well for future relations between that city and later Israel. It may also serve to justify the payment of tithes to the city. If Abram did this, then his descendants should do so too.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("By contrast, the king of Sodom, for whom Abram has done much more than he did for Melchizedek, appears ungrateful and grasping. There is no meal offered or blessing pronounced, just a brusque demand. Abram assures him that he is not out to profit from rescuing the ")]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("people of Sodom; only his warriors will take the regular share of the booty. Given that attitudes to Abram and his offspring are seen in 12:3 as a touchstone of divine benevolence, Sodom’s surliness bodes ill for the future.")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_vm._v("The Covenant Promise (J/[E]) (15:1–21)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Abram’s public triumph over the eastern kings cannot expunge the private tragedy of his childlessness, which was viewed as a disaster in the ancient world. Without children there was no one to carry on the family name, preserve the inheritance, care for you in old age, or carry out the funerary rites for the repose of your soul after death. In Abram’s case there was an added poignancy in that he had been promised children by God (12:2, 7; 13:16), yet nothing had happened. It still looks as though Eliezer, one of his household (not necessarily a slave, "), _c('i', [_vm._v("pace")]), _vm._v(" NRSV), will inherit from him. In other words, Abram will have to adopt him if he has not done so already.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In response to this the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" promises Abram a real son and heir fathered by himself. At this point the mother is not specified. Though the reader assumes that Sarah will bear the child, this is not made explicit till 17:16. In ch. 16 we see that Abram and Sarai thought of other possibilities. However, Abram did at least believe he would father a child, and “the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" reckoned it to him as righteousness” (15:6). Righteousness normally means living a good life and keeping the commands of the law (Ezek 18:5). It is the righteous who are acquitted by God (e.g., Ps 1:6). But here most unusually it is faith in the promise that counts as righteousness, a point to which St. Paul draws attention in Romans 4 and Galatians 3.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This faith prompts a reaffirmation of the land promise (15:7). Again Abram asks for confirmation, and he is asked to produce a number of animals usually used in sacrifice, kill them, cut them in two, and lay them in two lines. Then when darkness fell, Abram heard a prophetic explanation of the Egyptian slavery and subsequent exodus, and saw a smoking fire pot, evidently symbolizing the presence of God, pass between the pieces. Then the extent of the land his descendants will possess is further explained: it will stretch from the Euphrates in the north to the river of Egypt in the south (whether Wadi el-Arish or the Nile is not clear), boundaries that were only achieved by the Davidic empire (vv. 18–21).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The significance of the ceremony of the bisected animals and the fire pot has been much discussed. Most scholars compare the rite to the self-imprecations used in ancient treaty making. Animals were slain, and the partners to the treaty invited the gods to treat them similarly if they were unfaithful to it. In other words, the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" is invoking a curse on himself should he not fulfill his promise. Another way of reading the ceremony is based on the identification of sacrificial animals with Israelites, a key principle in understanding OT sacrifice. In this case God is passing through the middle of his people in a symbol that anticipates the cloud of fire that appeared at Sinai and accompanied their wilderness wanderings. In other words, the smoking fire pot symbolizes God’s presence with the future descendants of Israel as they proceed to the promised land. This interpretation fits in with the message to Abraham about the exodus and conquest in vv. 13–16 and 18–21. According to Lev 11:13–19, “birds of prey” are unclean and therefore represent foreign powers, perhaps in this context Egypt. In other words, it was Abram’s faith, displayed in driving off the birds, that preserved his descendants from annihilation in Egypt.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Williamson, P. R. 2000, "), _c('i', [_vm._v("Abraham, Israel and the Nations")]), _vm._v(", Sheffield: Sheffield Academic.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Birth of Ishmael (J/P) (16:1–16)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Ten years after the promise of descendants had first been made to Abram, there was still no progress, so Sarai decides to take the initiative. The two usual approaches to childlessness in the ancient Near East were to take a second wife (cf. 1 Sam 1:1–2) or surrogate marriage, whereby a slave girl bore a child for her mistress. This had the advantage of avoiding the problems inherent in bigamy, and the child counted as the wife’s, not the slave-girl’s. But the narrator hints that this is not God’s way. He does so, first, by the way Sarai blames God for her predicament, “The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" has prevented me.…” Second, he hints through the way the story echoes Genesis 3, with Sarai taking and giving (cf. 3:6) and Abram listening to her voice (cf. 3:17). Finally, the bitter conflict that ensues between Sarai and Hagar when the latter conceives hardly suggests that the scheme is approved by God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Hagar is the victim of Sarai’s scheming and Abram’s acquiescence, and the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" steps in to rescue her. This is the first appearance of the angel of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" in the Bible; it is the human form in which God appears to people, most often in times of crisis (cf. 21:17; 22:11). Often the angel is initially mistaken for a man (18:2; Judg 6:11–22). His demand here that she should return to Sarai sounds harsh, but it is coupled with the first statement of the promises directly to a woman (16:10; cf. 15:5). This is also the first birth oracle, “you have conceived and shall bear a son and shall call his name,” a formula that regularly announces the birth of saviors within the Bible (cf. Judg 13:3; Isa 7:14; Luke 1:31). Finally, his name, typical of early Amorite names, means “God [El] has heard.” These promises are then rounded off by a prophecy of Ishmael’s bedouin lifestyle (cf. 25:18); the wild ass, more like a horse than a donkey, is used elsewhere of a free, unconventional way of life (Jer 2:24).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Hagar gratefully acknowledges God’s concern for her by naming him “El-roi,” that is, “God, who sees me,” for she said, “Truly here I have seen him who looks after me” (so ESV, Booij, and Koenen as opposed to the NRSV). In due course her son was born, but contrary to Sarai’s plan, Ishmael did not count as her child, but Hagar’s. Three times in two verses the narrator underlines that “"), _c('i', [_vm._v("Hagar")]), _vm._v(" bore Abram a son” (16:15–16). God cannot be manipulated.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Booij, T. 1980, “Hagar’s Words in Gen 16:13b,” "), _c('i', [_vm._v("VT")]), _vm._v(" 30:1–7 • Koenen, K. 1988, “Wer sieht wen? Zur Textgeschichte von Gen 16:13,” "), _c('i', [_vm._v("VT")]), _vm._v(" 38:468–74.")])]), _c('p', {
    staticClass: "H2"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("The Covenant of Circumcision (P) (17:1–27)")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This chapter represents a high point in the Abraham story. It contains five divine speeches reaffirming and elaborating the promises in the most categorical terms. Abram and Sarai’s names are changed to the more familiar Abraham and Sarah. There is little difference in meaning between the old and new names, but the name change marks God’s intention that they will both share in the creation of nations. Finally, the rite of circumcision is introduced as a pledge of the eternal covenant between God and Abraham’s descendants.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("17:1–8")]), _vm._v(" begin with the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" introducing himself as El Shaddai, God Almighty, the older name of God according to Exod 6:3. Its etymology and meaning are obscure, but wherever it is used in Genesis it is associated with the promise of descendants. And almost immediately the promise of descendants is reaffirmed. On earlier occasions Abraham had been assured that he would become a nation and that his descendants would be too many to count. Now he is assured that he will be the father of many nations and that kings would be descended from him. What is more, the covenant made with him would be everlasting, and as a corollary the land, here designated Canaan for the first time in a speech, is designated as his offspring’s perpetual holding.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("17:9–14")]), _vm._v(" This statement of the promises, however, requires a response. Abraham must walk before God and be blameless, a high calling rarely attained by OT heroes (cf. 5:22; 6:9; Job 1:1). What is more, he and all his male offspring must submit to the rite of circumcision. Though women are full members of the covenant people and are expected to keep most aspects of the law, male participation in positive religious duties is especially stressed in the OT and later Judaism, and the command to circumcise men alone is of a piece with this attitude.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Circumcision was practiced by other peoples of the ancient orient, including the Egyptians, Canaanites, and Arabs, but not by the Philistines or Hivites (34:2, 14). Only in Israel was it a sign of the covenant, that is, a reminder to them of their obligation to keep the law and love the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" with all their heart, soul, and strength. So important was the sign that failure to be circumcised could lead to that man being cut off, that is, suffer a premature death sent by God. The episode thus ends with Abraham circumcising himself and all the members of his household “that very day,” a phrase that marks the event as a turning point in saving history, comparable to the flood or the exodus from Egypt (7:13; cf. Exod 12:17).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, before that comes the most astonishing formulation of the promise, this time that the elderly Sarah would bear a child. Abraham had obviously concluded that thirteen-year-old Ishmael was the promised child (17:18). He had given up hope that Sarah would conceive. His very laughter at the idea, however, is an inadvertent confirmation of it, for “and laughed” in Hebrew also spells “and Isaac.” Like Jacob and Ishmael, Isaac is a typical early-second-millennium Amorite name. It probably is a shortened form of the phrase “El [God] laughs/smiles,” but it could refer to the father’s joy—“He laughs” (cf. 21:6). Not only is it now specified that Sarah will be the mother of the promised child, but for the first time his birth date is announced, “at this season next year.” Once again the new form of the promise is not a mere repetition of what has been said before but a development making the promise more specific and firm.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". McEvenue, S. E. 1971, "), _c('i', [_vm._v("The Narrative Style of the Priestly Writer")]), _vm._v(", Rome: Biblical Institute.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Abraham, Lot, and Sodom (J) (18:1–19:38)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("No period of twenty-four hours in Abraham’s life is described more fully than this. This suggests the importance of this episode in the plot of the Abraham story; yet on first reading it seems rather a sidetrack. It begins with the renewed promise of a son for Sarah (18:1–15), which seems redundant in the light of ch. 17, continues with Abraham’s abortive intercession for Sodom (18:16–33), and describes Lot’s last hours in and escape from Sodom (19:1–29) and finally his intercourse with his daughters, leading to the birth of Moab and Ben-Ammi (19:30–38). It is not immediately apparent what all these events have to do with the theme of Genesis, the partial fulfillment of the promises.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This section is not only long, but it is tightly organized. The central section concerning Sodom is a large palistrophe, like the flood story in Genesis 6–8 (see above):")]), _vm._v(" "), _c('p', {
    staticClass: "PF"
  }, [_vm._v("A) Visitors look toward Sodom (18:16)")]), _vm._v(" "), _c('p', {
    staticClass: "PM1"
  }, [_vm._v("B) God’s reflections on Abraham and Sodom (18:17–21)")]), _vm._v(" "), _c('p', {
    staticClass: "PM2"
  }, [_vm._v("C) Abraham pleads for Sodom (18:22–33)")]), _vm._v(" "), _c('p', {
    staticClass: "PM3"
  }, [_vm._v("D) Angels arrive in Sodom (19:1–3)")]), _vm._v(" "), _c('p', {
    staticClass: "PM4"
  }, [_vm._v("E) Assault on Lot and visitors (19:4–11)")]), _vm._v(" "), _c('p', {
    staticClass: "PM5"
  }, [_vm._v("F) Sodom’s destruction foretold (19:12–13)")]), _vm._v(" "), _c('p', {
    staticClass: "PM4"
  }, [_vm._v("E′) Lot’s sons-in-law reject appeal (19:14)")]), _vm._v(" "), _c('p', {
    staticClass: "PM3"
  }, [_vm._v("D′) Departure from Sodom (19:15–16)")]), _vm._v(" "), _c('p', {
    staticClass: "PM2"
  }, [_vm._v("C′) Lot pleads for Zoar (19:17–22)")]), _vm._v(" "), _c('p', {
    staticClass: "PM1"
  }, [_vm._v("B′) Sodom and Gomorrah destroyed (19:23–26)")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("A′) Abraham looks toward Sodom (19:27–28)")]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("This mirror-image pattern is further enhanced by the opening section (18:1–15) discussing the birth of a child to Sarah, and the closing section (19:30–38) describing the birth of children to Lot’s daughters.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But it is not just the structure of these chapters that recalls the flood story; their topic is similar too. Both are tales of universal judgment from which only one man and his family escape. Furthermore, the terminology of chs. 18–19 echoes the flood story (“destroy,” 18:28, 31, etc.; cf. 6:13, 17; “reach out their hands,” 19:10; cf. 8:9; “shutting the door,” 19:10; cf. 7:16; “find favor with,” 19:19; cf. 6:8; “save life,” 19:19; cf. 6:19, 20; “preserve offspring,” 19:32, 34; cf. 7:3; “rain,” 19:24; cf. 7:4). Finally, “God remembered Abraham” recalls “God remembered Noah” (19:29; cf. 8:1). It may also be noted that both stories conclude with a coda in which the righteous hero gets drunk and then is disgracefully abused by his son or daughters (9:20–27; 19:30–38).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("So how do these chapters contribute to the theme of Genesis? First, the second announcement of the birth of ")]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("Isaac underlines the certainty that Sarah will indeed conceive. As Joseph later explained to Pharaoh, “The doubling of the dream means that the thing is fixed by God, and God will shortly bring it about” (41:32). It must also be noted that this second announcement, though ostensibly directed to Abraham, is really aimed at Sarah, quietly eavesdropping on her husband’s conversation from the tent. It is now her turn to express incredulity at the news; nothing is said about Abraham’s reaction.")])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Second, these chapters emphasize Abraham’s special status in God’s eyes. He asks rhetorically, “Shall I hide from Abraham what I am about to do?” (18:17). Abraham is seen as a prophet (cf. 20:7) who is privy to the secrets of the divine counsel (Jer 23:18), and then he goes on to intercede for Sodom: intercession for sinners is a key prophetic activity (Exodus 32; 1 Sam 12:23; Jer 14:11; 15:1). And the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" is ready to answer his prayer: if there had been only ten righteous people in Sodom, it would have been spared. Unfortunately, as ch. 19 makes clear, there were not. “All the people to the last man” were involved in attempting to rape the visiting angels. Clearly the wickedness of Sodom typifies that of many of the Canaanite cities that were later to fall to Israel, and explains why not everyone would be blessed in Abraham, however much he interceded for them.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("18:1–15")]), _vm._v(" The narrator informs us that “The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" appeared to Abraham,” but to him they seemed to be just men (cf. comments on ch. 16). But later it is apparent that two of them are angels (19:1) and the other is the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" (18:22). Though Abraham discovers their identity in the course of conversation, his treatment of them certainly befits deity as he prepares a feast of a calf and bread made with choice flour usually reserved for sacrifice (three seahs = six gallons or twenty-four liters). For Mamre (18:1) cf. 13:18.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Like Abraham in 17:17, Sarah is incredulous when she hears the promise of a son, and she laughs, another play on the name Isaac, thereby confirming the promise indirectly. It may seem odd that her disbelief is not more severely reprimanded, but the way she describes herself, “After I am worn out” (ESV), shows that her unbelief is not arrogance but despair after a lifetime of disappointment that had taught her not to clutch at straws.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("18:16–33")]), _vm._v(" Abraham’s intercession for Sodom is one of the most remarkable in the Bible, not least in that it is for a non-Israelite community; later prophets such as Moses, Amos, and Jeremiah pray for Israel, not for other nations. It is also remarkable in being prompted by the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" himself. He comments on Abraham’s character and then remains standing before him after the angels have left. (This assumes the older reading of 18:22, NRSV footnote.)")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Abraham’s appeal is based on God’s justice, that it would be quite wrong to treat the righteous and wicked exactly alike. V. 25 uses forensic language to stress the inequity of such a judicial sentence. Abraham begins by pleading for Sodom to be spared if it contains fifty righteous, possibly half the adult males of the town, and he then progresses down to forty-five, forty, thirty, twenty, and ten. The intercession proceeds in two cycles of three pleas. In the second cycle Abraham sounds noticeably more diffident and the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s replies become increasingly less encouraging, presumably prompting Abraham to ask no more. We are left to wonder whether there are ten righteous in Sodom.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("19:1–14")]), _vm._v(" But not for long. Righteous Lot, the only foreigner in Sodom, receives the angelic visitors as hospitably as Abraham had. Though his activities are described more briefly—“he made them a feast” and he insisted that they should stay for the night—he was just as good a host as his uncle. But it is ominous that his visitors were so reluctant to come in and that no Sodomites had welcomed him.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Soon the reason for the angels’ anxiety becomes clear as a mob, “all the people” of Sodom, attempt to storm Lot’s house, demanding to “know” his visitors. In itself “knowing” is quite an innocent term, but the context here makes it apparent that sexual intercourse is meant (19:8; cf. 4:1). In the ancient Near East outside Israel (cf. Lev 18:22) homosexual acts between consenting adults do not seem to have been banned, but homosexual rape was, except to humiliate prisoners of war. Everywhere it would have been regarded as abhorrent to treat guests this way; rather, there was a sacred duty to look after them. Lot’s offer of his daughters shows how seriously he took his responsibility toward his guests. It also suggests little regard for his daughters. However, it is dubious whether this is an example of patriarchal sexism that would have been approved by the author or his earlier readers. Later on Jacob is implicitly censured for not taking the assault on his daughter Dinah more seriously (ch. 34). Rather, Lot’s proposal illustrates his desperation: he could not think of any other way of appeasing the mob. Only the intervention of the “men,” who thereby disclosed their supernatural identity, saved the situation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If the assault on Lot’s house showed his isolation within the city and that there were no righteous besides him, his sons-in-law’s rejection of his appeal to escape the destruction of the city confirms it.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("19:15–26")]), _vm._v(" Even Lot himself and his family find it difficult to take the angelic warning seriously. They have to be dragged out of the city, then Lot protests about fleeing to the hills, and eventually he goes to Zoar instead. His wife looks back to Sodom and is turned into a pillar of salt. Though it is often surmised that this is an aetiology for the salt formations around the Dead Sea, in context it is another illustration of the divided loyalty of Lot and his family. Even the most righteous in the city are halfhearted about following divine instruction. Nevertheless, the rescue of Lot is a reminder that Abraham’s prayer for the city was not entirely fruitless (19:29).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('b', [_vm._v("19:30–38")]), _vm._v(" The final incident is both pathetic and repulsive. It invites comparison with 9:20–27. Lot eventually does settle in the hills, as he had been told (19:17). He had been a rich rancher before settling in Sodom (13:2–13); now, fearful for life itself, he retreats to the abject poverty of a cave dweller. There he is manipulated by his daughters to have intercourse with them. Their excuse (19:31) is patently false, as there were still people living in Zoar nearby. The writer clearly does not approve of their behavior (cf. 9:20–27) and records it simply to mention ")]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("the origins of some of Israel’s nearest neighbors, the Moabites and Ammonites, and to show what can happen to those who walk out of the covenant community and the land of promise (cf. ch. 13).")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Wenham. 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Sarah and Abimelech (E or J[?]) (20:1–18)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("What an extraordinary sequel to the preceding chapter! After Abraham’s intimacy with the Almighty in ch. 18 and his bold intercession for Sodom, it is astonishing to find him behaving with the same fearfulness in Gerar as he had earlier in Egypt (12:10–20). The way ch. 20 is phrased presupposes the reader’s knowledge of that earlier episode. It is also noteworthy that the king of Gerar, on the southwestern border of Canaan near Egypt, should be so pious and God-fearing after the Sodomites were so godless. It is also striking that this second royal abduction of Sarah occurs shortly before the birth of Isaac.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The narrative is at pains to point out that although Abimelech had taken Sarah into his harem he never touched her, so there is no question of the parentage of Isaac. The story does imply that she did live in Abimelech’s court for some time, for there was time for his wives to stop conceiving (vv. 17–18); indeed, it appears that some illness struck the court which also prevented him approaching Sarah (vv. 6–7).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The episode illustrates the faithfulness of God in keeping his promises to Abraham despite the latter’s faults. Abraham and Sarah do escape from this situation physically unscathed; they are financially enriched but also justly rebuked. Abimelech indeed invites him to settle in the land, a reminder of the land promise, and through Abraham’s prayers Abimelech and all his household are healed, reflecting the assurance that all the families of the earth should find blessing in Abraham. This episode reemphasizes that it is God’s grace, not patriarchal faithfulness, that is the ultimate guarantee of the fulfillment of the promises.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("20:1–7")]), _vm._v(" V. 1: Negeb; cf. 13:1; Kadesh; cf. 14:7. V. 4: Note that the sin of the leader may affect his people (cf. 2 Sam 24). V. 7: on Abraham’s prophetic intercessory role cf. the commentary on ch. 18.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Alexander, T. D. 1997, "), _c('i', [_vm._v("Abraham in the Negev")]), _vm._v(", Carlisle: Paternoster.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Isaac Displaces Ishmael (J/E/P) (21:1–21)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("At last, twenty-five years after the promise of nationhood was first announced, Isaac was born, the first visible fulfillment of the promises. The importance of his birth is underlined by its repeated mention in 21:1–2. It is followed by circumcision, demonstrating Abraham’s fidelity to the covenant (17:12). Sarah expresses her own joy by breaking out into poetry with a series of plays on Isaac’s name (laugh, laughter).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, by the time Isaac was weaned at about three years old (2 Macc 7:27) attitudes had changed. Sarah noticed Ishmael Isaacing (lit. “laughing, mocking”; the NRSV’s inclusion of “with her son Isaac” is unnecessary). In other words, Ishmael, now about seventeen, was pretending mockingly to be Isaac, Abraham’s chosen heir. Doubtless he was displeased at the fuss being made about his baby brother, but his behavior provoked maternal ire. It also showed disregard for the divine plan that the chosen line should pass through Isaac (21:10). That is why in this case, contrary to 16:2, Abraham is told to follow Sarah’s advice. Nevertheless, he is very distressed at the prospect of losing Ishmael, his first-born son, whom he had anticipated fulfilling the promises for a long time (17:18). So he shows his affection for them by giving them food and water for the journey.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Despite the NRSV, it is not necessary to suppose that Ishmael rode piggyback on Hagar’s shoulders (21:14). Had that been the case, she would have been more likely to have collapsed from thirst than Ishmael, given the difficulty of carrying a skin of water, food, and a child. In fact, except where stressing the bond between parent and child, the story always refers to Ishmael as a “lad” "), _c('i', [_vm._v("(na"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("ar)")]), _vm._v(" (e.g., vv. 12, 17–20), that is, a young man up to the age of forty. This is quite compatible with his being a teenager, as 17:25 implies.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is striking that God responds to Ishmael’s prayer, not his mother’s, suggesting that the one responsible for the situation had to acknowledge his responsibility before God would intervene. Though his name is not used in this story, Ishmael means “God will hear” (16:11), and as on the last occasion the angel of God addresses Hagar, making promises about his future nationhood. So just when she was expecting her son to die, she is shown a well and his life is saved. 21:20 describes Ishmael’s lifestyle, already anticipated in 16:12. Then, finally, Hagar arranges a marriage for her son from among her own people, a pattern Abraham was later to follow with Isaac (cf. ch 24).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Treaty with Abimelech (E/[J]) (21:22–34)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This quiet interlude describes an incident that happened in the “many days” (v. 34) that Abraham spent in the northern Negeb between Gerar and Beer-sheba, the territory of Abimelech, last mentioned in ch. 20. It begins with Abimelech requesting Abraham to make a treaty with him and his successors because of Abraham’s prosperity, evidence, according to Abimelech, that God is with him. Abraham’s grudging reply (21:24) indicates that there is something wrong.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("Then Abraham explains the cause of the problem, the confiscation of a well his servants had dug. As in 20:9, Abimelech protests his ignorance of the situation. A covenant is agreed upon, and Abraham presents seven lambs to Abimelech in exchange for the use of the well. This explains the meaning of Beer-sheba, “Well of the Seven” or “Well of the Oath.” Though this agreement does not appear momentous, it was for Abraham, because it was the first time he had been granted permanent water rights in ")]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("Canaan, the first small step to the acquisition of the land itself. So in an act of celebratory thanksgiving he plants a tree and worships (21:33).")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("“Land of the Philistines” (v. 34) is strictly an anachronism, since the Philistines did not settle in Canaan till the twelfth century. It could reflect the usage of the writer’s own time (cf. Dan 14:14, Ur of the Chaldees, 15:7; and the Introduction). Or it may refer to an earlier group of settlers perhaps also from Anatolia, as the name Phicol (21:22) suggests.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Sacrifice of Isaac (J/E) (22:1–19)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Theologically and dramatically this is one of the most powerful biblical stories. Every reader can identify with the horror Abraham must have felt, though the narrator never mentions his feelings. They are simply hinted at by the frequent echoes of ch. 21, the expulsion of Ishmael, which is said to have greatly distressed Abraham (21:11). If that is how he felt about sending away his elder son, how much worse must he have felt about sacrificing his only surviving younger son, the one through whom all the promises were to be fulfilled. Whereas in ch. 21 Abraham’s feelings are recorded, here they are not. Only God’s description of Isaac as “your only son, whom you love” (22:2) and Abraham’s cryptic comments to Isaac and his servants give any hint of his inner turmoil. Outwardly he simply and promptly obeys God’s command.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Sometimes it is suggested that this story is an aetiology explaining why human sacrifice was abandoned in Israel. Such an approach is possible if the account is removed from its present context and remarks conflicting with this interpretation eliminated (e.g., Gen 22:1). Outside Israel human sacrifice was practiced from time to time, so an earlier version of the story could have had a polemical aim. However, throughout the OT human sacrifice is regarded with horror, and that is the reaction expected of the reader of the present story too.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The opening comment, “God tested Abraham” makes the reader wiser than Abraham about the nature of his ordeal. “Testing” usually involves hardship and is designed to discover what a person is really like (cf. Deut 8:2, 16). But nowhere else does God demand the sacrifice of a man’s son; indeed, according to Mic 6:7 such a demand was unthinkable. A burnt offering involved the slaying of an animal and its complete incineration on the altar. The OT regards cremation of the dead as horrific (Amos 2:1), so it must have seemed incredible that God was demanding the death of a young man in this fashion. But by echoing his very first command to Abraham, “Go to the land I will show you” (12:1), in 22:2 God reminds Abraham of the nature of faithful obedience.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("He does obey promptly, and on the third day he sees the appointed mountain in the distance. He leaves the servant lads behind, and he and Isaac trudge up the mountain alone, giving the climb an added poignancy. The brief dialogue heightens the feeling of uncertainty and desolation. He tells the servants: “we will worship, and then we will come back to you.” Why does he say “we” and not “I”? Is this a lie to disguise his intentions, or does it indicate that he does not intend to sacrifice Isaac, or does it express hope that there will be a way out? The ambiguity may well be intentional: Abraham may not yet have decided what to do. Isaac’s direct question about the identity of the sacrifice is likewise evaded: “God himself will provide.” There is now less doubt that Abraham will go through with a sacrifice, but his response may simply be an attempt to hide from Isaac what he plans but still be an expression of faith, or it could be read as a prayer, “May God provide.” Isaac’s acceptance of Abraham’s answer shows either a degree of naivety or an acceptance of his role as sacrificial victim. In both cases he constitutes the perfect innocent sufferer. “The two of them walked on together” conveys the tension as they approach the summit.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There the narrator slows down describing the preparation for the slaughter. Isaac’s willingness to be bound—hence the Jewish title for this episode, the binding "), _c('i', [_vm._v("("), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("akedah)")]), _vm._v(" of Isaac—again shows his readiness to die. But then, just as in 21:17, the angel of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" calls from heaven with an urgent double “Abraham,” and the sacrifice is called off. Like Hagar, Abraham looks and sees the solution, a ram just caught in a thicket. And like Hagar he hears the promises renewed (22:16–18; cf. 21:18). This is the last point in the Abraham cycle in which the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" speaks to him, and it would be remarkable to suppose, as some commentators do, that originally there was no reiteration of the promises after Abraham had passed this most grueling test. In fact, they are not merely reaffirmed but developed in a strikingly new way. For the first time the promises are introduced with an oath formula (22:16). The promise of descendants is made more fulsome than before, and the prospect of the conquest of the land sounds closer, “shall possess the gate of their enemies” (v. 17). Finally, the promise of blessing to the nations is restated (v. 18). This transformation of the promises into a guarantee has come about “because you have obeyed my voice.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, this story also explains the origin of the place name “Moriah,” in later times identified with the hilltop in Jerusalem where the temple stood (2 Chr 3:1). That was the place where preeminently God could be “seen,” whenever faithful Israelites offered sacrifice there. And it seems likely that this sacrifice of Abraham, of the ram instead of his son, is an archetype of OT sacrifice, where the animal suffers in place of the human worshiper. Certainly this was how the Akedah is interpreted in late Jewish texts. But already in NT times the death of Jesus is compared to the sacrifice of Isaac in passages such as John 3:16; Rom 8:31–32; 1 Pet 1:19–20.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Neef, H.-D. 1998, "), _c('i', [_vm._v("Die Prüfung Abrahams")]), _vm._v(", Stuttgart: Calwer.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Genealogy of Rebekah (J) (22:20–24)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This brief genealogy of Nahor, Abraham’s brother (11:27), gives its purpose away by listing one girl among Nahor’s descendants, Rebekah, the future wife of Isaac and mother of Jacob (cf. chs. 24, 25).")])]), _c('p', {
    staticClass: "H2"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("Purchase of the Cave of Machpelah (P) (23:1–20)")])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("After Eve, Sarah is the first woman of importance in Genesis. But her life was hardly a happy one. Childless to the age of ninety, twice trapped in a foreign king’s harem by her husband’s folly, and taunted by her slave-girl and stepson, last but not least she watched her only son taken off to be sacrificed by her husband. Did he really care for her? she must have wondered. But at least after her death, he showed his love by acquiring a large burial ground for her and interring her in style. Indeed, her husband and most of her immediate descendants were buried there too (25:9; 35:29; 49:31; 50:13).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But there is more to this episode than the burial of Sarah and the establishment of an ancestral cemetery. This was the first acquisition of a plot of land in Canaan. In 21:30 Abraham had acquired the right to use a well; now he purchases a large field in which to bury his family. The lengthy negotiations with the Hittite owner are fully described to show that the purchase was fully and publicly agreed upon between the Hittites and Abraham so that he now had an impeccable right to this land in perpetuity. It appears that the Hittites were ready to give the land to Abraham (23:11), but that might not have given Abraham full title to it, so he insists on buying it (v. 13). Despite the high price asked, Abraham pays in full: there is to be no question about future ownership.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("23:2–3")]), _vm._v(" Kiriath-arba seems to be the older name for Hebron (cf. 13:18). V. 3: These Hittites do not appear to have any connection with the Hittites of Asia Minor. All OT Hittites have good Semitic names and, where locatable, live in the hills of Canaan.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Betrothal of Rebekah (J) (24:1–67)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The fullness of description in this episode signals its importance for the narrator. The death of Sarah in the preceding chapter here is followed by Abraham on his deathbed making his last wishes known to his faithful servant. In the typical biblical deathbed scene the dying man summons his sons to him and gives them his blessing (cf. chs. 27 and 49). But here it is the servant, not the son Isaac, who is entrusted with carrying out the patriarch’s wishes. But this is characteristic of Isaac throughout Genesis: he is the most passive of the patriarchs and open to manipulation by others.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In this scene Abraham is portrayed as concerned that his son should not marry a Canaanite, only someone from his own clan. He therefore commissions his servant to go and find a suitable wife for Isaac. Arranged marriages were standard practice in OT times, but once again Isaac is surprisingly little involved; usually the man would at least be consulted or tell his parents whom he would like to marry (cf. Judg 14:2).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Promptly the servant sets out for Aram-naharaim, the area in northern Syria between the Euphrates and Habur Rivers. And there by the well he meets the right girl. Here is another example of a biblical type scene: to meet one’s fiancé(e) near a well is almost conventional (cf. 29:1–12; Exod 2:15–22). Once again the characters of the actors involved emerge when one example of the scene is compared with the others. Here unusually the groom is absent, but the future bride Rebekah is marked by tremendous energy, volunteering to water ten thirsty camels and running hither and thither in a great display of enthusiasm. Rebekah turns out later to be the most decisive and energetic of all the patriarchal wives.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Having told the story of the encounter at the well in his own words (24:10–27), the narrator then allows the servant to retell the story to Laban and Rebekah’s family (vv. 34–49). Superficially this looks like repetition, but a close comparison of the two accounts shows some interesting differences. The servant’s retelling is subtly crafted to elicit a positive response from the grasping Laban. Note the stress on Abraham’s wealth and the sole heirship of Isaac (vv. 35–36). He also stresses Abraham’s desire that Isaac should marry a close relative, not one of the Canaanites (vv. 37–41). Then he presses for a decision. Surely the remarkable answer to his prayer at the well proves that God approves of the match. So Laban and Bethuel approve in principle (vv. 50–51).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, by the next morning they are stalling for time: “at least ten days” (v. 55) could be translated “a year or so.” Eventually Rebekah is asked to resolve the impasse. Her willingness to go and leave her family and homeland marks her out as a female Abraham. Like him her name contains the letters "), _c('i', [_vm._v("b")]), _vm._v(" and "), _c('i', [_vm._v("r")]), _vm._v(", also found in "), _c('i', [_vm._v("barek")]), _vm._v(", “to bless.” Her obedience, like his, will be the source of blessing to many, as her relatives declare as she leaves (v. 60).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Her reception by Abraham’s family is comparatively low key (vv. 62–67). There is in fact no mention of Abraham himself. That the servant now calls Isaac “my master” suggests that Abraham has now died too. Perhaps the mission to find Rebekah took longer than anticipated.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Within the perspective of Genesis this story offers a model and a justification of arranged marriages. Whatever doubts are raised by Rebekah and Laban’s subsequent behavior, in the eyes of the author, “The thing comes from the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("” (v. 50). For the author and his readers this is an example of the intersection of human prayer and divine providence working for the fulfillment of God’s promised purpose. Through Abraham’s initiative, his servant’s obedience, and Rebekah’s compliance the mother of Israel left her family and home to become Isaac’s wife and so became “thousands of myriads.”")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Concluding the Life of Abraham (J/P) (25:1–11)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("It is unlikely that all the events mentioned in this short epilogue to Abraham’s career happened after chs. 23–24. It is probable that 24:65 presupposes the death of Abraham, although it is not formally recorded till 25:7–11, which tells of Isaac and Ishmael reunited to do their filial duty of burying their father (cf. 35:29; 50:4–13). Similarly, it may well be that the narrator envisaged Abraham taking Keturah before Sarah’s death (ch. 23). But in order not to lose the track of the story these points have been left to the end.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("The main point of mentioning Keturah and her descendants, ")]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("like the Table of Nations in ch. 10, is to define Israel’s relationship with some of the neighboring nomadic peoples, who lived in the deserts nearby or traded with Israel. In modern terms they would be described as Arabs. So far as they can be identified, Keturah’s descendants seem to be peoples or tribes, thus fulfilling the promise that Abraham would be the ancestor of a multitude of nations (17:5). The linkage of these peoples with Abraham shows that in the time Genesis was written Israel felt a close affinity with these peoples.")])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("25:2")]), _vm._v(" Zimran may be an Arabian tribe. The Midianites were desert traders (cf. 37:28) and later enemies of Israel (Judges 7–8). Ishbak and Shuah may be located in northern Syria. 25:3: Sheba and Dedan (cf. 10:7) are located in Arabia. The Asshurim were a desert tribe mentioned in Num 24:22, 24 and Ps 83:8. 25:4: Ephah, Epher, Abida, and Eldaah may have Arabian connections.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("25:8")]), _vm._v(" “Gathered to his people” refers to being joined with his relatives in the afterlife.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Family History of Ishmael (P) (25:12–18)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This short family history is one of the ten into which Genesis is arranged. From Genesis 11 onward the long family histories of Terah, Isaac, and Jacob sandwich the short histories of Ishmael and Esau (36:1–37:1). As elsewhere in Genesis, the non-elect line, here Ishmael, is dealt with before the chosen line that follows, that is, Isaac (cf. Cain before Seth in ch. 4, and Esau before Jacob in chs. 36–37).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As the previous section does, this passage shows how Israel viewed her bedouin-like neighbors, the Ishmaelites. It suggests that although they are so closely related, tension between them can be traced right back to the squabbles between Isaac and Ishmael. But it is also a reminder that God made promises to Ishmael, too, that he would live opposite his brothers (NRSV, at odds with all his kin) (16:12), and would father twelve princes and become a great nation (17:20). The fulfillment of the first is mentioned in 25:18 and of the second in 25:13–16. The implication is that, if God fulfilled these rather minor promises, he will surely fulfill his greater promises through his chosen line of Isaac. This bare genealogy should whet the reader’s appetite for the next major family history.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Jacob Story (25:19–35:29)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The story of Jacob, also called Israel, brings us to the heart of Genesis. The book is about the origins of the nation of Israel, whose tribes all traced their descent to one man, Jacob. This section of Genesis tells of Jacob’s birth, marriage, how he fathered the ancestors of the twelve tribes, and that after a dramatic struggle with God he had his name changed to Israel. The next major section of Genesis (37:2–50:26), usually called the Joseph story, completes the life story of Jacob, telling how he emigrated to Egypt, settled there, and died there, but was buried in Canaan.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Often it has been held that the Jacob and Joseph stories were originally independent or at least had separate tradition histories, but a closer reading suggests they are intimately connected. In both we have the rivalry between Leah and her sons and Rachel and her sons. In both there are similar motifs, such as deception using a kid. The character of the actors is similar in both. The tensions that develop between family members in the Jacob story are not resolved until the end of the Joseph story. For these reasons it is preferable to regard Genesis 25–50 as constituting essentially one story. The editor has split it into two, sandwiching in between the two parts the genealogy of Esau (Edom) (36:1–37:1), thus making the second half of Genesis match the pattern of the first, with major narratives alternating with genealogies, and each section beginning “These are the descendants of Isaac [Esau, Jacob]” (25:19; 36:1; 37:2).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There are other signs of the editor’s hand. Motifs from the Abraham cycle are echoed in the Jacob story (e.g., quarrels between brothers, leaving home, etc.). For other examples see above, p. 48. Even more clearly than the Abraham cycle, the Jacob story is arranged palistrophically.")]), _vm._v(" "), _c('table', {
    staticClass: "Table15",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("25:19–34")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Jacob and Esau together")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("26:34–28:9")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Jacob takes Esau’s blessing")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("B")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("28:10–22")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Jacob meets God at Bethel")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("C")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("29:1–14")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Jacob arrives at Laban’s house")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("D")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("29:15–30")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Laban tricks Jacob")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("E")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("29:31–30:24")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Birth of Jacob’s sons")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("F")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("30:25–31:1")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Jacob outwits Laban")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("E′")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("31:2–55")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Jacob leaves Laban")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("D′")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("32:1–2")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Jacob meets angels of God")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("C′")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("32:3–33:20")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Jacob returns Esau’s blessing")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("B′")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("35:1–29")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Jacob and Esau meet again")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("A′")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("These are the points that are most obvious in the arrangement, but even sections which do not match so obviously, for example, chs. 26 and 34, may be dealing with the same theme, namely, relations between Israel and the inhabitants of Canaan. The central section of the above palistrophe is the birth of Jacob’s sons, the fathers of the twelve tribes, again emphasizing the book’s interest in Israel’s origins.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Fokkelman, J. P. 1975, "), _c('i', [_vm._v("Narrative Art in Genesis")]), _vm._v(", Amsterdam: van Gorcum • Rendsburg. 1986 • Sternberg, M. 1985, "), _c('i', [_vm._v("The Poetics of Biblical Narrative")]), _vm._v(", Bloomington: Indiana University • Syrén, R. 1993, "), _c('i', [_vm._v("The Forsaken Firstborn")]), _vm._v(", Sheffield: Sheffield Academic.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The First Clashes between Jacob and Esau (J, P, E?) (25:19–34)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Three short sketches from the early life of the twins Jacob and Esau define the temper of their subsequent careers and mutual relationship. First, they are described as smashing each other (“struggling together” understates the violence involved) in their mother’s womb. This makes life so painful for Rebekah that she wonders whether life is worth living, foreshadowing the pain their future antagonism will cause her (vv. 21–23).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("In her distress she turns to God and through a prophetic oracle is told, “Two nations are in your womb … the elder shall serve the younger.” This sums up the whole story of relations between Esau and Jacob in Genesis, as the two struggle for supremacy, and Jacob, the younger, regularly betters Esau. It also prefigures the bitter relationship between the nations of Edom and Israel described elsewhere (Num 20:14–21; Obad 10–21; Mal 1:4), and according to Paul the relationship between the elect and the non-elect (Rom 9:10–13).")])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The same pattern of behavior is evident at their birth (25:24–26), when Jacob emerges after Esau clutching his heel. The names given them at birth sum up their characteristics. Jacob probably is short for "), _c('i', [_vm._v("ya"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("qob-el")]), _vm._v(", “May El protect,” but here it is simply a pun on the word "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("aqeb")]), _vm._v(", “heel,” while the red Esau alludes to the territory his descendants inhabited, Edom (= red) or Seir (cf. Esau).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Finally (vv. 29–34), we see Jacob beginning to better Esau by persuading him to sell his birthright, that is, his privileges as firstborn son including extra gifts from his father during his lifetime and from his father’s estate. Jacob is pictured as a wily exploiter while his brother is shown to be an uncouth despiser of tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("25:20–21, 26")]), _vm._v(" Like Sarah and Rachel, Rebekah suffered a long period of infertility (17:17; 30:1). 25:28 notes the favoritism that is going to be so destructive in ch. 27.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Isaac and the Philistines (26:1–33) (J)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Were Genesis written in strict chronological order, much if not all of this chapter ought to have been placed before the preceding section, for obviously vv. 1–11 relate to a period before the birth of Jacob and Esau: there would have been no doubt about the marital status of Rebekah if she had twin boys! This section consists of a series of flashbacks into an earlier period in Isaac’s life to demonstrate the partial fulfillment of the promises made to his father Abraham, blessings that were so evident that even outsiders like Abimelech wanted to be on good terms with Isaac (vv. 28–29). This helps explain why Rebekah was prepared to go such lengths to obtain the blessing for Jacob.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But it is not merely that the promises are partially fulfilled; they are twice reiterated and even enhanced in vv. 2–5 and 24 (note “all these lands,” not merely “this land,” in v. 3). Furthermore, there are many parallels between this chapter, 12:10–14:20, and chs. 20–21 underlining the similarity between Isaac’s life and his father’s.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These parallels are clearest in 26:1–11. Once again (cf. 12:10–20; 20:1–18) the patriarch passes off his wife as his sister and infuriates the local king by his deception. As in Abraham’s case, we are led to understand that Isaac was not beyond reproach, and his wife’s escape owes more to the grace of God than to the merit of the patriarch.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("26:12–16")]), _vm._v(" is the only reference in Genesis to a patriarch raising crops. The high yield (cf. Matt 13:8) is proof of divine blessing, as are his large flocks and herds. But as with Abraham before him and Jacob after him, this leads to strife (cf. 13:6–7; 30:25–31:16).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("26:17–33")]), _vm._v(" Water rights are vital to survival, so quarrels about wells are matters of life and death. Without access to wells Isaac would have had to leave. These episodes show Isaac handling the disputes with the Philistines in conciliatory fashion (cf. 13:8–9) and being rewarded with a reaffirmation of the promises (cf. 13:14–17), the making of a treaty with their longtime antagonists (cf. 21:25–32), and the digging of yet another well, a foothold in the land promised in 26:3.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Philistines (26:1, 8, 15, 18), as known from Judges and Samuel, did not arrive in Canaan till the twelfth century, when they settled in the coastal plain. This term is either an anachronistic way of speaking of the earlier inhabitants of this area, or refers to an earlier group of immigrants (cf. Caphtorim; Deut 2:23) from the Aegean area.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Jacob Obtains Esau’s Blessing by Deceit (26:34–28:9) (J, P, E?)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The excitement and tension of this story grip every reader. Will Rebekah’s ruse succeed or will the aged Isaac uncover Jacob’s disguise and curse him instead of blessing him? Will Esau return before Isaac has eaten and pronounced his blessing on Jacob? How will Esau react to his brother’s deceit? We wait with baited breath to discover how things will work out. However, the very success of Rebekah and Jacob raises acute moral and theological problems. Does the author really approve of the devices they used to obtain the blessing? Can God’s blessing be acquired by such shameful tactics?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Closer reading of the narrative shows that the narrator is not as naive or biased as appears on first sight. The tale of deception is prefaced by a comment on Esau’s marriages to his two Hittite wives. This suggests either negligence on Isaac’s part, who should have arranged a more suitable match for Esau (cf. 24:1–9), or a disregard for propriety on Esau’s part, for he should not have married one Canaanite (on the Hittites see 23:3), let alone two (cf. 4:19). Then when Isaac comes to bestow his parting blessing, he flouts convention again. When a man knew his death was drawing near, he was expected to summon all his sons to hear his last wishes and to receive a final blessing (cf. ch. 49). However, Isaac ignores this custom by summoning only Esau and speciously excuses himself by saying, “I do not know the day of my death.” Tradition and principle are rejected because he favors Esau and wants another dish of game.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("No wonder Rebekah was incensed by this discrimination against her favorite. But does this mean that the narrator approves of her actions? This is unlikely, for he both mentions Jacob’s qualms about the morality and practicality of her plan (27:11–13) and shows with a sympathetic fullness Esau’s distress at having being cheated out of his blessing (vv. 34–38). Furthermore, in the ongoing story we see the long-term repercussions of Rebekah’s and Jacob’s actions. Jacob has to flee for his life, so that Rebekah never sees her favorite son again. Then, staying with his uncle, Jacob is exploited in various ways, most obviously by having to marry Leah before Rachel, for as his uncle cruelly comments, “It is not done in our country—giving the younger before the firstborn” ")]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("(29:26). Though Laban justifies his action on a do-as-youwould-be-done-by basis, this forced bigamy was the cause of endless pain and contention in Jacob’s family for the rest of his life. Full reconciliation between the sons of Leah and the sons of Rachel is achieved only after his death. As Rebekah mourned the loss of Jacob her favorite son for the rest of her days, so for much of his life Jacob supposed his favorite son Joseph had met an untimely end, for as he had deceived his father with a goat, so his sons misled him by the same means (37:31–35). Finally, Jacob himself acknowledges the injustice of his acquisition of the blessing, for when seeking reconciliation with Esau he says he is returning “my blessing” (ESV; NRSV, “gift”) (33:11).")])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("So from a moral point of view Rebekah and Jacob do not get away with their action: they suffer for it for the rest of their days. But theologically speaking it does seem to succeed, for he does obtain the blessing, and this still seems unfair. This is probably the clearest example in Genesis of God’s plans not being frustrated by human sin, of God’s grace being given to those who do not deserve it, but because it has been promised. Before birth Rebekah was told through a prophetic oracle that the older should serve the younger (25:23), and though she and Jacob acted improperly to secure it, that did not invalidate the promise (cf. 12:10–20; 16:1–14; 20:1–18; 26:1–11). Though such acts of unbelief delay the fulfillment of the promises in the short term, in the longer term the promises are still being fulfilled (cf. Rom 11:1–29).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Jacob at Bethel (28:10–22) (J, E)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Jacob left home under a cloud. Admittedly his parents had put the best gloss on his reasons for leaving to find a wife (28:2), but he knew that it was really fear of Esau’s revenge. So his experience at Bethel, some fifty miles north of Beer-sheba, must have been reassuring. His vision of angels going up and down a ladder linking earth and heaven was a promise of God’s accompanying protection. In the OT angels are portrayed as patrolling the earth for God and reporting back to him (Job 1:6–12; Zech 1:8–17; 6:1–8). Here they go up to the top of the ladder where the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" himself stands (NRSV mg., “stood above it,” is better than “beside him”).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Then for the first time Jacob hears the promises of land, descendants, and blessing that had been made to his father and grandfather reaffirmed and applied to himself (28:13–15). In fact, a new element is added, characteristic of the Jacob story (cf. 28:20; 31:3; 46:4), that God will be with him and bring him back to the land. This could be described as the governing motif of this part of the story: Jacob will be protected and will return to Canaan. The rest of the narrative will show how this happened.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But the experience also explains the name of Bethel, “house of God.” Whether it was a holy site before Jacob encountered God there is unknown, but subsequent generations of Israelites who went to the important sanctuary there (1 Kgs 12:29–13:32; Amos 4:4; 7:13) would recall that Jacob had met God there, erected a stone there, and promised to bring his tithes there. The partial fulfillment of this vow is recorded in Genesis 35, but presumably Jacob’s deed was supposed to serve as an example to his descendants. Although some see Jacob’s vow-prayer in 28:20–22 as redundant in the light of the promises in vv. 13–15, petitionary prayer in the Bible often appeals to divine promises (cf. Exod 32:11–13; Luke 11:5–13).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Jacob Arrives at Laban’s House (29:1–14) (J)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The scene is a rerun of the arrival of Abraham’s servant at a well near Haran described in 24:10–49, but with some interesting differences which point up the distinctive character of the main actors. There it was Rebekah who ran to and fro, watering ten thirsty camels. Here it is Jacob who heaves away the massive stone single-handedly and waters his cousin’s sheep. Then Isaac’s servant prays earnestly that his mission will be successful. Now Jacob chats cockily to the other shepherds while he waits for Rachel to arrive, and when she does, he kisses her. In both cases Laban rushes out to meet the newcomer and invites him to stay.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These similarities and differences foreshadow later developments in the narrative. Jacob’s tremendous exertion in moving the stone presages the great efforts he will have to make in Laban’s household, while kissing his cousin surely looks forward to his falling in love with her. In both situations Laban’s rush to greet the visitor is motivated by greed. But whereas Abraham’s servant was loaded, Jacob had come empty-handed, yet Laban found a way of exploiting him too.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Jacob Marries Leah and Rachel (29:15–30) (J, P)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The romance hinted at in 29:11 blossoms. But marriage in the ancient Near East did not merely involve the couple but their families. Traditionally betrothal was sealed by a large payment, the bride-price of up to fifty shekels (Exod 22:16–17; Deut 22:29) given by the man’s family to the bride’s family. But Jacob away from home could not call on his family resources, so he is forced to enter his uncle’s service to pay the equivalent of the bride-price. The bride-price usually was equal to a few years’ wages, but seven is on the high side, reflecting both Laban’s greed and Jacob’s love for Rachel (29:20).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("At the end of the seven years Jacob has to remind Laban to fulfill his side of the bargain. This was not the last time Jacob would find Laban slow to pay up (cf. 31:41–42). We know little about wedding celebrations in Bible times save what we can infer from this passage, Judges 14, and Matt 25:1–12. A seven-day feast was customary, on the first night of which the bridegroom took his bride to bed for the first time. But morning light showed that it was the wrong woman! Jacob protests that he has been “deceived,” thereby echoing what he had done, “came deceitfully” (27:35). But Laban hammers home the point, that Jacob has only been treated as he had treated his brother, by observing: “It is not done in our country to put the younger before the older.” Nevertheless, Laban agrees to give Rachel as well, if Jacob will work another ")]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("seven years for him. As the story goes on to tell, this was the start of a miserable marriage.")])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("29:17")]), _vm._v(" would be better translated, “Leah’s eyes were soft [i.e., lacked sparkle], but Rachel had a beautiful figure and a lovely face.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("29:24, 29")]), _vm._v(". At marriage it was customary for the bride’s father to give her a dowry, which usually consisted of furniture, clothes, and money. Here the wealthy Laban gives his daughters their own slave-girls as part of their dowries.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Birth of Jacob’s Sons (29:31–30:24) (J, E)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The birth of eleven sons to Jacob is the turning point of the story. From this point on, he tries to return home (30:25). For later Israelites this section must have been of special interest in that it relates the origins of most of the tribes and offers explanations of their names, most of which are characteristically second millennium in type. However, this must also count as one of the most poignant sections in the book. Marriage and motherhood were the ultimate goals of pre-modern women (30:1; cf. Psalms 127–128), but here what should have been their greatest joy is turned into a battleground. As they name their children, we glimpse the rivalry, bitterness, and disappointment that blighted their relationships with each other and with Jacob.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Leah’s pleasure at motherhood is darkened by Jacob’s lack of affection for her. Her sons’ names express the hope that their birth will change his attitude to her (see 29:32, 33, 34; 30:18, 20). On the other hand, Rachel’s choice of names shows her gloating over her sister (30:6, 8) or pathetically hoping for another child (30:24). It may be noted that those patriarchs who are to play the biggest roles in the Joseph story, Reuben, Simeon, Judah, and Joseph, all have their names explained by reference to the divine name, the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" "), _c('i', [_vm._v("(Yahweh)")]), _vm._v(", whereas the others just have explanations with the generic term for God "), _c('i', [_vm._v("(Elohim)")]), _vm._v(". Most of the explanations are not historical etymologies, which would explain what the name meant originally; rather, like most biblical etymologies, they are plays on the word giving the associations of the different names in popular thought.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The episode comes to its bitter climax in 30:14–18, as Leah exchanges her son Reuben’s mandrakes, an ancient fertility drug, for a night in her husband’s bed. Here we see Leah’s desperate desire for her husband’s love and Rachel’s yearning for children at their most intense. But it was not medicine that solved the problem, but God who opened Rachel’s womb (30:22). The tribes owe their origin to the will of God, not human manipulation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("30:21")]), _vm._v(" Dinah may not have been Jacob’s only daughter, but she is mentioned because of her role in ch. 34.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Jacob Outwits Laban (30:25–31:1) (J, E)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("As soon as Joseph is born, Jacob decides he must return to his country (30:25). He has seen the promises of children and protection fulfilled (28:2–4, 13–16); now he looks for the redemption of the land promise. However, his grasping father-in-law is reluctant to let him go. He puts his objections very suavely (30:27–28), but basically he says he cannot afford to let such an asset as Jacob go. So Jacob offers Laban a deal that will apparently cost Laban nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Sheep are usually white and goats are black: speckled specimens are unusual. So Jacob says that he will just take the speckled sheep and goats: the rest will be Laban’s. Laban thinks that this is fine, and leaves Jacob with a flock consisting entirely of white sheep and black goats. However, by putting white-striped rods in front of the goats when they breed and a black goat in front of the sheep when they breed, Jacob succeeds in producing speckled sheep and goats. According to the agreement these belonged to him. What is more, he restricts his selective breeding to the most vigorous sheep and goats, so that his share of the flock turns out to be the most healthy too. It is possible that by restricting his selective breeding to the strongest members of the flock, he chose the hybrids who tended to produce multi-colored offspring. However, the narrator is not interested in the science as much as in the fact that Jacob outwits Laban and thus secures himself a huge flock. Like Abraham before him (12:16) and Joseph after him, Jacob thus secures great wealth for himself in a foreign country.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Note that much of the terminology of this section is quite technical, and more detailed commentaries may need to be consulted to elucidate it. “Learned by divination” (30:27, NRSV) should be “grown rich.” V. 40 refers to the black goat put before the sheep when mating.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Jacob Escapes from Laban (31:2–32:2) (E, J, P)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Jacob’s success provoked a jealous reaction from Laban’s family, but it was a call that echoed the original call to Abraham (12:1–3) that really prompted him to move. However, his wives had to be persuaded to leave home, and he retells the history of his stay in such a way that it will lead them to agree. This apologetic purpose explains the differences between his account and the narrator’s version in the preceding chapters. Jacob stresses the duplicity of their father and the evident blessing of God on himself, so Rachel and Leah readily consent to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But their hasty exodus from Paddan-aram, like the later exodus from Egypt, prompts a furious pursuit. The ensuing standoff between Laban and Jacob is tense, particularly the search of Rachel’s tent for the teraphim, called gods in 31:31–35. The identity and purpose of the teraphim have been much discussed. Usually they have been supposed to have been images of the family’s gods, hence NRSV’s “household gods” in v. 19; but van der Toorn thinks that they were images of the ancestors. Why Rachel thought it important to take them with her and Laban was so keen to recover them is unclear. It is possible that possession of the teraphim conveyed inheritance rights, or brought fertility or good luck. The text assumes the reader knows, but we do not.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("After the abortive search Jacob takes the offensive and accuses Laban of cheating him. Shepherds in the ancient ")]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("orient were not expected to bear losses incurred by attacks of wild beasts or in some cases of theft; they were borne by the owner of the flock. But Jacob says that he did bear such losses, and hence he has been underpaid by Laban (see Finkelstein).")])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("At last Laban climbs down and proposes a covenant with ridiculous conditions, insisting Jacob should not invade the territory of Laban from which he was running away or take any extra wives. Although such a clause was frequent in ancient marriage contracts, this was cheek from Laban, who had forced Jacob to marry one more wife than he wanted! But the making of this covenant explains the origin of the place name Gilead, “heap or cairn of witness” (vv. 47–48).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("At Mahanaim, perhaps western Tulu edh-Dhahab just north of the Jabbok River, Jacob has another vision of angels. At Bethel he had seen them going up and down a ladder; here they are encamped, perhaps for battle (cf. 2 Kgs 6:17; 7:6). At any rate, as he returns to Canaan he is reminded of God’s promise that he would be with him and bring him back to his homeland in peace (28:15, 20–21), an assurance that he most needed at this critical juncture.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("31:42, 53")]), _vm._v(" “Fear of Isaac”: this unique title of God has prompted much discussion. Though other translations have been offered, the traditional one is appropriate in this context, for it was the fear of God (v. 24) that held Laban back from attacking Jacob.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Toorn, K. van der. 1990, “The Nature of the Biblical Teraphim in the Light of the Cuneiform Evidence,” "), _c('i', [_vm._v("CBQ")]), _vm._v(" 52:203–22.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Jacob Returns Esau’s Blessing (32:3–33:20) (J, E, P)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Would it be out of the frying pan into the fire? Having at last escaped Laban’s clutches, Jacob now faces the prospect of a meeting with Esau. His anxiety is palpable. He at once sends messengers seeking Esau’s favor with an excessively deferential message. Indeed, the terms “my lord Esau” … “your servant Jacob” seem to be the first of several moves by Jacob to undo the effects of his misappropriation of Esau’s blessing, whereby Jacob would be Esau’s lord and Esau would serve him (27:29, 37).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The messengers return with the news that Esau is on his way with four hundred men, which turns Jacob’s anxiety into panic (32:7–8). Preemptive defensive measures are followed by one of the longest prayers in Genesis. This consists in an appeal to God’s mercy (v. 11) sandwiched between two reminders of his promises (vv. 9, 12). It was God who had told him to return to Canaan (31:3) and who had promised to make his descendants numerous (28:14; cf. 22:17). For God to allow Esau to exterminate him and his family would be to annul his promises.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But prayer does not make action superfluous. Jacob prepares five flocks of presents totaling 550 animals to “appease” Esau. These references to “presents” "), _c('i', [_vm._v("("), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("minḥah")]), _vm._v(")")]), _vm._v(", “appease” "), _c('i', [_vm._v("(kipper)")]), _vm._v(", and “accept” "), _c('i', [_vm._v("("), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("raṣah")]), _vm._v(")")]), _vm._v(" echo sacrificial terminology (cf. Lev 1:4; 2:1–14), for as Jacob says later, he sees making peace with his brother as making peace with God (33:10; cf. Matt 5:21–26; 1 John 4:12–21).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Then follows one of the most mysterious episodes in the OT, Jacob’s struggle with a “man” at the Jabbok. It is mysterious historically, for it is hard to know what really happened. It is also mysterious theologically, in that the “man” somehow represents God, who seems initially intent on harming Jacob but eventually leaves him with a blessing. But there is no doubt about the importance of this encounter, for in it Jacob is renamed Israel, the name of the nation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Parallels with folktales from Ireland to the Hittites have been drawn to demonstrate the integrity of the story. Many have cited tales of attacks by river demons to explain the origin of the story. Perhaps Jacob’s opponent was a Canaanite river god. But Eissfeldt has pointed out that this is not the perspective of the story, which identifies the foe as El, the supreme creator God in the Canaanite pantheon (32:30). This fits in with other dangerous encounters with divine beings in the Pentateuch, where the mysterious opponent turns out to be either the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" or his angel (Exod 4:24–26; Num 22:22–35), for regularly in Genesis the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" is equated with El (cf. 16:13).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This makes it the more surprising that the “man” could not prevail against Jacob (32:25), and that he was in a hurry to leave before daybreak (v. 26). The reason for his haste is obscure. Jupiter’s demand to leave a city before dawn sounds similar (Plautus "), _c('i', [_vm._v("Amphitryo")]), _vm._v(" 532–33). It is probably an attempt to hide his identity, but it may also reflect the notion that no one may see God and live (cf. v. 30; Exod 33:20). These features all enhance the wonder of Jacob’s achievement, that he was able to wring concessions from a supernatural being in single combat.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Even with his hip dislocated he is determined to extract a blessing from his opponent. Obtaining a blessing has of course been Jacob’s lifelong goal. But in fact he is granted more than a blessing, a name change which announces his new character and destiny just as Abraham and Sarah’s change of name did (17:5, 15; cf. Matt 16:18). Israel probably means “God [El] fights, or judges/rules.” But as often the OT does not offer a strict etymology, more a play on the name, “you have struggled with God and with men and have overcome” (32:28). The old name Jacob recalled his past underhand dealing (27:36); his new name recalls this triumphant struggle with divine and human foes, and is a pledge to the people, who later were known as Israel, that they too would triumph over all the powers that might assail them. In the immediate context of the story the new name guarantees Jacob a successful meeting with Esau.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Within the Bible this is an extraordinary story. It invites comparison with God’s demand to Abraham to sacrifice Isaac, the nighttime attack on Moses, or the testing of Job (Gen 22:1–19; Exod 4:24–26; Job 1–42). In all these situations God appears to be acting abnormally, assaulting those he has promised to care for, indeed called to do his will. This paradox or mystery of divine action was often Israel’s experience as a people: the psalms of national lament (e.g., 74; 79; 80; 83) often express the conviction ")]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("that national disasters are sent by God, yet only God can deliver the nation from them. As Calvin puts it: “he fights "), _c('i', [_vm._v("against")]), _vm._v(" us with his "), _c('i', [_vm._v("left")]), _vm._v(" hand, and "), _c('i', [_vm._v("for")]), _vm._v(" us with his "), _c('i', [_vm._v("right")]), _vm._v(" hand.” The NT similarly sees Jesus’ suffering as the pathway to glory, and one that all his disciples should expect to follow (1 Pet 4:1–2, 13–19).")])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Coote, R. 1972, “The Meaning of the Name Israel,” "), _c('i', [_vm._v("HTR")]), _vm._v(" 65:137–46 • Eissfeldt, O. 1966, “Non dimittam te, nisi benedixeris mihi,” "), _c('i', [_vm._v("KS")]), _vm._v(" 3:412–16.")]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("Jacob’s transformation is patent next morning. Instead of following the rest of the party he now steps out in front to meet Esau first. Note, though, his sevenfold obeisance to his brother; he is still trying to reverse the blessing “may your mother’s sons bow down to you” (27:29). But as implied in the Peniel experience (32:28), Esau is transformed too. The brother who was last heard of planning to murder Jacob greets him with a warmth and generosity that is astonishing. Though Jacob’s comparison of Esau’s action with God’s sounds too fulsome, it is not inappropriate, for God’s mercy is like this according to Scripture (33:4, 10; cf. Luke 15:20). Esau’s reluctance to accept Jacob’s presents is eventually overcome as Jacob pleads, “Please accept my "), _c('i', [_vm._v("blessing")]), _vm._v("” (ESV; not “gift,” NRSV). Jacob for his part is determined to put right his earlier deception.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Esau’s forgiveness is reaffirmed as he urges Jacob to come and live with him. It is not clear why Jacob politely declined (vv. 13–14). Was it a lurking distrust or was it obedience to the command to return to Canaan (31:3)? By not clarifying his motives, the narrator allows both possibilities.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("33:17")]), _vm._v(" Succoth may be Tell Deir "), _c('span', {
    staticClass: "charSR"
  }, [_vm._v("ʿ")]), _vm._v("Alla or Tell Ekhas, sites about a mile apart, just north of the Jabbok.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("33:18")]), _vm._v(" should be translated, “Jacob came to Salem the city of Shechem.…” At last back in Canaan proper, he buys land, builds an altar, and worships, since the promises made at Bethel seem fulfilled (28:13–15).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Dinah’s Brothers’ Revenge (34:1–31) (J, E/P?)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This episode seems to have little to do with the theme of Genesis, the partial fulfillment of the promises, and its brutality horrifies the modern reader. These issues will be looked at in reverse order, for we cannot understand its thematic relevance without appreciating the ethical stance of the storyteller.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("To understand the author’s viewpoint, we must realize the stark rejection of sexual intercourse outside marriage in the ancient world. Adultery and rape were punishable by death. Consenting sex before marriage could cost as much as marriage itself, that is, several years’ wages (Exod 22:16–17; cf. comments on Gen 29:15–20). Here Jacob’s sons make the same point rhetorically, calling the act an “outrage in Israel … for such a thing ought not to be done” (34:7). It is treating their sister “like a whore” (v. 31). This is not to say that the author approves of the brothers’ revenge, for in fact he holds everyone culpable to various degrees, but he certainly did not view Shechem’s deed as venial. Accurately translated, v. 2 reads “Shechem took her, lay with her and humiliated her.” The NRSV is quite wrong to imply that Shechem used force. (In rape contexts such as Deut 22:25; 2 Sam 13:11 a different verb is used.) Dinah was humiliated by submitting to sex outside marriage, not by being raped.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("She herself was not faultless. For a single girl to “go out,” and particularly to visit the local inhabitants, was dubious. But even more shocking was her father’s indifference to the news of her liaison. He (cf. David; 2 Sam 13:21) should have been incensed. But whereas David was angry but did nothing, we are not even told that Jacob was angry. Perhaps this was because Dinah was Leah’s daughter, and he did not acknowledge her as his wife or her children as his (44:27). This callousness toward their sister spurred her brothers to take the law into their own hands (cf. Absalom; 2 Sam 13:22–29), abuse the covenant rite of circumcision, and perpetrate the horrendous massacre. To mitigate our sense of outrage a little, the narrator points out the duplicity of Hamor and Shechem, who make an agreement with Jacob’s sons but then sell a slightly different version to the people of the land (cf. 34:22–23 with vv. 8–17). It also emerges that the brothers negotiated under duress, for Dinah was throughout held in Shechem’s house (v. 26).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("None of this endeared Jacob’s family to the Canaanites, as Jacob lamely points out in an attempt to justify his lack of action (34:30). Nevertheless, despite his fears they were not attacked (35:5). In other words, despite the multiple family failings God’s promises of protection to Jacob still held good. Furthermore, this assault on the inhabitants of the land by Ur-Israel foreshadows the later assaults led by Moses and Joshua. In these cases, too, it is the sins of the Canaanites, especially with regard to sex, that justify the conquest, not the righteousness of Israel (Numbers 25; 31:1–31; Deut 7:1–8; 9:4–7)")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Parry, R. A. 2003, "), _c('i', [_vm._v("Using Genesis 34 in Christian Ethics")]), _vm._v(", Carlisle: Paternoster • Wenham, G. J. 2000, "), _c('i', [_vm._v("Story as Torah")]), _vm._v(", Edinburgh: T & T Clark, 109–19.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Jacob Returns to Bethel and Mamre (35:1–29) (J, E, P)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This section looks like a miscellany of Jacob traditions randomly lumped together to round off the story of Jacob’s homecoming. However, a similar series of topics is found at the end of the Abraham and Joseph stories (e.g., journey, 35:1–8; cf. 22:1–14; 46:2–7; reaffirmation of promises, 35:9–14; 22:15–18; 48:4; birth of sons, 35:17–18; cf. 22:20–24; 48:5–6; death and burial of wife, 35:18–20; cf. 23:1–20; 48:7; son’s marriage, 35:21–22; cf. 24:1–67; 48:8ff. (49:3–4); list of descendants, 35:22–26; cf. 25:1–6; 49:3–28; death and burial, 35:27–29; cf. 25:7–10; 49:29–50:14). These parallels indicate an editorial logic. A theological logic is also discernible. Promises were given to Jacob at Bethel, and Jacob made vows there. With the fulfilment of the promises Jacob is duty-bound to return to Bethel to fulfill his vows.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('b', [_vm._v("35:1–7")]), _vm._v(" Jacob is portrayed as a model worshiper making a pilgrimage to the great sanctuary of Bethel. The ")]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("command “go up” "), _c('i', [_vm._v("("), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("alah)")]), _vm._v(" later became a technical term for going on pilgrimage, especially to Jerusalem. Those who went on such pilgrimages had to be of pure hands and heart and particularly forswear idolatry (Ps 24:3–4). So here Jacob’s party does these things (35:2, 4). But the command to go to Bethel and build an altar also echoes the end of the Abraham story with the command to go to a mountain and worship.")])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In Abraham’s case that was a difficult thing to do because of the nature of the sacrifice. In Jacob’s it was risky because of the massacre of the Shechemites. But both patriarchs obeyed. And both were rewarded by the most powerful statement of the promises in their lifetimes (35:11–13; cf. 22:15–18). In addition, Jacob’s name change to Israel is reaffirmed (35:10). This may reflect an alternative source to 32:28, but Genesis regularly uses repetition of key points in the story to underline significant developments (cf. 17:19; 18:10; 37:6–10, etc.). Here the first name change is presupposed, for no explanation of the new name is given (unlike 32:28).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But Bethel was also associated with tragedy. There Deborah, Rebekah’s nurse, died. The only other mention of her is in 24:59. Presumably her death is recorded because the oak she was buried under could be visited in later times. Sadder still was the death of Rachel, Jacob’s favorite wife, giving birth to her second son. There is a poignant irony in the circumstance of her death in childbirth, for she had said earlier, “Give me children, or I shall die!” and when at last Joseph was born, she prayed, “May the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" add to me another son!” (30:1, 24).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Though in modern times Rachel’s grave is located about a mile north of Bethlehem, that would appear to be based on a misunderstanding of this text. V. 16 probably should be translated, “Then they journeyed from Bethel; and when they were about two hours’ distance from Ephrath.…” This would place Rachel’s tomb somewhere north of Jerusalem, which would fit in with Rachel weeping for her children in Ramah (Jer 31:15). By calling Rachel’s son Benjamin, son of the right hand, Jacob was indicating his favored position. The “tower of Eder” (35:20) may be near Bethlehem.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("35:22")]), _vm._v(" Reuben’s disgraceful behavior requires no comment by the narrator. It is specifically condemned by Jacob in 49:3–4, when he demotes Reuben from his position as firstborn. According to Lev 20:11, this type of incest warrants the death penalty. Reuben’s motives are unclear, but it is usually thought to have been an attempt to stop Rachel’s maid from taking Rachel’s position as Jacob’s favorite wife. As the oldest son of Leah Reuben doubtless bitterly resented his father’s preference for Rachel.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("35:27–28")]), _vm._v(" Eventually Jacob arrives back at his father’s house (cf. 28:20), now located at Mamre. And there, as the two brothers, Isaac and Ishmael, had buried their father, so the brothers Jacob and Esau bury theirs (cf. 25:7–9).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Family History of Esau (36:1–37:1) (P)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This is the last of the short genealogies that alternate with the long cycles of stories about Abraham (chs. 12–25), Jacob (chs. 25–35) and Joseph (chs. 37–50). In each case the genealogy of the non-elect brother (Ishmael and Esau) precedes that of the elect (Isaac and Jacob). The Ishmael genealogy is quite short (25:12–18), whereas this one is much longer. The genealogy of Esau is also distinctive in having a double heading, “These are the descendants of Esau,” in vv. 1 and 9. This has led commentators to suppose that originally 36:1–8 and 37:1 stood alone; this would make the genealogies of Ishmael and Esau quite similar. Then later 36:9–43 were added, perhaps after David had conquered Edom and incorporated it into his empire (cf. 36:31). Westermann suggests that this latter material came from the royal archives of Edom.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The origin of this material about Edom remains speculative, but its inclusion reflects the close affinity Israel felt for its near neighbor to the south and east of the Dead Sea. The Edomites were believed to be descended from Esau, Jacob’s twin brother. Yet throughout history they were at loggerheads with Israel (Num 20:14–21; 2 Sam 8:13–14; Ps 137:7–9), and this is reflected in Genesis’s account of the rivalry between Jacob and Esau. Nevertheless, the note of bitter hatred of Edom found in the later parts of the Bible following Edom’s role in the destruction of Jerusalem (e.g., Obadiah, Lam 4:21–22) is noticeably absent from Genesis. The portrait of Esau, while not uncritical, is often quite sympathetic (e.g., chs. 27, 33). This suggests that Genesis reflects early attitudes in Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Read without the later insertion of 36:9–43, 36:1–8 and 37:1 explain how Esau’s decision to live in Seir outside Canaan meant that he had excluded himself from the land of promise, which therefore belonged entirely to Jacob and his descendants. It thus implies the partial fulfillment of the promises to Abraham. The insertion of 36:9–43 changes the focus somewhat. It mentions that Esau, too, fathered a nation with kings (vv. 31–39), so that the birth oracle given to Rebekah, “two nations are in your womb,” was also fulfilled. The incorporation of Edom into the Davidic empire also demonstrates that “the elder shall serve the younger” (25:23). Implied too, especially by ch. 33, is the hope of reconciliation between Edom and Israel even though they live in different territories. The long list of names contain many familiar Israelite names and thus underline the common roots and heritage of both peoples.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("36:2–5")]), _vm._v(", listing Esau’s wives and grandsons, do not match 26:34 and 28:9. It seems that the differences stem from different traditions.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("36:10–19")]), _vm._v(" fall into two sections in which the names overlap greatly: 10–14 (Esau’s sons) and 15–19 (the “chiefs [not “clans,” NRSV] of the sons of Esau”). Similarly, vv. 20–30 fall into a list of sons and grandsons of Seir the Horite (20–28) and a list of chiefs (29–30). It seems likely that the Horites were the earlier indigenous inhabitants of Edom, arriving before the descendants of Esau.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("36:31–39")]), _vm._v(" The King List reflects a period before the establishment of the Israelite monarchy. But these Edomite kings seem to have been local rulers without any dynastic succession, and the capital city moves with the king. In this respect it is like the situation of Israel portrayed in Judges.")])]), _c('p', {
    staticClass: "H2"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("The Joseph Story (37:2–50:26)")])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The Joseph Story, as the last fourteen chapters of Genesis are usually called, is something of a misnomer. The Hebrew title of this section is “The Story of the Family of Jacob” (37:2), and this is much more apt, for although more space is devoted to Joseph than to the other members of the family, in certain sections there is no mention of him at all (e.g., ch. 38). More exactly these chapters seem to constitute the second half of the biography of Jacob, which began with the account of his birth in 25:21–26 and ends with his death in ch. 50. His sons are viewed as the ultimate ancestors of the twelve tribes, so their deeds are almost as pivotal as their father’s. Hence just before the close of the book Jacob gives each of his sons a blessing, which anticipates their future roles and destinies (ch. 49). Longacre has plausibly argued that this represents the peak of Genesis, which gives the reader a glimpse of the embryonic nation of Israel and the glorious future of each of its constituent tribes.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Unlike the Abraham and Jacob stories (chs. 12–25 and 25–35), the Joseph story has no clear palistrophic arrangement. Instead the heart of the Joseph story consists of a pair of three parallel panels, A, B, C, A′, B′, C′.")]), _vm._v(" "), _c('table', {
    staticClass: "Table15",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("37:2–36")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Joseph sold into Egypt")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("38:1–30")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Tamar and Judah")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("39:1–20")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Joseph and Potiphar")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("39:21–40:23")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Joseph in Prison")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("B")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("41:1–57")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Joseph in the Palace")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("C")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("42:1–38")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("First visit of Jacob’s family to Egypt")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("A′")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("43:1–45:28")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Second visit of Jacob’s family to Egypt")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("B′")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("46:1–47:31")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Third visit of Jacob’s family to Egypt")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("C′")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("48:1–50:26")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Last days of Jacob and Joseph")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("The Joseph story, like the Abraham and Jacob stories, contributes to the exposition of the theme of the Pentateuch by showing how the promises to Abraham were partially fulfilled. And like the two preceding stories, it begins with a divine intimation of the central figure’s future destiny: in two dreams Joseph sees the rest of his family bowing down before him. His brothers’ sale of him into Egypt was designed to prevent such an outcome, but inexorably, despite his imprisonment on a false charge, he rises to be vizier over all Egypt. And it is when his brothers come to Egypt that they unwittingly fulfill his early dreams (42:6; 44:14). Some have held that the Joseph story proper ends with his father’s move to Egypt, but his brothers fall down before him one last time after Jacob’s death (50:18). The key point of the story is expressed in 50:20: “Even though you intended to do harm to me, God intended it for good, in order to preserve a numerous people.” It tells of the ultimate reconciliation of the schisms that had rent Jacob’s family ever since he had married Leah as well as Rachel, suggesting to later generations that tribal factionalism should also be overcome.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A unique aspect of the Joseph story is its Egyptian setting, which has prompted much reflection by Egyptologists. It is evident, on the one hand, that the author is very familiar with Egyptian customs, but, on the other, he is writing about Egypt in a way that is intelligible to later Israelites. Does this enable us to place the career of Joseph in a definite period of Egyptian history and give any clues as to the period in which the story was written up? Answers differ, but on balance the following conclusions would appear likely.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Many features of the narrative would be at home in Egypt at almost any period, so they cannot be invoked for dating purposes. But Joseph’s name, like several other patriarchs’, is typical of early-second-millennium Amorite names. Texts show that many Asiatic slaves were brought to Egypt in this era. Joseph’s rise to power could well fit the Hyksos period (c. 1650–1540 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") when Semitic chieftains ruled Egypt; it was also then that the Egyptian capital was in the eastern Nile delta. The names Potiphar, Zaphenath-paneah and Asenath could well have originated then, though the pronunciation seems to reflect the Ramesside era (13th cent.), generally identified with the time of Moses. However, some phrases seem to reflect later Israelite terminology. In 41:23 the good ears of corn are blighted by the "), _c('i', [_vm._v("east")]), _vm._v(" wind, as they would be in Canaan, but in Egypt it was the "), _c('i', [_vm._v("south")]), _vm._v(" wind that shriveled up the crops. Similarly, Joseph’s appointment to be “over my house” (41:40) fits his appointment as Pharaoh’s deputy if taken in a Hebrew sense, not an Egyptian one. These data suggest that the traditions about Joseph reach well back into the second millennium, but that they may have received their final form in Israel somewhat later.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Coats, G. W. 1976, "), _c('i', [_vm._v("From Egypt to Canaan")]), _vm._v(", Washington, D.C.: Catholic Biblical Association • Hoffmeier, J. K. 1996, "), _c('i', [_vm._v("Israel in Egypt")]), _vm._v(", Oxford: Oxford University • Humphreys, W. L. 1988, "), _c('i', [_vm._v("Joseph and His Family")]), _vm._v(", Columbia: University of South Carolina • Kitchen, K. A. in Hess, Satterthwaite, and Wenham. 1993, 67–92 • Longacre, R. E. 1989, "), _c('i', [_vm._v("Joseph: A Story of Divine Providence")]), _vm._v(", Winona Lake: Eisenbrauns • Vergote, J. 1959, "), _c('i', [_vm._v("Joseph en Egypte")]), _vm._v(", Louvain: Publications Universitaires.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Joseph Is Sold into Egypt (J, E, P) (37:2–36)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Like the family story of Isaac, Jacob’s family story tells of a conflict that will divide the family for some twenty years. Once again it is a conflict between brothers triggered by parental favoritism. Whereas Isaac preferred Esau and Rebekah Jacob, Jacob had always loved Rachel and her sons more than Leah’s. (Translators cannot agree whether Jacob marked his favoritism with the gift of a long-sleeved coat or a multi-colored one.) But as before, the children aggravate the problem (cf. 25:25–34; ch. 27) to such an extent that they speak of killing each other. Here Joseph’s tactlessness in telling tales on his brothers and then recounting his dreams makes his brothers mad.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, as already observed the dreams are not Joseph’s own imaginings but announcements of God’s plans, and the fact that they are paired is an assurance of their eventual fulfilment (cf. 41:32). In the short term, however, they act as a catalyst of family breakdown.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("The tension in the story builds as Jacob sends his darling son some fifty miles away from home in Hebron to Shechem in the north into the arms of the brothers who ")]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("hate him intensely. As they see him approach, some want to kill Joseph, whereas Reuben seeks to stall proceedings by having him dumped in a pit. But evidently while he is away, the other brothers change their plan and decide to make a tidy sum of money (twenty shekels represents two to three years’ wages for a hired shepherd) by selling Joseph as a slave.")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The identity of the slave traders has long proved a crux for commentators. In 37:25, 28 and 39:1 they are called Ishmaelites, but in 37:28 and 36 they are termed Midianites. Some have supposed that two groups of traders were involved, others that the variation represents the terminology of different sources. However, there is no doubt that the author of Genesis thought Ishmaelites and Midianites were alternative names for the same group of people (cf. 37:36 and 39:1 and Judg 8:24). Why they should sometimes be called Ishmaelites and sometimes Midianites is less clear. It may be that Ishmaelite means “nomadic trader” and Midianite refers to the tribe they belonged to, or Ishmaelites may be the larger tribal grouping of which Midianites were a smaller group.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The last scene with Jacob mourning inconsolably for his dead son Joseph is touching, but the phraseology is doubtless chosen to remind us of how Jacob years before deceived his father using his brother’s clothes and a goat (ch. 27). “He recognized it” (37:33) picks up another word from 27:23. In this way the author hints at the inescapability of divine justice. Jacob is being treated by his sons as he treated his father. But, as the story will show, Joseph’s sale into Egypt will in the end work out to save many lives, heal the family rift, and forward the fulfillment of the promises.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Tamar and Judah (J) (38:1–30)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("On the face of it this episode has very little to do with the surrounding material: the story of Joseph would flow much more smoothly if it were not interrupted by this digression about Tamar and her children. However, as Alter and Humphreys, among others, have noted, this episode offers a significant commentary on the Joseph story and indeed helps to explain the remarkable transformation in Judah’s character between chs. 37 and 44.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The most obvious parallel between the Joseph and Tamar stories comes out in 38:25–26. “Take note” or “acknowledge” is the same term as “see now” or “recognize” in 37:32–33. It should also be noted that there is a similarity in the actions of the parties. Jacob deceived his father Isaac, was in turn deceived by his sons led by Judah, who finally was tricked by his daughter-in-law. In all the incidents items of dress and goats play a role.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Another principle emerges in the Joseph story, and this one, let alone elsewhere in Genesis, is God’s choice of the younger son in preference to the older (cf. Esau and Jacob, Joseph and his brothers, Manasseh and Ephraim). In this story there is a double statement of this principle. First, Judah’s older boys, Er and Onan die, but Shelah survives (38:3–11); then at the end of the story Zerah sticks his hand out first, making him the firstborn, but Perez arrives first, and later proves to be the ancestor of King David (Ruth 4:18–22). This double reinforcement of the principle of God’s choice of the younger serves to underline that Joseph’s dreams of supremacy will eventually prove justified.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Chapter 37 ended with Jacob inconsolable at the death of one son Joseph, whereas ch. 38 opens with Judah apparently accepting stoically the death of his two sons. This fits in with the hard calculating image of him in 37:26 cold-bloodedly selling his brother into slavery. Yet in 44:18–34 he is seen pleading with great warmth and tenderness for Benjamin’s release, so that his father will not have to suffer anymore. The beginnings of this transformation are seen in his confession of guilt in 38:26.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Finally, this episode reinforces some of the key themes of Genesis. Tamar is one of those foreigners (cf. Melchizedek [ch. 14] and Abimelech [chs. 20, 26]) who put the descendants of Abraham to shame by being more concerned with righteousness and the fulfillment of God’s purposes than the chosen line. Onan, and by implication Judah, display an indifference to fulfilling the promise by not obeying the command to have children. Tamar, on the other hand, is desperate to have a child, so at the end Judah acknowledges, “She is more in the right than I.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Judah disregards patriarchal principle by marrying a Canaanite (cf. 24:3; 28:1), so it may be that Genesis does not regard his sons’ death as entirely unmerited (cf. 38:7). However, according to the customs of the time, it was compulsory for a childless widow to marry the next boy in the family. This rule of Levirate marriage is known among many peoples, including the Assyrians, Hittites, and Canaanites, and is further spelled out in Deut 25:5–10. By the time of Deuteronomy the duty of the Levirate was no longer mandatory, and could be avoided at the cost of public derision. But Judah simply sidestepped the obligation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, Tamar makes an even greater laughingstock of Judah than the book of Deuteronomy would have and exposes his callous hypocrisy. Quite how she dressed so that she was taken for a prostitute is not explained, but it worked. And Judah is shown to be more concerned with paying his fee to the prostitute than doing his duty to his daughter-in-law by providing her with a husband. Because Tamar had been promised to be given in marriage to Shelah, though it was never carried out, she was technically guilty of adultery, or at least a capital offense, for having intercourse with a third party (cf. Deut 22:22–24). However, in the later law burning was reserved for particularly shocking offenses (Lev 21:9). Judah’s demand for it here again illustrates his brutal callousness. Yet at his moment of self-righteous triumph his daughter-in-law proves her own integrity and his humbug.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Joseph and Potiphar (J) (39:1–20)")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("The tale of the immoral Israelite male worsted by the upright foreign female Tamar is followed by the story of the immoral foreign female apparently vanquishing the immaculate ")]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("Joseph. Yet the story begins by insisting that “The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" was with Joseph” (39:2). The next episode starts similarly (39:21), though it, too, appears to end in disaster for Joseph. These two episodes showing Joseph serving Egyptian overlords for no reward are then complemented and contrasted with a third episode, where he suddenly rises to become Pharaoh’s right-hand man, in which it is patently obvious that God is on his side, though the author never says so.")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Chapter 39 has often been compared with the thirteenth-century-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" Egyptian “Tale of Two Brothers,” and it has been argued that Genesis is dependent on this story. However, there is remarkably little to suggest any connection except that both deal with the issue of a faithful single man who spurns the advances of a married woman, a motif found in many ancient tales. What Genesis stresses is both Joseph’s total reliability so that Potiphar made him chief steward over all his estate (vv. 5–6) and also his stunning beauty, perhaps inherited from his mother Rachel, the only other person in the OT described as Joseph is in v. 6 (29:17).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The attempted seduction is described three times. First, accurately by the narrator in vv. 7–12, then by Potiphar’s wife to the slaves in vv. 14–15, and finally to her husband in vv. 17–18. In both cases she distorts the events to put Joseph in the worst possible light. In addressing the slaves she identifies with them against Joseph and her husband in v. 14, and when talking to her husband she sides with the Egyptians against foreign slaves in v. 17. Her lies have the required result of infuriating her husband, but maybe they did not entirely convince him. Had he been sure of Joseph’s guilt, he might have had him executed: instead Potiphar confines him to the royal prison which he managed. Whereas this looks like further degradation for Joseph, a step worse than slavery, like his sale into slavery years earlier, it actually moves him closer to triumph and the fulfillment of his childhood dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Joseph in Prison (E, J) (39:21–40:23)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This, like the previous episode, begins with the observation that the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" was with Joseph (39:21; cf. 2) and an account of Joseph’s promotion to a position of authority. As before, however, his situation at the end seems more hopeless than at the outset. The chief cupbearer whom Joseph had asked to mention him to Pharaoh forgot and left him there in prison.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As in chs. 37 and 41, two dreams are described: this interest in dreams fits the Egyptian setting of the story, where dreams were seen as the gift of the gods putting one in direct contact with the supernatural world. However, Egyptians also believed that you needed experts to interpret dreams, and they were not readily available in prison. Hence the prisoners’ glumness and Joseph’s reassurance (40:7–8).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The chief cupbearer’s dream compresses three stages of wine production—blossom, ripening, and pressing of grapes—into quick succession, suggesting perhaps the rapid fulfillment of the dream. The cupbearer was probably more than chief wine-taster; he probably acted as adviser to Pharaoh (cf. Nehemiah’s similar role in Neh 1:11–2:8). Doubtless the promise of restoration was very welcome to him.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Bakery was a well-developed art in Egypt; so, encouraged by Joseph’s interpretation of the other dreams, the chief baker tells his dream. Joseph makes his interpretation of the second dream as much like the first for as long as he can; only with the hanging of the baker does it diverge. The impaling of the corpse on a pole after execution is probably intended. This gruesome and exemplary form of capital punishment was intended to prevent the soul of the criminal from resting in the underworld.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Unfortunately for the baker Joseph’s interpretation was fulfilled, but this of course vindicated his claim to have God’s help to interpret dreams (cf. 41:16).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Joseph in Pharaoh’s Palace (E, J?) (41:1–57)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Chapter 41 concludes the thirteen-year interlude in Joseph’s life covered by chs. 39 and 40 (41:46; cf. 37:2). Separated from his family and struggling to make his way in Egypt, Joseph has twice been promoted by high Egyptian officials only later to be cast aside. In﻿ ch. 39 he rises to become chief steward in Potiphar’s household, but ends up in prison. In ch. 40 he becomes confidant of the royal baker and cupbearer, only to be forgotten when the latter is released. Ch. 41 constitutes the third scene in this great triptych. Compared with the preceding chapters it starts ominously, for it says nothing about the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" being with Joseph. Yet this time God is more evidently with Joseph than ever before, for he is miraculously brought out of prison, interprets Pharaoh’s dreams, and is appointed second man in the kingdom.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The episode begins with two bizarre dreams. But even with access to the royal dream interpreters, Pharaoh cannot interpret them. This jogs the cupbearer’s memory, and Joseph is summoned from the prison. The rapidity of Joseph’s transformation from forgotten prisoner to royal adviser is accentuated in v. 14. But even to Pharaoh Joseph insists that it is God who enables him to interpret dreams, not his own intelligence. V. 16 should probably read: ‘Except for God, who can announce Pharaoh’s welfare?” but the drift of the NRSV is much the same.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Pharaoh’s retelling of the dream embellishes the first account somewhat (e.g., vv. 19, 21), which helps us to appreciate how disturbed he was by this pair of alarming dreams. Joseph not only interprets them in a fairly natural way and explains the purpose of paired dreams, but he also turns them into a prophetic oracle about the future. The language of v. 29, literally, “Behold, seven years are coming,” sounds like prophecy, and the conclusion drawn, “Now therefore let Pharaoh select a man …,” is a prophetic call to action. However, “take one-fifth of the produce of the land” (v. 34) is probably too precise at this juncture in the story; it may be translated more simply, “organize the land.”")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("Pharaoh responds promptly and appoints him to the position of second-in-command in the land (vv. 40, 43). As vizier he was the great supervisor of all Egyptian government ")]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("activities. The title “over my house” would, if it were a literal translation of the Egyptian phrase “master of the palace,” indicate an official of lesser authority than the vizier, but it probably has the usual Hebrew sense here. The master of the house in Israel was second to the king, just as the vizier was in Egypt.")])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The vivid description of Joseph’s installation as vizier in vv. 42–43 can be filled out from paintings of similar ceremonies from Egyptian tombs. Indeed, one portrays the appointment of the Semite Tutu as vizier. Various suggestions have been made about the original form and meaning of Joseph’s Egyptian name, perhaps “the god has said, ‘he will live,’ ” “the man he knows,” or “[Joseph], who is called Ip-ankh.” His wife’s name Asenath means, “she belongs to the goddess Neit,” or “she belongs to her father,” or “she belongs to you.” Joseph’s age at his appointment (v. 46) allows us to calculate how long he had been in Egypt (cf. 37:2).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The explanation of the names of Manasseh and Ephraim (vv. 51–52) is paradoxical. Had he really forgotten his family, Joseph would not have mentioned them here. Besides, his insistence in v. 32 that a doubled dream indicates that fulfillment will be certain and prompt raises questions about his own dreams. Will his family ever see him again? Characteristically of Genesis, the last scene of one episode, here the coming of all the world to buy food from Egypt (vv. 54–57), anticipates the topic of the next section (chs. 42–47), when eventually all the brothers and his father will come and bow before him as the dreams foretold.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("First Visit to Egypt by Jacob’s Family (E, J) (42:1–38)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This chapter opens a new phase in the family’s history. For about twenty years the narratives have focused on Joseph in Egypt: apart from ch. 38 we are told nothing of what was going on with Jacob’s family in Canaan. But now three parallel episodes in Joseph’s career are followed by three journeys to Egypt by the rest of the family (ch. 42, chs. 43–45, chs. 46–47).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Here Jacob reemerges as a major figure. He may be ageing, but he is still head of the family: it is his decision that leads his sons to go to buy bread in Egypt. But he is still protective of Benjamin, here called Joseph’s brother (42:4), as if to remind us of Jacob’s special love for the sons of Rachel.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In bowing down to Joseph, his brothers are partially fulfilling his dreams described in 37:6–10. But this of course sharpens Joseph’s curiosity: What has happened to his brother Benjamin and his father? The sharp interrogation that follows is partly to elicit this information, but it is also designed to put the brothers into a position similar to that in which they were when they abandoned him. Now he wants to test them (42:15), ostensibly to see if they are telling the truth, but more importantly to see if they will adopt the same heartless attitude to Simeon as they did to him. His brothers clearly sense the parallel between this situation and the earlier one. They feel that divine justice is catching up with them, and they argue about who is most to blame. Interesting details about Joseph’s sale, for example, his unheeded pleas for mercy, emerge in their conversation, which ch. 37 did not mention. The narrator alerts us to the fact that Joseph is not as callous as he appears by mentioning his weeping at hearing their confessions of guilt.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is not clear why he returned their money in their sacks, but their guilty consciences interpret it as another bad omen (42:28). They give Jacob a rather sanitized account of their meeting with Joseph, leaving out some of their more unpleasant experiences, such as their joint imprisonment, describing Simeon’s detention in the kindest of ways, and adding a promise Joseph did not make about free trade (vv. 30–34)!")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, the discovery of money in all their sacks alarms them and their father still further. The brothers doubtless saw this as another sign of judgment catching up with them, while Jacob maybe saw it as proof that they had actually sold Simeon into slavery: that is why the money had come back. So the scene ends with another bitter interchange recalling Jacob’s distress when the brothers brought back news of Joseph’s disappearance. Emotionally this is a rerun of that bitter episode. But the reader is wiser than the actors and can look forward in a more detached fashion to how they will react to the test (cf. 22:1).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Second Visit of Jacob’s Family to Egypt (J, E) (43:1–45:28)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The description of this second visit by Joseph’s brothers runs in close parallel to the first. (1) Jacob sends his sons to Egypt (42:1–4 par. 43:1–14); (2) arrival in Egypt (42:5 par. 43:15–25); (3) first audience with Joseph (42:6–16 par. 43:26–34); (4) brothers in custody (42:17 par. 44:1–13); (5) second audience with Joseph (42:18–24 par. 44:14–45:15); (6) departure from Egypt (42:25–28 par. 45:16–24); (7) sons report to Jacob (42:29–38 par. 45:25–28). There are many references back to the first visit in this second one. The much greater fullness of the account of this second visit shows that this is the climax of the Joseph story. The narrative tension builds through each scene until following Judah’s great confession of guilt and plea for mercy the brothers are reconciled and their father consoled. Here we have Hebrew storytelling at its best, and attention will be drawn to some of its techniques.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("43:1–14")]), _vm._v(" As before (cf. 42:1), it is Jacob who takes the initiative and suggests that his sons go down to Egypt to buy grain. But this trip is much more problematic as a result of what happened on the previous outing. Not only is Simeon detained there, but Joseph has demanded that Benjamin be brought to Egypt as well, something Jacob is extremely loath to permit.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("So once again the brothers discuss their last visit to Egypt. This time they are forced to stress the seriousness of the warning given to them about the consequences of not bringing Benjamin. And Jacob blames them for letting on that there was a younger brother. Eventually it is Judah’s pledge to be responsible for Benjamin’s welfare that persuades Jacob to let him go; already Judah’s ")]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("change of heart is beginning to be evident. However, just as he did when going to meet Esau, Jacob does his best to smooth their way by preparing a large present. But he is not sanguine about success, fearing that he will be bereaved again.")])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("43:15–25")]), _vm._v(" The narrative pace slows still further as their arrival in Egypt is fully described (cf. the brevity of 42:5). The tension rises as they are unexpectedly invited to dine with Joseph, who had seemed so hostile last time; only massive reassurances from the steward persuade them that they are not all about to be imprisoned. The restoration of Simeon seems to confirm his promises.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("43:26–34")]), _vm._v(" The audience with Joseph seems to go much more smoothly than on previous occasions. Joseph’s joy on meeting his full brother Benjamin is mentioned to preclude any misinterpretation of his apparent harshness in the next encounter. But yet again the other brothers are alarmed by the seating plan, which seems to them like a spooky coincidence. But good food and drink help them forget their fears and enjoy themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("44:1–13")]), _vm._v(" Modern readers, all too conscious of miscarriages of justice as a result of frame-ups, react uneasily to this account of Joseph’s entrapment of his brothers. But this is to overlook the purpose of his actions; he is trying to re-create a parallel situation to the day they delivered him to the Ishmaelites despite the agony it caused their father. He is trying to discover whether they are ready to treat Benjamin in the same way.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("His brothers, knowing their own innocence, try to demonstrate it by pointing out their honesty in returning the money found on the first trip. Then they rashly offer that if anyone is found to have stolen Joseph’s cup he shall die, and all the others be enslaved. By this offer they are in a sense replicating Joseph’s experience: he was enslaved, though his father believed him dead. But Joseph wants to test the bonds between Leah’s sons and Rachel’s, so his steward insists that only the guilty party must suffer.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The speed with which they submit to a search demonstrates their own conviction of innocence. But the tension rises as the search ends with the youngest and the cup is found. The episode invites comparison with Laban’s pursuit of Jacob and his sons and the search for the teraphim. Then Jacob pronounced a death sentence on the guilty, not realizing that his favorite wife was to blame. On that occasion she escaped. But this time the only known surviving son of Rachel has been condemned by his brothers. How will they react to his arrest?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("44:14–45:15")]), _vm._v(" In this climactic scene the full extent of the brothers’ transformation becomes apparent. They all tear their clothes and return to the city, showing their solidarity with Benjamin. And there Judah, who earlier had appeared to be one of the most hard-hearted and callous of them, makes a “speech of singular pathos and beauty” (Driver) in which he shows an amazing empathy with his father. It includes various details from the past that are already well known to the reader about Jacob’s affection for Benjamin and his consequent reluctance to let him visit Egypt, but there are also fresh points. He accepts Jacob’s blatant favoritism as a matter of course: “my wife bore me two sons” (44:27) implies that Jacob regarded Rachel as his only wife and only her two sons as his own. Yet Judah does not hold his own delegitimation by his father against him; rather, he cites it as an argument for sparing Benjamin. Then he mentions Jacob’s reaction on seeing Joseph’s garment, “Surely he has been torn to pieces.” Finally, Judah offers, indeed insists, that he, the rejected son, should be taken as slave in place of Benjamin, whose detention would cause the death of his father.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Given this comprehensive change of heart by his brothers, it is little wonder that Joseph breaks down. Nor is it surprising that his brothers are struck dumb by his self-revelation. Joseph does not simply reassure his brothers in a psychological way, though; he argues theologically. “It was not you who sent me here, but God … to preserve life” (45:8, 5) sums up the theological message of the Joseph story and ties it in with the theme of the Pentateuch. The sale of Joseph ensured the preservation of Abraham’s descendants and of many others as well, so that through him the families of the earth started to find blessing.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Joseph also mentions his special relationship to Pharaoh: “father to Pharaoh” means adviser to him. And whereas Joseph merely offered them the land of Goshen, somewhere in the East Nile Delta, Pharaoh is even more expansive, offering “the best of the land of Egypt” (vv. 18, 20). He not only gives them food and new sets of clothes, but he also supplies wagons (to judge from contemporary paintings, two-wheeled oxcarts) to transport the young and the elderly down to Egypt.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("45:25–28")]), _vm._v(" The closing scene offers a marvelous contrast to the last two mentioned returns of the brothers to Jacob. On both of those he declared that he would go down in mourning to Sheol, the abode of the dead (37:33, 35; 42:36, 38). Now he triumphantly declares, “Enough! My son Joseph is still alive. I must go and see him before I die.” For other dramatic exit lines anticipating the next section of the story cf. 27:45; 29:14; 30:24; 37:35; 42:38.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Third Visit of Jacob’s Family to Egypt (P, E, J) (46:1–47:31)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The third visit of Jacob’s family to Egypt differs from the first two in lasting much longer; indeed, it looks like permanent immigration. But as God stresses in the opening vision to Jacob, it will be temporary. And before he dies, he insists that he must be buried in Canaan, the land of promise, with his ancestors. That is the people’s true home. Within the total time span of the Pentateuch the Israelite sojourn in Egypt is just a blip in the progress toward settlement in Canaan (cf. 15:13–16).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("However, for Jacob, who often anticipated his own death long before it occurred, it was a momentous step moving to Egypt. As he neared the border of Canaan near Beer-sheba, which was often regarded as the practical southern limit of the promised land, he offered sacrifices. There in a night vision he heard the traditional promises of nationhood, protection, and land reiterated for the last time in Genesis (cf. 12:1–3), as well as the ")]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("unique assurance that Joseph would close his eyes in death. It may also be noted that this is the last statement of the promises to the patriarchs; not until the era of Moses will the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" reaffirm them and bring their fulfillment much closer.")])]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("On the face of it these chapters seem to be a rather unconnected collection of diverse materials. Besides the obviously relevant account of the journey to Egypt and the meeting with Pharaoh, there is a list of Jacob’s descendants (46:8–27), a description of Joseph’s famine relief measures (47:13–26), and a deathbed oath (47:29–31). But on further reflection these elements are all closely connected to the theme of the Pentateuch.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The list of Jacob’s descendants names seventy people who went down to Egypt with him. Seventy is also the total number of nations listed as descendants of Noah in ch. 10, so seventy had some symbolic significance in Bible times. This is confirmed by a careful reading of 46:8–27, which shows the author’s keenness to make the total come to seventy. It looks as though he had a list of seventy descendants of Jacob, but then he realized that not all of them entered Egypt (e.g., Er and Onan; v. 12), or that some were born in Egypt (e.g., Manasseh and Ephraim; v. 20). Strictly speaking, just sixty-six descendants went down with Jacob, but if Dinah is added as well as Joseph and his sons, the total reaches seventy (vv. 26–27). Sarna (317) has suggested that seventy represents totality: it expresses the idea that all Israel went down to Egypt. It also shows how the promise of a multitude of descendants, first made to Abraham (12:2), is progressing toward fulfillment. The first readers of Genesis would have recognized these names, not simply as the names of their ancestors but as names of tribes and clans, so to them the fulfillment of the promise would have been even more apparent.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("After the pause to list Jacob’s descendants the story of the move to Egypt continues. Though the meeting of Jacob and Joseph is described briefly, it is pregnant with emotion. The superfluous remark about Joseph making ready his chariot suggests his excitement at the prospective reunion. Then the author suggests the impact Joseph’s coming made on his father. Translated literally, the text says, “he appeared to him” (NRSV, “presented himself to him”). This terminology is reserved elsewhere in the OT for God’s appearance to human beings; here it expresses the power and grandeur of Joseph in his chariot, accompanied by all his servants. But it is Jacob’s words, “I can die now … [for] you are still alive,” that are the most evocative for their sweet contrast with his previous comments on his death (37:33, 35; 42:36, 38; 45:28).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("46:31–34")]), _vm._v(" For his part Joseph is concerned that his brothers should not put their foot in Goshen until they meet Pharaoh. He will make it clear to Pharaoh that they have brought their flocks with them, so that they will not be sponging off the state. For their part they must describe themselves as “keepers of livestock,” not “shepherds,” because the Egyptians hate shepherds. Egyptian literature does not disclose a particular dislike of shepherds; it seems likely, though, that Joseph is pointing to the widespread distrust of nomadic peoples (e.g., gypsies) by settled urban people.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("47:1–6")]), _vm._v(" But in the pomp of the audience with Pharaoh the brothers forgot Joseph’s advice and duly describe themselves as shepherds! Such is the benevolence of Pharaoh toward Joseph’s family, however, that it does not matter. Indeed, in stilted official language he gives them permission to settle in Goshen as they had requested and offers them jobs as royal stockmen. Texts from the time of Rameses III show that foreigners were often employed in this role.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Jacob’s meeting with Pharaoh is much less formal. The aged Jacob has to be brought into court and is then stood up (NRSV, “presented,” fails to bring out the fact that Jacob had to be helped to stand, as the Hebrew implies). Then rather than Pharaoh granting favors to Jacob, it is Jacob who blesses Pharaoh (vv. 7, 10). All Pharaoh does is to inquire respectfully as to his age. Jacob’s reply alludes to the many sorrows that have dogged his career (his flight from home, Rachel’s death, the ravishment of Dinah, Joseph’s disappearance). Then through Joseph Pharaoh grants the family permanent settlement rights in Egypt, “a holding in the land of Egypt,” which gave them more rights than the typical immigrant. “The land of Rameses” (v. 11) appears to be a later name for the area of Goshen.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("“I will bless those who bless you.” Pharaoh’s treatment of Jacob and his family certainly put him in the category of those who may expect to be blessed. As far as Genesis is concerned, this blessing extends not simply to Pharaoh but to his land, and this is illustrated by Joseph’s handling of the famine. To modern readers this looks like exploitation, but this is not the perspective of the ancient Israelites or according to the story of the Egyptians either. They express their gratitude to Joseph for saving their lives (v. 25).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The OT approach to destitution is set out in Exod 21:2–11, Leviticus 25, and Deut 15:1–18. Free landholding peasants were liable to fall into debt whenever drought led to crop failure. In the absence of a welfare state richer relatives or neighbors were expected to help them out first by buying the debtor’s children as slaves, then by giving a mortgage on the debtor’s land, and finally, if the worst came to the worst, taking on the debtor as a slave himself. Two points should be noted about these apparently harsh arrangements. To be a slave, as the OT envisages it, was more like being an employee in modern society, whereas being free was like being self-employed. The OT therefore envisages that many slaves may decide to turn down their right to freedom at the end of six years; they may prefer the security of being a slave of a good employer to the risks of being free and self-employed (Exod 21:5–6; Deut 15:16–17). Secondly, when land was mortgaged or a landowner sold himself into slavery, he or it was automatically released without payment in the Year of Jubilee, which occurred every fifty years (Leviticus 25).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("The arrangements Joseph made are not exactly those envisaged in the law. Whereas in Israel it was the wealthy relative or neighbor who was expected to bail out the bankrupt, in Egypt it was Pharaoh. Four stages of increasing destitution are described. First, when their own crops have failed, the Egyptians bought grain for money ")]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("from Joseph. Then they mortgaged their animals; it would seem unlikely that they actually sold them. Then they mortgaged their land, or, more exactly, sold it and leased it back in exchange for grain. Finally, they sold themselves as slaves (47:21). As a result of these deals, they saw Joseph as having saved their lives (v. 25). Though the date of Joseph’s career cannot be established on the basis of this story, it certainly reflects accurately the tenancy arrangements in Egypt, where all the land was held by the crown or the temples and private landownership hardly existed.")])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("If Joseph’s saving Egypt from starvation reflects the partial fulfillment of the promise that “in you all the families of the earth shall be blessed,” the episode closes with other clear allusions to the promises, namely, the multiplication of Jacob’s descendants and his wish to be buried with his ancestors in Canaan (vv. 27, 30). As often in Genesis, the last scene of one episode anticipates the topic of the next one, here Jacob’s deathbed testament.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Last Days of Jacob and Joseph (J, E, P) (48:1–50:26)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The most important figure of Genesis is Jacob, the father of the nation of Israel, and for this reason the narrative gives ample space to describing his death and burial. Indeed, it has been argued that the last words of Jacob, the blessing of Jacob in ch. 49, constitute the book’s peak with its vision of the twelve future tribes of Israel each occupying their allocated portion of the promised land.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Initially this section of the book looks somewhat disorganized, and various attempts have been made to explain the diversity of the material in terms of different sources being drawn upon. But as pointed out in the commentary on ch. 35, there is a similar arrangement of topics and material at the end of the previous main sections of the book, that is, 22:15–25:10 and 35:9–29, which suggests that the same author or redactor is responsible for these passages. Running through this whole section is a strong affirmation of the promises and their fulfillment. Jacob’s last recorded words, like those of his grandfather before him and his own father Isaac, are all concerned with the promises made by God and the progress toward their fulfillment. Each expresses both his own faith in God’s power to fulfill them and the need of his children to exercise a similar faith and work toward their fulfillment.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Jacob begins (48:3–4) by reminiscing about the past, bringing together promises made to him at Bethel (35:11–12), the last words of his father Isaac (28:3), and elements of the promises made to Abraham (17:8). He then proceeds to adopt Joseph’s sons, Ephraim and Manasseh, as his own, thereby putting them on a par with his own sons, such as Reuben and Simeon. This explains why the traditional twelve tribes include Ephraim and Manasseh but not Joseph. Adoptions within a family are well known in the ancient orient: a text from Ugarit mentions a grandfather adopting his grandson as his heir.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But in adopting Manasseh and Ephraim Jacob reverses their seniority, putting the younger Ephraim before the older Manasseh by placing his right hand on the younger boy. This so annoys Joseph that he grasps (NRSV, “took,” is too gentle) Jacob’s right hand to put it on Manasseh’s head and addresses his father rather brusquely. But Jacob, despite his blindness, knows what he is doing and insists on the new order. Manasseh will become a people, but Ephraim a multitude of nations, perhaps echoing the promise to Abraham (17:4–6). This recollection of the descendants prompts Jacob to reassert the importance of the land promise: his descendants will return to Canaan and take possession especially of the portion he had conquered by the sword. It is not clear which part of the land he means, but the area where Shechem lived seems most probable (cf. ch. 34).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This incident is full of echoes of Isaac’s blessing of his sons Jacob and Esau. It is a deathbed blessing. Both patriarchs are blind or nearly so (cf. 48:8, 10). In both the natural order of seniority is reversed, once involuntarily and once deliberately. In both there is a strong request to maintain the birth order, which is rejected by the patriarch. If Isaac’s unintended reversal of seniority is unalterable, how much more is Jacob’s deliberate change. But this reversal is not peculiar to chs. 27 and 48; it is also the case with Cain and Abel, and Perez and Zerah (4:1–8; 38:27–30), making it almost a general principle in Genesis.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("After adopting his grandsons and blessing them Jacob finally addresses his sons in a long poem that is usually called “the blessing of Jacob” (49:2–27). Much discussion has taken place about the origin and transmission of this poem. It is universally acknowledged to be one of the oldest parts of the Hebrew Bible. It may indeed go back in some original form to Jacob himself, but its present form is later than the patriarchal age. For the most part it pictures the situation of the tribes in the judges era, so it may date from then. But when it portrays the future of Judah, the rise of the Davidic monarchy is clearly in mind, so some would date it then.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It has sometimes been suggested that the blessing of Jacob is really a conglomerate of originally independent sayings, but this seems unlikely because about two-thirds of the poem reflects on the major actors in the rest of Genesis, Judah, Joseph, Reuben, Simeon, Levi, and Benjamin, whereas the others mentioned only in lists have about one verse each. It is hard to see these individual verses ever circulating on their own, or the curses on Reuben, Simeon, and Levi being preserved separately by the tribes themselves. For this reason it seems best to take the poem as a unit and try to understand the individual sayings within the context of the whole.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Like Noah (9:25), Jacob begins by cursing the sons guilty of unfilial behavior. The oldest by right had various privileges and was believed to inherit his father’s dynamism (v. 3), but Reuben had forfeited his rights by misbehavior, sleeping with his father’s concubine (35:22). Jacob had said nothing about it then, but now on his deathbed he speaks his mind (cf. 1 Kgs 2:5–6) and demotes his eldest from being head of the family.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("Simeon and Levi were the next in age, but their behavior in slaughtering the sons of Hamor after the Dinah affair had annoyed Jacob (34:30), and now he more outspokenly condemns their acts. Some of Jacob’s imagery is ")]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("obscure. It is clear that he is referring to their revenge in general, but not what their hamstringing of oxen refers to. Genesis 34 speaks of them capturing oxen, not hamstringing them. It therefore seems likely that the oxen are figurative, referring either to the leaders of the Canaanites who were massacred, or to Jacob himself, whose plans for peaceful coexistence with the Canaanites were ruined by his sons’ action. Jacob therefore sentences the descendants of Simeon and Levi to dispersal in Israel. The tribe of Simeon was gradually absorbed by the surrounding tribe of Judah, while the Levites were assigned forty-eight cities throughout the land when it was allocated by Joshua. Thus both tribes could be said to have been divided and scattered.")])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Judah, next in age, therefore inherits the family headship. The sayings about him are the longest and the first that could be termed blessings. He is pictured as the acknowledged leader of his brothers (49:8), and like a lion that seizes its prey, returns to its den, and dares anyone to challenge it (v. 9). This image foreshadows the military triumphs of David and gave rise to the messianic title “The Lion of Judah.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("49:10 continues this picture of Judah as national leader, and declares that it will be permanently his: “the scepter shall not depart.” What is more, a permanent Judean dynasty will ensure “ruler’s staff … feet.” Finally, all nations will pay tribute to him. The first part of “until tribute comes to him” has been discussed at great length. The NRSV margin gives some other possible translations, but has put the most likely in the main text. Many psalms mention that the Davidic king was appointed to rule the nations, and this seems to be the allusion in Genesis too (e.g., Ps 72:8–11).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Finally, this age when this king appears will be one of astonishing plenty. The territory of Judah is famed for its grapes, but in this era there will be such a grape harvest that it will not matter if the tethered royal donkey eats them and people wash their clothes in wine. 49:12 either takes this picture of abundance further or is a description of the king’s beauty.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The saying about Zebulun (49:13) is problematic, for though they settled in the north near Sidon, they lived inland some way from the coast (Josh 19:10–16). Maybe some Zebulunites worked for the Phoenicians, or the tribe settled by the sea for a short while.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Issachar (49:14–15) will settle in a fertile part of the country and there become a slave to its neighbors. De Vaux (1978: 664) has linked this prophecy with an El-Amarna letter which mentions slave-labor gangs in the area of Issachar’s settlement, the eastern Jezreel valley, but this is uncertain.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A pun on Dan’s name (= he judged; cf. 30:6) is followed by a comparison with a horned viper, suggesting the tribe will be small but deadly to its enemies. There may be an allusion here to the exploits of Samson, a Danite (Judges 13–16). The prayer in 49:18 may reflect the precarious position of the tribe of Dan in the judges period (they were forced to emigrate northward; Judges 17–18), or indeed of the whole nation. The father of the nation thus prays for his descendants in their future predicament.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A multiple pun on Gad’s name (49:19)—four of the six words in this verse contain the consonants "), _c('i', [_vm._v("gd")]), _vm._v("—reflects the tribe’s frequent involvement in border wars.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Asher (v. 20) occupied a fertile strip of coastland running north from Mt. Carmel and may have exported its produce to foreign courts.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As translated in the NRSV, the saying about Naphtali (v. 21) sounds like a compliment, but it could be taken as a mild rebuke. The historical allusion is quite unclear.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Though the general drift of the blessing on Joseph is clear, many details of its interpretation are not. As the NRSV translates v. 22, Joseph is compared to a flourishing tree, a frequent OT image for the righteous (e.g., Ps 1:3). But it may be better, as with the other tribal blessings, to find animal imagery here. 49:22 could be translated “Joseph is a wild ass, a wild ass beside a spring, his wild colts beside the wall.” The archers in v. 23 may refer to the many opponents that Joseph had to overcome in his career. This image carries over into v. 24, which probably refers to his opponents’ bows losing their suppleness. In other words, all the attacks on Joseph proved fruitless in the long run thanks to the strength “of the Mighty One of Jacob,” an ancient title for God. The blessing then seems to move into the future, reflecting on the tremendous riches that the tribes of Ephraim and Manasseh will enjoy as the largest tribes dwelling in fertile land.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The picture of Benjamin (v. 27) as a ravenous wolf does not match the picture of him in the rest of Genesis, but it certainly became a militant tribe in the judges period (Judg 3:15–30; 5:14; chs. 19–21). Interestingly, there is no allusion to Saul the first king, an indication of the age of this saying.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Having predicted the glorious future of the tribes in the land of promise, Jacob reiterates his wish to be buried there (49:29–33). In fact, he is given a grand state funeral in Egyptian style. First he is mummified, a lengthy process (also done to Joseph; 50:26), before the huge funeral cortege set out for Canaan. Just before entering the land the Egyptians stopped at the threshing floor of Atad. Traditionally this has been located near Jericho in the Jordan valley (cf. 50:10), but a more modern suggestion is that it is at Tell el Ajjul, four miles southwest of Gaza. At any rate, the Egyptians turned back there, and let the family proceed to Machpelah for a private interment.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The book of Genesis ends with two short codas. First, Joseph’s brothers, fearing that his kindness was prompted by love for his father rather than by love for them, plead for mercy and forgiveness. This is the first time they have asked him to forgive them, and so it is by no means redundant. However, it does provide yet another opportunity to stress God’s overruling purpose in all the events recorded: “Even though you intended to do harm to me, God intended it for good, in order to preserve a numerous people.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Finally, like Abraham, Isaac, and Jacob on their deathbeds, Joseph’s last concern was that the promises should be fulfilled. So he insists that when the family eventually leaves Egypt, they should carry up his bones and bury him in Canaan. In this way the promises that constitute the theme of Genesis are linked to the exodus, which will be the focus of the next book.")])])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT",
    attrs: {
      "id": "ch006"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-006"
    }
  }, [_vm._v("Exodus")])]), _vm._v(" "), _c('p', {
    staticClass: "CA"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-006"
    }
  }, [_vm._v("William D. Johnstone")])]), _vm._v(" "), _c('p', {
    staticClass: "H1a"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Perspectives for Understanding Exodus")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("“There is no earlier or later in the Torah,” say the rabbis: timelessness, or applicability to all time, is characteristic of the law of Moses. Such a saying can appear particularly puzzling to the reader when confronted with a book like Exodus. For Exodus gives every appearance of being an account of events, and events by their nature occur but once in the past. It is that concern with the past as past that has motivated much research on Exodus: if only we can re-create precisely the period, conditions, and events to which it refers, we shall be in a better position to understand what it says.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But if the rabbinic saying is correct, that attempt is foredoomed to failure. However related the narrative of Exodus must be to historical events, these events are not recorded for their own sake but as expressive of enduring truths of the human condition. The saying has an echo in Psalms, precisely in connection with an incident recorded in Exodus: “O that today you would listen to his voice! Do not harden not your hearts, as at Meribah …” (Ps 95:7–8; cf. Exod 17:7). It is the readers’ response in their “today” that is the point of the narrative. Part of the mechanism for securing that response is that the narrative in Exodus is related at every point to religious institutions: the events that happened long ago to somebody else can be appropriated through the observance of religious practices and so made real in every generation. This is true above all of the Passover (ch. 12), still observed annually by the Jewish community as a memorial and as a basis for expectation (“next year in Jerusalem”). But it is true of the other institutions as well: circumcision, the festival of Unleavened Bread, the offering of firstlings, the revelation of Torah, the covenant, and the sanctuary, all of which bulk more or less large in Exodus.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is likely, thus, that Exodus is not so much about Israel’s escape from Egypt, the imperial power of the last half of the second millennium "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", however that is to be reconstructed historically, as about using the undoubted historical facts of Israel’s deliverance as a signal example of enduring truths of Israel’s existence. A strong case can be made for the composition of a first draft of Exodus during the Babylonian exile of the sixth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". It is that moment of national catastrophe, when every agency supporting national life has been destroyed—temple, monarchy, political independence through possession of land—which has precipitated the reappraisal of all the earlier traditions and practices and the attempt to produce a new synthesis. Superimposed upon that first draft is the final edition of the work, which is a response to the actual attempts to re-create national life in the postexilic period. Hopes for the future, which only God can bring about, are here expressed through an idealized portrait of Israel’s origins; this is what the journey through the wilderness must be like if Israel is successfully to enter the promised land.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The presentation of Exodus in the following pages as a combination of two major editions may come as a surprise to some readers. To those schooled in the academic tradition of the past hundred years and more it has come to be accepted that the Pentateuch represents the combination of four “sources.” The view taken here is that there is no doubt that, behind the older of the two versions identified below, lie preexilic traditions; but it is doubtful whether earlier written accounts of these traditions, which were preserved after all in a vast reservoir of living religious practice, can be recovered by the analysis of the extant literary account. The “older version” of the exilic period is a free literary composition and digest of preexilic traditions, not (or not only) the elaboration of inherited written “kernels.” Equally, for some, it may appear disturbing that we should argue that the biblical revelation is not unitary but represents a dialogue between two contrasting presentations. In answer to that it must be pointed out that this dialogue corresponds to the way in which the history of Israel is presented in two contrasting presentations later in the Bible (compare Samuel-Kings on the one hand and Chronicles on the other). It also corresponds to Jewish tradition of the dual Torah revealed at Sinai (the written form accompanied by continuous oral discussion) and to the requirement that any student of the Torah should get a fellow student. It is in debate between wholly acceptable contrasting positions about inherited tradition that further insight is gained. That debate is already present in the form and structure of the biblical record.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("COMMENTARY")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Linking the Book of Exodus with the Destiny of God’s People (1:1–7)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The book of Exodus is a link in a chain of developments, not just a book on its own. It can be understood only against the background of what has gone before, as told in Genesis, just as at the end of the book there is a link through the construction of the tabernacle with the rest of the Pentateuch and beyond.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("The link with the past is made in the most succinct way possible—through a family tree. “The sons of Israel” are here portrayed in full individuality as Jacob’s eleven sons, who with their entire households come to join Joseph, the remaining son, in Egypt. The drama of how Joseph had been sold as a slave into Egypt by his brothers and had then risen to a position of power at court second only to Pharaoh himself as told in Genesis 37–50 is presupposed. In the reunion of this small family resident as foreigners in Egypt the fate of all Israel is at stake (cf. Gen 45:7).")])]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The sons of Jacob coming down to settle with Joseph are here grouped by mother in order of birth: the six sons of Jacob’s first wife, Leah; the son of his second wife, Rachel; the two sons by Bilhah, Rachel’s maid; and the two sons by Zilpah, Leah’s maid (the story of the birth of all twelve is told in Gen 29:31–30:24; 35:16–18; cf. the summary, following the same sequence as here, in Gen 35:22–26). The sequence of these names changes in later lists in the Hebrew Bible (HB) when the historic significance of the tribes in relation to one another is established (e.g., in 1 Chr 2:3–8:40). The “seventy” members of the family of Jacob are listed in Gen 46:8–27.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But this family does not merely stand in historical continuity with the past. It also inherits the promises made by God in that past. The statement that “they were fruitful and prolific; they multiplied” (1:7) echoes the command to humankind at creation, “be fruitful and multiply and fill the earth” (Gen 1:28, here in the fuller form of the post-flood renewal of the command, Gen 9:7; the Hebrew for “land” in 1:7 is the same as that for “earth” in Genesis 1). But they become not only numerous but also powerful (cf. v. 20), and therein the fateful seeds of tension with the host country are sown. Vv. 1–7 thus look forward to the persecution and deliverance of the following chapters and the means of the fulfillment of the promises to the ancestors.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Persecution of the Hebrews in Egypt (1:8–2:22)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("At the end of Genesis, Egypt has become the haven from famine for the family of Jacob. Through a reversal of fortunes, worked by God himself, the deadly schemes of Joseph’s brothers have been turned into the means of preserving life. Now Israel as a whole finds itself in a far greater danger; yet God is, once more, about to be its deliverer. The whole of Exod 1:8–15:21 is designed to show how it is God alone who, “by signs and wonders, by a mighty hand and an outstretched arm” (Deut 4:34), saves his people.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Paradoxically, God’s blessing of Israel provokes persecution. A “new king” has arisen over Egypt who is entirely ignorant of the blessings bestowed on his country by Joseph’s administration. Israel’s increase in numbers and power provokes a nationalist reaction on the part of the Egyptians; fear precipitates measures of the utmost barbarity to reassert their control (the vocabulary of blessing in 1:7, “multiplied and grew … strong,” is picked up in the same or parallel vocabulary in Pharaoh’s speech in v. 9 and provides the reason for the persecution about to be detailed throughout the rest of ch. 1).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The historical context is sketched with the utmost brevity. The story is told from the point of view of Israel and is deliberately generalized to serve as pattern to encourage faith. The entire narrative, indeed, is about to be related to religious institutions such as circumcision and sabbath and, especially, the two annual festivals of Passover and Weeks/Pentecost, as the means of perpetual participation in the experience of God’s deliverance. Thus Pharaoh is identified only as the “new king … who did not know Joseph.” The subsequent note of the name of one of the places, Rameses (1:11, usually located in the northeast delta), where the Israelites are to work as slave laborers, is, astonishingly enough, the only positive indication of the historical period envisaged in the entire book; it relates to the famous “Ramesside” period, the nineteenth and twentieth Egyptian dynasties (c. 1320–1085 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The particular fear of the Egyptians is that the Israelites as an alien group will multiply to such an extent that they will become a threat to the security of the state (cf. the prodigious growth of the warriors to 600,000 within three generations, 12:37); especially in case of war they might join forces with the enemy and thus “gain control of the land” (as the meaning of the phrase at the end of v. 10 may be in the immediate context, as in the JPSV). Pharaoh thus looks for measures to reduce the number of Israelites and to keep them in submission. He successively attempts three measures.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first (1:11–14) is to grind the Israelites down by forcing them to become slave laborers in Pharaoh’s building projects. The word translated “forced labor” (v. 11) connotes the manhandling of building materials and well suggests the arduous toil. But the policy has precisely the opposite effect: the more oppressive the regime, the more Israel “multiplies” (against the NRSV, the same verb is deliberately repeated in vv. 10 and 12). The Egyptians become “sick with terror” (v. 12) at the unchecked growth of Israel and now subject them to the most crushing of menial tasks in the pitiless conditions of the delta: brick making, building, and laboring in the fields.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("1:13–14 introduce the thematic term which is to dominate this narrative and much of the HB beyond it: “slavery” (the root "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("bd")]), _vm._v(", in its noun and verb forms, occurs five times in these verses and some sixty-two times in Exodus 1–13). The fundamental point to be made is that release from slavery to a human master can only be achieved by God himself, who must in turn be served with no less devotion. To the Israelites the word for “slavery” is the same as that for the “worship” of God ("), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("abodah")]), _vm._v(", 12:25–26; 13:5).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("We should observe the role of this passage within the widest framework of the exilic version of Israel’s history which concludes at 2 Kings 25. It is likely that there is a cross reference between the description of Pharaoh’s oppression in 1:11 and the portrayal of the tyrannical acts of Solomon in the last years of his rule. No fewer than three relatively infrequent terms used in v. 11 (“forced labor” [included by the NRSV in “"), _c('i', [_vm._v("task")]), _vm._v("masters”]; “burden” ")]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("[NRSV, “forced labor”]; and “supply cities”) recur in the 1 Kings narrative on Solomon (e.g., 1 Kgs 4:6; 11:28; and 9:19 respectively; a similar interplay will be noted later between Exodus 32 and 1 Kings 12). By his violation of the law on monarchy in Deut 17:15–17 (cf. the account of his later years in 1 Kings 9–11), Solomon in a sense forced his people “to return to Egypt.” The final years of Solomon threaten a rerun of the tyranny of Pharaoh; in the end, the monarchy that had promised the realization of Israel’s destiny becomes instead, through its failure, the instrument of its deportation to Babylon. Egyptian enslavement is understood typologically in the time of the Babylonian exile as an ever present threatening possibility of Jewish life. The full pain and horror of it can be felt only in looking back from the ideal of a free people, dwelling undisturbed in its land, each family in the rural model of self-sufficiency living “under its vine and fig tree” (1 Kgs 4:25), which was realized in the early years of Solomon and lost once again—and in a sense forever—under the Babylonians.")])]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Pharaoh now tries his second measure: to turn the Israelite midwives into infanticides among their own people. They are instructed to put to death every Hebrew male child at birth (1:15–21). The words “put to death” (v. 16) are used in the HB of an officially sanctioned death penalty. But the midwives acknowledge a higher authority than Pharaoh: God himself. The term “God-fearer,” given here (vv. 17, 21), has already been used of Abraham, the founding father and role model of every community of faith, in Gen 22:12; it implies awe before God’s revelation of himself and unconditional obedience to his commandments (cf. Exod 20:18, 20). The commandment in this case—in advance of the revelation of the Decalogue in Exodus 20—can only be the law on the sanctity of human life made binding on Noah, the second father of humanity, and his sons in Gen 9:5–7 (where, significantly, it is related to the terms “be fruitful, teem, multiply” just used of Israel in Exod 1:7; cf. vv. 12 and 20). But the potential absence of such “fear of God,” demanded though it is of all humanity, has already been anticipated among non-Israelites, the Philistines in Gen 20:11 and the Egyptians themselves in Gen 42:18.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Pharaoh’s plan is foiled by the resourcefulness of these midwives. Their significance in the narrative is heightened by their being named: in contrast to the unnamed Pharaoh (and all the other anonymous Egyptians in the later narrative), they are given names, “Beauty” and “Maiden.” The fact that the growing population of Hebrews can be served by only two midwives, who between them would have to attend every birth in order to carry out Pharaoh’s command, lends credibility to their tale of the “vigor” of the Hebrew mothers. Through these God-fearing midwives not a male child is harmed, and so God “gave them families.” The reference is probably to families for Israel, not merely for the midwives: the personal pronoun “them” is plural masculine and resumes the end of 1:20; vv. 20b and 21b are parallel; the second plan to limit the Hebrew population founders just as the first had done (v. 12).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A third plan has to be put into effect (1:22): if the midwives will not do the deed, the whole populace of Egypt must be recruited. The MT heightens the irrational and indiscriminate nature of Pharaoh’s decree by apparently including the Egyptian boys as well in the drowning.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("At this climactic moment of persecution and powerlessness the birth of Moses takes place, Moses who is destined to become the agent of deliverance of his people. The whole of the next subparagraph, 2:1–22, is devoted to his birth, upbringing, and early manhood. It is a story of high drama—and that is precisely the point. The most important observation to make is the absence, for the only time in the book, of direct action by God, however much the reader may sense that events are being controlled “behind the scenes.” This apparent absence of God, expressed not least through the flounderings of much of the human action, prepares the way for the next section, 2:23–4:17, where God himself will be portrayed as the one who directly intervenes as the true deliverer of Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The whole narrative in 2:1–22 can thus be read as a drama entirely on the human plane. The inhumanity of Pharaoh is contrasted with the natural humanity of the Hebrew family, who, again with great resourcefulness, seek to preserve the life of their infant son (vv. 1–4), and with the humanity of his own daughter, who is moved by common pity to rescue the doomed, alien child from the Nile (vv. 5–10).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There are satisfying ironical twists in the tale. Pharaoh’s omnipotence is undermined by the power of those regarded as weakest in society. The Hebrew midwives introduce a series of women who despite their lack of status prepare the way for Israel’s deliverance: the slave woman Jochebed, the mother of Moses, the deliverer to be; his sister Miriam; Pharaoh’s own daughter and her attendants; and, finally, the daughters of the priest of Midian, one of whom is to become Moses’ wife. All of them, by their fear of God or by their commitment to such basic human values as preservation of life, compassion, or hospitality, provide the first links in the chain of events which lead eventually to Israel’s freedom.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("The ironies multiply: the Hebrew mother who was to be robbed of her child now becomes his wet nurse and is paid to boot. The objective of Pharaoh to limit the power of the Hebrews is undermined by his own daughter and her ladies-in-waiting: the one who is to become most powerful Hebrew leader and the agent of the destruction of the later Pharaoh and his host in the Red Sea (chs. 14–15) is adopted by Pharaoh’s daughter and brought up in his own court. The name “Moses,” “the one who draws out,” is imparted by Pharaoh’s daughter (v. 10). She applies it to her own action in drawing Moses out of the Nile; it might then have been more appropriate for it to have been in the form of the passive participle, “Mashuy,” “the one drawn out.” The irony is that in naming her adopted son with the masculine active participle, “Mosheh,” Pharaoh’s own daughter is signaling that he is the one who is destined to achieve precisely what Pharaoh feared and his policy was designed to prevent: to “draw” the Israelites out of the land. It is tempting to see yet another significance in the name: given the Ramesside context, is it possible that “Moses” is a play on the name “Ra-meses” borne by eleven Pharaohs of the ")]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("period, meaning “Ra [the sun god] has given birth”? That would be especially appropriate given a later theme in Exodus, that God will execute judgment on the gods of Egypt (6:6; 7:4; 12:12).")])]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("There is, however, a fitness to later circumstances in the unfolding of events. This fitness is focused in the question of the Hebrew to Moses in 2:14: “Who made you a commander and judge over us?” At this stage the answer to that rhetorical question must be, “No one.” Moses is as yet the impulsive human being, moved by raw emotion against injustice against, or even among, the people with whom he knows he is kin (2:11–13; v. 11 picks up 1:11). He takes the law into his own hand to vindicate a Hebrew who is suffering (“fatally” is implied by the Hebrew) at the hands of an Egyptian and another at the hands of a fellow Hebrew. Yet everything in his background and training is preparing him for the day in which God, now concealed in the background, will appoint him precisely as leader and lawgiver of his people. It is then that the purity of his descent from the tribe of Levi (2:1) will become significant, for it is to be from Levi that the teachers of the law and the priests at the altar are to be derived (ch. 28). It is then that Moses’ innate gifts of physical strength (cf. 2:2), energy, and moral outrage, here shown in action (cf. v. 17), will be harnessed and brought to fulfillment.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There is thus also pathos in the story in the reversal of roles that Moses has to undergo (2:15–22). He who is to realize the identity of his people is here mistaken for an Egyptian; he who is to be the champion of his people is the victim; he who is to lead his people out at the exodus “with a high hand” into the wilderness toward the promised land is forced to flee in a dead-end exodus into the desert as a fugitive; he who bears the exclusive name of Levi marries the daughter of a foreign priest (“Reuel,” however, means “friend of God”). The low point of his fortunes is marked by the name he gives to the first son of that union, “Gershom,” meaning “an alien there” (a pun may also be intended on the verb "), _c('i', [_vm._v("geresh")]), _vm._v(", “drive out,” used in v. 17). The section ends as it began—with the birth of a son (2:2, 22). But, whatever hopes had been aroused by the amazing deliverance of the infant Moses, they have been dashed, and the deliverance of the people seems farther away than ever.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Moses Commissioned (2:23–4:17)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This section is introduced with a brief passage establishing the link between the external events of history and the unseen workings of God (2:23–25). The death of the king who had driven Moses from Egypt marks a new opportunity. But in the meantime the persecution continues. No fewer than four words for “crying, groaning” (2:23–24) convey the intensity of Israel’s suffering. But these are matched by an equal number of verbs for “taking note” on the part of God, arranged in climactic sequence: “he heard … remembered his covenant … saw … and knew” (2:24–25). The covenant which God remembers is that made first with Abraham in Genesis 15. The link with the next two generations of Israel’s forefathers, Isaac and Jacob, as in Gen. 50:24, relates that covenant specifically to the promise of land. Israel’s hope is not just for deliverance from slavery in Egypt but for the realization of its national destiny by entry into the promised land, where the privileges and responsibilities of deliverance can be lived out (cf. 3:8).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The course of God’s plan embedded in the unfolding events is now disclosed (3:1–9). It is appropriate that the nature of the divine act in the realm of the mundane should become clear to Moses in the course of his ordinary duties as a shepherd in the wilderness for his father-in-law. The wilderness pasturage turns out, wittingly or unwittingly, to be located at “the mountain of God”; there a natural object, a bush, becomes invested with supernatural significance: “the bush burned but was not consumed” (3:2). The MT is not completely unambiguous about the nature of the divine apparition: whether the angel of the Lord appeared "), _c('i', [_vm._v("in")]), _vm._v(", or "), _c('i', [_vm._v("as")]), _vm._v(", the flame of fire. For the latter sense, it may be noted that elsewhere in the HB fire is used as symbol of the divine presence (e.g., Exod 19:18); in that case the stress here would be on the communication by God to Moses (cf. 3:4). But why, then, does God speak from the tree and not from the mountain itself (as in ch. 19)? The better interpretation—which is, in any case, the more natural grammatically in the Hebrew—may, therefore, be the former: the Lord appeared "), _c('i', [_vm._v("in")]), _vm._v(" the flame of fire. There is here fuller symbolism: the tree stands for Israel, the fire for persecution in Egypt, and the burning without being consumed for the fact that, despite persecution, Israel is not destroyed. It is because God is present in the midst of the affliction of his people that he is able to deliver them and lead them to the promised land (3:7–9). The conventional description of that land as “flowing with milk and honey,” introduced now for the first time in the HB (3:8), expresses an ideal of paradisal prosperity based on God’s provision: as the first man had to tend the garden of Eden (Gen 2:15), so human cooperation is required to harvest the bounty of the land. But its abundant yield of natural products requires no backbreaking toil such as Israel is now enduring in Egypt.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is one thing to hear the gracious promises of God, but it is quite another to be commissioned to be the agent by whom these promises are to be carried out (3:10). There now follows an extended dialogue between Moses and God (3:10–4:17) in which Moses objects five times to his being chosen as agent; in response, God provides further clarification of his being and action.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("(1) Moses’ natural first reaction is modesty, a due sense of personal inadequacy at the overwhelming magnitude of the task (3:11): to confront the world emperor, Pharaoh, to convince his own people, and then to defeat the indigenous inhabitants of the land (in 3:8, 17, the MT lists six of the traditional seven ethnic groups [Deut 7:1]). Moses’ expression of inadequacy precipitates the assurance by God of his enabling presence against which no adversary can prevail.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("This assurance is coupled with the first “sign.” The word is used here and in 4:1–9, where three more signs are given, demonstrations of the invincible power of God in favor of Israel (“wonders” is used of the demonstration ")]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("of God’s power against the Egyptians, especially in the “plagues”; cf. 4:21). This first sign, unlike the three in ch. 4, is not designed as confirmation in advance of Moses’ status as leader in the exodus; rather, the success of the exodus will itself be the sign confirming the claims of God. This first sign, “serving God at the mountain,” thus links together the whole of the narrative in the Pentateuch from Exodus up to Numbers 10: it is precisely at the Mountain of God that the covenant will be made which will formalize the relationship between God and God’s people and the revelation of the law will take place by which God’s people can remain in relationship with him.")])]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("(2) Moses’ second objection turns from “Who am I?” to “Who are You?” (3:13–22). How can he convince his own people unless he has a new revelation of who God is? God has hitherto based his claims on the covenant he made in the past with the patriarchs. That promise is now activated in terms of an exposition of his name, “Yahweh.” Given that a name in Hebrew may be held to contain a definition of the character of the person who bears that name (1 Sam 25:25 is a clear example), it is likely that this name of God is meant to be enigmatic: no human being, not even Moses, can fully know the nature of God. The word “Yahweh” by itself is a third-person masculine singular of the verb “to be” in the future tense, “he will be” (or, possibly, “he will cause to be”). Both subject and predicate are left undefined: who God is and what he will be are not indicated. The enigmatic character of the name is still further heightened: not only is it then expounded in first-person common terms, “I shall be,” but, above all, a relative clause is added in which the same elusive verb is repeated. A possible translation of the entire phrase, “I shall be who I shall be,” fully safeguards the mystery of the divine being and the freedom of his action. Only a God who is of such transcendent nature and power is worth affirming.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Yet the name conveys certain constants: God’s nature is not arbitrary or inconsistent. He is the one who can be affirmed as the living God. His own exposition in first-person terms expresses the absoluteness of the divine initiative in all circumstances. The “I” is relational: it presupposes the “you” of his people. Thus he who is inexpressible in his transcendence is, nonetheless, the eternal one who commits himself to constant relationship with his people. He is not just the God of Abraham, Isaac, and Jacob: the promise in the past is continually renewed and moves forward through God’s personal action to its fulfillment.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is with that assurance that God commissions Moses to go to his people and to Pharaoh (3:15–22). The ideal response of the people is portrayed: in the light of this reaffirmation of the covenant to the forefathers in terms of deliverance from their present affliction, they will believe in Moses without hesitation. But it will be different with Pharaoh; only demonstrations of divine power will force him to let Israel go.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This section is closely integrated into the following chapters by a series of thematic terms and concepts and even by the chronology of events envisaged. The motif of “spoiling the Egyptians” here announced (3:21–22) recurs in the context of the final plague, the culminating demonstration of the strength of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s hand, in 11:1–3; 12:29–36. At first sight, the spoiling of the Egyptians by the Israelites may appear mercenary, deceitful, and vindictive. The true significance of the action can be appreciated only in the light of the legislation on the release of Hebrew slaves in Deut 15:12–18. There in the same language it is laid down that when slaves are given their liberty they are not to be sent away “empty-handed”: they are entitled to the value of the work which they have supplied; they need resources to set themselves up in their new life of freedom so that they do not revert to the dependency of slavery. (A further instance of the verb “despoil” will be found in 33:6, where, because of its own “enslavement” at the golden calf incident, Israel is “self-despoiled” and forfeits the tokens of its liberty.)")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In two further respects, the context of that legislation on the release of slaves in Deuteronomy is still more suggestive. It immediately passes from the release of slaves to the offering of the firstborn (Deut 15:19–23), which is the very point of the final plague in Exodus (11:1–12:36). As the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s firstborn son (Exod 4:22), Israel is to be dedicated to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(". If Egypt will not free Israel to realize its status as the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s firstborn, it will suffer the loss of its own first-born.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The legislation in Deuteronomy then turns to the Passover (Deut 16:1–8), the one-night-plus-seven-days celebration which is distinctive of Deuteronomy. There are grounds for interpreting the whole of the earlier version of the exodus narrative from Exod 2:23–24:8 as commemorated in the chronology of that Deuteronomic Passover: the one night is the night of the escape from Egypt, as recounted in Exodus 12; this is followed by a pilgrimage of three days to the Mountain of God as already envisaged in this chapter (Exod 3:12, 18, a motif to recur in 5:3; 8:27; cf. 15:22, where the alternative chronology of the final version takes over); on the third day after the arrival at the Mountain the Decalogue is revealed to the people (Exod 19:10–11, 16; 20:1–21); on the following, final day the covenant is sealed between God and Israel (Exod 24:3–8).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("All of these themes—release of Hebrew slaves, dedication of the first-born, and celebration of the Passover—are being prepared for in Exod 3:15–22.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("(3) Moses’ third objection is that his own people will not believe him (4:1–9; the motif recurs in 4:31; 14:31; 19:9). There might indeed be many reasons in Moses’ early history for such rejection, principally his earlier ignominious flight (2:15). But Moses expresses his fear of rejection in theological terms: the people will object that, no matter who this new Yahweh may be, he has not appeared to Moses. Specifically in response (4:5, 8–9), Moses is now empowered to work “signs”: the staff turned into a snake and back again; the hand turned leprous then healed; Nile water turned to blood. It may be that the first two are meant to mirror the career of Moses to date: the staff of authority thrown down, and flight when it is turned against him (2:15); the enforced dwelling apart from the community as though he were a leper (2:22; cf. Lev 13:46). These signs thus express the reintegration of Moses into the community and his restored, ")]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("and now soundly based, authority within it. The third sign is an authentication of Moses’ power within the land of Egypt itself; it is still directed at the Israelite community, though it anticipates the action of God against Egypt in the series of plagues which begins precisely with the turning of the Nile into blood (7:14–25).")])]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("(4) Moses now (4:10–12) gives as an excuse his poor performance as a public speaker (“heavy of mouth and heavy of tongue,” v. 10). God seeks to counter this objection by appealing to his power as the creator of human speech. The reassurance of God’s presence (as in 3:12) is repeated: the “I will be” (4:12) must now clearly be understood in the light of the “I will be” of 3:14. That promise is now translated in terms of “teaching” (from the root of “Torah,” or law) the words to be uttered.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("(5) Yet once more Moses seeks to evade the responsibility (4:13). But modesty can be false modesty, a mask for disinclination, and both can be disloyalty to God, who reveals himself as present with power. It is therefore in exasperation that God, having thus made himself known in his being and action as focused in his name “Yahweh” revealed to Moses himself, does indeed find a “mouth” and a “tongue” for Moses by appointing his brother Aaron as his spokesman. The message, however, remains unchanged; it is still the same “I will be” who will be with both (v. 15); the message will come through the authenticated mediator, Moses, and Aaron will but speak what he has heard. Again the verb “teach,” from the root of “Torah,” is used.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Redeemer Redeemed (4:18–26)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Exod 4:18–26 contains one of the most puzzling incidents in the HB: God’s encounter with Moses and attempt to kill him (vv. 24–26). It seems extraordinary that no sooner has Moses been appointed as the agent of Israel’s escape, despite all the resistance on his part described in 3:11–4:17, than God seeks to destroy him, the very human through whom that escape will be brought about. The point being made must once again be that beyond all human effort, even on the part of a Moses, it is God alone who is the deliverer of his people (cf. ch. 2). Through the dispensability of the human agent the primacy of the divine action is declared. Within the wider context of the Pentateuch, there is a suggestive parallel with Genesis 22: God’s promise of progeny to Abraham can be fulfilled only through Isaac; but that promise is threatened by the demand for the sacrifice of Isaac to God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But other points are being made in the incident. The view presented below is that the decisive clue to understanding lies in the fact that the MT presents 4:18–26 as a single section (contrast the three paragraphs into which it is subdivided in the NRSV). The fundamental point at issue is the status of Israel: the astonishing metaphor used is that Israel is not just God’s son but his firstborn son (v. 22). The penalty for denying that status is about to be paid by Egypt in terms of “like for like” (cf. the law code embedded in Exod 21:22–25): if they maltreat God’s firstborn son, they will forfeit their own firstborn (v. 23). But, equally, God lays responsibilities on Israel. In recognition of their status, they must offer to God their firstborn. Of none is this more true than of their leader, Moses (vv. 25–26).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The narrative proceeds on two levels: the external events and the continuing unfolding of how God’s purpose of rescuing his people takes place. The external course of events is sketched with the utmost economy (4:18, 20a, 24a): Moses asks Jethro’s permission to leave; the permission is granted; he and his family reach a stopping place for the night. The omission of many circumstantial links in that chain of events shows where the true interest lies: the actions of God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Moses continues to appear in a somewhat ambiguous light. There is a discrepancy between the reason he gives to Jethro for his departure and the actual reason: “let me go to see whether my kindred in Egypt are still alive” (4:18) sounds like a family visit taken on his own initiative, whereas in truth it is under divine compulsion that he is being sent to save his entire people. It may just be deliberate understatement—in advance of the successful completion of his mission why should he be any more forthcoming to Jethro? But the reticence about his mission may be a continuation of his reluctance in the previous section. Moses’ passivity, at least, is notable; whereas he appears to be a headstrong figure in ch. 2, here he first needs an assurance from God of his personal security before he will act (the narrative sequence in 4:18–19 shows that, though he has declared his intention to Jethro to go, he has still delayed: it is back in Midian that God gives him the instruction to return). The two actions of Moses, “and he took” (v. 20), are thus enfolded in two directives from the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" (vv. 19, 21). When he takes his wife and family (the passage of time since 2:22 is indicated by the plural “sons”; cf. 18:5), he also takes the staff, which, with its proven wonder-working power, is now termed “the staff of God.” What had been the “staff in your hand” (4:2) now becomes empowerment to work “portents” before Pharaoh (cf. the matching “in your hand” in v. 21). Though they will be worked through Moses, they are essentially acts of God; therefore, Moses, as their agent, is in a sense a spectator who will “see” them, not just do them (cf. Israel as participants yet spectators at the Red Sea, 14:31).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The word “portents” introduces a thematic term for the demonstrations of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s power before the Egyptians (7:3, 9; 11:9, 10; as opposed to the “signs” in 3:12, etc., worked for Israel’s benefit). These are to be termed, fundamentally, the “wonderful deeds” of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" (3:20; cf. 15:11), not merely, as in popular parlance, “the plagues of Egypt” (terms for “plagues” are used quite sparingly in the following narrative: "), _c('i', [_vm._v("deber")]), _vm._v(", “plague,” appears only in 5:3; 9:15 and as the term for one of the specific plagues themselves in 9:3; cf. the other roots “strike,” "), _c('i', [_vm._v("nkh")]), _vm._v(", 7:17, 20; 8:17; 9:25 [2×]; 12:29; "), _c('i', [_vm._v("pg"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")])]), _vm._v(", 5:3; "), _c('i', [_vm._v("ngp")]), _vm._v(", 8:2; 9:14; 12:13, 23 [2×], 27; "), _c('i', [_vm._v("ng"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")])]), _vm._v(", 11:1; “judgments,” "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("shepaṭim")])]), _vm._v(", 6:6; 12:12). They are a cumulative series of disasters which are portents of disorders of a much deeper character (nothing less than the collapse of Egyptian imperial power) and of divine action of still more far-reaching significance (the deliverance and establishment of his people Israel).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_77"
    }
  }), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("It would not be surprising if Pharaoh misses the point of the series of portents as each one occurs. What is surprising is that it is God himself who makes him miss the point (4:21b). The series of portents is a deliberate device to make it clear that the deliverance is the result of no human decision or action but of God himself (the motif recurs in 9:12; 10:20, 27; 11:10; and, in different vocabulary, 7:3, 14; 8:15, 32; 9:7, 34; 10:1; cf. 7:13, 22; 8:19; 9:35, where the same verb is used of Pharaoh’s own “heart”). Pharaoh is locked into the consequences of the now ineradicable evil for which he has been responsible from the first. The series of seven (in the underlying version) or ten (in the final edition) punitive acts of God about to be recounted in 7:14–12:36 corresponds to traditional numbers of punishments sent by God (e.g., Lev 26:15–41).")])]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("At the end of 4:21 and in v. 22 key terms are introduced from the legislation in Deut 15:12–16:8, which, as suggested above (see on 3:15–22), provides the master pattern for the events described in the earlier version of Exodus up to Exod 24:8: the release of Israel as slaves, its status as the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s firstborn son, and the celebration of that status in the festival of Passover. The verb in v. 21, not just “let go,” or even “expel,” is the technical term for the release of a slave. This verb is now going to appear as a thematic term in the following chapters (some thirty-nine times in all to the end of ch. 13).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In 4:22 Moses is commissioned with the words he is to speak to Pharaoh. These amount to a digest of all the encounters which Moses is to have with Pharaoh throughout chs. 5–11. They are expressed in the two-part form of “messenger speech” so characteristic of the later prophets (cf. the definition of Moses as the prophet par excellence in Deut 18:18; 34:10). Those commissioned by God speak not on their own account but in the name of him who sends them; they thus introduce their words with an authentication of their message: “This is what the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" has said.…”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first part of Moses’ message speaks of Israel’s status among all the peoples of the world, including by implication in this context even the imperial power of Egypt. This is expressed in the highest and most intimate terms conceivable: “Israel is my son—not only so, my firstborn son.” The term “firstborn,” now introduced for the first time, binds the whole narrative of the ten “marvelous deeds of God” together, reappearing (apart from, significantly, the genealogical material in 6:14) as the focus of the tenth, climactic, “marvelous deed” in 11:1–12:36, and then links these marvelous deeds with the legislation on the dedication of the firstborn in ch. 13.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("4:23a is unexpected: the second part of the classic prophetic speech—instruction about the appropriate action to take in the light of the situation indicated—would now naturally follow: “Therefore, I command you, release my son.” The turning of that command into a report of the past, “I commanded … but you refused,” presupposes all the events now to follow in chs. 5–10 and prepares for the climactic “marvelous deed” in chs. 11–12.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The second part of Moses’ message in 4:23b thus, in effect, announces the impending action of God: because of Pharaoh’s refusal to set free the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s firstborn, the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" is going to slaughter Pharaoh’s son, indeed, his firstborn (the construction at the end of v. 23 matches the construction at the end of v. 22).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But if Moses is safe from the Egyptians (4:19), he is not safe from God, as the following incident indicates (vv. 24–26). He is saved only by the speedy act of his wife Zipporah in circumcising their son Gershom (presumably) and touching Moses’ genitals (“feet” may be a euphemism as in, e.g., Isa 7:20) with the severed foreskin.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As suggested above, this strange incident should be understood within its immediate context. In acknowledgment of its status as the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s firstborn, Israel owes to him the offering of its firstborn, both human and animal (as the legislation in 13:1, 11–16 makes clear, the human firstborn are themselves to be redeemed—in the fully developed system by the vicarious dedication of the Levites, Num 3:12–13). In the rite of dedication of the firstborn, there is a threat both to the firstborn and to those who neglect the rite. In this case, Gershom of the levitical family of Moses is protected by the rite of circumcision, as Moses is by the vicarious circumcision of his son. The designated redeemer of the people, whose redemption is to be marked by the dedication of their firstborn vicariously redeemed by the Levites, must himself be redeemed vicariously by his own firstborn. Moses himself is not above duty to God; he who is to be the later mediator of the law is bound by the requirements of what will be enshrined in the law.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The equally enigmatic term for her husband, “a bridegroom of blood,” used by Zipporah, is explained in the context in terms of the blood of the circumcision. Zipporah perceives the deadly threat to her son and to her husband that Moses’ new status brings; the blood of circumcision indicates the dedication to a new life; that new life may bring with it implications of change in relationship with her. That a separation from his wife took place at this point is stated by the later narrative (Exod 18:2; as I will argue below, there are grounds to hold that that passage stood before Num 10:29 in the original version, i.e., after the revelation of the law at the Mountain of God). By this act, the status of the once unwilling and unresponsive Moses has been irreversibly changed.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The First Encounter with Pharaoh (4:27–6:9)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Once again the MT paragraphing highlights the major point of this section: Moses’—and Aaron’s—disastrous first encounter with Pharaoh provokes not only outright rejection of their request to go to the Mountain of God but intensified persecution, and yet leads to a renewed promise by God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The section functions to establish still more clearly the culpability of Pharaoh. Everything that has been promised and forewarned by God in section 2:23–4:17 turns out to be true. Aaron, and the elders and people, without hesitation respond positively to Moses’ commission. But Pharaoh’s reaction is even more repressive than predicted; it is only when at Pharaoh’s decree conditions become still worse that in despair and recrimination the people turn against Moses.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("As promised in 4:14–16, Aaron, designated as Moses’ ")]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("spokesman to the people, comes to meet him at the Mountain of God (the verb “to meet,” v. 27, is the same as that in v. 24, the only times in these chapters that the verb is used: threat has become reassurance). Aaron’s acceptance of Moses’ commission and the accompanying signs (cf. 3:10–4:9) is so taken for granted that it is not even recorded (4:28). In v. 29 they precisely fulfill the instructions of 3:16: to gather the elders (“all” is now added for emphasis) of the people, to whom Aaron duly acts as spokesman (4:30; it is not clear who “performed the signs”; the syntax suggests Aaron). Again as predicted, the people, too, immediately respond (v. 31; cf. 3:18) with belief that God has indeed “visited” (3:16) them and “seen their affliction” (3:7, 17). The last phrase of 4:31 expresses the unconditionality of their acceptance and submission (cf. 12:27; 34:8).")])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Strengthened with this complete fulfillment of every promise, Moses, Aaron, and the elders confront Pharaoh (5:1). Their speech echoes Moses’ prophetic speech of 4:22–23. The “messenger formula,” “Thus says the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(",” remains to authenticate their words, with the necessary identification of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" as “the God of Israel”; the accusation is omitted, though the enslavement of Israel is implied by the imperative, “Let my people go free”; “my son” is replaced by “my people”; “to serve me” is explained as “to hold a pilgrimage festival in my honor in the wilderness.” Pharaoh’s rejection of the word of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" triggers the series of “wonderful deeds.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The narrator does not pause to consider how those who to Pharaoh’s eyes must have seemed like self-styled leaders of a band of convicts could have been granted audience with the world emperor. He goes straight to the theological point: Pharaoh cannot possibly be impressed by the word of an unknown God, least of all the God of his Hebrew slaves. His fateful words, “I do not know the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("” (5:2) are to become the point of the whole ensuing narrative, that Pharaoh will, through the “marvelous deeds,” precisely come to know and acknowledge the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" (7:5, 17; 8:10, 22; 9:14, 29).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The identification of the rite in the wilderness as a “pilgrimage festival” (5:1) is an important piece of evidence for recovering the underlying version related to Deuteronomy. Only in Deut 16:1–8 is the Passover identified as a pilgrimage festival to the sanctuary (see above on 3:18, 76). Further Deuteronomic influence is to be observed in 5:3, where the rite is described in terms of the cultus of the central sanctuary as a “sacrifice” (contrast the legislation on the Passover in the final edition in Exodus 12, where the rite is domestic and the formal cultic term for sacrifice is avoided). A fundamental aspect of the Passover as the spring rite of shepherds observed to ward off danger at the time of change of pasture from the wilderness to the agricultural area shines through at the end of v. 3; “pestilence and sword,” along with famine (and wild beasts), are regarded as standard instruments of God’s punishment, especially in Jeremiah and Ezekiel.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Pharaoh turns from theology to practicalities—and, in so doing, misses the significant factor in the situation, just as he takes truth to be lies (5:9). These religious observances, he judges, are just excuses of a lazy people for a holiday (5:4, 8, 17; there may well be intended in Hebrew puns on “distract,” "), _c('i', [_vm._v("tapri"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("u")]), _vm._v(", v. 4, and “Pharaoh,” "), _c('i', [_vm._v("par"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("oh;")]), _vm._v(" cf. 32:25). His response is to intensify the labor which was his first plan for the control of Israel’s growing numbers (5:5; cf. 1:9, 11). In Pharaoh’s eyes they are just ordinary people, “the people of the land” (cf., e.g., Gen 42:6), to be exploited; in God’s eyes they are “my people” (e.g., 3:7). Israelite foremen accountable to Egyptian supervisors (presumably those earlier identified as “taskmasters” in 1:11) are appointed over the workforce (5:14). On pain of death (cf. 5:21) they have to force their own people to comply with Pharaoh’s demands.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The new intensification of the labor is to require the same output of bricks but without providing any longer the straw as the necessary binding material (5:6–8). The Israelites have to forage on their own. It is striking that the message of Pharaoh in 5:10–11 is formulated in the same way as the word of God in v. 1: the “messenger formula” for authentication, followed by the message in two parts, the first describing the situation (v. 10b) and the second laying down the appropriate action (v. 11a; the only formal difference is the addition of an explanatory clause at the end of the second part, v. 11b). The doomed Pharaoh tries his own line of destruction.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("An ironical touch is introduced in 5:13, 19: the demand by the Egyptian taskmasters that the Israelite slaves perform their appointed tasks each in full, day by day, echoes the cultic requirement on Israel in its service to God (e.g., Lev 23:37; the key term “service,” "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("abodah")]), _vm._v(", recurs in 5:9; cf. 1:14).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The refusal of the Israelite foremen to blame God even in their extremity is impressive. Initially they do not turn on Moses but on Pharaoh as the cause of all their troubles (5:15); only when their pleas to Pharaoh are unavailing do they confront Moses and Aaron (5:20). Even then, they do not reject the reality of their experience, only the disastrous outcome of their message. And they consign the issue to God’s justice: may he apply the same vigilance to them that he applied over the injustice suffered by his people (“may the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" look upon you,” 5:21, uses the same verb as in “and God took note,” 2:25).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("By contrast, though all had happened as he had been forewarned, Moses’ words to God are direct (5:22–23; for such directness cf. the “why” of the psalms of lamentation, e.g., Psalm 22): “You have brought this disaster on the people … you have not delivered them” (the same verb as in the promise in 3:8). The mission to which he has been committed with such reluctance has turned out to be worse than a complete failure: it is precisely speaking in the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s name that has brought intensification of the disaster. In reply (6:1) the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" picks up the forewarnings and promises of 3:19–20; 4:21 (“do, perform” is the linking term): it is only under the duress of the “wonderful deeds” of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" that Pharaoh will permit their departure, indeed, “will drive them out.”")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("At this critical juncture the narratives diverge. The older version proceeds directly to 7:14 and the first “wonderful deed.” The final edition brings in a long addition (6:2–7:13) with two main purposes: to confirm belief in the nature and purpose of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" now put under such strain during the first encounter with Pharaoh, 6:2–9, ")]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("which provides a new ending to this section; and in five completely new sections to deal once again with Moses’ lack of self-confidence by the appointment of Aaron to act as his spokesman (6:10–7:13). Aaron is now to be the spokesman for Moses not only to Israel (as in 4:14–16) but also to Pharaoh and to be a wonder-worker in his own right (6:10–13, 28–7:13). If the final edition comes from the postexilic period, a motive for thus extending the authority of Aaron and, by implication, of the priesthood that stems from him is evident: they are the custodians and exponents of the Mosaic tradition. The remaining verses (6:14–27) thus give a partial list of Israelites, which demonstrates in genealogical terms the status and role of the Levites, in particular the descendants of Aaron, within Israel.")])]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In the final edition, the section ends with a speech by God reaffirming his nature and purpose (6:2–9). The speech begins and ends with the phrase, “I am the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("” (vv. 2, 8, as also the speech to be reported to the Israelites begins in v. 6; cf. v. 7): everything that God is and does is expressed in the meaning of that name (cf. 3:12–15). As in 2:24, the patriarchs are recalled to provide the basis and continuity of belief; but the knowledge they had of God expressed in the name “God Almighty,” overwhelming yet restricted in sense though it was, is now complemented by “the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(",” boundless in its possibility. (That this final edition seems to view the history of revelation differently from many passages in Genesis where God is in fact known as “the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("” by many of the patriarchs, e.g., Gen 12:8, has been very influential in the source criticism of the Pentateuch.) Again as in 2:24, the specific point in the recollection of the patriarchs is the covenant made with them to give them the land of Canaan (the vocabulary in this passage may be compared particularly with the covenant with Abraham in Gen 17:1–7; e.g., the opening “I am,” “establish my covenant,” “the land of Canaan, the land of their sojourning”). That unbreakable promise must give Moses and the people the confidence to trust that God is indeed at work to effect his purpose despite every evidence to the contrary: as to Abraham the promise was of uncountable descendants, so now at the time of the cry of these descendants of Abraham for help God will indeed release them from slavery.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Some distinctive vocabulary appears in God’s speech in 6:6b. “I will redeem you” uses a theological term familiar elsewhere in the HB (e.g., Isa 41:14) which is borrowed from the realm of property rights: it is the next of kin who has the responsibility of buying back the occupancy rights to land of one who has fallen into slavery through debt. Within the context of the covenant with the patriarchs, this term provides an appropriate and powerful metaphor of God as Israel’s next of kin, freeing his people from slavery and vindicating their rights to possession of the land of Canaan.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The last phrase of 6:6, “with an outstretched arm and mighty acts of judgment,” is a variant on the phrase characteristic of the earlier version “with a strong hand and an outstretched arm,” where the first of the pair seems to refer to the ten “wonderful deeds” and the second to the defeat of Egypt at the Red Sea. In this final edition, the “outstretched arm” and the “judgment” may refer quite generally to both “wonderful deeds” and the defeat at the Sea (cf. 7:4; 12:12).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But the matter is not left with mere recollection and reaffirmation of a covenant made with ancestors. The divine speech climaxes (6:7) in a variation of the covenant formula, “I will be your God, and you will be my people” (cf., e.g., Lev 26:12; Deut 29:13). Here there is the additional element of election, “I will take you …” (cf. Deut 4:20; 2 Sam 7:8; Amos 7:15). The entire salvific relationship made known in the past is also fully effective for the present generation. 6:8 brings these promises to past and present generations together.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("6:7b introduces a rather different note about the response of the people. Whereas in the older version “a mighty hand and an outstretched arm” are, in general, designed to force the recognition of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" by the Egyptians (though contrast 10:2), here they are for Israel’s benefit, to bring them to acknowledge the saving acts of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(". Their implied present disbelief is confirmed in 6:9. This contrasts with the noble refusal of the Israelite foremen to question God himself, noted above at 5:21. In general, Israel in the older version is (until the first crisis in ch. 32) a people responsive to God and eager for freedom. If, as is probable, that version was penned during the exile, it in turn would be appropriate to the conditions prevailing at the time—a message of encouragement to those enduring the new slavery of subjection to Babylon.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Aaron’s Status (6:10–7:13)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Five sections are now introduced to explain the high status of Aaron. It is appropriate to take them together since they have been so linked by the editor himself. Not only do they share a common topic; they are also closely associated by some external indications. The short section 1 (6:10–12), on Moses’s disqualification as a speaker, is directly resumed by the still shorter section 3 (6:29–30; some two-thirds of the words are identical). The reason for this repetition is to enfold section 2 (6:13–28), on the pedigree of Aaron and the subsequent Aaronic priesthood, which anticipates how, in section 4 (7:1–6), Aaron is commissioned as Moses’ spokesman and, in section 5 (7:7–13), as a wonder-worker. The division between sections 2 and 3 breaks across the syntax of 6:28–29. It is striking that each of these five sections begins in similar fashion: nos. 1–3, “Then the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" spoke to Moses”; nos. 4–5, “Then the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" said to Moses.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("(1) Section 1 reopens the question of Moses’ incapacity as a speaker. God has long since commissioned Moses to go to Pharaoh to demand the release of Israel (3:10). Moses has already proffered his five excuses (3:11–4:17), including the objections, made again here, that the people will not believe him (4:1–9) and that he is a poor speaker (4:10).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("A new formulation of Moses’ incapacity as a speaker is introduced (v. 12); whereas in 4:10 he had described himself as “heavy of mouth and heavy of tongue,” he now terms himself “uncircumcised of lips.” This figure may mean no more than “unable, incapable” as in the figure of the inability of “uncircumcised” ears to hear in Jer 6:10 ")]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("(cf. the metaphor of “uncircumcised” hearts, Lev 26:41; Deut 10:16; Jer 4:4; and the sense of “unfit, unready” in connection with immature fruit trees in Lev 19:23). However, the sacral associations of the term “uncircumcised” are perhaps relevant and are astonishing in connection with the mediator of Israel’s law and covenant. Elsewhere in the HB the uncircumcised are synonymous with aliens as threatening (e.g., the Philistines, 1 Sam 14:6; the foreign nations, Ezek 31:18; 32:19–32). Perhaps still more to the point is that uncircumcision is equated with ritual uncleanness (Isa 52:1). This may open up ritual and editorial dynamics in the text: the later, fully developed system of the relation between the priest and the Levite is here prefigured. As the Levites, though teachers of the law and monitors of Israel’s practice of it, had to be subservient to the Aaronic priesthood as practitioners of the laws of holiness and purity, so here already Moses, though the original mediator of the law, is enabled by Aaron to be only its practitioner.")])]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("(2) Section 2 (6:13–28) opens with a brief subsection (v. 13) which states the whole point of these editorial developments of the text: both Moses and Aaron are commissioned to go to both the people and Pharaoh to secure the release of Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Now follows a subsection (6:14–28) which demonstrates the status of Aaron genealogically. Syntactically, this subsection falls outside the narrative sequence (cf. the broken syntax with which it ends, v. 28); it introduces the circumstances of descent and time presupposed by the narrative. The opening, “these are the heads of their households” (v. 14a), creates the expectation that an update of the complete listing of the Israelites will now be given, matching 1:1–4. In the event, the list covers only Reuben, Simeon, and Levi, the first three sons of Israel as listed in Gen 29:32–34. The reason for this shortened list is now clear. Reuben, it is stressed, is “the firstborn of Israel” (6:14b); but it is to be the function of the Levites to be the tribe of Israel that is dedicated to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" by way of redemption of the firstborn of the remaining tribes of Israel (Num 3:12–13). Thus the fundamental function of the Levites is here stated: they do not merely provide the teachers of Israel and the officiants at the altar; they are the tribe who vicariously redeem the firstborn of Israel. Once again the fully developed system of the dedication of the firstborn is anticipated, the rationale for which is being provided by the narrative of the deliverance of Israel as a whole from Egypt at the cost of the Egyptian firstborn (cf. 4:22–23): Israel is “bought for a price”; so, too, are the Levites.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The four sons of Reuben are listed, as are the six sons of Simeon (both as in Gen 46:9–10), in order to indicate the full spread of these tribes, their constituent “clans” (6:14–15, including, incidentally, under the last, their intermarriage with the native population).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The descendants of Levi are listed at much greater length (6:16–25), as befits their function, as vicariously dedicated to God, and the range of their duties within Israel (cf. the slightly different introduction, “according to their generations,” which may imply “their hereditary offices”). Thus the three great levitical families are listed, Gershon, Kohath, and Merari (as in Gen 46:11).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But before expounding their relative status genealogically, the book of Exodus supplies some chronological data (6:16b; cf. other such data at vv. 18, 20): the length of Levi’s life as 137 years. This note belongs to a series of chronological notes in Genesis, the essential feature of which for the production of an overall chronology is the age of the father at the begetting of the son in question. This series is intact in Genesis 5; 11:10–26 from Adam to Abraham gives a total of 1,976 years. The age of Abraham at the begetting of Isaac (100) is given in Gen 21:5, and of Isaac at the begetting of Jacob (60) in Gen 25:26. The only gap in the chain is the age of Jacob at the begetting of Levi. This can be roughly calculated from the data (assuming that they all share the same conceptual framework) that Jacob was 130 years old when he arrived in Egypt (Gen 47:9) in the second year of the famine (Gen 45:6), by which time Joseph was about 38 (cf. the date of his appointment by Pharaoh at the age of 30 in the first of the seven years of plenty, Gen 41:46); in other words, Jacob begat Joseph at about the age of 92 (cf. Gen 35:28, which states that Isaac died at the age of 180 but was already an old man when Jacob had to flee to Laban and find his wives, Genesis 27). Since, like all his brothers except Benjamin, Joseph was born in the last thirteen years of the twenty-year period of Jacob’s employment with Laban (Gen 31:38, 41), Levi as an older brother must have been born at the earliest in Jacob’s tenth year with Laban; that is, Jacob must have been about 90, or a year or two less, when he begat Levi. All these figures from creation to the death of Levi would add up to some 2,363 years. The obvious artificiality of these figures from a historical point of view should not obscure the theological point the writer wishes to make: it has been suggested that the final editor is an eschatological writer who is looking forward to the end of a 4,000-year era, in which the revelation to Israel, and in particular the erection of the tabernacle in the year 2666, or two-thirds through this era, as the center of Israel’s life, has the key part to play (creation to the descent of Jacob = 2,266 years; sojourn in Egypt = 400 years [Gen 15:13]). The writer is now preparing for that event.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is from the central family, Kohath, that the priesthood is derived. Part of its family tree is therefore elaborated for four further generations (6:18, 23–25) in order to show the descent of Aaron, the first high priest, who is to be succeeded in office by his son Eleazar (for whose later prominence see, e.g., Num 3:32; Josh 14:1), and in turn by his grandson Phinehas (for whom cf., e.g., Num 25:7–13; Josh 22:30–32).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("A number of significant incidents in the history of the priestly Levites is alluded to in this list of names. The marriage of Aaron’s father to his aunt (6:20, confirmed in Num 26:59, where she is called “daughter of Levi”) would be condemned in the legislation to come (Lev 18:12–14; 20:20); she, oddly enough, bears a name compounded with the divine element "), _c('i', [_vm._v("Yo-")]), _vm._v(", translated into English as “the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(",” thus anticipating the revelation to Moses in 3:14. An intriguing note is the marriage of Aaron to the sister of Nahshon, son of Amminadab (6:23). While an Amminadab is listed in 1 Chr 6:22 as a son of Kohath (cf. the legislation of Lev ")]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("21:14 on the marriage of the Aaronic high priest), the only Nahshon, son of Amminadab, known in the HB is the leader of the “host” of the leading tribe, Judah (cf., e.g., Num 1:7; 2:3; 7:12–17; 10:14), who also appears in the genealogy of King David (Ruth 4:19). He is the chief executive in the military realm, the leader of the “host” of Israel, the physical armies on earth which are the sacramental expression of the unseen, cosmic forces of the “"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LORD")]), _vm._v(" of hosts” (cf. the term for Israel as the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s hosts in v. 26; 7:4). Intermarriage between the high-priestly family and the royal family is evidenced in the marriage of Jehoiada, high priest at the time of King Joash, to a princess of the royal house of Judah (2 Chr 22:11; her name Jehoshabeath, incidentally, is a variant of Aaron’s wife’s name, Elisheba).")])]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The names of Aaron’s four sons are faithfully recorded (6:23b), but the first two are soon to be destroyed for unorthodox practice at the altar (Lev 10:1; Num 3:4; 26:61; in Exod 24:1, 9 they play a positive role). Of the two remaining, it is the branch of Eleazar which is to be dominant, producing not only the high priest but sixteen of the twenty-four teams of priests (1 Chr 24:1–6).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The maintenance of the exclusive status of the priesthood despite the claims of possible rivals is stressed by the recording of the name of Aaron’s cousin Korah (6:21), who is later to lead a revolt (Numbers 16–17). The destruction of Korah, but not of his family, does not prevent his descendants from discharging important roles as non-priestly Levites in the music of the later temple liturgy (cf. the headings of Psalms 42–49, 84, 85, 87, and 88; cf. 1 Chr 9:19).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The non-priestly Levites of all three branches are, on the whole, listed only to the second generation; again it suffices to indicate their chief families. Some of these names recur rarely (e.g., Mishael and Elzaphan in 6:22 reappear only in the important passage in Lev 10:4) or not at all (e.g., Putiel, v. 25) in the HB.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The section ends with the resumption of the main theme (6:26): the status of Aaron in the exodus. Here for the only time in Exodus (and the HB except in family trees or their equivalents, where the fact that Aaron is three years Moses’ senior is acknowledged by his being listed first; cf. 7:7) Aaron precedes Moses. The standard order is resumed in v. 27.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("(3) Section 3 (6:29–30) resumes Section 1 after the long account of the circumstances of Aaron’s birth and status in Section 2, which explains the fitness of Aaron to act as Moses’ spokesman and agent.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("(4) Section 4 (7:1–7) provides Aaron with his warrant as spokesman for Moses to Pharaoh. He is to speak nothing but what Moses communicates to him from God, so that, in a vivid phrase (v. 1), he is Moses’ prophet, his mouthpiece, while Moses is God to Pharaoh. The same unsuccessful outcome to their mission is foretold as in 4:21: guilty Pharaoh is locked into the consequences of his guilt by God’s “hardening of his heart” (7:3). The “signs and wonders” will be used to demonstrate the power of God and force acknowledgment by the Egyptians (v. 5; for the key term “know” cf. 5:2; whereas in the earlier version “signs and wonders” were distinguished as “signs” to Israel and “wonders” to Egypt, here the words are used indiscriminately and are termed “judgments” [7:4], as in 6:6).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("(5) Section 5 (7:8–13) provides Aaron with his warrant as agent for Moses to Pharaoh. Just as Moses is armed with the “sign”-working staff in 4:1–5, which turns into a snake, so now Aaron is similarly equipped as he goes to confront Pharaoh. The word for “snake” now used is different from that in ch. 4; elsewhere it can mean “sea monster” (though it is parallel to “python” in Deut 32:33), an appropriate reference given the portrayal of Egypt as a sea monster lurking in the Nile in Ps 74:13; Isa 27:1; 51:9–11. That cosmic conflict is intended by the imagery is suggested by the fact that Pharaoh’s magicians, too, could turn their staffs into “sea monsters”; nonetheless, the sea monster produced by Aaron swallows them up as a portent of the victorious crossing of the Sea by the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s hosts (12:17, 41, 51) at the exodus to come. But again Pharaoh is blind to the portent.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The First Nine “Wonderful Deeds” of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" (7:14–10:29)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The series of ten so-called “plagues of Egypt,” culminating in 12:36 in Israel’s release into freedom, now begins. They should be more accurately termed the “wonderful deeds” of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" (3:20). In the older version, 7:14, which introduces the first of these “wonderful deeds,” would link directly with 6:1: this is the beginning of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s response by word and act to the despair of his people. The all-too-clear forewarning of Pharaoh’s refusal to set Israel free in 3:18–20; 4:21–23 and the all-too-completely-fulfilled experience of that refusal on first encounter in ch. 5 are now to be repeatedly borne out (much of the vocabulary of these earlier chapters is used over and over again in these new encounters; cf., e.g., 7:16). But these demonstrations of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s power will culminate in the release of Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first nine “wonderful deeds” are related, though here in intensified form and cumulative effect, to regular patterns of devastation for which Egypt is notorious. The cracking of the veneer of order in the natural world demonstrates the fragility of even the most pretentious and tyrannical human power structure. The climactic tenth “wonderful deed,” the slaughter of every firstborn male in Egypt, whether human or domestic animal (11:5), is, by contrast, by its very nature an entirely unprecedented event. It is appropriate, therefore, to take the first nine “wonderful deeds” in 7:14–10:29 together and then to treat the exceptional tenth in 11:1–12:36 separately. There are, indeed, a number of recurrent elements in the accounts of the first nine “wonderful deeds” which lend cumulative force to the whole and can best be appreciated in this way (the eight major—and four minor—paragraph markers subdividing 7:14–10:29 in the MT do not all coincide with the nine plagues: plagues 2–4, e.g., are linked together; the narratives of plagues 7 and 8 are both divided into two).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("There is reason to believe that, like much of the rest of the book of Exodus, the series of plagues has been developed in two major phases. It is likely that plagues 3, 6, ")]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("and 9 belong to the final edition and have been added to the original version of seven plagues (including plague 10). They link with the commissioning of Aaron in 6:2–7:13, which, it has just been argued, belongs to the final edition of the work; they are much briefer than almost all the other plague narratives; and they differ from the remainder in structure in that they plunge straight into the action that Moses (and, usually, Aaron) has to perform. The addition of these three plagues to an earlier series of seven would explain some anomalies in the text; for example, in plague 7 (9:15) the reference is to plague 5, not to plague 6; the prohibition on seeing Pharaoh again in 10:28–29 at the end of plague 9 contradicts what happens in 11:1–8. In the process, the narrative of plagues 1, 2, 4, 5, 7, and 8 (and 10, as will be argued below) has itself been added to and adapted. In plague 1, for example, there are adjustments in 7:19–22: Aaron and the Egyptian magicians are introduced (the staff referred to initially in v. 15 is Moses’ staff of 4:2–4, not Aaron’s of 7:9–12, as the word used for “snake” makes clear); “the water in the Nile” has been extended to “water, even in vessels, throughout all the land of Egypt.” There are similar additions to later narratives, for example, to plague 2 in 8:5–7 and to plague 8 in 10:1–3.")])]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The original version of plagues 1–9 presents, in terms suitable to conditions prevailing in Egypt, a coherent set of variations on the themes of famine and pestilence, two of the stock instruments in the HB of divine warning of final punishment to come (cf., e.g., Amos 4:6–13). They are “portents”: however unprecedented their coincidence and catastrophic their proportions (9:18, 24; 10:6, 14), they remain events of recurrent possibility in the natural world; but they indicate a deeper meaning. Thus, annually from about the middle of June the Nile floods over, full of the suspended alluvium brought down from its upper reaches (which in fact guarantees the continuing fertility of the soil); at this time it can indeed become undrinkable and be described as “turned into blood” (plague 1). The only uncertainty of that flood is the variability of the height to which it will rise (cf. the Nilometer at Aswan). The spread of repulsive frogs across the surface of the land with those floodwaters, plague 2, is thus equally explainable (cf. the “naturalistic” depiction in 8:3, as opposed to the miraculous element in 8:5–6), as is their death when the flood waters recede. Swarms of flies from the heaps of dead frogs (plague 4) are then inevitable, with the hazards to the health of livestock that they pose (plague 5). The two further natural disasters, hail (plague 7) and locusts (plague 8), are unconnected with the preceding in the normal course of events; that they should strike now with such universal destructive force and complete the devastation is the compelling factor. For those with eyes to see, these events are “portents” of deeper disturbance: the dislocation of the natural order is a summons to look below the surface at the structures of the community, a warning that the apparently securely based institutions of the state are equally conditioned, equally susceptible to attack and overthrow, equally open to impending doom. For those with dulled sensitivity, these disasters are merely interruptions, after which life can go on as before. The obtuse Pharaoh, whose moral sense is already atrophied, as demonstrated by his insensitivity to the suffering of generations of his slaves, is impervious to such transient inconveniences, let alone to any deeper significance they might symbolize (cf. the variations on the phrase “hardening of the heart” throughout the plague narratives, already signaled in 4:21).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The casual cynicism and obduracy of Pharaoh are heightened in plagues 2, 4, 7, and 8 by the motif of the intercession of Moses (a role of the prophet which recurs in the later HB, especially in the Deuteronomistic parts of Jeremiah, e.g., Jer 32:16). Repeatedly opportunities are given to Pharaoh to “know” (another recurrent theme; cf., e.g., 8:10), to acknowledge the incomparability of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" (9:14; 10:2) as demonstrated in the control and precise time-tabling of the crises; but, apart from brief moments of expediency or offers of minimal concessions (e.g., 8:25), he refuses to recognize the significance of the “portents.” The dawning acknowledgment among the ordinary Egyptians (9:20; 10:7; cf. 11:3) focuses all the responsibility on Pharaoh himself.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The moral lesson to be derived from these portents is portrayed in terms of the sparing from disaster of the area settled by Israel (explicitly noted in plagues 4, 5, and 7; cf. 9:23; 11:7). That sparing could be naturalistically explained in terms of the location of the land of Goshen, outside the Nile valley (cf. Josh 10:41), where Israel was settled (Gen 45:10). But part of the character of these events as “portents” is not just the suffering of the tyrant and his people who are implicated in his guilt, but the sparing of the oppressed slave population whose rights need to be vindicated.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The main reason for the additions and adjustments by the final edition to the older version is to lend a cosmic dimension to the confrontation between God and Pharaoh. A titanic struggle has now begun, the collision between two rival and incompatible belief systems. This is chiefly signaled by the introduction of Aaron and his wonder-working staff, which had been turned into the “sea monster” (7:9–10). Aaron, priest-to-be of the tabernacle, the representation in miniature of the cosmos (chs. 25–31; 35–40), the rites of which are, above all, to maintain that cosmos in being, is in direct competition with the Egyptian magicians and their magic arts (cf. 7:11–12). Initially, the magicians are able to work the same marvels (additions to plagues 1 and 2); but soon they are exposed as charlatans (plague 3) and are driven from the field in humiliation, smitten by the plague they cannot cause, let alone cure (plague 6).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Tenth “Wonderful Deed” of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" (11:1–12:36)")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("The narrative of the climactic tenth plague which finally forces Pharaoh’s hand to release Israel is now set forth. But the true climax of chs. 1–15, the definitive elimination of Egypt as a threat to Israel’s freedom, which warns against taking the so-called “plague narrative” as a self-contained unit from 7:14 to, say, 11:10 or 12:36, is not reached until 14:31. It is only at that point that the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s ")]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("outrage at the enslavement of his people, already announced in 2:23–25, is resolved and his intervention to secure their release complete. But the tenth plague marks the end of the first decisive stage in that process: Israel escapes but is yet to be assured of enduring liberty.")])]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("As the structure of the narrative of the tenth plague in 11:1–12:36 makes rather clear, there is once again a significant interplay between the older version and the final edition. The narrative of the final plague is contained within the opening and closing subsections, 11:1–3, 4–8; 12:29–36. There are grounds for believing that these subsections, in fact, constitute the entire content of the original version of the tenth plague. 12:29–36 stands in chiastic correspondence to 11:1–8; 12:29–34, the depiction of the sequence of events, the death of the Egyptian firstborn leading to the expulsion of Israel, relate to Moses’ ultimatum to Pharaoh in 11:4–8; 12:35–36 pick up the instructions to Moses “to spoil the Egyptians” in 11:2–3. As in the earlier cycle of plagues 1–2, 4–5, and 7–8, so now in plague 10 a confrontation with Pharaoh begins with an accusation of Israel’s wrongful enslavement, continues with Pharaoh’s peremptory rejection of the request to leave, and ends directly in an act of God, from which Israel is, once again, shielded (11:7; cf. 8:22; 9:4). The crucial difference in this final encounter is that Pharaoh is forced by the overwhelming nature of the catastrophe, the death of all Egyptian firstborn, both human and animal, to propel the Israelites out of the country in fear lest the destruction of the entire population of Egypt should follow. The sequel of commemorating such a hasty expulsion, when there was no time to wait even for the bread to rise, by the rite of eating unleavened bread for seven days is then entirely appropriate (12:34; 13:3–10).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But to place the “plagues” narrative of 7:14–12:36 even within the wider framework of the outrage of God and his intervention to right the wrong in 2:23–14:31 is still not adequate. As has been noted above (on 4:21–23), the sequence of events in Exodus 1–24 exactly matches the order of the legislation in Deut 15:12–16:8 on the release of the Hebrew slaves, the offering of the first-born, and the celebration of the Passover. In order to gain the fullest expression of the action of God, of participation in that action, and of the implications of participating in that action, the “plague cycle” must be related to the celebration of the Passover. The narrative of the tenth plague thus naturally climaxes in the narrative of the Passover. There are grounds to hold that in the original edition the institution of the Passover is first outlined in 13:3–10; but its full exposition then extends to 24:8, including also the theophany and covenant at the Mountain of God as part of the Deuteronomic model of the Passover as a one-night-plus-seven-day observance (Deut 16:1–8). But, even then, the Passover as a commemoration and celebration of the action of God in rescuing Israel his firstborn must be complemented by an expression of thanksgiving on the part of Israel in the offering of their firstborn: the Passover ordinance in 13:3–10 is thus enfolded in the legislation for Israel’s offering of their firstborn in 13:1–2, 11–16.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The final edition of Exodus views the relationship of the “plague cycle” to its context very differently. Three new subsections have been introduced between 11:9 and 12:28. The first of these, 11:9–10, is a summary of the plague cycle, which is thus now separated from its natural sequel in the death of the Egyptian firstborn (12:29–36) and the legislation on the offering of the Israelite first-born (13:1–2, 11–16). Instead, the plague cycle now issues in the Passover as redefined in non-Deuteronomic terms in 12:1–13; indeed, a further section on the Passover is introduced in 12:43–50, which is concluded with a yet further summary of events in 12:51. The legislation on the offering of the firstborn in ch. 13 is thus now disconnected from the tenth plague and left in some isolation. Further, the Passover is rigidly understood as a one-night observance, as the new—or newly edited—material in 12:1–13, 21–28, 43–50 makes clear; it is now carefully distinguished from the pilgrimage festival of Unleavened Bread (12:14–20).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These changes in the layout of the material have been caused by fundamental changes in conception. The plague cycle is no longer merely the demonstration of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s redeeming power in the eyes of the Egyptians; part of its purpose is to convince Israel itself of the reality of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s intervention on its behalf (cf. 10:2). Indeed, the tenth plague is now equally threatening to Israel: it is only by the observance of the Passover as a rite of protection even for Israel itself that the firstborn of Israel are spared (12:21–28). The Passover as a one-night domestic observance is separated from the “octave” of the ensuing pilgrimage festival at the Mountain of God, about to be described in the original version of 15:22–24:8. In the process, the covenant is separated from deliverance from Egypt (the primary covenant is that with the patriarchs, as the final edition has already stated in 6:5) and is now overlaid as a revelation of law. Israel as eager covenant partner has become Israel the recalcitrant and disobedient, in need of the sacrificial cultus and its rites of atonement to maintain its relationship with God. Thus two sharply different—though still complementary—portrayals of Israel are presented in the one text. The older version is a message of reassurance for an Israel “in exile” that God’s unwavering purpose of bringing freedom to his people through his covenant endures. The later edition is a message of discipline aimed at an Israel “in return from exile.” The vast task of building the community in which God’s central claims on the loyalty and obedience of his people are fully met is far from complete. The traditional theological terms, “justification” for the older version and “sanctification” for the final edition, themselves equally complementary, congenially fit these two contrasting portrayals.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("The first scene (11:1–3) announces the final plague (the term “blow” is used, v. 1, for the first and only time). As foretold in 6:1 and fulfilled in 12:39, Egypt in the end will be only too eager to “drive out” Israel (11:1). The sequence of thought in these verses can only be appreciated from the legislation on freeing a Hebrew from slavery in Deut 15:12–18 (the verb “let go” in 11:1 recurs four times in Deut 15:12, 13, 18). In recognition of the value of the service provided, the erstwhile slave owner is required to “festoon” the freed slave with produce; hence Israel has every right to demand of its Egyptian oppressors objects of silver ")]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("and gold in recompense for its years of toil (the key term “not empty-handed” in Deut 15:13 has already been used in Exod 3:21–22 in anticipation of this passage and its fulfillment in 12:35, 36). The dignity of the people and the authority of Moses inspire a favorable response on the part of the ordinary Egyptians.")])]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The scene now shifts (11:4–8) to the final confrontation between Moses and Pharaoh (the fact that the addressee is seemingly suppressed in v. 4 and the location of the encounter is not made clear until v. 8 is a reflection of the view of the final editor, who has already been responsible for the addition of plague 9; contrast 10:28–29). It is matched by its direct continuation in 12:29–36. There is a close correspondence within acceptable variations of language between the forewarning of Moses and the outcome; for example, the “great cry” at the unprecedented calamity of the bereaved Egyptians foretold by Moses in 11:6 (which picks up and counterpoises the “cry” of the Israelites to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" in 3:7) is bitterly fulfilled in 12:30 and leads directly to the expulsion of Israel laden with valuables. The whole purpose of the narrative has been achieved: Israel is released into the service of God (12:31), as Egypt is compelled to acknowledge (11:7; cf. 5:2).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("After his new summary in 11:9–10, which somewhat draws a line in the present text under the “plague cycle,” the final editor introduces a revised statement on the Passover in 12:1–28. The importance of this material is indicated by the fact that it is in two matching sections, the first containing the instructions from God to Moses and Aaron (12:1–20) and the second, the communication of these instructions, with some further specifications, to the people (12:21–28; there are already some switches from third to second person in the first section in anticipation; contrast the previous account of the plagues where an equivalent of one or the other of these sections has occurred, at least in plagues 1, 2, 4, 5, 7, 8, and 10, but never both).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first section, 12:1–20, puts forward a highly distinctive view of the festivals of the Passover and Unleavened Bread, which contrasts with the practice of the older version found in its full form in Deut 16:1–8 and in heavily edited form in Exod 13:3–10 (phrases from Deuteronomy 16 and Exodus 13 are here picked up in Exodus 12 and qualified in a new context; e.g., for v. 12 cf. 13:15; for vv. 15, 19 cf. 13:6; Deut 16:3–4; for v. 25 cf. 13:5).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Both accounts begin with a reference to the calendar. For the final edition in Exod 12:2, the Passover marks the fifteenth of “the first month,” reckoned according to the “Babylonian” calendar, which begins in the spring; in the older version in Exod 13:4 it falls in “Abib,” the seventh month of the “Canaanite” calendar, which begins in the autumn (cf. Exod 23:14–19). The rites themselves are sharply distinguished in the two accounts. In Deuteronomy the one-night rite of the Passover has entirely engulfed the following seven days of Unleavened Bread, the agricultural festival of the barley harvest; here the two are clearly demarcated in 12:3–13 and 14–20 respectively (for the standard formulae in v. 14 cf. Lev 23:41; Num 29:12). In Deuteronomy the festivals of the Passover and Unleavened Bread are regarded as parts of the one pilgrimage festival to the sanctuary. As a result, the Passover victim is treated like other sacrificial offerings in the sanctuary: it may be selected from cattle as well as from sheep or goats; and it is boiled (incidentally, there is no definition of the age of the victim or of the numbers of victims). By contrast, in Exodus 12 the Passover is a lay domestic rite which is thus necessarily entirely distinct from the specialized priestly rites of the sanctuary: the victim is “slaughtered,” not “sacrificed” (though an echo of the vocabulary of the older version remains in v. 27); it is spit-roasted whole (cultic boiling, as in 1 Sam 2:13, is specifically forbidden, v. 9), and any parts not consumed are burned. Provision is sufficient for the company. It is notable that in v. 5 the victim is specified as a yearling ram, not as a firstling; the connection with the firstborn, which has been the whole point of the earlier version of the plague cycle, is thus broken. The specification as a yearling ram does, however, have echoes of ritual practice; cf. Lev 1:10 for acceptable offerings; Lev 9:3 at the dedication of the sanctuary; and, especially, the stated sacrifice at the offering of first fruits at the feast of Weeks in Lev 23:18, which may in fact conceal elements of historical practice in connection with the offering of firstlings, as suggested by Deut 15:19–20.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A feature which both accounts share is that the Passover meal is to be completed that night. But again there is a difference: in Exodus 12 the instructions are, somewhat improbably, that Israel itself on that very night of its expulsion is to eat this very meal (v. 28). It is only by staying indoors until the morning in houses whose doorposts and lintels have been marked by the blood of the victim (v. 22), which has itself been set aside in readiness for the past four days (v. 3), that Israel will be safe from the destruction. The point then of “eating in haste” is somewhat lost (v. 11; as is the eating of the wild “bitter herbs” of the wilderness "), _c('i', [_vm._v("before")]), _vm._v(" the departure from Egypt, v. 8).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The older version is more consistent: the rite is to be observed only when Israel is settled in the promised land (13:5; cf. the echo preserved in 12:25). It is a rite not of warding off the threat of destruction (a demonstration of the power of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" to deliver as opposed to the powerlessness of the Egyptian gods to protect their people, v. 12), but of commemoration of deliverance. The sign of haste is the eating of unleavened bread, again in commemoration that it was actually during that night that the Israelites were forced out of the country, with no time to let their bread dough prove.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Passover has now been presented in a twofold fashion: as a memorial in the older version and as a means of deliverance in the final edition. The release of Israel from slavery is now accomplished, but entirely on God’s terms, into the service of God, which has been the dominant theme since the beginning of the book (cf. 1:13–14).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Beginning of the Journey (12:37–42)")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("This brief section opens up the topic of the route the Israelites follow through the wilderness from Egypt to the Mountain of God before then setting out on the long trek into the promised land. Once again, there are two ")]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("views on this question in the Pentateuch: the final edition is summarized in Numbers 33, and the earlier version is reflected in Deuteronomy. Once again, both of these, with their associated theological outlooks, are represented in the present combined text in Exodus.")])]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The route Israel follows in the final edition of Exodus 12–19 begins in Rameses, one of the places where Israel toiled as slave laborers (cf. 1:11); thence Israel sets out to Succoth (12:37), then on to Etham (13:20), Pi-hahiroth (14:2), Marah (15:23), Elim (15:27), the wilderness of Sin (16:1), Rephidim (17:1), and, finally, the wilderness of Sinai (19:2). This route matches, with some omissions, and one significant addition in 17:1–7, the summary in Numbers 33.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Corresponding to that route is a distinctive timetable of events: Israel leaves Rameses on the fifteenth day of the first month, the day after the celebration of the Passover; it arrives at the wilderness of Sin on the fifteenth day of the second month (16:1) and at the wilderness of Sinai on the first day (?) of the third month (19:1). This timetable is part of a much wider chronological framework in the final edition of the Pentateuch: in Exod 40:17 the tabernacle is set up on the first day of the first month of the second year; in Num 10:11 on the twentieth day of the second month of the second year Israel departs from Sinai initially to Kibroth-hattaavah and Hazeroth (Numbers 11; cf. Num 33:15–17); eventually Israel reaches Kadesh on the first day (?) of the first month of the fortieth year (Num 20:1; 33:36–38).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Deuteronomy has an entirely different view of the route and its associated chronology, which Israel follows from Egypt to Kadesh. So far from Kadesh being reached only in the fortieth year, the journey from Egypt via the Mountain of God to Kadesh is all accomplished within the first year of the exodus (Deuteronomy 1; 2:14). In particular, no incident is recorded on the journey from the Red Sea to the Mountain of God; it is apparently swift and uneventful. There are materials in Exodus corresponding to such a conception of the journey, for example, the motif of the “three days’ pilgrimage” into the wilderness to the Mountain of God, introduced in Exod 3:18, and the bearing of Israel on swift and irresistible “eagles’ wings” in Exod 19:4. It would seem that yet once again, now in the matter of itinerary and its associated chronology, a version matching the presentation in Deuteronomy has been overlaid by a final edition corresponding to the summary in Numbers 33.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These contrasting views of route and timetable also introduce contrasting views of the location of God’s miraculous deliverance of Israel at the Sea. In Num 33:7–8 the crossing takes place at Pi-hahiroth, the fourth station in the wilderness wandering. From the associated place names Baal-zephon and Migdol, and from the probable meaning of the name Pi-hahiroth (“the mouth of the channels”), it is clear that the location envisaged is the easternmost arm of the delta of the Nile as it flows into the Mediterranean. By contrast, in Deut 11:4 and elsewhere in Exodus (13:18) the miraculous deliverance takes place at the Red Sea (contrast Num 33:10, where the arrival at the Red Sea is at station 7; a matching note has seemingly been suppressed for harmonizing purposes in Exod 16:1).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The reason for the difference of views about the location of the miraculous deliverance of Israel is clear. For the older version, the point of view is geographical: by this act of God, Egypt’s empire has been destroyed and with it its power to enslave subject peoples (cf. 12:38, “the mixed multitude” who “went up” with Israel); the frontier of Egypt has been definitively set at the Red Sea. For the final edition the matter is also cosmic. Just as the final editor has introduced Aaron with his wonder-working staff that turned into a sea monster (7:9–10) in order to confront the power of Pharaoh and controvert his magicians, so now Egypt perishes in its own Nile. The deified Nile, whose flooding waters bring life to the country, is now turned into an instrument of destruction (cf. Ezekiel 29–32); by this act, in the words of the final editor, the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" does indeed work “judgments on the gods of Egypt” (12:12). And these judgments are wrought in favor of the “hosts” of Israel (12:51): the sacramental representation on earth of the hosts in the cosmic realm which “the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" of hosts” has at his disposal (12:41).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The date of the exodus may equally have cosmological significance: understood in the terms of Gen 15:13, it falls 2,666 years after creation, or two-thirds through an era of 4,000 years (see Exod 6:14–28 above).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Passover, an Israelite Household Rite (12:43–51)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The subsection on the law of the Passover in 12:43–50 is uniform with legislation already given in 12:1–13 (the Passover is a domestic rite, v. 46; again law is narrated as part of the action of the night of the first Passover and the following day, vv. 50–51, though the situation implied is that of a community settled in the land, v. 48). The structure of the section underlines its significance: it begins and ends with words for “law” (vv. 43a, 49); most clauses begin emphatically with an itemized case and end with the appropriate action (e.g., v. 43b: “no foreigner shall eat of it”). The list has a certain chiastic structure: it begins and ends with those excluded, foreigners and uncircumcised (vv. 43b and 48b); vv. 44 and 48a deal with outsiders who have undergone circumcision. The heart of the matter—Israel’s observance of the rite—stands at the heart of the section in vv. 46–47.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the conception of the final edition, observance of the Passover is the means of protection and deliverance of Israel. The section thus answers in particular the question of who may participate in the Passover: only Israel, understood as those who belong to the community of the primary covenant with Abraham, the sign of which is circumcision. Therefore, no foreigner or temporary resident, no uncircumcised male, may share. The only exceptions are those who have been incorporated permanently into the community, the slave and the resident alien.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("Points already made in 12:1–13 are now developed. Since the rite protects each household by the sign of the blood on its lintel and doorposts on the night when the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" “passes over,” it is to be observed within the home. In contrast to the sacrifices offered in the sanctuary, the ")]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_vm._v("animal must be roasted whole; there is no cutting up of the carcass to lay it on the altar (v. 46).")])]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_vm._v("The Commemoration of the Exodus (13:1–22)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("By contrast, in the earlier version, preserved in edited form in ch. 13:1–16, there is no ceremony on the original night of the tenth plague, the slaying of the firstborn of Egypt: Israel does not need to be protected from the means of its own deliverance. Rather, when Israel is brought into the promised land (vv. 5, 11) two rites of commemoration of Israel’s deliverance will be observed (for the stress on commemoration, cf. “remember” [v. 3], “reminder” [v. 9], and its alternate, “emblem” [v. 16]).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first rite, the dedication of Israel’s firstborn, both human and animal (13:1–2, 11–16), relates directly to the tenth plague, the death of the Egyptian firstborn, both human and animal (12:29), and is the appropriate commemoration of the means, and cost, of Israel’s redemption. Appropriately, then, it enfolds the second rite (vv. 3–10), here described in terms of “unleavened bread” (v. 6) in deference to the final editor’s account of the Passover just given in ch. 12. The unevennesses in the present text of vv. 3–7 (e.g., the abrupt switches in thought in vv. 3–4; the repetitions between vv. 3, 6, and 7) suggest the intervention of the later editor. In the smoother parallel text in Deut 16:1–8 this one-night-plus-seven-day pilgrimage festival is termed “Passover,” and so it was, in all probability, in the underlying version here.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It now becomes clear how integrally these two institutions—dedication of firstlings and Passover—are related in providing the framework for the rest of the earlier version of Exodus. The legislation cited here in connection with both institutions is codified in 34:18–20. The link between the two passages is highly significant. I have already argued (on 4:21–23) that not only is the sequence of the legislation on the offering of firstlings and on the Passover in Deut 15:19–16:8 reflected in the earlier version of Exodus 1–24; the legislation on the Passover itself in Deuteronomy 16 provides the chronology of a seven-day pilgrimage festival to the Mountain of God which culminates on the seventh day in the covenant of Exod 24:3–8. Integral to that covenant is the “book of the covenant” (24:7), the content of which has been revealed to Moses on the previous night (20:22–23:33). It is that Book of the Covenant which, I will argue, along with the Decalogue forms the basis for the remaking of the covenant in ch. 34, the final chapter of the original version of Exodus. Strikingly, the clause on the dedication of the firstborn in that repeated version of the Book of the Covenant in 34:19–20 is cited here in vv. 2, 12, and 15. Equally, the clause on the eating of unleavened bread in 34:18 (cf. 23:15) is cited here in vv. 4 and 6. Exod 13:1–16 thus anticipate the original festal “octave” of the one-night-plus-seven-days of the journey to, and presence at, the Mountain of God commemorated by the Deuteronomy version of the Passover, which culminates in the making of the covenant (ch. 24) and the remaking of that covenant on identical terms (ch. 34).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The integral connection between the rites of firstlings and Passover—and their structural function within the narrative, linking earlier and later parts of the book—is made clear by the use of a number of other recurrent themes in both: “bringing out of Egypt with a strong hand” (13:3, 9 and 14, 16); “leading into the land promised to the forefathers,” with the itemization of the indigenous population of the land (vv. 5 and 11); the instruction of the son (vv. 8 and 14); and the “sign on the hand and between the eyes” (vv. 9 and 16).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("13:17–22 continues the itinerary of the older version (see on 12:37–42): it picks up the language of expulsion of 12:33; Israel passes directly to the Red Sea where the miraculous deliverance of Israel from the pursuing Egyptians is about to take place (contrast the Red Sea as station 7 in the summary of the later edition in Num 33:10; there is a snatch of that later itinerary in v. 20 to prepare for the joint account of the deliverance at the Sea in ch. 14).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The itinerary is directly linked to the question of how Israel should respond to God’s action. To achieve God’s purpose for their conquest of the promised land, Israel has to be fully participant in God’s action. Therefore, the people go up “in battle formation” (13:18). But Israel is not yet ready for the conquest; it is not led into direct confrontation with the nearest inhabitants of the land (v. 17). The battle must await God’s timing (v. 18)—the same vocabulary is eventually to be used of Joshua’s invasion of the land in Josh 1:14; 4:12. Meantime, Israel is en route through the deliverance at the Sea to the covenant at the Mountain, where the quality of their commitment will be disclosed and tested. Covenant implies an act of deliberate decision on Israel’s part, a set of responsibilities assumed. Reliance on God thus means not passivity or inaction but total readiness, as defined by the covenant, for participation in the coming act of God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The journey thus marks the wide span of God’s purpose from promise to fulfillment. That purpose is further symbolized by the bones of Joseph (13:19). In Gen 50:25 Joseph makes the Israelites promise, in the vocabulary reused here, that when they have been “visited” graciously by God in Egypt, they will take up his bones for burial in the promised land. That promise is to find its eventual fulfillment under the conquest of Joshua (Josh 24:32). Moses’ action now enables the fulfillment of God’s promise as symbolized by Israel’s promise to its ancestor.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But there is a direct token of God’s unwavering purpose: “the pillar of cloud by day and of fire by night” guiding—and soon protecting (14:19, 20)—the people (vv. 21–22). One may assume that this pillar is the same as the one in 33:9–10, where some of the same vocabulary recurs. The “going before” is then symbolized by the ark and the tent of meeting, which lead the people from camping ground to camping ground. The language may be entirely figurative (cf. cloud and fire as accompaniments to the self-disclosure of God in 19:9, 16) or may apply to the burning of incense (cf. Lev 16:13; “cloud” is not used elsewhere of the smoke from the altar of burnt offerings).")])]), _c('p', {
    staticClass: "H2"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("The Crossing of the Sea (14:1–31)")])]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("In the discussion of the first stages of Israel’s route from Egypt in 12:37–42 I noted that there are two conceptions of the location of the deliverance at the Sea: the earlier version places it at the Red Sea, the later edition at the easternmost branch of the Nile. Each has its corresponding purpose: the earlier is geographical, the later cosmic. In the narrative in ch. 14 these two views are developed and combined.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the final form of the text the drama is presented in three acts: 14:1–14, 15–25, and 26–31. Each is introduced with the phrase, “Then the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" spoke/said to Moses”; the action is in every case initiated by the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(": the hardening of Pharaoh’s heart to pursue the fleeing Israelites; the hardening of the Egyptians’ hearts to pursue Israel onto the dried-up bed of the Sea; and the drowning of the Egyptian host in the returning waters of the Sea.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The earlier narrative is, broadly, contained in 14:5–6, 10–15, 19–21a, 24, 25b–27a, 28, and 30–31. It carries on directly from the statement of 13:21–22 that the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" goes before his people in the pillar of cloud by day and of fire by night. That same pillar, here identified with “the angel of God” (v. 19; cf. 3:2; 23:20–23; 33:2), now protects Israel by switching from their vanguard to their rear guard to stand between the fugitive Israelites and the pursuing Egyptian army. It is from that same fiery pillar that panic is spread among the Egyptians (v. 24). The conception of how the sea is dried up is distinctive: it is driven back by “a strong east wind” (v. 21a); the waters recede only to flood back at the end of the narrative (vv. 26–28).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This version resumes central themes of the work: the “cry” of Israel, which the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" hears (14:10, 15; cf. 3:9); the despair of the people (vv. 11–12; cf. 5:21); the fundamental point that the battle is the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s (vv. 14, 25b; cf. on 13:18); the confirmation of faith in the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" and in Moses (v. 31; cf. 4:1–9, 31; 19:9); and the proper fear (vv. 10, 13, 31).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The chronology of this account is consistent with other parts of the older version. It is now clear how the “three days” (cf. 3:18) of the journey from Egypt to the Mountain are filled. It is toward the end of, presumably, the first day after the Passover that the pursuing Egyptians catch up with Israel. The strong east wind which brings deliverance blows the entire ensuing night (v. 21). It is in the third and last watch of that night that the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" creates panic in the camp of the Egyptians (v. 24); at dawn (v. 27; thus on the second day) the waters rush back and trap the Egyptians. On the following day, on that version, Israel will reach the Mountain of God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The vocabulary in this version has notable coincidences with that used in the narrative of the crossing of the Jordan in the “Deuteronomistic History” in Joshua 3–4: “dry land” (14:21a; cf. Josh 3:17; 4:18; the later edition has a different word, translated “dry ground”), “the waters returning” (vv. 26–28; cf. Josh 4:18).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The purpose of the narrative in the older version is to make clear that the liberation of Israel from the tyrant by itself is not enough; all possibility of the tyrant ever again imposing his servitude has to be eliminated (cf. the view of Deut 11:4). The Red Sea is the limit at which the power of Egypt is definitively destroyed.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The second edition amplifies this version with complementary conceptions. The clearest modifications are those which concern the route that Israel is following (14:1–4, 9). The Sea is now envisaged as the easternmost arm of the Nile. A cosmic dimension is implied (see on 12:37–42). The violent language, that the Sea is “split” (14:16, 21b, and therefore that Israel passes through a channel with the waters heaped up as a “wall to their right and left/south and north,” vv. 22, 29), matches the mythological language used in encounters with rival belief systems, as in Ps 74:12–15. The encounter with the Egyptian host is provoked by the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s hardening of their hearts (14:4, 8, 17, 18). Thus one of the outcomes of Israel’s deliverance is the acknowledgment of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s triumph by the world, not least by the Egyptians (vv. 4, 18; cf. 7:5). For the splitting of the Sea Moses’ wonder-working staff is reintroduced (cf. 4:1–5; in the older version Moses’ hand suffices).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Israel’s Hymn of Celebration (15:1–21)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This section provides an excellent example of the principle stated at the beginning of this commentary on Exodus: in the Torah there is no earlier or later (see “Perspectives for Understanding Exodus,” 72 above). Thus, when Moses and the men of Israel (for the women, cf. v. 20) raise a hymn in response to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s display of sovereignty over Egypt at the Sea—and, by extension, over any power on earth or in heaven that might challenge his sovereignty—it is not merely the destruction of the Egyptian host which they celebrate. The whole story of God’s saving acts on behalf of his people in time, and true for all time, is included in the hymn.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Thus, though the initial reference is to the drowning of the Egyptians in the Sea (15:1, 4, 5, 9, and 10), and to the deliverance of Israel (v. 8), these are but the immediate demonstrations of what is eternally true of God. The specific experience in relation to Egypt is generalized to hold in all circumstances. The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" is “salvation” (v. 2), a “man of war” (v. 3a), whose mighty right hand shatters his enemies (v. 6); everything he does is in accord with his nature as revealed in his name, “the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("” (v. 3b; cf. on 3:14–15). The hymn therefore appropriately goes on to celebrate God’s subsequent acts: his guidance of his people through the wilderness (vv. 13–15; the rebellion of Korah in Num 16:31–34 may be alluded to in v. 12); the conquest under Joshua (v. 16; cf. Exod 23:27; Josh 2:9 for the “dread” which will fall on the indigenous population); and the climax of the choice of Jerusalem at the time of David (vv. 13, 17).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is thus appropriate that many of the themes of the Jerusalem tradition of theology, as expressed in the prophets of Jerusalem, particularly Isaiah, and in the liturgy of the Jerusalem temple as reflected in the Psalms, are utilized in this hymn.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("Indeed, this poem would be perfectly at home in the book of Psalms. Its title, “a song” (15:1), is one of the commonest in the psalter; the term translated “splendor” in v. 11 is literally “hymns,” one of the two main categories of psalm (the other is “prayers”). In structure it ")]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("has many parallels in the book of Psalms. It begins with an exhortation of the psalmist to himself in the collective first person, “Let me …” (cf., e.g., Ps 101:1). It switches from hymnic celebration of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", who is spoken of in the third person in vv. 1–5 and in the conclusion in v. 18, to direct address of God in the second person in the thanksgiving of vv. 6–17 (cf. the structure of, e.g., Psalm 48). From beginning to end there are many other coincidences with the language of the psalter; for example, v. 2a is the same as Ps 118:14; for v. 2b and v. 18 cf. Ps 145:1–2.")])]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The reflection of the language of the Jerusalem prophet Isaiah is equally striking. For example, the same exhortation in the first person as in 15:1 is used in Isa 5:1; v. 2a is also found in Isa 12:2b; and “majesty” (v. 7) is a term for God in Isa 2:10, 19, and 21.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These coincidences in form and language with expressions of the Jerusalem tradition of theology cannot be accidental. This theology is the “Melchizedek” tradition (cf. Gen 14:18–20; Ps 110:4) of the priest-kings of God Most High of pre-Israelite Jerusalem, which was polemically adopted by David and the Davidic house after their conquest of Jerusalem and provided the theological basis of their rule: David is the priest-king of God Most High now equated with the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The adoption of this Jerusalemite tradition of theology provided massive resources for the development of a creative apologetic response to the challenge and threat of the rival theological systems of the indigenous Canaanites. Language echoing the mythologies of ancient Canaan sounds through the Song: the conflict between Baal and Sea, for instance, and the recognition of the kingship of the victorious God through the exposure of the powerlessness of his rivals. It is through the appropriation of such language and concepts that the themes of the universal sovereignty of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" (15:5, 8b), the incomparability of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" among the gods (v. 11), and the eternal reign of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" (v. 18) are here developed. The power of God to control the forces of creation is equally in evidence in imposing order among the nations. It is thus entirely appropriate that this vocabulary is used here in the context of another challenge and threat: the encounter of Israel and her God with Egypt and her gods.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is equally appropriate that this Song was, in all likelihood, already present in the older version, for this older, Deuteronomistic version was composed in all probability during the unparalleled crisis of the Babylonian exile, the time of gathering of traditions and the reconstruction of religious life in encounter with yet another rival theological system. The end of 15:1 reflects the view of Deut 11:4; the term “Red Sea” is used for the location of the crossing in v. 4 (cf. the discussion of the route of the exodus in 12:37–42); there is further use of the vocabulary of the crossing of the Jordan in the Deuteronomistic History in Joshua 3–4 in v. 8 (the “heap” in which the waters of the Sea stood up echoes Josh 3:13, 16; cf. 14:21, 26).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But that version is now placed within a framework supplied by the later edition: v. 19 as a summary ties the song into its context by picking up the vocabulary of ch. 14 (for v. 19b cf. 14:22, 29). Thus traditional ideas of the cosmic reign of God exploited in the older version are developed wholly congenially in the final edition.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In a subsection (15:20–21) the traditional role of women as those who greet the returning victorious army with tambourines, dancing, and song (cf. 1 Sam 18:6) is recalled. Miriam, identified here as Aaron’s sister (not Moses’, perhaps because of their similar public functions; cf. their collusion against Moses in Num 12:1), is called a “prophetess” for the only time, somewhat as in 1 Chr 25:1 the musicians in the temple are said “to prophesy.” This “prophecy” is no longer the prediction of the impending act of God, as among the “classical prophets” of the HB, but the celebration in hymn of eternally valid theological truth. The first line of Moses’ and Israel’s song is cited, but with one modification: as sung by leaders of public praise, the first word is now turned into an imperative, “Sing to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Israel’s Journey to the Mountain of God (15:22–18:27)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("In this section (which the MT divides into no fewer than ten subsections) on the route which Israel follows from the Sea to the Mountain, the final edition has performed one of the most radical reinterpretations in the whole book (see already on 12:37–42). The names of the main stopping places in this section (Marah, Elim, Sin, and Rephidim) correspond to the summary of the route through the wilderness in the final edition of the Pentateuch in Num 33:8–14. None of these names occurs in the reminiscence in Deuteronomy and, therefore, in all probability in the underlying version in Exodus which that reminiscence presupposes. The striking exception is Massah-Meribah in 17:1–7; it, by contrast, is not listed in Numbers 33 but does appear in Deuteronomy (esp. 9:22). But, highly significantly, in Deuteronomy Massah-Meribah features in the journey "), _c('i', [_vm._v("after")]), _vm._v(" the departure from the Mountain, not, as here, "), _c('i', [_vm._v("before")]), _vm._v(" the arrival at it. The explanation for this occurrence in Exodus of a place name peculiar to Deuteronomy but misplaced according to Deuteronomy can only be that the final editor has incorporated the Massah-Meribah narrative from the older version but has for his own reasons transposed it into a new setting.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The timescales in the older version and in the final edition are equally distinctive. Whereas for the older version Israel departs immediately after the deliverance at the Red Sea for the Mountain of God to arrive there on the third day (cf. Exod 3:18) within the “octave” of the Passover, in the later edition the journey from the Sea to the Mountain is to last at least six weeks (cf. 19:1), thus bringing the arrival at the Mountain and the associated revelation of the law within the ambit of the feast of Weeks (Pentecost). Appropriately, then, the festival of Weeks becomes in later Judaism (and perhaps already in the mind of the final editor here) the occasion for the celebration of the revelation of the law.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("Thus, apart from the opening of 15:22, the entire narrative down to 19:2a is, on grounds of route and time ")]), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("scale, the work of the final editor. But that does not mean that he has not made use of materials in the older version. Chief among these reused passages is the incident at Massah-Meribah, just mentioned, in 17:1–7 (others will be noted below). In the light of the evidence of Deut 9:22, that incident occurred originally in the older version between the corresponding narratives of events at the other two places mentioned in that text, Taberah and Kibrothhattaavah, that is, between Num 11:1–3 and Num 11:4–35.")])]), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The final editor has transposed this Massah-Meribah narrative to its present position for a number of reasons. As has been noted, for the final editor the primary covenant is that with the patriarchs (see on 6:4). The events at Sinai (his term for the Mountain, as opposed to “Horeb” in the older version) thus concern, above all, the revelation of Torah. It is this view of the centrality of the Torah that leads him to construct the vast narrative of the revelation of the law at Sinai, with its distinctive chronology, in Exod 19:1–Num 10:28, which, apart from materials in Exod 19–24 and 31:18–34:29, incorporated from the older version, to be noted below, belongs wholly to him. This centrality of the law is matched by symmetry in the narrative. Thus incidents appear to be repeated on each side of this huge Sinai narrative: the gift of manna and quails (Exodus 16, repeated in Num 11:4–34), the striking of water from the rock at Meribah (Exod 17:1–7, repeated in Num 20:7–13), and the deliverance from the Amalekites (Exod 17:8–16, repeated in Num 21:1–3).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The transposition of the Massah-Meribah material is part of this construction. Its particular function is to show how, right from the start of the wilderness wandering, Israel, despite God’s promises in the covenant with the patriarchs, has been a rebellious people (contrast the older version where the first open rebellion is the golden calf incident in ch. 32, as in the reminiscence of Moses in Deut 9:7–10:11). As a rebellious people, Israel is, thus, from the beginning in constant need of law for control and discipline, and of appropriate officers of the law. A hierarchy of leadership becomes pronounced: no longer is it Moses the mediator on the one side and Aaron and the people on the other, as in the older version; now the figures of Hur (17:10; 24:14) and the seventy elders (cf. 24:1, 9), who are appointed to act as judges and marshals of the people (18:21), make their appearance alongside Aaron.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The reason for the sequence of events in 15:22–18:27, in the form in which the narrative has left the hand of the final editor, now becomes clear. Despite the unwavering zeal of God (symbolized in this section above all by the “glory” of God in the cloud, 16:10) to fulfill the terms of his covenant with the patriarchs, Israel constantly threatens to fall away in revolt against the arduous route on which it is being led. There is a recurrent pattern of adversity encountered, complaint and rebellion by Israel, and gracious provision by God, not just of the outward necessities of life but also of the most basic necessity of all, the Torah.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This pattern is set in the first incident (15:22b–26): the “three days’ journey” brings Israel not on a pilgrimage festival to the Mountain of God (as projected in the older version) but to Marah (“bitterness”). There the people “complain,” and God “tests” them. The bitter waters of Marah, themselves turned sweet, are then followed by the sweet waters of the oasis at Elim (“big trees”; 15:27).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The journey to the Wilderness of Sin continues the pattern (ch. 16; “Sin” is a geographical location of uncertain meaning, cf. Ezek 30:15–16; the intervening stage of the Red Sea of Num 33:10 is here omitted in deference to the older version’s handling of that already in 13:18; 15:4, 22). It immediately provokes another crisis of complaint, this time about food, and another “testing” of the people. The theological factor is pointed up by the date (16:1); this is the day after the Second Passover, legislated for in Num 9:9–14. Even the gift of manna is met by disobedience (it is as beside the point to attempt a materialistic identification of this miraculous “food of angels,” which according to ch. 16 melts in the heat of the sun yet can be baked, boiled, stored, and breed maggots, with, for example, the honey dew of the tamarisk, as it is to attempt rationalistic historical and geographical reconstructions of Israel’s exodus and route through the wilderness).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The arrival at Rephidim (17:1–7) heralds yet another bout of strife: this time it is the people who put the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" to the test (the integration of material from the older version is indicated by the all-too-appropriate alternative names: Rephidim, “food stores,” becomes Massah, “testing,” and Meribah, “strife”).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("That God is trustworthy not only in the provision of food and drink but also in the defense of his people from their enemies is demonstrated in the following incident, Israel’s victory over the nomads of the Negev, the Amalekites (17:8–16; again there is incorporation of older materials; this incident is in part the narrative counterpart of the legislation in Deut 25:17–19; cf. 1 Sam 15:2).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But the fundamental element in this cycle of narratives in the final edition is the place of the law. The complaint at Marah is met by a promulgation of “statute and ordinance” (15:25)—that combination of capital offenses and civil law which makes up the standard Israelite law code. In contrast to the lightning march of the older version (cf. 19:4), the laborious trek through the wilderness of the final edition requires a framework of law, even in advance of the definitive promulgation of the law to come at Sinai (the pronounced Deuteronomic language of 15:25b–26 suggests that the final editor may, indeed, have developed the episode on the basis of material originally located at Horeb). A similar stress on Torah, this time in connection with the law of the sabbath in anticipation of the Decalogue in 20:8–11, appears in 16:4–5, 22–30.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("The need for Torah-based order within the community has, finally, prompted the transposition of the Jethro material in ch. 18, which includes the advice that Moses should appoint judges (18:13–27). According to the version of these events in Deut 1:6–18, the appointment of judges did not take place on the eve of arrival at the Mountain of God, as in the present text of Exodus, but on the eve of departure from the Mountain. The narrative matching Deut 1:6–18 is now contained in Num 11:11–17, 24–30. In the light of that evidence it is likely that the final editor has, once again, transposed a text which in the earlier version stood after the Mountain to before the Mountain (in the older version the story of the arrival of ")]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("Jethro now in Exod 18:1–12 was probably thus in immediate connection with the note on Jethro’s son Hobab in Num 10:29). The reason for the transposition is clear: during Moses’ protracted absence on the Mountain to receive the revelation of the tabernacle (chs. 25–31), it is essential that there should be available authorized personnel to arbitrate in all disputes (cf. 24:14 with reference to the judges now appointed in 18:13–27).")])]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_vm._v("God’s Revelation of Himself at the Mountain (19:1–25; 20:18–21)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The “Ten Commandments”—better “Ten Words” or “Decalogue,” as I will argue below—constitute the central revelation at the Mountain of God (20:1–17). That revelation is framed by a narrative with matching elements: 20:18–21 reflect the vocabulary and correspond to the presentation of 19:16, 17, 19. It is appropriate, therefore, to consider this narrative framework before looking at the Decalogue itself.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Two conceptions of how events at the Mountain of God are to be understood have already been foreshadowed in the story of the journey to the Mountain in 15:22–18:27. These views are combined in the narrative of events at the Mountain itself.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the final edition, Sinai, the Mountain of God, marks the twelfth stage of the journey through the wilderness (Num 33:1–15). Arrival at Sinai falls within the ambit of the feast of Weeks (NT “Pentecost”; this passage is central to the understanding of Acts 2), six weeks and more after the exodus (19:1–2a). The rebellious attitude of the people during the march is now matched by the threat of disruptive behavior at the Mountain: Sinai, on which God descends in theophanic fire (19:18), has to be fenced around lest, inquisitive and unconsecrated, the people break through into the realm of the holy to their destruction (19:12–13, 20–25). There is a strict hierarchy of personnel: Moses at the apex of the Mountain, with Aaron in attendance (the status of the priesthood as a whole is recognized in 19:22; cf. ch. 29), while the people have to be rigorously excluded at the base of the mountain. The elders interposing as representatives of the people (19:7; cf. 18:13–27) may belong to the same scenario.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In this final edition, the focus of interest is the revelation of the law, first and foremost the Decalogue seemingly revealed to Moses on the mountaintop and thence relayed by him to the people (there is an awkward transition in the text as it stands between the newer edition in 19:25 and the older version in 20:1; the text now runs: “Moses went down to the people and said to them, ‘God has spoken all these words …’ ”).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the older version events unfold as in Deuteronomy (cf. Deut 4:9–40; 5:2–33). The arrival at the Mountain, named Horeb in 17:6, takes place within the ambit of a one-night-plus-seven-day feast of Passover (cf. Deut 16:1–8). After the night of the exodus, a direct journey of three days (reflected here in the metaphor of the speed and power of eagles’ flight, Exod 19:4; cf. Deut 32:11) has brought Israel to the Mountain. Three further days of consecration (Exod 19:10, 15, 16) culminate in the revelation of the Decalogue on the sixth day. This revelation is directly in the sight and hearing of the people (Exod 19:19; 20:18). Overwhelmed by the awe-inspiring theophany, the people retreat in terror and ask Moses to continue alone as the mediator of the terms of the covenant (Exod 20:19). The following night Moses receives the “book of the covenant” (Exod 20:22–23:33), in which the terms of the covenant focused in the Decalogue are to be spelled out, and on the basis of which the covenant is to be concluded on the morning of the seventh day (Exod 24:4). For the older version the focus of the narrative is, thus, the sealing of the covenant (Exod 19:5), which is to be brought to its conclusion in Exod 24:3–8.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The sounding of the trumpet (19:16, 19; 20:18) is a significant detail in this older presentation: according to Joel 2:15, the blowing of the trumpet is a summons to a “solemn assembly,” a rare term similar to that used for the seventh day of Passover in Deut 16:8.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The divine speech in 19:4–6 provides a summary of the covenant: the relationship it presupposes, its terms, and its desired result. All is based on the prior action of God as deliverer and initiator of the relationship (v. 4). The consequences (“Now therefore,” v. 5) for Israel are obedience and observance of the terms of the covenant (in essence, the Decalogue, about to be revealed in 20:1–17, which is itself termed “the covenant” in Deut 4:13). If these conditions are fulfilled, then Israel will receive special status: out of all the nations of the world they will be chosen as God’s “treasured possession” (the word recurs in Eccl 2:8; 1 Chr 29:3 of royal treasures), “a kingdom.” The special qualities of that kingdom are indicated by the epithet “priestly” and the parallel phrase “a holy nation.” There is no stress on hierarchy within Israel; Israel as such is chosen and consecrated to enjoy access to God and to discharge a priestly function on behalf of the nations of the world. It is not the relationship with God that is conditional (he has already “brought them to himself”; he is bound to them as a father to his firstborn, just as God is bound to the rest of the human race in Adam, as the same writer, in all probability, is saying in Genesis 2–3); it is their ability to enjoy their status and to discharge the function for which they have been elected that is conditional on their obedience to the terms of the covenant.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The response of the people to God’s opening overture about the covenant is readiness and willingness (19:8), as it has been consistently in the older version (despite moments of despair, 5:21; 14:11–12). This willing response is matched by the terror with which they appropriately react to the experience of the overwhelming self-manifestation of God (19:16, 17). As the sequel to the older version in 20:18–21 makes clear, so far from being tempted to break through to gaze upon God, the people recoil in fear. Their positive response is motivated and maintained by the direct, personal experience of God’s self-disclosure. It is their own encounter with the awesome majesty of God, which can never be erased from their memory, that is designed to ensure that they will never fall away (20:20).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("The fundamental significance of the Decalogue in the covenant relationship between God and his people is thus demonstrated by the fact that it alone of all the ")]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("terms of the covenant is communicated to Moses in the hearing of the people (19:9; for the motif of the consequent confirmation of belief in Moses cf. 4:1–9; 14:31).")])]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_vm._v("The Decalogue (20:1–17)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("“Decalogue” is the better translation of the phrase “the ten words,” which Deuteronomy (e.g., Deut 4:13) and the literature related to it customarily use, than the conventional “Ten Commandments.” It also guards against a serious distortion: the equally conventional view is that the Decalogue is a list of “Thou shalt nots” (and there have been scholarly attempts to “recover” such a stereotyped pattern throughout the ten), a series of prohibitions defining basic human duty. But it must be emphasized, in line with the summary of the covenant in 19:4–6, that the first “word” (v. 2, which in Jewish tradition is included within the first “commandment”) begins with a statement about the being and action of God, not about human duty. “The indicative of grace precedes the imperative of law” (cf. Barth, "), _c('i', [_vm._v("CD")]), _vm._v(", IV/1, 424).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Much scholarly effort has been expended in the endeavor to date the Decalogue. Comparisons have been made, for instance, with the form of vassal treaties current in the ancient Near East. On the basis of the internal evidence of the addressee in the kind of society envisaged—the male head of the household of the middle generation who has both elderly parents to care for and sons and daughters to bring up, and who is a well-set-up farmer with ox and donkey and even slaves and can provide hospitality for strangers—it is argued that a postconquest date must be sought. Given that there is no mention of a king or of temple worship, it may be assumed to have arisen in premonarchical times. These arguments are not without validity.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The view taken here, however, as throughout this commentary on Exodus, is that more certain results can be obtained by asking when and how the text functioned than when and how it arose. The text of the Decalogue, as of the remainder of Exodus, is a laminate made up of an older version still preserved in Deut 5:6–21 and a reedited final edition. As both an “exilic” and “postexilic” text, then, it presents an ideal of Israelite society in terms of an idyllic past of rural self-sufficiency. There are no poor, for instance, to support (cf. Deut 15:4), for according to this ideal everyone has a place in the community within the family, whether relative or dependent, and each family has the necessary land to ensure its support. There is here both pathos and eschatological hope: the irony that the “ten words” achieve currency in an exilic context of dispossession, and the hope that one day the ideal, with whatever transmutations, will become real.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I do not deny that each of these “words” may—must—have had a long prehistory (there is evidence of analogous collections in, e.g., Hos 4:1–2, 12). But I suggest that they are indeed intended to be the essential digest of Israel’s belief (cf. their distinctive character as those directly revealed in the hearing of the people, 19:9; their special status as written “by the finger of God,” 31:18, as opposed to the following “book of the covenant,” mediated and written by Moses, 24:4). As such they are a selection of much wider available materials, deliberately generalized, and worn so smooth by use that it is impossible to get a hold of their date of origin.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Everything depends on the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s Name, his revealed nature as in 3:14–15. The opening clauses of the Decalogue outline the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s prerogatives by virtue of who he is and what he has done, as expounded in the whole narrative of Exodus up to this point: the recognition that he alone is God; his jealous zeal for his people that can brook no rival or alternative system, portrayal or concept; his claim on the exclusive worship of his people; and the absolute demand that this Name not be misused for any purpose, whether in blasphemy against himself or in perjury or curse against a fellow member of the community.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The major difference (there are more than a score) between the older version of the Decalogue still extant in Deuteronomy and the later edition of it in Exodus concerns the reason for observing the weekly sabbath. In Deuteronomy it is the celebration of liberation from slavery in Egypt and an anticipatory sharing in ultimate liberation from all slavery. In the final edition of Exodus, in line with the cosmic dimension already noted in connection with Aaron’s confrontation with the Egyptian magicians (7:9–12) and the drowning of the Egyptians in the Nile (14:30), it refers to the creation narrative in Gen 1:1–2:4a. It is a celebration of God’s work as creator and invites participation in the beauty and order of his finished creative work. Here, too, there is an eschatological dimension.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There are, indeed, some puzzling features in the Decalogue; for example, God himself is the speaker only for vv. 2–6; where is the division between the two tables (a question which in part motivates the search for ten short prohibitions): does duty to parents (v. 12, the “fifth commandment,” and the second following the two positively formulated commands which lay down absolute obligations) fall in the first section, among the duties toward God, or in the second, among those toward humanity?")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("In particular, what is the purpose of the “eighth commandment,” “You shall not steal,” if in the “tenth” even the underlying motivation to steal is forbidden? The suggestion that “steal” has here the sense of “kidnap,” as in 21:16, has much to commend it. In that case, the last five clauses have to do with the (ideal) protection of the life (but “kill” is restricted here to “murder” and does not include killing as an inevitable consequence of war [cf. 30:11–16] or the death penalty; cf. the capital offenses in the Book of the Covenant), marriage, freedom, justice, and property of the fellow Israelite. These are all the gifts of the freeborn individual, which have, indeed, been provided by God by his action in liberating his people from slavery. An alternative suggestion is that the “tenth commandment” is aimed at those who would misuse the legal system to misappropriate the possessions of others, a particularly lively issue during the exile (cf. Ezek 11:15; 33:24); in other words, the “eighth commandment” simply deals with the isolated offense (cf. the similar overlap between the “seventh commandment” on adultery and the “tenth”). Perhaps these alternative possibilities simply ")]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("underline the fact that the Decalogue expresses principles applicable in a great variety of circumstances.")])]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_vm._v("The Book of the Covenant (20:22–23:33)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The Decalogue is the statement of the fundamental duties which the responsible householder owes toward God, family, and community. But as it stands in the present combined text of Exodus, which dates from periods of profound social dislocation, it looks forward to the realization of hopes for the future that are expressed in terms of the recreation of the idealized, self-sufficient rural communities of the past.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Within this context the Book of the Covenant (“B”; 20:22–23:33) happily finds its place. At its heart lies a law code. As a digest of Israel’s civil and criminal law, dating back no doubt to the origins of the community, it reflects a long history of ancient Near Eastern law, as studies comparing and contrasting it with the practice of ancient Israel’s neighbors demonstrate. This ancient practice, reflecting much the same rural society as the Decalogue, provides Israel with a stock of ideas and vocabulary to express its expectations for the future.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The name “Book of the Covenant” derives from Exod 24:7: it is the document, received by Moses alone overnight after the Decalogue had been revealed in the sight and hearing of the whole community, on the basis of which the covenant between the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" and Israel was made.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The structure of the work reflects its purpose. Its core (21:1–22:20) is made up of two varieties of law set forth in four blocks in alternating sequence. This core is set within a covenantal framework, 20:22–26; 22:21–23:19. The whole is rounded off with an exhortation, 23:20–33.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The core contains “statutes” and “ordinances.” The “ordinances” are set forth in the two blocks 21:1–11; 21:18–22:17. Their title, “ordinances,” is supplied by 21:1. The word implies “usual practice” (e.g., in Jer 30:18 it is used in concrete terms of the “customary location” on which fortresses will be rebuilt); that is, it is case law based on precedent. The “customary way” of dealing with a wide variety of issues is listed: slavery for debt; compensation for injuries inflicted on freeman, slave, and pregnant woman, issuing in the principle of “like for like” (“an eye for an eye,” etc., interpreted in Jewish tradition as commutable into monetary payment); damages for injuries caused by a goring ox or an open cistern; penalties for theft, destruction of crops by grazing or fire, stolen or damaged deposits, and fornication. The arbitration of the court, presumably “the elders in the gate,” is alluded to in 21:22 (cf. the assessment of damages implied in 21:30, 34, 36).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A different variety of law is to be found in two blocks of material relating to capital offenses (21:12–17; 22:18–20). It may be assumed that the term “statutes” applies to these laws (cf. the Hebrew for “law code,” “statute and ordinance,” as in 15:25). The cases dealt with cover murder (carefully distinguished from homicide), injury to parents, kidnapping, cursing of parents, sorcery, bestiality, and sacrificing to any god other than the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This combined law code of “statutes and ordinances” is, however, set within the framework of a covenant document. There are essential differences in form and content between a law code and the code of a covenant between God and Israel. In form the outer framework is cast into second-person address, “You shall …,” as opposed to the law code in 21:1–22:20, which is almost uniformly expressed in the objective third person, “when someone …,” or “anyone who.…” The exceptions in the law code to this form of address in 20:2 and 21:18, where the second person “you” is used, make the point: these verses at the outer edges of the law code show how the law code as a whole has been taken up into the covenant code with consequent changes in its formulation into second-person address.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There is also a striking difference in content: in the law code, especially in the “ordinances,” God, if he figures at all, appears only as a sanction to enforce observance (“God” in 21:6; 22:8–9 should probably be translated “judges,” as in Jewish tradition, e.g., "), _c('i', [_vm._v("m. "), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("Aboth")]), _vm._v(" 3:6; cf. the plural verb at the end of 22:9). The only explicit reference to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" in the “statutes” is in 22:20, precisely at the point of transition to the second-person covenantal framework. The law code is the immemorial practice of the community and governs human relations within it (cf. the “second table” of the Decalogue, where God is not mentioned). By contrast, in the framework God addresses Israel (through Moses as his spokesman). It begins and ends with the obligations of Israel in their personal relationship with the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" as worshipers (cf., in both form and content, the opening of the “first table” of the Decalogue, where God is speaker). Thus the instructions for the building of the altar for sacrifice at the beginning in 20:22–26 are matched by instructions for worship in 23:10–19.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But, once again, at the edges of the material there is a merging of form and content. The closing framework element (22:21–23:19) is laid out in four blocks arranged by content, again in alternating sequence, and has to do with obligations to fellow Israelites (22:21–27, the care of the vulnerable within society, the sojourner, widow, orphan, debtor, and borrower; 23:1–9, the practice of justice, enfolding humanitarian concern for the animals owned even by an enemy; 23:9, virtually repeating 22:21, forms a bracket around this material) and to God (22:28–30, suitable to the theme of the whole book including the obligation to offer firstfruits and firstlings; 23:10–19, the observance of sabbatical year, sabbath, exclusive worship, and festivals). The obligations to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" are thus integrated with the obligations to fellow members of the community which he has created. In form these “commands” represent the casting into second-person address of the third-person legal “statute” (e.g., 22:21–23) and “ordinance” (e.g., 22:25–26).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A striking feature of this framework is the addition of reasons for carrying out these obligations, typically appealing to the theme of the whole book, the exodus from Egypt (22:21; 23:9, 15; others are given a humanitarian as well as a theological motive, 22:27; 23:7; and still others are more general, 20:25; 23:8; contrast the body of the law code where only once is such a reason given, and that a purely rational one, 21:21).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("It is notable that the code at the heart of Deuteronomy (Deuteronomy 12–26) is the other main collection of “statutes and ordinances” in the HB (Deut 12:1), where third-person law is cast in the form of second-person covenantal address, and where the reason given for observing individual stipulations typically has to do with God’s saving acts on behalf of his people, not least their deliverance from Egypt (e.g., Deut 15:15). The law code in Exodus is thus cast by its framework into the same kind of covenant code as is to be found in Deuteronomy. Once again, then, the coincidence of material in Exodus with that in Deuteronomy is striking and justifies the conclusion that the older version of Exodus included B and can appropriately be called “Deuteronomic.”")])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The relation between B in its present form and the Deuteronomistic History (Joshua–2 Kings) is made even clearer in the peroration to B in 23:20–33. At the end of other codes, promises of blessing and threats of curse appear as inducements and sanctions to encourage observance of the terms of the code; this is notably the case in Deut 27:11–28:68 and Lev 26:3–45. In the conclusion of B, the blessing constitutes by far the greater proportion (cf. the presentation of Israel in the older version of Exodus as still responsive to God’s action); warnings appear only in vv. 21, 24, 32, and 33. The promise in particular is of an “angel” (cf. 3:2; 33:2) to go before Israel to guide it on the way to the promised land and to lead it in its conquest. This angelic figure must relate to the “pillar of cloud by day and of fire by night” which leads them on the way in 13:21 and which in turn is associated with the tent of meeting and the ark of the covenant (33:7–11; Num 10:33–36; cf. the association here with the name of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", v. 22; cf. 3:15). The condition put upon this promise of blessing is that Israel will be obedient to the guidance of this angel (for what that obedience means compare v. 24 with the Decalogue, 20:5). It is significant that this same angelic figure reappears in Judg 2:1–5 at the end of the narrative of the conquest of the promised land, thus providing a further link between the older version of Exodus and the Deuteronomistic History (cf. the link between Exod 1:11 and the portrayal of Solomon in 1 Kgs 9:19, the burial of the bones of Joseph linking Exod 13:19 with Josh 24:32, and the golden calf incident in ch. 32 which anticipates 1 Kgs 12:28; the “hornet” in v. 28 here links with both Deut 7:20 [the NRSV renders “pestilence” in these two cases] and Josh 24:12; the account of the gradual conquest in vv. 29–30 relates to Deut 7:22; for the “Red Sea” [v. 31] cf. 13:18; for the “snare” in v. 33 cf. Deut 7:16). By the time of the stage indicated in Judg 2:1–5, Israel lies under the curse of the covenant that is to befall the people because of their disobedience, not under the blessing. Israel is to enter the promised land not in triumph but in tears.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Making of the Covenant (24:1–11)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This section well demonstrates the combination of the two versions of events running through Exodus. At its heart (24:3–8) lies the older, Deuteronomistic version: on this day, as commemorated in the “solemn assembly” on the last day of the Deuteronomic Passover (Deut 16:8), the covenant is made at the Mountain of God. The terms are spelled out in the “book of the covenant” (v. 7), comprising “statutes and ordinances” of the old Israelite law code, set within a covenantal framework, which is laid out in 20:22–23:33. As the Deuteronomic Passover is a “communion sacrifice,” so this covenant is now concluded by means of “whole burnt offerings and communion sacrifices.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The whole burnt offering, as its name implies, involves the burning of, essentially, the whole animal on the altar as an expression of total devotion to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" (for the method of offering this sacrifice, according, at least, to the later edition, see esp. Lev 1:2–13). The “communion sacrifice” fitly expresses the double bond implied in the covenant (for the method of offering this sacrifice, see Leviticus 3). On the one hand, it acknowledges the bond between God and his people. God himself has given his people their lives and everything which they possess, including the domestic animals from which the sacrificial victims are selected; the vital parts of the animal, especially the blood as its life force, are, therefore, returned in acknowledgment to God as the giver at the altar. As domestic animals, the victims belong, too, to the support system on which the people’s lives depend; the gracious acceptance by God of this offering is thus an expression of his favor toward them in every respect. On the other hand, the “communion sacrifice” also involves the sharing of the remainder of the animal in a meal with family and neighbor; it is thus an expression of solidarity within the community and a recognition of the reciprocal responsibilities of each for the others. The responsibilities toward God and humanity, focused in their essentials in the Decalogue and expounded at length in the Book of the Covenant, are thus sacramentally expressed in this sacrificial rite of the Passover.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("An additional sacramental act follows (24:8). In a rite unique in the HB, half of the blood of the sacrificial animals is sprinkled over the altar, which Moses constructs, and half over twelve stone pillars (the phrase “blood of the covenant” is equally unique). As the twelve pillars explicitly represent the twelve tribes of Israel, so, it may be presumed, the altar, the place and means whereby the physical offering is raised by the column of smoke into the heavens through the gift of fire upon the altar from God himself (cf. 1 Kgs 18:24), represents the gracious presence and response of God. Altar and pillars alike stand evermore as memorials and witnesses to the commitment of God and his people to each other.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("This version is complemented by the later edition (24:1–2, 9–11; cf. the counterpointing of “young men,” v. 5, and “elders,” vv. 1, 9). The hierarchy, so in evidence in 19:7, 21–25, reappears. Moses is accompanied by Aaron, the head-to-be of the family of priests (cf. 28:1–29:27), who is therefore now accompanied by his two older sons (6:23; cf. Num 3:2; in the Samaritan Version all four sons are included, perhaps correctly; the two mentioned here in the MT are soon to be removed for cultic malpractice, Lev 10:1). The people, immediately responsive and involved in 24:3–8 (cf. 24:3b, 7b with 19:8), are now, as in ch. ")]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("19, rigorously excluded from the proceedings; even their representative elders occupy a subordinate position.")])]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("There is now no mention of concluding a covenant; for the later edition, the covenant above all is that with the patriarchs (cf. 6:4). Rather, the experience is of the awesome transcendence of God which precisely requires the hierarchy of priest and elder in those who would approach him. It can hardly be God himself whom they see (24:10a); as the clarification in v. 10b makes clear, they can sense his presence only through the translucent blue vault of the heavens (for the description, cf. Ezek 1:26; 10:1). Nonetheless, the relationship God has with his people and the commitment God shows to them are expressed through the fact that these “chief men” of the community (the rather rare word "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("atsilim")]), _vm._v(" can hardly be separated from the verb from the same root of the “taking” of the spirit which attended the appointment of the seventy elders in Num 11:17) not only remain unscathed but share a meal (v. 11). The question in the forefront of these verses is the authority of those who will have to maintain good order within the community during the impending absence of Moses on the mountaintop to receive the laws in 25:1–31:17.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Breaking and Remaking of the Covenant (24:12–18; 31:18–34:35)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("In the remaining chapters of Exodus the final editor incorporates two very large additional passages (amounting to more than one third of the total book): specifications for the tabernacle (25:1–31:17) and its construction according to these specifications (chs. 35–40). When these large blocks are for the moment set aside, the remainder as defined in the title of this section bears a strong resemblance to the “reminiscence” in Moses’ speech in Deut 9:8–10:11. What the earlier version in Exodus at this point must have looked like can still be seen from a comparison of the present text with that passage in Deuteronomy. From that comparison the stress on covenant in the older version and the sometimes quite radical reconstructions of that version in the final edition, in its concern with the transcendence of God, the revelation of Torah, and the hierarchy within the community, can be all the more appreciated.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first part of this material, 24:12–18, sets the scene. The verses of the framework, vv. 12 and 18b, are virtually identical with Deut 9:9: the ascent of the Mountain by Moses to receive the stone tablets on which the Decalogue is to be inscribed by the finger of God (as stated in the immediate sequel in the original, 31:18 par. Deut 9:10) and his stay there for forty days and nights. It may be assumed that the version in Exodus would be slightly fuller than the reminiscence in Deuteronomy; thus v. 13, with its note that Moses is accompanied by Joshua (not Aaron!), though it has no parallel in Deut 9:9, must belong to the older version in view of the positive role of Joshua in the sequel (and the negative role of Aaron in ch. 32).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But the remainder of the passage has all the hallmarks of the later editor. True to his view that the fundamental covenant is that with the patriarchs (Exod 6:4), the note in Deut 9:9 that the tablets are “the tablets of the covenant” is suppressed in 24:12. Instead, in line with his view that the Mountain is the place of the revelation of law, he reads “the tablets of stone, and the Torah and the commandment,” all of which God now writes “to instruct them” (the verb “instruct” being from the same root as “Torah”). Equally, the preparations for the maintenance of good order within the community made in 18:13–27 are now put into effect during Moses’ absence (24:14; for Hur cf. 17:10).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Also characteristic of the final editor is the stress on the transcendence of God, termed here, as typically, “glory” (24:16, 17; cf. 16:7). This “glory,” now seen on top of Sinai (the final editor’s name for the Mountain), will hereafter fill the tabernacle (40:34). The term thus binds together the whole of this last part of the final edition of Exodus. Accordingly, in the final edition, after a time of preparation double that for the revelation of the Decalogue (24:16; cf. 19:10), the revelation of the specification of the tabernacle now follows in 25:1–31:17.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Meanwhile, as the reminiscence in Deut 9:10 indicates, the older version continues in 31:18. Once again the narrative in the older version is fuller than that provided in the reminiscence: the story of the golden calf, merely presupposed by Deut 9:12, is told in detail in 32:1–6 (its Deuteronomistic character is confirmed by the cross reference between v. 4b and 1 Kgs 12:28).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is now for the first time in that older narrative that Israel rebels. The direct experience of the awesome self-manifestation of God they have had in chs. 19–20 and the commitment they have given to the covenant in ch. 24 now count for nothing. On the disappearance of Moses on the Mountain, they appeal to Aaron to provide them with alternative gods. Their request, “make gods for us” (32:1), amounts to a comprehensive incrimination of themselves. It is a direct infringement of the opening terms of their covenant with the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" as expressed in both the Decalogue (20:3) and the Book of the Covenant (20:23). In their identification of Moses as the one “who brought us up out of the land of Egypt,” they deny the action of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" as expressed in the first “Word” of the Decalogue (20:2; the verb is the one used in 3:8). Their request for someone to lead them is a rejection of the promise of the guidance of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s angel in 23:20. It is thus grimly ironical that the verb in the phrase “they gathered around Aaron” in 32:1 comes from the same root as the word for “sacral assembly,” "), _c('i', [_vm._v("qahal")]), _vm._v(" (e.g., Deut 5:22; 10:4).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Their self-incrimination is compounded by the action of Aaron, who now, without the slightest demur despite his status as Moses’ spokesman to the community (4:16), becomes accessory to the revolt (32:2): the golden earrings melted down by Aaron could have been gained by these former slaves from the Egyptians only as part of their reparation for slavery, demanded precisely by the women and placed on their sons and daughters (3:22). They are the symbols, worn in every household, of the effectiveness of the “strong hand” of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" (3:19) by which he restored their independence.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("The golden calf which Aaron makes (32:4) is no doubt meant to be a compromise on his part. To the people these are new gods; the plural is used deliberately to echo ")]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("Jeroboam I’s “golden calves” in 1 Kgs 12:28. But Aaron attempts to integrate the calf into the worship of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", as probably Jeroboam also tries to do with equally disastrous results. Whole burnt offerings once brought in utter devotion to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" and communion sacrifices once celebrated as an expression of solidarity between the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" and his people (24:5) are now made to these vacuous “gods” of the people’s own invention. The bacchanalian revels implied by 32:6b reflect the licentious celebrations of the grape harvest at the New Year festival of the indigenous population of Canaan, as the parallel with 1 Kgs 12:32 suggests.")])]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The close parallels with the reminiscence in Deuteronomy resume in 32:7–10 (par. Deut 9:12–14). The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" himself now takes up the charge of ineffectualness against Moses: it is Moses’ people whom Moses has brought up who have quickly turned aside from the way of life marked by the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s commandments. Let the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" destroy them and make of Moses a new and greater people.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But thereafter the final editor intervenes with large-scale rearrangements of the older text as attested by Deuteronomy. The sequence of events in Deuteronomy from this point on (though its text has its own anticipations, resumptions, and editorial history) is coherent and logical. Moses now descends to see the full horror of the people’s apostasy (Deut 9:15–16). He breaks the tablets of the covenant he has received from the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" (9:17). Nonetheless, he returns to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" for a second forty-day-and-forty-night period to make intercession for the people (9:18–19, resumed in 9:25–29 and 10:10) and for Aaron (9:20), after grinding the golden calf to powder and casting its dust onto the stream flowing away from the Mountain. During this second period, Moses receives a copy of the tablets, makes an ark for them (10:1–4), and is bidden to arrange the departure from the Mountain (10:11). Accordingly, at the end of the period, Moses descends from the Mountain, deposits the tablets in the ark (10:5, doubtless in the tent of meeting), appoints the Levites as bearers of the ark (10:8–9), and, presumably, organizes the departure.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A text echoing this sequence of events, with typical Deuteronomistic amplifications, is discernible in Exodus. Moses descends from the Mountain with the tablets of the Decalogue in his hands (32:15–16). When he sees the full enormity of what the people are doing, he breaks the tablets (32:17–19). He grinds the golden calf to powder (32:20) and confronts Aaron with his complicity (32:21–24). He returns to the Mountain for a second forty-day-and-forty-night period for intercession for the people (32:30–31). God relents; new tablets are prepared (34:1, 4). Some Deuteronomistic additions follow. After a declaration by God of his Name and nature in terms reminiscent of the opening of the Decalogue (34:5–8), the covenant is remade (34:10). The exclusiveness of the covenant is underlined by the command to avoid any covenant with the indigenous population of the land of Canaan, particularly through marriage, since the marriage contract would involve recognition of the gods of Canaan (34:11–16). The fact that the covenant is being remade on the same terms as before is indicated not simply by the allusion to the Decalogue in 34:5–8, and again in v. 17, but also by the virtual repetition of the closing words of the covenant framework of the Book of the Covenant (34:18–26; cf. 23:12–19; the addition of legislation on the offering of the firstborn, 34:19–20, is particularly significant in view of the overall argument of the book of Exodus; cf. 4:22). As Moses wrote the original Book of the Covenant (24:4), so now he writes the Book of the Remade Covenant (34:27). After the delivery of the rewritten tablets of the Decalogue (34:28; written by God himself, as the parallel with Deut 10:4 makes clear), Moses descends to lead the people away from the Mountain (34:29). The departure from the Mountain toward the promised land would be the climax of the older version of Exodus.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But that clear Deuteronomic/Deuteronomistic text embedded in 31:18–34:29 has, as in 24:12–18 and earlier parts of the book, been closely edited, and in places radically rearranged, by the final editor for his own theological purposes. Given his starting point that the fundamental covenant is that with the patriarchs (6:4) and that Sinai—his term for the Mountain—is, therefore, primarily the place of the revelation of Torah, the tablets of the Decalogue are no longer called by the older version’s name, “tablets of the covenant,” but “tablets of the testimony” (31:18 par. Deut 9:10–11; so again 32:15 par. Deut 9:15; cf. 34:29 par. Deut 10:5). The tablets are now the objective attestation of the requirements of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" for his people; the covenant relationship itself has been established since Abraham. The final editor is concerned with the people’s process of “sanctification”; the miracle that they have been “justified,” brought into being by an act of free grace as God’s people, is taken for granted.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The final editor intervenes again in the golden calf incident, specifically in connection with Moses’ intercession. The substance of Moses’ prayer, as in Deut 9:25–29, which takes place at the beginning of the second period of forty days and nights, is now transposed to the end of the first period in Exod 32:11–14. This permits a quite new outcome to the beginning of the second period in 32:30–35: not that a greater people will be made out of the descendants of Moses but that a calamitous act of punishment will come upon the guilty people (32:35; words from the root “sent a plague on” have hitherto been used only of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s act against the Egyptians, 8:2; 9:14; 12:13).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("It is likely that the immediate act of punishment of the people by the Levites in 32:25–29 also arises from the work of the final editor. In Deut 10:8–9, and thus presumably in the older version in Exodus, the Levites are not appointed to office until the moment of departure from the Mountain, and then as bearers of the newly constructed ark and as officiants “before the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(",” which can only mean in a sanctuary, that is, in the equally new tent of meeting. Here a quite different context is given for the “ordination” of the Levites (the technical expression “fill the hand” is used in 32:29): the bloody punishment they unleash on the Israelites for their sin in constructing the golden calf. In the light of Deut 33:8–11 it is likely that this incident originally took place at Massah-Meribah (cf. v. 29 with Deut 33:9), that is, in the context of the incident which, I have argued, the later editor transposed into Exod 17:1–7 from its original context between Num 11:3 and 4 (cf. the acts of punishment of the people at the two other places mentioned in Numbers 11). ")]), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("The view that punishment immediately follows a crime is much in evidence in Chronicles, a work probably close in time and authorship to the final edition of Exodus.")])]), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Strikingly, the final editor has changed the significance of grinding the ashes of the golden calf to powder (Exod 32:20) from purification (as in Deut 9:21; cf. Deut 21:1–9) to incrimination (cf. Num 5:11–31).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the light of the reminiscence of Deut 10:1–11, it seems clear that the final editor has also transposed the material on the departure from the Mountain, already beginning in 32:34 and continued in 33:1–6, as well as Moses’ habitual practice of pitching the tent of meeting for the ark (33:7–11; obliquely referred to as “for it” [not overtly translated in the NRSV] in 33:7). In the Deuteronomic view all these actions can take place only after the renewal of the broken covenant and the remaking of the tablets of the Decalogue in 34:1–29. The reason for the final editor’s transposition of this material is surely clear. Given that he is about to introduce some forty-two new chapters on the construction of the tabernacle and on further revelations at Sinai (Exodus 35–Num 10:28), all within a new and quite extended chronology (Exod 40:17; Num 10:11), it is inappropriate that that material should be left in its original position between Exod 34:29 and its natural continuation in Num 10:29 (including also, as already argued, Exod 18:1–12).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A major difference, reflected in these radical transpositions, between the older version and the newer edition concerns the nature and purpose of the sanctuary. The tent of meeting of the older version, spoken of in 33:7–11, conforms to the Deuteronomic picture of the sanctuary, served by Joshua and the Levites, which goes ahead of Israel and functions as a guide through the wilderness (cf. Deut 31:14–15). It is related to the promise of the presence of God, as the guiding angel and the pillar of cloud by day and of fire by night (cf. 13:21–22). The name “tent of meeting” indicates that it is there that the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" meets with Moses and “speaks to him face to face, as one speaks to a friend” (33:11; cf. Deut 5:4; 34:10). As we shall see in the final section on the tabernacle, the final editor has a quite different view of the institution. It is given the name “the tabernacle” (lit. “the dwelling place”). While the final editor relates the name “tent of meeting” to “tabernacle” (e.g., 27:21) and thus integrates the two structures, he locates it not in the van of the camp of Israel but at its center. Its function is, above all, to be the place of continuing revelation of Torah and of the altar of the sacrificial cult (cf., e.g., Lev 1:1).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Because of these different views, two questions call for clarification in the final edition in 33:12–23: the nature of the presence of God, and the nature of Moses’ encounter with God. 33:12–19 anticipates and qualifies the vocabulary of 34:6, 9. The passage makes it unambiguously plain that it is “the presence” of God himself who accompanies his people (33:14), soon to be termed his “glory” (33:18) or his “goodness” (33:19). But, in qualification of 33:11, the nature of Moses’ encounter with God is not that he speaks with him “face to face,” for no man can bear to see the full “glory” of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" (33:21–22). Rather, even Moses must be shielded and, at most, can only see “God’s back” (33:22–23).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These transpositions and qualifications caused by the different point of view of the final editor are matched by two adjustments in ch. 34. In 34:1–4, as the comparison with Deut 10:1–3 shows, he edits out the mention of the ark made by Moses in the second period of forty days and nights on the Mountain. The reason for this change is also clear: as we will again see in the final section, he has already introduced the specifications for the ark (now termed, from his viewpoint, “the ark of the testimony”; cf. 31:18; 32:15) in 25:10–22 and is about to record its construction in 37:1–9. It is therefore inappropriate to speak of it in this context. Instead, he replaces it with material on the transcendence of God and the sacredness of Sinai (34:2–3; cf. 19:12–13, 20–25).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In 34:29–35 the status of Moses as a recipient of revelation is further discussed in line with 33:18–23. Moses does not descend, as in Deut 10:11, to lead Israel away from the Mountain; rather, this descent from Sinai is but the epitome of continual “comings out” from the presence of God (34:34). Even if Moses is not permitted to see the “face of God,” his full “glory,” yet the modified encounter with the presence of God is enough to make Moses’ own face shine with a splendor that the Israelites cannot bear to look upon. Thus, after imparting the teaching to them with this reflection of divine authority physically imprinted on his face, Moses is obliged to cover this supernatural brightness with a veil.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Construction of the Tabernacle (25:1–31:17; 35:1–40:38)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The surpassing climax of the final edition, as the sheer volume of material makes clear, is the construction of the tabernacle. The presentation is in two roughly matching parts: the revelation of the heavenly blueprint in 25:1–31:17; and the account of the construction of the tabernacle in accordance with this blueprint, and its dedication, in chs. 35–40. The purpose of Moses’ stay on the Mountain for forty days and nights is now to receive not just the written Decalogue, as in 24:18; 31:18, the verses from the older version immediately framing the first of these two sections (though that is still part of the reason, 25:16), but also the revelation of the mode in which God will reside with his people (the verb “dwell” occurs already in the first section in 25:8 and in the last section in 40:35—and at 29:45–46; “tabernacle” itself ["), _c('i', [_vm._v("mishkan")]), _vm._v("], which is named first in 25:9 and fifty-six times in Exodus thereafter, has the same root as the verb “to dwell”).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("The complementary interests of the two versions of Exodus are, once again, expressed, now through their respective concepts of the sanctuary. The older version (33:7–11) has spoken of the “tent of meeting,” the movable structure pitched outside the camp where God descends in the pillar of cloud to give Moses guidance through the wilderness. There the two “tablets of the covenant” are lodged in the “ark of the covenant.” In the final edition, the sanctuary is termed the “tabernacle.” It is still a movable structure, but it is now pitched in the middle of the camp and is to be the place which the “glory” of God is to fill. In its most holy inner sanctuary it still houses the ")]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("“ark” with the tablets; but that ark is now called “the ark of the testimony” (e.g., 26:33), and the tablets are “the tablets of the testimony” (cf. the final editor’s adjustment of 31:18; 32:15). The covenantal relationship between God and his people is taken as given (6:4); what is now required is the sanctification of the people through obedience to the terms of the law, the objective “testimony” of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s will to Israel, so that God may continue to dwell in their midst. The ark now has the added significance of being the “mercy seat” (e.g., 25:17), the covering of the ark where annually the rites of the Day of Atonement are to be observed (Leviticus 16) and where, uniquely, revelation is to continue to Moses (25:22; the verb “I shall meet [with you]” is from the same root as the noun “meeting” in “tent of meeting”).")])]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The complementary character of these two views of the nature and purpose of the sanctuary is indicated by the integration of these two structures and their names in the final edition (e.g., 39:32). The “tent of meeting” is incorporated within the “tabernacle” (the whole structure of shrine plus surrounding court is termed the “tabernacle”; cf., e.g., 27:9; 40:33); sometimes that term is used for the shrine proper (e.g., 26:1), and sometimes the shrine proper is called by the old name, “tent of meeting” (e.g., 27:21; the secondary covering of the shrine, also called “tent,” e.g., 26:7; 40:19, is not to be confused with the tent of meeting). The “corporate identity” of the shrine as the “tent of meeting” is retained; but the physical structure, with a whole new range of significance, is now the “tabernacle” (e.g., 40:22). The older version’s “cloud” of theophany and the final edition’s “glory” of God’s indwelling presence are equally combined at the climax of the book (40:34–38).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The tabernacle is not the end in itself; it is the means to the end. As such, it must be entirely appropriate for its purpose. For this reason the heavenly origin of the blueprint (“pattern,” 25:9[twice], 40) and the carrying out of that revelation in precise terms are stressed by means of the large-scale “repetition” between the two sections, especially as regards specifications of the structure and its furnishings. There must be an absolute correspondence between the heavenly and the earthly. The tabernacle is, so to speak, a “sacramental” structure: it is the “outward and visible sign” in the physical world of transcendental realities; it is “the means of grace” by which access to these realities is enabled and participation in them granted to God’s people.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A table is perhaps the most convenient way of giving a bird’s-eye view of these complicated materials and of the relationship between specification and execution.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The specifications of the tabernacle are laid out in the MT in 25:1–31:17 in ten main sections, which are used as the baseline here; the parallels in the account of the execution in 35:1–40:38 are noted alongside (these show at times a quite different order, to be commented on below):")]), _vm._v(" "), _c('p', {
    staticClass: "BL1"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the ark of acacia wood overlaid with gold surmounted by a lid with two facing cherubim (25:10–22 par. 37:1–9; for the associations of the cherubim, cf., e.g., 1 Sam 4:4; Ezekiel 10);")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the table of acacia wood overlaid with gold for the twelve loaves of the “bread of the presence” representing the tribes of Israel, with its implements of gold (25:23–30 par. 37:10–16);")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the lampstand of gold, with its implements of gold (25:31–40 par. 37:17–24);")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the ten linen curtains over the shrine (26:1–6 par. 36:8–13);")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the eleven goat’s-hair curtains to cover the shrine, with skins and leather (26:7–14 par. 36:14–19);")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("further structural details and equipment: the paneled walls of the tabernacle, of acacia wood overlaid with gold set in silver sockets with rings of gold and tie bars of acacia overlaid with gold (26:15–30 par. 36:20–34); the veil separating the most holy inner sanctuary set on four acacia pillars overlaid with gold on silver sockets, and the screen at the entrance on five acacia pillars overlaid with gold in bronze sockets (26:31–37 par. 36:35–38); the altar of burnt offerings, of acacia wood overlaid with bronze with its bronze implements (27:1–8 par. 38:1–7); the courtyard (27:9–19 par. 38:9–20); the oil for the lamp (27:20–21; listed among the offerings brought by the people in 35:8, 28); the priestly garments for Aaron and his sons (28:1–5; cf. 39:1);")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the setting apart of the priesthood: the garments for Aaron as chief priest—the “ephod” (28:6–12 par. 39:2–7), an outer garment with settings on its shoulder straps for two stones engraved with the names of the tribes (28:13–14; not explicitly paralleled); the “breastpiece of judgment” for the sacred lots (28:15–30 par. 39:8–21); the “robe of the ephod” (28:31–35 par. 39:22–26); the rosette on the turban, the tunic, turban, and sash; the garments for Aaron’s sons—tunics, sashes, and headdresses; undergarments for Aaron and his sons (28:36–43 par. 39:27–31; rearranged in two subdivisions); the dedication of Aaron and his sons (29:1–37; this is not paralleled until Leviticus 8); the specification of the daily offerings (29:38–46; again not executed till later; cf. Num 28:3–8);")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the incense altar of acacia overlaid with gold (30:1–10 par. 37:25–28);")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the rites of maintenance of atonement (30:11–16; cf. 38:21–23 for responsibility for the supervision and construction, and 38:24–31 for, among other things, the per capita payment);")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the bronze basin and stand (30:17–21 par. 38:8), with great variation;")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the ingredients of the oil for anointing the tent of meeting, its furnishings, and personnel (30:22–33; noted only in 37:29a"), _c('i', [_vm._v("a")]), _vm._v("); the ingredients of the incense (30:34–38; noted only in 37:29a"), _c('i', [_vm._v("b")]), _vm._v("); the appointment of Bezalel as chief craftsman and his assistants (31:1–11 par. 35:30–36:7).")])])]), _c('p', {
    staticClass: "Body1"
  }, [_c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("A striking feature of the above table is the difference in the sequence of the materials in the “specification” and the parallel “execution” sections. It can hardly be disputed that, as an account of construction, the sequence in the “execution” section (chs. 35–40) is the more logical (cf. the logical order of Moses’ construction in 40:18–33). After the appeal to Israel to bring the materials ")]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("required and the appointment of the chief craftsman and his assistants (ch. 35, in round figures), it begins with the construction of the structure of the sanctuary itself (ch. 36), then its furnishings (ch. 37), bringing the incense altar, which stands in isolation in the “specification” section in ch. 30, into direct association with the other furnishings of the sanctuary, the table for the bread of the presence and the lampstand. It then proceeds to the courtyard of the tabernacle and its furnishings (ch. 38). Finally, the officiating garments for the priesthood are made (ch. 39). But in the “specification” section this logical sequence is, in part, broken up and rearranged—37:1–24; 36:8–38; 38:1–7, 9–20; 39:1–31; 37:25–28; 38:21–31; 38:8; 37:29; 35:30–36:7.")])]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The main factor in this radical change of sequence in the “specification” section is the introduction of the figure of Aaron (in raw statistics Aaron appears forty times in the “specification” section and only four times in the immediate parallel in 35:1–39:31). In line with the interest of the final editor in Aaron (cf. 6:10–7:13), the high priest and his family are now brought into center stage: he is introduced in the last verse of ch. 27, and that leads directly into chs. 28–29, which are wholly devoted to the priesthood, their vestments, and their consecration (ch. 29 has no parallel in chs. 35–39, thus confirming the dominating position of Aaron in this section). The climax of the “specification” section is reached at the end of ch. 29 in God’s promises that he “will meet with the Israelites … will dwell among the Israelites, and become their God …” (29:43–46, where verbs related to both “tent of meeting” and “tabernacle” are used), but the fulfillment of these promises is dependent on the system of the Aaronic priesthood being maintained. The symmetry of the other chapters of “specifications” relating to the ordination of the priesthood (chs. 25–27; 30–31) is thus striking. But considerations beyond symmetry are involved, for chs. 30–31 lead on into the central roles of the priesthood: rites at the altar of incense, especially annually on the Day of Atonement (30:10); other rites designed to maintain atonement (30:11–16); the lustration required of the priesthood (30:17–21); the anointing ceremonies for sanctuary and priesthood; and the recipe for the incense (30:22–38). Equally, the opening chapters, where the furnishings (ch. 25) are listed before the related structure (chs. 26–27), place the functions which the priests will discharge before the context within which they will discharge them.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("By contrast, in the “execution” section the figure of Bezalel, the master craftsman, predominates (he is the grandson of Hur, 17:12; 24:14). But, since he is merely the artificer, executing an itemized list to order, the logic of construction is used rather than the logic of function. It is not Bezalel’s place to consider how Moses will integrate each item into the whole or the role of the priesthood within the finished system (thus, e.g., there is no parallel to 25:21–22 after 37:9). Consequently, a long appendix in 39:33–40:33 records how all the elements of the structure and the vestments are finally brought to Moses, a triumphant list of how work for the highest purpose according to the highest standard has been successfully completed, and how his is the final responsibility of bringing the whole institution into being and of setting it in operation. In advance of the inauguration of the priesthood, Moses in this passage fulfills all the functions that later became those of the priests and of the high priest—above all, blessing the people (39:43) and officiating at the altar (40:29). Nonetheless, where Aaron is mentioned in the “execution” section, it is always in a climactic position: in 35:19 in Moses’ summons to the people to bring their free will offerings, in 38:21 in connection with atonement rites, and in 39:1, 27 in connection with priestly garments.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Other features call for comment. For example, the account of the priestly vestments underscores the awesome role which Aaron has to discharge as representative of his people in the presence of God himself (cf. the warning bells on the hem of the ephod, 28:35): he bears before God the names of his people (28:12, 21), the lots that guarantee good order within the community (28:29–30), and the symbol of the acceptability of all their offerings (28:38).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The proportions of the tabernacle match those of the later temple, though on half the scale (cf. 1 Kgs 6:2). The most holy inner sanctuary is seemingly a perfect cube, measuring ten cubits in each dimension. The metals used, gold, silver and bronze, descend in value the further from the ark and inner sanctuary, thus matching the descending degrees of holiness of those admitted to the respective areas of the tabernacle.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Already in early Jewish interpretation the structural details of the tabernacle were held to possess cosmic significance, thus bringing the account of creation in Genesis 1 into correspondence with Israel’s sanctuary as its focus and climax. Josephus interprets the symbolism as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("When Moses distinguished the tabernacle into three parts, and allowed two of them to the priests, as a place accessible and common, he denoted the land and the sea, these being of general access to all; but he set apart the third division for God, because heaven is inaccessible to men. The veils, too, which were composed of four things, declared the four elements; for the fine linen was proper to signify the earth, because the flax grows out of the earth; the purple signified the sea, because that color is dyed by the blood of the sea shell-fish; the blue is fit to signify the air; and the scarlet will naturally be an indication of fire. ("), _c('i', [_vm._v("Ant.")]), _vm._v(" 3.7.7)")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("… the seven lamps signified the seven planets; for so many there were springing out of the candlestick … the twelve loaves that were upon the table signified the circle of the zodiac and the year; but the altar of incense, by its thirteen kinds of sweet-smelling spices with which the sea replenishes it, signified that God is the possessor of all things that are both in the uninhabitable and habitable parts of the earth, and that they are all to be dedicated to his use. ("), _c('i', [_vm._v("J.W.")]), _vm._v(" 5.5.5)")])]), _c('p', {
    staticClass: "Body1"
  }, [_c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("The long list of requirements for the construction—the costliest of metals and the most gorgeous of cloths, prepared animal skins and hides, the finest wood and precious stones to be donated by escaped slaves no matter ")]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("how compensated by their ex-masters—and questions of availability (e.g., of olive oil in the wilderness, 27:20), of compatibility of the free will offerings in kind presented, of the labor and tools involved in metal casting, joinery work, and sewing, of the weight in transportation (approximately two tons of gold, seven of silver, and six of bronze; cf. 38:24–31), all prompt the comment that this is no less visionary—and no less significant—a sanctuary than, say, the temple in Ezekiel 40–48. The point is not one of feasibility but of the ideal participation of the whole people to the utmost of their God-given capacities in materials and skill.")])]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The end which the tabernacle is designed to serve is, above all, the sanctification of the people (e.g., 28:38), so that with no disqualifying factor the glory of the divine presence can take up residence in the tabernacle among them. The sheer mass and complexity of the material on the construction of the tabernacle should not be allowed to obscure three points in this regard which the arrangement of the material already makes clear.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("(1) The account begins with the note that it is constructed with the free will offerings of the people (25:1–9; to stress the point, the execution section, 35:4–29, including a summary list of all the items to be contributed and made, is, unusually, much longer than the specification one). Though they do not have access to the tabernacle, its construction is enabled by the dedication of the laity and it is built on their behalf for use by their representatives. The purpose is plain: “that they may make [this root “make” is used some 246 times in this section] a holy place for me, so that I may dwell among them” (25:8).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("(2) The final editor links the two parts of his presentation of the tabernacle together with what, at first sight, seems to have little to do with it—the observance of the sabbath (31:12–17, at the very end of the specification section matched by 35:1–3 at the beginning of the execution section). For ordinary Israelites who do not possess the required degree of holiness to gain access to the holy place of the tabernacle (cf. the insistence on hierarchy already in 19:20–25), the climactic seventh day of each week is itself “holy” (31:14; 35:2), the sacred space and time available to all, reserved for sharing in the “rest” of God, which marks the completion of creation and its maintenance in equilibrium ever since (cf. the reason for observing the sabbath in the final form of the Decalogue in 20:8–11). The sabbath is the “sign” (31:13, 17) of the most fundamental covenant of all between God and his people (31:16; cf. Lev 24:8). It is the sacramental means whereby human life is infused with that wholeness which God imparted at creation. Those who do not observe it as a celebration of life are necessarily dead (31:14–15). Within the present context, not even work on the construction of the tabernacle can take precedence over this absolute observance.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("(3) Another issue apparently equally tangential to the question of the construction of the tabernacle is broached in 30:11–16: the maintenance of the holiness of the people by a rite of atonement. When the people are mustered for action as the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s host, as in the advance through the wilderness, they must be duly prepared for battle. Because of the risk of taking human life in warfare, Israel as the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s host must pay an indemnity in advance. Unlike rites of atonement involving sacrifice at the altar (e.g., Leviticus 1–7), which are intended to repair retrospectively the relationship between God and people accidentally breached by impurities of any kind, this legislation presupposes that the relationship is intact and is intended prospectively to maintain that unity. As a result a fixed payment for every male within Israel, irrespective of personal wealth, is to be applied to the construction and maintenance of the sanctuary (cf. the note on the fulfillment of this requirement in 38:24–39:1). Once again, the sanctuary is “sacramental”: since it is the outward sign of the indwelling presence of God, its maintenance is equally the symbol of Israel’s dedication to maintain the realm of the holy within which that presence may fitly dwell.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Appropriately, therefore, the book closes with the account of Moses’ construction and consecration of the tabernacle on the first day of the second year after the exodus (again the account is in two matching parts, the divine instruction followed by Moses’ obedience to the letter, 40:1–16, 17–33, each sub-section in the MT, except the last, ending insistently with the phrase, “As the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" had commanded Moses”; the chronology is that of the final editor, cf. 12:37–42). In gracious response, the cloud associated with the tent of meeting descends to veil the glory of God which now “resides” in the tabernacle (40:34–35). The means whereby Israel, delivered from slavery to the world empire, can live a life of total oneness with God has been established. But the final word (40:36–38) echoes that of the earlier version (33:7–11): the tabernacle is not a structure fixed at one place forever; it is a movable shrine from which God dictates how his people will continue their march through the desert, stopping at various places en route to the promised land.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Several times I have made statements in the commentary above to the effect that “a good case can be made for the view that the present book Exodus represents the thorough re-editing, from a distinctive theological perspective, of an older version recoverable from the reminiscences still available in the book of Deuteronomy.” More detailed argumentation to make this case than there is room for in the commentary will be found in the following publications, in which opportunity is also taken to engage critically with the work of other scholars: Johnstone, W. 1990 and repr. 2000, "), _c('i', [_vm._v("Exodus")]), _vm._v(", Sheffield: JSOT Press = pt. 3 of Moberly, R. W. L., W. Johnstone, and J. Rogerson. 2001, "), _c('i', [_vm._v("Genesis and Exodus")]), _vm._v(", Sheffield: Sheffield Academic • Johnstone, W. 2002, “The Use of the Reminiscences in Deuteronomy in Recovering the Two Main Literary Phases in the Production of the Pentateuch,” pp. 247–72 in J. C. Gertz, K. Schmid, and M. Witte, eds., "), _c('i', [_vm._v("Abschied vom Jahwisten: Die Komposition des Hexateuch in der jüngsten Diskussion")]), _vm._v(", BZAW 315, Berlin: de Gruyter • Johnstone, W. 2003, “The Revision of Festivals in Exodus 1–24 in the Persian Period and the Preservation of Jewish Identity in the Diaspora,” pp. 99–114 in R. Albertz, and B. Becking, eds., "), _c('i', [_vm._v("Yahwism after the Exile: Perspectives on Israelite Religion in the Persian Era")]), _vm._v(", Studies in Theology and Religion 5, Assen: Van Gorcum, 2003 • Johnstone, W. 2003, “Recounting the Tetrateuch,” in A. D. H. Mayes, and R. B. Salters, eds., "), _c('i', [_vm._v("Covenant as Context")]), _vm._v(", Festschrift for Ernest Nicholson, Oxford: Oxford University.")])])])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT",
    attrs: {
      "id": "ch007"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_101"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-007"
    }
  }, [_vm._v("Leviticus")])]), _vm._v(" "), _c('p', {
    staticClass: "CA"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-007"
    }
  }, [_vm._v("Walter J. Houston")])]), _vm._v(" "), _c('p', {
    staticClass: "H1a"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("In traditional Jewish communities children begin their study of the Hebrew Bible with Leviticus. Among Christians, on the other hand, it may well be the least read of OT books. Leviticus is the heart of the law, which defines traditional Jews as a people and defines many Christians in terms of what they suppose they are against: legal religion and “empty ritual.” But if Christians desire any meeting of the mind with Jews, they must try to understand this book.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The main subject matter of Leviticus is ritual, and even those parts of the book that are concerned with morality and social order impose a ritual image on moral requirements. It thus raises two types of question. First, what is ritual and how can we explain it? Second, how has such a book come to exist; what is its purpose; and what meaning can we attach to it?")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Ritual")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("If we are to understand Leviticus, we have to cast off the mind-set which automatically attaches the label “empty” to the word “ritual.” The book itself is sparing in its explanation of the rituals it prescribes, but the work of social anthropologists on ritual in a wide range of human societies gives us some clues to finding meaning in these (e.g., Douglas 1966; Turner 1969).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Ritual may be defined as any group of symbolic practices by which a community expresses its understanding of the world and regulates and renews its own life (Gorman 1990: 13–38). Ritual has both "), _c('i', [_vm._v("meaning")]), _vm._v(" (cf. Leach 1976) and "), _c('i', [_vm._v("function")]), _vm._v("—it achieves certain ends in society, which the participants are not necessarily aware of.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The meaning and function of various major aspects of ritual in Leviticus are discussed in the comments on the appropriate sections, as follows.")]), _vm._v(" "), _c('table', {
    staticClass: "Table15",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_c('i', [_vm._v("Discussion of:")])]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_c('i', [_vm._v("in comment on:")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Sacrifice")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("chs. 1–7")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Atonement")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("4:1–6:7; ch. 16")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Priesthood")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("chs. 8–9")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Rites of passage")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("chs. 8–9")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("“Uncleanness”")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("chs. 11–15")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Festivals")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("ch. 23")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("Underlying these various aspects of ritual in Leviticus is a consistent ritual structure, expressed in the sanctuary which God commands Moses to make in Exodus 25–31 (see comment there). This is the main theater of the rituals in Leviticus, so every reader of the book needs to be aware of it. Its structure is concentric. The presence of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" fills the inner sanctum (16:2), and the tabernacle as a whole is made intensely holy by it (Exod 40:34). Hardly less holy is the altar, but the court surrounding them is holy to a lesser degree. Surrounding the court is the camp, where the people live. This is not holy, but it is clean—that is, it is fit for holy things. The area outside the camp, or the wilderness, is considered unclean. A reader in biblical times would apply what is said about the tabernacle to the temple, while the camp stood for the walled city.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("To the classification of space corresponds a classification of personnel: only the high priest may enter the inner sanctum (16:2), and only priests may enter the tabernacle or ascend the altar; only persons in a clean state may enter the court (12:4), and the most severely unclean must leave the camp (13:46; cf. Num 5:2–4). For what is unclean can never become holy, and it is dangerous for the two to come into contact (cf. 6:8–7:36; 10:10). The holy is in the sphere of God; what is unclean represents what is opposed to God, which can never co-exist with the holy and constantly threatens it. The holy and the unclean are seen as states or influences that objectively exist, not as mere symbols. Thus the sanctuary is a microcosm: in a small space it presents the cosmic opposition of God and evil.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The idea of a unique place of divine presence, guarded rigorously by successive boundaries, is typically priestly. Priests were the professional guardians and functionaries of a temple, and temples had always been understood as the dwelling place of a god; it was natural for them to understand the place they guarded as the one important channel of communication between God and the people—not to speak of the advantages in wealth and power that accrued to them as a result.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("All societies have rituals of some sort, but various societies differ in how far they are shaped by and express themselves in ritual. Modern Western society stands almost at the opposite pole from Leviticus in this respect, and that is why we tend to find the book alien to us. Mary Douglas (1970) shows how the richness of ritual in a group tends to vary in a consistent way with the social structure. Leviticus gives clues as to the kind of society it assumes or prefers: a solid patriarchal family structure (ch. 18), the inheritance of prescribed roles such as the cultivation of the land (ch. 25) or priesthood (chs. 8–10), and the need to define boundaries against outsiders (20:24–26). When a society is concerned to maintain a strong traditional order, and when people experience roles as given rather than achieved (Eilberg-Schwartz 1990: 195–216), they tend to find ritual self-evident and "), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_vm._v("effective because the strict rules of the rite are reinforced by their daily experience and their need for a shape to life. For them the structures of sanctuary and cosmos echo and are echoed by the structure of society.")])]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("But the society which Leviticus presupposes was not necessarily the same as the society it was written in. It projects an ideal for society: a priestly ideal, shaped by the priests’ experience of life and their primary concern for ritual order (for a contrary view, see Gerstenberger 1996). We cannot tell how far it corresponded to reality, though it has contributed to the shaping of Judaism ever since.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Leviticus as a Book")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("We will now try to understand the book itself. But "), _c('i', [_vm._v("is")]), _vm._v(" Leviticus a book as a coherent whole, or is it simply an arbitrary slice of the Torah (see Sawyer 1996: 22–64)? Leviticus is clearly marked out within the Sinai episode by its opening verse, in which Yahweh is said to “call” to Moses (the only other place where this happens is in Exod 19:3), and by the (doubled) summary at 26:46; 27:34. At the end of Exodus the tabernacle has been set up for the first time, and Yahweh’s glory has filled it. In Leviticus Yahweh gives (“from the tent of meeting”) all the basic instructions for the conduct of worship at the tabernacle and for the conduct of the people who live around it. Numbers then proceeds with instructions for the journey.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The book is part of the foundation story of Israel. It is held together by a thin thread of narrative: all the commands are given by Yahweh to Moses and/or Aaron in thirty-five separate speeches. Whatever its actual origin, all the teaching in Leviticus becomes the command of Yahweh: this is its basic claim to authority. At a few places the thread broadens to show how instructions were obeyed (chs. 8–9) or to tell a short story as background to instructions (ch. 10; 16:1; 24:10–12). The main divisions of the book are marked by these expanded narratives.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The structure of the book is easy to explain (cf. Douglas 1993). The sacrificial rubrics in chs. 1–7 are followed by the initiation of the sacrificial cult in chs. 8–10; ch. 16, ordaining the purification of the sanctuary and the people, stands between chs. 11–15 on “uncleannesses” and chs. 17–22 requiring both ritual (17; 21–22) and moral holiness (18–20). Chs. 23–25 are linked by the theme of sacred times. Ch. 26 spells out the consequences of obedience and disobedience, and the final chapter, as often happens, brings us back to the start with the subject of dedication to God.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Writing of Leviticus")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Most of the passages of ritual instruction in Leviticus (chs. 1–7; 11–15; 16; 27) are written, with some short exceptions, in a characteristically dry legal style, without direct appeal to the reader or any explanation of the commandments. It is an impersonal style, always referring to God in the third person and generally referring to the person carrying out the rite in the third person (this is often obscured in the NRSV, which changes it to the second person to avoid the masculine pronoun; in fact, usually only Moses is addressed directly). The same style characterizes the narrative in chs. 8–10. All these passages use a precise technical vocabulary; this cannot be detailed here (see Milgrom 1991: 35–42). This is generally recognized as the style of the Priestly code (P).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A distinctly different style prevails in chs. 17–26. Here we find Yahweh speaking directly and personally to his people, using “I” and “you” frequently, especially in the constant refrain “I am the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" your God.” Series of simple commands are framed by sermonlike material calling for obedience. Many of the same ideas and much of the same vocabulary are used as in chs. 1–16, but often in a different, looser way (see Milgrom 1991: 35–42 and Knohl 1995), besides other distinctive expressions. There are also some traces of this style in chs. 1–16 (see 11:44–45; 16:29–34; and below). The leading ideas in the sermonic material are obedience, holiness, the exodus, and separation from the nations. See the major discussions on “I am the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("” in the comment on ch. 18 and on “holiness” in that on ch. 19.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Most scholars see in these different styles the work of two related schools of writers (see Knohl 1995; against Crüsemann 1996: 277–80). All the texts belong to the priestly writings, but within them chs. 17–26 form a block often called the Holiness code (H), from the overwhelming use of “holy” in chs. 19–22. In the following paragraphs, the symbol P is used for the non-H materials only.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The two groups of material, although they have differences, cohere closely. Although Yahweh speaks in a personal way only in the H material, he also delivers the impersonal instructions; all the material without distinction constitutes the commands of Yahweh. Chs. 17–26 make repeated allusion to the matters dealt with in the earlier chapters. Most significantly, H employs a number of ritual terms such as holiness and defilement, but broadens their meaning from technical terms of ritual to the theological and moral realm. Its ideal of morality and society is shaped by a concern for traditional order which coheres symbolically with the importance of order in the ritual structure. So the ritual structure becomes a model for the relationship of Israel to Yahweh. As the tabernacle is made holy by the divine presence and is kept separate from uncleanness, so Yahweh will dwell among Israel (26:11), whom he separated from other peoples (20:24–26) when he brought them out of Egypt. Thus he also commands them to be holy (19:2) in their daily lives.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_vm._v("Now we can begin to answer the question why Leviticus exists. The ritual instructions seem to have grown out of the practice of priests giving oral instruction and answering questions on ritual matters (see Hag 2:10–13). But it would be a mistake to regard them as a procedural manual. They are concerned not so much with "), _c('i', [_vm._v("how")]), _vm._v(" things are to be done as with "), _c('i', [_vm._v("what")]), _vm._v(" is to be done (Knierim 1992) and which elements of procedure are essential: how the types of sacrifice are to be differentiated or what ")]), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("a menstruating woman should guard against. They do not aim at instructing the novice, who would have elders to give guidance; rather, their concern is standardizing practice, perhaps at a time when this was in flux or uncertainty.")])]), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("H, on the other hand, can be seen as the preaching of zealous reformers, concerned to shape Israel’s life as a strictly monotheistic community. It aims to persuade and to create obedience rather than simply to instruct. It projects a picture of the ideal Israel, devoted to Yahweh alone, excluding anything which smacks of polytheism or is unworthy of a “holy people” and maintaining social justice and conservative standards of family life. In these ways, it is similar to Deuteronomy (cf. Cholewinski 1976). However, H’s origin is in a priestly circle: for H Israel is a community gathered around the sanctuary of Yahweh, and their lives are to be structured on the model of ritual. There is no real distinction between the treatment of morality and of ritual; the prohibition of eating blood (7:26–27; 17:10–14) is handled with the same moral seriousness as the prohibition of incest (ch. 18). But see the next section.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Scholars differ a great deal on dating (for contrasting views see Milgrom 1991: 13–35 and Gerstenberger 1996: 6–10). The Holiness code used to be regarded as an originally separate document later incorporated into P. But such a code would have no obvious coherence on its own. It seems better to think of the H writers as editors who worked with P and other material, developing the priestly themes in new directions (Knohl 1995; see also Milgrom 1991: 13–42) and actually producing the book of Leviticus as we now have it. This more easily accounts for the presence of H traits outside the Holiness code. Knohl (1995: 105) identifies the following passages in Leviticus 1–16 as H: 1:1; 3:17; 6:17–18; 7:19b, 22–36; 9:16b; 10:6–11; 11:43–45 (I would add vv. 41–42); 14:34; 15:31; 16:29–34.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The most probable date for the final editing of Leviticus is in or after the exile (Crüsemann 1996: 282–90). It contains prohibitions of practices which are taken for granted by good Yahwists down to the exile (see the comments on 19:27–28, 26:1), and there are obvious close links between H and Ezekiel. A time of profound disruption, followed by the tentative reestablishment of a small community around Jerusalem, is the most appropriate context for an effort to shape society’s life anew in dependence on the sanctuary. However, Knohl may be right in seeing the beginnings of the Holiness movement at the time of Hezekiah, with the collapse of the Northern Kingdom (Knohl 1995: 199–224).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Reading Leviticus")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The commands of Leviticus are attributed to God and addressed to Israel. If readers identify themselves to any extent with this Israel, they must decide how far they can accept that God is addressing them literally. For other readers this will be a less pressing issue. Christians are in an ambiguous situation. They have always regarded most of the commandments as of no practical significance for them; but Christians do read the book, and they take some of its commandments with great seriousness: 19:18 is an obvious example, and 18:22 is creating bitter division among Christians at the present time.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Although ritual dominates Leviticus, attention to the book’s rhetoric alters the perspective: far more of the effort to persuade is concentrated on its moral and social teaching. It is going too far to say (with Douglas 1993) that the ritual instructions are there as symbolic backing for the moral teaching, though that is "), _c('i', [_vm._v("one")]), _vm._v(" way in which they may taken (cf. D. P. Wright 1991). Ritual and moral teaching are integrated into a conception of ideal, holy, obedient Israel. Ritual is also a field in which Israel must express obedience to Yahweh. But the idea that Leviticus teaches that God desires sacrifice rather than mercy is, I suggest, a misreading.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("How, then, may the moral teaching of Leviticus be read in the context of the book as a whole? The rhetorical effect of the book is to place ritual and moral demands in parallel: moral and ritual demands are equally aspects of holiness, equally words of the Lord, and equally absolute. Two opposite effects can be observed in readers of the book. Traditional Jews, who observe the ritual laws as a matter of daily routine, tend to interpret their meaning in moral terms (e.g., Milgrom 1991: 704–42 asserts that the dietary laws teach restraint and respect for life). Others appear to derive from Leviticus (or find in it support for) rigidity in moral teaching, especially concerning sex, which is characteristic of ritual. It is perhaps easier to appreciate the value of the moral teaching of some parts of Leviticus without succumbing to this rigidity if one understands the book as a call by a nation’s leaders, at a particular point in history, to reshape its life under God rather than as the very words of the God in whose mouth the call is placed.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("COMMENTARY")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Sacrifices (Leviticus 1–7)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Sacrifice is an essential part of traditional religions in every part of the world, yet it is absent (in the literal sense) from the practice of religion in the modern West. Animal sacrifice in particular is deeply alien to us. What is sacrifice? Why did people offer sacrifice? What does it mean?")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("Gift")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("It seems likely that every sacrifice was understood as a gift to God; this is expressed in much of the vocabulary used. However, not all gifts to God were sacrifices (see ch. 27 or Numbers 7). Sacrifice involves further ideas as well.")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("Consecration")])])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("The offering of a sacrifice transfers the victim from the secular realm to the sacred by being brought to the altar (see 105). In the case of offerings that are eaten, this applies to the whole of the offering, not just the portion burned on the altar, for it can be eaten only in conditions of ritual purity, whether it is the priests or the lay worshipers who eat it (6:16–18, 25–27; 7:19–21). And because the victim is in some sense identified with the offerer, its ")]), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("transfer to the sacred realm and mediation with the deity enable the offerer "), _c('i', [_vm._v("either")]), _vm._v(" to share this consecration in some way (e.g., when by sacrifice and the application of the blood of sacrifice Aaron and his sons are ordained as priests [ch. 8]) "), _c('i', [_vm._v("or")]), _vm._v(" to be released from supernatural danger (as with the sacrifices for unwitting sin in ch. 4).")])]), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("Expiation")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Many sacrifices, therefore, function to atone for sin or to purify ritual uncleanness; they are "), _c('i', [_vm._v("expiatory")]), _vm._v(". The sacrifices in 4:1–6:7 are prescribed for that reason. But 1:4 also gives this function to burnt offerings (see the comments on ch. 1). The simplest, and very likely the popular, view of expiation is that the sacrifice as a gift is intended to gain favor from God; but the priestly prescriptions for expiation do not support this idea: they have various distinct rationales and are much better seen as occasions for God to offer expiation by a prescribed procedure (see the comments on 4:1–6:7; 4:1–5:13; 5:14–6:7; 16).")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("Meal")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The ritual of sacrifice most obviously resembles the preparation and eating of a meal. The offering of ch. 3 became a meal shared by the participants; but the simplest understanding of the divine portion (or burnt offering) is that it also symbolizes a meal taken by the deity. The biblical writers did not believe that God needed feeding (see Ps 50:12–13); but the rites they prescribe and the vocabulary they use suggest a meal nevertheless. Of all secular activities, a meal is what a sacrifice resembles most. Even if no one understood it literally (which we cannot show), that is the character of the symbolism.")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("Communion")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Sacrifice also establishes communion with God through the sharing of a common meal. This obviously cannot apply to the whole offering of ch. 1, where the participants receive nothing, but it may apply to the shared offering of ch. 3, where they eat the flesh of a victim which in principle has been consecrated to God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This is by no means a comprehensive view of the proposals which have been made for how people understood what was going on in sacrifice, but it covers the major ideas. It is clear that no one idea “explains” sacrifice; all of them are needed to understand a rich and many-faceted institution.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Why did people engage in sacrifice? The most basic reason was in order to approach God and set up communication with him, whether to seek his aid or to rejoice in his goodness. Ancient peoples would not think of approaching a king or official without bringing a present; how much less when approaching God (cf. Exod 23:15)? Social life was governed by a network of mutual favors and marked by occasions of hospitality which created obligations to be discharged when they were needed. It is natural that their religious life should be patterned in a similar fashion. By offering their God the first share of the increase of their produce they acknowledged that blessing came from him, and that he was their benevolent Lord. Occasions of sacrifice were also of importance in binding the community together on a social level.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In Leviticus, however, sacrifice is the most significant means by which the ritual order is maintained and kept in repair (see esp. 4:1–6:7 and ch. 16, and the references to sacrifice in chs. 12, 14, and 15). Against the constant encroachment of “uncleanness” upon the holy, the consecration of sacrificial victims, and especially the shedding of their blood (17:11), acts to preserve people from the disastrous effects of the desecration of the sanctuary and of the ordered world.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("All the types of sacrifice here, especially the animal sacrifices, follow the same general pattern. Their key elements are as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("a. The offerer. Moses is told to speak to the Israelites, and in 1:2 the potential offerers seem to be restricted to Israelites. However, non-Israelites living among them could offer sacrifice according to 22:18. Moreover, offering sacrifice is not restricted to males (1:2; 12:6).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("b. The object for sacrifice (technically the "), _c('i', [_vm._v("victim")]), _vm._v("). Animal victims are confined to cattle, sheep, and goats, that is, those species of animals commonly herded by the Israelites, and doves or pigeons, and in general they come from the offerer’s own stock, though it was also possible to buy victims. Animals had to be unblemished (see 22:17–25 and comment). The basis of all the grain offerings is wheatmeal (see on ch. 2), which was the more expensive and highly regarded of the two staple crops of the land, barley and wheat. Thus all the offerings permitted represent the basic produce of the land, on which the people’s lives depended.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("c. The place. The victim has to be brought “to the entrance of the tent of meeting” (1:3; 4:4). Sacrifice cannot take place anywhere else than at the sanctuary indwelt by Yahweh’s glory (cf. 17:3–9 and comment). The phrase means inside the court in front of the tent proper (Exod 27:9–19).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("d. The priest. Everything requiring contact with the altar and the tent, the most holy areas, is the exclusive province of the priest; therefore, it is the priest who has to catch and manipulate the blood and burn the victim on the altar.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("e. The hand-leaning. In the case of beasts, the offerer presses his or her hand firmly on the beast’s head (the NRSV is wrong in translating simply “lay your hand”). The meaning of this act is disputed. It may be to identify the victim with its offerer; but the most widely accepted theory is that it is simply a sign that the beast belonged to the offerer. It is therefore not required in the case of birds and grain offerings, which are carried in the hands (Milgrom 1991: 151–53). But this does not explain why the hand has to be pressed firmly on the head rather than simply touching it. The gesture may be rather “an act by which the animal is officially surrendered to its sacrificial death” (Knierim 1992: 38; cf. 24:14).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("f. The victim, if a beast, is slaughtered by the offerer, though at some stage this work was mostly taken over by the Levites. Bird victims are killed by the priest (1:15; 5:8) because the blood has to be applied to the altar at the same time. The blood is caught in a bowl by the priest. Blood belongs to God and may not be used for human consumption (3:17; 17:10–14; and comment on ch. 17). It can be manipulated to express various meanings (see on 4:1–5:13).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_104"
    }
  }), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("g. In all sacrifices, whether animal or vegetable, part at least of the victim is formally brought to the altar. This is essential to its consecration. The blood is dashed against the altar, thus entering God’s particular sphere (differently in the case of the sin offering). Solid parts are presented at the altar and then burned on it as God’s peculiar portion; in each case the climax of the text comes at this point. It always says that the priest shall “turn into smoke” what he has placed on the altar fire. The idea is probably that the material ascends to heaven as smoke to reach God. It was an "), _c('i', [_vm._v("ishsheh")]), _vm._v(" to Yahweh (except for the sin offering in ch. 4), a word found only in ritual connections which probably means “gift” (NRSV, “offering by fire”). It was “of a pleasing odor” or “of appeasing odor.”")])]), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_vm._v("The Structure of the Text")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The text can be grouped into two main divisions. 1:1–6:7 are addressed to the lay community and lay down procedures for various categories of sacrifice. 6:8–7:36 are principally addressed to the priests and give supplementary regulations about the same categories of sacrifice, largely but not entirely in the same order. 7:37–38 is a summarizing note.")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('b', [_c('i', [_vm._v("1:1–6:7")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("1:1–6:7 falls into two parts. A single speech occupies chs. 1–3 and deals with the three types of sacrifice that one may voluntarily undertake to offer; then the three speeches in 4:1–6:8 deal with sacrifices that the individual (in one case the community) is required to offer in specified situations.")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('b', [_c('i', [_vm._v("Chs. 1–3")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("1:1 introduces not just the speech in chs. 1–3, but probably the whole book (see Introduction, 102).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("1:2 introduces not only 1:3–13 but also ch. 3, on the shared offering. 1:14–17 and ch. 2 were probably added afterward.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Burnt Offering (1:3–17)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Most aspects of this text are dealt with above, in the section on chs. 1–7.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The burnt offering or whole offering comes first since it had the highest status; it also formed the regular daily offering of the community (Exod 29:38–42). It is wholly burned on the altar, apart from its skin (7:8). The victim has to be a male (if a beast [v. 3]). Male animals had greater prestige. Female animals could be offered as sacrifices of well-being and sin offerings, but in being restricted to male victims the burnt offering probably exemplifies ancient practice most exactly.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("1:4, dealing with hand-pressing, says that the offering will thereby be looked on with favor “to atone for him.” The offering has an expiatory function, but unlike the sin offering and guilt offering it does not have the circumstances for its offering specified. The assumption may be that since human beings always stand as sinners before God, this standard sacrifice will always be graciously accepted by him for atonement. But in view of the great variety of occasions on which it was offered, this cannot be its sole function. As the offering was pure gift, without any material benefit in the way of a feast accruing, it was suitable for solemn occasions and for pleading for God’s help in a variety of ways; at big celebrations one burnt offering might precede several offerings of well-being.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Grain Offering (Ch. 2)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Most flesh offerings were accompanied by grain offerings (Num 15:1–8). But this chapter deals with independent grain offerings. It seems likely to be a later insertion into the context introduced by 1:2 to make clear that it was possible for someone who could not even afford a bird for a burnt offering to bring a grain offering. The offering is “most holy” (2:3, 10), which means that the lay offerer may not eat of it. It is consumed by the priests (vv. 3, 10), with the exception of the “token portion” which is burned on the altar.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("All the altar offerings (except for first fruits, 2:14–16) consisted of "), _c('i', [_vm._v("solet")]), _vm._v(", a type of wheat flour (NRSV, “choice flour”). It appears to mean semolina or grits (Milgrom 1991: 179), a coarser meal than bread flour but nevertheless more highly valued. Olive oil was the main fruit product of the country and indispensable in cooking. The distinctions between the different offerings are only in the manner of cooking. Raw flour (vv. 1–3) had to be offered with frankincense, a costly spice. The cooked offerings, however, would be within the reach of the poor.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The prohibition of leavened bread and honey (2:11–12) as altar offerings has not been satisfactorily explained. It is not because fermentation in itself was thought incompatible with holiness, for wine was acceptable (Num 15:5). “Honey” may well have been fruit syrup rather than bees’ honey. Salt (2:13) was essential to the offering as it was in cooking; it was also a symbol of hospitality and so of agreement between two parties; thus the salt of sacrifice becomes a symbol of the covenant between Yahweh and Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Sacrifice of Well-being (Ch. 3)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This chapter resumes the prescriptions for animal sacrifices begun in ch. 1. Many aspects of the text have been dealt with above, in the comments on chs. 1–7. It gives standard regulations for the various types of sacrifice (some listed at 7:12, 16) eaten by the worshipers. They are grouped under the name of "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("zebaḥ shelamim")]), _vm._v(";")]), _vm._v(" NRSV, “sacrifice of well-being” (3:1). This translation is untrustworthy. "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("Zebaḥ")])]), _vm._v(" is the most usual word for a sacrifice eaten by the worshipers, but "), _c('i', [_vm._v("shelamim")]), _vm._v(" is a word of uncertain derivation and meaning (“gift of greeting,” according to Levine 1974: 3–52).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("Apart from regulations applying to all animal sacrifices, some of which are repeated from ch. 1, the chapter is concerned to define which parts of the animal were ")]), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("Yahweh’s portion and not to be eaten by the worshipers. This text is not concerned with the meal following the sacrifice; there are regulations about this in ch. 7.")])]), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("3:16b–17 raise instruction to the status of commandment with the characteristic (H) phrase “a perpetual statute throughout your generations.” This underlines the importance of a divine law, perhaps particularly one that was in danger of being ignored (Tomes 1988). Why the fat was Yahweh’s portion is not clear. But it would not be a sacrifice unless he had his due. For the blood, see above on chs. 1–7, point f, and ch. 17.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Expiatory Offerings (4:1–6:7)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This section deals with two main types of offerings that are mandatory in particular situations. The situation envisaged here is generally one where the offerer has committed an unintentional or unconscious offense (4:2, 13, 22, 27; 5:14, 17); but 5:1–4 and 6:1–3 appear to be exceptions (see below). The first divine speech, 4:1–5:13, deals with the “sin offering”; the other two, 5:14–19 and 6:1–7, with the “guilt offering.” These two offerings are quite different in their ritual and functions, but they have one thing in common: in both cases the priest is said to “make atonement” (Heb. "), _c('i', [_vm._v("kipper")]), _vm._v("), and the result of the ritual is that the offender was forgiven. So before we go on to deal with the two offerings separately, we will discuss (a) the rationale of sacrifice for unintentional “sin,” and (b) the meaning of "), _c('i', [_vm._v("kipper")]), _vm._v(" and its relationship to forgiveness.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("We may feel that an unintentional sin is not a sin at all. Why should sacrifice be required for it? First, according to Num 15:30–31, a deliberate, brazen sin cannot be dealt with by sacrifice; although the rites of the Day of Atonement (ch. 16) release the community from responsibility for an individual’s sin, the offender has to suffer God’s punishment. In that light the requirement to bring a sacrifice for unintentional sin (or negligent or repented sin?; see comment on 5:1–13 and 6:1–7) is an important concession: it recognizes that intention does make a difference in relation to responsibility. Secondly, our own legal and moral systems do not regard unintentional harm as nothing. When we have caused damage or harm, we recognize our responsibility to put things right or pay compensation even when we did not act on purpose. The view reflected in Leviticus is that there is an objective divine order in the world which is reflected in the social and religious order, and any breach of this order brings dangerous consequences both to the world in general and to the offender in particular, regardless of intention. The object of the expiatory sacrifices was to heal the breach and deal with the consequences. If there was harm to fellow human beings, it is not dealt with by these sacrifices. In some cases it may be dealt with by civil law.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The conclusion to each separate case (except the first; see the note on 4:10) states that the priest is to make atonement for the offender, and the offender will be forgiven (4:20, 26, 31, 35; 5:[6], 10, 13, 16, 18; 6:7). These two actions are not the same: atonement is an act carried out by the priest, but forgiveness is an act of God. Forgiveness does not mean exemption from punishment, for the rule in 5:16 is clearly penal. It means that the offender is reconciled to God, restored to his grace. It seems at first as if in these rituals God’s forgiveness follows inevitably from the priest’s action. But atonement is seen as made possible in the first place by God, the priest acting as his representative in the rite and the offender responding to the opportunity offered to obtain forgiveness (Janowski 1982: 358–59).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The verb "), _c('i', [_vm._v("kipper")]), _vm._v(", “expiate,” “make atonement,” is used much more widely than in these rituals for unintentional sin. It describes the ritual of the sin offering wherever it is used (see the next section), and that includes a number of occasions in chs. 12–15 in which the problem is not sin but ritual impurity. The original meaning of "), _c('i', [_vm._v("kipper")]), _vm._v(" is literally to “rub, wipe,” and in connection with the sin offering to “wipe off” or “purge” the sanctuary of impurity engendered in it by either sin or human impurity (Milgrom 1991: 1079–84; see 16:16, 19). But it has acquired the broader connotation of removing or “dealing with” sin, or the effects of sin, as well as impurity, by means of a ritual (“to perform rites of expiation,” Levine 1974: 64; cf. Kiuchi 1987: 87–109). The rituals and the effects they deal with must be discussed separately for the two different offerings.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("17:11 adds a complication. The verse offers a theological explanation for the prohibition of eating blood: that God has reserved it for another purpose. But the phrase translated “making atonement for your lives” in the NRSV regularly means “ransom you” (Levine 1974: 67–68). Although the verb in Hebrew has the same form as the one discussed above, it probably has a different origin and meaning. The writer is deliberately playing on this ambiguity. Because blood was used in the sin offering to "), _c('i', [_vm._v("kipper")]), _vm._v(", “purify of sin,” the blood, which represents life, functioned to "), _c('i', [_vm._v("kipper")]), _vm._v(", “ransom,” you from the threat of death. Hence the verse offers a substitutionary theory of atonement (Schwartz 1991: 45–61), but this is a theological interpretation which is not supported in the extensive ritual texts on expiatory sacrifices (Janowski 1982 disagrees).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Wherever in this section the NRSV uses the phrase “incur guilt” or “be guilty,” the true meaning is probably “realize guilt” (Kiuchi 1987: 31–34; cf. Milgrom 1991: 342–45), except in 5:17, where “feel guilty” is better. The same Hebrew word is used in 5:5 and 6:4, where the NRSV translates “realize your guilt”; nothing else would make sense. In 4:22–23, 27–28 being told about your sin by someone else is an "), _c('i', [_vm._v("alternative")]), _vm._v(" (there ought to be an “or” between the two verses in each case). In each case in ch. 4 it is a question of an unintentional offense which one either realizes oneself or has pointed out to one. In 5:17 it is an unconscious offense: you don’t know what you have done wrong, but you suspect you have done something (Milgrom 1991: 331–33).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Sin Offering (4:1–5:13)")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("Hebrew "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ḥaṭṭaʾt")])]), _vm._v(", which is a homonym of one word for “sin,” has traditionally, as in the NRSV, been translated ")]), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_vm._v("“sin offering.” But the REB, following Milgrom (1983: 67–69), gives “purification offering,” deriving it from "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ḥiṭṭeʾ")])]), _vm._v(", “to purify.” As we shall see, this fits better.")])]), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("This sacrifice is to be offered when a prohibition has been unintentionally broken, not on the failure to observe a positive command. This is because only a positive act is seen as having a dangerous power which has to be specially dealt with. Myths (like the story of Eden, or the Orpheus story) often make the breaking of a prohibition the source of disaster. (The apparent gap is filled in Num 15:22–29.)")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But this is not the only kind of situation in which this offering was required. On the Day of Atonement (ch. 16) it is offered for "), _c('i', [_vm._v("all")]), _vm._v(" the sins of Israel, deliberate or not (16:16). It is also to be offered by people purifying themselves of ritual uncleanness, which is not a sin at all (see chs. 11–15 and comments); and on various public occasions.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There are just two distinct variations of ritual among the prescriptions in ch. 4 (there are other variations in chs. 8, 9, and esp. 16). In both, the blood is sprinkled or daubed on sacred objects, and what is left over is poured out at the base of the altar, not dashed against its sides as with normal offerings (1:5; 3:2). In the first type, prescribed for the sin of the high priest (4:3–12) or the whole community (4:13–21), the blood is taken into the shrine proper, sprinkled in the direction of the inner sanctum, and daubed on the incense altar. After the fat pieces have been placed on the altar, as for the offering of well-being, the rest of the animal is taken out of the camp and burned.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the other type, prescribed for a clan chief (chs. 22–26) or an ordinary person (chs. 17–25), the blood stays in the court and is daubed on the altar, on its four horns, which were projections at each corner. The other difference is that the meat is not burned; according to 6:26, it is eaten by the officiating priest. There is also a gradation of the victims according to rank.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("How are these rituals to be interpreted? (See Levine 1974: 55–114; Kiuchi 1987; Milgrom 1991: 226–92.) The sprinkling or daubing of blood must signify the purification of the objects which were daubed or sprinkled. The blood represents the life of the victim (cf. 17:11), and the victim has been made holy by the act of sacrifice; so its blood is seen as having the power to wipe out or absorb the opposing power which has made the objects impure. 16:16, 19 suggest that the holy objects were thought to be polluted by the sins and impurities of the Israelites, and 15:31 suggests that that is why their impurities were dangerous to them, unless they were purified.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The whole idea sounds like magic. But is this idea still active in the priestly texts about the sin offering? One would expect that the victim whose blood was used to wipe away such lethal pollution would be gravely polluted itself, and that is what seems to be suggested by the burning of the victim in 4:11–12, 21; 16:27: it is a way of finally getting rid of the dangerous power. But in that case why are the priests able to eat the flesh of the victim in the second type of sin offering, which, so far from being polluted, is “most holy” (6:26–29)?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("One view (Kiuchi 1987: 46–52, 130–41) is that the priest himself bears the guilt (10:17), and the offering does not become infected with pollution. Only when the priest himself is involved in the sin which was being expiated is this impossible—certainly he cannot be allowed to benefit from his own sin—and then the offering is burned. But if this is indeed the view expressed in Leviticus, it means that the simple magical idea of a substance which wipes the sanctuary free of its taint is no longer operative. And this is what one might expect. Rites are more durable than the ideas they express.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A. Marx (1989) points out that the occasions on which the sin offering is called for tended to be times of transition in the life of the individual or the community, such as after childbirth (12:6), or when the cleansed “leper” rejoins normal society (14:31). In many cultures such times are seen as times of danger, and special rituals, known as rites of passage by anthropologists, are often observed (see the comments on chs. 8–9). In these cases the sin offering serves as part of a rite of passage rather than strictly as a purification.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But since the time of transition is generally seen as dangerous, it is natural for the priestly mind to conceive the danger as one of pollution threatening the temple, and so the rite takes the form of a sin offering. For the priest, all life is centered on the temple. Society, the cosmos, and the temple symbolize and echo each other. God is at the center of them all, and dangers that threaten society at times of transition also threaten the temple; conversely, to purify the temple is to remove the threat to society, to expiate sin, or to purify impurity.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("One may suggest that the origin of the ritual is the rite of 16:14–19, carried out either once a year or from time to time to rid the entire sanctuary of dangerous pollution and ending in the burning of the victim away from the sacred area (16:27). The rite of 4:3–21 is then a slightly attenuated form of this: entering the inner sanctum was avoided except on the Day of Atonement. One of the causes of pollution might be a mistake by the priest, and so the rite could be adapted to deal with unintentional transgressions by others as well, and also with their points of transition. The blood did not need to be sprinkled inside the shrine because laypeople could not enter it. The idea of the victim picking up a physical taint of pollution from the use made of its blood was fading, and the priests were in need of support, so the adapted offering became a perquisite of the officiant; the fading of the original idea also made it possible to declare a grain offering from the very poor, without any blood rite at all, an acceptable expiation (note the specific declaration at the end of 5:12: “it is a sin offering”). The symbolism seems to be gradually moving toward the idea of a gift to the priests which serves to right the offense.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Whenever Christians speak of “the blood of Christ,” they are using language derived from the sin offering. Crucifixion is not a bloody death; to speak of blood in connection with it is to image Christ’s death as a sacrifice, and since it is just in the sin offering that blood is used to expiate sin, it is this specific offering that has given rise to the language.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_c('b', [_vm._v("4:10")]), _vm._v(". Why is the prescription of the offering for the anointed priest not concluded like all the others with the ")]), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_vm._v("statement that “he shall make atonement for him, and he shall be forgiven”? The best suggestion (Milgrom 1991: 241) is that the first two paragraphs form a single case (this explains “the first bull” in v. 21); as the high priest’s error brought guilt on the people (v. 3), so the people needed to bring an offering. When the high priest has carried out this rite as well, his forgiveness is doubtless included in the forgiveness of the people (v. 20).")])]), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("5:1–13")]), _vm._v(". While each case in ch. 4 is introduced in the most general way, four quite specific cases are cited in 5:1–4. The most likely explanation is that these are borderline cases, cited to make clear that that kind of case was in fact included. These cases are all probably examples of offenses committed in negligence rather than by mistake, and are intended to stand for any number of similar cases. Although they are only doubtfully unintentional, they may all be expiated with a sin offering. But because of their doubtful character, confession is required (v. 5; cf. 6).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In v. 1 the “adjuration” is actually a “curse,” and it is probably directed at the unknown offender (see Judg 17:2), not, as the NRSV suggests, at possible witnesses. But anyone with information has a moral duty to supply it. Failure to do so is a sin, but it may be due to negligence rather than malice. In vv. 2–3, someone has knowingly become “unclean” (not an offense in itself) and has then forgotten it, so that he or she has failed to take the simple purification measures required (see 11:24–28; 15). The extension of the time makes it a more serious matter. V. 4: failing to fulfill a promise on oath could be just carelessness, but it is certainly more than an accident.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As a further concession the poor may bring doves instead of a goat or lamb, or even wheatmeal. 5:7: when doves are brought for a sin offering, there are always two, one for a burnt offering, perhaps simply to make more of a show on the altar (Milgrom 1991: 304).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Guilt Offering (5:14–6:7)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The Heb. "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("asham")]), _vm._v(" (lit. “guilt”) is translated “reparation offering” in the REB, following Milgrom 1976. Its use is much more restricted than the sin offering, and it is never offered in regular public worship. The main case in 5:15–16 concerns sacrilege, when someone inadvertently appropriates what technically belongs to God. According to Milgrom (1991: 320–26), this includes all holy things. But in 22:14 it seems not to include eating from offerings of the lowest degree of holiness (Marx 1988: 184; see the next section). The object of the offering is obviously to compensate God for his loss, or, from another point of view, to compensate the priests who would enjoy the use of the property. The provision that the ram should be valued implies that the offering may be commuted to money; in addition, the offerer has to repay the value of the misappropriation with a 20 percent penalty on top.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Two cases do not quite fit the rubric in 5:15. The first, in vv. 17–19, looks at first sight like one of the cases in ch. 4. But the translation is imprecise. The difference here is that the offerer never realizes what the offense is but only suspects it (Milgrom 1991: 331–34). One of the bugbears of the ancient world was the idea that one might have committed some serious offense against the gods without knowing it; part of the book of Job is spent repudiating this idea, which Job rejects. Since the offense was not known and might be the dreaded offense of sacrilege, the troubled conscience had to offer a ram for reparation rather than the less valuable goat or lamb for a sin offering.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But in 6:1–7 there is no doubt that the offense is deliberate and very serious: profaning Yahweh’s name by making a false statement on oath to conceal a property offense (see Exod 22:11). How is it that a deliberate offense can be expiated by sacrifice contrary to Num 15:30–31? Only, it would seem (Milgrom 1976), because the offender voluntarily repents and confesses (since there is no evidence, no one else knows). The offender is no longer sinning “with a high hand,” and if he properly restores what he has stolen or embezzled and offers reparation to God for his profanation of God’s name, he may be forgiven. Since the penalty for swearing falsely in God’s name was death at God’s own hands, this provision was a strong inducement to confess. Thus the ritual system, if its rules were judiciously bent, worked to reinforce the criminal justice system.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Regulations for Disposal (6:8–7:38)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This passage is primarily concerned with how the material of sacrifices is to be dealt with after the formal ritual has been completed. The section is primarily addressed to the priests (6:9, 24) because they had the responsibility of disposing of most sacrifices. The exception is the sacrifice of well-being, which is therefore left to the last, and in fact from 7:11 on the text is mainly concerned to regulate the layperson’s conduct. Supplements on related topics have been added in the editorial process: these are 6:19–23, 7:8–10, and 7:22–27.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Although the eating or other disposal regulated here is not part of the ritual, the offering remains holy, and care has to be taken not to infringe that holiness. Most of the regulations can be understood if we have in our minds the priestly picture of the world (see Introduction, 101). In this section we may see four grades in the “spectrum of holiness” (Jenson 1992): things may be “most holy” (lit. “holy of holies”), holy, clean (i.e., neither holy nor unclean), or unclean. The basic principle applied throughout the section is that material may not come into contact with people or places more than one grade lower in the scale.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_vm._v("All sacrifices other than sacrifices of well-being are “most holy.” They can only be eaten by priests and only inside the sanctuary. Burnt offerings, of course, cannot be eaten; but 6:8–13 ensures that the ashes, which were themselves holy, are safely disposed of. Other sacrifices are eaten by the priests; the raw grain offering is shared equally among the whole corps (6:16; 7:10; see above on 2:3, 10), while the baked grain offering (7:9, but contrast 2:10), sin offering, and guilt offering (6:26; 7:7) are the officiating priest’s reward for his work. One priest could hardly eat a whole ram or goat, but the regulations allow him to share it with his priestly brethren; only males of ")]), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_vm._v("priestly familes could be priests, so only they might eat (6:29; 7:6).")])]), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The offering of well-being is holy, not “most holy,” so it may be eaten by anyone who is ritually clean (7:19–21), and in any place not contaminated by ritual impurity (cf. 10:14). However, specified portions are priestly perquisites (7:28–36). As these portions are only “holy,” not “most holy”; they may be eaten by any (clean) member of a priest’s household, not only males (22:10–13). For “elevation offering” (7:30, 34) see the comments on 23:9–20.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The penalty of being “cut off from one’s kin” in 7:20, 21, 27 probably refers to divine punishment. See further on ch. 17.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("6:9, 12–13")]), _vm._v(". Many peoples have the tradition of an eternal altar fire. It serves a practical purpose: it was difficult to relight a fire before matches were invented; but it is also associated with the myth that the altar fire has an ultimate divine origin (9:24; cf. 1 Kgs 18:38).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("7:15–18")]), _vm._v(". A “votive offering” is one offered in fulfillment of a previous vow to do so if God did something for the worshiper (see, e.g., Gen 28:20–22). The difference in the time allowed is difficult to explain. But possibly the thanksgiving offering had to be eaten in the sanctuary, although it was only “holy” (Milgrom 1991: 419). This was the normal practice in older times for all sacrifices (1 Sam 2:13–14). For the limit of two days for other shared offerings see on 19:5–8.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Consecration and Inauguration of the Priesthood and the Sanctuary (Chs. 8–9)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The narrative flow resumes from Exodus 40. The new sanctuary has been constructed, and God has shown his approval by indwelling it with his glory (Exod 40:34). Leviticus 1–7 has prescribed the sacrifices which will be offered there. Now the ritual for which the sanctuary is designed must be inaugurated, beginning with the consecration of the priests who are to serve there. The account in ch. 8 follows fairly closely the instructions given in Exod 29:1–37, with some influence from Exod 40:9–15.")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("Priesthood")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("There are many accounts in the Bible of sacrifices being offered by laypeople, but this would not normally be possible at a temple, where priests officiated. At Jerusalem the status was hereditary in a clan: all males claiming descent in the male line from Aaron were priests of the Jerusalem temple, and traditionally of the tabernacle. Their functions were primarily ritual, to present sacrifices on the altar and, in the case of the high priest (represented by Aaron in this account), to serve God inside the shrine (Exod 30:7–8, 10; Lev 4:3–21; 16; 24:3–4, 8; Haran 1978). His position was not simply the headship of the priests but one of special sanctity (21:10–15).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("All this is associated with the concentric holiness of the sanctuary (see Introduction, 101). Wherever there is sacred space, sacred personnel are required to cross the perilous boundaries. Since many roles were hereditary in ancient Israel, this way of choosing them would be taken for granted. Conversely, the doctrine of sacred space was of convenience in reserving privileges.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("According to Exod 29:9; 40:15 the ordination of Aaron’s sons as priests was of permanent validity; their male descendants after them were born priests and did not require further ordination (Milgrom 1991: 555). But each new high priest, though he was already a priest, would have to be ordained to his role.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This account can be looked at from two points of view. On the one hand, it is the myth of the foundation of Israel’s cult and priestly order. Like other parts of the Pentateuch, it is a story in its own right, and the tragic sequel in ch. 10 is motivated by the plot of the story, not by ritual. On the other, it would to some extent be a mirror of the consecration rituals carried out in the author’s own time.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The complex of inaugural rites (chs. 8–9) falls into three parts: the rites of purification and consecration in 8:6–30 are separated by a period of seven days (8:33–35), during which Aaron and his sons must remain on the holy premises, from their inauguration on the eighth day (ch. 9). Only then does Yahweh show his approval (9:23–24).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This three-part pattern is one which anthropologists have observed in rites of passage, especially initiation rites, throughout the world (Van Gennep 1909, esp. 148–60; Leach 1976: 77–79). The initiates are separated from normal society in “rites of separation” and reintegrated into society in their new role in “rites of aggregation”; but in between there is very often a time in which they are “on the margin,” neither one thing nor the other, segregated from the rest of society in a special place and under special rules. This is known as the “liminal” (threshold) period. When the initiation is to a professional role, the rite of aggregation often consists in their carrying out their new duties for the first time. All these points are clearly illustrated in this account. During the seven days the ordinands are not yet recognized as priests, and yet they are no longer part of lay society.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The rituals in ch. 8 are easily interpreted as rites of separation. Their more precise symbolism tends to fall into one of three categories: (a) purification, moving from the unclean to the clean category; (b) consecration, or separation from secular life altogether, moving from the clean to the holy; and (c) the bestowal of authority. But the distinction between these is uncertain; for example, anointing with oil (vv. 10–12, 30) generally marks the giving of authority—Israelite kings were anointed; but in both places here the text says that it is a sign of sanctification.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The ordinands offer three sacrifices: for the types see the comments on 4:1–5:13, ch. 1, and ch. 3 respectively. The “ram of ordination” (vv. 22–29) is a type of sacrifice of well-being; the unusual feature is the use of the blood to daub the extremities of the offerers as a symbol of purification and/or consecration. The extremities stand for the whole person (likewise for the cleansed leper in 14:25); this follows the same principle as the daubing of the altar horns in the sin offering (ch. 4), or of the lintels and doorposts in the Passover of Egypt (Exod 12:22–23). All these are rites of purification or of protection against danger.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_109"
    }
  }), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_vm._v("The rites of ch. 9, which inaugurate Aaron’s and his sons’ service as priests, are a complete festival service. The sin offerings come first in each pair because the whole proceedings are a rite of passage in which Aaron and his sons pass to a higher, more sanctified walk of life and must run greater risks and pose greater threats to the sanctuary; as for the people, this is the first time they have been allowed to present any gifts at the altar, and their sin offering guards against the threats that they may pose.")])]), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The theme and climax of the day is the appearance of Yahweh’s glory to the assembled people (9:4, 6, 23). In theory, all rites at the sanctuary are carried out “before Yahweh.” His visible appearance (not as a form, but as cloud-wrapped brightness) can be told only in story, but it justifies and confirms everything that is done there. His appearance confirms Aaron’s blessing. The appearance of the glory is often repeated in P’s story of the wilderness wandering, frequently as the prelude to judgment—and we have to wait only three verses for this theme to appear here.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Death of Nadab and Abihu (Ch. 10)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This chapter concludes the account of the inauguration in two ways. A narrative about the tragedy of the newly ordained priests (10:1–7, 16–20) frames two groups of instructions to them: the first (vv. 8–11) gives basic guidance on the work they must do, while the second instructs them about the disposal of the sacrifices. This leads back to the narrative.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The narrative deserves to be evaluated as literature. If we view it from Aaron’s perspective, it is tragic in the strict sense (Houston 2000). He is at the pinnacle of his career and has just received the visible approval of Yahweh when at once his two elder sons (Exod 6:23) in their arrogance are struck down. The theme of sons disgracing a powerful father is common in the Hebrew Bible. Aaron cannot disown his sons, but neither can he defend them; hence his silence at Moses’ rebuke. His responsibility for the family tragedy may be more personal than that. He had been deeply implicated in the sin of the golden calf (Exodus 32).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Aaron’s agony is increased. Moses, who a moment before had shared his glory, now acts like an enemy, expressing no sympathy, forbidding any expression of grief, and finding fault with the surviving brothers for a technical ritual error. Aaron’s dignified and eloquent response receives Moses’ approval, thus resolving the tension.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Commentators have detected various coded messages in the story: a struggle between priestly factions (Gerstenberger 1996: 116–22) or a polemic against private incense offering outside the temple (Milgrom 1991: 628–33), with the danger of the invocation of other gods.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The chapter raises a number of further questions. In v. 3 Moses appears to quote a previous saying of Yahweh; but it is not found anywhere else.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Why Moses does not ask Eleazar and Ithamar to remove their brothers’ bodies is explained in 10:6–7. They were not allowed because of their sacred ritual status either to defile themselves with dead bodies or to leave the sanctuary (cf. 21:10–12).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The prohibition of alcohol to priests on duty (10:9) is explained in practical terms: priesthood was a calling requiring discernment. They had to be able to make the basic ritual distinctions (v. 10), exemplified in the previous (chs. 1–7) and subsequent (chs. 11–15) groups of prescriptions, and to teach Yahweh’s decrees to the people. The understanding of the priest as a teacher would originally have referred to ritual law, but it takes on a broader significance here.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The instructions in vv. 12–15 are explained in the comments on 6:8–7:38.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("10:16–19")]), _vm._v(". The offering referred to is the people’s sin offering in 9:15. The rule broken by the new priests is in 6:26 (compare 6:30). Given the general belief that substances used for purification were filled with dangerous power, Moses perhaps fears that the burning of the offering may suggest that Eleazar and Ithamar are still ruled by this superstition (Milgrom 1991: 639).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Aaron’s answer could mean that the death of his sons in the court of the tabernacle had recontaminated the sin offering, making it unfit to eat, but his mention of the other offerings seems rather to imply that the whole process of consecration had been thrown into doubt by the day’s happenings (Gerstenberger 1996: 120).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("At all events, the story leaves a ritual loose end: the sanctuary has been severely contaminated by the sin and still more by the dead bodies of Nadab and Abihu. How is it to be restored to purity? When the narrative thread is resumed in 16:1, this very question is taken up.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Impurities (Chs. 11–15)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Most readers will find it alien to regard bodily processes, dead animals, and dead human bodies (Numbers 19) as dangers, not in the hygienic sense but religiously, as hindrances to full participation in worship and in the extreme to the very presence of God with his people. But all peoples, including ourselves, regard certain things or processes as “dirty” and have rules about the “proper place” for certain objects or activities; whether they explain this in hygienic or religious terms, or refer to evil spirits, it is basically the same phenomenon. It is very likely that the ancient Israelites had a wide range of impurity beliefs and avoidance customs (see Deut 23:10–14 and Ezek 4:12–15), and that only some of these have been selected by the priestly writers to be given religious significance.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_vm._v("The system has an internal logic. Over against the holiness of the Tent of Meeting, a source of blessing for the people of Israel, a number of kinds of impurity stand as threats to the holiness of the sanctuary and thereby to the presence of God and the blessing which flows from it. Some have argued that defining these as “unclean” is simply arbitrary and that the internal logic of the ritual system corresponds to nothing in the real world. However, it is more common to explain ritual impurity as symbolically related to the realities of society in one way or another (see Douglas 1966). Ideas of impurity are related ")]), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_vm._v("to the general structure of ideas in a particular society, and this reflects the structure of society itself. Impurity arises from things which are seen as unacceptable or ambiguous in relation to boundary or structural lines, and it is seen as powerful only where such lines are clearly defined.")])]), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Most “impurity” is created by things which pass into or out of the body; in Leviticus many impurities are focused on the passage of blood (see 12:5, 7; 15:19, 25). It may quite naturally be that the sense of uncanniness or of danger in the bleeding of a human body, of the threat of formlessness and destruction, creates the potential for impurity beliefs. The same may be true of the deformation of the appearance of a “leper” (ch. 13). But it is unlikely that this potential would be realized unless this threat to the integrity of the body could be seen as in some way symbolizing a threat to the integrity of society.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Concern about the integrity of Israel as a whole is certainly present in the repeated formula “you shall be holy,” and in 20:24–26 this is quite specifically expressed as a concern for the separateness of Israel from all other nations. But this concern exists at the editorial level of the book and does not have a strong influence on the purity system as such, though it is applied as an interpretation to the distinction of clean and unclean animals.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Possibly of greater importance in relation to bodily impurity is concern for structures and lines of distinction within Israel: between men and women, or protecting liminal states (see on chs. 8–9). Very many peoples treat menstruating women as unclean (cf. 15:19–23), and this is generally related to a patriarchal social structure in which women are subordinate. In Leviticus this is balanced by the impurity attributed to male seminal emission and morbid flux (15:1–18). But Douglas (1966: 140–53) notes that where women are under strict physical control there is no menstrual uncleanness; it is the ambiguity of a position which treats women as commodities exchangeable between families but at the same time as persons with freedom to play men off against each other that is signaled by the impurity of their blood flow. Sex is “dangerous” where it creates conflict between different objectives in society.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Childbirth (ch. 12) is ambiguous in a slightly different way. It is a source of new life, of increase for the social group; but at the same time it is dangerous to the life of the woman herself, as suggested by the flow of blood. This has led to its being treated as a liminal state in many societies (Van Gennep 1909: 57–70): the new mother must be separated from general society for a certain period, and this is expressed in Leviticus by a purity prescription.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Another important function of impurity ideas is to back up morality where moral beliefs and social controls are too weak (Douglas 1966: 129–39). This is not operative in Leviticus 11–15, which deals mainly (except for 11:1–23, 41–45) with impurities which are involuntary or unavoidable; but in ch. 18 every type of sexual immorality is warned against on the grounds that it “defiles” both those involved and the holy land.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In comparing impurity in Leviticus with pollution beliefs in societies studied by anthropologists, it needs to be borne in mind that Leviticus does not tell us what popular customs were followed or beliefs held in respect to any of the conditions mentioned. Belief in impurity means a belief in danger: impurity is dangerous, either to people in general or to particular groups, and ethnographic literature is full of the unpleasant consequences which are held to ensue from touching a menstruant, having an adulterous wife, and the like. Milgrom (1991: 948–53) shows that such popular fears were also found among ancient Jews; but none of this appears in Leviticus. The concern of Leviticus has a thoroughgoing religious orientation; the danger feared is in 15:31: if impurities are not purified, the sanctuary, which is the sign of God’s presence among the people, will be defiled and the result will be death for the Israelites. According to Milgrom (1983: 75–84), grave impurities (those cleansed by sacrifice) affect the sanctuary without direct contact. This follows from the fact that the “sin offering” is designed to purify the sanctuary. However, the function of the “sin offering” may have evolved (see on 4:1–5:13). Others believe the concern is that an unpurified person might actually enter it. However made, the contact is fatal—not to God’s presence but to the people themselves. But because it inevitably happens, there has to be a way of dealing with it; hence ch. 16.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("An important effect of these chapters in their context in Leviticus is to bring impurity and sin close together. Although impurity is not sin in itself, neglecting to purify it may be (15:31; cf. 5:2–3), and sin can be thought of as impurity (18:24–30). They are "), _c('i', [_vm._v("structurally")]), _vm._v(" identical. Both have the same effect of defiling the sanctuary and ultimately of threatening the existence of the people (see ch. 26). Both are dealt with by the same rites in ch. 16. The repeated call to holiness has both alike in mind. “Purity of heart” is a metaphor for moral blamelessness. But Leviticus is interested in purity of body as well as of heart: its symbols are more than metaphors; they are active, material, everyday reminders of the call to holiness (D. P. Wright 1991).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Clean and Unclean Animals (Ch. 11)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("For this whole chapter see Houston 1993 or 2002. The arrangement of this chapter is as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "BPF"
  }, [_vm._v("Vv. 1–2a: Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "BPM"
  }, [_vm._v("Vv. 2b–23: Animals that may and may not be eaten.")]), _vm._v(" "), _c('p', {
    staticClass: "BPM"
  }, [_vm._v("Vv. 24–40: Impurity caused by the bodies of dead animals. This section is not concerned with animals as food, except for v. 40 in passing.")]), _vm._v(" "), _c('p', {
    staticClass: "BPM"
  }, [_vm._v("Vv. 41–45: Crawling animals forbidden as food, moving into the sermonic conclusion relating the prohibition to the holiness of the people.")]), _vm._v(" "), _c('p', {
    staticClass: "BPM"
  }, [_vm._v("Vv. 46–47: Summary.")]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("It is not clear why we leave the subject of food in v. 24 and then come back to it in v. 41. Probably vv. 41–42 were written by the (H) author of vv. 43–45, who realized that vv. 2b–23 had not covered one group of animals (see the comments on vv. 2b–23, 41–45; Houston 1993: 27, 54–55, 250).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_vm._v("The greater part of this chapter is different from the rest of chs. 11–15, including 11:24–40, in that, instead of telling what to do in cases of unavoidable uncleanness, it ")]), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("consists of prohibitions. Eating “unclean” or “detestable” food is forbidden because the people of Israel are to be holy. It may be that the prohibitions in the chapter were originally developed for the ritual situation, but vv. 43–45 apply them to the whole life of Israel: keeping these rules is an everyday way of showing their loyalty to Yahweh. This is typical of the H editors (cf., e.g., 19:2; 20:22–26, and see the Introduction, 102). Another version of the instructions in vv. 2b–20 is included in Deuteronomy (14:3–20), in a similar context.")])]), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("Rules Restricting the Use of Animals for Food (11:2b–23, 41–42)")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("All peoples have food taboos, though not all articulate them expressly. For example, English people would be horrified if asked to eat dog meat, and for a good reason: dogs are pets, our “best friends”; or for another, rather contradictory reason: dogs are “dirty.” In either case, eating dogs would violate boundaries of social significance.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The ancient Israelites and their neighbors ate a relatively restricted range of animals: mostly the cattle, sheep, and goats that they kept, with some game, mostly deer and gazelle, and birds such as partridge, which were trapped. Many people also ate locusts when they were available. Pigs were kept and eaten by many peoples of the area, especially in earlier times. They were probably fed garbage and were hardly ever brought for sacrifice, which suggests that quite apart from any rules people were consciously or unconsciously applying a symbolic grid to the animal world. They made the basic distinction between tame, vegetarian domestic creatures and wild creatures which ate blood and rejected human rule. Pigs and dogs, even if not wild, fell on the wrong side of the line because they were scavengers. Donkeys were not eatable for a different reason: because they were kept only to share human labor. On the other hand, among wild animals an exception could be made for deer and gazelles, which resembled cattle, sheep, and goats in appearance and habits. A number of East African cattle-raising peoples also restrict their eating of game to animals closely resembling cattle. (See Houston 1993: 124–217 for the whole paragraph.)")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("So this chapter develops common custom and makes a rule out of it. 11:2–23 fall into three sections corresponding to the three spheres of life: the land, the water, and the air. However, in many other places animals are divided into four groups, not three (see Gen. 6:20; 7:8; etc.), and this is true in this chapter taken as a whole. 11:2b–8 deal with the larger land animals (REB; NRSV in v. 2 is inaccurate), and vv. 41–45 with “creeping things.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("No beast is to be eaten which belongs to a type not acceptable for sacrifice (Firmage 1990). The acceptable animals can be identified by three criteria (v. 3): they must have hooves (NRSV here translates incorrectly), their hooves must be divided in two, and they must chew the cud. These tests are not arbitrary: they isolate that family of animals, the ruminants, to which those actually used for sacrifice belonged; it includes cattle, sheep, goats, deer, and gazelles. They also exclude three common domestic animals: dogs (no hooves), donkeys (hooves not divided), and pigs (they do not chew the cud).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("11:4–8 deal with borderline cases, which seem to have one or two of the criteria but not all three, and make it clear that to be acceptable beasts have to have all three. Camels do have cloven hooves, but there is a pad under their feet, so that the split does not extend all the way down. The rock badger or coney and the hare do not actually chew the cud, but they may give the impression of doing so. All these beasts are described as “unclean,” which implies that their corpses convey ritual impurity as well as being forbidden for food. This applies to all the forbidden beasts (see vv. 24–28). V. 8 is difficult since if it applied to all the forbidden kinds it would be impractical. It may apply only to times when ritual purity was required, that is, when visiting the sanctuary.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Seafood was not important, and only fish (with fins and scales) in dried form are likely to have been widely sold at the markets. So the rule in vv. 9–12 may be based on custom.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The chapter does not have a criterion to offer for birds acceptable for food but only a list of unacceptable ones (11:13–19). The identification of many of them is not at all certain, and the translations are little better than guesses. But there is good evidence that nearly all of them are birds of prey or carrion eaters, consumers of blood. Since locusts were eaten, ways of identifying acceptable insects had to be found. As in vv. 3 and 9, a test is developed on the basis of custom (v. 21); however, to make sure, the edible kinds of locust are also listed—again, the translations are guesses.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("All the great variety of “swarming” animals (“moving about on the ground,” NIV), including those as large as a mouse (11:29), are prohibited (vv. 41–42); probably, to begin with, they were not even thought of as possible food.")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("Impurity from Animal Carcasses (11:24–40)")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("There would be many situations in life in which it was necessary to handle the dead bodies of unclean animals: to bury a donkey, for example. In 11:24–38 this is seen as passing on a minor degree of impurity. This serves to emphasize the prohibition of their flesh. The rule applies only to land animals, and not to all of them. Vv. 24–28 cover all the larger land animals not permitted as food in v. 3. Vv. 29–38 select eight kinds of “swarming” animal; again the meaning of many of the names is uncertain, but the context suggests that they are all small animals which might be found in houses or cooking areas. Their dead bodies pass on impurity not only to people but also to objects.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("11:39–40 deal with animals permitted for food which die a natural death. V. 40 agrees with 17:15, but v. 39 clashes with 7:24.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Childbirth (Ch. 12)")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("See the comments above on chs. 11–15. Probably the ancient custom was to isolate a woman who had just given birth in fear of the dangers associated with that time of transition. But the effect of these prescriptions is less comprehensive. The impurity of the woman is connected with the vaginal discharge which continues for some ")]), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_vm._v("weeks, at first bloody like the menstrual discharge, later losing its color. Probably for this reason the impurity is seen as a two-stage process. In the initial period of seven to fourteen days, her impurity is of the same degree as if she were menstruating. This refers forward to 15:19–24; see that passage (and comments) for details. Afterward, until the end of forty or eighty days since the birth, she suffers a lesser degree of impurity which does not affect her ordinary activities (though many Jews in ancient times forbade marital intercourse during this time; Milgrom 1991: 748).")])]), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Why the period of impurity is longer after the birth of a girl than of a boy is uncertain. A common view is that it is longer because of the lower status of women in ancient Jewish society. But this is unlikely: note that a dead pig (Lev 11:24–26) is "), _c('i', [_vm._v("less")]), _vm._v(" polluting than a human corpse (Num 19:11–16), not more. A possible explanation (Magonet 1996) is that vaginal discharge is a not uncommon phenomenon in newborn girls. Magonet suggests that the mother is made to bear the potential impurity of the baby. But the more central role of men is indeed reflected by the circumcision of a baby boy (v. 3) as the formal rite of admission to the covenant community (see the comments on Genesis 17); there is nothing comparable for girls. This is not connected with the impurity of the mother, but is referred to as an essential part of the ritual activities surrounding childbirth.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The significance of childbirth is marked by a formal rite of passage (12:6–8). There are two sacrifices, as is customary in cases of impurity. One is the so-called “sin offering,” which has nothing to do with sin but serves the technical purpose of purification (see commentary on 4:1–5:13). The other is a burnt offering, which simply honors God (see also the comments on 5:7–10). After this rite the mother is “clean” in the sense that she can fully rejoin society.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Unclean Skin Disease and Similar Conditions (Chs. 13–14)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The so-called “leprous disease” which is the main subject of these chapters is not what is now called leprosy (Hansen’s disease). The descriptions recall such conditions as psoriasis, but they could cover a number of medically recognized conditions.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Beliefs about the supernatural origin of disfiguring disease were and are widespread. In ancient Israel “leprosy” was believed to be the result of offenses against God. (See 2 Chr 26:6–20; Numbers 12.) It seems to have been normal to isolate sufferers (2 Kgs 15:5), and in these chapters this custom is systematized. There is no explicit suggestion that sufferers are sinners, but the fact that they have to bring a guilt offering on readmission to the community (14:12; see on 5:14–6:7) implies that they may have committed sacrilege. Skin afflictions can be the result of psychological conditions, and a feeling of guilt might combine with the knowledge that such a condition was regarded as divine punishment to give rise to one (Lloyd Davies 1988).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Unlike the cases of the menstruant and the new mother, where the authors are not interested in the traditional custom of isolation and may be trying to repress it, isolation is prescribed for the sufferer of skin disease at two different points: a period of quarantine for unconfirmed cases (13:4, 5, 21, etc.), and living “outside the camp,” that is, away from the community, for a confirmed sufferer (13:45–46). Affected persons must make sure that everyone who does come near is aware of their condition, and must also behave like mourners (13:45). The purpose is not hygienic but ritual. The skin disease is seen as a particularly potent form of “uncleanness,” as potent as a corpse (Numbers 19). The risk is that another person might be unknowingly contaminated and then touch sacred food (Milgrom 1991: 805). Hence the need for exclusion. Symbolically, the condition is seen to be a kind of death in life.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The series of rites prescribed in ch. 14 for the “cleansed” sufferer is a complete example of a rite of passage. It is very much like the ordination ritual in chs. 8–9 (see the comments). The person proceeds from one state of life to another through a liminal stage of seven days marked at either end by a ritual. Here the initial rite of separation includes a traditional rite (vv. 4–7) which is rather like the scapegoat ritual in ch. 16. One bird is killed and its blood is used symbolically to purify the sufferer, while the other is set free, probably seen to be carrying the uncleanness away with it.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("After this the sufferer is no longer excluded but not yet fully “reaggregated” to the community (14:8b). The sanctuary ritual in vv. 10–32 fully readmits the sufferer. It includes a ceremony of purification (vv. 25–29) very similar to the rite of ordination in 8:23–24. This marks the movement of the person from a state of impurity to one of purity and perhaps protects the person in this dangerous time.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Alongside the main subject, the text picks out some kinds of mold on fabrics (13:47–59) and rot in buildings (14:34–53) as analogous conditions, and applies some of the same regulations to them. There are Mesopotamian parallels for this.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Genital Discharges (Ch. 15)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("For general considerations on ritual uncleanness, see the comments above on chs. 11–15. The final section of these laws is set forth as follows. Note the symmetrical arrangement of the rules.")]), _vm._v(" "), _c('table', {
    staticClass: "Table15",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_c('i', [_vm._v("Verses")])]), _c('td', {
    staticClass: "td-left-l"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("1–15")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("morbid male discharges, presumably gonorrhea")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("16–17")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("normal male emissions")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("18")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("sexual intercourse")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("19–24")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("normal menstruation")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("25–30")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("abnormal female discharges of blood")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("31")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("general comment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("32–33")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("summary of 15:1–30")])])])])]), _c('p', {
    staticClass: "Body1"
  }, [_c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_vm._v("The chapter brings to light an aspect of ritual thinking that has not been apparent in the previous four chapters: that “uncleanness” could be transmitted at a second ")]), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_vm._v("remove, from a person to an object and then to anyone touching the object.")])]), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The first subsection includes more detail than the others, and it is not easy to decide which of the details are meant to apply in the other cases and which are unique to the man with the discharge. Certainly only persons healed of "), _c('i', [_vm._v("abnormal")]), _vm._v(" discharges need to bring sacrifices (see the comments on ch. 12 for 15:14–15, 29–30), while bathing is required after all uncleannesses (15:13, 16, 18, but also, though unmentioned, for the women in 19–24, 28–30). It is also clear that the emission of semen is less severely polluting than either menstrual blood or morbid discharges. But do those who touch a menstruant have to bathe and wash their clothes (contrasting vv. 7 and 19); does her spittle convey impurity (cf. v. 8); should she wash her hands before touching anyone (cf. v. 11)?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Now the popular custom among the ancient Jews, as with many other peoples, was to isolate menstruants in the belief that their condition was dangerous to others. Among some groups they would not even be able to live at home (Milgrom 1991: 948–53). (We should remember that fertile women had periods much less often than now; they were married at puberty and spent the rest of their lives either pregnant or nursing—few survived to the time of menopause.)")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But in this chapter we do not find such a horror at menstruation. It does not imply that the menstruant can harm others by simply being in the same room or passing by. And the rules make it clear that the uncleanness is concentrated in the menstrual blood or other discharge itself. The only objects which can pass on impurity to people are those which have been underneath the person and so may actually have absorbed the fluid. A man touches his genitals when urinating, hence his hands may become unclean. The same does not apply to a woman; therefore, washing her hands is not mentioned (Milgrom 1991: 911). The conclusion must be that a menstruating woman could safely touch anyone or anything, and could live at home.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Israelite priests have often been accused of contempt for women and subjecting them to degrading rules. The truth may rather be, once one looks carefully at the surrounding culture, that they tried to lighten the burdens which custom imposed on them. However, it seems that people were generally unwilling to accept their more relaxed approach: so the woman with a discharge in Mark 5:25–34 tries to touch Jesus without his noticing.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("15:18: it is a very widespread idea that if one has not cleansed oneself after sex one is not fit for sacred things. Sex and the sacred are seen as belonging to opposed worlds.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("For 15:31 see above on chs. 11–15; it applies to the whole section.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Great Rite of Expiation (Ch. 16)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This chapter is pivotal to the book. It picks up the narrative thread from the end of ch. 10 and looks back to the teachings on sacrifice and on uncleannesses; it also looks forward to the teaching about how Israel is to be a holy people by referring for the first time to their deliberate sins (16:16, 21; the word translated “transgressions” in the NRSV occurs only here in Leviticus). The rite frees only the people collectively from their responsibility; individuals continue to suffer punishment for their own deliberate sins (Num 15:30–31).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("From the narrative point of view expiation is now necessary in view of Nadab and Abihu’s arrogant sin and the defilement of the tabernacle by their corpses. From the ritual point of view expiation will always be necessary, either in emergencies like the present or regularly every year as v. 33 ordains. Only thus can Yahweh’s continuing presence with his people be assured. The chapter ordains the ritual which is to be used each year on the Day of Atonement (v. 29; see also the comments on 23:26–32).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Day of Atonement involves three main types of ritual.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("a. The sin offering, or ritual to purify the sanctuary, for which see the comments above on 4:1–5:13. Here the blood is brought right into the inner sanctum, in this chapter called simply “the holy place” or “inside the curtain,” and the rite is explicitly given its original purpose (16:16, 19): to purify the entire sanctuary of accumulated impurity. Aaron offers sin offerings not only on behalf of the people but also on behalf of the priests themselves (“himself and his house,” vv. 6, 11), who naturally bear the greatest responsibility")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("b. A special ritual in which the sins of the people are symbolically laden on the head of a goat, which is then driven away into the wilderness (16:20–22). This is the famous “scapegoat” (from the KJV’s translation of “Azazel” [vv. 8 etc.]). The only thing similar in Leviticus is the initial cleansing rite for the so-called “leper” (14:2–7). In each rite there are two similar animals: one is slaughtered and its blood used for purification, while the other is let go to carry the evil far away. The sacrificed goat, along with the bull, cleanses the sanctuary, while the live goat removes the danger from the people in the camp.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("c. Thirdly, the public fast or ritual of penitence and humiliation (16:29–31), such as was often called on occasions of public emergency (see Joel 1:13–14; Jonah 3:5–9). Aaron’s confession of the people’s sin over the scapegoat would be pointless unless the people themselves expressed their sense of penitence before God. The kind of activities involved are vividly rendered in Isa 58:3–5. This part of the rite continues to be solemnly observed by Jews after the temple and its ceremonies have vanished.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_vm._v("The divine speech (16:2b–34a) is structured like this. Vv. 2b–28 give instructions to be passed to Aaron. Vv. 2b–5 explain how he is to prepare. V. 6 begins the instructions for the ritual; but in vv. 7–9 the text digresses to ensure that the two goats are distinguished and prepared for their fates before Aaron begins the sacrificial ceremony. In this way we get an overview of the ceremony. V. 11 then takes us back to where we left off, repeating v. 6, and the prescriptions move straight forward to v. 25; vv. 26 and 27–28 clear up details of disposal, not necessarily in chronological order. Vv. 29–34a switch abruptly into address to the people (characteristic of H), telling them of their own part in the rites. These verses for the first time mention ")]), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_vm._v("that the rite is to be carried out once a year, and give the date.")])]), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The rite is impressive in the weight and range of its symbolism. The priestly system draws sharp boundaries: between clean and unclean, holy and profane, tabernacle, camp, and wilderness, God, priests, and people. But real life is not like that. In reality the boundaries are fuzzy; and sin and impurity continually make them more fuzzy. The rites of atonement restore the confused categories (Davies 1977: 395).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Davies shows how a whole series of symbols reinforces this message. To begin with, everything earthly, including the high priest and the holy of holies, is seen as impure and therefore at the farthest pole from God. The people fast and humble themselves. Aaron wears simple white vestments (16:4) in place of his gorgeous regal robes (Exodus 28; Lev 8:7–9), and puts these on again only after the main ritual is complete (16:24). The blood of the sin offerings represents life (Lev 17:11; Davies 1977: 395), and it is brought into the holiest place to restore God’s lively presence. The scapegoat goes out in the opposite direction, out from the holy place into the place of uncleanness, to take Israel’s sins away with it. All the symbols work together to suggest that the proper categories and relationships are being restored. The sanctuary and its priests become pure and holy once more, and the people are cleansed of their sins (v. 30).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A few details require explanation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The words “atone” and “atonement” render Heb. "), _c('i', [_vm._v("kipper")]), _vm._v(". See the comments on 4:1–6:7. This translation is often awkward here, and in places it would be better to translate it “purify” or “remove sin.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The “mercy seat” in 16:2, 13–15 is the golden cover over the ark (Exod 25:17–22). The name in Hebrew, "), _c('i', [_vm._v("kapporet")]), _vm._v(", gives the impression of being connected with "), _c('i', [_vm._v("kipper")]), _vm._v(", “to make atonement”; hence the NRSV translation (from the KJV): the place where atonement is made.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Who or what is “Azazel” in vv. 8, 10, and 26? It is likely to be the name of a demon. It is a surprising thing to find in the strictly monotheistic priestly text, and shows that the scapegoat rite goes back to an earlier stage in Israel’s religion. However, if at one time the idea was that the goat was presented to Azazel as a way of diverting his unwelcome attentions from the people, that is not so in this text, where the name simply survives as a way of denoting the destination of the goat.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Which altar is referred to in 16:18: the altar in the court or the incense altar in the tabernacle? Probably the former, but there are some who think that it is the latter, because of Exod 30:10. However, probably the words “so he shall do for the tent of meeting” in 16:16 refer to the purification of the altar of incense (cf. 4:6–7).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the NT the rites of the Day of Atonement are taken as the (imperfect) model of Christ’s sacrifice, particularly by the Letter to the Hebrews (Heb 9:6–14, 23–28; 10:1–20; 13:11–12). Today we are accustomed to the idea of a “scapegoat” as a human victim who is identified as an easy target on which to discharge the accumulated hatreds of a community, or responsibility for a crime, thus reinforcing the bounds and categories of society by the unbridled expression of violence. The rites of the Day of Atonement achieved this, with violence, certainly, but in a strictly controlled and symbolic way. If there must be a victim, which is preferable: two goats or six million men, women, and children?")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Shedding the Blood of Animals (Ch. 17)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This chapter is principally concerned with the slaughter of animals for food, and above all with the way in which the blood should be dealt with. It contains five distinct laws: 17:3–7, 8, 10–12, 13–14, and 15–16; the NRSV is misleading in making a break between vv. 13 and 14. All are drafted in such a way as to bring the issue of “blood” to the fore (Schwartz 1991).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("For the Israelites, as for many other peoples, the shedding of an animal’s blood was a focus of symbolism and ritual. Blood was considered to be impregnated with power, the power of “life” (v. 11), which had to be handled with great care. Consumption of blood, even as part of the meat, was and is scrupulously avoided, and the main object of this chapter is to reinforce this ancient taboo, possibly when it was threatened at a time of traumatic social change.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("People normally slaughtered their own animals; slaughtering and butchery were not specialized trades. The method of slaughter is still used by the Jewish slaughterer "), _c('i', [_vm._v("("), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("shoḥeṭ")]), _vm._v("):")]), _vm._v(" a sharp knife is drawn across the throat, and the blood spurts from the carotid arteries as the heart is still beating. Except among the wealthy, the eating of meat was a relatively rare event nearly always associated with a celebration, and in early times it is likely that the slaughter of domestic animals was always a religious ceremony, a sacrifice.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first law, in 17:3–7, confirms this but demands that the Israelites use only one official altar. It is unclear how it is related to the law which permits secular slaughter in Deut 12:15–16, 20–25 and which regulates Jewish practice today. The best explanation may be this (for a different view see, e.g., Knohl 1995: 218–20; Milgrom 2001: 1503–14). In Deuteronomy 12 the normal ancient practice is specifically challenged and secular slaughter encouraged as part of the attempt to eliminate all altars but one. Probably this attempted transformation of popular culture was not successful. Slaughter would have continued to be surrounded with a religious aura. If it could not be carried out at an official shrine of Yahweh, it might be directed toward some other god (v. 7). This law tries to deal with this danger by requiring all domestic animals for slaughter to be brought to the temple (for which the “tent of meeting” stands in the wilderness setting of the text) for sacrifice to Yahweh. But this remained a dead letter. Vv. 8–9 then reinforce the law of Deut 12:8–14.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("17:4 it says that anyone who slaughters an animal away from the sanctuary is “guilty of bloodshed.” Normally this phrase refers to the killing of a human being. This language may be used to underline that blood has been let loose in an uncontrolled and dangerous manner, as in manslaughter. There appears to be an implied criticism of Deut 12:16.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_115"
    }
  }), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_vm._v("For 17:5–6 see the comments on chs. 1–7.")])]), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("17:11 offers a theological justification for the ancient rule; for detailed comment see above on 4:1–6:7.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("17:15 belongs here because an animal that has died of itself or been killed by wild beasts will not have had the blood drained. However, compared with Exod 22:31 or Deut 14:22 this law is not rigorous (cf. 11:40). H imposes a higher standard on priests (22:8) but is concerned for the poor (Milgrom 2001: 1487).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Most of the laws here are binding on the alien as well as the Israelite. This is a characteristic of H and its concern with the holiness of the land they share (18:25).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("All the laws have the same sanction attached: that offenders will be “cut off from [their] people.” It is uncertain what this means. The death penalty has its own vocabulary (e.g., 20:2); therefore, this phrase seems to refer to divine punishment. It is possible that it refers not to the sudden death of offenders but to their failure to establish a line of descendants or to be gathered to their ancestors in the underworld after death.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Leviticus 18–20 form a small block of teaching on being the Lord’s people in the secular realm. Ch. 20 refers back to ch. 18 repeatedly, and this highlights ch. 19 as the central part of the teaching.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Sexual Prohibitions (Ch. 18)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This speech consists of a general sermonic exhortation addressed to the nation as a whole (18:2b–5, 24–30), framing two series of prohibitions addressed to the individual, always the man.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The sermonic framework (18:2b–5, 24–30) is developed around certain key themes and phrases. The moral standards demanded are Yahweh’s commands (vv. 4, 5, 26, 30), and correspondingly the reminder “I am the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" (your God)” frames the entire discourse and is frequently repeated (within the series of prohibitions also at vv. 6, 21). We shall come across this formula repeatedly in the next eight chapters; it is one of the hallmarks of H. It is clearly a seal of authority, reminding the hearers from whom the commandments come; but in origin it is Yahweh’s self-introduction (see Exod 6:2); the commandments expand their knowledge of who Yahweh is (Zimmerli 1982:12). But more than that it reminds them, in its longer form, of the basis of Yahweh’s authority in that they belong to him and he to them (cf. 25:55; 26:12–13, 42–45); and expansions of the formula (e.g., 19:36; 22:32–33; 26:13) root this in his rescue of them from Egypt.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Second, the standards are seen as setting Israel off against the nations, particularly the Egyptians and the Canaanites. Later passages (e.g., 20:22–26) see the exodus as an act of God dividing Israel from the nations (see Crüsemann 1996: 301–3). Here a sense of national distinctiveness is encouraged by projecting immorality on others. We should not take it at face value and assume that 18:24 is simple historical truth. All the peoples of the area had very similar moral standards, especially when it came to incest.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Third, the sins in question are described as “defiling” both the people and the land. That is, they are comparable to the kind of ritual uncleanness dealt with in chs. 11–15; see the comments there and the Introduction. In vv. 17, 20, 22, and 23, the idea that certain sexual conduct is wrong is based not on its objectively damaging character but on the notion that it is “unclean” or “abominable.” This idea is found in many cultures, perhaps arising from the symbolic function of these prohibitions in reinforcing social structure. For a man to take the role of a woman in the sexual act, or for the fundamental boundary between humans and animals to be blurred, symbolically threatens the foundations of society. This is a ritual function: we cannot draw a hard-and-fast line between morals and ritual in Leviticus. (See 103.)")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There appears to be a shift in time between 18:3 and 24, where Yahweh is about to cast out the inhabitants of the land, and vv. 25 and 27–28, where they have already gone, contrary to the setting of these speeches. This is a natural rhetorical shift.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Although the difference between the two series is quite clear, the point where one ends and the other begins is not. 18:7–16 prohibit intercourse with close relatives, and the prohibitions are all set in the same style (v. 6 is an introduction, addressed in the plural). Vv. 19–23 prohibit various types of conduct considered outrageous and are more varied in style. Vv. 17 and 18 are similar to vv. 7–16 but are concerned with marriage rather than with sex in general; and v. 17 concludes with the kind of moral assessment found in vv. 20–23, whereas the rationales found in vv. 7–16 appeal to family sentiment. Probably vv. 7–16 (plus 17?) are an old group of instructions for family members taken over by the editor.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The prohibitions are closely related to a particular order of society, and, as far as v. 22 is concerned, the Bible as a whole does not take into account variations in sexual orientation. These facts should be borne in mind whenever it is suggested that texts from this chapter should determine sexual ethics in the present day.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("All human societies have incest taboos since society is based on clear lines of structure in the family, but they vary somewhat. 18:7–16 (17) give a restricted list compared with that of many societies; Israelite society was broadly endogamous, preferring marriage within the clan (see, e.g., Gen. 24:3–4, 15). The prohibitions are not based on any one principle. Three types of relationship are prohibited (Bigger 1979): ones with wives of members of the group of related males (vv. 7, 8, 14–16); these women’s sexuality is explicitly identified with their husbands’; ones with female members of the male descent group (vv. 9–12); and in v. 13 one relative in the female line. Bigger believes that prohibitions of the first type would lapse on the husband’s death (so that v. 16 would not clash with Deut 25:5–6). But this is doubtful in view of 20:21.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The main problems presented by the list are the absence of the daughter—incest with a daughter is the commonest type in our society—and the overlap of vv. 9 and 11. In ancient Israel a man’s daughter was directly under his own control. It may therefore have been thought improper to interfere with his rights. However, virginity was a normal requirement for marriage, and if a man abused his daughter he would lose the bride-price he could otherwise expect for her.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_116"
    }
  }), _c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_vm._v("It seems possible (Elliger 1966: 231–32) that 18:9 was originally intended to cover one’s full sister and v. 11 one’s half-sister, but both verses have been expanded in a way which makes them overlap.")])]), _c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In the second series 18:19 deals with what was always considered a major sin (Ezek 18:6 links it with adultery alone) because of the “impurity” (15:19–24) of the woman’s periods. V. 20 deals with adultery; the NRSV’s use of “kinsman” is misleading—the word means “fellow citizen.” V. 21 may be found here because it is also concerned with family relationships; for comments see 20:2–5. Why lesbianism is not mentioned is uncertain; perhaps the men who compiled the chapter simply had no knowledge of it.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Holiness in All Things (Ch. 19)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The central speech in chs. 18–20 differs from the other two, and all other speeches in the book, in that it brings together a variety of instruction on different topics. It does, however, have a detectable structure. 19:2b at the beginning: “You shall be holy, for I the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" your God am holy,” and v. 37 at the end are a theological framework. Everything in between is both a command of Yahweh (v. 37) and a way of being “holy” (v. 2), and most of the groups of commands are linked with this theological framework by the refrain “I am the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("” (see the comments on ch. 18). The commands fall into three large groups (Magonet 1983): vv. 3–18, 19–29, and 30–36; at the beginning of each is the command to “keep” God’s sabbaths or statutes, and the third group echoes and develops the first in several ways. There is a clear climax at v. 18, and this is echoed in v. 34, near the end of the third group. Where there are small groups of commands, they are generally related to each other (e.g., vv. 11–12).")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("Holiness")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The first appearance of the theme of “holiness” in the so-called Holiness code is in v. 2; it is developed through chs. 19–22, and the sermonic material in chs. 18, 25, and 26 is related; see also 11:44–45. What does it mean to call God holy, and what does it mean for the people to be holy? God’s holiness is that numinous, awesome, at times terrifying power which we see in Isaiah 6, proclaimed by the seraphim, or in this book in the story of Nadab and Abihu (10:1–3); no sinner can approach it and live.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But in that case how can the people also be asked to be holy? It sounds as if they are being asked to imitate God, but this is not really so. In ritual, people may be holy in that they are dedicated to God and as a result must observe certain taboos: examples are the priests in 21:1–15 and the nazirite in Num 6:1–21. And when laypeople prepared to meet God in his sanctuary they had to be ritually pure (e.g., Exod 19:14–15), and this is called “sanctification,” making oneself holy, literally, in the same sense as the priests. But they should also be "), _c('i', [_vm._v("morally")]), _vm._v(" pure (Psalm 15; 24:3–6).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Now H uses this ritual idea to apply to the whole of life. Because the Israelites belong to Yahweh, not just when they are in the temple but all the time, they must all the time be “holy” in the sense that they are faithful to him, obey his commands, make the proper distinctions (which we might see as ritual or moral), and live rightly with one another. And Yahweh has “sanctified” (22:32), “separated” (20:24) them (by the exodus) precisely for this purpose. Although in P only some Israelites are holy, H is not in disagreement: it is using the word in a new, expanded sense.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The speech does not aim to be comprehensive but to give examples. It shows connections with the Decalogue (Exod 20:2–17; Deut 5:6–21) and with the Deuteronomic code (Deuteronomy 12–26). But the parallels are haphazard in order and varied in wording. The codes are the work of reformers active around the same period, but they did not necessarily copy each other’s work.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("19:3–18 are a basic religious and moral code for life in a small but unequal community. Most of the contacts with the Decalogue are in this section.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("19:3–4. The opening commands lay down the authority structure of the community; the individual is subject to parental authority, and the community as a whole is subject to Yahweh and no other god; his “sabbaths” (again in v. 30) are a symbol of this. This opening echoes four of the first five of the Ten Commandments (see Exod 20:2–12).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("19:5–8 repeat the command of 7:15–18, without the distinction of thanksgiving offerings made there; but see 22:29–30. The code selects one sacrificial regulation which the laity was responsible for keeping. The reason for it has nothing to do with hygiene. The holiness of the offering is profaned, perhaps because time exposed the eaters to the greater danger of uncleanness—for example, a woman might start her period—or of carelessness.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("19:9–18 turn to relationships in the community. Vv. 9–10 (see also Deut 24:19–22) seems to offer very meager assistance. However, the practice may be an ancient one, originally for the benefit of the spirits of the field. The monotheistic teachers turn this superstition to the benefit of the community. It is only a minimal demand, and personal generosity may (may!) make it more adequate.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("19:11–18 is a series of basic requirements for harmonious community living arranged in four almost equal groups of brief commands. Vv. 11–12 deal with deceitful practices among equals, while vv. 13–14 forbid taking advantage of those weaker than oneself. “Defraud” and “steal” in v. 13 are translated incorrectly in the NRSV; “exploit” and “rob” would be more accurate; both verbs refer to exploitation of the poor. The context of vv. 15–16 is the lawcourt. The phrase translated “profit by the blood” in v. 16 is very uncertain: “place someone’s life in jeopardy,” “conspire against,” and “stand aside when someone’s life is in danger” have all been suggested. Both judges and (potential) witnesses have a duty to see that justice is done.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_vm._v("19:17–18, finally, root relationships in basic attitudes and day-to-day conduct. The behavior condemned is the feuds so characteristic of life in small communities. “Anyone of your kin” in v. 17 is misleading: literally it is “brother,” but it refers to any member of the community. V. 17b is uncertain. It is not clear whether “reprove” means to act privately (cf. Matt 18:15–17) or to begin a legal ")]), _c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_vm._v("action (to prevent grudges from festering), and “or you will incur guilt yourself” might rather be “do not expose "), _c('i', [_vm._v("your neighbor")]), _vm._v(" to the guilt” of pursuing the feud. “Love” (v. 18) means to act practically for the neighbor’s benefit just as you would act for your own (another interpretation is found in the REB).")])]), _c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The second section, 19:19–29, contains commands placing limits on the use of God’s gifts as an expression of holiness. Most of them have close parallels in Deuteronomy, which is also concerned with the holiness of Israel (Deut 14:1).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("19:19 (cf. Deut 22:9–11) perhaps shows that these mixtures of species were seen as transgressing boundaries in the same way as bestiality (18:23) and consequently symbolically threatening society. However, it may be that the wool-linen mixture (see Deut 22:11) was reserved for sacred use (see Exod 26:1, etc.; Haran 1978: 160).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("19:20–22 are a legal conundrum with a ritual solution. Adultery in this tradition is subject to the death penalty (20:10), and this applies as soon as the woman is betrothed (Deut 22:23–24). But violating a slave is only a trespass against property (cf. Exod 21:20–21). A sin has been committed, but it is not legally punishable. The solution is the guilt offering, which in 6:1–7 may be used in cases of deliberate fraud to supplement an inadequate legal system.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("19:23–25 give religious reasons for a sound practice. No fruit may be enjoyed from a tree before God has been given his due. Why is the fruit of the immature tree described as “uncircumcised” (see NRSV footnotes)? Probably because circumcision was originally practiced on boys at puberty to prepare them for marriage, and not in infancy (12:3). There is a symbolic connection between circumcision and fertility and between fruit and the genitals (Eilberg-Schwartz 1990: 146–54).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("19:26–28 prohibit ritual practices seen as damaging to Israel’s holiness. For v. 26a see on ch. 17 (cf. Deut 12:23–25); for v. 26b (cf. Deut 18:10) see on v. 31. The practices in vv. 27–28 (cf. Deut 14:1) are all mourning rites taken for granted in earlier writings (e.g., Isa 22:12; Jer 16:6). But for H self-mutilation identifies the living with the dead too closely (that is its object), and therefore again (cf. v. 19) blurs boundaries important to society (Schmidt 1994: 178).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("19:29 (cf. Deut 23:17) arises, once more, from a standard of decency governed by a concern for proper boundaries. A man might be strongly tempted by poverty to prostitute his daughter; but prostitutes were slaves and foreigners, not free Israelites.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("19:30 introduces the final section of the speech, which picks up issues from the first section and supplements them.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("19:31 picks up v. 4. It condemns the practice of obtaining oracles from the dead through mediums (cf. Deut 18:11 and see 1 Samuel 28). The NRSV translation is probably incorrect: the Hebrew words refer to the ghosts themselves, not the mediums. All means of attempting to foretell the future are condemned which do not acknowledge Yahweh’s authority (cf. v. 26).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("19:32 extends the shaping of family authority seen in v. 3 into the community.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("19:33–34. People who did not belong to the community and had no landed stake in it were especially vulnerable to exploitation (cf. vv. 9–10, 12–13). Equality in responsibility (17:12; 20:2; 24:22) must imply equality in protection. The command in Exod 22:21; 23:9 is repeated, with the language of v. 18, so that it becomes clear that the command to love one’s neighbor is not limited to Israelites. The message of the Good Samaritan (Luke 10:29–37) is not original!")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("19:35–36 begin with the same command as v. 15 (this is obscured in the NRSV) but goes on to develop v. 12 in its application to the commercial world. There were no publicly ordained standards of measurement in antiquity, which left the door open to sharp practice. The “ephah” was a dry, and the “hin” a liquid, measure of capacity.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Punishment (Ch. 20)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This speech prescribes punishments (mostly capital) for a range of serious offences. All the offenses are ones which have been denounced in the previous two chapters, mostly in ch. 18 but also in 19:3 (implicitly, 20:9) and 19:31 (20:6, 27). The core is 20:9–16, probably an old code prescribing the death penalty for a series of family offenses; the editors have framed this with penalties for offenses they were especially concerned about, and with exhortation. Those in vv. 17–21 are all sexual offenses denounced in ch. 18, and it looks as though the object was to include all significant crimes from that chapter which had not already been dealt with.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Could this chapter be described as a criminal code? Many of the laws (20:6, 17–21) do not prescribe the death penalty but simply say that God will punish (for “cut off” in vv. 3, 5, 6, 17, and 18 see on ch. 17). Why this particular choice of offenses? Can one imagine the chapter being of use to a court of law?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Although we know of many early “codes” of law from the ancient Near East, it seems that they did not directly govern the decisions of courts. A criminal code would include those crimes that by custom were normally punished, without necessarily being binding on courts. Vv. 9–16 is such a code; it includes those offenses felt to be the greatest threat to family and social structure. But the editors’ concern is not so much with legal consequences as to warn their audience of those offenses against God’s dignity and against decency which most gravely threatened their status as God’s holy people. There was no precedent for a humanly executed death penalty for the offenses in vv. 6 and 17–21, so none is given, but the text is confident that God would punish them. In any case, though adultery (v. 10) was by far the commonest of these offenses, we know of no occasion when the death penalty was ever actually enforced (McKeating 1979), though some precedent must have existed (see also Deut 22:22). So even in vv. 9–16 the law may be theoretical rather than practical.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_vm._v("The reason why the death penalty is appropriate is expressed in v. 14, combined with v. 7: that kind of offense has to be rooted out so that the people may be holy to Yahweh. Vv. 2 and 27 speak of stoning. The probable reason ")]), _c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_vm._v("for this mode of execution is that the whole community was involved. In case of any dispute over the verdict or penalty, no one person can have the finger pointed at them as the executioner. To make doubly sure, in most cases the phrase “their blood is upon them” is added. This relieves those who carry out the penalty of the guilt of bloodshed.")])]), _c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The subject matter of the offenses has been dealt with in the comments on ch. 18 or 19, except for the first, in 20:2–5. This probably deals with a ritual in which a child of the worshiper was sacrificed (18:21) to a god, here called “Molech,” and burned (2 Kgs 23:10); other texts (e.g., Deut 18:10; 2 Kgs 16:3) refer to “passing one’s child through fire” without mentioning Molech. “Molech” is probably derived from the divine title "), _c('i', [_vm._v("melek")]), _vm._v(", “king,” with the vowels (added by the scribes) of "), _c('i', [_vm._v("boshet")]), _vm._v(", “shame.” The god in question may have been a god of the underworld (Heider 1985). But there are many uncertainties. The original “king” may have been Yahweh himself (Jer 7:31; Ezek 20:25–26 might suggest this). This would explain why it “defiles my sanctuary” (v. 3). But if so, the author was passing on a tradition which he did not understand.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In 20:24–26 a new theme appears in the exhortation. Being holy to Yahweh involves being “separated” from other peoples, in order to be granted the land. The dietary laws (ch. 11) are brought in here as a symbol of this “separation.” The same verb is used in Ezra 9:1 when Ezra demands that the Jews should put away foreign wives. This understanding of the symbolism of the dietary laws remained influential, and the refusal to share Gentiles’ tables expressed it in practice. Acts 10 uses it in order to reverse the demand for separation.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Rules of Holiness for the Priests (21:1–22:16)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("It is clearly the ritual functions of the priesthood (see above on chs. 8–9) that determine the presentation here (see 21:6, 8, 12, 17, and 21): it gives ritual taboos and disqualifications and is silent on moral or spiritual qualifications. Because the priests are active in holy places and handle holy things, they must observe rules of ritual holiness which are more stringent than those applying to laypeople. The first group, 21:1–15, gives prohibitions relating to two areas of life: death and sex; and here the high priest (vv. 10–15) is subject to more stringent rules even than ordinary priests. The second, 21:16–23, disqualifies priests with physical deformities from performing priestly functions. The third, 22:1–16, is devoted mainly to prescribing the conditions under which priestly food may be eaten.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("21:1–15. See Numbers 19 and comments. Laypeople are expected to bury the dead and comfort mourners, and then be purified from the uncleanness involved. But the priests’ degree of holiness demands that this defilement should be avoided in any case. The high priest (vv. 10–11) is absolutely forbidden to go anywhere near a dead body, or even to show any of the customary outward signs of mourning. A concession is made to the ordinary priest: he may bury his close relatives (vv. 2–3). It seems as if this does not include his wife (his sons would see to that), though the translation of v. 4 is uncertain. In Ezek 24:15–24 the specific signs of mourning Ezekiel is forbidden to show (as a prophetic sign) are not forbidden to ordinary priests. V. 5 forbids only what is forbidden to all Israelites in 19:27–28.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is typical of the patriarchal culture promoted by Leviticus that the threat of uncontrolled sex to priestly holiness is focused on women, as marriage partners (vv. 7, 13–15) or as daughters (v. 9; cf. 19:29), rather than on the conduct of the priests themselves. The requirement that the high priest may marry only a virgin, and one who herself belongs to the priestly clan (v. 14), may be intended to protect the purity of the descent line; but all priests are required to avoid marrying a woman who might be suspected of unchastity.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("21:16–23. Just as sacrificial animals must be unblemished (22:17–25), so must the priest who offers them. This is not a matter of ritual purity, for a disabled or deformed priest may eat offerings for which ritual purity is required (21:22; cf. 22:3). Rather, it is a question of what is fitting in the presence of God. (Is this why the healing of deformities is a frequent accompaniment of preaching the kingdom of God in the Gospels?) Many of the items in the list in vv. 18–20 are of uncertain meaning. There are twelve, as there are twelve disqualifying blemishes in victims (22:22–24), and many of the same words are used; this underlines the correspondence between the things and the personnel in each degree of holiness.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("22:1–16. Priests were maintained by gifts that were technically gifts to God: portions of sacrifices (see 6:8–7:38 and comments), first fruits, tithes, firstborn of cattle. They are subject to the same restrictions as laypeople (7:19–21) in eating them (21:3–7). For the impurities mentioned in vv. 4–5, see chs. 11–15. 21:8 gives a rule on a related subject; like the rules in 21:1–15 it imposes a more stringent standard than for laity (17:15). Vv. 10–13 make clear who may eat holy gifts (not most holy, which may be eaten only by actual priests [6:16–18, 29; 7:6]): those who are regular members of a priest’s household but not temporary bondservants (cf. 25:40). For 21:14–16 cf. 5:15–16.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Rules for Sacrificial Offerings (22:17–33)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The passage on holiness is completed by returning from rules for the priests to address all Israel once more. The rationale for the demand in 22:17–25, which elaborates the words “without blemish” in 1:3 etc., is clearly expressed in Mal 1:8. To offer substandard sacrifices to God is no more acceptable than offering substandard gifts to an earthly ruler, and to allow it would rapidly lead to a situation in which it would be acceptable to get rid of unhealthy animals by way of the altar. For the sacrificial terms see the comments on chs. 1–7, especially 7:11–18.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_vm._v("The two rules in 22:27–28 are probably not due to humanitarian concern. There is once again a concern with symbolic boundaries: birth and death are kept apart. Eilberg-Schwartz (1990: 123–25, 128–34) suggests that, as with the rules on blemishes, rules about animals metaphorically echo rules about human beings: v. 27 echoes ")]), _c('a', {
    attrs: {
      "id": "page_120"
    }
  }, [_vm._v("the eighth-day circumcision rule for human male children (12:3), and v. 28 echoes the incest rules, particularly 18:17 and 20:14.")])]), _c('a', {
    attrs: {
      "id": "page_120"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("22:29–30 repeat the rule in 7:15 (see comment there).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("22:31–32. Through chs. 19–22 the idea of holiness has been developed, and it is finally stated here in a more subtle form than in 19:2. Like the priests, the whole people are “sanctified,” or called to holiness, by Yahweh himself. Their obedience is required in order to retain their holiness; and though Yahweh is in himself holy in a way that nothing external can affect, he has a “name,” a reputation that depends on the obedience of his people, so that his holiness can even be said to depend in a sense on his people. This becomes a constant theme in Ezekiel (e.g., 36:20).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("A Calendar of Festivals (Ch. 23)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Two main theological ideas, which in practice are in some tension with one another, have come together to structure this chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first is the idea of sacred time. Just as there are holy places and people, so there are holy days, times when the normal business of life is suspended and the community is devoted solely to God. In this way the whole of time is claimed as under God’s authority. This idea requires that the times should be precisely fixed; so in this chapter there are several dates; and a calendar is presupposed according to which these dates are fixed (see below). Besides the weekly rhythm of sabbaths (23:3), there are seven major holy days in the year, when there is “a holy convocation” (better, “a holy occasion” [JPSV]; lit. “a holy proclamation”) and no work is to be done (vv. 7, 8, 21 [but this one not precisely dated!], 24–25, 27–28, 35, 36).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The other idea is that at appropriate times of the cycle of the agricultural year God should be praised for his goodness and his blessing sought for the future. The tension arises in that the harvest does not begin or end on fixed dates every year, or on the same dates everywhere. Probably (Knohl 1995: 8–45) a calendar of sacred time like Numbers 28–29 has been edited to develop the aspect of agricultural rejoicing and seeking of blessing.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This accounts for the missing dates. The firstfruits ceremonies in 23:9–14 and 15–20 depended on the harvest; so “the day after the sabbath” (v. 11) is not a proper date; Jewish authorities later tried to fix it in connection with the feast of Unleavened Bread; for their various interpretations see Hartley 1992: 385–86 and Milgrom 2001: 2056–63. Then the offering of the loaves (vv. 15–21) is dated seven weeks after the raising of the sheaf (cf. Deut 16:9) and not according to the calendar like the other holy days.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The calendar used here begins in the spring (cf. Exod 12:2). The first month (23:5) is roughly March–April, and the seventh month (vv. 23–36) roughly September–October (see "), _c('i', [_vm._v("ABD")]), _vm._v(", 1:814–20). The first day of the “seventh” month (vv. 23–25) is now the Jewish New Year’s Day. This name is not used in the Bible; yet 25:9 and Exod 23:16 suggest an autumn new year. The year could have started at different times for different purposes. So the official calendar of sacred time begins in the spring, but the natural turn of the agricultural year is in the early autumn, and that is when we find ceremonies suggesting a new start.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("For the sabbath (23:3), see the comments on Exod 20:8–11. In vv. 5–8 no details are given about the Passover and unleavened bread; these have already been given in Exodus 12–13.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The ceremonies in 23:9–21 are firstfruits ceremonies, offering the harvest to God before humans partake of it: v. 14 (the same principle as in 19:23–25). This is complemented by v. 22, a shorter version of 19:9–10; not only God but also the poor have a prior claim on the produce of the comfortable. The “raising” or “elevation” of various offerings in vv. 9–21 is a ceremony in which the offering is swung up and down and from side to side as a formal dedication to God of material which actually goes to the priests (see 7:30). Presumably the offerings of grain are to come from every farmer, while the animal sacrifices will be public offerings. For the terms used for animal sacrifices, see the comments on chs. 1–7. The “raising” of the sheaf in 23:9–14 marks the beginning of the barley harvest in about April, and the ceremony of the loaves seven weeks later (vv. 15–17) marks the wheat harvest. This festival is elsewhere called Weeks (Exod 34:22; Num 28:26; Deut 16:10) or Pentecost (= “fiftieth day”) in the NT.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The ceremonies of the seventh month form a complex. The festival of Booths (23:33–36, 39–43) was the chief festival of the year, held after all the produce had been gathered in, and before the first rains; therefore, it was a time both for thanskgiving and for seeking blessing for the coming year; it is prepared for by the blowing of trumpets on the first day of the month (vv. 23–25) and by the day of penitence and atonement on the tenth (vv. 26–32, mostly repeating 16:29–34). The festival of dwelling in booths (vv. 42–43) arose because pilgrims to Jerusalem built themselves shelters for the week; here it is given a meaning as a memorial of Israel’s history and God’s grace—surprisingly the only such reference in the chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Provision for the Service of God in the Tabernacle (24:1–9)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The material here might seem more at home in Exodus 25–31; 24:2–3 repeat Exod 27:20–21 almost word for word, and vv. 5–9 expand on the brief instruction in Exod 25:30. The reason they are here is probably that v. 2 requires the people to provide the oil for the lamp, and probably they are to supply the flour for the bread as well. V. 8 says that Aaron in setting out the bread fulfills a responsibility of the people, “a covenant [better “an obligation”] forever.” So, as in most of the Holiness code, the focus is on the people’s responsibilities.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These rituals belong to a class of rituals in ancient temples which symbolically provide the god with his daily needs, such as food and light (Haran 1978: 205–29). The OT authors do not take this literally and openly instruct the priests to eat the bread. Thus the symbolism is reversed, and God is seen as the source of light and bread for his people.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_120"
    }
  }, [_vm._v("Exod 25:31–40 has a seven-branched lampstand, but ")]), _c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_vm._v("24:2–3 seem to have only one lamp in mind; v. 4 makes it clear that the seven-branched lampstand is meant.")])]), _c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The ephah (24:5) may have been as small as ten liters ("), _c('i', [_vm._v("ABD")]), _vm._v(", 6:903–4), but even so the flat, round loaves would be too big to be set out in rows on the little table of Exod 25:23–30; the tradition was that they were placed in two piles. The burning of the frankincense (v. 7) converts them into a genuine sacrifice: for “offering by fire” see the comments on chs. 1–7.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("A Legal Case (24:10–23)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The narrative raises a legal problem which is solved by taking it to God. God’s word then gives the rule to be followed in similar cases. A similar teaching technique is used in Num 9:6–14; 15:32–36; 27:1–11. The details of the story are very bare, and it was probably made up for the purpose. For general comments on criminal law, see ch. 20.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("What is the problem which leads to the appeal to God? Is it how blasphemy is to be punished or the question whether the law (Exod 20:7; 22:28) applies to an alien? Perhaps both: so far there has been no statement on the punishment for blasphemy. But H insists elsewhere that laws concerning the holiness of the community apply equally to citizen and alien (16:29; ch. 17 and comments; 18:26; 20:2).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Blasphemy in this text involves the explicit pronunciation of the name Yahweh in a context of cursing; otherwise it is deliberately vague about the crime. This is why Jews came to refrain from pronouncing the name at all, even when reading the Scriptures. Death for blasphemy (cf. 20:9) is inevitable in the context of Leviticus: one who explicitly abuses the community’s supreme authority must be rooted out. For the use of stoning, see the comments on ch. 20. The witnesses lean their hands on the offender’s head (24:14), as the sacrificer does on the victim’s (1:4, etc.), and maybe for the same reasons: to dispatch the criminal to his doom and, at the same time, as with the use of stoning, to share the responsibility among them all.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The passage of legal teaching which follows (24:15–22) has broader concerns than blasphemy. One of these is the issue of equality before the law. The other is that of equal restitution, or “talion” as it is called. The passage is arranged as a ring structure in which vv. 15–16a correspond to v. 23, 16b to 22, 17 to 21b, 18 to 21a, 19 to 20b, leaving 20a, the formula “fracture for fracture, eye for eye, tooth for tooth,” in the center as the basic principle. It is a common principle in the law of the ancient Near East and appears in the OT also at Exod 21:24–25 and Deut 19:21. We should not think that courts took it literally: Num 35:31–32 suggest that it was normal to accept monetary compensation in all cases but murder. Rather, it sets up a norm by which compensation may be measured.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Sabbath Year and Jubilee (Ch. 25)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The climax of the book of Leviticus is a single very long speech (25:2–26:45). Its central concern is the land which Yahweh is about to give the people of Israel. On what conditions will they retain it?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Chapter 25 can be seen as an attempt to resolve a clash between irreconcilable attitudes to the land in Israelite-Jewish society. The old tribal attitude was like Naboth’s (1 Kgs 21:3): land was a trust which family heads held on behalf of their kin group and could not deal with as they chose. It is possible that in the earliest period the land of a village was communally owned and periodically redistributed. At all events a family’s use of a recognized portion of land was fundamental to society: it supported not merely their livelihood but their standing in the community.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("On the other hand, with the rise of cities and a money economy the idea spread that land was a private possession. When peasants, who always lived close to the margin, needed a loan, they were often compelled to mortgage or sell the land they cultivated. In doing this, of course, they were implicitly accepting the idea that they “owned” their land. Wealthy people took advantage of this to build up large estates (Isa 5:8; Mic 2:1–2), and peasants became slaves or day laborers. Even earlier it was common for people to mortgage or sell their children or themselves (cf. 25:39–55). We have a picture of the process in Neh 5:1–5.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This chapter reaffirms in principle the old idea that land is inalienable, and that Israelite families should be helped to retain their traditional position as landholders. This is part of the wider project of Leviticus to maintain an ordered society in an ordered cosmos (Fager 1993). But the chapter also takes the money economy for granted and realistically accepts that land (and indeed people) will be bought and sold. It affirms that this should not be permanent, so that the “sale” of land becomes in effect its lease until the jubilee (vv. 14–17), and the “sale” of Israelite people is not into slavery but into a kind of indentured service (vv. 39–43, 53–54). But, more fundamentally, it affirms that Yahweh is the Lord of the land and of the people; it does so at the outset in 25:2b–7, and this, for the writers, is the basic reason why neither of them can be sold outright (vv. 23, 42).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Were these laws meant to be observed or are they “utopian”? There are no sanctions for nonobservance; the law relies on the goodwill (25:17!) of the well-to-do, who would be disadvantaged by it. It is possible that selfish interests are involved: the law would give legitimacy to the demand of the exiles for land on their return from Babylon; but the idea of social and divine justice here is bigger than those interests. We know from Josephus and other sources (Milgrom 2001: 2246) that the sabbath year "), _c('i', [_vm._v("was")]), _vm._v(" observed in the Second Temple period, but there is no evidence that the jubilee was. As with many other laws, literal observance may not have been the aim, but it is not utopian in the sense of projecting an ideal polity in a nonexistent world; it takes the real world seriously, and sketches an approximation to justice in that world (Fager 1993: 122; but see Houston 2001).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The chapter seems to have grown through successive additions. The following analysis may clarify the text. Some of the paragraph divisions in the NRSV are unhelpful.")]), _vm._v(" "), _c('table', {
    staticClass: "Table15",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_c('a', {
    attrs: {
      "id": "page_122"
    }
  }, [_vm._v("Basic text:")])]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("2b–19")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a1"
  }, [_vm._v("the sabbath year")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("2b–7")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a1"
  }, [_vm._v("the jubilee")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("8–13")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a1"
  }, [_vm._v("consequence of the jubilee for sale of land")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("14–17")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a1"
  }, [_vm._v("closing admonitions")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("18–19")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a"
  }, [_vm._v("Appendix: a problem")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("20–22")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-at"
  }, [_vm._v("Subsidiary regulations:")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a1"
  }, [_vm._v("redemption of property before the jubilee")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("23–28")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a1"
  }, [_vm._v("exemption: walled cities")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("29–34")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a1"
  }, [_vm._v("responsibility to impoverished fellow citizens")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("35–38")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a1"
  }, [_vm._v("sale of a person to an Israelite")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("39–46")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-left-a1"
  }, [_vm._v("sale of a person to an alien.")]), _vm._v(" "), _c('td', {
    staticClass: "td-left-l"
  }, [_vm._v("47–55")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("Each subsidiary regulation is a variation on the case: “If anyone of your kin [better, “any of your fellow citizens”; lit. “your brother”] falls into difficulty.…”")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("The Sabbath Year (25:1–7)")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("25:1–7 reaffirm the old practice of the fallow year found in Exod 23:10–11. A rotating fallow is normal; but here the whole land is to lie fallow at once. In v. 4 the religious motivation is stated in words typical of H. A complete rest from human exploitation gives the land a year for God, just as the weekly sabbath devotes a day completely to God. How was it possible for peasants on tight margins to give up cultivation for a year? Fertility could be maintained only if fields were left fallow not just every seven years but every other year. A farmer might divide his holding into two parts, one part lying fallow each year. If he was going to let his whole holding lie fallow in the seventh year, he would cultivate both parts in the sixth year and suffer very little loss of production (Hopkins 1985: 194–201).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("25:5–6, 11–12. They may eat from the land but not harvest it. What is the difference? The point is that the produce is open for anyone to pick; it is not for the landholder to gather it in in the normal way.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Why do 25:21–22 say that the sixth year’s crops cover three years rather than two? This may be because the official calendar does not coincide with the agricultural year (see the comments on ch. 23). Sowing is forbidden in year 7; this would mean no harvest in year 8, reckoning by the spring calendar; so year 6’s crops (actually harvested in the spring of year 7) have to last until year 9. But see Milgrom 2001: 2181–83.")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("The Jubilee (25:8–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The jubilee, like the sabbath year, is an old tradition; the original meaning of “jubilee” (Heb. "), _c('i', [_vm._v("yobel")]), _vm._v(") is lost. But it is not possible to recover the original way in which it was observed. Ancient rulers made occasional decrees remitting debts and taxes, releasing slaves, and providing for the return of people to their land (Weinfeld 1995; see Jer 34:8). But the regularly recurring jubilee is either a new idea or has a different background, possibly in Israel’s tribal society, where it may have been connected with the redistribution of communal land (Weinfeld 1995: 177–78). The essence of the jubilee here is that people are to return to their original landholdings, being released from slavery if necessary (25:10, 28, 33, 41, and 54).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Is the jubilee the forty-ninth (25:8) or the fiftieth year (vv. 10 and 11)? The simplest explanation is that it is the seventh sabbath year, that is, the forty-ninth, and that fiftieth is inclusive reckoning (as when Jesus is said to have risen “on the third day”). But see Milgrom 2001: 2250.")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("Redemption (25:25–34)")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Another old tradition in the chapter is the redemption of land or slaves by a relative (25:25–34, 47–55; cf. Ruth 4:1–6). It arises out of the family solidarity of rural society. However, it is not referred to in vv. 39–43: an Israelite who is sold to another Israelite is not to be treated as a slave; therefore, it seems, redemption is not required. The case in vv. 47–55, where the master is an alien, is treated differently. However, Exod 21:2–6, a much older law, and Deut 15:12–18 require a debt-slave to be released after only six years: Is our text a compromise? One problem is whether redeemed land (25:25) is returned to the original holder or kept by the redeemer. The point may be that land is a family rather than an individual holding, so that once the redeemer has acquired it, the law’s intention is achieved.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In 25:29–34 city property is exempted from the laws. It was not bound up with people’s livelihood and status in the same way as agricultural land. But this was the only stake for the Levites (see Num 35:2–5) in the land.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("25:36–37 take up a constant theme (Exod 22:25; Deut 23:19–20). The NRSV’s addition of “in advance” is ill-judged: any form of interest is forbidden.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("25:45–46 are a plain contradiction of the spirit of 19:33–34. The chapter is concerned with maintaining the connection between Israelite families and their land. One can understand that resident aliens did not have that connection to start with; but a proper working out of the implications of 19:34 would surely have led to second thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Reward and Punishment (Ch. 26)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This sermon is the rhetorical conclusion to the book, driving home its message, especially that of the last eight chapters with their call to holiness. It is concerned with "), _c('i', [_vm._v("communal")]), _vm._v(" obedience and disobedience; the ritual and civil measures in chs. 16 and 20 and the warnings of divine punishment (“cutting off”) throughout protect the community from the effects of individual wrongdoing. The original audience, if this was after the exile, could well find the rhetoric recalling their experience and being reinforced by it.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There is, however, a special tie with ch. 25. The land is Yahweh’s supreme blessing on Israel; ch. 26 offers them its blessings if they are obedient and threatens them with its loss (v. 33) in case of disobedience. It is therefore appropriate to pair it with ch. 25, in which the land is the symbol of Yahweh’s claim on them (C. J. H. Wright 1990: 150). So the loss of the land is an ironic fulfillment of the sabbath year law (vv. 34–35, 43; cf. 25:2–7). V. 13 also picks up 25:42, 55.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_vm._v("Prefixed, however (vv. 1–2), is a reminder of the most fundamental of all Yahweh’s requirements: to be faithful ")]), _c('a', {
    attrs: {
      "id": "page_123"
    }
  }, [_vm._v("to him, negatively (v. 1) and positively (v. 2). V. 2 repeats 19:30 word for word; v. 1 recalls 19:4 (as well as Exod 20:2–6) but expands it. The “pillars” are free-standing undecorated stones which as late as the seventh century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" had been accepted symbols of Yahweh’s presence. It is perhaps to avoid even the suspicion of idolatry that they are forbidden (cf. Deut 16:22).")])]), _c('a', {
    attrs: {
      "id": "page_123"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("As the conclusion to a law code, Leviticus 26 is similar to Deuteronomy 28, which pronounces blessings and curses on Israel for obedience and disobedience. Both of them follow a tradition which is seen throughout the ancient Near East in law codes and treaties. Yahweh’s “covenant” with Israel is therefore a major theme (vv. 9, 15, 25 [?], 42, and 44–45). Heb. "), _c('i', [_vm._v("berit")]), _vm._v(" means “treaty” as well as “covenant,” so that the idea is appropriate to the literary form. But here there are no blessings and curses, but rather statements by God of his personal intentions. And the punishments are not presented as final vengeance, but rather as a graduated series of disciplinary actions intended to make Israel come to its senses (like Amos 4:6–12), which are expected to be eventually successful (v. 40). Yahweh in fact will never abandon Israel, but will “remember his covenant.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The covenant is seen primarily as Yahweh’s promise (Genesis 17). There are conditions which Israel can break (v. 15, perhaps referring to Exodus 24), but this does not wipe the covenant out. The phrase “vengeance for the covenant” in v. 25 is unique and might better be translated “covenant vengeance” or “treaty vengeance,” referring not so much to "), _c('i', [_vm._v("the")]), _vm._v(" covenant as to treaties in general, with their pronouncement of vengeance on the violator. So in spite of the long series of fearsome warnings, the impression the chapter leaves in the end is of God’s irresistible grace and faithfulness to his people.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("26:5: threshing, vintage, and sowing occur in that order in the summer and autumn. The meaning is that the harvest will be so fruitful that farmers will not have time to complete one process before the next has begun.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("26:29: cannibalism would be resorted to only in the desperate situation of a prolonged siege (cf. 2 Kgs 6:25–29).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("26:30: the reference is again to worship which the reformers had censured. The “high places” are the country places of worship, frequently censured in Kings, and the word translated “incense altars” (but of uncertain meaning; see Levine 1989: 188) has the same associations.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Gifts to the Sanctuary (Ch. 27)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("By our notions of composition, it is an anticlimax to follow a dramatic conclusion like ch. 26 with some technical priestly regulations. And since the summary in 26:46 is repeated in 27:34, it seems that ch. 27 is in fact an addition to the book. But it ensures that it does not end with the sad picture of Israel in exile, and the last section of the book recalls the first (chs. 1–7), both dealing with dedications to God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Officially the dedications are made “to the Lord,” in practice they are to the sanctuary or to the priests (v. 21), who may have wanted some way to exert control over the popular practice of making vows. The main issue is under what conditions these gifts, which in theory are invariably in kind, may be commuted for a money payment. All such gifts are valued, and if they are to be commuted a premium of 20 percent is added in most cases, perhaps as a disincentive. All the money values are expressed as shekels of silver, and the standard is given in v. 25: a shekel would probably be about twelve grams.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The body of the chapter (27:2–25) concerns objects dedicated to God voluntarily by individuals. Persons and animals (vv. 2–13) may be dedicated by vow (v. 2). It is clear from vv. 2–8 that the vow of a person (oneself or a family member or slave) was always commuted since human sacrifice was not acceptable (cf. Exod 13:13). The passage gives the scale on which this was done. Most likely the prices reflect the economic value of the persons and may be related to the slave market (Wenham 1979: 338).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Animals which could be sacrificed had to be (27:9–10); those which could not (vv. 11–13)—for example, a donkey or a camel; cf. 11:3–7—could be redeemed. (In some editions of the NRSV the word “redeemed” has been accidentally omitted in v. 13.)")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In relation to real estate (27:14–23) the word “vow” is replaced by “consecrate,” presumably because it was not customary to vow houses or land, but these might be gifted in some other way. Vv. 16–24 concern land which comes under the jubilee law (ch. 25). The value of the land (vv. 16–18) is assessed according to the rule in 25:15–16; yet if it is not redeemed it passes permanently (unlike other land) into priestly hands (v. 21), provided that the donor was its original holder (vv. 22–24). Redemption was therefore much cheaper, and possibly was the usual course. In v. 20 “sold to someone else” refers to being sold "), _c('i', [_vm._v("before")]), _vm._v(" being dedicated by the original holder (this was the holder’s right as the legally permanent possessor).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("27:25–33 deal with things and persons which legally belong to Yahweh in any case.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The law on the firstborn of animals (27:26–27) parallels that on vows, except that this not a voluntary gift (cf. Exod 13:2). On unclean animals, the law in Exod 13:13 is different; the present law suggests a later period in which more cash was circulating.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("27:28–29 are obscure since the practice of “devotion to destruction” (Heb. "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ḥerem")])]), _vm._v(") belongs normally to warfare (Deut 7:2; Josh 6:21), except for Exod 22:20, which may explain v. 29. Placing one’s own property under such a ban (v. 18) may be a type of oath: “If I do not do so-and-so, may such-and-such be devoted to destruction” (Levine 1989: 199).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The use of tithes (vv. 30–33) is dealt with in Num 18:21–32. But a tithe of livestock is not mentioned elsewhere.")])]), _c('p', {
    staticClass: "Bib1"
  }, [_c('a', {
    attrs: {
      "id": "page_123"
    }
  }, [_c('b', [_c('i', [_vm._v("Bibliography. Commentaries")])]), _vm._v(". Budd, P. J. 1996, "), _c('i', [_vm._v("Leviticus")]), _vm._v(", NCBC, Grand Rapids: Eerdmans/London: Marshall Pickering • Elliger, K. 1966, "), _c('i', [_vm._v("Leviticus")]), _vm._v(", HAT 1/4, Tübingen: Mohr • Gerstenberger, E. S. 1996, "), _c('i', [_vm._v("Leviticus: A Commentary")]), _vm._v(", OTL, Louisville, Ky.: Westminster/John Knox (ET of "), _c('i', [_vm._v("Das dritte Buch Mose: Leviticus")]), _vm._v(", ATD 6, Göttingen: Vandenhoeck & Ruprecht, 1993) • Hartley, J. E. 1992, "), _c('i', [_vm._v("Leviticus")]), _vm._v(", WBC 4, Dallas: Word • Hoffmann, D. 1905–6, "), _c('i', [_vm._v("Das Buch Leviticus")]), _vm._v(", Berlin: Poppelauer • Levine, B. A. 1989, "), _c('i', [_vm._v("The JPS Torah Commentary: Leviticus")]), _vm._v(", Philadelphia: Jewish Publication Society • Milgrom, J. 1991, "), _c('i', [_vm._v("Leviticus")])]), _c('a', {
    attrs: {
      "id": "page_124"
    }
  }, [_c('i', [_vm._v("1–16")]), _vm._v(", AB 3, New York: Doubleday • Milgrom, J. 2001, "), _c('i', [_vm._v("Leviticus 17–22")]), _vm._v(", AB 3A and "), _c('i', [_vm._v("Leviticus 23–27")]), _vm._v(", AB 3B, New York: Doubleday (vols. 3, 3A, and 3B are continuously paginated) • Sherwood, S. K. 2002, "), _c('i', [_vm._v("Leviticus, Numbers, Deuteronomy")]), _vm._v(", Berit Olam, Collegeville, Minn.: Liturgical • Wenham, G. J. 1979, "), _c('i', [_vm._v("The Book of Leviticus")]), _vm._v(", NICOT, Grand Rapids: Eerdmans/Exeter: Paternoster.")])]), _c('a', {
    attrs: {
      "id": "page_124"
    }
  }, [_c('p', {
    staticClass: "Bib"
  }, [_c('b', [_c('i', [_vm._v("Other Works")])]), _vm._v(". Bigger, S. F. 1979, “The Family Laws of Leviticus 18 in Their Setting,” "), _c('i', [_vm._v("JBL")]), _vm._v(" 98:187–203 • Bourdillon, M. F. C., and M. Fortes, ed. 1980, "), _c('i', [_vm._v("Sacrifice")]), _vm._v(", London: Academic • Cholewinski, A. 1976, "), _c('i', [_vm._v("Heiligkeitsgesetz und Deuteronomium: Eine vergleichende Studie")]), _vm._v(", AnBib 66, Rome: Pontifical Biblical Institute • Crüsemann, F. 1996, "), _c('i', [_vm._v("The Torah: Theology and Social History of Old Testament Law")]), _vm._v(", Edinburgh: T. & T. Clark and Minneapolis: Augsburg Fortress • Davies, D. 1977, “An Interpretation of Sacrifice in Leviticus,” "), _c('i', [_vm._v("ZAW")]), _vm._v(" 89:387–98 • Douglas, M. 1966, "), _c('i', [_vm._v("Purity and Danger")]), _vm._v(", London: Routledge • Douglas, M. 1970, "), _c('i', [_vm._v("Natural Symbols: Explorations in Cosmology")]), _vm._v(", New York: Barrie & Rockcliffe • Douglas, M. 1975, "), _c('i', [_vm._v("Implicit Meanings: Essays in Anthropology")]), _vm._v(", London: Routledge, 249–318 • Douglas, M. 1993, “The Forbidden Animals in Leviticus,” "), _c('i', [_vm._v("JSOT")]), _vm._v(" 59:3–23 • Douglas, M. 1999, "), _c('i', [_vm._v("Leviticus as Literature")]), _vm._v(", Oxford: Oxford University • Eilberg-Schwartz, H. 1990, "), _c('i', [_vm._v("The Savage in Judaism")]), _vm._v(", Bloomington: Ind.: Indiana University • Fager, J. A. 1993, "), _c('i', [_vm._v("Land Tenure and the Biblical Jubilee")]), _vm._v(", JSOTSup 155, Sheffield: Sheffield Academic • Firmage, E. B. 1990, “The Biblical Dietary Laws and the Concept of Holiness,” in J. A. Emerton, ed., "), _c('i', [_vm._v("Studies in the Pentateuch")]), _vm._v(", VTSup 41, Leiden: Brill, 177–208 • Gorman, F. H. 1990, "), _c('i', [_vm._v("The Ideology of Ritual: Space, Time and Status in the Priestly Theology")]), _vm._v(", Sheffield: Sheffield Academic • Grabbe, L. L. 1993, "), _c('i', [_vm._v("Leviticus")]), _vm._v(", Old Testament Guides, Sheffield: Sheffield Academic • Gray, G. B. 1925, "), _c('i', [_vm._v("Sacrifice in the Old Testament: Its Theory and Practice")]), _vm._v(", Oxford: Clarendon • Gruber, M. I. 1987, “Women in the Cult according to the Priestly Code,” in J. Neusner et al., eds., "), _c('i', [_vm._v("Judaic Perspectives on Ancient Israel")]), _vm._v(", Philadelphia: Fortress, 35–48 • Haran, M. 1978, "), _c('i', [_vm._v("Temples and Temple Service in Ancient Israel")]), _vm._v(", Oxford: Clarendon • Heider, G. C. 1985, "), _c('i', [_vm._v("The Cult of Molek: A Reassessment")]), _vm._v(", JSOTSup 43, Sheffield: Sheffield Academic • Hopkins, D. C. 1985, "), _c('i', [_vm._v("The Highlands of Canaan: Agricultural Life in the Early Iron Age")]), _vm._v(", Sheffield: Sheffield Academic • Houston, W. J. 1993, "), _c('i', [_vm._v("Purity and Monotheism: Clean and Unclean Animals in Biblical Law")]), _vm._v(", JSOTSup 140, Sheffield: Sheffield Academic • Houston, W. J. 2000, “Tragedy in the Courts of the Lord: A Socio-Literary Reading of the Death of Nadab and Abihu,” "), _c('i', [_vm._v("JSOT")]), _vm._v(" 90:31–39 • Houston, W. J. 2001, “ ‘What’s Just about the Jubilee?’ Ideological and Ethical Reflections on Leviticus 25,” "), _c('i', [_vm._v("Studies in Christian Ethics")]), _vm._v(" 14:34–47 • Houston, W. J. 2002, “Foods, Clean and Unclean,” in D. Baker and T. Desmond Alexander, eds., "), _c('i', [_vm._v("Dictionary of the Old Testament: Pentateuch")]), _vm._v(", Downers Grove, Ill.: Inter-Varsity • Janowski, B. 1982, "), _c('i', [_vm._v("Sühne als Heilsgeschehen")]), _vm._v(", WMANT 55, Neukirchen-Vluyn: Neukirchener • Jenson, P. P. 1992, "), _c('i', [_vm._v("Graded Holiness: A Key to the Priestly Conception of the World")]), _vm._v(", JSOTSup 106, Sheffield: Sheffield Academic • Joosten, J. 1996, "), _c('i', [_vm._v("The People and Land in the Holiness Code")]), _vm._v(", Leiden: Brill • Kiuchi, N. 1987, "), _c('i', [_vm._v("The Purification Offering in the Priestly Literature")]), _vm._v(", Sheffield: Sheffield Academic • Knierim, R. P. 1992, "), _c('i', [_vm._v("Text and Concept in Leviticus 1:1–9")]), _vm._v(", FAT 2, Tübingen: Mohr • Knohl, I. 1995, "), _c('i', [_vm._v("The Sanctuary of Silence: The Priestly Torah and the Holiness School")]), _vm._v(", Minneapolis: Fortress • Leach, E. 1976, "), _c('i', [_vm._v("Culture and Communication: The Logic by Which Symbols Are Connected")]), _vm._v(", Cambridge: Cambridge University • Levine, B. A. 1974, "), _c('i', [_vm._v("In the Presence of the Lord")]), _vm._v(", Leiden: Brill • Lloyd Davies, M. 1988, “Levitical Leprosy: Uncleanness and the Psyche,” "), _c('i', [_vm._v("EvT")]), _vm._v(" 99:136–39 • Magonet, J. 1983, “The Structure and Meaning of Leviticus 19,” "), _c('i', [_vm._v("HAR")]), _vm._v(" 7:151–67 • Magonet, J. 1996, “ ‘But If It Is a Girl, She Is Unclean for Twice Seven Days …’: The Riddle of Leviticus 12.5,” in J. F. A. Sawyer, ed., "), _c('i', [_vm._v("Reading Leviticus: A Conversation with Mary Douglas")]), _vm._v(", JSOTSup 227, Sheffield: Sheffield Academic, 144–52 • Marx, A. 1988, “Sacrifice de réparation et rites de levée de sanction,” "), _c('i', [_vm._v("ZAW")]), _vm._v(" 100:183–98 • Marx, A. 1989, “Sacrifice pour les péchés ou rite de passage? Quelques réflexions sur la fonction du "), _c('span', {
    staticClass: "charSR"
  }, [_vm._v("ḥaṭṭaʾt")]), _vm._v(",” "), _c('i', [_vm._v("RB")]), _vm._v(" 96:27–48 • McKeating, H. 1979, “Sanctions against Adultery in Ancient Israelite Society …,” "), _c('i', [_vm._v("JSOT")]), _vm._v(" 11:57–72 • Milgrom, J. 1976, "), _c('i', [_vm._v("Cult and Conscience: The ASHAM and the Priestly Doctrine of Repentance")]), _vm._v(", Leiden: Brill • Milgrom, J. 1983, “Israel’s Sanctuary: The Priestly ‘Picture of Dorian Gray,’ ” in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(", Leiden: Brill, 75–84 • Nelson, R. D. 1993, "), _c('i', [_vm._v("Raising Up a Faithful Priest: Community and Priesthood in Biblical Theology")]), _vm._v(", Louisville, Ky.: Westminster/John Knox • Rendtorff, R., and R. A. Kugler, eds. 2003, "), _c('i', [_vm._v("The Book of Leviticus: Composition and Reception")]), _vm._v(", Leiden: Brill • Sawyer, J. F. A., ed., 1996, "), _c('i', [_vm._v("Reading Leviticus: A Conversation with Mary Douglas")]), _vm._v(", JSOTSup 227, Sheffield: Sheffield Academic • Schmidt, B. B. 1994, "), _c('i', [_vm._v("Israel’s Beneficent Dead")]), _vm._v(", FAT 11, Tübingen: Mohr • Schwartz, B. J. 1991, “The Prohibitions concerning the ‘Eating’ of Blood in Leviticus 17,” in G. A. Anderson and S. M. Olyan, eds., "), _c('i', [_vm._v("Priesthood and Cult in Ancient Israel")]), _vm._v(", Sheffield: Sheffield Academic, 34–66 • Tomes, R. 1988, “ ‘A perpetual statute throughout your generations,’ ” in B. Lindars, ed., "), _c('i', [_vm._v("Law and Religion: Essays on the Place of the Law in Israel and Early Christianity")]), _vm._v(", Cambridge: James Clarke, 20–33 • Turner, V. W. 1969, "), _c('i', [_vm._v("The Ritual Process")]), _vm._v(", Ithaca, N.Y.: Cornell University • Van Gennep, A. 1909, "), _c('i', [_vm._v("Les Rites de Passage")]), _vm._v(", Paris: Nourry • Weinfeld, M. 1995, "), _c('i', [_vm._v("Social Justice in Ancient Israel and in the Ancient Near East")]), _vm._v(", Jerusalem: Magnes/Minneapolis: Fortress • Wright, C. J. H. 1990, "), _c('i', [_vm._v("God’s People in God’s Land: Family, Land and Property in the Old Testament")]), _vm._v(", Grand Rapids: Eerdmans • Wright, D. P. 1991, “The Spectrum of Priestly Impurity,” in G. A. Anderson and S. M. Olyan, eds., "), _c('i', [_vm._v("Priesthood and Cult in Ancient Israel")]), _vm._v(", JSOTSup 125, Sheffield: Sheffield Academic, 150–82 • Zimmerli, W. 1982, “I Am Yahweh,” in "), _c('i', [_vm._v("I Am Yahweh")]), _vm._v(", Atlanta: John Knox, 1–28.")])])])])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT",
    attrs: {
      "id": "ch008"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_125"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-008"
    }
  }, [_vm._v("Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "CA"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-008"
    }
  }, [_vm._v("Philip J. Budd")])]), _vm._v(" "), _c('p', {
    staticClass: "H1a"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The book of Numbers has some of the characteristics of a travel diary. It tells the story of Israel’s journey from the wilderness of Sinai (1:1) to the plains of Moab, close to Jericho and the borders of the land (36:13).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Topographical information is regularly provided at appropriate points, and the journey as a whole (including the story told in Exodus) is tracked in detail toward the end of the book in 33:1–49.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Meticulous attention is also given to the timing of key events—the census (1:1), the Passover command (9:1), the beginning of the journey from the wilderness of Sinai (10:11), and the arrival in the wilderness of Zin (20:1).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It would be a mistake nevertheless to think of Numbers as a diary in the modern sense of the term. It is likely that the story line, represented by the topographical and chronological data, is actually a means of organizing a wide variety of traditional materials which authors and editors were anxious to associate with the Mosaic period prior to the settlement. This observation does not preclude the presence of historical recollection, preserved by groups who eventually became part of Israel in the land, but it is rarely easy to identify such material or assess its extent.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The title “Numbers” comes from the Vg "), _c('i', [_vm._v("(Numeri)")]), _vm._v(", which itself translates the title used in the LXX. This draws attention to the numbering of the people with which the book begins (1:1–54), and which is repeated at a later stage in the story (26:1–62). The Hebrew title "), _c('i', [_vm._v("In the Wilderness")]), _vm._v(" provides an altogether more comprehensive description of the story line the book embodies.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("COMMENTARY")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Reading Numbers as a Literary Whole")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("It is appropriate to maintain that the book has an integrity and distinctiveness of its own. Numbers is not disordered or incoherent. Wenham (1997: 13–25) provides an account of several recent approaches to the structure of the book. Douglas (1993: 98–126), for example, has seen elements which function as commentary on the book of Genesis. Two special contributions to the traditions of the Pentateuch have to do with:")]), _vm._v(" "), _c('p', {
    staticClass: "BL1"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the Levites as a subordinate clerical order (1:47–54; 3:1–4:49)")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the tent of meeting as a sanctuary located at the "), _c('i', [_vm._v("center")]), _vm._v(" of the camp (2:1–34)")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("In broad terms a threefold structure emerges:")]), _vm._v(" "), _c('p', {
    staticClass: "NL1"
  }, [_vm._v("1."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Constituting the Community at Sinai (1:1–9:14)")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("2."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Journey—Setbacks and Success (9:15–25:18)")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("3."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Reconstituting the Community in Moab (26:1–35:34)")])]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("Constituting the Community at Sinai (1:1–9:14)")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("At the outset the dimensions of the community are established (1:1–46) and its character as a priestly theocracy is affirmed (1:47–4:49). Threats to its purity are identified in 5:1–31, and procedures for dealing with them are set forth. The ways in which laypeople can share in higher levels of “consecration” are indicated in the vow of the nazirite (6:1–21), while the priestly blessing brings security and well-being to the community (6:22–27).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("An account of exemplary lay commitment to the sanctuary at the community’s center, and to the cult which sustains it, is evident in 7:1–88. The roles of Moses as supreme recipient of the divine word, and of the lamps, which perhaps symbolize the light the word brings to the community, are stressed in 7:89–8:4. The consecration of the Levites for their new role within the theocracy is described in 8:5–26. The keeping of the Passover, the community’s foundational rite, is recorded in 9:1–14, along with situations connected to Passover observance which may threaten its purity.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In all these ways Israel, as the recipient of the Sinaitic law, is prepared for the journey to the land. The tone is positive, with leadership and people doing what is commanded.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is important to appreciate the patterns by which the community is structured. These patterns may be depicted hierarchically or in terms of a center with peripheries:")]), _vm._v(" "), _c('p', {
    staticClass: "Orn1"
  }, [_vm._v("Moses")]), _vm._v(" "), _c('p', {
    staticClass: "Orn"
  }, [_vm._v("Priests—the Sons of Aaron")]), _vm._v(" "), _c('p', {
    staticClass: "Orn"
  }, [_vm._v("Levites")]), _vm._v(" "), _c('p', {
    staticClass: "Orn"
  }, [_vm._v("[Nazirites]")]), _vm._v(" "), _c('p', {
    staticClass: "Orn"
  }, [_vm._v("Leaders/Heads of Tribes")]), _vm._v(" "), _c('p', {
    staticClass: "Orn"
  }, [_vm._v("Males")]), _vm._v(" "), _c('p', {
    staticClass: "Orn"
  }, [_vm._v("Females")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Many will regret that women receive little attention in this structuring process. Though largely marginalized, they do have the right, at least in principle, to make a nazirite vow (6:2) (but see also 30:3–15).")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("The Journey—Setbacks and Success (9:15–25:18)")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("There are two major themes in the central part of the book—the land as ultimate destination, and the issue of authority within the community now constituted. These "), _c('a', {
    attrs: {
      "id": "page_126"
    }
  }, [_vm._v("themes are dealt with successively in the form of major expressions of divine commitment to the land and to the community on the one hand, and major challenges to the authority of the community’s leadership, and ultimately therefore to Yahweh himself, on the other. These challenges represent different forms of faithlessness, ranging from doubts about the practicability of the journey to assaults on the authority of Moses and Aaron.")])]), _c('a', {
    attrs: {
      "id": "page_126"
    }
  }, [_c('p', {
    staticClass: "H4"
  }, [_vm._v("God’s Commitment (9:15–10:36)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("That the journey to the land is divinely guided is established at the outset. The cloud signifies God’s commitment to the enterprise and his control of its timing (9:15–23). The trumpets signify a derived authority for the priests in assembling the community for action, both on the journey and in the land itself (10:1–10). The departure from Sinai takes place in an ordered way and in accordance with the guidance provided (10:11–36). So far, all is well.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Human Disaffection (11:1–14:35)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("There follows a series of incidents in which the feasibility of the journey is called into question and the authority of Moses as its leader seriously challenged. The hardships of the journey are highlighted (11:1–3, 4–35), along with the threat posed by the occupants of the land (13:1–14:45). Those who complain are primarily the people at large (11:1, 4; 14:1–4), and there is no doubt that Moses’ leadership and the future of the whole enterprise are at stake (11:10–15; 14:4).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These challenges mean that leadership issues have to be discussed. The role of the elder as sharer of the burdens of leadership is depicted in 11:16–17, and the legitimacy of the prophets as recipients of the spirit and agents of the divine word is affirmed in 11:26–30. In the light of these developments the uniqueness of Mosaic authority remains, despite a direct challenge from Miriam and Aaron (12:1–16).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The ultimate outcome of this faithlessness, particularly the resolve to return to Egypt (14:4), is the death of the current generation in the wilderness (Joshua and Caleb excepted) and a long delay in the occupation of the land (14:26–35).")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("God’s Commitment (15:1–41)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The positioning of the regulations which follow suggests that, despite Israel’s faithlessness, Yahweh’s commitment to an ordered cultic life in the land remains firm and unwavering. For the most part the material in 15:1–31 reaffirms the laws for the land provided in Leviticus, by means of supplementary detail. The importance of obedience to God’s commandments, and of holiness in general, is stressed in 15:32–41, with sabbath observance highlighted.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Human Disaffection (16:1–17:13)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("In the second serious phase of faithlessness the basic issue is the legitimacy of the order established when the community was constituted in the wilderness of Sinai (1:1–9:13). This legitimacy is challenged in different ways. There is the truculence of Dathan and Abiram, who reject Moses’ right to lead (16:12–14). There is the protestation of the two hundred and fifty leaders that the community as a whole is holy, which therefore calls in question priestly and levitical privilege (16:3), and there is the claim by Korah and his fellow Levites that they, like the sons of Aaron, have the right to offer incense (16:9–11).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The outcome is a decisive confirmation of the order established at Sinai, with the deaths of the rebels and lasting cultic reminders of the legitimacy of that order (16:36–40; 17:1–11). The people are suitably subdued (17:12–13).")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("God’s Commitment (18:1–19:22)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The cultic material which follows again has the effect of reaffirming Yahweh’s commitment to the community, to the order established at Sinai, and to the land. Like the material in 15:1–31, much of it supplements prescriptions already provided in Leviticus. There is a clear continuing commitment to the clerical privileges and responsibilities of priests and Levites (18:1–32), while the red heifer rites of 19:1–22 have special relevance at this point, given the many deaths recorded in 16:49.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Human Disaffection (20:1–21:9)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The third failure involves Moses and Aaron themselves (20:12). At Kadesh, in providing water from the rock, they display lack of trust in Yahweh and a failure to honor him.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The consequences are that they, too, are excluded from the land (20:12), and for Aaron death is not long delayed (20:22–29). Further setbacks on the journey are the hostility of the king of Edom (20:14–21) and the continuing discontent of the people in the face of the hardships on the way (21:4–9).")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("God’s Commitment (21:10–24:25)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Yahweh’s continuing commitment is already evident in the success at Hormah (21:1–3), but now more substantially in the significant progress through Transjordan (21:10–35) and the frustration of Balak’s attempt to halt that progress (22:1–24:5). Balaam’s blessings on Israel constitute a potent witness to Yahweh’s good purpose for Israel as a people in the land.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Human Disaffection (25:1–18)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The fourth and final phase of faithlessness involves the people at large (25:1–5), and an individual, Zimri, in particular (25:6–15). The issue here is apostasy—the honoring of gods other than Yahweh. Zimri’s relationship with the Midianite woman Cozbi is probably to be understood as compromising in the same way. The events are located at Shittim in the plains of Moab, close to the border of the land.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A further twenty-four thousand of the wilderness generation die (25:9). Yahweh’s continuing commitment is most evident in the reconstitution of the community in 26:1–36:13, but the affirmation of Phinehas’s priesthood (25:10–13) and the call for an aggressive response to the Midianites (25:16–18) mean that Yahweh does not intend to be deflected from his course.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_126"
    }
  }, [_vm._v("It seems unlikely that these juxtaposed cycles of divine commitment and human failure are accidental. Occupation ")]), _c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_vm._v("of the land is integral to the divine purpose, and the ordered community Yahweh has created must be sustained and defended if that purpose is to be realized. Faithlessness in all its forms is disastrous, but Yahweh raises up those who hear “the words of God” (24:4) and whose eye is “clear” (24:15, NRSV), and he is not diverted from his purpose.")])]), _c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("Reconstituting the Community in Moab (26:1–35:34)")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The temptation to see 26:1–36:13 as miscellaneous appendages to the book should be resisted. A case can certainly be made for seeing 36:1–13 as an appendix, taking up again the issues raised in 27:1–11, but there are good reasons for seeing 26:1–35:34 as integral to the whole.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The disasters which led to the elimination of the wilderness generation and the delay in entering the land are now in the past. Israel is on the plains of Moab, ready to enter, and it is appropriate that the community should be reconstituted, as at Sinai in 1:1–9:14. Deuteronomy, in essence an earlier book than Numbers, had already established this location as a place of Mosaic speeches and lawgiving (Deut 1:1). It is not the intention of the editors simply to repeat the themes of 1:1–9:14, though these are sometimes reflected. The basic structural features of the theocracy are to be assumed, and have been confirmed during the phases of disaffection. The particular concern of the editors is in part to develop some of the themes in 1:1–9:14, but also to stress that this reconstitution of the community should be seen as preparation for entry into the land, the key integrating theme in these chapters.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This process of reconstitution involves reestablishing the dimensions of the community (26:1–65). That the new census will provide a basis for the process by which the land will be divided is indicated by 26:52–56. Issues of inheritance in the land are raised in 27:1–11, and the principle is established that land is to remain within the owning family even if there are no males to inherit (see also 36:1–12). The commissioning of Joshua as leader of the settlement provides an important point of continuity (27:12–23). He and Eleazar are successors to Moses and Aaron, who have both been debarred from entry into the land (27:12–13).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A calendar of daily offerings and key festivals (28:1–29:40), with the appropriate offerings, provides the basis for cultic observance in the land. Its detail supplements information already available in Leviticus. The question of vows, and in particular those made by women, reflects the note in 6:2 that females are entitled to become nazirites (30:1–16). The ramifications of this entitlement in a patriarchal society are dealt with here.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Midianite war (31:1–54) is important at this point because it indicates a positive response on Israel’s part to the divine word in 25:6–18 and because it prepares the way for the invasion of the land. The offerings from the booty (31:25–54) reflect the same measure of commitment to the cultic order which Israel exhibited in 7:1–88. The Transjordanian territory, to be occupied by Gad and Reuben, is the point at issue in 32:1–42. So, too, is the need for the commitment of these tribes to the settlement west of the Jordan. The passage recalls elements from the beginning of the march, as described in 10:11–36.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As the book reaches its climax, the route from Egypt is recalled and painstakingly recorded (33:1–49); attention turns to the land itself, its dangers (33:50–56), and its dimensions (34:1–15). As in 1:5–15 and 2:1–34, leaders are appointed to assist, in this instance in the apportionment of the land. The Levites who were consecrated in 8:5–26 are now provided with cities and land as possessions (35:1–8), an important supplement to their entitlements in 18:21–24, and already presupposed in Lev 25:32–33. Certain cities are also to function as cities of refuge (35:9–34), whereby blood feuds can be checked and space created for a proper consideration of intention in cases of homicide. A key concern in 5:1–31 was that the community be protected from ritual impurity; a similar anxiety is reflected here with regard to the well-being of the land (35:33–34).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Detecting the Processes of Composition")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("While Numbers may well have been subject to very deliberate and distinct processes of editing, it is also true that it cannot be fully understood apart from its wider literary context within the Pentateuch (and perhaps the book of Joshua too). The story line is obviously dependent on themes introduced in the books of Genesis and Exodus; and, as suggested above, much of the cultic material supplements, and is therefore dependent upon, the book of Leviticus. The conclusion of the book leaves major issues such as the circumstances of Moses’ death and the settlement of the land unresolved.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is commonly held that the Pentateuch, as we know it, is the product of a major revision and supplementation of tradition, undertaken by priestly circles in the late Babylonian and early Persian periods (from about 550 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" to about 400 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("). It is arguable that a similar literary endeavor had already been undertaken at a slightly earlier period (from about 620 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" to 550 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") in scribal circles, resulting in Deuteronomy and the Deuteronomistic History (Joshua to 2 Kings in the HB). A prominent alternative to this view holds that the priestly work was completed during the preexilic period and that the Deuteronomistic work is later (see, e.g., Milgrom 1991: 3–34).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The precise circumstances under which the priestly work was undertaken are of course unknown, but it may be that much was accomplished between the return (539 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") and the completion of the Second Temple (516 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("). This major literary achievement would have been most appropriate as a formative program for the new order emerging under Persian auspices. By showing how much that was crucial to faith was revealed by God "), _c('i', [_vm._v("outside")]), _vm._v(" the land it served to authenticate a program which had its roots among the exiled priests in Babylon. At the same time it embodied a story line, as we have seen, which envisages the land as the ultimate destination.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_vm._v("This priestly work entailed the editing and supplementation of existing narrative tradition and the incorporation of cultic material (preserved now in Leviticus) from the First Temple. To the extent that Numbers includes cultic material supplementing that in Leviticus ")]), _c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_vm._v("and depicted as given at places other than Sinai, it possibly originates within the period of the Second Temple. On the other hand, there is no substantial reason for thinking that Numbers, much as we know it, was not complete by about 500 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("To what extent can the pre-priestly earlier traditions in Numbers be identified? Here, too, there are bound to be many uncertainties. There are some signs that the deuteronomists have edited these traditions, but their influence is probably not extensive. A common view, held less widely and with less confidence nowadays, is that the earlier traditions consist very largely of two independent narrative sources—a blending of Yahwistic and Elohistic traditions (titles deriving from the use of the divine name) which derive respectively from the southern and northern kingdoms.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As far as Numbers is concerned, the priestly cultic material (of a legislative nature) is easily identified and very widely recognized by a variety of scholars. Priestly narrative is marked by such indicators as the depiction of Israel as “congregation” or “assembly,” of Aaron as high priest, and of the Levites as a subordinate clerical order. It also locates the sanctuary at the center of the camp. The early narrative tradition identifies the community as “the people” or simply as “Israel,” Aaron is a leader but not obviously a priest, and the tent of meeting is pitched outside the camp. This third point indicates that the priestly revisers did not wish to eliminate the tradition of a tent outside the camp (they may have thought there were two), but they do wish to stress the tradition of the sanctuary at the center, which they identify as the tent of meeting and which is also a place where oracles are given (Num 7:89). The tradition of two tents may have helped authenticate both Babylon and restored Jerusalem (outside and inside) as places where God’s will is made known.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The circumstances under which the early narrative materials came to be written are of course very difficult to establish. It seems likely that the “national epic” they seem to constitute would have begun to take shape during the period of the united monarchy, either under David or Solomon. The Balaam oracles in Numbers 22–24 are of interest in the attempt to track this process. The Yahwistic and Elohistic redactions may be crystallizations of the tradition at crucial points in the histories of the kingdoms of Israel and Judah. If the beginnings of the deuteronomistic movement are to be traced to the reign of Josiah, then the form of the early narrative tradition with which the priestly writers worked, with Yahwistic and Elohistic material combined, may be traced perhaps to the Yahwistic revival associated with Hezekiah, in the late eighth or early seventh centuries "), _c('span', {
    staticClass: "small"
  }, [_vm._v("﻿BC")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("For general purposes of interpretation it is sufficient to note that the early narrative tradition is represented primarily by:")]), _vm._v(" "), _c('p', {
    staticClass: "BL1"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("stories of disaffection and opposition to Moses")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the journey through Transjordan")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the blessing of Israel in Balaam’s oracles")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The priestly revision supplements the stories of disaffection and of journeying through Transjordan and adds material about:")]), _vm._v(" "), _c('p', {
    staticClass: "BL1"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the dimensions and ordering of the community")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the distinction between priests and Levites")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("cultic observance")])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Reading Numbers Thematically")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("While a sequential reading of Numbers, as previously indicated, is entirely appropriate, it is also methodologically sound to address the text on a thematic basis. The final editors of the book, the priests, wished to preserve and incorporate into the community’s traditions a number of concerns which can be distinguished and which give the book many of its peculiar characteristics. These themes can be organized as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "NL1"
  }, [_vm._v("1."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Numbering and Ordering the Community (1:1–47; 2:1–34; 26:1–56, 63–65)")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("2."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Priests and Levites (1:48–54; 3:1–4:49; 6:22–27; 7:89–8:26; 18:1–32; 26:57–62; 35:1–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("3."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Purity and Offering (5:1–6:21; 7:1–88; 9:1–14; 15:1–40; 19:1–22; 28:1–29:40; 31:1–54)")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("4."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Journey to the Land (9:15–10:36; 20:14–21:3; 21:10–35; 27:12–23; 32:1–34:29)")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("5."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Disaffection (11:1–14:45; 16:1–17:13; 20:1–13; 21:4–9; 25:1–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("6."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Story of Balaam (22:1–24:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("7."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Community Law (27:1–11; 30:1–16; 35:9–36:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("1. Numbering and Ordering the Community (1:1–47; 2:1–34; 26:1–56, 63–65)")])]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("The Size of the Community (1:1–47; 26:1–56, 63–65)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The priestly writers are responsible for the statistical and organizational detail of these chapters. A good indicator of this is the depiction of Israel as a congregation (1:2, 16, 18; 26:2). So, too, is the stress on a close association between Aaron (and his son Eleazar) and Moses with regard to function (1:3, 17, 44; 26:3) and as joint recipients of the divine word (2:1), and on Aaron (and his son) as priest (26:1, 3). The chronological detail (1:1), linking Numbers with Exod 40:17, is a key part of the editorial adhesive which holds the books together. For the priestly writers the tent and the tabernacle are interchangeable terms (Exod 40:1), and the story of the construction of the shrine is told in Exod 25:1–27:21; 35:4–40:38.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The priestly writers seem to presuppose a systematic organization of Israel’s life, but since terminological usage is not always clear, there is some difficulty in describing it. The following is one possibility.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_vm._v("The largest unit is the "), _c('i', [_vm._v("tribe")]), _vm._v(". The concern to present the priestly tribe of Levi as quite distinct from its brothers means that in order to preserve the tradition of twelve tribes (based on the belief that Jacob had twelve sons) the tribe of Joseph in priestly lists is split into two—Ephraim and Manasseh (the two sons of Joseph). Earlier listings preserve the tradition that the twelve (including Levi) were all the immediate sons of Jacob (e.g., Gen 49:1–27; Deut 33:1–29). Justification for treating Levi as distinct rests on the fact that traditionally the tribe of ")]), _c('a', {
    attrs: {
      "id": "page_129"
    }
  }, [_vm._v("Levi was landless, depending for its upkeep on its priestly expertise (cf., e.g., Deut 10:9; 33:8–11; Judg 17:7–18:31).")])]), _c('a', {
    attrs: {
      "id": "page_129"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("It is widely held that the tribal system reflects the administrative needs of the early monarchy and that the ethnic connections between the various groups which comprise it were far more complicated than the tradition of Jacob’s twelve sons would suggest.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Within the tribe were smaller units, identified here as "), _c('i', [_vm._v("clans")]), _vm._v(". It is difficult to say how many clans each tribe might contain, but Num 26:1–51 does identify clans within tribes, in some instances noting descendants (subclans). It is unlikely that this information is simply fictional, but it is difficult to determine to what situation and circumstance it relates. It may be assumed that clans constituted groups of closely related people living in the same or neighboring settlements.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The "), _c('i', [_vm._v("ancestral house")]), _vm._v(" is a smaller unit again, within the clan, and approximating perhaps what would now be called the extended family (but see Levine’s view [1993: 131–33] that the “ancestral house” is the primary unit). The subclans noted above, and cited in Num 26:1–51, may in effect be ancestral houses. The head of the house (1:4) had a distinct place within the group, and only those with this dignified status might assist Moses with the census. The list of men chosen for the task may be derived from archival sources (it differs from the men chosen to be spies in Num 13:4–16), but what these archives were cannot now be established. In 2:1–34 the same men are designated as leaders of their respective tribes.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The numbers (only men capable of military service) are impossibly large from a purely historical perspective. Once again it is unlikely that such information is simply fictional. The dimensions of each tribe are certainly expressed in round numbers, but they are by no means as round as they could be, and it is appropriate to ask on what basis the differentiations are made, both between individual tribes in the same list and between the two lists as a whole. What was the original point of reference, and what was the significance of the numbers for the priestly writers? A discussion of various attempts to answer these questions is provided by Davies 1995: 14–18.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("One suggestion is that “thousand” originally denoted units of some kind (connected perhaps with military needs) within each tribe. On this basis Reuben had 46 such units and a total of 500 men available for military service. This reduces the numbers in 1:1–47 to 5,550. It is puzzling nevertheless that Judah, in comparison with Reuben, and with as many as 74 units, mustered only 600 men.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Another possibility is that the numbers are derived from the quantity of silver that, for some reason, the priests believed had been used in the construction of the tabernacle. According to Exod 38:24–31, this amounted to 100 talents, 1,775 shekels (with 3,000 shekels to the talent), a total of 301,775 shekels. Since the sanctuary tax was half a shekel (Exod 30:13), there must have been 603,550 eligible to pay it. In short, the census return is deduced from the size of the silver offering. This does not explain, of course, how the distribution of the total among the twelve tribes was computed. Perhaps the proportions are related to priestly perceptions of the size of the territory and number of settlements inherited by each of the tribes (Num 26:54).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The importance of the temple tax as a means of providing for the daily offerings (Num 28:1–29:40) is clearly one reason for priestly interest in census taking. Those registered are the ones liable to pay. This raises another possibility—that the lists are based on archival material containing information of this kind. It is conceivable from this point of view that numbers of settlements are the point at issue, with Reuben having 46, including approximately 500 per settlement. If this were the case, then the size of the silver offering in Exod 38:24–31 would be deduced from the census return.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The differences between the two lists are of interest. Despite a slight overall reduction during the wilderness period seven tribes record an increase in population, and five a decrease. Simeon’s catastrophic losses might be traced to texts such as Gen 49:7, but Manasseh’s large gains are hard to explain on the basis of textual tradition. In Gen 48:8–22; Deut 33:17 it seems to be implied that Ephraim is the dominant of the two.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is possible that the adjustments in the second list simply reflect assessments of the relative strengths of the tribes in early postexilic times. Given the centrality of Judah within the postexilic community, its preeminence in both lists is understandable.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("The Community Encamped (2:1–34)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The ordering of the camp reflects a distinctive priestly understanding of the nature of the community, and of God’s presence within it. In diagrammatic terms it can be depicted thus:")]), _vm._v(" "), _c('table', {
    staticClass: "Table15",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdcenterf"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_vm._v("Dan")]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_vm._v("Asher")]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_vm._v("Naphtali")]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdcenterf"
  }, [_vm._v("Ephraim")]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_vm._v("Levites")]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_vm._v("Judah")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdcenterf"
  }, [_vm._v("Manasseh")]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_vm._v("Levites")]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_vm._v("TENT")]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_vm._v("Priests")]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_vm._v("Issachar")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdcenterf"
  }, [_vm._v("Benjamin")]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_vm._v("Levites")]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_vm._v("Zebulun")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdcenterf"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_vm._v("Simeon")]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_vm._v("Reuben")]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_vm._v("Gad")]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The first-named tribe in each group of three has a certain priority, so that the first of the four major encampments are the camps of Judah, Reuben, Ephraim, and Dan. The groupings, moving from south to east to west to north, follow the order in 1:1–47, but there is a wish here to mention the camp of Judah first, and so the listing moves from east to south to west to north. This also becomes the order of the march—Judah-Reuben-Ephraim-Dan (2:9, 16, 24, 31). Clearly it was important to the priests, as exponents of the traditions of the Southern Kingdom, that the priority of Judah be affirmed. The “priority” of Reuben, Ephraim, and Dan seems to be based only on their position in the list. The position that Gad has (third) in the lists of 1:20–47; 26:1–56 (Levi’s place in earlier lists) is unusual; it is not derived from known earlier traditions. It could indicate the use of archival material now lost, but it does keep Judah at the head of a group of three, and therefore, from the point of view of the compilers’ methodology, its natural leader.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_129"
    }
  }, [_vm._v("This ordering of the camp gives perfect expression to the priestly theology of the God who lives among his ")]), _c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_vm._v("people (Exod 29:45). The structures which characterize periods of encampment are preserved for the journey (2:17), so that there is a continuing witness to the character of the community and its God.")])]), _c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("That this is a patriarchal community is evident in the male authority figures (Moses and Aaron) and in those chosen to help with the census and to lead generally. It is also clear that thoughts about war are present—another reason for the limited nature of a census that excludes women, children, and the elderly (1:3). The priests of the postexilic community are evidently sustaining this order and exerting their influence within the community in their revision of its formative story. That this influence is designed to secure their own place within both story and community is easy to see. The census has connections with the size of the offerings for the sanctuary (Exod 38:24–31); one of its outcomes is “registration” for the temple tax (Exod 30:13).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But such pressures are often ambiguous or more complex, with respect both to motivation and effects. Under Persian rule the priests took advantage of the opportunity to reconnect the community to its roots in the land and to preserve its identity, its purpose, and its sense of self-worth in an environment which in many respects remained unfriendly and difficult. They remained true to the traditions which spoke of liberation from the oppressions of imperial power (Egypt) while downplaying the significance of human militarism in achieving that goal (see also Lohfink’s discussion of the Pentateuch and war (1994: 173–226). One underlying effect of the census is to indicate God’s grace in causing the community to grow and prosper.")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("Priests and Levites (1:48–54; 3:1–4:49; 6:22–27; 7:89–8:26; 18:1–32; 26:57–62; 35:1–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The sharp distinction between priests (sons of Aaron) and Levites (other males from the tribe of Levi) is one of the most characteristic features of Numbers. In earlier texts Levites are highly valued as priests (e.g., Judg 17:7–13), though it seems to be assumed that others could serve in that role. In such texts the right of Levi as a whole to undertake such duties is affirmed (Deut 33:8–11). Deuteronomy confirms that right, and insists that it is exclusive to Levi (Deut 18:1–7). By contrast, Numbers insists that only the sons of Aaron and their descendants have full priestly rights and responsibilities; the remaining Levites (the majority) have a subordinate role as clerical assistants to the priests but with their own dignity and rights to income. The effect of this development is to give the word “Levite” a functional connotation, in addition to the tribal significance it retained.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is sometimes held that this development within the priestly office is traceable to the upheavals of the exilic period, and perhaps to adjustments or compromises which had to be made in the light of competing claims to legitimacy among exiled priests and those who continued to serve the cult in Palestine. In any event, the priestly editors and writers of Numbers are responsible for the relevant passages. Israel is identified as a “congregation” (1:53; 31:13, 16, 26, 43), and a preoccupation with the content of the tabernacle is readily apparent (1:50–51; 3:8, 25–26, 31, 36–37; 4:5–16, 24–33; 7:89). Aaron as a joint recipient with Moses of divine words is evident in 4:1; sometimes he even receives commands on his own (18:1, 8). That the general content of the passages is of immediate interest to the priests is obvious throughout.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Priestly Responsibilities")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The priests belong to the family of Aaron—Aaron himself and his sons Eleazar and Ithamar serving as such in the wilderness period (3:1–4). The fate of the elder sons is described in Lev 10:1–7. The duties of the priests are:")]), _vm._v(" "), _c('p', {
    staticClass: "BL1"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("to oversee the Levites with respect to their care of the sanctuary and its furniture (3:32; 4:28, 33), and to protect the Kohathites in particular (4:17–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("to protect the sanctuary from intrusions by outsiders (3:38)")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("to take responsibility for dismantling the inner sanctum and preparing its furniture and utensils for the journey (4:5–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("to pronounce the priestly blessing (6:22–27)")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("to take responsibility for the positioning of the lampstand (8:1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("to present the Levites as "), _c('i', [_vm._v("tenupah")]), _vm._v(" (“elevation offering”—NRSV) (8:10–11), an obscure procedure, which apparently dedicates them as gifts to the priests (8:20–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("to carry out sacrificial duties connected with the altar (both the altar for sacrifice and the incense altar) and all functions in the inner sanctum (18:5, 7, 8)")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("These duties involve supreme care, for the sanctuary and for the community. The divine blessing will be negated by any defilement of the sanctuary, inadvertent or not, and divine wrath in those circumstances would endanger the community.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Priestly Rights and Privileges")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The privileges attaching to the priestly office are:")]), _vm._v(" "), _c('p', {
    staticClass: "BL1"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the priesthood itself, the duties of which are conceived of as a divine gift (18:7)")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("to have the Levites as assistants and as a gift (3:9; 8:6, 19; 18:2–3). The point of the "), _c('i', [_vm._v("tenupah")]), _vm._v(" (elevation offering) is that it is a priestly source of income (Lev 7:34)")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("to receive as income the elevation offerings (18:11), the first fruits (18:12–13), the firstborn of clean animals (18:15), the redemption price for the firstborn of human beings and unclean animals (18:15–19), and a tithe from the resources (the best of them) received by the Levites (18:28–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("These rights and privileges clearly brought a degree of power and well-being to the priestly families in postexilic times.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Levitical Responsibilities")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("All Levites belong to one of three levitical families: Gershon, Kohath, and Merari. Gershon has two clans, Kohath four, and Merari two (3:14–20). They begin to serve at the age of twenty five and retire from their duties at the age of fifty (8:23–26).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The main duties of the Levites are:")])]), _c('p', {
    staticClass: "BL1"
  }, [_c('a', {
    attrs: {
      "id": "page_130"
    }
  }), _c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_vm._v("•"), _c('span', {
    staticClass: "space05"
  }, [_vm._v("to take responsibility under the priests for the tabernacle (1:50) and its furnishings (3:8):")])])]), _c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_c('p', {
    staticClass: "BL"
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("▪"), _c('span', {
    staticClass: "space05"
  }, [_vm._v("Gershon—the tent covering, the hangings, and the screen (3:25–26; 4:24–28)")])])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("▪"), _c('span', {
    staticClass: "space05"
  }, [_vm._v("Kohath—the sacred utensils and furniture (3:31; 4:15, 17–20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("▪"), _c('span', {
    staticClass: "space05"
  }, [_vm._v("Merari—the frames of the tabernacle (3:36–37; 4:31–33)")])])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space05"
  }, [_vm._v("to assist the priests (3:6) in duties not connected with the altar(s) or inner sanctum (3:7; 18:3–4, 6, 23)")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("These duties are clearly those of supervised assistants, but in the nature of the case they are deemed vital and honorable (contrast Ezek 44:10–14).")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Levitical Rights and Privileges")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The privileges attaching to the levitical office are:")]), _vm._v(" "), _c('p', {
    staticClass: "BL1"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("receipt of the tithes as income (18:21, 24, 30–32).")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("receipt of forty-eight cities with their pastureland (35:1–8). The priestly writers take the view that Levites "), _c('i', [_vm._v("do")]), _vm._v(" have a right to landed property (cf. Lev 25:32 and contrast Deut 10:9).")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("The effect of these rights and privileges is to provide a degree of economic independence and security within the community (contrast the impression given of their status in Deut 14:29).")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("The Significance of the Priestly Hierarchy")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The priestly writers stress the distinctiveness of the priestly tribe by insisting that the Levites are numbered separately (1:49). That this has to do with proximity to holy things is confirmed by 4:1–4. The total (22,300, not 22,000 [3:39]) makes Levi the smallest tribe; the males counted here include those from one month old and upward (3:22; contrast 1:3). As with the census in 1:1–47, we can only speculate about how the figures were calculated; the breakdown among the three families may have been influenced by estimates as to what their respective tasks required.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A second levitical census (4:1–4, 21–23, 29–30) identifies those between thirty years of age and fifty, that is, the men who are required to do the work in connection with the sanctuary.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("When the next generation is counted on the plains of Moab, the Levites have increased slightly—23,000 males from the age of one month upward (26:62).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The pattern of encampment further enhances the distinctiveness of the Levites. They, together with Moses and the priests, camp closest to the tabernacle and encircle it (1:53). The picture is as follows:")]), _vm._v(" "), _c('table', {
    staticClass: "Table1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdcenter"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_c('p', {
    staticClass: "td-center"
  }, [_vm._v("Merari (3:35)")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdcenter"
  }, [_c('p', {
    staticClass: "td-center"
  }, [_vm._v("Gershon (3:23)")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_c('p', {
    staticClass: "td-center"
  }, [_vm._v("TENT")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_c('p', {
    staticClass: "td-center"
  }, [_vm._v("Moses/Aaron/Priests (3:38)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdcenter"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_c('p', {
    staticClass: "td-center"
  }, [_vm._v("Kohath (3:29)")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("This proximity to the holy place is a mark of the higher holiness which the Levites and the priests embodied. Moses, Aaron, and the priests are the ultimate expression of this sanctity and thus are positioned on the east side close to the entrance of the tent.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A further function of this proximity to the tabernacle is protection and social stability. Dangers threaten from two directions. Outsiders must be prevented from defiling the holiness of the sanctuary, and the community must be protected from divine wrath, the reaction of holiness to any undermining of the sacred order (1:51, 53; 18:4, 22). The Levites themselves are subject to restraints, and the Kohathites in particular are at risk (4:15, 20); they must not cross the sharp boundary between priest and Levite. A common form that “wrath” could take would be plague (8:19; 16:46). It is clear that “atonement” is significant in this context (8:19), and that the presence of the Levites, keeping laypeople at a distance, has an “atoning” effect. The word has a complex set of possible meanings. In priestly literature it is often best understood as “purification” or “riddance”; the presence of the Levites “eliminates” any sin threatening the sanctuary and “absorbs” any wrath which threatens the congregation (for discussion see Milgrom 1991: 1079–1084).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Another prominent feature of the hierarchical arrangements is the idea that the Levites function as substitutes for the firstborn (3:11–13; 8:16–18), an idea the priestly writers connect with the deaths of the Egyptian firstborn (Exod 12:29). In 3:41 even the livestock of the Levites are substituted for the firstborn of animals generally. That the firstborn belong to Yahweh (in pre-Israelite times this may have entailed sacrifice) is affirmed in 3:13. Early Israelite laws envisage, not sacrifice, but redemption (Exod 13:2; 22:29; 34:20). The priestly innovation regarding the Levites necessitates another count, which yields 22,273 firstborn among the lay tribes (3:43). This means that, using the figure for the Levites given in 3:39 (22,000), there is an excess of firstborn, totaling 273. These must be redeemed at the price of five shekels a head, and the money handed over to the priests (3:44–51). This reestablishes the principle of redemption and may have been a practice the postexilic priests wished to confirm in the circumstances of their time. Once again, a concern to provide for the priests is uppermost.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This priestly view of order, and of the dangers which ensue if boundaries are crossed and confusion introduced, is clearly also a view of the basis for social stability. That this order in some way privileges both priests and Levites within the social order, and also provides them with comfortable means of support, needs to be recognized. Their income, as envisaged in Numbers, looks a good deal more ample than that provided in Deut 14:28–29; 18:1–5. This social order is also decisively patriarchal; only the males are counted, only the males can function in the various clerical spheres, and only the male firstborn need to be considered as belonging to Yahweh.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_vm._v("On the other hand, this stress on a community identity, with a sharply defined social structure, enabled the resettled community to overcome the dislocations and alienation of uprootedness and exile. A sense of communal dignity and purpose was important under conditions which did not allow complete political independence. The priestly blessing (6:24–26) has attained wide recognition as a classic expression of religious aspiration and feeling at its best. Versions of it, dating perhaps to the seventh or sixth centuries "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", have been found in the ")]), _c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_vm._v("Hinnom valley at Jerusalem on silver amulets or plaques (Levine 1993: 236–44). It expresses the community’s aspirations for security, well-being, and a peace which embraces all its members. The explanation (v. 27) “put my name” may refer to the priestly gesture of the hand which accompanies the blessing (Davies 1995: 69).")])]), _c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("Purity and Offering (5:1–6:21; 7:1–88; 9:1–14; 15:1–40; 19:1–22; 28:1–29:40; 31:1–54)")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("All the material on these topics is priestly, and the roots of its thought are in Leviticus. A key text is Lev 10:10, which distinguishes between two realms—the “holy” (the space occupied by the sanctuary) and the “common” (the space outside—including the rest of the camp and space beyond). A further distinction is made there between “unclean” and “clean.” Though this distinction can be applied to space, it denotes primarily various conditions which attach to objects or people at particular times. If they are “unclean,” such people or objects are problematic; safeguards must be observed and steps of a ritual nature must be taken to restore the situation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Offerings are also part of this worldview. They are sometimes necessary to rectify situations created by uncleanness (the expiation sacrifices [Lev 4:1–6:7]), or they honor God and seek his help, in the process creating bridges between holy and common (the pleasing odor sacrifices [Lev 1:1–3:17]). As events that take place on boundaries (in time or space), they often mark transitions from one state or situation to another.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The priestly writing as a whole is a worldview which constructs a cosmic system of order and stability, and within which the security and well-being of the community are perceived. While the system certainly privileges the priests with respect both to their resources and their influence, it also provides the community with a sense of identity within the scheme of things and a shared meaning system in situations of disruption and dislocation. Douglas (1993: 41, 158–59) has also suggested that it is a “benign” “non-discriminatory” system; she notes that purification is relatively easy and open to all, with good intention as the prime condition.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There remains of course the much discussed question of why purity systems take the forms they do. Historically their growth is probably complex, and ultimate origins are hard to locate. “Incongruity” and “associations with death” provide some of the likely formative influences.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Skin Conditions (5:1–4)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The demand that people with “leprous” conditions be excluded from the camp is found in Lev 13:46. The stipulations here offer a clarification and an expansion.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The expansion requires that exclusion be extended to those with a “discharge” or who have been in contact with a corpse. Leviticus discusses discharges in 15:1–33 and contact with death in a variety of contexts (11:39–40; 17:14–16; 21:1–4), but it makes no explicit reference to exclusion.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The clarification offered here in 5:1–4 is that females are also subject to the exclusion order. The succession of masculine pronouns in Lev 13:45–46 must therefore be interpreted inclusively, though the clarification might also be prompted by the fact that there are distinct female discharges (Lev 15:19–30).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The theological justification for exclusion lies in the claim that Yahweh’s indwelling presence at the heart of the camp requires it (5:8). His holiness is such that uncleanness in all its forms has to be set at a distance from him.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Restitution (5:5–10)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This law supplements the material in Lev 6:1–7. It deals with those occasions when compensation both to one’s neighbor and to God (in the form of a guilt offering) is required. The supplementary material here in Numbers again specifies that the law is applicable to women as well as to men (5:6).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It also presupposes the role of “next of kin” (or “redeemer”) (cf. Lev 25:25; Num 35:12), and indicates that where there is no such person to receive restitution, the compensation (8:10–11), in the event of the injured party’s death, is paid to the sanctuary, and specifically to the priest (v. 8). The priests are therefore in receipt of both the guilt offering and the financial restitution. This is another aspect of the tendency, already observed in Numbers, whereby the priests strengthen their access to the community’s resources, though it is reasonable to suppose that a situation such as this would be comparatively rare. The insistence on restitution and compensation undermines any supposition that priests were concerned merely with ritual and priestly dues; they also sought to foster practical social responsibility, an essential, in their eyes, if the fabric of the social order was to be restored.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There is the final insistence that every “sacred donation” (a reasonable rendering of "), _c('i', [_vm._v("terumah")]), _vm._v(") is a priestly entitlement. The principle had already been established in Lev 7:14, in connection with a very specific offering. Here all offerings which may be so designated are declared to be priestly property.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("The Adultery Ordeal (5:11–31)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The old ordeal rites concerning a woman suspected of adultery can also be deemed supplementary to provisions in Leviticus. In Lev 20:10 there is the very clear stipulation that guilty parties must be put to death. There is also an anxiety about hidden sin and the need to take appropriate precautions (Lev 5:17–19). Here a rite is prescribed which is intended to make known what is hidden, thereby insuring that perceived threats to the wellbeing and stability of the community can be dealt with.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There is no comparable procedure in biblical law, though the oath taking in Exod 22:10–13 (which may also be implied in the phrase “before God” in Exod 22:8 and 9) appears to anticipate some divine intervention which will resolve difficult cases.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_vm._v("The contrasting experiences of the man and the woman are striking features of the rite. The man’s psychological needs (his “spirit of jealousy” [5:14]) are catered for by the rite itself. The woman’s anxieties, of whatever kind, are ignored. She must simply await the outcome of procedures over which she has no control ")]), _c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_vm._v("and within which she has no influence. Moreover, she is subject to humiliation at the hands of the priest (vv. 18 and 27), who for his part benefits from the grain offering (v. 15) (see Lev 2:10). The disheveling of her hair (v. 18) seems to cast her in a dubious light; such a state would impugn the holiness of the priests themselves (Lev 10:6).")])]), _c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("A miscarriage is apparently expected should the woman be guilty (5:22). In the light of what she is required to drink (vv. 23–24) it may be supposed that any such eventuality would be improbable, but the psychological strains to which she is subjected should not be underestimated, and the risk of a serious miscarriage of justice is real. In v. 28, for example, there is at least a possibility that infertility will be interpreted as an indication of guilt, and the concluding comment (v. 31), wryly cited by Arabella in Hardy’s "), _c('i', [_vm._v("Jude the Obscure")]), _vm._v(" (pt. 5, ch. 8), is a reminder of the exploitation and disadvantage to which women have often been exposed.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Nazirites (6:1–21)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The vow of the nazirite is the means by which laypeople, male or female, can embody something of the holiness which is intrinsic to priestly ministry, though the assumption seems to be that it will be for a limited period only (6:13–20). There are allusions to nazirites in earlier texts (Judg 13:5; 1 Sam 1:11; Amos 2:11–12); there the defining characteristics are abstinence from alcohol and uncut hair. The circumstances prompting such a vow in Judg 13:5; 1 Sam 1:11 are those of grateful parents offering their children to God. Amos 2:11 is also inclined to suggest the dedication of young people. That being a nazirite was a lifelong commitment is clearly indicated in Judg 13:7; 1 Sam 1:11.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is arguable perhaps that priestly legislators thought such vows threatened the status of the priests, and that they must therefore be subject to controls. The traditional characteristics of the vow are retained (6:1–5), but it seems to be assumed that it will be made by responsible adults on their own accounts and only for limited periods of time.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As is customary, there are various points at which the legislation connects with Leviticus. Abstinence from alcohol places the same demand on the nazirite as on the priest who enters the tent (Lev 10:9). It is perhaps the fermentation process, with its transformative power, changing substances from one thing to another, that underlies its unacceptability in a “holy” context. Hair, like other substances, seems to embody a divine power which those taking the vow must respect.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The concern about a nazirite’s inadvertent proximity to a corpse (6:9–12) also connects with legislation in Leviticus, and with the duties and responsibilities of the priest depicted there. The priest is permitted contact with the dead in very limited circumstances (Lev 21:1–4), and any inadvertent indirect contact would require washing (Lev 22:4–6). The risks for a nazirite, circulating more widely in the community, are greater, and here an offering of two birds (burnt and sin offerings) and a male lamb (guilt offering) is stipulated. This is relatively modest in size, being the requirement for a sufferer from leprous disease who is being restored (Lev 14:21–32). The shaving of the head (6:9) indicates being done with the past and starting anew (v. 12).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The transitional character of offerings is also evident in the rites which mark the end of the vow (6:13–20). The person, by means of the offerings made, returns to his or her customary station in life. The burning of the hair (v. 18) may signify the return of divine power and life to God (as in the burnt offering); it also clearly marks the end symbolically of the period of the vow. The elevation offering "), _c('i', [_vm._v("(tenupah)")]), _vm._v(" (v. 20) is perhaps a specific ritual action (rendered “wave offering” in older translations such as the KJV and RV), which marks the flesh and the grain as belonging to the priest (Lev 7:28–36).")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Offerings for the Tabernacle (7:1–88)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This section draws on elements previously discussed in the priestly writing, in both Exodus and Leviticus. In Exodus 25–31 and 35–40 details about the construction and completion of the tabernacle are provided. In Leviticus 8–9 its priests and its cult are ordained and inaugurated. The construction of the tabernacle had from the outset been a product of the people’s resources and skills (Exod 35:4–39:43). The insistence is that it was voluntary (Exod 35:21) and that the response was far in excess of what was needed (Exod 36:5).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The offering brought by the laypeople on the day that the tabernacle was erected (i.e., on the first day of the first month of the second year—Exod 40:17) is here specified as six wagons and twelve oxen. This gift enables the Gershonite and Merarite priests to transport those parts of the tabernacle for which they are responsible; the Kohathites who carry the holiest items (4:5–15) are not entitled to such assistance (7:9).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The process of altar dedication takes twelve days, and offerings by a leader representing each of the tribes are made on each of these sacred days.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The leaders who make the offerings are the same as those who assist with the census in 1:5–15, but there is a distinct order of offering. In 1:5–15 the sons of Leah are listed first (Reuben, Simeon, Judah, Issachar, and Zebulun) and then the sons of Rachel (Joseph [Ephraim and Manasseh] and Benjamin). The remaining four were born to maids of the matriarchs (Dan, Asher, Gad, and Naphtali), but the arrangement does not follow the birth order suggested by Gen 30:1–13 (Dan, Naphtali, Gad, and Asher). Here in 7:1–88 the order of offering is influenced by the order of encampment given in 2:1–34.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The content of each daily offering is the same. Here, too, the legislators are assuming familiarity with earlier texts—the grain offering (Lev 2:1–16), the preparation of incense (Exod 30:34–38), the burnt offering (Lev 1:1–17), the sin offering (Lev 4:1–5:13), and the well-being offering (Lev 3:1–17). These offerings serve to illustrate the importance the priests attached to the involvement of the community at large in the life of the tabernacle and the ministry of the altar at its center.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Passover Law (9:1–14)")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_vm._v("This law presupposes the narrative and legislation in Exod 12:1–13:10, where the feast was first instituted. Its basic principles, and an account of its observance, are recorded ")]), _c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_vm._v("in 9:1–5. The main purpose of the text, however, is to develop the legislative tradition and to create a framework within which existing law can be interpreted for new and specific problematic situations. Two such situations are addressed here:")])]), _c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_c('p', {
    staticClass: "BL1"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("uncleanness through contact with a corpse")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("journeys at Passover time")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("A Passover observance on the fourteenth day of the "), _c('i', [_vm._v("second")]), _vm._v(" month (instead of the first) is permitted in these circumstances (9:11). It is to be assumed that these are exceptional and unavoidable situations; the law is not intended to relax the norms (v. 13).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Laws incorporating resident aliens into the life of the people of God are a feature of priestly legislation (9:14) (cf., e.g., Lev 16:29; 17:13; 19:34; 22:18; 25:47–55). Here the participation of aliens in the Passover appears to be voluntary, but, if accepted, the responsibilities and privileges of native and alien are the same.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The supplementary character of much of the legislation in Numbers is also evident in 15:1–31.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Accompaniments to Animal Offerings (15:1–16)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("These laws envisage the possibility that burnt offerings (Lev 1:1–16) and well-being offerings (Lev 3:1–17) may be accompanied by grain and wine. The circumstances in which this would be appropriate are when the sacrifice is in fulfillment of a vow, or when freely offered, or on a major festival (15:3). In point of fact, it is hard to envisage a situation in which an individual would offer sacrifices which could "), _c('i', [_vm._v("not")]), _vm._v(" be categorized in one of these three ways. The distinction between the votive and the freewill offering has already been made in Lev 7:16, but the concern there is only with the well-being offering and its disposal. The effect of the legislation here in Num 15:1–16 is to make grain and wine offerings a normal accompaniment of both burnt and well-being offerings. The quantities of flour and wine required depend on the size of the animal offered (vv. 5–10). As in 9:1–14, the resident alien is entitled to engage in the cultic life of the community (vv. 14–16; cf. also v. 26).")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("First Fruits (15:17–21)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The Holiness code (Lev 17:1–26:46) had already legislated for the offering of first fruits (Lev 23:9–14). The first cutting of the harvest must be offered to Yahweh, in addition to burnt, grain, and wine offerings. The distinctive feature here in Num 15:17–21 is that there must also be a "), _c('i', [_vm._v("terumah")]), _vm._v(" offering (“donation”—NRSV) of a loaf of bread from the harvest. Such offerings were the special possession of the priests, and were possibly subject to distinct ritual procedures (hence the old translation “heave offering”). This is further indication of a strengthening of the rights and privileges of the priests in those parts of the priestly legislation which occur in Numbers (cf. 18:1–32).")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Sin Offerings (15:22–31)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This material can be interpreted as supplementary to that on this topic in Leviticus. A fundamental purpose of the sin offering is to cleanse and protect the sanctuary from ritual defilement. Where the sins of the priests or the community at large are the cause, disposal of the carcass is by burning outside the camp (Lev 4:12, 21). Where the cause is some other source, such as the situations listed in Lev 4:22–5:13, and not involving the priests, there the flesh is a priestly entitlement (Lev 6:26, 29–30; cf. 10:16–20). The sins in question must always be inadvertent, and the impression given in Lev 4:13, 27; 5:2–4 is that sins of "), _c('i', [_vm._v("commission")]), _vm._v(" are at issue (contrast Lev 5:1, which seems to envisage a sin of "), _c('i', [_vm._v("omission")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The focus here in Num 15:22–26 is on the sin of the whole community (cf. Lev 4:13–21). There is a hint in 15:22 that this relates to sins of omission (contrast the explicit stress on commission in Lev 4:13). The requirement here is that the bull should be a burnt offering (not a sin offering, as in Lev 4:14). The sin offering consists rather of a male goat (15:24). The “atonement” which the offering accomplishes is purification for the sanctuary and forgiveness (a restored relationship with Yahweh) for the community.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The point of the supplement regarding sin offerings for individuals (15:27–31) is, as elsewhere, to make clear that resident aliens share fully in the community’s cultic life (v. 29) and to insist that sin offerings are only efficacious for inadvertent sins. Deliberate high-handed infringements incur the penalty “cut off from among the people” (vv. 30–31). This may have entailed a form of excommunication, or more probably the expectation that God himself would take some kind of direct action against the offender.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Sabbath (15:32–36)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The sabbath principle, along with the penalty for its infringement, has already been strongly affirmed in the priestly legislation (Exod 31:12–17; Lev 19:3; 23:3). It is clear nevertheless that answers to the question of what precisely constitutes sabbath work are necessary. A previous stipulation insists that kindling fire is an infringement of the sabbath (Exod 35:3). The narrative in 15:32–36 reveals the emergence of further answers. Using stories for legislative purposes clearly had its attractions (Lev 24:11–23; Num 9:6–8; 27:1–11; 36:1–12). In this instance the answer is established by a divine word; gathering sticks is sabbath work, and the offender must be stoned to death. While the earlier absence of a ruling on the matter may engender a certain sympathy for the man in his predicament, the supposition of the priestly writers was that he should have been far more cautious about engaging in such activity. This is particularly so since the kindling of fire has already been firmly prohibited (Exod 35:3).")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Fringes (15:37–41)")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_vm._v("It is appropriate that this section on “tassels” or “fringes” should conclude this body of laws (Num 15:1–36). Whatever the original significance of these blue fringes, they are interpreted by the priests as aids to the memory. Worn on clothes, they constitute a daily reminder of the obligation to follow Yahweh’s laws rather than personal predilection. Just as the sabbath story in 15:32–36 has affinities with the Holiness code in Leviticus, so, too, do the concluding verses of this chapter with their reminders that ")]), _c('a', {
    attrs: {
      "id": "page_135"
    }
  }, [_vm._v("the people must be holy and that Yahweh brought them out of Egypt (cf., e.g., Lev 19:2; 22:31–33).")])]), _c('a', {
    attrs: {
      "id": "page_135"
    }
  }, [_c('p', {
    staticClass: "H4"
  }, [_vm._v("Purification from Contact with Death (19:1–22)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("From the perspectives of the purity system, contact with death was a source of uncleanness which could not be ignored. The matter had already been addressed in Leviticus, in relation to contact with dead animals (Lev 11:24–38), and in the Holiness code as it affected the priests and their dead relatives (Lev 21:1–15). The laws in Num 19:1–22 make it clear that impurity ensues and cleansing is necessary, whenever people (clerical, lay Israelite, or alien) come into contact with a human corpse. The period of uncleanness lasts for seven days (v. 11), and purification is accomplished through washings on the third and seventh days (v. 12). The legislators are particularly alert to the consequences of laxity in these matters—the uncleanness will persist (v. 12b) and the person will be “cut off” (excluded or liable to divine punishment) (v. 13). The tabernacle itself will suffer defilement (v. 13), and the well-being of the whole community thereby put at risk.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The water used for the cleansing process must be specially prepared (vv. 1–10); it comes from water kept at the sanctuary which contains the ashes of a red heifer. There are various obscurities here. Why add ashes to the water? Why a red heifer? Why is it killed and burned outside the camp? Why the burning of the cedarwood, the hyssop, and the crimson material? There are no easy answers to these questions. It may be that the red heifer rite originally served some other cultic purpose and that it has been adapted by the priests to serve this new purpose—for cleansing after contact with a corpse. This might explain why the purposes of some facets of the rite are difficult to identify.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It appears that the ashes insure the holiness of the water. They are gathered by someone clean and deposited in a clean place (v. 9). Perhaps contact with death requires this extra precaution. The heifer is of course an animal suitable for sacrifice and therefore suitable, through its ashes, to be a purifying agent. The slaughter outside the camp makes it clear that this is "), _c('i', [_vm._v("not")]), _vm._v(" a sacrificial offering in the customary sense; the ashes remain outside the camp for the use of the people at large. Some of the blood, however, which, as always, is Yahweh’s, is sprinkled in the direction of the tent of meeting. This acknowledges the uniqueness of the blood and protects the sanctuary from any inadvertent defilements. Perhaps for this reason the procedures can be called a purification (sin) offering (v. 9). The wood, the plant, and the fabric figure in the cleansing ceremonials for skin diseases in Lev 14:4. It is usually assumed that these had traditional cultic uses and functions now lost to us.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The last part of the chapter (19:14–22) makes it clear that the contaminations of death extend beyond the person(s) who necessarily handle the body. Those who enter the tent, or are present at the point of death, are unclean; so, too, is the tent itself and any open vessels inside it. Contact with death in the open air is also contaminating, whether through bodies, bones, or graves. The procedures and warnings (vv. 17–22) are essentially the same as those in vv. 11–13.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("The Daily Offerings (28:1–29:40)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("These two chapters contain lists of offerings to be made at different points in the cultic calendar. As with so much of the priestly legislation in Numbers, there is information which supplements issues raised in Leviticus. This appears to be the fullest and final form of the Pentateuchal calendar. Earlier calendrical information can be found in texts such as Exod 23:14–17; 34:18–24. The Holiness code offers an approximation to the calendar here in Numbers and cites all of the occasions except the daily offering and the new month celebration (Lev 23:1–44). Among its particular concerns are to identify “holy convocations” and to insist that they are occasions of abstinence from work.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The information supplied here in Num 28:1–29:40 specifies the daily temple sacrifices which must be offered. They are therefore distinct from the private offerings which individuals might make, whether freely, or as an act of thanksgiving, or in fulfillment of a vow. The daily morning and evening sacrifice is “regular”; in other words, it is offered in addition to the special sacrifices which mark major festivals. Though the quantities and calendar may have been different in preexilic times, it seems likely that the king was responsible for providing the animals for these “public” occasions (cf. Ezek 46:1–8). In postexilic times the temple tax, levied on all registered males, provided the necessary income (Exod 30:13; Neh 10:32–33).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The cult, and the priests who administered it, were demanding by way of animal sacrifice (Coote and Ord 1991: 57–66, 105–15). The special festivals obviously call for more in the way of offerings. Unleavened Bread and Booths were weeklong events; hence the markedly larger requirements. The decreasing quantities at Booths (29:12–38) suggest that the importance of the festival days decreases, but why this should be so is hard to explain. A sin offering on the special occasions helps to protect the sanctuary from any defilements which threaten it on such public occasions and thereby also, from the priestly perspective, preserves the stability and well-being of the community.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The lambs, bulls, and goats were accompanied by grain offerings mixed with oil and by wine offerings. The oil measures for bulls and rams were probably in proportion to the additional quantities of flour required. These quantities of flour, oil, and wine were substantial; an ephah was probably about a kilogram and the hin about a liter (see GNB translation).")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("The War against Midian (31:1–54)")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_135"
    }
  }, [_vm._v("This account is exclusively priestly in content and is a reminder that “holy war” is not entirely absent from priestly thought. This particular conflict arises out of the priestly accretions to the Baal of Peor story in 25:1–18, which identify Midian (not Moab) as the major devious and destructive influence in that event (31:16–18). Balaam too, despite his prophecies in Israel’s favor, is killed (v 8). The priestly hostility to Midian is not easy to explain. There was, of course, a fierce rejection of intermarriage in postexilic times (cf., e.g., Ezra 10:1–44), and the priestly ")]), _c('a', {
    attrs: {
      "id": "page_136"
    }
  }, [_vm._v("scribes may have thought it vital to make clear that the old tradition which has Moses related by marriage to Jethro, priest of Midian (Exod 18:1), was not applicable as a model for the present. The story of the war in 31:1–54 carries through Moses’ command in 25:16.")])]), _c('a', {
    attrs: {
      "id": "page_136"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Despite priestly adherence to the concept of holy war, there is much that is stylized and unrealistic about this conflict. A round figure of 1,000 from each of the twelve tribes provides the army (31:4 and 5), which is accompanied, not by the ark, but by sanctuary vessels (v. 6). The victory is total and all-embracing (vv. 9–12). The quantities of booty captured are enormous (vv. 25–54), and all of this apparently without a single casualty on Israel’s side (v. 49).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The truth is that the priestly writer is less interested in the war as such than in purity and in the use and distribution of resources—hence the relevance of the “war” at this point in the discussion. The distinctive features of the priestly attitude to war are discussed by both Lohfink (1994: 195–224) and Niditch (1993: 78–89).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The interest in "), _c('i', [_vm._v("purity")]), _vm._v(" becomes apparent immediately when the army has returned to the plains of Moab. Moses is angered by an apparent breach of purity principles. All the captive women have been preserved, along with their offspring (31:15–17). As Moses perceives it, only the female virgins pose no threat to the purity of the camp, and only they can therefore be allowed to live (v. 18). It seems that the young Midianite males embody something fundamentally alien and dangerous, which the females who have engaged in sexual relations now share. The situation is exacerbated by the events at Peor, in which these females are said to have been implicated (v. 16).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The difficulties which purity systems pose are all too evident here; it is not simply the exclusion of that which is felt to be different and threatening, but its extinction. Purity systems help us understand our world and our experience, and their prevalence in human societies (and perhaps necessity) needs to be acknowledged. But they are deeply ambiguous and should always be open to criticism.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is easy to see how ancient patriarchal societies, frequently endangered and threatened perhaps with extinction, would value the procreative power of virgin female captives. It is interesting to note, too, that the priests do not exclude them from the holy community. The problem for the priests has nothing to do with modern fantasies about racial purity. It is not Midianite blood (the virgins who survive are born and bred Midianites), but Midianite maleness, and the womenfolk these men have made theirs through sexual relations, which threaten defilement and the supposed danger to tabernacle and community.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The war has also brought defilements on the army through killing and contact with death, and appropriate purity rites must therefore be observed (31:19–20, 24) (cf. 19:1–22). Miriam suffered a week’s exclusion for leprosy in 12:14, while the purification procedures (v. 19) would be those of 19:12. Garments and other items could also become contaminated, and for them, too, water would be necessary (Lev 11:32).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Metal items, primarily weapons, need, in addition to water purification, the purging influence of fire (vv. 21–23) (cf. Isa 6:6–7). Here, too, it is apparent that the priests are interested in war, not as a means to political ends but as a threat to the purity system which sustains the community.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In 31:25–47 attention turns to "), _c('i', [_vm._v("the distribution of the booty")]), _vm._v(". The items captured (humans and animals) are divided equally between soldiers and congregation (v. 27). From the share of the soldiers one item in every five hundred is Yahweh’s and goes to the priests (vv. 28–29), while from the share of the congregation one item in every fifty is Yahweh’s and goes to the Levites (v. 30). The association of priests with soldiers highlights the sanctity of the war and the way in which such activity is brought within the all-encompassing embrace of the priestly vision.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A key concern is to insist clearly that a fixed quantity of the resources accruing from the war belong to Yahweh, and that these items become the property of the temple clergy, the priests, and the Levites. It is appropriate to ask what interest would be served by such attention to detail in the circumstances of the Second Temple since the prospects for real war and real booty were negligible under Persian rule. The priestly writers were of course working with traditional themes about Yahweh’s war, and in telling the story about Israel’s past it was natural that they would wish to bring those themes within the compass of the priestly system. At one level this chapter serves to confirm the point that "), _c('i', [_vm._v("all")]), _vm._v(" resources, in all circumstances of life, are subject to levies which sustain and in some measure enrich the priestly classes. Evidence that the priests were seeking to establish and extend their power within the community are easy to find in Numbers. Yet this same process, which affirms Yahweh’s rights and power within the community, was one which served, in times of inescapable subordination to a foreign power, to provide social identity, cohesion, dignity, and durability.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The concluding element in the chapter (31:48–54) deals with the use and distribution of other items taken in the war. Here the same concerns are paramount—to strengthen the position of the priests and the distinctive identity of the community. The items in question are valuable ornaments and pieces of jewelry (v. 50), and "), _c('i', [_vm._v("all")]), _vm._v(" of these are brought as an offering to Yahweh. This contrasts with the deviousness of Achan in Josh 7:6–26. The offering is voluntarily made by the army officers, and in making the offering they seek “atonement” (31:50). It is interesting to note that the word can be used in a situation which does "), _c('i', [_vm._v("not")]), _vm._v(" involve the blood of animals. It seems to signify purification from any ritual defilement and protection from any consequences which defilement might bring. The valuables amount to 16,750 shekels of gold, and they are used in some unspecified way to enrich the tent of meeting (v. 54). In this way they function as a “memorial” (NRSV), a continuing witness to the success which God gave, and to the faithfulness and devotion of the participants in the war.")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("The Journey to the Land (9:15–10:36; 20:14–21:3; 21:10–35; 27:12–23; 32:1–34:29)")])])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_136"
    }
  }, [_vm._v("These parts of Numbers constitute the travel story at the book’s core. Most of the material comes from the priestly ")]), _c('a', {
    attrs: {
      "id": "page_137"
    }
  }, [_vm._v("writers, but there are clear and reasonably substantial traces of the earlier narrative traditions which they employed. An indicator of earlier tradition is the presence of ancient poetic fragments—for example, 10:35, 36; 21:14–15, 17–18; 21:27–30. In one instance the Book of the Wars of Yahweh is cited (21:14) as the source. These poetic pieces were probably already embedded within the earlier tradition when taken over by the priestly scribes. Texts which lack the characteristic description of Israel as a “congregation” or which fail to depict Aaron in priestly guise are probably early. Texts which betray overall editorial interests can be attributed to later levels of priestly tradition.")])]), _c('a', {
    attrs: {
      "id": "page_137"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("On this basis we can reasonably attribute the main outline of the wilderness journey to the early narrative tradition. Israel is traveling (10:35–36) and seeks, with some success, to enter the land from the south, close to Arad (21:1–3). But this fragmentary tradition is dominated by the stronger insistence that Israel took a Transjordanian route which avoided Edom (20:14–21) but which led to successful settlement further north (21:10–35). These territories become the possession of Gad, Reuben, and half of Manasseh, who agree to join an invasion of Canaan from the east (32:6–27, 33–42). It is clear that there are different levels of tradition within the story, which may perhaps be differentiated as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "BL1"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the old poetic fragments")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("traditions of settlement from the south and in Transjordan")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("the final form which envisages a journey "), _c('i', [_vm._v("through")]), _vm._v(" Transjordan to Canaan.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("The priestly writers do not modify the journey outline in any significant way. Their first concern is to show that it was conducted in priestly fashion (9:15–23; 10:11–28). They are also interested in authority and leadership issues—in the death of Aaron and the investiture of Eleazar as his successor (20:22–29), in the appointment of Joshua as eventual successor to Moses (27:12–23), and in Eleazar’s involvement in decisions about the invasion (32:1–5, 28–32). Their overall editorial interests are evident in the comprehensive account of the itinerary and settlement preparations (33:1–56) and in the account of the land’s dimensions (34:1–29).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Study Bibles generally contain relevant maps of the southern deserts and the Transjordanian region, with an indication of the sites which can be identified with some confidence.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("The Order of the March (9:15–10:36)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The priestly writers begin their account of the journey from Sinai with reminders about the means by which Yahweh guides and guards his people. The “pillar,” apparently cloud by day and fire by night, is present in the early narratives (Exod 14:19–20, 24). The priestly writers accept this and associate with it the notion of Yahweh’s “glory,” which signifies his awe-inspiring but protective presence (Exod 40:34–38).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The stress here at the beginning of the journey is on the guidance God gives through these agents of his presence (9:15–23). The way in which the points about guidance and obedience are insisted on at length is characteristic of the attention to detail in priestly thought. It was clearly important to the priests to indicate divine care and control "), _c('i', [_vm._v("before")]), _vm._v(" beginning the account of the journey itself (10:11). The “trumpets” cited in 10:2 are not the same as that in Lev 25:9, nor are they actually mentioned by name in the festival texts of the Holiness code (Lev 23:24; cf. Num 29:1). They are essentially for assembly. Use of one trumpet indicates that only leaders need assemble; use of both indicates that all must come. Distinct from the call to assembly are the “alarms” which these trumpets sound. The use of this word suggests a background in time of war (made explicit in 10:9). The primary interest at this point in the story is to indicate that the alarm is a command to set forth on the journey (10:5–6). For the priestly writers in Numbers these “trumpets” are indeed the festal musical instruments and can be used on a wider range of occasions than the festival texts themselves might suggest (10:10). Their use on these other occasions—war and cult (which for priestly writers are closely related)—serves to bring Israel to God’s mind (10:9 and 10).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The march begins nineteen days after the census (10:11; 1:1). The order of the march corresponds with the order of encampment in 2:1–34. Placing the Levites in central positions helps to preserve the sense that God is at the center, among his people, as the symbolism of 2:1–34 makes clear. Giving a distinct position to the Kohathites helps to emphasize their uniquely weighty responsibilities, as indicated in 4:4–20. The tribal leaders on the march are those who assist Moses and Aaron with the census (1:5–15).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This highly stylized and schematic picture of the way the journey begins is built on a shorter and possibly fragmentary account from the early narrative tradition (10:29–36). Moses’ father-in-law is here remembered as Hobab (contrast Jethro in Exod 3:1; 4:18; 18:1). These variants are probably indicative of diversity in the tradition. Hobab apparently belongs to the Kenites (Judg 4:11), early allies of Israel (Judg 5:24). The brief story here (10:29–32), in which Hobab is seemingly persuaded to continue the journey, helps to explain this close association. The tent-dwelling Kenites have an expertise which Moses values (v. 31). That Hobab should act as advisor about places to encamp contrasts with the priestly stress on divine advice (9:15–23).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_137"
    }
  }, [_vm._v("The position of the ark at the head of the Israelite column (10:33) is another point of contrast. The cloud in this story is over Israel (v. 34). The ark was a sacred box which, in deuteronomistic thought, contained the law tablets. The account of the construction of the ark in the early narrative has been supplanted by the priestly version in Exod 25:10–22. A number of features in this early story make the people look like an army on the march. Earliest tradition saw the ark as signifying Yahweh’s presence in time of war, and it might well be carried into battle (cf., e.g., 1 Sam 4:5–9). Both the poetic fragments (vv. 35 and 36) have associations with war. The first appears to envisage Yahweh as enthroned upon or above the ark and is a prayer for his enemies to be vanquished. The second is obscure, but in the word rendered “thousand” there is ")]), _c('a', {
    attrs: {
      "id": "page_138"
    }
  }, [_vm._v("probably reference, not to families but to Yahweh’s armies (Davies 1995: 98).")])]), _c('a', {
    attrs: {
      "id": "page_138"
    }
  }, [_c('p', {
    staticClass: "H4"
  }, [_vm._v("The Journey through Transjordan (20:14–21:35)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The account of the detour around Edom and through Transjordan depends primarily on traditions from the early narrative (20:14–21; 21:10–35), but it incorporates an isolated account of victory over the king of the southern city Arad (21:1–3). The priestly writer is content simply to insert an account of the death of Aaron and the investiture of Eleazar as his successor (20:22–29).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Moses addresses the king of Edom as “brother” (20:14) because of the ancestor traditions in Genesis which identify Esau (Jacob’s twin brother) as father of the Edomites. Though the stories celebrate the supremacy of Jacob/Israel the younger twin, as foretold in the birth oracle (Gen 25:23), there is an ultimate reconciliation (Gen 33:1–17). Moses has no wish to antagonize or in any way threaten a “brother” (cf. Deut 23:7–8).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Moses assumes that Edom will know of Israel’s experiences (20:14–16). The tradition of angelic leadership out of Egypt, which he cites in v. 16, is preserved in parts of the early narrative (Exod 14:19; 23:23). The conviction that the exodus was an escape from oppression is attested here (20:15), a central element in both narrative (e.g., Exod 5:1–6:1) and legal sources (e.g., Exod 22:21; 23:9). The King’s Highway was the main north-south route through Transjordan, and Moses promises to use it merely as a means of passage through Edomite territory.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The request seems reasonable, and the reader may be surprised that Edom is suspicious, hostile, and unyielding (20:18–21). As the oracles of Balaam will make clear (Numbers 22–24), Israel is widely feared as a potentially powerful people. Moses acquiesces because of the brotherly ties which bind Israel and Edom and because Edomite territory, unlike other Transjordanian areas to the north, is not part of Israel’s settled land.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The location of Mt. Hor (20:22) is unknown, but the priestly writer, in accordance with the story of rebellion in vv. 1–13, must give an account of the death of Aaron. It must take place before Israelite land is reached; hence this site somewhere on the borders of Edom.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Eleazar, the third son of Aaron, had not been implicated in the sin of Nadab and Abihu (Lev 10:1–7), so he is the appropriate successor. The priestly writer does not wish to exonerate Aaron for the sins associated with him in tradition (Exod 32:1–6), and the rebellion which leads to his exclusion from the land is frankly acknowledged (Num 20:1–13). In some ways the priestly account mirrors the experience of exiled priests in the sixth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". The writer acknowledges the justice of their exile but affirms very strongly the authenticity of the religion they represent through his stress on the Aaronic order instituted by God at Sinai.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The short account of a victory at Hormah (21:1–3) belongs to the early narrative but stands in some tension with its dominant story line. It suggests perhaps a successful incursion from the south, and in remembering Hormah as a place of victory it deviates from the main plot in which Hormah was a place of defeat which leads to the need for a detour through Transjordan (14:39–45). Arad was an important city on the southern boundaries of the land, and “the way of Atharim” is presumably to be located in that region.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The itinerary (21:10–20) comes from the early narrative. The water courses Zered and Arnon can easily be identified, but the place names with less certainty. The intention is clear, however—to indicate a route which takes Israel well to the south of the Dead Sea (avoiding Edom) and then northward through Transjordan to Pisgah, which must clearly be located to the north of the Dead Sea, opposite Jericho. In addition to avoiding the Edomites, the Israelites keep clear of Moabite territory, the writer identifying the Arnon as Moab’s northern boundary (v. 13). The inclusion of poetic fragments is characteristic of the early narrative.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first of these (21:14) is said to come from “the Book of the Wars of Yahweh.” There are various difficulties for translators here, and the text is too slight to judge with certainty of what kind it is. Is it simply indicating boundaries or is it a celebratory song? “The Book of the Wars of Yahweh” appears to contain material of the latter type. If v. 14 contains such a song, it may commemorate victories in the region to the north of Moab. Ar was clearly a Moabite town of some importance (v. 28), but its capture or defeat is not necessarily implied.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("“The Song of the Well” (21:17–18) is another ancient fragment. It evidently reflects the experience of peoples living on the margins of the desert. It may celebrate the successful discovery of water, or be a text for use in the search for this vital resource. Reference to the scepter may indicate royal rites as part of procedures and observances at potential or discovered water sources.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The early narrators go on to record victories and settlement in the territory to the north of Moab and to the east of the Jordan River (21:21–35). Sihon is the monarch of a small Amorite kingdom. Amorites could be found elsewhere, and the word can sometimes be used of Canaanites in general. Moses’ request (v. 22), like that made to the king of Edom (20:14–19), asks for passage and promises to keep to the King’s Highway, avoiding any expense to Sihon and his people. Sihon’s refusal, unlike that of the Edomites, leads to a battle, near Jahaz, and a comprehensive victory which secures for Israel all the territory between the Arnon and the Jabbok rivers. The main prize is Heshbon, which Sihon, according to the story, had previously captured from Moab (v. 26).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A more substantial poem is incorporated at this point (21:27–30). Like many such pieces, it is not fully intelligible (for detailed discussion see Davies (1995: 231–34). The allusions to Heshbon clearly explain its inclusion by the narrators. The song calls for the rebuilding of the city and recalls a successful campaign conducted by Sihon its king against Moabite territory, and particularly against Ar, one of its major cities. Moab is evidently the target of the singer’s mockery (such texts are sometimes called taunt songs), and the song highlights the destruction, slavery, and diminution suffered.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_138"
    }
  }, [_vm._v("If it is correct to see taunts and mockery in the song (and in other such biblical texts), then the apparent delight in human suffering and the effects of war is distasteful, to say the least. The songs were themselves a ")]), _c('a', {
    attrs: {
      "id": "page_139"
    }
  }, [_vm._v("product of precisely such suffering, often at the hands of those whose downfall is now celebrated. The texts are a reminder of the vicious cycles of violence and revenge that greed, oppression, and war generate.")])]), _c('a', {
    attrs: {
      "id": "page_139"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("A further episode of military engagement, victory, and settlement occurs in 21:33–35. Bashan must have been still further to the north, somewhere to the east of the Sea of Galilee and in territory subsequently occupied (according to the story) by the Gadites (one of the Israelite tribes). For the narrators this was always part of the land, and so Moses makes no request to pass through. Og, the king of Bashan, is remembered by the deuteronomists as the possessor of an unusually large bed (Deut 3:11). The victories over Sihon and Og became a familiar motif in Israelite hymnody (Pss 135:11; 136:19–20).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The historicity of this journey through Transjordanian territory is very hard to assess. The story presupposes a united Israel under single leadership at a stage when strong historical evidence, inside and outside the Bible, points to much more complex processes of migration and settlement. Israel, in the sense in which the story understands it, probably did not exist prior to the monarchy. The ancient poetic fragments give the historian little to work with, and their content suggests that the early narrators were in the same predicament. The story they told may have various functions. It certainly affirms the legitimacy of settlement and royal rule in parts of Transjordan. The story may also be a means of uniting southern traditions associated with Kadesh and eastern tribal tradition. The effect is to produce a single national epic, a natural and necessary interest from the point of view of kings and their courts.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("The Commissioning of Joshua (27:12–23)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The priestly writers add to the story an account of the commissioning of Joshua as the successor to Moses. It is worth considering why they do so at this particular point. The early narrators had brought Israel to the place in Transjordan where Moses was to die, but the Deuteronomists do not set forth the account of his death and the mysterious circumstances of his burial until Deut 34:1–12. Perhaps the priestly writer thought it important that the event should not be far removed from the circumstances that gave rise to it (Num 20:1–13) and that assurances about the succession were available to the reader.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Joshua was already established in early tradition as an assistant (Exod 33:11) and a man of prophetic inspiration (Num 11:18). He is also identified here as a man endowed with “spirit” (divine insight and power) (27:18). The main concerns of the priestly writer, however, here in vv. 12–23, are to stress once again the reason for Moses’ exclusion from the land (vv. 12–14) (cf. the account of Aaron’s death in 20:22–29) and to bring the Mosaic succession within the orbit of priestly order (27:15–23).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The reason for God’s refusal to allow Moses to cross the Jordan is found in the story of Num 20:1–13. As in the case of Aaron, the failure of Moses was not an embarrassment for the priests of the exile. It helped to show that those who had been excluded from the land, as they themselves had, could still be recipients and agents of an authentic religious order.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Joshua’s task as leader is depicted with the help of images from pastoral husbandry. The Deuteronomistic stress on Joshua as an aggressive man of war is here modulated into a picture of him as a shepherd, offering guidance and protection (v. 17). This corresponds well with the circumstances of the Jewish community under Persian rule in postexilic times. The Jewish priestly leadership has no ambition to lead or encourage a war of liberation or conquest. Their task is to care for the community through observance of the cult.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Eleazar, as chief representative of the priestly order, is drawn into the rites of commissioning (27:19). It is important to stress that Joshua’s shepherding is undertaken under the direction of Eleazar’s sacred oracle (the Urim) (v. 21). It seems likely that eventually the Urim (and Thummim) had little more than symbolic significance. In Exod 28:30 they are decorative elements in the high-priestly vestments, though we should not assume that a functional role had ceased altogether in early postexilic times (Ezra 2:63). In earlier tradition they are clearly means (perhaps stones for throwing) by which consultations with God can be made (Deut 33:8; 1 Sam 14:41–42).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The laying on of hands in this passage (27:18, 23) evidently confers Mosaic authority on Joshua as the man commissioned to take Moses’ place (v. 20).")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Settlements in Transjordan (32:1–42)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The literary evidence suggests that an early story of this event has been overlaid with minor priestly accretions. The priestly elements are notes to the effect that Eleazar is consulted along with Moses (vv. 2, 28), and that Israel is structured as a congregation with tribal leaders (vv. 2, 4). They also reflect a knowledge of the priestly account of the spies and the forty years of wandering (vv. 12, 13).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The land of Jazer and Gilead (32:1) is situated to the east of the Jordan and consists of the land captured in the battles of 21:21–35. Its suitability as grazing ground for cattle impresses Gad and Reuben, and they note nine places of settlement in particular which attract them (v. 3). Most of these names reappear in what appears to be an independent and larger list of Transjordanian settlements, incorporated by the early narrative in vv. 33–42. If Sebam and Sibmah are identical, then only Nimrah and Beon (v. 3) are absent from the larger list. Evidence from the book of Joshua suggests that Gad’s territory lay to the north of the region (Josh 13:24–28) (i.e., to the north of Heshbon). Reuben’s area was to the south, from Heshbon down to the Arnon (Josh 13:15–23).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The larger list of settlements (32:33–42) records Transjordanian activity by elements from Manasseh who occupy parts of Og’s territory, well to the north and bordering on the Golan to the east of Galilee (Josh 17:1–3). It would appear that while this information was available to the early narrators, they chose not to incorporate it into the texture of the story in 32:1–32. This may reflect the administrative arrangements which obtained when they wrote and under which Manasseh was situated to the west of the Jordan.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_139"
    }
  }, [_vm._v("Israel’s hold on land to the east of the Jordan was variable during the period of the monarchy and at its most extensive during the reigns of David and Solomon. The ")]), _c('a', {
    attrs: {
      "id": "page_140"
    }
  }, [_vm._v("settlements envisaged here are more modest. They nevertheless affirm a significant presence there.")])]), _c('a', {
    attrs: {
      "id": "page_140"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("At the same time, the fact that Moses himself does not order the settlement and needs to be persuaded by Gad and Reuben is a peculiarity that deserves explanation. If it is correct, as currently held by some, that Israel’s historical origins lie in the hill country to the west of the Jordan and were a result to a significant degree of migration from the lowlands, then the Transjordanian settlements probably represent a subsequent expansion eastward. The dominant motif in the early narrative epic, a story of a united Israel on the march through Transjordan and entering the land from the east, reverses the historical flow and establishes the Transjordanian tribes as the first settlers. The historical realities about Transjordan (later settlement and harder to hold) might be reflected in the need to persuade Moses.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("The Itinerary (33:1–56)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This section reviews the whole journey thus far, from Egypt to the east of the Jordan, opposite Jericho. It includes data from both the early and priestly traditions and is probably to be traced to the priestly editors who gave the book its present form. The journey is perceived as a march, in formation (v. 1), presupposing the priestly processional order in 10:11–28. A number of the place names have not previously occurred, but the editors presumably had enough locations within the traditions to enable them to reconstruct their view of the route. The journey had three main components:")]), _vm._v(" "), _c('p', {
    staticClass: "BL1"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("from Egypt to Sinai (vv. 5–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("from Sinai to Kadesh (vv. 16–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("from Kadesh to the Jordan (vv. 37–49)")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("The text notes that Moses wrote down the itinerary (33:2); the view that Moses engaged in literary work and was ultimately the author of the Pentateuch emerged strongly in postexilic times. Aaron’s age at the time of his death (v. 39) is also additional information (cf. 20:22–29).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A review of progress thus far comes appropriately at this point in the story. The priestly writers were of course well aware of Israel’s disaffection in the desert and at some points developed it, as in the story of the manna in Exod 16:1–36, but they retained the sense that the exodus was a triumph of God’s grace and power (Exod 14:17) and saw the journey and its route as the successful outcome of God’s purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The concluding verses of the chapter (33:50–56) issue a command to expel the inhabitants of Canaan and severe warnings about the religions they practice. There may be an early base to these verses, but the theme is more characteristically Deuteronomistic in its allusions to the exclusion of alien practices and to the stones and images of Canaanite religion (v. 52). Priests of the exilic and postexilic periods shared such concerns (cf., e.g., Lev 26:1). The concept of apportionment of the land by lot (v. 54) is one which might be attributed to the Deuteronomists but which can as readily be associated with the “ideal” perceptions held by the priests (cf. Josh 18:6–7). The word “ancestral” (v. 54, NRSV) is reminiscent of priestly usage in 1:2.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The biblical hostility to religions deemed alien has sometimes been used as a justification for intolerance and cruelty and, on the face of it, sits uneasily with pluralistic worldviews. It is certainly arguable that this hostility has its roots in a resistance to the oppressive power of prevailing religious ideologies and their exploitation by kings and others who wield that power. But if that is the case, the texts ought to function as a stimulus, not to authoritarianism and the abuse of power but to an informed critique of both power and religion, a critique from which faith itself might benefit.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("The Boundaries of the Land (34:1–29)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("An extensive tract of land is envisaged, stretching from the Egyptian border (34:5) to Lebo-hamath (v. 8), well to the north of Damascus. David’s campaign in the north is described in 2 Sam 8:3–8 and his friendly relations with the king of Hamath in 2 Sam 8:9–12. This “ideal” appears to be Deuteronomistic in origin (1 Kgs 8:65), but it raised no problems for the priestly editors.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The western boundary is the Mediterranean coast (34:6). The eastern boundary appears to lie somewhere to the east of the Sea of Galilee and then becomes the Jordan and the Dead Sea (vv. 10–12). There are large areas to the north and east here which Israel rarely, if ever, controlled. Since the terms of the story assume that the Transjordanian tribes are already settled, the allotment of land will effectively occur only in land to the west of the Jordan (vv. 13–15). The narrator locates himself to the west of Jericho (v. 15) and therefore perhaps at the royal court in Jerusalem.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Another list of tribal leaders is required to assist Joshua and Eleazar in conducting the apportioning of the land. It is obvious that of those who conducted the reconnaissance of the land (13:1–16) only Caleb (representing Judah) will have survived to assist, and he is cited first. The ordering of the rest, with Gad, Reuben, and Levi (the priestly tribe) excluded, follows a new listing pattern. The southernmost tribes (Judah, Simeon, and Benjamin) come first, followed by Dan in the far north, then those in the central hill country (Ephraim and Manasseh), and finally the Galilean tribes (vv. 16–29).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The struggle for land continues to be a problematic, and sometimes deeply divisive, issue. There are biblical “ideals” about the extent of the land, sometimes expressed with a degree of precision, as in this chapter. It has to be said that rarely, if ever, were these ideals realized in biblical times, while a major theme of the Deuteronomistic history is that land can be lost as well as gained. Insofar as biblical land signifies access to vital resources and human well-being (a land “flowing with milk and honey”), it represents a vital and legitimate human aspiration (for substantial discussion see Brueggemann 1977). Insofar as it becomes associated too strongly with sovereignty, power, and exclusion of others, its symbolism remains deeply problematic.")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("Disaffection Stories (11:1–14:45; 16:1–17:13; 20:1–13; 21:4–9; 25:1–18)")])])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_140"
    }
  }, [_vm._v("The tradition of Israel’s disaffection during the journey is well established in both early narrative and priestly traditions. It is also present in the earlier phases of the ")]), _c('a', {
    attrs: {
      "id": "page_141"
    }
  }, [_vm._v("journey recorded in the book of Exodus (e.g., Exod 14:11–12; 15:24; 16:2–3; 17:2–3; 32:1). The early elements can usually be identified by their depiction of Israel as “the people” or simply “Israel”; the priestly writers invariably deploy the word “congregation.”")])]), _c('a', {
    attrs: {
      "id": "page_141"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The early narratives of this kind have a variety of functions. Some exhibit etiological interests, providing explanations for place names on the journey (11:3, 35). This follows a pattern already established in the story in Exod 15:23; 17:7. It seems likely that these explanations are secondary, presupposing the disaffection motif; they are sophisticated and literary, and the place names could as well lend themselves to other interpretations. The interest in disaffection as apostasy (25:1–5) is reminiscent of Exod 32:1–35, but it is too occasional to be the traditional core of the motif.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("An issue more central to the stories is the legitimacy of the journey itself. Elements among the people look back regretfully to the comforts and securities of Egypt (11:4–6; 21:5) and even plan to return there (14:4). The leadership provided by Moses is thus a matter of serious concern (16:13–14). Not surprisingly, this prompts questions about the demands of the project (11:10–15), which in turn provide a basis for stories dealing with issues of a more general nature—the validity of prophecy (11:24–30) and the uniqueness of Mosaic authority (12:1–16).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There are biblical traditions which view the wilderness experience in positive terms (Hos 2:14; Jer 2:2), while Psalm 105 focuses on the period entirely as one of gracious provision. What prompted the belief that it was also a period of rebellion (reflected in Psalms 78; 106) is debatable. The motif certainly provides a means of explaining Israel’s long detour and entry into the land from the east. But there is still the question—why explain the detour in terms of disaffection? There must have been other less negative ways of accounting for the route taken. The critique of Israel embodied in the motif probably reflects the work of the prophets, Israel’s earliest and greatest critics. If we can indeed attribute the latest elements in the early narrative to the time of Hezekiah, the collapse of the Northern Kingdom and its incorporation into the Assyrian Empire (721 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") may have contributed to the picture of Israel as persistently rebellious. The specific interest in returning to Egypt in the handling of the motif may mirror criticism of pro-Egyptian policy in Judah (cf., e.g., Isa 30:1–7; 31:1–3), a further example, as some might have seen it, of the same rebellious tendency.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Priestly interest in the motif tends to consist of accretions to the existing tradition. The story of water from the rock (20:1–13) reworks the early tradition now found in Exod 17:1–16. The priestly writers wish to stress failure to enter the land as the fruit of faithlessness (14:26–38; 20:12). They also employ “opposition to Moses” in earlier tradition as a means for legitimating priestly order (16:1–17:13; 25:10–13). It proved useful as a tool for pressing their essential distinction between priests, the sons of Aaron, and the rest of the Levites.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Fire at Taberah (11:1–3)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The story of complaints at Taberah reveals very clearly the simple structure of the disaffection stories in the early narrative as they appear in Numbers. Disaffection, hostile divine intervention, intercession, and divine restraint are the four essential elements. The stories in Numbers are less sympathetic to the people insofar as there is no preliminary account of their predicament (contrast Exod 15:22–23; 17:1) and in that Yahweh’s hostility is more immediate and destructive. The divine fire at the camp’s perimeters is reminiscent of the divine fire in the prophetic stories associated with Elisha (2 Kgs 1:10, 12, 14). The etiology (11:3) is a scholarly note appended by the narrators. The place name does not generate the story. Taberah could have been understood as a place where fire consumed Israel’s enemies. It is the existence of the disaffection motif which prompts the thought that Taberah must have been a place where a tragic outcome of disaffection was experienced.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Quails (11:4–35)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This story is complex. The familiar elements of desert disaffection stories are present, but particular features of that tradition are much expanded in the interests of new motifs which are of special concern to the early narrative. A basic story can be detected in 11:4–6, 31–35. It tells of complaints about the monotonies of wilderness food and of a divine response which turns out to be an act of judgment. There is also the familiar scholarly note which interprets the place name Kibroth-hattaavah in terms of disaffection. It would appear from Ps 105:40 that desert quails, at least in cultic circles, were not always thought of negatively (though they are in Ps 78:30–31). The power of the disaffection motif to transform a tradition is thus very evident. For the priestly writer, whose account of desert provision dominates in Exod 16:1–36, quails, along with the manna, are an earlier gracious response to need. The quails and manna constitute respectively the “meat” and the “bread” which Yahweh supplies (Exod 16:12 and 13).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The story also contains a scholarly note about the appearance of manna and the ways in which it was collected and used (11:7–9) (cf. similar notes in Exod 16:14, 31). Manna is usually associated with insect excretions found on the tamarisk tree. The quails tradition also reflects a familiarity with a food which might occasionally become available in desert places.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The complexity of the story arises, however, from the use of the basic tradition of wilderness disaffection in the interests of an exploration of the question of leadership in the community. Whereas Moses might have been expected to intercede with Yahweh (as in 11:2), he here delivers an extended protestation about the difficulties of leadership (vv. 10–15). The themes resemble an issue already addressed in Exod 18:13–27, where the problem is the weight of judicial decision making which burdens Moses. The solution there is the appointment of able, God-fearing men to assist. Here the problem is of a more general kind—the pressure of leading and providing for a disaffected people, who appear to have lost faith in the journey and its goal. At the heart of Moses’ complaint is the fact that Yahweh, not he, has conceived and given birth to this people; the burden of motherly provision, a notable metaphor, should therefore be with Yahweh (11:12–13).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_141"
    }
  }), _c('a', {
    attrs: {
      "id": "page_142"
    }
  }, [_vm._v("The protest is accepted, with Yahweh indicating that he will indeed provide—albeit in a way which will make the people regret their discontent (11:18–23). The phrase “consecrate yourselves” (v. 18) (cf. Exod 19:10) suggests that the quail giving is as solemn an act of divine intervention as God’s revelation of himself at Sinai. The pressures of leadership in general are to be shared with seventy elders (11:16). Leadership is clearly characterized by spirit endowments (v. 17) which enable the recipients to function as prophets (vv. 24–25).")])]), _c('a', {
    attrs: {
      "id": "page_142"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("A further episode involving Eldad and Medad (11:26–30) authenticates prophecy at large, and not simply the authorized prophecy of temple and court. In point of fact Eldad and Medad are among the seventy (“registered” [v. 26]), but for some unspecified reason they are not present with the rest at the external tent of meeting (cf. Exod 33:7–11). The authenticity of prophecies in places other than temple and court is thereby affirmed. The aspiration of Moses that all should be prophets (v. 29) goes further still; the freedom of the divine spirit means that prophets are not necessarily “registered” or officially authorized.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is of interest to speculate why it was felt important to engage in this particular discussion. As court writers from Jerusalem the early narrators would naturally associate spirit endowment with the charisma of kings, and particularly with that of the Davidic dynasty. It may be the case that traditions of this kind legitimize the involvement of the prophets in affairs of state. If we can trace the early narrative to the time of Hezekiah, it is reasonable to associate this interest with a much increased respect for northern prophetic tradition in the wake of the fall of Samaria (721 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("). The prophecies of Hosea, the stories about Elijah and Elisha, and perhaps the Elohistic parts of the Pentateuch are all testimony to a southern seal of approval for northern Yahwism at about this period.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The text’s critique of the craving for meat is also of interest. In a context in which frequent meat consumption was familiar only in courts, temples, and the homes of the wealthy generally (see, e.g., Coote and Ord 1991: 57–66), the description of the instigators of this particular example of disaffection as the “rabble” (11:4, NRSV) is inherently ambiguous. Is the narrator critical of envy and unrest among the poor or of the indulgence of the rich? If his work can be tracked to a period of social reform such as the reign of Hezekiah appears to have been, then the rich may have been the objects of his attack. His sympathy in this episode for the stance of the prophets, even of those not authorized, is suggestive in the same way.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Miriam and Aaron (12:1–16)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The story of Miriam’s “leprosy” is another vehicle for the consideration of questions concerning authority and leadership. That this is also part of the early narrative is suggested by the absence of any priestly characteristics for Aaron and by a tent of meeting located outside the camp (12:4). There are some indications that here, as in 11:4–35, older tradition has been developed in the interests of these questions about authority and leadership. A curious feature of the story is that although Aaron is implicated in the criticism of Moses and is said to be one of the objects of Yahweh’s anger (12:1–9), he escapes any unpleasant consequences and is depicted as intercessor on Miriam’s behalf (vv. 10–12). We may therefore suspect an older tradition in which Miriam alone was the critic and in which the point at issue was Moses’ choice of a Cushite wife (v. 1). The expansion of the tradition implicated Aaron and focused on the question of the uniqueness of Moses as divine spokesman (v. 2).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Miriam’s place in ancient Israelite history cannot now be determined, but her importance as an ancient leader, comparable to Deborah (Judg 5:1), is suggested by the old tradition preserved in Exod 15:19–21. Cushites were customarily people from Egypt, and since the name Moses is itself Egyptian in form, there may well be ancient and accurate tradition here about his origins and marriage. The hostility of Miriam may also have historical roots.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The main interest of the narrators, however, is the question of the uniqueness of Moses as a divine spokesman. Aaron is drawn in as critic in order to dramatize the absolute authority attaching to the words of Moses. It must be understood that although seventy elders are endowed with Mosaic spirit (11:25) and although Moses wishes that all the Israelites were prophets (11:29), his own status as one with privileged access to Yahweh and his will is unique and not to be challenged. It may be that in their day the early narrators thought of the king as embodying Mosaic authority, but late in preexilic Judah, and under the influence of the Deuteronomists, Mosaic authority came to be located independently, in written laws and reform programs. The work of the scribes who produced the early narrative here may well have fostered that process. Moses, after all, was a humble man who did not seek dignity or homage (12:3).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The pillar of cloud which marks the divine appearance (12:5) recalls the protective divine presence at the Sea of Reeds (Exod 14:19). The reference to it here clearly heightens a sense of the importance of the occasion and of the revelations which are to come. These are the divine words in 12:6–8. Their main aim is to draw a clear distinction between the inspiration of the prophets and the authority of Moses. Prophetic words, like other forms of divine speech, are "), _c('i', [_vm._v("mediated")]), _vm._v(". They may appear more spontaneous than, for example, the priestly oracle, but in reality they are communicated through “visions” and “dreams.” Nor are they wholly unambiguous. There may be something obscure or elusive in the words of prophets (hence the “riddles” in v. 8). Moses, by contrast, enjoys "), _c('i', [_vm._v("immediate")]), _vm._v(", “face-to-face” access to the presence of Yahweh, which clearly gives a priority to the words he speaks. A prophetic inspiration which challenges or contradicts his words must be deemed suspect.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The belief that God is visible to human eyes is affirmed elsewhere in the early narrative (Exod 24:10). For Jacob this is a “face-to-face encounter” (Gen 32:30), but not apparently for Moses in Exod 33:20–23. Here, however, Moses shares the privilege of Jacob (v. 8). The encounter “face-to-face” is a metaphor for the clarity and finality of God’s message to Moses.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_142"
    }
  }, [_vm._v("It is important to note the terms in which Moses is described. He is “my servant,” and also “entrusted with all my house” (12:7). Both phrases aptly describe the status ")]), _c('a', {
    attrs: {
      "id": "page_143"
    }
  }, [_vm._v("and role of the king as understood in preexilic Judah. The probability is that the concern here is not so much to legitimize the king—that would need to be more explicit—but to establish Mosaic tradition as the final and decisive authority in the life of the people, a task effectively carried through by the Deuteronomists. Moses is the ultimate “servant,” whose authority and message insure the well-being of the community.")])]), _c('a', {
    attrs: {
      "id": "page_143"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The “leprous” condition which afflicts Miriam (12:10) could be one of a variety of skin complaints. Laws about these conditions are preserved in Lev 13:1–14:57. Aaron’s plea for mercy, followed by the intercession of Moses, calls forth a curious divine response (12:14). To spit in someone’s face is clearly an expression of utmost contempt. It is endured, along with removal of the sandal, by the man who refuses to marry his dead brother’s wife (Deut 25:9), in accordance with custom. The circumstances under which a father might treat a daughter in this way, and exclude her, can only be guessed at. Yahweh’s reference to such a practice could be read in different ways. Perhaps his intention is to stress the gravity of the offense; she is the object of contempt and suffers withdrawal of family privilege and protection for a period. Perhaps the response is to be understood as gracious. A disowned daughter would suffer only seven days’ exclusion; Yahweh will demand no more.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It may reasonably be assumed that with her return to the camp Miriam is healed of the condition. Certainly the priestly editors of Numbers would have made that assumption. While the history of the tradition (as previously suggested) may offer some explanation for Aaron’s escape from the consequences of his offense, this aspect of the story remains unsatisfactory. Later traditionists do not seem to see the problem, let alone offer answers. In Mic 6:4 Moses, Aaron, and Miriam stand together as founders of Israelite faith. Pentateuchal tradition, for its part, finds fault with all three (cf. also Exod 32:1–6; Num 20:1–13). Moses nevertheless becomes the great lawgiver, and Aaron the founding father of a privileged priesthood. Only Miriam remains in relative obscurity and without a major impact on the tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Reconnaissance of the Land (13:1–14:45)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This long and much amplified tradition is difficult to analyze in detail, but there appears to be:")]), _vm._v(" "), _c('p', {
    staticClass: "BL1"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("part of the early narrative telling of a report by the spies in which only Caleb speaks favorably, which provokes disaffection, a change of plan, and ultimately an abortive attack from the south (13:17–20, 22–24, 27–30, 33; 14:3–4, 25, 39–45)")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("some expansion (14:13–24), possibly Deuteronomistic, which stresses the role of Moses as effective intercessor (cf. Exod 32:7–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("a major priestly revision which lists the spies, includes Joshua along with Caleb as a faithful spy, develops the disaffection, depicts Moses and Aaron as pleading with the rebellious, and makes it clear that the faithless spies and the whole of the rebellious generation will not enter the land (13:1–16, 21, 25–26, 31–32; 14:1–2, 5–12, 26–38)")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("The intentions of the early narrative are influenced by a need to account for the failure to invade from the south (the obvious direction) and to affirm a tradition of conquest across the Jordan from the east. The Deuteronomists had a particular interest in Moses as the great intercessor and mediator between God and the people (cf., e.g., Deut 4:9–24; 9:8–21). The priestly interest in lists of tribal representatives is familiar (cf., e.g., 1:5–16; 26:5–51), and there is a particular concern to establish this incident as the great watershed between one generation and the next. It may be that the priests of the early postexilic period saw parallels between this rebellion at Kadesh and the circumstances of the exile. In both instances access to the land was at stake, and they, like the new generation in the wilderness, were the nucleus of God’s future.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The leaders listed as spies in 13:4–15 are not the same as those who undertake the census in 1:5–16. The background and origins of the names are as difficult to establish as in the other priestly lists. The order in which the tribes are listed is again distinct. Like other priestly lists, it ignores Levi and instead of Joseph uses the names of his sons Ephraim and Manasseh, thereby creating twelve tribes. A principle of ordering is suggested by the fact that the sons born to Jacob’s wives Leah and Rachel are listed first, and then the four born to the slaves Bilhah and Zilpah. It seems likely that the name “Hoshea son of Nun” attracted the attention of the priestly scribes and led them to the identification with Joshua (13:16).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The mission the spies are to undertake, as conceived in the early narrative, covers the southern desert (the Negeb) and unspecified parts of the hill country further north (13:17). The nature of the land and the strength of its occupants are the key elements in the brief (vv. 18–20). The arrival at Hebron (v. 22), and the fruit gathering nearby at Wadi Eshcol constitute a fulfillment of the task, at least with respect to the Negeb. The majority report carries a mixed message. The land is fruitful and eminently desirable (13:27), but the towns are large and heavily fortified, and defended by the physically intimidating Anakites (13:28). Caleb’s minority view is that these are not insuperable objections (13:30) and that an invasion should begin immediately. In tradition Hebron becomes the location which Caleb inherits (Josh 14:6–15).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This part of the story has been amplified with various scholarly notes about the building of Hebron (13:22), the inhabitants of the land (v. 29), and the connection between Anak and the legendary Nephilim (v. 33; cf. Gen 6:1–4). Priestly amplifications suggest that the mission of the spies covered the whole land (13:21)—Lebo-hamath is in the far north—and remind the reader about the location of the congregation at Kadesh in the wilderness of Paran (vv. 25–26). The amplifications also accentuate the faithlessness of most of the spies; they appear to change their view of the land, which has now become “one that devours its inhabitants” (vv. 31–32).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_143"
    }
  }, [_vm._v("The account of the community’s complaint is typical of the disaffection stories at large. The priestly writers make it clear that this is a cry of the congregation against both Moses and Aaron (14:1–2). The validity of the whole enterprise is called into question (v. 2). The anxiety about death by the sword (v. 3) reflects the majority report, and ")]), _c('a', {
    attrs: {
      "id": "page_144"
    }
  }, [_vm._v("is probably an early element in the story, along with the discontented talk about a return to Egypt (v. 4).")])]), _c('a', {
    attrs: {
      "id": "page_144"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The further attempt on the part of Caleb and Joshua to bring the community to its senses (14:5–12) is essentially priestly. Since the faithless generation will not enter the land, Joshua, as one of the spies, must have aligned himself with Caleb’s view. The prostration of Moses and Aaron at such crises of discontent (v. 5) is suggestive of desperate intercession, as indicated in Num 16:22. Appearances of divine glory (14:10) are also a feature of such times (Exod 16:10; Num 16:19; 20:6). This shining light, indicative of splendor and royal power, is essentially the means by which the invisible God can be discerned and his presence known.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The protestations of Caleb and Joshua are directed in the first instance at disparagements of the land (14:7 as in 13:32). In their judgment it embodies the best, since it “flows with milk and honey.” This turn of phrase is rooted in the older traditions (e.g., Exod 3:8; Num 16:13). It is reminiscent of the “curds and honey” of which Isaiah speaks (Isa 7:15), and which may carry similar overtones of well-being. The phraseology of 14:9 is unusual, but the vulnerability of the inhabitants, of which it speaks, is clear to see.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Yahweh’s plan to disinherit the people is first made clear in 14:12. Much of what follows in 14:13–19 carries echoes of the discussion which ensued from a previous act of apostasy—the affair of the calf image (Exod 32:7–14). Common motifs are the divine proposal to make a new nation from the descendants of Moses and the fears, voiced by Moses, that Yahweh’s reputation among the Egyptians will be fatally compromised. The celebration of Yahweh as a God of patience and forgiveness (14:18) reiterates themes from Exod 34:6–7. It also took root in liturgical sources (e.g., Ps 103:8–14). The sense that divine judgment against the guilty extends to several generations reflects a theme in the Decalogue (Exod 20:5; Deut 5:9). That the divine love is stronger and more extensive in its scope should not be forgotten (Exod 20:6; Deut 5:10)")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is customary to think of Moses as the divine leader and mouthpiece, but his role on Israel’s behalf, as powerful intercessor and savior of the people, is of comparable significance. It culminates in the Deuteronomistic view that his exclusion from the land was vicarious, something endured on Israel’s behalf, and that it was connected with this occasion at Kadesh (Deut 1:37; cf. Deut 3:26; 4:21).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Yahweh does relent to the extent that faithful Caleb will enter the land and that disinheritance will be confined to the rebellious generation (14:20–24). The prospect of ongoing judgment to a fourth generation, or of a new beginning excluding all but the descendants of Moses, is averted. The motif of the whole earth filled with divine glory seems to have a cultic background; it is strongly reminiscent of the song of the heavenly beings in Isa 6:3, which sets the scene for the prophet’s call in the temple.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("To enable the emergence of a new generation a return to the wilderness is necessary, and a much prolonged journey. This is apparently the point of 14:25 (cf. Deut 1:40), an important link with the traditions of a conquest from the east. It is curious, therefore, that the reason given relates to the presence of Amalekites and Canaanites in the valleys. It is reasonable to assume that these are the valleys of the hill country where Amalekites and Canaanites reside (14:43, 45). Perhaps the linking of traditions of advance from south and east had been established before disaffection was identified as the major cause.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The priestly writers offer their own account of Yahweh’s judgment upon the faithless generation (14:26–35). It stresses the poetic justice of all that will ensue; faithlessness reaps the fruit of what is feared (v. 28). A connection with the census (Num 1:1–47) is established (1:29), and forty years are affirmed as the period of divine displeasure. The faithless spies receive their just deserts at once (14:36–38). It seems likely that priestly thought would have seen parallels between the forty years in the wilderness and the exilic experience in Babylon.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The early narrative records an attempt on the part of the people to evade the prospect of disinheritance (14:39–45). Confident of their ability to effect an invasion from the south into some unspecified part of the hill country, they defy Moses and ignore the absence of the ark but are driven back by the Amalekites and Canaanites. Hormah must be located somewhere near Arad (Num 21:1–3), which implies a total failure to reach even Hebron, let alone the hill country further north. The tradition assumes disaffection—“we have sinned” (14:40)—and looks to be an intensification of the motif.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These two chapters constitute the critical central event in the story of Israel as told in the book of Numbers. Taking all the traditions together, the ordered, unhindered march from the wilderness of Sinai (chs. 1–10), which begins to founder in chs. 11–12, is decisively and disappointingly halted here in the southern desert. Yet failure is never the last word, and the rest of the book recounts the slow and sometimes difficult process of reconstruction and renewed purpose and vision. There is a realism about the larger sweep of the biblical narrative which resists triumphalism on the one hand and despair on the other.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Korah, Dathan, and Abiram (16:1–17:13)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The faithlessness of the people after the exploratory reconnaissance and the misguided attempt to enter the land from the south (Num 13:1–14:45) are not the only disasters which occur at Kadesh. Further rebellions, led by Korah, Dathan, and Abiram, bring about deaths which begin the process of insuring that the wilderness generation, with the exception of Joshua and Caleb, will fail to enter the land.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The story contains an early narrative core (found essentially in 16:12–15, 25–34) which told of the rebellion of the Reubenites, Dathan, and Abiram and of the opening of the earth to swallow them, their families, and their tents. This is the tradition recorded in Deut 11:6.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_144"
    }
  }, [_vm._v("It has been greatly expanded by substantial priestly accretions, within which at least two levels are discernible. Both extend the scope of the rebellion. The first adds 250 leaders (presumably from different tribes) as ")]), _c('a', {
    attrs: {
      "id": "page_145"
    }
  }, [_vm._v("rebels. Their protest is about the right to offer incense and is based on the holiness of the whole community (essentially 16:2–7). A test proves their claim to be false and leads to their deaths by fire (16:16–18, 35).")])]), _c('a', {
    attrs: {
      "id": "page_145"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("A further level builds in a rebellion of Korah and some Levites who are seeking full priestly rights alongside Aaron and his family (16:8–11). They seem to secure the support of the whole congregation (v. 19). Intercession by Moses and Aaron insures that only the instigators of rebellion die (vv. 20–24), so that the Levites perish along with Dathan and Abiram (v. 32).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The remaining material probably assumes both levels of priestly tradition. The censers of the 250 are to be used as a covering for the altar, but it is clear that the point at issue is that only Aaron and his descendants can offer incense (16:36–40). The story which follows (16:41–50) is a dramatic demonstration of the atoning power of incense, used by the right person (Aaron). The concluding tradition about the twelve staffs (17:1–11) could conceivably belong to the first level. The point at issue seems to reflect, not disputes within the house of Levi, but between Levi and the other tribes, as seemingly is the case with the rebellion of the 250 leaders. But the story can be read as summing up the overall stance of the priestly writers. The staff which blossoms is emphatically Aaron’s. It is a vivid reminder that priestly privilege is indeed confined to Levi, but also specifically to Aaron and his descendants, and it constitutes a potent warning to all rebels (17:10).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Speculation about the motivations of the writers might suggest that the early narrators had an interest in explanations for the decline of Reuben, as attested in early poetic texts (cf. Gen 49:3–4; Deut 33:6). The refusal of Dan and Reuben to answer the summons of Moses (16:12) also accentuates the circumstances that necessitated the long, circuitous journey and the death of the wilderness generation. Obedience to authorized leadership (the Davidic king for Hezekiah’s scribes) recalls the authority issues raised in Num 11:1–12:16).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The priests had their own agenda in elaborating and developing the tradition. It was important to them to insist that Deuteronomy’s belief in the holiness of the whole community did not imply that priestly duties, such as the offering of incense, were open to all. The Deuteronomists, in the context of exile under the Babylonians, had offered a radical view of the future which undermined aspects of priestly privilege. The priests, enjoying the support of the Persians who wished to reestablish local cults, were able to reassert priestly power and prerogative. The insistence on the right to offer incense is part of that program. A subsequent struggle within the priesthood, between Aaronides and other Levites, completed the development of the tradition. This may perhaps be dated to the later years of the sixth century, when the Second Temple had been successfully established under Persian auspices and when there was scope and opportunity for rivalries within the priesthood.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These tensions regarding power and privilege within communities of faith have persisted through the centuries. The notion of a priestly community (Exod 19:6) or its modern variant, the “priesthood of all believers,” is an attractively “democratic” perspective, which has frequently come into conflict with pragmatic and/or self-interested concerns about leadership and authority. The tendency to accept without question the view that authorization for specific functions is also the only route to power and influence is a factor which arguably sustains these tensions.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Moses and Aaron (20:1–13)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("There is one further act of rebellion at Kadesh before the journey to the land resumes. This is the incident in which Moses and Aaron are found to be seriously at fault, and which culminates in their exclusion from the land. The story is a variant of the tradition preserved by the early narrative in Exod 17:1–7, and emanates essentially from the priestly authors. The “congregation” or the “assembly” defines Israel (20:1, 2, 4, 6, 8, 10, 11, and 12), and the two leaders, as is commonly the case in the priestly narratives of the journey, prostrate themselves as they witness the divine glory (v. 6; cf., e.g., Num 14:5, 10; 16:19, 20, 42, 45). It remains likely nevertheless that elements of the story are variants of the old account in Exod 17:1–7. The tradition of Kadesh as the place of Miriam’s death and burial (20:1), elements in v. 3 which speak of the “people” and of a quarrel against Moses alone, and the etiological link with Meribah (v. 13) are the most likely traditional features.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The structural outline of the story is common enough in the disaffection tradition. A situation of deprivation (20:2) leads to complaints (vv. 2–5), which in turn are followed by intercessory prostration and a theophany (v. 6). Divine instructions (vv. 7–8) bring relief (v. 11) but at the cost of the future leadership of Moses and Aaron (vv. 9–12).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The complaints are a typical and familiar challenge to the policy which has brought Israel to Kadesh, a place without grain or fruits—in short, a policy which has failed to deliver in every respect. There are no unfavorable contrasts with the nostalgic and unrealistic memories of life in Egypt (Num 11:5), but there is little doubt that the leadership is deemed to have reneged on its promises.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The most difficult problem with the passage is to determine precisely what the sin of Moses and Aaron is, and some deliberate vagueness or suppression of tradition (considered by Davies 1995: 204–6) is not to be excluded. It seems unlikely that the striking of the rock is wrong. Moses is certainly required to address the rock (20:8), but the command to take the staff and the legitimacy of striking in the earlier tradition (Exod 17:6) make it improbable that blows are the issue. The double blow (20:11) is noted, but had this been problem, it would be reasonable to expect attached critical comment. That the consequences for Moses and Aaron are so severe (v. 12) is an indication of the seriousness of what they have done. The explanation (v. 12) is the best starting point in the search for answers. The sin is a failure of trust and a failure to demonstrate Yahweh’s holiness to the congregation.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_145"
    }
  }, [_vm._v("It is feasible that the speech of Moses in 20:10 implies ")]), _c('a', {
    attrs: {
      "id": "page_146"
    }
  }, [_vm._v("that it is his own and Aaron’s power, not God’s, which will provide the water. But it is also noteworthy that earlier priestly disaffection tradition emphasizes Moses’ insistence that the rebellion is not against him (or Aaron), but against God (Exod 16:8). Perhaps it is this which Moses should have pressed in his address. His description of the people as “rebels” (20:10) (i.e., against "), _c('i', [_vm._v("his")]), _vm._v(" leadership) rather than murmurers or complainers against "), _c('i', [_vm._v("God")]), _vm._v(" may lie at the heart of his failure of faith and of witness to divine holiness.")])]), _c('a', {
    attrs: {
      "id": "page_146"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Priestly explanation for the exclusion of Moses and Aaron from the land has a new dimension. Whereas Deuteronomy is inclined to attribute blame to the people (3:23–29), the priestly writers are content to find fault with the leadership. This may have been prompted by circumstances in their situation. The tradition for which they stood had been preserved among the Babylonian exiles, who had been driven from the land and excluded for sins which were recognized and acknowledged (the sin of Moses and Aaron was a generalized description of the sin of their priestly ancestors). This exclusion did not, however, compromise the authenticity and authority of their program, which is precisely that of Moses and Aaron, whose experience is thereby mirrored in their own.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Fiery Snakes (21:4–9)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This disaffection story has many of the familiar structural characteristics of the tradition—complaints about the hardships of the journey (21:4–5), a divine punishment in the form of poisonous snakes (v. 6), intercession (v. 7), and gracious divine provision to alleviate the situation (vv. 8–9). There is every reason to associate it with the early narrative tradition, there being no clear signs of priestly influence and some affinities with the story of the rebellion of Miriam and Aaron in 12:1–16 (e.g., the verb “spoke against” (21:5; cf. 12:1).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("At the heart of the story is an explanation for the origins of Nehushtan, a bronze serpent which apparently stood in the Jerusalem temple (2 Kgs 18:4) and which was probably an important focus for pilgrims seeking healing and health. Its ultimate Canaanite origins are quite likely. The scribe, working perhaps during Hezekiah’s reign, is anxious that its Mosaic origins should be acknowledged. Only so could its continuing presence in the temple be justified. The deuteronomistic historian also affirms its Mosaic origins, but he believes that it attracted alien forms of devotion and attributes its removal to Hezekiah.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The story interests the narrator for two reasons. It provides one further example of the rebelliousness which necessitated the protracted journey and a delayed entry into the land. It also gives an interpretation of Nehushtan’s origins and a justification for its existence as a cult object.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Baal of Peor (25:1–18)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("A further serious act of disaffection takes place in Moabite territory at Shittim, close to the Jordan and within sight of Jericho. The story has received major supplementation from priestly sources (25:6–18) and addresses the question of apostasy, the honoring of deities other than Yahweh. The story of the golden calf (Exod 32:1–35) is the only earlier incident among the wilderness narratives, but the tradition of serious apostasy at this period became well established (Ezek 20:16).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The older tradition, embedded in 25:1–5, is probably from the early narrative. There may be independent elements within it, one witnessing to relations with Moabite women and the service of Moabite gods (vv. 1–2) and the other to a more specific commitment to the Canaanite deity Baal, as worshiped at Peor (vv. 3–5).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Moabite apostasy arises out of the sexual opportunities which these new contacts provide (cult prostitution does not have to be assumed) and from the attraction of the cultic meals which were integral to the Moabite rites. In the context of the story it can be supposed that these meals provided richer and more varied fare than the Israelites had become accustomed to during the hardships of the journey.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The “yoking” of which the Baal of Peor material speaks suggests some kind of covenantal agreement with the deity. According to Ps 106:28, ancestor cults were an aspect of the apostasy. That Israel should begin to look for support from a fertility god on the borders of the land is at a certain level understandable, but the storyteller clearly sees it as a crass example of faithlessness. The belief that Yahweh himself was a god of rain and storm, essential for fertility, is clearly attested in an ancient text such as Judg 5:4. That the “yoking” was institutional, organized by leaders in the name of the community, is suggested by the killing of the chiefs. Impaling is the fate which overtakes descendants of Saul (2 Sam 21:6, 9). It is for the treatment of the corpse in these circumstances that Deuteronomy legislates in Deut 21:22–23. There is clearly an assumption that such actions appease the wrath of Yahweh, who has been excluded and offended by this new relationship with Baal. Further action is to be taken by the judges against others who are known to have entered into the agreement with Baal (25:5). According to other texts (Deut 4:3; Ps 106:29), and implied perhaps by 25:8–9, a damaging plague ensues.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is reasonable to expect a new sensitivity to the perils of apostasy in late eighth-century Judah. The compilers of the early narrative were aware of the fall of the Northern Kingdom in 721 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", and probably also of the construction which prophets such as Hosea had put upon it. The testimony of the historian in 2 Kgs 18:4–6, to the effect that Hezekiah was a religious reformer seeking to establish the exclusive worship of Yahweh, is further evidence that these issues were on the agenda. It was appropriate, therefore, that when the history was compiled, readers would be reminded of how deeply rooted the dangers were, and how serious the consequences.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_146"
    }
  }, [_vm._v("The hostility of elements in the biblical witness to other religious beliefs and insights continues to be problematic. To those who find a “pluralistic” sensitivity essential, they will be particularly so. How can we be so arrogant as to assume that all religious truth is to be found where we happen to be? Is not such an assumption the antithesis of a proper religious sense of sin and limitedness? For those, on the other hand, who find religious ")]), _c('a', {
    attrs: {
      "id": "page_147"
    }
  }, [_vm._v("pluralism problematic there is the question of the coercion to which other perspectives are subjected and the savagery which sometimes accompanies it. How can killing be morally justified as a resolution to a religious dispute?")])]), _c('a', {
    attrs: {
      "id": "page_147"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("To the extent that Israel experienced the oppressiveness of both Egyptian and Canaanite power, in politics, society, and religion, the desire for a “clean break” and a “new order” is intelligible and a cause for sympathy. There are signs that this desire is deeply rooted in Israel’s history, however we construct the details of its circumstances. How such desire can be translated into action, legitimately and morally, remains unresolved and is a question rarely addressed in the texts themselves. It is for this reason that the canonical process, whereby testimony and texts become sacred, needs to be treated with critical caution, even if a commitment to the Scriptures is finally deemed appropriate. Problems of this kind are common to both Testaments.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The priestly supplementation (25:6–18) introduces yet another crisis of apostasy into the tradition, involving in this instance an Israelite and a Midianite woman. The hitherto friendly relations between the two peoples—Jethro, the father-in-law of Moses, was priest of Midian (Exod 18:1)—here begin to turn sour, by way of preparation perhaps for the destructive war of Num 31:1–54. Intermarriage is the issue, and the event is set in the context of a devastating plague which eliminates a further twenty-four thousand of the wilderness generation (25:8–9).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The story serves two main purposes for the priestly writers. The need to draw boundaries around the people of God and to prevent intermarriage was a matter of prime concern to the exiled priests, and Ezra’s subsequent policies reflect their point of view (Ezra 10:1–44). Nehemiah apparently shared this exclusive attitude (Neh 13:23–31), and its prevalence in other texts relating to the early postexilic period raises the possibility that this was in part a matter of Persian policy (Ezra 4:3; Neh 13:3). There may have been advantage in supporting religious attitudes which created social stability.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("For many readers the exclusivity inherent in this and other such texts will be distasteful and deeply problematic. At one level communities need boundaries in order to discover and define their identities, and this is all the more the case in situations of humiliation, oppression, and alienation, as experienced by exiled peoples. The very survival of such communities may depend upon the boundaries they are able to locate or construct. It is easy to see, on the other hand, that such boundaries can begin to stifle interaction and communication, to engender isolation, and even to foster oppression and cruelty toward others.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The other priestly interest the story serves is to establish that the high-priestly succession is to be traced through Phinehas and his descendants. This was not in itself remarkable since the two elder sons of Aaron had died offering unholy incense (Lev 10:2), and Eleazar the father of Phinehas (Exod 6:23, 25) replaced them as third in line. With the death of Aaron (20:22–29) Eleazar clearly began to function in the same way that his father had done (e.g., 26:1; 27:2; 31:13, 21, 26, 31). The effect of the story in 25:6–13, therefore, is to confirm Phinehas in his priestly role; his zeal is potent evidence of his qualifications for the job, and his reward is a “covenant of peace” with Yahweh (v. 12). This distinctive phrase suggests a permanent divine commitment to the priestly order Phinehas represents and a position of privilege and wellbeing for the priest and his descendants.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The action of Phinehas is reminiscent, in its effects, of the atoning intervention of Aaron in 16:41–50. There, too, a rampant plague called for decisive priestly action. The weeping of the people (25:6) is to be understood presumably as a response to the deaths recorded in vv. 4–5. It is conceivable that “the tent” (v. 8), an unusual word (“inner room”—RSV), was a part of, or attached to, the tent of meeting, and that the action of the offenders had cultic connotations. In any event, the zeal of Phinehas averts a worse disaster and comes to be widely remembered in later tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is interesting to note that a variant and probably earlier tradition makes reference only to a plague, which itself was apparently the outcome of the Baal of Peor apostasies recorded here in 25:3–5. If this tradition, preserved in Ps 106:28–29, is assumed to lie behind the story in 25:1–18, the extent of the plague’s effects in v. 9 is easier to understand. It is also remarkable that in Ps 106:30 the saving intervention of Phinehas seems to be an act of intercession. In short, the Midianite motif, with the killing of the couple, may be a reinterpretation of the nature of the event.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("An additional note identifies the offenders (25:14–15); such notes look to be scholarly accretions to the tradition, but it is difficult to identify the techniques by which the information they contain has been established.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The priestly writers find in these sad events a basis for continuing hostility toward the Midianites and for their subsequent defeat in 31:1–54. They are blamed in 25:16–18, not only for the activities of Zimri and Cozbi but also for the apostasy at Peor, which, according to v. 18, was provoked by Midianite deceit. There is no hint of this in vv. 1–5 themselves, nor in other texts which refer to Baal of Peor, and one can only assume that this development of the tradition was initiated by the priestly writers themselves in pursuit of their interest in the Midianite war (31:1–54) and the issues which emerge from it.")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("The Story of Balaam (22:1–24:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The three chapters containing the story of Balaam are in many ways a unique feature of the Pentateuchal books. They are a largely self-contained piece of tradition, embodying narratives and ancient poems and celebrating Israel’s place in the purposes of Yahweh.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_147"
    }
  }, [_vm._v("The self-contained character of the tradition suggests that it has been drawn in from some other source or setting by a biblical author and used to give further substance to the Transjordanian journey. The author in question would probably be one of the early narrators since traces of priestly influence are entirely lacking and, characteristically, Israel is depicted as “the people” (e.g., 22:3, 41). Substantial parts of the tradition are Elohistic ")]), _c('a', {
    attrs: {
      "id": "page_148"
    }
  }, [_vm._v("and the deity identified as “God,” and this might assist in identifying earlier elements. The priestly writers make no contribution to the tradition except to identify Balaam as one of the casualties in the Midianite war (31:8) (but note the suggestion of Douglas 1993: 216–34 that the story is political satire for early postexilic times). Inclusion of the story here (after 21:35) is appropriate because Balak the hostile king is a Moabite and Israel has now reached the plains of Moab (22:1).")])]), _c('a', {
    attrs: {
      "id": "page_148"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The general aims of the narrators in taking over this older story and deploying it here seem to be to renew faith in Yahweh’s commitment to Israel and in his good purpose for the people. The faithlessness exhibited at Kadesh by spies and people alike (Numbers 13–14), and the rebellions and deaths associated with Dathan and Abiram (Numbers 16) and the snakes (Num 21:4–9), belong to the past and have not affected Yahweh’s determination to support and sustain his people against enemies. The success achieved against King Og (21:33–35) is confirmed by the frustration of Moabite attempts to undermine Israel and defeat the march toward the land.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is difficult to know with certainty what ensues in the early narrative. Some have thought the story ends here, but others would see it continuing into the book of Joshua or even as far as the story of David. If we are correct to see the story as a product of court scribes at Jerusalem, whatever earlier elements may be embedded in it, some account of the processes of settlement in the land is likely. Otherwise the story fails to provide a full enough account of present experience. Joshua’s farewell address (Josh 23:1–16) and the covenant making at Shechem (Josh 24:1–33) would appropriately round off a work completed during Hezekiah’s reign. The bearers of Shechem’s traditions came south after the collapse of the Northern Kingdom (721 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") and were accepted there, as is clear from the elements preserved in Deut 27:1–26. The conclusion of the early narrative may mark this acceptance, though Joshua 23–24 in their present form have clearly been influenced by Deuteronomistic editing.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("The Narrative")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The introductory material in the Balaam story (22:1–6) sets the scene, indicating clearly the basis of Balak’s fear (vv. 2–4) and the plan to involve a diviner capable of invoking a powerful curse on Israel (vv. 5–6). The civilizations of the East were well known for their skills in these arts (cf. Isa 2:6, where some such expertise seems implied). Nonbiblical evidence about Balaam the seer has been found in the Deir ‘Alla texts (for a discussion of their importance see Davies 1995: 281–84). Balak has unbounded confidence in the power of Balaam to weaken Israel and to remove the threat that it poses (22:6).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The initial request for assistance is rebuffed (22:7–14). The story affirms that Balaam, though a non-Israelite resident in a distant land, is genuinely in touch with God and has no initial intention of disobeying God’s will.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The story is skillfully developed by means of a second embassy, more numerous, more distinguished, and offering bigger rewards (22:15–21). Balaam’s resistance to these blandishments remains firm, but he is prepared to consult God again, and on this occasion he is encouraged to go with Balak’s officials, on condition that he adheres strictly to God’s instructions.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The fable about Balaam’s donkey and the angel of Yahweh (22:22–35) may well be an intrusion, introduced perhaps by the early narrators themselves, since “Yahweh” predominates as the divine name. Such an assumption makes it easier to understand why the divine anger, somewhat inconsistently in the light of v. 20, is stirred against Balaam. Nevertheless the tension at this point in the story still needs to be interpreted. Why should the narrators have voluntarily introduced material which they must have known generated a logical unevenness? The answer perhaps is that the episode allows them to insist again on the essential hostility of God to the whole enterprise and to reaffirm that Balaam is allowed to engage in it only on strict conditions, and under strict control. So it is that God’s anger is renewed (v. 22) and the controls reaffirmed (v. 35).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The fable of the talking donkey brings ridicule on the head of a foreign diviner. This supposed “expert” in discerning the mind and will of the gods is outperformed in spiritual insight by his donkey! His cruel treatment of the animal, in contrast to its own reasoned response, only accentuates his blindness and folly. The essential elements of the story might have an earlier point of reference which has been applied by the early narrative to the story of Balaam.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The “angel of Yahweh” also appears to Hagar (Gen 16:7), and it is clear here, as there, that the words this messenger utters are Yahweh’s. The insistence that Balaam should speak only what he is told to speak (22:35) is reminiscent of the control on Balaam’s actions in v. 20. These points are stressed yet again in the conversation between Balaam and Balak when they finally meet (vv. 36–38). The sacrifice of oxen and sheep (v. 40) and the shared meal that presumably ensues are acts of welcome on Balak’s part.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The rest of the story consists of the four oracles Balaam eventually delivers (23:7–10; 23:18–24; 24:3–9; 24:15–24); these are connected by repetitive narrative indicating the persistence and increasing frustration experienced by the king.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The narrative moves from Bamoth-baal (22:41), to Pisgah (23:14), and finally to Peor (23:28). These are all high places from which Israel, at least in part, is visible to the two men. The final oracle is delivered, not at Balak’s instigation or wish but in a spirit of prophecy about the damage Israel will do to Balak’s people. On the three high places altars are built and substantial sacrifices offered (23:1, 17, 29). The intention presumably is to attract God’s attention.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_148"
    }
  }, [_vm._v("Balaam for his part removes himself some distance on the first two occasions, in the hope of meeting Yahweh (23:3, 15). His intentions apparently are to seek some kind of omen (24:1). This would presumably have been the result of divinatory actions or observation. Even then what comes to him is not a mediated sign but a prophetic oracle, the very words of God himself. On the third occasion Balaam abandons omen seeking, looks toward the wilderness, and is seized by the spirit of Yahweh (24:1–2). The point seems to be that he has now learned where to ")]), _c('a', {
    attrs: {
      "id": "page_149"
    }
  }, [_vm._v("look for and expect the voice of God. He is to be found in the wilderness among his people. Given the unpromising content of Balaam’s oracles, it is scarcely surprising that Balak’s irritation increases and his anger finally explodes (23:11, 24; 24:10–11). Balaam, for his part, continues to insist on the story’s overarching theme—that he can speak only what God commands him to speak (23:3, 12, 26; 24:12–13).")])]), _c('a', {
    attrs: {
      "id": "page_149"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Balaam’s performance in this part of the narrative thread is without fault, and it is therefore surprising to see his emergence in subsequent tradition as evil, along with the likes of Cain and Korah (Jude 11; Rev 2:14). The view seems to have developed that he was motivated by financial gain, or that he instigated the eating of food offered to idols in Israel, through his influence over Balak. His blindness in 22:22–35 scarcely warrants this demonization of a figure whose words speak only well of Israel and who obeys God unflinchingly. The tradition may have arisen through associations and assumptions. Balaam was associated with Peor. It was one of the places where sacrifices were offered (23:28), and a place shortly to become a scene of serious apostasy (25:3, 5, 18) on Israel’s part. Questionable associations very easily lead to false assumptions.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("The Oracles")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("These texts are fascinating, albeit difficult to interpret. There are indications that they are ancient, though the “scepter” and “rule” of the monarchy seem to be presupposed (24:7, 17, 19). A celebration of David’s achievements is quite plausible by way of setting. Most of the difficulties lie in the detail; the overall picture is reasonably clear. A pattern of developing and increasingly precise insight into Israel’s place is discernible in each of the oracles.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the first (23:7–10) Israel is at present isolated, and peripheral in international affairs (v. 9), yet her potential is huge and her destiny desirable (v. 10).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the second (23:18–24) Yahweh is identified as Israel’s king (v. 21), having led the people out of Egypt with irresistible strength (v. 22). The “misfortune” and “trouble” of v. 21 might be read as “iniquity” and “mischief” (REB), or “guilt” and “perversity” (NJB), though the NRSV is probably preferable (Davies 1995: 262); in either event God and his people are united in a common endeavor. Divination against Israel will not succeed (v. 23) (or there is no divination in Israel—REB). Among the nations the people will emerge as a powerful and fearsome predator (v. 24).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the third (24:3–9) Israel’s resources are recognized as plentiful (vv. 5–7a), and the human king who leads will be a man of renown (v. 7b). The predatorial image (vv. 8–9a) is given substance in terms of the fulfillment of the promise to Abram (Gen 12:3) (v. 9b).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the fourth (24:15–24) the king to come is likened to a star (REB also has comet [for “scepter”]); he will crush the territories and kingdoms to the east of the Jordan (vv. 17–19). In the history of interpretation the “star” (v. 17) has often been read messianically (Davies 1995: 273).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In addition to these main themes there are also revealing points of textual detail. The repeated phrase “uttered his oracle” (23:7, 18; 24:3, 15; NJB, “declaimed his poem”) seems to stress the distinctive nature of Balaam’s inspiration over against the various divinatory techniques which called for the manipulation of objects and/or the reading of signs. The inspiration of Balaam is not mediated; it is a divine word (the noun is often “proverb”) placed directly in Balaam’s mouth (23:5, 16) through the agency of the divine spirit (24:2).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The third and fourth oracles seem to stress the uniqueness of this access to God in other ways. Some such concern is intended by the obscure phrase “whose eye is clear” (24:3, 15, NRSV) (or “far-seeing”—NJB; see Davies 1995: 267 for further discussion). Balaam is one who hears divine words, encounters God in visions (24:4, 16), and is endowed with special knowledge (24:16). The encounter is with Shaddai (“Almighty,” 24:4, 16) and Elyon (“Most High,” 24:16), ancient names for God or manifestations of his being and presence (cf. Gen 14:19, 20; 49:25).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A vital connecting thread in the first two oracles, and throughout the narrative parts of the story, is the stress on the immutability and irresistibility of God’s good purpose for his people (23:8, 19–20).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The three concluding oracles (24:20–24) appear to have been added subsequently, but they pose many problems for translators and interpreters (see Davies 1995: 276–81). Following the NRSV, the first (v. 20) predicts or celebrates the fall of Amalek from a position of eminence among the nations to final dissolution and destruction. The second (v. 21) reflects upon the experience of the Kenites, an ancient and enduring people, but one due to suffer dispersion without evident end at the hands of Assyria. The third (vv. 23–24) foresees a check on Assyrian expansionism (Asshur and Eber) at the hands of a fleet and forces to the west. Assyria’s ultimate end is also affirmed. If these identifications are correct, the oracles apparently reflect, at least in part, some experience of the Assyrian Empire and may have been worked in by the early narrators from sources known to them.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The militantly aggressive elements in some of the oracles raise pressing questions about the ease with which religion legitimates land acquisition, along with militarism and the cruelties of war. It must be remembered, of course, that access to resources may well be a struggle for those on the margins; slave refugees from Egypt would clearly belong to such groups. It is also true that the historical emergence of Israel in the land of Canaan was probably much less of a military campaign than many of the traditions suggest, with infiltrations into thinly populated areas and with many of its first members already settled. On the other hand, the content of the predatorial images remains and is best confronted and challenged rather than explained away. A sensitivity to processes of religious legitimation is one safeguard; so, too, is a critical (though not necessarily unsympathetic) attitude to the processes by which texts become sacred in communities of faith.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_149"
    }
  }, [_vm._v("A bigger theme in the story is the prevailing critique of the culture of divination. This is one aspect of a tendency in the Hebrew scriptures, sometimes noted by sociologists, toward the desacralization of religious belief and practice. Some (e.g., Berger 1967: 113–21, supported ")]), _c('a', {
    attrs: {
      "id": "page_150"
    }
  }, [_vm._v("by Bruce 1996: 9–10) have seen in this tendency a contributing factor to the secularization of the modern Western world. The point at issue in the Balaam texts is not so much the "), _c('i', [_vm._v("exclusion")]), _vm._v(" of God from areas of human interest and activity (a working definition of secularization) as "), _c('i', [_vm._v("competing claims")]), _vm._v(" to influence within a world which remains pervasively religious. It is true nevertheless that the critical, combative spirit of much biblical religion may have contributed to the questioning, testing frame of mind which has always marked the search for truth and meaning, especially since the Enlightenment. There is nothing necessarily irreligious about such an attitude. It is because the believer affirms dimensions to the divine which lie well beyond human understanding that a critical attitude to religious claims and authority is always appropriate, and a suspicion about the workings of religious legitimation desirable.")])]), _c('a', {
    attrs: {
      "id": "page_150"
    }
  }, [_c('p', {
    staticClass: "H3"
  }, [_c('i', [_vm._v("Community Law (27:1–11; 30:1–16; 35:9–36:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The later sections of the book of Numbers contain a miscellany of laws on such matters as property (27:1–11; 36:1–13), vows (30:1–16), and asylum (35:9–34). The priestly character of the legislation is evident in references to Eleazar and/or the congregation (27:2; 35:24, 25, 26), in the way in which the Korah tradition is assumed (27:3), and in presuppositions about the high priest (35:25, 32) and the jubilee (36:4; cf. Lev 25:1–55). There is also the familiar tendency of Numbers legislation to build on or develop issues already raised in the book of Leviticus. Property law has been addressed in Lev 25:8–55 and again in connection with vows in Lev 27:1–34. Earlier asylum law can be found in Exod 21:13–14 and was also an issue for legislators in Deuteronomy (Deut 19:1–13; cf. Deut 4:41–43). The material on property and vows also provides important insights into the status of women in ancient Israelite society.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Property (27:1–11; 36:1–13)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The tradition that property belonged to a family in perpetuity was ancient, though it was apparently threatened by the power of kings (1 Kgs 21:1–29) and probably also by the commercialization of land and agriculture during the period of the kings. That males would be the inheritors was taken for granted, and this continues to be assumed in the restoration (or perhaps creation) of the jubilee laws (Lev 25:1–55), whereby land sold would return to its original owners in the jubilee year, that is, every fiftieth year. As part of the Holiness code this legislation in its present forms is perhaps exilic.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is in Num 27:1–11 that the possibility of female inheritance is raised for the first time. The five daughters of Zelophehad, a deceased member of the tribe of Manasseh, have no close male relative to inherit their father’s property. Having observed that Zelophehad was not implicated in Korah’s conspiracy (v. 3) and that there is therefore no reason why his family should be disadvantaged, they press their case. This is based not so much on new perceptions about the rights of women but on a concern for their father’s ancestral name and the wellbeing of his clan (v. 4). In this respect their case assumes and affirms patriarchal norms, and the solution they seek—to have “a possession” among their father’s brothers (v. 4)—might be interpreted simply as a request that they and their land become part of their uncles’ families and possessions.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The legitimacy of the case is recognized in Yahweh’s response to Moses, and it goes on to make clear that in certain circumstances there would be inheritance by women "), _c('i', [_vm._v("in their own right")]), _vm._v(". The only thing to prevent such inheritance would be the presence of brothers (27:8). A father’s name can therefore be vested and preserved in the daughter(s). Inheritance passes to the dead man’s brothers only if there are no daughters (v. 9). More remote possibilities are addressed in vv. 10–11, with the “nearest kinsman” (NRSV) as the final recipient.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The conclusion of the book returns to the theme (36:1–13), addressing the wider problem of tribal, as opposed to family, identity. There is anxiety among the heads of the tribe of Manasseh, one of the two Joseph tribes, that the previous ruling in favor of daughters will threaten tribal possessions should the daughters marry into other tribes, taking their inheritance with them. The assumption here is that independent property rights granted to women in the previous judgment are vested in the husband’s family when marriage takes place.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Once again Yahweh accepts the validity of the concern (27:5), and a restriction is placed on intermarriage between the various tribes where property complications of this kind are involved. In short, the daughters must marry within the tribe of Manasseh. The aim is to preserve the identity, integrity, and wealth of each distinct tribe. This apparently poses no problems for the women, and they marry cousins (vv. 10–12). This kept their property within the tribe, while Zelophehad’s name lives on among his brothers.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It would appear that problems of this kind exercised the priestly writers, and that definitive rulings were required. The serious dislocations, the loss of land and identity, which must have accompanied the exilic experience called for a legislative framework within which social structures could be reestablished and community recreated.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Vows (30:1–16)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("A good illustration of what might be entailed in a vow is provided by the story of Jacob at Bethel (Gen 28:18–22). The seriousness of such commitments is reflected in Jephthah’s vow (Judg 11:30–31) and its terrible consequence (Judg 11:34–40). The usual content of a vow would probably have been the promise of an offering to God in return for guidance, success of some kind, or answered prayers.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The insistence that vows must be kept under all circumstances was already well established in legal forms. The legislators in Deut 23:21–23 had stressed the importance of a prompt fulfillment of what had been promised, though they also give the impression that the making of vows is not necessary and certainly not obligatory. The priestly writers had already worked on the subject in Lev 27:1–34, dealing in the main with the circumstances under which vows involving persons, animals, or property might be redeemed by money equivalents.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_150"
    }
  }), _c('a', {
    attrs: {
      "id": "page_151"
    }
  }, [_vm._v("The issue here in Num 30:1–15 is the status of vows made by women. Existing views are reaffirmed in the case of men (vv. 1–2), but vows made by women are affected by their marital status. In two situations a vow can be disallowed by the appropriate male—in the case of an unmarried woman still resident in her father’s house (vv. 3–5) and in that of a married woman living with her husband (vv. 6–14). The father or husband must reject the vow at the point when he hears it (vv. 5, 8). In these situations the woman’s vow is evidently subject to male approval.")])]), _c('a', {
    attrs: {
      "id": "page_151"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The vows of widowed and divorced women, however, must stand (30:9), and there is the further insistence that if a husband wishes to disallow his wife’s vow he must do so at once (vv. 10–15). Failure to disallow at once means that the vows stand and that he must accept ultimate responsibility for them (v 15). It is reasonable to suppose, in view of the stress on “the time that he hears it” in v. 5, that the same applies to a father in relation to vows made by an unmarried daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The concern of the priestly legislators in all this is evidently to protect and preserve the patriarchal social order. Religious commitment and devotion on the part of women can be exercised only within the constraints of that order. From a practical point of view it is true enough that the father and husband were financially responsible in an ultimate sense, and to that extent they needed controls over the activities of their womenfolk. But this is the sort of argument which leaves women in a “no win” situation. It is the legitimacy of patriarchy itself which is at stake. The modern world, whatever its faults, has created some opportunity for women to discover and express their own forms of faith and spirituality.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This legislative material on property and vows provides useful insight into the position of women in the ancient world. Their subordinate status within the prevailing social order is apparent throughout, and must be confronted. At the same time there is an emerging public profile for women in the legislation, which in theory raises the thought of other possibilities, even if these are not as yet appreciated or implemented. As 30:9 makes clear, a woman who has a life outside the prevailing order—though this can rarely have been of much material advantage or benefit to her—is recognized as on a par with a man in respect to her religious commitments.")]), _vm._v(" "), _c('p', {
    staticClass: "H4"
  }, [_vm._v("Asylum (35:9–34)")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("These regulations (35:9–34) are part of the processes whereby the administration of justice passed from family and tribe to the institutions of the state.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Ancient custom saw murder as an offense against the victim’s family and placed responsibility for effecting justice (by the killing of the offender) in the hands of the nearest relative. It is easy to see how such practice would tend to overlook considerations about the wilfullness or otherwise of the deed and generate lasting and destructive blood feuds. Early legislation sought to intervene in such vicious circles by establishing the principle of asylum (Exod 21:13). Initially local sanctuaries functioned in this way (cf. 1 Kgs 1:50), giving space for inquiry, probably under the auspices of priests, as to whether the death was willfully caused or not. If it was found to be deliberate, responsibility for the killing of the murderer would presumably remain with the victim’s nearest relative.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The emergence of the monarchy brought with it an interest in “law and order” on a wider scale. Without a “rule of law” within the king’s domain the stability of his position and the security of his dynasty were at risk. This must have strengthened the principle of asylum and the necessity of distinguishing between deliberate and unintentional killings. Kings came to see themselves as responsible for righting wrongs in relation to murder and bloodguilt (cf., e.g., 2 Sam 4:11).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The idea that there should be cities as places of asylum is best traced to the centralization of worship under King Josiah and the elimination of local sanctuaries. An alternative, as a place of refuge for those killing unintentionally, was clearly required. The laws in Deuteronomy identified three cities to the east of the Jordan for this purpose (Bezer, Ramoth, and Golan—4:43), and insisted that three more should be found to the west (19:3). According to Josh 20:7, the cities selected were Kedesh in Galilee, Shechem, and Hebron.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Here in the priestly laws of Num 35:9–34 the question of intent is clearly the starting point (v. 11), and the need for six cities, distributed on both sides of the Jordan (vv. 13–15), is affirmed. Situations which constitute murder are those in which the killer “strikes” (vv. 16, 17, and 18), with whatever weapon or implement. The verb presumably embodies the notion of deliberate assault. In accordance with ancient custom “the avenger of blood” (v. 19, NRSV) (i.e., the nearest relative of the dead person) carries out the sentence of death. Any kind of malicious or premeditated assault is interpreted as deliberate (vv. 21–22) and is therefore to be treated as murder.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Situations which must be reckoned as unintentional are those which are not premeditated or prompted by malice (35:22–23), an example being the flying ax head of Deut 19:5. In these instances the priestly laws insist that the congregation must act as judge and protect the person suspected from the “avenger of blood” (v. 24). In Deut 19:12 “elders” are responsible for surrendering a killer to the avenger of blood, where appropriate, and would presumably be expected to act as representatives of the congregation here in Num 35:24–25.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The new element in the priestly laws is the place given to the office and person of the high priest in the arrangements affecting the slayer and the avenger of blood (35:25b–28). The stipulation effectively “frees” the slayer from confinement in the city of refuge when the high priest dies. It is conceivable that the principle itself is not a priestly innovation; it might once have applied to the rule of kings. It may also have been informed by the sacrificial system, where death in some way “atones” for sin. The holiness of the high priest brings protection against the consequences of defilement caused by the shedding of blood, but only within the confines of the city of refuge. The stipulation is also an element in the process whereby high-priestly theocracy was established as the social and political norm. The rule of the high priest touches all aspects of life, including the administration of justice.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_151"
    }
  }), _c('a', {
    attrs: {
      "id": "page_152"
    }
  }, [_vm._v("The chapter concludes with the insistence that murder—premeditated, malicious, and intentional killing—can be resolved only by the death of the murderer (35:30–34). The recognition that there must be witnesses (more than one) (v. 30) is a requirement which is also attested in Deut 19:15. Whereas the laws in Deuteronomy go on to deal with the possibility that some witness may be motivated by malice, the priestly laws here proceed to address specifically priestly interests. The possibility of redemption was something to which priestly legislators were alert (cf., e.g., Lev 27:1–33; Num 3:44–51)—after all, it brought resources to the sanctuary—but the seriousness of murder is such that redemption cannot be entertained (35:31). The priests were informed in this attitude by their fundamental belief that the shedding of blood brought defilements to the land which could not be resolved by monetary means (v. 33), but only by further bloodshed, the death of the offender (v. 33). That belief also entailed a theology of the divine presence (v. 34). Since blood above all else signifies the life of God, the shedding of blood is the ultimate insult to his very being.")])]), _c('a', {
    attrs: {
      "id": "page_152"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("It has to be acknowledged that the priestly insistence on what would today be called “capital punishment” cannot properly be separated from the whole system of thought which priests taught, on holiness, defilement, blood, sacrifice, and related matters. The origins of animal sacrifice in human history are clouded in obscurity, but if there is any sense at all in which “execution” in the ancient world was a form of “sacrifice”—a recompense to God for a kind of acted blasphemy—then current discussion of penal issues in relation to murder cannot seriously be expected to engage with such material. Other considerations must inform the discussion. The biblical literature in the main is moving beyond such perspectives—the recognition that killing may be unintentional is an illustration of this—but its antiquity as human literature continues to be evident at many points. There is no reason why aspects of the priestly system may not be found informative and helpful, but the selectivity and thinking entailed in such processes of discovery are in significant measure what we as interpreters contribute. To attempt to treat the literature as determinative of belief and action demands a consistency which takes the whole on its own terms.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The recognition that intention is a significant consideration in assessing the morality and culpability of actions is an important indicator of the trajectories which biblical literature sometimes exhibits. There is no overt consideration of negligence as a complicating factor in cases of accidental death, either here in Numbers or in Deuteronomy, but it is addressed in an older law in Exod 21:29–32 (cf. also 21:33–36; 22:5–6). It would appear that death or a fine might be imposed in such circumstances, and certainly the latter in the case of a dead slave.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Concluding Observations")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("It is important to remember that the themes of the book are elements which constitute a story, and one volume in a much larger story contained in the books which surround it. A key motif in that larger story, and one which has informed various trends in modern theology, is “liberation.” Israel’s escape from slavery in Egypt (as told in the book of Exodus) has become a crucial paradigm, among others, whereby God’s will for his people, and for humanity at large, has been identified and interpreted. The book of Numbers is a reminder that “liberation from” is only one aspect of the story, and that “liberation for or to what?” is an equally important consideration. It tells of the difficulties and setbacks which the journey from slavery to freedom entailed, and it gives insight into the ways in which the community sought to organize its “liberated” life through its laws. To put it another way, the first experience of liberation (from Egypt) was one thing; the challenge to create and sustain a just and participatory community is quite another. Whether the “mixed success” (triumph and disaster) of which the book of Numbers speaks is always to be the human “story” is very much in human hands.")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Berger, P. L. 1967, "), _c('i', [_vm._v("The Social Reality of Religion")]), _vm._v(", London: Faber and Faber • Budd, P. J. 1984, "), _c('i', [_vm._v("Numbers")]), _vm._v(", WBC, Waco: Word • Bruce, S. 1996, "), _c('i', [_vm._v("Religion in the Modern World: From Cathedrals to Cults")]), _vm._v(", Oxford: Oxford University • Brueggemann, W. 1977, "), _c('i', [_vm._v("The Land: Place as Gift, Promise, and Challenge in Biblical Faith")]), _vm._v(", London: SPCK • Coats, G. W. 1968, "), _c('i', [_vm._v("Rebellion in the Wilderness")]), _vm._v(", Nashville: Abingdon • Cody, A. 1969, "), _c('i', [_vm._v("A History of Old Testament Priesthood")]), _vm._v(", AnBib 35, Rome: Pontifical Biblical Institute • Coote, R. B. and D. R. Ord. 1991, "), _c('i', [_vm._v("In the Beginning: Creation and the Priestly History")]), _vm._v(", Minneapolis: Fortress • Davies, E. W. 1995, "), _c('i', [_vm._v("Numbers")]), _vm._v(", NCB, London: Marshall Pickering • Douglas, M. 1993, "), _c('i', [_vm._v("In the Wilderness: The Doctrine of Defilement in the Book of Numbers")]), _vm._v(", JSOTSup 158, Sheffield: Sheffield Academic • Jenson, P. P. 1992, "), _c('i', [_vm._v("Graded Holiness: A Key to the Priestly Conception of the World")]), _vm._v(", JSOTSup 106, Sheffield: Sheffield Academic • Levine, B. A. 1993, "), _c('i', [_vm._v("Numbers 1–20")]), _vm._v(", AB, New York: Doubleday • Lohfink, N. 1994, "), _c('i', [_vm._v("Theology of the Pentateuch: Themes of the Priestly Narrative and Deuteronomy")]), _vm._v(", Edinburgh: T&T Clark • Milgrom, J. 1991, "), _c('i', [_vm._v("Leviticus 1–16")]), _vm._v(", AB, New York: Doubleday • Niditch, S. 1993, "), _c('i', [_vm._v("War in the Hebrew Bible: A Study in the Ethics of Violence")]), _vm._v(", Oxford: Oxford University • Sakenfeld, K. D. 1992, “Numbers,” in "), _c('i', [_vm._v("The Women’s Bible Commentary")]), _vm._v(", London: SPCK, 45–51 • Wenham, G. J. 1997, "), _c('i', [_vm._v("Numbers")]), _vm._v(", Old Testament Guides, Sheffield: Sheffield Academic.")])])])])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT",
    attrs: {
      "id": "ch009"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_153"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-009"
    }
  }, [_vm._v("Deuteronomy")])]), _vm._v(" "), _c('p', {
    staticClass: "CA"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-009"
    }
  }, [_vm._v("John W. Rogerson")])]), _vm._v(" "), _c('p', {
    staticClass: "H1a"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Deuteronomy is a speech delivered by Moses to the Israelites in an area north of the Dead Sea and east of the River Jordan, on the eve of the people’s crossing of the Jordan to take possession of the land of Canaan. In his speech Moses reviews Israel’s recent history as one of disobedience to God’s commandments, and he warns the people of what will be required of them when they settle in Canaan. It will be necessary for them to avoid religious contact with the inhabitants of Canaan, they must set up a sanctuary only in the place which God commands and chooses, and they must observe the laws which God commands. These laws occupy chs. 12 to 26 of Deuteronomy, although they are preceded by a statement and exposition of the Ten Commandments in chs. 5 to 11. In ch. 27 Moses and the elders order a ceremony to be held on Mt. Gerizim and Mt. Ebal at which curses are uttered against anyone who breaks any of twelve commandments. Ch. 28 lists the consequences of observing or ignoring God’s commandments in terms of blessings and disasters, and in chs. 29 to 30 Moses sets before the assembled people two alternatives: either to obey the commandments, which is to choose life and prosperity, or to ignore them, which is to choose death and disaster. Ch. 31 records the appointment of Joshua to succeed Moses, and the final chapter (34) records Moses’ death and burial. This is preceded in chs. 32 and 33 by two long poems entitled the “Song of Moses” and the “Blessing of Moses” (on the individual tribes).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Deuteronomy is thus an elaborate and extended farewell speech by Moses which sets out a blueprint for how Israel is to live as the people of God in the promised land, and it serves as an introduction to the books of Joshua to 2 Kings which relate what happened to the people after the promised land had been occupied.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("For some seventeen hundred years Jewish and Christian interpretation of Deuteronomy took for granted that it was indeed a speech of Moses delivered on the eve of the occupation of Canaan. If critical comment was needed, it dealt with apparent contradictions between the laws in Exodus and those in Deuteronomy. For example, the instructions about observing the Passover in Exod 12:1–27 imply that the Passover lamb will be killed locally by heads of families and that the lamb must be roasted. Deut 16:1–8 requires that the Passover be eaten “at the place which the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" will choose as a dwelling for his name” so that the lambs can be killed at the central sanctuary. In addition, the lamb is to be boiled (NRSV, “cook,” at 16:7 obscures this). Traditional Jewish interpretation dealt with these apparent contradictions by distinguishing the “Passover of Egypt” (described in Exodus 12) from the “Passover of the Land” (described in Deuteronomy 16) and maintained that the Hebrew word for “boil” at Deut 16:7 was a general term for any kind of cooking. Another passage in Deuteronomy that called for comment was its version of the Ten Commandments in Deut 5:6–21 as compared with the version in Exod 20:2–17.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The suggestion made in 1805 by W. M. L. de Wette that the lawbook discovered in the temple in 622 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" in the reign of Josiah (see 2 Kgs 22:8) was Deuteronomy or part of it radically changed the interpretation of Deuteronomy. This suggestion was based on the similarity between the insistence in Deuteronomy that sacrifice to God should be offered only at a central sanctuary chosen by God, and Josiah’s reform, as described in 2 Kings 22–23, which involved closing down all the sanctuaries in Judah except that in Jerusalem. Josiah also ordered that the Passover be celebrated in Jerusalem (2 Kgs 23:21–23; cf. Deut 16:1–8). It would be possible, of course, to link Deuteronomy with Josiah’s reform and also to maintain that it was a speech delivered by the historical Moses. In this scenario Deuteronomy would have been concealed in the temple and would have been long forgotten, only to be discovered during repairs to the temple in the seventh century and then used as the basis for Josiah’s reform. However, fundamental to de Wette’s argument was the fact that if Moses commanded that there should be only one legitimate sanctuary where sacrifice could be offered to God, no one was aware of this before the time of Josiah. Samuel, for example, offered sacrifices at Mizpah (1 Sam 7:5–9), at a city in the land of Zuph (1 Sam 9:5–15), and at Gilgal (1 Sam. 11:12–15), while Elijah complained that the people had destroyed God’s altars while he himself repaired an altar on Mt. Carmel to offer a sacrifice there (1 Kgs 18:30; 19:10).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Research subsequent to de Wette has concluded that Deuteronomy probably began to be composed in the seventh century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" albeit using older material, and that it did not reach its final form until after the exile (i.e., late sixth to early fifth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("). It has noted that Deuteronomy is dependent on, or implies knowledge of, material elsewhere in the opening books of the Bible. Thus, the résumé of Israel’s progress from Mt. Sinai to the River Jordan in Deuteronomy 1–3 implies familiarity with stories in Exodus and Numbers. Some of the laws in chs. 12 to 16 seem to be adaptations of laws found in Exodus 21–23 and 34.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A broad consensus has emerged that describes the origin and growth of Deuteronomy in the following general terms. After the destruction of the Northern Kingdom, "), _c('a', {
    attrs: {
      "id": "page_154"
    }
  }, [_vm._v("Israel, in 722/721 by the Assyrians, refugees came south and settled in Jerusalem and Judah. The need to absorb them into the social and economic systems of Judah gave rise to social problems, including greatly adding to the class of “strangers,” that is, Israelites living in towns and villages who were refugees and thus not members of the established families in those places. However, the refugees also brought with them laws and theological traditions, including a prophetically inspired loyalty to Yahweh as the only God who should be served. Their outlook influenced certain circles in Judah, especially “the people of the land” (independent landowners) and the leading families that provided the administrative elite in Jerusalem. When, on the death of King Manasseh in 640 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", his son Amon was murdered by court officials (2 Kgs 21:23), “the people of the land put the assassins to death” and placed on the throne the eight-year-old Josiah. The motives of those who murdered Amon are unknown, but their action gave “the people of the land” the opportunity to take over the government of Jerusalem and to implement social and religious policies formulated in the laws of Deuteronomy 5–26. The authors of this material will have been scribes in the Jerusalem administration in sympathy with the objectives of “the people of the land.”")])]), _c('a', {
    attrs: {
      "id": "page_154"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Judah at this time (640–622) was still technically a vassal of Assyria, but as Assyrian power declined, a desire for independence in Judah expressed in terms of loyalty to Yahweh grew. By the eighteenth year of Josiah (622 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") independence could be overtly pursued, and a full-scale reform of the cult was undertaken based on an early form of Deuteronomy 5–26. It may well be that these chapters formulated a treaty between Yahweh and Judah which was meant to replace the vassal treaty that Judah had been forced to make with Assyria. This covenant was formulated in terms of an address by Moses to the Israelites when they were assembled together (Deut 5:1).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The next stage in the growth of Deuteronomy occurred during the exile. The trauma of the destruction of Jerusalem by the Babylonians in 587 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" led to much theological reflection on the meaning of this tragedy, and the history of Israel and Judah was seen as one of disobedience to God’s commandments, the end result being the destruction of Jerusalem as a divine punishment. This story was told in the books of Joshua to 2 Kings. On the eve of the return of some of the exiles to Jerusalem after 540 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" Deuteronomy was made the introduction to Joshua to 2 Kings, and chs. 1–4 and 29–30 were added. These latter chapters presuppose that Israel is in exile and promise that God will restore the people to the promised land if they return to God and obey him (Deut 30:1–5). The opening chapters of Deuteronomy picture the Israelites as about to enter the promised land. The analogy is easy to see. The reality of a people about to "), _c('i', [_vm._v("return")]), _vm._v(" to the promised land is addressed by a narrative about a people "), _c('i', [_vm._v("initially")]), _vm._v(" entering the promised land.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The final stage in the growth of Deuteronomy was the addition of material such as ch. 27, expansions to the legal sections of Deuteronomy 19–25 to meet new situations that had arisen after the return, and of the addition of chs. 31–34.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This conjectural outline of the origin and growth of Deuteronomy raises difficulties for commentators and readers. The book can obviously be read in several different ways. Taken on its own terms, it is a unified farewell speech by a single speaker; and this is how Jewish and Christian interpreters understood it for some seventeen hundred years. If it alludes to a situation of exile in chs. 29 and 30, it can be argued that these prophecies were later fulfilled. On the other hand, there is undoubtedly much to gain from trying to understand the laws in chs. 12 to 26 in terms of what can be conjectured about social conditions in Judah in the seventh and sixth centuries. These laws then cease to be timeless instructions about life in Canaan issued before the people had actually arrived there. Instead, they arise out of real situations of crisis and are instances of contextual and applied theology—the work of leaders trying to apply religious principles to social problems in order to solve them compassionately and in a way that reflects God’s graciousness to his people.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Probably no one strategy will solve the problems faced by readers and commentators on Deuteronomy; being aware of these problems, however, will to some extent alleviate them. In what follows, references to passages from Exodus and Numbers which are thought to underlie Deuteronomy will be made only when absolutely necessary. Where the social situation implied in the laws is crucial for understanding them, this social background will be invoked.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("The Literary Units of Deuteronomy")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The book divides neatly into several sections, which are marked by literary introductions.")]), _vm._v(" "), _c('p', {
    staticClass: "NL1"
  }, [_vm._v("1."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("1:1–4:43")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("2."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("4:44–11:32")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("3."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("12:1–28:68")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("4."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("29:1 (Heb. 28:69)–30:20")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("5."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("31:1–29")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("6."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("31:30–32:52")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("7."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("33:1–29")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("8."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("34:1–12")])]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("COMMENTARY")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Deuteronomy 1:1–4:43")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_154"
    }
  }, [_vm._v("The introductory verses, 1:1–5, set the scene for Moses’ speech and are in the third person singular. The perspective of the writer is that of someone who is in Israel, for he describes the setting as being beyond the Jordan, that is, on the eastern side. While the places named in 1:1 cannot be identified, the general area is the broad plain immediately to the north of the Dead Sea and east of the River Jordan. The area is further specified in terms of its journeying distance from Mt. Horeb, Deuteronomy’s name for Mt. Sinai. The fortieth year (1:3) is reckoned from the exodus, and no doubt a certain irony is intended ")]), _c('a', {
    attrs: {
      "id": "page_155"
    }
  }, [_vm._v("in the fact that an eleven-day journey has taken forty years. Why a comparatively short journey should take so long is explained in 1:46 and 2:14. The Israelites spent thirty-eight years between leaving Kadesh-barnea and crossing the brook Zered (probably the modern Wadi El Hesa at the southern end of the Dead Sea), when the unbelieving generation that refused to go up and possess the land had died out. In the irony of the eleven-day journey taking forty years, one of the main themes of the opening four chapters, the persistent refusal of the Israelites to trust in God’s promises, is introduced.")])]), _c('a', {
    attrs: {
      "id": "page_155"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The speech of Moses in the first-person singular begins at 1:6 and continues to 4:40. "), _c('b', [_vm._v("Ch. 1")]), _vm._v(" describes the circumstances that led to the prolonged stay at Kadeshbarnea. Whereas this oasis in the Negev desert should have been the base from which the Israelites entered Canaan from the south, it became instead the scene of the first major rebellion recorded in Deuteronomy.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("That the people had become numerous is indicated by 1:9–18 (cf. Exod 18:25–26; Num 11:10–25). Moses had had to appoint helpers to assist him in dealing with disputes that arose among the people. Yet this populous nation was not prepared to advance to the promised land. In spite of God’s promise that an advance into Canaan, described here as the “hill country of the Amorites” (1:7, 19; Amorite is a general term for the pre-Israelite occupants of Canaan), will be successful, the people refuse to advance. They have been frightened by the reports of the men sent to spy out the land (1:28) and ascribe their situation to God’s malevolent will: “because the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" hated us he has brought us forth out of the land of Egypt, to give us into the hand of the Amorites” (1:27). When God decides to let only Joshua and Caleb enter the promised land out of all the people gathered at Kadesh-barnea, the people decide, against God’s counsel through Moses, to fight after all (1:41–46). The inevitable defeat endorses the point that without God the people are powerless.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("Chapters 2–3")]), _vm._v(" indicate that the lesson was learned, at least by the second generation of the men of war. Moses’ résumé charts the journey from the brook Zered to the plains of Moab, avoiding battle with the Ammonites (2:19) just as Israel had avoided battle with Edom and Moab prior to crossing the brook Zered (2:4–9). However, no mercy was shown to Sihon, king of Heshbon, and Og, king of Bashan (2:26–3:11; cf. Num 21:21–35). Their cities were captured and their inhabitants were killed, including women and children (2:34; 3:6).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The accounts of Israel’s success in warfare raise for the first time in Deuteronomy a matter that is problematic for modern readers: the wholesale killing of inhabitants of defeated cities. Rules of warfare are given later, in Deut 20:1–20, and they are less harsh than in chs. 2–3. They require the killing of males only, and give cities the option of surrendering, in which case the inhabitants are put to forced labor. These rules will be commented on later. However, even they will be offensive to modern readers.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Various attempts have been made to soften the impression created by this material. Attention has been drawn to one of the likely sources of Deuteronomy, Exod 34:10–28, with its uncompromising insistence that the Israelites have no dealings with the inhabitants of Canaan and its promise that God will cast out the nations that dwell in Canaan (Exod 34:24). But even if Deuteronomy 2–3 is an interpretation or misinterpretation of this source, this hardly ameliorates the sentiments expressed in Deuteronomy. Again, it has been argued that the language of Deuteronomy merely employs the rhetoric of conquest typical of the ancient Near East, a rhetoric that is not meant to be taken literally. For example, in the so-called Moabite Stone (c. 850), Mesha, king of Moab, claims to have killed seven thousand Israelite men, boys, women, girls, and maidservants in Nebo on the instructions of the god Chemosh ("), _c('i', [_vm._v("ANET")]), _vm._v(", 320).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("An older view, that language about wholesale destruction of inhabitants is a survival of ancient practice in Israel, is no longer tenable. The actual Israelite occupation of Canaan was a gradual and mostly peaceful one, and it is later literature that portrays it in such violent and destructive terms. The most likely explanation is that these descriptions were written at a time when Judah was under the control of powerful empires such as Assyria and Babylon. By looking back to a supposed time when God had driven other nations before them, they gained encouragement for their own future. If they obeyed God, he would free them from the yoke of foreigners. Readers must judge for themselves whether this helps them come to terms with chs. 2–3. Two further points can be added. If the OT represents God as driving out nations before the Israelites, it also insists that God uses other nations to punish Israel (e.g., Isa 10:5–11). Second, the justified moral indignation that readers feel when they read about the indiscriminate slaughter of men, women, and children must be tempered by the recognition that the slaughter of human beings was carried out on an unprecedented scale in the world wars of the twentieth century. This does not in any way justify it, but it does qualify our right to judge other times and places. The real problem of Deuteronomy 2–3 remains that it is God who is presented as requiring and bringing about the slaughter, and readers are entitled to ask, with Abraham in Gen 18:25, “Shall not the Judge of all the earth do what is just?”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Chapter 3 ends with an account of the settlement of the tribes of Reuben and Gad in Transjordan and of the acquisition by part of the tribe of Manasseh of territory east of the Jordan (3:14–15). The decision to bar Moses from entering the promised land is confirmed (3:23–29). It seems paradoxical and ironical that Moses should be both the great deliverer and lawgiver of his people, and yet the one who shares the fate of the redeemed yet disobedient generation that is denied entry to the promised land. Yet this harsh judgment on Moses is in line with what is found elsewhere in the OT, that human leaders are just that (cf. the treatment of David’s adultery and murder in 2 Samuel 11–12), and that those who heed the call of God find themselves drawn into suffering and possible rejection.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_155"
    }
  }, [_c('b', [_vm._v("Chapter 4:1–40")]), _vm._v(" switches from the narrative about Israel’s progress from Mt. Horeb to the threshold of Canaan and becomes a passionate exhortation to Israel to observe God’s statutes and ordinances. It alludes to past events: to Israel’s apostasy at Baal-peor (knowledge of ")]), _c('a', {
    attrs: {
      "id": "page_156"
    }
  }, [_vm._v("Num 25:1–18 is assumed by 4:3–4), to the giving of the Ten Commandments on Mt. Horeb (4:9–14), and to the exodus from Egypt (4:34–38). It also hints, prophetically from Moses’ point of view, at the Babylonian exile, when Israel will be scattered among the nations and subject to peoples that serve gods made by human hands (4:25–28).")])]), _c('a', {
    attrs: {
      "id": "page_156"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The purpose of the exhortation is not simply to advise the Israelites of what is in their best interests. The exhortation is driven by the belief that there is no God in heaven and earth other than the God of Israel (4:39), and his commandments are the most just ordinances that could be devised (4:8). By observing them, Israel will be seen by the world to be a great, wise, and discerning people (4:6). The special relationship between God and Israel is also indicated, as well as the privilege and responsibility that this entails. “Has any god ever attempted to go and take a nation for himself from the midst of another nation?” (4:34).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The exhortation takes the general form of a collection of laws, such as that of Hammurabi, with an introduction (4:1–8), a setting forth of the law (4:9–31), and an epilogue (4:32–40). Further, vv. 9–31 have been compared with vassal treaties, with vv. 10–14 being a prologue, vv. 15–19 and vv. 23–44 demanding the complete loyalty of the people, and vv. 25–31 containing blessings and curses. Vv. 15–20 are an exposition of the commandments in the Decalogue that forbid the making of any human, animal, or natural representation of God and the worship of the sun, moon, or stars. This anticipates the later general patterning of the laws of Deuteronomy around the Ten Commandments.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("4:41–43")]), _vm._v(" switches to third person narrative and describes how Moses designated three cities of refuge in Transjordan to protect anyone who had accidentally killed another person. Once in a city of refuge, the killer would be protected from a member of the deceased’s family taking revenge for the killing. The passage presupposes Num 35:9–34, where the operation of the cities of refuge is explained in detail and the designation of the cities is described as a task to be carried out "), _c('i', [_vm._v("after")]), _vm._v(" the crossing of the Jordan into Canaan (cf. Josh 20:1–9, where this is done). Within the context of Deuteronomy, 4:41–43 is best seen as an anticipation of 19:1–13, where the operation of cities of refuge is commanded but no cities are designated. The compiler has placed these verses immediately before one of the other rare pieces of narrative in Deuteronomy so as not to intrude third person narrative into material in the first person or imperative command forms. The three cities designated are located in the three main regions of Transjordan northward from the top of the Dead Sea. Whether there were Jews living in this area when Deuteronomy reached its final form (6th–5th cents. "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") is uncertain, and the purpose of this regulation may simply be to claim Israelite possession of these areas of Transjordan.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Deuteronomy 4:44–11:32")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('b', [_vm._v("4:44–49")]), _vm._v(" introduce the laws and statutes that Moses is to set before the people, whereas 1:1, “These are the words …,” introduces a historical résumé. Commentators have seen in the apparent duplication of material in vv. 44 and 45, “This is the law that Moses set …,” and “These are the decrees … that Moses spoke …,” evidence of compositional processes. Certainly, vv. 45–49 could be a summary of chs. 1–3 (or are these chapters an expansion of 4:45–49?), leaving v. 44 as an “original” introduction to Deuteronomy before 1:1–4:40 was added as a preface. These compositional matters do not fundamentally affect the interpretation of the verses.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In "), _c('b', [_vm._v("5:1–5")]), _vm._v(" another introduction, “Moses convened all Israel, and said …” (5:1), prefaces Deuteronomy’s version of the Ten Commandments in "), _c('b', [_c('i', [_vm._v("5:6–21")])]), _vm._v(". The emphasis is on the immediacy of the divine revelation. “Not with our ancestors did the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" make this covenant, but with us, who are all of us here alive today” (v. 3). It is reasonable to suppose that in the context of late seventh-century Judah, the people were assembled to hear the laws contained in Deuteronomy read to them, with the implication that they should think of themselves as representing the generation addressed by Moses.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Ten Commandments are most familiar in their form in Exod 20:2–17. The Exodus version, supplemented for Lutherans and Catholics by Deut 5:21, has been used in church liturgies and catechisms for centuries. The major difference between the two versions is the reason why Israel must observe (5:12; Exod 20:8 has “remember”) the sabbath day. In Exod 20:11 the commandment is grounded in an appeal to the creation story, with God resting on the seventh day. In Deut 5:15 the commandment is connected with the exodus and with Israel’s deliverance from slavery. Appeal to the exodus deliverance as the ground for observing the commandment is characteristic of Deuteronomy.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The other main difference concerns the final commandment. Whereas Exod 20:17 reads “You shall not covet your neighbor’s house; you shall not covet your neighbor’s wife,” Deut 5:21 puts the neighbor’s wife at the head of the prohibition. This is not a way of saying that a man’s wife is his most important possession, a formulation that would rightly offend modern readers. Deuteronomy is sensitive to the position of women, and the Deuteronomic reformulation of Exod 20:17 removes the wife from a subordinate position among other goods and chattels to be the prime subject of a separate commandment. For commentary on the details of the other commandments see the commentary on Exod 20:1–7.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("5:22–33")]), _vm._v(". In Exodus 19–20 the description of the divine presence on the mountain in all its awe and wonder precedes the Ten Commandments. Here it follows as part of Moses’ narrative. While Moses is designated as the intermediary through whom God spoke, this passage emphasizes that God was speaking to the whole people and not just to Moses (cf. 5:4–5). The role of Moses as intermediary is necessary because the leaders of the people fear that they will be destroyed by the fire with which the mountain burns (cf. Exod 19:12–24, where it is God who warns the people not to approach the mountain). This mark of respect is acknowledged by God (5:28) and used as an object lesson for the presumed hearers/readers of Deuteronomy. Anyone who fears the destructive fire of the holy mountain should take seriously the commands of God.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_156"
    }
  }), _c('a', {
    attrs: {
      "id": "page_157"
    }
  }, [_c('b', [_vm._v("6:1–25")]), _vm._v(". A new section is introduced by the words “Now this is the commandment …,” but the emphasis moves from an address to the generation that stood at Mt. Horeb (5:4) to instruction to children and children’s children. If the generations are obedient, they will multiply greatly in the promised land (6:3). V. 4 begins the opening section of the most famous prayer of Judaism, the Shema, so named because of the Hebrew imperative "), _c('i', [_vm._v("shema"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")])]), _vm._v(", meaning “hear!” The whole prayer consists of Deut 6:4–8; 11:13–22 and Num 15:37–41 and is recited twice daily by observant Jews. The translation and interpretation of the opening words are problematic, as indicated by the various alternative renderings provided as footnotes in the NRSV. The Hebrew is literally, “Yahweh our God, Yahweh one,” with the NRSV representing Yahweh as “"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LORD")]), _vm._v(".” On the basis of usage elsewhere in Deuteronomy, it is unlikely that “Yahweh our God” should be rendered “Yahweh is our God,” against the NRSV text; it is more likely that “is” should be added between “Yahweh” and “one.” This yields the translation “the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" our God, the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" is one.” It is then necessary to explain what is meant by “one.” This most likely refers to Yahweh’s uniqueness. He alone is God, and he needs no other gods to assist him. However, this unique and incomparable God is also, for Israel, "), _c('i', [_vm._v("our")]), _vm._v(" God, not because of what Israel deserves or merits but because of God’s graciousness (cf. 7:7). The uniqueness of God leads to a unique claim upon Israel: the Israelites must love God with heart, soul, and might (6:5). “Love” in this context includes an emotional element, as indicated in 7:7–8 where it is said that God set his heart on Israel (Heb. "), _c('i', [_vm._v("hashaq")]), _vm._v(", meaning “to love” or “become attached to”) and chose and loved them. But it also entails loving obedience to God’s commandments.")])]), _c('a', {
    attrs: {
      "id": "page_157"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The phrase “with all your heart and with all your soul” is a trademark of Deuteronomy and of books influenced by it, and it occurs for the first time at 4:29. The metaphors do not mean the same as in English. The “heart” is the seat of the intellectual faculty of a person, while the “soul” (Heb. "), _c('i', [_vm._v("nephesh")]), _vm._v(") is the seat of emotional and spiritual faculties. "), _c('i', [_vm._v("Nephesh")]), _vm._v(" can also mean “person.” Heart and soul taken together thus mean a person’s total life, physical, mental, and spiritual. In 6:5 “might” is added, probably referring to a person’s material possessions. The injunction to recite “these words” when a person lies down and rises up and that they should be placed on their hands, foreheads, and doorposts has given rise in Judaism to the recitation of the Shema prayer evening and morning, to the wearing of phylacteries at times of prayer, and to the placing of "), _c('i', [_vm._v("mezuzot")]), _vm._v(" on doorways. These practices continue to this day. Phylacteries contain Deut 6:4–9, 11:13–21, and Exod 13:1–10, 11–16, while "), _c('i', [_vm._v("mezuzot")]), _vm._v(" contain Deut 6:4–9 and 11:13–21. In the original context of 6:6–8 “these words” refers to all that is to be commanded, and the injunctions about why the words should be recited and where they should be placed are powerful rhetoric stressing the abiding importance of what is enjoined. It may also be based, however, on the fact that, in the ancient Near East, people wore amulets to give them protection, and that doorposts inscribed with sacred words have been found in Egypt (see Weinfeld 1991: 341–43 for further details).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("6:10–19")]), _vm._v(" set the demand for loyalty to God alone in the context of the fact that in Canaan the Israelites will benefit from things that they have not themselves produced: large cities, well-stocked houses, hewn cisterns for collecting water, and vineyards and olive orchards. They imply that this prosperity will lead them to forget the God who freed them from slavery and tempt them to serve other gods. This brings two warnings: God’s zealous anger will be kindled against his people if they act thus. The people are also reminded of the Massah incident (Exod 17:1–7) when they complained about the lack of water and questioned whether God was with them. They are not to repeat this testing of God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In "), _c('b', [_vm._v("6:20–25")]), _vm._v(" the reason for obeying God’s commandments, that they are Israel’s response to God’s graciousness in freeing them slavery in Egypt, is emphasized by way of an answer to questions from future generations. To the question “What do these things mean that God has commanded?” the reply is given in terms of a rehearsal of the exodus deliverance. The implication is that what was true for those who were delivered from slavery is true for all subsequent generations, including that to which Deuteronomy is addressed.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("7:1–6")]), _vm._v(". The Israelites are commanded to make no covenant with the inhabitants of Canaan nor to intermarry with them. These injunctions in vv. 1–4b are in the second person "), _c('i', [_vm._v("singular")]), _vm._v(" imperative. The command to destroy their altars and other sacred objects in v. 5 is in the second person "), _c('i', [_vm._v("plural")]), _vm._v(" imperative and widely regarded as the work of a later editor. The narrow exclusivism demanded will not be attractive to modern readers; but what is being expressed is the conviction that the standards of justice and compassion demanded by God for his people will not be found among the occupants of Canaan and that mixing with these peoples will compromise those standards. The reference to the “sacred poles” (Heb. "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("asherim")]), _vm._v(") in v. 5 is interesting in the light of recent archeological discoveries, which raise the question whether, in some forms of popular Israelite religion, the God of Israel had a female consort, Asherah. This possibility cannot be ruled out and would make sense of the command here to destroy such objects.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The seven nations named in 7:1 represent the Deuteronomic version of a tradition that elsewhere speaks of six nations that occupied Canaan prior to the Israelites (Exod 23:23). These “nations,” that is, groups who occupied particular cities (e.g., the Jebusites in Jerusalem, the name of which was also Jebus; see Judg 19:11) or who could be identified in some other way, had long since ceased to exist when Deuteronomy was composed, and now symbolized human forces that could not have been defeated by Israel unaided by God.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_157"
    }
  }, [_c('b', [_vm._v("7:7–11")]), _vm._v(". Amid the warnings to Israel of the consequences of turning away from God occur sublime verses that emphasize his compassion and mercy. The redemption from slavery in Egypt, which is the basis of God’s claim on Israel, was accomplished not because Israel was a numerous people but because it was the fewest of all peoples. A contrast with the seven mightier and more numerous nations of v. 1 is implied. God’s action in Egypt was motivated by his love for Israel and his loyalty ")]), _c('a', {
    attrs: {
      "id": "page_158"
    }
  }, [_vm._v("to his promise to the ancestors, Abraham, Isaac, and Jacob. God not only demands loyalty from his people: he is faithful and loyal to the covenant that he makes.")])]), _c('a', {
    attrs: {
      "id": "page_158"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("7:12–26")]), _vm._v(" enumerate and emphasize the advantages that will accrue from loyalty to God. They include fruitfulness of the womb, the land, and domesticated animals, and freedom from illness. These blessings presuppose the possession of Canaan. This latter task, impossible from a human standpoint, will be achieved with the help of God, who defeated Pharaoh and Egypt at the exodus. However, once Canaan has been occupied, the idols and images of the people there must be destroyed so that they do not become a snare to the Israelites. The “abhorrent thing” in v. 26 is probably the idol of a false god.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Two lifestyles are contrasted in "), _c('b', [_vm._v("8:1–20")]), _vm._v(": a prosperous one that will accrue from living in the land with flowing springs, abundant trees, and minerals such as iron and copper; and the lifestyle of the wilderness in which the Israelites depended not on the natural resources of the land but on God’s special provision, as in the giving of the manna (cf. Exodus 16). The Israelites are warned not to suppose that the prosperity that they will enjoy in Canaan is the result of their own efforts, for then they will forget God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The rhetoric of the chapter relies on a certain amount of idealization. Life for subsistence farmers in the hill country of Judah and of Samaria was not easy, and famines are mentioned in the stories of Abraham, Jacob, and Ruth as well as in prophetic warnings. On the other hand, groups that inhabited the wilderness lived largely off the natural vegetation and other resources of the area, and they did not have to construct terraces, organize plowing, sowing, and harvesting, or arrange for fields to lie fallow more frequently than once every seven years. On the face of it, Deuteronomy 8 has reversed what was actually the case, namely, that settled life needed much more organization and application than the mobile life of the wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("We may detect in the rhetoric something of an antagonism that was widespread in the ancient Near East between the wilderness and settled ways of life. The simplicity of the wilderness, its closeness to nature, and the virtues of independence, courage, and hospitality that it engendered were prized above what was seen to be the idle luxury, corruption, and injustice of life in cities (cf. Isa 3:16; 4:1; Amos 4:1; 6:4–7). The God of Israel was a God who had come from the wilderness (Ps 68:7–8) and who had revealed his law in the wilderness. The problem addressed in Deuteronomy 8 is therefore how the Israelites could maintain honesty, simplicity, and justice in reliance on God in an environment which bred and had bred in Israel’s history a disregard for God, and which produced in its turn a disregard for fellow Israelites.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("9:1–11:31")]), _vm._v(". Chapter 9 begins a long section which contains a résumé of Israel’s history of rebellion against God during the wilderness wanderings, with particular reference to the incident of the golden calf (Exodus 32). It is structured as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "NL1"
  }, [_vm._v("1."), _c('span', {
    staticClass: "space1"
  }, [_c('b', [_vm._v("9:1–7. A")]), _vm._v(" summons to Israel to remember that they are a stubborn people and that their forthcoming success in occupying Canaan will depend on God’s grace to them in spite of their stubbornness. Also, their conquest will be God’s way of punishing the wickedness of the nations that occupy Canaan.")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("2."), _c('span', {
    staticClass: "space1"
  }, [_c('b', [_vm._v("9:8–10:11")]), _vm._v(". A résumé of the golden calf incident: how Moses smashed the two tablets of the commandments, how he interceded for Aaron and the whole people, and how he made an ark to contain the new tablets on which God wrote the Ten Commandments (a literal translation is “Ten Words”). There are two digressions in this block: 9:22–24 and 10:6–9. The first alludes to other occasions when Israel provoked God’s anger: at Taberah (Num 11:1–3), Massah (Exod 17:1–7), Kibroth-hattaavah (Num 11:31–34), and Kadesh-barnea (cf. Deut 1:19–33). The second refers to the death of Aaron, the succession of his son Eleazar as priest, and the designation of the tribe of Levi as bearers of the ark of the covenant. The place names in 10:6–7 are evidently taken from Num 33:31–33, although this latter passage is a small part of a much fuller itinerary. Beeroth-bene-jaakan means the wells of the “bene” (sons of) Jaakan, a tribal group in the wilderness west of the central rift valley. Gudgodah contains the same Hebrew consonants as Hor-haggidgad at Num 33:32. In contradiction of Num 33:38 where Aaron dies on Mt. Hor, 10:6 places Aaron’s death at Mosarah, which may involve a pun on the Heb. "), _c('i', [_vm._v("musar")]), _vm._v("—“reproof.” The two digressions are generally seen as later additions to Deuteronomy, although not necessarily from the same hand because the first retains the first person address to Israel while the second is in the narrative third person. The purpose of the second digression would appear to be to legitimate the priestly functions of the descendants of Aaron and the tribe of Levi.")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("3."), _c('span', {
    staticClass: "space1"
  }, [_c('b', [_vm._v("10:12–11:12")]), _vm._v(". This section demands Israel’s loyalty, with “all their heart and all their soul” (10:12). It reiterates the contrast between God’s greatness as God of gods and Lord of lords and his choosing of one particular people. It contains a noble account of God’s ways, who takes no bribes and who cares especially for orphans, widows, and strangers. Also repeated are the themes of God’s power manifested in the exodus deliverance and the promised land as one well provided for in terms of fertility.")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("4."), _c('span', {
    staticClass: "space1"
  }, [_c('b', [_vm._v("11:13–31")]), _vm._v(". The blessings that will accrue from obedience to God’s commandments are again rehearsed, as is the command to bind these words on the hand and the forehead, to affix them to gates and doorposts, and to teach them to one’s children. The alternatives of blessing and curse are set before the Israelites, and a ceremony of blessing and curse on Mt. Ebal and Mt. Gerizim is commanded once the Israelites have occupied Canaan. This latter command is carried out at Josh 8:30–35; there is an amplified version of the injunction in Deuteronomy 27.")])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Deuteronomy 12:1–28:68")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_158"
    }
  }, [_c('b', [_vm._v("12:1–14")]), _vm._v(". The words “These are the statutes and ordinances” in v. 1 are generally held to introduce the central ")]), _c('a', {
    attrs: {
      "id": "page_159"
    }
  }, [_vm._v("legal section of Deuteronomy, which continues to the end of ch. 26. Earlier (7:5, 25) the Israelites have been instructed to destroy the cult objects of the inhabitants of Canaan: altars, idols, and sacred poles. This command is repeated here (v. 4) with the addition that the sacred "), _c('i', [_vm._v("places")]), _vm._v(" of the Canaanites are to be destroyed also. This latter command is the prelude to the injunction that God must be worshiped only in the place that he will choose (vv. 4–7, 11–12, 13–14).")])]), _c('a', {
    attrs: {
      "id": "page_159"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The designation of the "), _c('i', [_vm._v("single")]), _vm._v(" sanctuary, which is never actually identified with a specific place in Deuteronomy, is generally held to be an innovation in Israelite religion and is attributed either to Hezekiah (2 Kgs 18:4; 2 Chr 31:1–2) or to Josiah (2 Kgs 23:4–20). In the books of Samuel and Kings characters such as Samuel and Elijah are portrayed as sacrificing at "), _c('i', [_vm._v("various")]), _vm._v(" shrines, and they seem to be unaware of the command to use only a "), _c('i', [_vm._v("single")]), _vm._v(" sanctuary (see the Introduction, 153). The crucial question, which cannot be answered with complete certainty, is whether Deut 12:4ff. reflects something that was carried out in the eighth or seventh centuries or whether it accords with the situation in postexilic Judah in which Judah was a comparatively small community centered in the temple in Jerusalem.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Those who favor the connection with Josiah point out that, apparently, the altars in the frontier towns of Arad and Beersheba were dismantled in the seventh century. Also, seals of officials in Jerusalem and a frontier town have been discovered that are aniconic, that is, they bear nothing but the name of the official. Earlier seals bear religious symbols. These details would support the account of Josiah’s cultic reforms in 2 Kgs 23:4–20, although they cannot prove that this is what Deut 12:4ff. is implying or reflecting.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is necessary to distinguish two separate things: the destruction of pagan altars, and the command to sacrifice only at a single sanctuary. The first does not entail the second, for it would be possible to destroy all pagan places of worship and to have several legitimate sanctuaries dedicated to the God of Israel. The command to have a single sanctuary is a practical way of expressing the need of Israel to pledge exclusive loyalty to one God.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The command, however, has serious practical implications. If offerings to God can be made only at a single sanctuary (12:5–7) and if whole households are expected to gather at it, how was this to be organized? Later practice did, indeed, involve long journeys to Jerusalem at Passover time (see Luke 2:41–51); but how often could this have been done without disrupting normal life to the point of breakdown? Another implication is considered in vv. 15–27. For the moment we should note that the apparent impracticalities of any "), _c('i', [_vm._v("regular")]), _vm._v(" (several times a year or more) assembly of whole households at a single sanctuary are an argument in favor of linking the commandment to the small, postexilic community centered in Jerusalem.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("12:15–27")]), _vm._v(". These verses raise two issues: “secular” slaughter (vv. 15–16, 20–25) and the economic implications of the single sanctuary (vv. 17–19, 26–27). It is often claimed that, prior to the law of Deut 12:15–16 and the like, all slaughter of animals for the purpose of human consumption was considered to be a sacred act and was carried out at a local sanctuary. The only exception was if game was hunted and killed in the chase (see 12:15). On this view, Deut 12:15–16 and similar passages introduce “secular” slaughter, that is, slaughter purely for the purpose of human consumption as opposed to killing an animal in sacrifice to God. The reason is that the single sanctuary now makes it impractical to carry out "), _c('i', [_vm._v("any")]), _vm._v(" killing for food there.This may be correct; but we have no evidence that "), _c('i', [_vm._v("all")]), _vm._v(" Israelites regarded "), _c('i', [_vm._v("any")]), _vm._v(" killing of an animal for food as a sacred act to be performed only at a sanctuary, and the injunction could just as well be an attempt to clarify an already existing distinction between killing to eat and killing to sacrifice to God, given the impracticalities introduced by the single sanctuary. The command not to eat the blood but to pour it onto the ground (12:23–24) safeguards the sacred quality of blood. It represents the life force of a person (its loss brings about death), and it is used in sacrifice as a substance with great symbolic cleansing power.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The economic implications of eating tithes of grain, wine, oil, the firstlings of herbs and flocks, and other freewill offerings and donations not locally but at the single sanctuary (12:17–19) would be considerable, and involve a massive transfer of resources away from local towns and sanctuaries to the single sanctuary and its town. Presumably, the tithes and other goods would not be entirely consumed by the household that produced them. Dues would be rendered to the sanctuary. Because of the massive transfer of resources implied by these verses, it has been argued that they reflect the circumstances of the postexilic, temple-based community centered in Jerusalem; or if the reign of Josiah is envisaged, they have been seen as part of fiscal reorganization that benefited Jerusalem and the ruling classes at the expense of peasant farmers and their local towns and villages.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("12:29–32 (Heb. 12:29–13:1)")]), _vm._v(". The demand for absolute loyalty to the God of Israel is strengthened by claiming that the inhabitants of Canaan offer even their sons and daughters to God in sacrifice.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("13:1–18 (Heb. 13:2–18)")]), _vm._v(". With this section we meet for the first time in Deuteronomy a form of law that is generally known as casuistic. This is case law and argues from specific instances. It is usually opposed to apodictic law, which lays down a categorical commandment applicable regardless of circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Three examples are given of how the people might be tempted to follow other gods. They might be induced by a prophet (13:1–5), by a member of their own family (vv. 6–11), or by the example of a whole town (vv. 12–18). No mercy is to be shown to any of these. In the case of the town the notion of collective responsibility required the destruction of all its inhabitants. The questionings of Abraham about the morality of destroying the innocent with the guilty (see Gen 18:22–32) may be implied by the injunction that a thorough investigation be made, and the destruction can be carried out only if the charge of apostasy is established. Included with all the inhabitants are the town’s livestock and its “spoil” (Heb. "), _c('i', [_vm._v("shalal")]), _vm._v(", the term for what is taken by an invading army). The implication is that an apostate city has become, in effect, a Canaanite city and is to be dealt with as such (see Deut 20:16–18).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_159"
    }
  }), _c('a', {
    attrs: {
      "id": "page_160"
    }
  }, [_vm._v("Comparisons have been made between this injunction and the clauses in vassal treaties, in which a vassal is threatened with the destruction of his cities if he breaks faith with his overlord. This way of expressing vassal-ship may well be presupposed in Deuteronomy 13; but it is given a religious dimension in that the apostasy of an Israelite town is not merely disloyalty to God but an embodiment of uncleanness and of temptation to others, and must be eradicated without trace.")])]), _c('a', {
    attrs: {
      "id": "page_160"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("There is also, however, a social dimension to the need to execute the prophet or member of one’s family who tries to lead people away from the God of Israel. In both instances the Israelites are reminded that God redeemed them from Egypt, from the house of slavery (13:5, 10). This gives God a claim on the Israelites’ loyalty; but it also has social implications in that God expects Israel to organize itself in such a way as to express in social relationships the graciousness that God has shown to it in delivering the people from slavery. This latter point, not stated explicitly in ch. 13, assumes great importance, especially in ch. 15. Apostasy from God is therefore not merely a matter of what people "), _c('i', [_vm._v("believe;")]), _vm._v(" it profoundly affects their understanding of justice and how society is "), _c('i', [_vm._v("organized")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("At this stage in Deuteronomy, there is no attempt to distinguish true from false prophets (see on 18:22). The sense of 13:3 is that God is using a prophet who advocates apostasy to test the loyalty of Israel. Nevertheless, such a prophet is to be put to death and is by implication a false prophet.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("14:1–2")]), _vm._v(" prohibit two practices associated with mourning rites: gashing one’s skin and shaving the hair of the forehead. Jer 16:6 mentions these signs of mourning, along with others, without any indication that they were other than normal practice, and this raises the question why they are prohibited here (at Lev 21:5 they are restricted to priests, and at Lev 19:28 used with reference to gashing only). The prohibition may, of course, be an ideal: an attempt to get Israelites to abandon mourning practices that they shared with other peoples. The commentaries mention similar practices among peoples ancient and modern. Some also suggest that there is an allusion to fertility rites and to mourning carried out in connection with the “death” of a fertility god. What is clear is that Israel’s special relationship to God as his children (14:1) and as a holy people and treasured possession (v. 2) must be marked by behavior different from that of other peoples.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("14:3–21")]), _vm._v(". The theme that being God’s special people entails special behavior is continued in the prescriptions about which animals are clean and may be eaten and which are unclean and forbidden. The animals are divided into land animals (vv. 3–8), sea creatures (vv. 9–10), and birds and insects (vv. 11–20). Similar prescriptions are found in Leviticus 11 except that there only general regulations are given for classifying unclean animals, whereas Deut 14:3–8 provides a list of names. Lev 11:20–23 deals more extensively with insects than the single verse in Deut 14:20.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Various attempts to account for the classifications and prohibitions have been made, none of which is entirely satisfactory but some of which probably contain elements of truth. Thus, some of the prohibited species may have been believed to be animated by evil forces, or they may have been used in heathen rites, or their flesh may have been unhealthy or had a foul taste. The birds may have been prohibited because some of them were birds of prey that ate the corpses of animals. There may also have been economic reasons behind the ban. It has been argued that pigs were prohibited because they competed with humans for scarce resources of grain. A recent suggestion is that the prohibited species were anomalies that did not precisely fit into the classificatory schemes used by the Israelites to distinguish animals. It is likely that a mixture of superstition, custom, practical economics, and observation combined to produce the lists and that attempts to justify them rationally, for example, by allowing animals that divided the hoof and chewed the cud (v. 6), were retrospective justifications rather than considered first principles. Whether or not ordinary Israelites observed these injunctions is unknown. The injunctions in v. 21a not to eat anything that dies of itself is best understood in terms of the command not to eat blood with the flesh (see 12:23). 14:21b has excited much comment. It occurs also at Exod 23:19 and 34:26, in both cases in contexts regulating the presentation of first fruits. Explanations such as that the killing of an ewe that is suckling its young is prohibited ignore the actual content of the injunction, which is that a kid should not be boiled in its "), _c('i', [_vm._v("own")]), _vm._v(" mother’s milk. It has been claimed on the basis of a fragmentary text from Ugarit that this was a Canaanite practice, although even on the most generous reading the Ugaritic text does not allude to a kid being boiled in its "), _c('i', [_vm._v("own")]), _vm._v(" mother’s milk. An older suggestion (Driver 1902: 166) that the practice was a method of preparing milk that would make fields and orchards more productive is a warning against supposing that attention should be focused on the kid rather than the milk. Labuschagne (1990: 71) links the practice to first fruits, suggesting that the initial milk of the ewe might contain blood and that the regulation was designed to avoid eating blood which had contaminated the milk in which the kid was boiled. This suggestion has the virtue of linking the half verse with the rest of the verse and its implied prohibition of eating blood. However, no interpretation is entirely satisfactory.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("14:22–29")]), _vm._v(". A tithe was a tenth of the produce of the land, whether grain, wine, or oil. This quantity, depending upon time and place in the ancient world, could be required by a king, a sanctuary, or a local ruler as a tax to support central or local administration or the functioning of the religious cult. In 1 Sam 8:15–17 the Israelites are warned that if they have a king he will take from them a tenth of the produce of their land and of their flocks.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_160"
    }
  }, [_vm._v("In Deut 14:22–29 the tithe law is reformulated as a consequence of the centralization of the cult. If it was the case that, prior to centralization, the peasants offered their tithes to local sanctuaries to support, among other things, the priest(s) there, the abolition of local sanctuaries would make a number of priests destitute and create a surplus of produce no longer needed to support local sanctuaries. What would happen to the destitute priests ")]), _c('a', {
    attrs: {
      "id": "page_161"
    }
  }, [_vm._v("and surplus produce? The answer is that the produce is to be brought to the single sanctuary either as produce, or in its monetary equivalent if the peasant lives too far from the single sanctuary. There the produce, or what its monetary equivalent can buy, is to be consumed by the household that produced it, not forgetting the destitute priests (i.e., the Levites). As with the centralization law of ch. 12, this raises questions about the practicality of whole households (see v. 26) traveling to the central sanctuary for this purpose. Presumably, somebody had to remain at home to do the milking and protect the property! Crüsemann (1997: 252–56) argues that the regulations abolished tithes as a form of taxation since they are not to be paid to anyone but to be enjoyed by the producers. For him this proves that the “people of the land”—the landholders—were the authors of or the inspiration behind the Deuteronomic legislation, since this regulation is very much in their interest.")])]), _c('a', {
    attrs: {
      "id": "page_161"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("If 14:22–27 raise practical problems, the same is not true of vv. 28–29. Here a third-year tithe is enjoined which is not to be brought to the central sanctuary but to be stored locally and to be used to feed the Levites, as well as orphans, widows, and resident aliens (Israelites living apart from their kin groups). This has been seen as part of the attempt in Deuteronomy to legislate for the support of the underprivileged, legislation that is continued in ch. 15.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("15:1–6")]), _vm._v(". A seventh year in which the land was to lie fallow and its produce was to be left for the poor and for wild animals is commanded in Exod 23:10–11. Research (Hopkins 1985: 194–95) indicates that actual practice in the highlands of ancient Israel required fields to lie fallow every other year. The regulation in Exod 23:10–11 may well be an ideal rather than a necessity made into a theological virtue. Deuteronomy contains no law about a seventh, fallow year. Instead, 15:1–16 commands a remission of all debts in the seventh year, in obedience to “the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’s remission” (v. 2). The remission applies only to Israelites and not to foreigners (v. 3); and if this is offensive to modern readers, the rule can be explained (but not necessarily justified) as follows. God wants his people to be a community of brothers (the NRSV renders the Hebrew word for “brother” as “member of the community” in vv. 2–3 to avoid gender-specific language), in which case it is inappropriate that it should contain people whose relationship is determined by long-term indebtedness. Foreigners are not members of the people of God and are therefore excluded from the provision.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("15:4–5 can be understood in several ways. The first problem is whether v. 4 states that there will be no one in need (NRSV), or whether it enjoins that there "), _c('i', [_vm._v("ought not")]), _vm._v(" to be anyone in need (NJB, “must not”; NIV, “should not”). The second problem is how to connect this statement or command to what follows. The REB and the GNB rearrange the translation so that the absence of the poor is dependent on obeying God by diligently observing his commandments. There will be no poor if the Israelites remit loans, as commanded. The NRSV implies that there will be no poor because God will bless the Israelites if they obey him. However the verses are rendered, they seem to be contradicted by v. 11, which states that there will always be someone in need; unless, taking the two passages together, the sense is that situations of need will always arise but will not lead to permanent poverty if loans are remitted. V. 6, which envisages Israel lending to nations and ruling over them, need not be read in a sinister way. A people to whom God has been gracious ought to be gracious to other nations.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This passage received particular attention in the “Jubilee 2000” campaign to persuade rich nations to cancel the debts owed to them by poor nations. The biblical Jubilee (Leviticus 25) says nothing about the cancellation of debts or interest, and if biblical support is sought for the campaign, it has to depend on Deut 15:1–6. This in turn raises the question whether this passage is concerned with the remission of "), _c('i', [_vm._v("interest")]), _vm._v(" or the remission of "), _c('i', [_vm._v("debts")]), _vm._v(". Judaism at the beginning of the common era (see Danby 1933: 50–51) certainly understood it to enjoin the remission of "), _c('i', [_vm._v("debts;")]), _vm._v(" it had to find a way around the fact that nobody would be willing to make a loan shortly before the seventh-year cancellation of loans! The seven-year periods were fixed periods in later Judaism rather than periods that began to be counted only from the date of granting of any particular loan.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("15:7–11")]), _vm._v(" articulate a view of social responsibility in which the powerful kin term “brother” is applied to any Israelite in need. The NRSV, avoiding gender-specific language, obscures this, and the RSV is a better indicator of the force of the Hebrew. An Israelite could be afflicted by need in several ways, especially if he was a subsistence farmer. Illness or an accident could affect his ability to work, there might be a failure of the rains, or crops could be affected by blight or insects. Tax demands from a ruler or invader in the form of produce could leave a farmer below subsistence level for himself and his family. It is also possible that refugees are in mind: Israelites driven from their own lands by an invader and sheltering among fellow Israelites. The loans mentioned here could be of produce, animals, or their monetary equivalent; and the imminence of the seventh year of remission of debts must not deter an Israelite from lending to his brother Israelite (see above on the problem in later Judaism). Failure to be generous is a wrongdoing in the sight of God (v. 9b).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_161"
    }
  }, [_c('b', [_vm._v("15:12–18")]), _vm._v(". The laws governing the slavery of Hebrews are probably dependent on those in Exod 21:3–11, with the difference that in Deut 15:12 women slaves are given the same right of release as men slaves. Strictly speaking, these laws would not be necessary if there were no poor (v. 4) and if loans cancelled at the seventh year were made to Israelites in need. However, there are many variables in human relationships and organization. The important points about these verses are their inclusion of women in the law of release (there is no similar provision in Exodus 21) and their appeal to the exodus deliverance from slavery as a reason for acting generously toward released slaves, who will have to establish some form of economic independence (15:14–15). God did not free his people from slavery so that they could enslave each other. Further, the slave is described as a “brother” (v. 12; NRSV, “member of your community”). The public ceremony to be undergone by a slave who wishes to remain as such after ")]), _c('a', {
    attrs: {
      "id": "page_162"
    }
  }, [_vm._v("six years is taken from Exod 21:5–6, with women being included (v. 17b).")])]), _c('a', {
    attrs: {
      "id": "page_162"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("15:18 adds to the theologically driven reasons for releasing slaves the practical economic one, that a master has enjoyed free of charge services for which he would have had to employ hired laborers.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("15:19–23")]), _vm._v(". Laws about firstborn domestic animals are found at Exod 13:2, 11–16; 22:29–30; 34:19–20 and at Num 18:15–18. The formulation in Deuteronomy is distinctive in that it presupposes the single sanctuary and therefore commands that firstborn animals be consumed there annually, whereas Exod 22:30 requires that they be offered on the eight day after birth. Further, the animals will be enjoyed by the household of the producer (cf. 14:22–26). Combined with the injunction is the regulation that only perfect animals are to be offered to God (cf. 13:1). Therefore, any firstborn animal with a defect is eaten locally and not at the central sanctuary.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("16:1–8")]), _vm._v(". Ch. 16 contains Deuteronomy’s cultic calendar, detailing three festivals: Passover (vv. 1–8), Weeks (vv. 9–12), and Booths (vv. 13–18). Vv. 16–17 enjoin three festivals (Heb. "), _c('i', [_vm._v("hag")]), _vm._v(") which are named as Unleavened Bread, Weeks, and Booths (cf. Exod 34:18, 22–23). However, in 16:1–15 only two festivals are named (vv. 10, 13), and Unleavened Bread has become the Passover sacrifice during which no leaven must be seen for seven days. Vv. 16–17 undoubtedly reflect earlier practice, because a festival "), _c('i', [_vm._v("(hag)")]), _vm._v(" is a pilgrim celebration in which the Israelites are expected to appear at the sanctuary (v. 16). Evidently Passover was originally observed as a local festival. The requirement that there should be a single sanctuary made Passover a centralized observance, entailing its combination with the festival of Unleavened Bread.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Compared with the regulations concerning the Passover in Exod 12:1–13, those in Deut 16:1–8 are noteworthy in several ways. First, the mention of flocks and herds (v. 2) implies that another animal instead of a lamb may be offered (cf. NEB, “you shall slaughter a lamb, a kid or a calf”). Second, no mention is made of the blood of the Passover sacrifice. The explanation for observing the Passover is connected with the unleavened bread and the haste with which the Israelites left Egypt (v. 3). The unleavened bread is also called “the bread of affliction” (v. 3—only here in the OT, perhaps recalling Exod 3:7, “the affliction [NRSV, “misery”] of my people”). No doubt the lack of reference to sprinkling the blood on the doorposts so that the angel could "), _c('i', [_vm._v("pass over")]), _vm._v(" is occasioned by the practicalities of killing the Passover sacrifice at the central sanctuary. Nevertheless, a wholesale reinterpretation as well as transformation of the ceremony as implied in Exodus 12 is envisaged.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("16:9–12")]), _vm._v(". Unleavened Bread/Passover was celebrated at the time of the barley harvest (late March/April). The festival of Weeks was named after the seven weeks that were to be counted from the time that the wheat began to be harvested. This would vary slightly from region to region. Later Judaism, basing itself on Lev 23:1–21, developed a strict timetable which linked Weeks to Passover by beginning to count the fifty days (Lev 23:16—Pentecost) from the second day of Passover, when, it was reckoned, the sheaf offering was to be made (see Lev 23:15, taking sabbath to mean Passover). No such strict timetable is envisaged here. The Deuteronomy version of the festival requires the presence of entire households including male and female slaves, strangers, orphans, and widows at the central sanctuary, presumably to share in consuming the offering set aside from the harvest.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("16:13–15")]), _vm._v(". No precise date for the festival of Booths or Tabernacles is given except that it follows the ingathering from the winepress. Nor are details given about how the festival is to be observed or what the significance of the booths is. Presumably this was common knowledge. See Lev 23:33–43 for further details about the festival and its meaning. Again, the presence of entire households at the central sanctuary is required.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("16:18–18:22")]), _vm._v(". There is broad agreement among commentators that 16:18–18:22 is a distinct block of material dealing with four kinds of office: judges (16:18–17:13), the king (17:14–20), priests (18:1–8), and prophets (18:9–22). However, this convenient division should be regarded more as a general guide to reading the passages than as a satisfactory way of interpreting the details. To take one example only, 16:18–17:13 deals explicitly with judges only at 16:18–20 and 17:8–13; and this latter section is concerned with cases that are too complicated for the local judges. Such cases must be referred to the levitical priests and the judge "), _c('i', [_vm._v("(sic)")]), _vm._v(" who is in office at the central sanctuary. 16:21–17:1 deals with worship and sacrifice. It may be possible to explain these diversities in terms of the processes by which the material has been edited into its present form; but this presupposes that readers were and are very sophisticated users of the material. In what follows the diversity of the material will not be suppressed in favour of a neat general classification, however attractive the latter may be.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("16:18–20")]), _vm._v(". This provision, that judges and officials are to be appointed in all the towns and that they must administer justice impartially, may be compared with 1:9–18. In this passage, Moses describes how he appointed leaders to administer justice in the wilderness, reserving for himself the function of dealing with the most difficult cases. In ch. 16 there is the difference that the judges and officials are to be appointed by the people themselves. This may reflect the fact that Deuteronomy is being written long after Moses’ death; and it cannot be supposed that the appointments were made democratically (in the modern sense) by procedures that disregarded traditional structures of leadership such as the headship of the most powerful families. However, it may be significant that the first reference in Deuteronomy to the exercise of power is not in terms of hereditary priests or of monarchy but in terms of local decision making. Although the local exercise of power is not necessarily less corrupt than the central exercise of power, it may be more amenable to accountability.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_162"
    }
  }, [_c('b', [_vm._v("16:21–17:1")]), _vm._v(". These three verses are often identified as belonging to older material that was included in Deuteronomy, the reason being that 16:21–22 seem to prohibit certain practices at "), _c('i', [_vm._v("any")]), _vm._v(" altar dedicated to Yahweh. In the context of Deuteronomy they can only refer to the central sanctuary; and the mention of the sacred pole (Heb. "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("asherah")]), _vm._v(") is relevant to the time of Josiah’s reform. ")]), _c('a', {
    attrs: {
      "id": "page_163"
    }
  }, [_vm._v("Whether Asherah was a goddess or a fertility pole is not clear, but such poles were destroyed by Josiah (2 Kgs 23:6), having been introduced into the temple by his grandfather Manasseh (2 Kgs 21:3, 7). The stone pillar (Heb. "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("maṣebah")])]), _vm._v(") is harder to interpret. The twelve pillars set up by Moses alongside an altar (Exod 24:4) are described by the same Hebrew word. A stone pillar as such was not objectionable, but some usage associated with it, whose precise nature we do not know. The prohibition against sacrificing a defective animal (17:1) repeats 15:21.")])]), _c('a', {
    attrs: {
      "id": "page_163"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("17:2–7")]), _vm._v(". Judges having been appointed (16:18–20), there follow rules governing evidence; but the illustrative case is a religious rather than a civil one and concerns a man or woman who serves other gods. The passage thus continues the cultic theme of the preceding verses. The possibility that people could be falsely accused and wrongly punished (cf. 1 Kings 21, the story of Naboth’s vineyard) is addressed at 19:18–19. Here the judges (although they are not mentioned explicitly) must “make a thorough inquiry.” Two or three (independent) witnesses are required for a successful proof of guilt. An apostate member of the people is as much an abomination (17:4) as a pagan cult object or defective sacrificial animal. However, this indicates a widening of the notion of ritual offense to include religious allegiance as well as ritual practice.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("17:8–13")]), _vm._v(". It is not clear from the Hebrew whether the cases that are to be referred to the central sanctuary are exclusive (i.e., only these cases and no others) or illustrative (NRSV, “any such matters of dispute”). The translations vary. Further, modern translations (e.g., the RSV, NRSV, NIV, and NJB), following much older Christian exegesis, spell out the cryptic Hebrew (“between blood and blood, between plea and plea, and between stroke and stroke”) in a way that differs from traditional Jewish understanding of the passage. For the latter (Rashi 1946: 89) “blood” refers to that of the menstruous woman, while “stroke” is understood as a plague that may be clean or unclean. Modern translations and commentaries are well represented by the NRSV, “between one kind of bloodshed and another,” for example, murder or manslaughter (Exod 21:12–14); “one kind of legal right and another,” for example, theft or embezzlement; or “one kind of assault or another,” for example, some kind of personal injury (Exod 21:18–27). The difference between traditional Jewish and modern critical interpretation is not trivial because the mention of the levitical priests in v. 9 could indicate that the cases referred to were technical ritual cases rather than civil ones. If the modern critical interpretation is correct, the role of the priesthood as envisaged in Deuteronomy is not confined to ritual matters. The levitical priests are to act as interpreters of a civil body of laws.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("17:14–20")]), _vm._v(". Several important features of the law regarding the king should be noted. First, a king is not essential for the people of God as envisaged by Deuteronomy. If they wish, the people may choose a king, the implication being that they do not have to. Second, such a king is as much subject to God’s commandments as any other Israelite, and he even has the obligation to possess and regularly study a copy of the law. No doubt this section presupposes the kind of evaluation of kings that is found in the books of Kings. There the view is maintained that disobedient kings were primarily responsible for the division of the kingdom at the death of Solomon (1 Kgs 11:29–33), the destruction of the Northern Kingdom, Israel (2 Kgs 17:21–23), and the fall of Judah (2 Kgs 23:26–27). The Deuteronomic law is designed to prevent any repeat of this in the future and hints strongly that Solomon was a bad example in 17:17. If there is any truth in the view that the whole section 16:18–18:22 deals with offices in Israel, it is significant that rules about the king are preceded by rules about provincial judges and the priests and judges at the central sanctuary. The king is not at the top of the tree.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("18:1–8")]), _vm._v(". This is perhaps the most difficult section in the whole of Deuteronomy. Little is known for certain about the meaning or derivation of the name “Levite” or about the history of the Levites. The tantalizing glimpses that we get in stories about Levites (Judg 18:1–31) or in sayings regarding them (see esp. Deut 33:8–11) do not provide sufficient information to construct any sort of “history.” Further, our lack of knowledge of the exact nature and history of ancient Israelite social organization makes any attempted theorizing about the Levites highly speculative. Deuteronomy clearly states that any Levite is entitled to exercise priestly functions at the central sanctuary (18:7). In the books of Chronicles (1 Chr 23:2–32) the Levites are assigned less important duties in the sanctuary in support of the sons of Aaron, who alone carry out the priestly tasks. The same division is implied in Num 18:21–32. What history or struggles for power by differing groups lie behind these different pictures is not known.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The present section of Deuteronomy presupposes two situations in which Levites who are priests find themselves. Those already at the central sanctuary (their location is not explicitly stated) are entitled to the shoulder, the two cheeks, and the stomach of an ox or sheep brought for sacrifice as well as the first fruits of grain, wine, oil, and sheep skins (18:4) Different parts of the sacrificial animal are allocated to the priests as their due at Lev 7:32–34. These offerings support the Levites and their families economically. The other class of Levite is not at the central sanctuary but living in the towns (18:6). The law gives such Levites the right to come to the central sanctuary and to receive the same privileges and dues as those Levites already there. This may be an ideal that could not be put into practice—the resources of the central sanctuary were not limitless—and the common theory may be correct that sees the later distinction between Aaronic priests and Levites as the result of Josiah’s reformation. The closure of local sanctuaries would mean the loss of economic support for their priests, and if they were Levites and prevented from coming to the central sanctuary, whatever the law might say (cf. 2 Kgs 23:9), they would become an underclass, dependent on the charity and goodwill of the local communities they had once served (see Deut 14:27). But all this can only be conjecture.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_163"
    }
  }, [_c('b', [_vm._v("18:9–22")]), _vm._v(". The section on prophets begins with a prohibition of child sacrifice, and then condemns various types of occult divination. Taken together with the concluding ")]), _c('a', {
    attrs: {
      "id": "page_164"
    }
  }, [_vm._v("verses, which define true and false prophets in terms of the accuracy of their forecasts, the prophecies are understood as divinely given as opposed to human or occult methods of ascertaining the future. Embedded in the passage, and giving a different view of the function of a prophet, is the famous promise of God that he will raise up a prophet like Moses for the people of Israel: not a prophet who forecasts the future but a prophet who conveys God’s laws to the people; this is recognized in v. 19, where God requires that the prophet’s words (i.e., laws spoken in God’s name) be obeyed. The promise is therefore of one who will mediate God’s commandments, not of one who will be an exceptional forecaster. The NT, following Jewish exegesis of this passage, indicates that hope in the fulfillment of the promise was strong in the first century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" (cf. John 1:21).")])]), _c('a', {
    attrs: {
      "id": "page_164"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("Chapters 19–25")]), _vm._v(". These chapters constitute the third block of legal material within the collection 12–26.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("19:1–13")]), _vm._v(". In 4:41–43 three named cities in Transjordan are designated as “cities of refuge,” without specifying how they are to function. Here their functioning is described, but the three required cities are not designated. The Hebrew of v. 3, “You shall prepare the road (or route, or way),” leads to renderings such as “build roads” (NIV) to “you shall calculate the distances” (NRSV). Rashi (96) charmingly suggests that at each crossroad was to be a notice inscribed “refuge” pointing to the nearest such city. Although the NRSV rendering is free, it is probably closest to the realities of the situation in ancient Israel. The regulations about the cities of refuge are straightforward and provide protection from blood revenge for anyone who accidentally kills another person with whom he has not been at enmity. Noteworthy are the considerations of the nature of the relationship between victim and agent, and the view that the killing of someone guilty of an accidental death would itself be a crime. In 19:11–13 the elders (mentioned for the first time in Deuteronomy in a judicial capacity) are given the duty of handing over to the avenger of blood (a relative of the victim) anyone who has reached a city of refuge but is guilty of murder.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("19:14")]), _vm._v(". Today one can commonly see orderly piles of stones marking the division of fields or property in the Middle East. Inscribed boundary stones containing curses against anyone who moves them are known from the ancient world. Clearly, in a world in which there were no maps as we know them, the division of land depended on tradition and goodwill, and could easily be abused.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("19:15–20")]), _vm._v(". What was touched upon in 17:16–17 regarding witnesses is spelled out in greater detail here, in a passage which is evidently older than the composition of Deuteronomy since v. 17 implies that there will be priests in office in places other than the central sanctuary. The principle is stated that a convicted false witness must suffer the punishment that the accused would have suffered if he (or she) had been found guilty on the basis of the false evidence. This principle leads to an alternative interpretation of the law of talion (an eye for an eye, etc.) from that in Exod 21:23. There it is applied to physical damage inflicted on a person. Here it is connected with the law of evidence.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("20:1–20")]), _vm._v(". The rules of warfare in Deuteronomy have no parallel elsewhere in the OT, and modern readers might well regret their presence here. At the same time it can be argued that, in presenting these rules, the writers of Deuteronomy have tried to suffuse some compassion into them. War is an inescapable, if highly regrettable, feature of human existence, and even in the twenty-first century international bodies have both recognized the right of nations to defend themselves by force of arms if attacked, and tried to ameliorate the effects of warfare on prisoners and civilians.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The extent to which Deuteronomy 20 reflects or includes actual procedures in warfare in ancient Israel is hard to determine. The priestly exhortation to the Israelite army to be unafraid when confronted by superior armies because God would go before them to give them victory (vv. 2–4) must surely express a pious hope rather than describe the real world, as well as arguably introducing the concept of a God who exists for the benefit of Israel and not vice versa. The OT contains abundant evidence that Israelite armies were not invincible. In fact, the verses express the typical themes of passages that elsewhere describe “holy war” (cf. Exod 14:10–18). It is easier to accept such material as a literary creation than to see it as a reflection of actual practice.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The section that provides for exemptions from fighting for those who have just built but not dedicated a house (20:15), those who have planted but not enjoyed the fruit of their vineyards (v. 16), those who have betrothed but not yet married a wife, and those who are afraid are hard to reconcile with the real world, and imply, in the case of those frightened, that the priestly assurance of divine assistance had not produced the desired effect! The justifications for exemption in the first three cases are compassionate, if not utopian, and can be compared with Isa 65:21–22, where the divine creation of a new heaven and earth will create the situation in which")]), _vm._v(" "), _c('p', {
    staticClass: "PF"
  }, [_vm._v("They shall build houses and inhabit them;")]), _vm._v(" "), _c('p', {
    staticClass: "PM1"
  }, [_vm._v("they shall plant vineyards and eat their fruit.")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("They shall not build and another inhabit;")]), _vm._v(" "), _c('p', {
    staticClass: "PM1"
  }, [_vm._v("they shall not plant and another eat.")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The present passage can thus be read as an attempt to put into practice utopian ideals in the most brutal of human situations.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The same cannot be said of the next section, which commands the complete extermination of the non-Israelite population of the cities of Canaan which the Israelites will capture. Cities outside of Canaan are to be treated differently, with only the males slaughtered if there is fighting, and with all the people put to forced labor if the city capitulates without fighting. Distasteful though this material is, it belongs to rhetoric rather than reality. As pointed out earlier (7:1–5), the Israelite occupation of Canaan was gradual and peaceful, and the purpose of the material about conquest and destruction is to stress the need for the people to maintain absolute loyalty to God.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_164"
    }
  }, [_vm._v("The attempt to breathe at least a small element of humanity into rules of warfare concludes with the provision that the fruit trees of a besieged city must not be cut ")]), _c('a', {
    attrs: {
      "id": "page_165"
    }
  }, [_vm._v("down in order to make siege works. The aspect of the real world that comes to the fore here is the knowledge that fruit trees take some years to mature and produce fruit, whereas war can destroy them in a very short time. Such insights have not, alas, been of any interest to those who waged “total war” in the past century.")])]), _c('a', {
    attrs: {
      "id": "page_165"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("21:1–9")]), _vm._v(". This interesting section, embedded in the rules about warfare (which continue at 21:10–14), probably owes its position here to the fact that war was one of the ways in which the body of a slain (lit. “pierced”—e.g., with sword or arrow) person could be found in open country. However, the regulation is not restricted to someone killed in war. Unavenged bloodshed—it was normally the duty of a person’s family to execute a murderer (cf. Deut. 19:4–13)—was held to be an offense in God’s eyes and to pollute the whole land. In the laws of Hammurabi (paras. 23–24; "), _c('i', [_vm._v("ANET")]), _vm._v(", 167) a city or territory in whose governance a crime has been committed, including murder, has the responsibility of compensating the victims. The regulation in Deuteronomy is a detailed ritual with many “primitive” features.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The chief agents are the elders and judges (the reference to the levitical priest in 21:5 is clearly a Deuteronomic gloss, for the Levites take no part in the ceremony), and their actions are paralleled elsewhere in the OT only in the ritual for cleansing a “leper” in Leviticus 14. The feature common to the two procedures is the killing of a bird (Lev 14:5) or heifer (Deut 21:4) over running water and the symbolic removal of guilt or uncleanness. The point of using a heifer that has not been used for work is that it is a young animal not yet used for secular purposes whose first use can be for a sacred ritual. A perpetual stream in a valley neither plowed nor sown is a tall order! Not only were there comparatively few perpetual streams in the land; they were precisely where the land was likely to be worked because of the irrigation that they provided. The provision may, as with specifying the unworked heifer, be a way of indicating sacredness within a natural environment. Perhaps less likely, the perpetual stream would carry any blood from the heifer away from the spot, and there would be no danger of it ending up on human produce if the valley was untilled and not sown (although the text neither mentions any blood nor tells exactly how the heifer’s neck is to be broken—see Rashi [105] for the view that a hatchet was used). How the ceremony was symbolically to remove the guilt belongs to the strangeness of the prescription for modern readers; in its present version it is accompanied by a prayer (21:8). Taken as a whole the passage indicates the sacredness of human life in God’s sight and the need for the community to take this seriously.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("21:10–14")]), _vm._v(". The attempt to make rules of war compassionate continues with the regulation about the treatment of foreign female captives. The shaving of the head and the paring of the nails, together with the month’s mourning for her parents, are a kind of rite of passage that disconnects her from her past. She can now be married to her captor, but if she is subsequently divorced she may not be sold. Uncongenial though these provisions may be for modern readers, they display a higher morality and respect for gender and ethnic differences than those which informed the armies of supposedly civilized nations in the past century, some of whose soldiers regarded the rape of enemy women as one of the rewards of victory.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("21:15–17")]), _vm._v(". The theme of compassion to women is continued in the law requiring a man to leave the major portion of his inheritance to his firstborn son. A polygamous family is presupposed in which it is likely that a second, and younger, wife has been taken by a man after his first wife became less attractive. The regulation preserves the rights of the son of the elder wife (who is most likely to have borne the first son) to his inheritance, and thus to her support if she survives her husband. The right of the firstborn, which is common in the ancient world, is a sensible and practical arrangement for providing for the family on the death of its head. That it caused contention is indicated by stories such as that of Jacob and Esau (Gen 25:29–34).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("21:18–21")]), _vm._v(". The power of a father over his children in the ancient world was, in theory, absolute and could extend to power over life and death. What is interesting in these verses is that the mother is included with the father in the judicial process and that there is public accountability. The conclusion is ambiguous. The evil purged from Israel is no doubt the son whose rebelliousness is not only a social inconvenience but a refusal to obey God’s ways as taught by his parents. But the indiscriminate, publicly unaccountable killing of a son could also be part of the evil.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("21:22–23")]), _vm._v(". The final section of the chapter continues the theme of not defiling the land, by ordering that the bodies of executed criminals should be displayed (hung on a tree) for no more than a day. Presumably, the purpose of such a display was to act as a warning against wrongdoing; but it was also the exhibition of a person and deed that had violated divine law, and as such its open display needed to be limited. Although the verses do not refer to crucifixion, Paul in Gal 3:13 associated them with this form of Roman execution.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("22:1–4")]), _vm._v(". Ch. 22 begins a miscellany of regulations. The first is an enlargement of Exod 23:4–5 which specifies help in restoring to a person’s enemy his lost ox or ass, or helping his ass if it is lying under its load. In Deuteronomy the enemy has become the brother, and Otto (1995: 193) has argued especially that in the particular circumstances of Deuteronomy the obligations normally met within the family group have become the responsibility of the whole people. Every Israelite is a brother, to whom kin obligations apply. The NRSV’s “neighbor” (the literal translation is “brother”) obscures this point. The regulation here not only expands Exod 23:4–5 (and has sheep instead of ass) but also enlarges the scope of the provision to include a garment or any other possession. The command to help the ass is extended to include an ox, and the plight of these animals is broadened to “fallen down by the way.”")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_165"
    }
  }, [_c('b', [_vm._v("22:5")]), _vm._v(". Most commentators regard this verse as a prohibition of pagan religious practice in which gender roles were reversed. The word “abomination” usually refers to religious abuses. However, the words rendered “man’s apparel” are literally “baggage” or “equipment of a ")]), _c('a', {
    attrs: {
      "id": "page_166"
    }
  }, [_vm._v("man,” and this may support the view that it is female participation in warfare and male avoidance of warfare by disguise as a woman that is prohibited.")])]), _c('a', {
    attrs: {
      "id": "page_166"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("22:6–7")]), _vm._v(". Permission to benefit from the eggs of a bird is tempered by a ban on killing the mother bird. This is prudent management; but it also embodies respect for the species as such.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("22:8")]), _vm._v(". The protection of a roof, which could be slept on or otherwise used, by a parapet is common sense. Here it becomes a way of stressing the sanctity of human lives and the blood guilt that is incurred if life is wantonly lost.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("22:9–11")]), _vm._v(". The prohibition against sowing with two kinds of seed may derive from the practical observation that one type of seed can hinder the germination of another (Borowski 1987: 150). Plowing with an ox and an ass yoked together will put unbearable strains upon the ass. Again, prudent management expresses concern for the weaker of the two animals. The prohibition of wearing a garment of mixed stuff may be meant to rule out garments associated with magic.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("22:12")]), _vm._v(". One has to look to traditional Jewish scholarship (Rashi: 110) for an explanation (whether convincing or not) of why the law about tassels occurs at this particular point in Deuteronomy. According to this interpretation the occurrence of the word for “tassels,” which is at the beginning of the sentence in the Hebrew, shows that while garments may not be made of mingled stuff, tassels may be so made. A fuller and more theological reason for the tassels is given at Num 15:37–41. Some experts have drawn attention to the tassels shown on garments worn by "), _c('i', [_vm._v("shasu")]), _vm._v(" nomads (groups mentioned and pictured in Egyptian sources) and have made a link between the "), _c('i', [_vm._v("shasu")]), _vm._v(" and proto-Israelites who may have migrated from Egypt to Canaan.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("22:13–21")]), _vm._v(". The space devoted to regulating marriage in the OT laws is meager in comparison with the more than fifty paragraphs in the laws of Hammurabi (out of the total of 282 paragraphs). There are no explicit instructions in the OT laws about betrothal, marriage contracts, or divorce procedures (see 24:1–4). Yet the material preserved in Deuteronomy 22 is weighted heavily toward the protection of married women.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first seven verses are designed to protect a married woman from being divorced on the grounds that she was not a virgin when she married. She is to preserve the garment (22:17) in which she slept on the occasion of her first intercourse with her husband as evidence to be produced in case she is accused of not having been a virgin. The fact that the father takes the initiative in his daughter’s defense may indicate that he was to retain the garment. If the elders of the city are satisfied that the charge is groundless, the husband is whipped, required to pay a fine to the girl’s father, and excluded from any further attempt to divorce his wife. The value of the fine, a hundred shekels of silver, is not easy to determine, but by way of comparison, Jeremiah (Jer 32:9) is reported to have paid seventeen shekels of silver in order to purchase a piece of land. Perhaps the fine prescribed was sufficiently large to deter husbands from making frivolous charges against their wives. If the proofs of virginity cannot be produced, the girl is to be stoned to death at the door of her father’s house by the men of the city. The blatant unfairness that regards the female as a source of evil to be purged from Israel (v. 21) but not the male who despoiled her prior to her marriage is partly, but not entirely, mitigated in what follows.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("22:22–29")]), _vm._v(". Betrothal was the first stage of marriage in ancient Israel, so that a betrothed woman was regarded in these regulations as a wife. There is a measure of equality in vv. 22–24 in that both the man and the woman caught in adultery are to be stoned to death. Vv. 25–27 and 28–29 tilt the laws in favor of the woman. A betrothed virgin who has intercourse with a man in the open country is given the benefit of the doubt that she has been raped because her cries for help would not be able to be heard. The man is condemned to die. If an unbetrothed virgin is presumed to have been raped, the man is fined (for the value of the fine, fifty shekels of silver, see above on v. 19) and must marry her without the possibility of divorce. However, even this attempt to protect the woman raises questions for modern readers such as whether she would want to marry the man and how he would treat her in marriage. Unfortunately, the quality of relationships is not something that can be legislated, and modern readers should be given at least some credit to the attempt in these laws to do something to protect the legal standing of women.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("22:30")]), _vm._v(" is the beginning of ch. 23 in the Hebrew numbering, but goes most naturally with ch. 22. The prohibition against a man’s taking (i.e., having intercourse with) his father’s wife or wives could apply to two situations. Absalom is said to have gone into David’s concubines when he forced David to flee from Jerusalem (2 Sam 16:21–22), thus indicating his usurping of power. The other situation would arise on the death of a man and the assumption of power by his son. The "), _c('i', [_vm._v("motive")]), _vm._v(" for the regulation is not stated. It could be an expression of repulsion at incest, or it could further extend protection to vulnerable women. The second part of the verse is usually taken to mean that the private sexual life of a man is not to be invaded by a son (cf. Gen 9:22–23, where Noah’s “nakedness,” that is, the fact of his having intercourse with his wife, is treated with respect by two of his sons).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_166"
    }
  }, [_c('b', [_vm._v("23:1–8")]), _vm._v(". This is one of the most difficult sections in Deuteronomy. We do not know what the nature or function of the assembly was, and it is not certain whether a "), _c('i', [_vm._v("mamzer")]), _vm._v(" was a person born of a union such as that forbidden in Leviticus 18 and 20. Furthermore, two different justifications for excluding males from the assembly are given. Those with defective male sexual organs and those born of incest (if this is what being a "), _c('i', [_vm._v("mamzer")]), _vm._v(" refers to) are defective human beings on analogy with the requirement to offer in sacrifice to God only perfect animals (15:21). The reasons given for excluding Ammonites and Moabites (23:3–6) and including Edomites and Egyptians are based on the traditions of interaction between these peoples and Israel. It is likely that two different kinds of material have been put together here. Plausible reasons for the exclusions and the linking of the material can be given. It has been argued that v. 1 refers to men who had deliberately destroyed their ability to procreate, as part ")]), _c('a', {
    attrs: {
      "id": "page_167"
    }
  }, [_vm._v("of a pagan rite. They are therefore excluded because they serve a foreign deity. The "), _c('i', [_vm._v("mamzer")]), _vm._v(" of v. 2 has been linked to the Ammonites and Moabites with reference to the story of Lot’s incest with his daughters in Gen 19:30–38, which resulted in the birth of the ancestors of the Ammonites and Moabites. Again, historical reasons can be given for the passage. The book of Nehemiah explicitly refers to a regulation “in the book of Moses” excluding Ammonites and Moabites from the assembly of God (Neh 13:1) and records hostility toward Nehemiah by the Ammonites (Neh 4:7). The passage may therefore reflect a situation in which the Jewish community was being threatened from Transjordan (Ammon) but was being supported by the Edomites and Egyptians to the immediate south; but this is only speculation. It is probably impossible to be certain about the significance of the section within the book as a whole; for modern interpreters its redeeming feature is that it is not totally exclusive.")])]), _c('a', {
    attrs: {
      "id": "page_167"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("23:9–14")]), _vm._v(". These verses, strangely to modern readers, equate sanitary with ritual purity. That soldiers on active duty avoided sexual intercourse is indicated in narratives such as 1 Sam 21:4–5, so that it may not be illogical that masturbation (23:10) in camp was regarded as an act from which a man needed to be purified (v. 11 and cf. Lev 15:16–18). That the passing of feces was thought to contaminate the camp (23:12–14) is harder to understand, although there were obviously good hygienic reasons for making soldiers bury their excrement outside the camp.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("23:15–16")]), _vm._v(". The rule forbidding an escaped slave to be returned to his master is apparently unique among the laws of the ancient Near East, and, if exploited to any great extent by slaves, would have put that institution under some pressure. Traditional Jewish interpretation (Rashi: 115) took the slave to be a non-Israelite. If the regulation was meant to apply to Israelites also, it is an indication that slavery was tolerated because the social mechanisms required for its abolition were not in place (and did not come into being until the eighteenth century in Europe, and even later in America!). However, the toleration of slavery violated the notion that God’s people should not be enslaved, and this regulation undermined the institution to some extent.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("23:17–18")]), _vm._v(". That sacred prostitution existed in ancient Israel, including in the Jerusalem temple, is indicated by passages such as 1 Kgs 14:24 and 2 Kgs 23:7. It may have served several functions, from being a symbolic act imitating and therefore stimulating fertility of crops or animals, to being a regulated form of prostitution that provided revenues to support a sanctuary. The mention of male prostitutes, referred to in v. 18 as dogs, may indicate that homosexual acts were performed. The vows referred to in v. 18 were presumably vows made by prostitutes. The prohibition of sacred prostitution served to make Israel distinct from its neighbors; but it may also have had a humanitarian effect if not aim. Temple prostitutes were the product of social conditions that the Deuteronomic laws aimed to abolish—in theory, at any rate.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("23:19–20")]), _vm._v(". The prohibition against charging interest to a fellow Israelite must be understood in the first instance in its historical and social setting. If people needed loans, whether of money or produce, it was not in order to invest but to survive. It is entirely in keeping with Deuteronomy that the need of an Israelite to survive should be the occasion for assistance, not of taking advantage. The same attitude does not extend to a non-Israelite, however, although it is not known to what extent the latter would have needed assistance from Israelites in the postexilic community. Christian tradition for over a millennium and Muslim tradition to this day took this and other passages (Exod 22:25 and, especially for Christian tradition, Luke 6:35) to teach a ban on charging interest.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("23:21–23")]), _vm._v(". The need for vows to God to be taken with the utmost seriousness needs no elaboration.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("23:24–25")]), _vm._v(". These two regulations permitting anyone to eat a neighbor’s grapes from his vineyard and to pluck ears of corn from his grain, provided that neither a container nor a sickle was used, could have been abused and have been disastrous to landowners. They are best seen as a humanitarian provision for the poor and hungry in extreme need.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("24:1–4")]), _vm._v(". This is the only passage in the Bible that describes the method of divorce in ancient Israel (the “certificate of divorce” is alluded to at Isa 50:1), and yet this is not the section’s primary purpose, which is to forbid a man from remarrying a wife whom he divorced and who married another man before becoming available for remarriage by divorce or widowhood. Such an act is declared to be abhorrent (Heb. "), _c('i', [_vm._v("to"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("ebah")]), _vm._v("—usually indicating a ritual offense against God). This is more likely to be an old taboo than theological justification for the humanitarian attempt to prevent the first husband from getting a second payment of “bride wealth” (cf. Jer 3:1). Because of the passage’s unique content on divorce it became the center of discussion in early Judaism, with the followers of Hillel and Shammai differing in their interpretation of the difficult Hebrew phrase translated as “something objectionable.” The latter took the phrase to mean “unchastity”; the former broadened it to include almost anything displeasing. It must be emphasized that this discussion was about the interpretation of a difficult piece of Hebrew; divorce practice was weighted in order to make it difficult. Something of that stringency is indicated here. Although nothing is said about the nature or content of the divorce document, the stipulation (twice) that it must be put in the wife’s hand suggests a properly witnessed public procedure. Divorce would have dire economic and social consequences for a woman and her family, and it is interesting here that an old taboo against remarriage outweighs the social advantages that remarriage would bring for the woman.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_167"
    }
  }, [_c('b', [_vm._v("24:5–22")]), _vm._v(". This section contains a set of miscellaneous laws with a strong humanitarian bias. Much of the material can be paralleled elsewhere, but there are interesting differences in some cases. The tendency in Deuteronomy to equate what we would regard as civil and ritual offenses is used to make kidnapping and forcible enslaving ritual abuses (v. 7; cf. Exod 21:16), while the Exodus prohibition against taking a male neighbor’s cloak in pawn (Exod 22:26–27) appears in 24:17 as a prohibition against taking a widow’s garment in pledge. The Exodus version of the law presupposes that a day laborer was required to give a kind of deposit that could be withheld if he did ")]), _c('a', {
    attrs: {
      "id": "page_168"
    }
  }, [_vm._v("not do sufficient work; how this might affect a widow is unclear. Vv. 10–15 contain the strongest regulations anywhere in the OT in support of day laborers or those needing a loan. Creditors may not forcibly enter a debtor’s house; wages must be paid daily before sunset. To act fairly in these matters will earn God’s favor (v. 13); to ignore them will be to incur guilt (v. 15).")])]), _c('a', {
    attrs: {
      "id": "page_168"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("24:16, preventing parents from being put to death for their children’s offenses and vice versa, is meant to operate within human affairs. Divine action could entail corporate responsibility and corporate punishment (Deut 5:9). Whether individual responsibility was first “discovered” in Israel at the exile (cf. Ezekiel 18) is to be doubted. Without a notion of individual responsibility there can be no sustainable ethical, legal, or ritual practice; yet this has to be held alongside the easily observable fact that the decisions of those in power affect the lives of the powerless, often to their disadvantage. What was seen as the punishment of a king was bound to affect the king’s subjects also.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The humanitarian provision about allowing aliens, orphans, and widows to benefit from the wheat and grape harvests (24:19–21; cf. Exod 23:10–11; Lev 19:10) is justified here by reminding the Israelites that they were once slaves in Egypt.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("25:1–3")]), _vm._v(". Judicial flogging as a penalty for crime is well attested in the laws of the ancient Near East (see "), _c('i', [_vm._v("ANET")]), _vm._v(", 175). Strangely, there are no indications in the OT laws of which offenses were to be punished in this way, while instances of people being beaten (e.g., Jeremiah by Pashhur, Jer 20:2) do not precisely fit the law that is enunciated here. The rabbis ("), _c('i', [_vm._v("m. Mak.")]), _vm._v(" 3:1–15 in Danby 1993: 405–8) did specify which offenders were punishable by flogging, for example, those guilty of the illicit sexual liaisons prohibited in Lev 20:17–21. The purpose of the law here is twofold: to insure that flogging was a publicly witnessed process, and to restrict the punishment to what was appropriate in the opinion of judges so that the guilty person was not humiliated. Significantly, the guilty person is described as the innocent person’s brother (in the wider sense of a member of the same community; NRSV, “neighbor”).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("25:4")]), _vm._v(". The reason why an ox might be muzzled while pulling a threshing sledge over the newly harvested ears of barley or wheat was to prevent it from eating the separated grain. Such muzzling is prohibited. A domesticated animal is to be treated compassionately (cf. Exod 23:12). Paul was wrong if, in quoting this passage, he implied that God did not care for oxen (1 Cor 9:9).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("25:5–10")]), _vm._v(". Levirate marriage, the marriage of a childless widow with one of her late husband’s brothers (Lat. "), _c('i', [_vm._v("levir")]), _vm._v(", “brother-in-law”) so that any children inherit the deceased’s name and property, is attested in many societies ("), _c('i', [_vm._v("Notes and Queries on Anthropology:")]), _vm._v(" 117–18). Only here is it found among OT laws, although it is implied in the stories of Tamar and Judah (Genesis 38) and Ruth (Ruth 3:1–4:14), where it is a secondary marriage and not strictly a levirate marriage). To what extent it was regularly practiced is not known, but that the Deuteronomic legislation regarded it as a fundamental way of protecting and providing for childless widows and their deceased husbands, quite apart from their property, is indicated by the ignominy to be suffered by any brother-in-law who refused this obligation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("25:11–12")]), _vm._v(". This is the only passage in the OT laws that specifies mutilation as a punishment for an offense, although it is implied in the law of talion (“eye for eye,” etc.; Exod 21:22–25; Deut 19:21). Jewish interpretation took the passage to be referring to a monetary fine (Rashi: 123). A similar Middle Assyrian law ("), _c('i', [_vm._v("ANET")]), _vm._v(", 181, law 8) assumes that a woman has damaged a man’s testicle in a brawl with him, in which case she is to lose a finger. A male’s sexual potency, both for his own self-esteem and for preventing his family from dying out (this is the possible link with the preceding law), was regarded as sufficiently important in the Deuteronomic legislation to want to deter a woman from even attempting to catch hold of a man’s testicles in defense of her husband.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("25:13–16")]), _vm._v(". This is another instance (cf. 24:7) in which a civil offense is described in terms of a ritual offense (Heb. "), _c('i', [_vm._v("to"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("ebah")]), _vm._v(", “abomination”). That dishonest trading is so fiercely condemned is typical of Deuteronomy’s extension of responsible behavior in God’s eyes to the practicalities of everyday life.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("25:17–19")]), _vm._v(", which recall Israel’s encounter with the Amalekites during the wilderness wanderings (Exod 17:8–16), is linked, via the word “rest” (25:19), with 12:9–12. They form, together with the material in ch. 12, a narrative framework for the laws of chs. 12–25.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_168"
    }
  }, [_c('b', [_vm._v("26:1–11")]), _vm._v(". Following the conclusion of the main body of laws, a number of ceremonies are enjoined, of which two occur in this chapter. The first, that of first fruits, incorporating the “small historical creed” of vv. 5–9, has been the center of much discussion since G. von Rad’s monograph "), _c('i', [_vm._v("The Form-Critical Problem of the Hexateuch")]), _vm._v(", published in German in 1938. Von Rad saw in this summary an ancient, basic “creed” which had been the core of the narrative traditions as developed in Genesis to Joshua. The lack of reference to Sinai and the giving of the law led him to suppose that the latter traditions were associated with a covenant festival at Shechem (see further on Deuteronomy 27), while the “creed” of 26:5–9 was associated with a "), _c('i', [_vm._v("Landnahmefest")]), _vm._v(" (festival of occupying the land) at Gilgal near Jericho (Josh 4:19). The general view now seems to be that, far from being ancient, 26:5b–9 were composed by exilic or postexilic Deuteronomists, expanding older material, traces of which can be found in vv. 2a, 5a, and 10a. On this view, Israelites were accustomed annually to taking their first (or best) fruits to a local sanctuary where they recalled that their ancestor (Jacob; but some would include Abraham) was a wandering (or on the point of perishing) Aramean, whereas the offerer was now settled and able to produce and present a harvest. The passage reached its present form, it is held, by locating the ceremony at the central sanctuary (v. 2b), giving the priest a role in the ceremony (contrast v. 4, where the priest sets the basket down before God, and v. 10, where the worshiper does this) and perhaps a share in the produce. The reference to the wandering ancestor was expanded to include a summary of the story of the oppression in Egypt, the exodus, and the occupation of the land. The final form of ")]), _c('a', {
    attrs: {
      "id": "page_169"
    }
  }, [_vm._v("the text, in its context in Deuteronomy, prescribes a striking ceremony that serves to remind the Israelites of the divine graciousness to which they owe their security and prosperity (v. 11).")])]), _c('a', {
    attrs: {
      "id": "page_169"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("26:12–15")]), _vm._v(". The third-year tithe is first introduced in Deuteronomy at 14:28. Its inclusion in a ceremony (at the central sanctuary? 26:13) again combines the social and the ritual in a manner unfamiliar to modern readers. The purpose of the third-year tithe was to provide for the Levites, aliens, orphans, and widows (v. 12), yet the prayer to be said by the Israelite who has paid the tithe refers to it as a sacred portion (i.e., one dedicated to God so as to be set apart from secular use). Further, the confession of innocence in v. 14 not only declares that the tithe has not been used by the offerer but that it has not been used while he was ritually unclean. The latter declaration about being ritually unclean is not strictly necessary and gives some plausibility to the view that it comes from a declaration that the worshiper has not taken part in any pagan religious activities. What is clear is that the passage strongly links the performance of this humanitarian action with God’s promise to bless the land with abundant harvests (v. 15).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("26:16–19")]), _vm._v(". The two ceremonies are followed by a passage which resumes the address of Moses and therefore rounds off the “sermon” in which the laws and ceremonies have been included. The verses refer to the preceding “statutes, commandments and ordinances” which constitute the agreement between God and his special people. They will be holy to God—a concept in Deuteronomy which combines humanitarian concern and action with ritual purity.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("27:1–26")]), _vm._v(". This is an intriguing chapter in several ways. First, it appears to interrupt the speech of Moses begun in 26:16–19 and continued in 28:1ff. Second, 27:2–8 seem to combine two traditions: that the Israelites are to set up twelve stones as soon as they have crossed the Jordan (v. 2, “on the day that you cross”; cf. Josh 4:1–9) and that they are to set up the stones as well as an altar on Mt. Ebal (if this is the correct reading), which could certainly not be reached on foot from the River Jordan in one day by a large group of people traveling with their possessions. Third, in 27:11–26 the tribes are divided into two groups on Mt. Ebal and Mt. Gerizim—the former to curse, the latter to bless the people. Yet only curses are uttered, and by the Levites, although Levi is one of six tribes on Gerizim whose function is to bless! It is clear from these unevennesses that different types of material have been combined together, some of which may be older than the composition of Deuteronomy.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The so-called Shechemite Dodecalogue (twelve commandments delivered at or near Shechem, which was flanked by Mt. Ebal and Mt. Gerizim), is unparalleled as a collection in the OT although its individual prescriptions can be paralleled from Exodus 20 and 22 and Leviticus 18, 19, and 20. Its form (“Cursed be …”) is also unique for a set of laws in the OT although the curse formula is found, for example, at Gen 3:14. However, the curses in Deuteronomy 27 (and 28) differ from that in Gen 3:14 in that a sentence is pronounced there upon the serpent; here no sentence is indicated. In ancient Near Eastern treaties curselike formulae are found and directed against those who break treaties. The present passage, if it is to be read in treaty terms, understands disloyalty to God in terms of offenses against other people.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The collection is typical of Deuteronomy in the sense that ritual and social offenses occur together. Four of the twelve “commandments” (27:20–23) concern illicit sexual relationships, while six (27:16–19, 24–25) are humanitarian. Only one is specifically “religious” (v. 15, concerning the setting up of an idol or the casting of an image), while the final curse is directed against anyone who does not observe “this law.” It has been noted that a number of the curses refer to private or secret actions such as setting up an idol in secret (v. 15), deliberately misdirecting a blind man (v. 18), and secretly striking down a neighbor (v. 24). As such, and whatever the origin of the Dodecalogue (it is probably a late Deuteronomic composition combining some earlier material), it adds a dimension to the moral responsibility that God is believed to require from his people.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("27:11–14")]), _vm._v(" probably reflect a different ceremony from that implied in vv. 15–26, a more familiar covenant-ratification ceremony in which blessings and curses are uttered (see further on ch. 28).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("27:9–10")]), _vm._v(" may be an introduction to 28:1 and a continuation of 26:19. The participation of Moses and the levitical priests (27:9) contrasts with 27:1, where Moses and the elders address the people (unless one emends the text to read “Moses charged the elders”). Some commentators maintain that the Samaritan Pentateuch is correct in reading Mt. Gerizim instead of Mt. Ebal in v. 4, and that anti-Samaritan sentiment was responsible for the present text. The German "), _c('i', [_vm._v("Einheitsübersetzung")]), _vm._v(" (United Translation) actually has Mt. Gerizim in its main text. For vv. 5–7 cf. Exod 20:25. 27:7 contains the only reference in Deuteronomy to peace or well-being offerings. Burnt offerings (v. 6) are mentioned elsewhere in the book only in 12:6, 11–13, 27.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("Chapter 28")]), _vm._v(" sets before the Israelites the choice of blessings that will follow obedience and punishments that will follow disobedience. For modern readers this may sound immoral. Is the service of God that is undertaken in order to enjoy blessings and avoid disasters really worth the name? This question will be tackled at the end of the section, where it will receive sharpened focus in the light of the grizzly nature of some of the threatened punishments.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The first striking thing about the chapter is that the threatened punishments far exceed the promised blessings. The latter occupy 28:3–14 and are followed by curses in vv. 16–19 that parallel exactly the blessings of vv. 3–6. At this point the similarities end. The seven verses (7–13) that describe blessings are overbalanced by forty-nine (20–68) that detail disasters. However, vv. 20–68 can be divided into three sections: 20–44, 45–57, and 58–68, with vv. 45 and 58 clearly introducing new sections.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A striking feature of 28:20–44 is their similarity at some points with the vassal treaties of the Assyrian king Esarhaddon (681–669; "), _c('i', [_vm._v("ANET")]), _vm._v(", 534–41). Particularly interesting is the similarity between paras. 63–64 and vv. 23–24.")]), _vm._v(" "), _c('table', {
    staticClass: "Table1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdcenter"
  }, [_c('a', {
    attrs: {
      "id": "page_170"
    }
  }, [_c('b', [_vm._v("Esarhaddon")])])]), _vm._v(" "), _c('td', {
    staticClass: "tdcenter"
  }, [_c('b', [_vm._v("Deuteronomy")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-para1"
  }, [_vm._v("May all the gods … reduce your soil in size to be as narrow as a brick, turn your soil into iron, so that no one may cut a furrow in it.")]), _vm._v(" "), _c('td', {
    staticClass: "td-para2"
  }, [_vm._v("The sky over your head shall be bronze, and the earth under you iron.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td-para1"
  }, [_vm._v("Just as rain does not fall from a copper sky, so may there come neither rain nor dew upon your fields and meadows, but let it rain burning coals in your land instead of dew.")]), _vm._v(" "), _c('td', {
    staticClass: "td-para2"
  }, [_vm._v("The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" will change the rain of your land into powder, and only dust shall come down upon you from the sky.…")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Whether these, and some more general, thematic similarities prove that the writer of Deut 28:20–44 actually used a version of the Assyrian vassal treaties is a matter of opinion (see Steymans 1995 for an attempt to prove the case). However, at the least they indicate that Deuteronomy 28 is to be seen as a Hebrew version of a type of literature well known in the ancient Near East at one time. A plausible case can be made for the view that during the seventh century the kings of Judah had been required to agree to an Assyrian vassal treaty similar to that known from the vassal treaties of Esarhaddon, and that a similar form was employed in Deuteronomy in order to articulate Israel’s need for exclusive loyalty to God. On the basis of comparisons with the Assyrian treaties it has been proposed that the core of ch. 28 is vv. 20–44 (the vassal treaties contain only threats against disloyalty), that the bulk of vv. 3–19 was composed before the exile, and that vv. 47–57 (which vividly describe war and siege) and vv. 58–68 (which presuppose the exile and scattering of the people “from one end of the earth to the other” [v. 64]) were appended after the exile. Within vv. 20–44, vv. 36–37 also presuppose exile and may be a latter addition.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The subject matter of the chapter needs little comment. The real problem of the material is its apparent attempt to coerce Israel’s obedience by the threat of dire punishment. No entirely satisfactory answer can be given to this problem for modern readers, but several points can be made.")]), _vm._v(" "), _c('p', {
    staticClass: "NL1"
  }, [_vm._v("1."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The use of the treaty formula inevitably highlights the coercion factor.")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("2."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Within the context of Deuteronomy, with its stress on the humanitarian treatment of others, particularly the poor and disadvantaged, the coercion takes on a different significance. God, as opposed to an Assyrian overlord, does not desire blind loyalty as much as humane and sensitive dealings with fellow Israelites. God’s threats of punishment are directed against a nation that ignores social justice.")])]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("3."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Other parts of the OT (e.g., Psalm 73 and the book of Job) make it clear that there cannot be a simple correlation between obedience and blessing, and disloyalty and disaster. The OT at its most realistic knows that the righteous may suffer and the wicked may prosper. Faith and obedience then become things done for their own sake; yet they need the confidence that the universe is ultimately a moral universe, and this is certainly what the Deuteronomic scheme of blessings and curses is meant to uphold.")])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Deuteronomy 29:1 (Heb. 28:69)–30:20")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("This section contains, according to 29:1 (Heb. 28:69), a covenant made between God and the Israelites in the land of Moab, additional to that made at Mt. Horeb (i.e., Mt. Sinai). Many commentators have detected a covenant form known from extrabiblical texts within the section: (a) historical introduction (29:2–9), (b) statement of the covenant bond (vv. 10–15), (c) a sermon warning of the consequences of disobedience (vv. 16–21), (d) a description of the consequences of disobedience and their causes (vv. 22–29), (e) a sermon giving hope and promising blessing (30:1–10), (f) and a final address promising blessings and threatening disaster, and urging obedience. Whether or not a dependence upon covenant forms can be demonstrated, the analysis gives a useful breakdown of the material.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This section contains many allusions to other parts of the OT. 29:10–15 echoes Deut 5:1–5 but also has reminiscences of Josh 9:3–26. In that passage a covenant is made with the Gibeonites, who become hewers of wood and drawers of water. The same phrase occurs in 29:11. Another passage that has been cited is the incident in Josh 7:1, 16–26 in which Achan wrongly and secretly kept some of the spoil of Jericho. 29:18 warns against individuals who may secretly turn away from God, trusting that the general loyalty of the people will keep them safe. These allusions (they are not exact parallels) may indicate that the material of chs. 29–30 has its origin in “preaching” that was undertaken in the postexilic community, including the use and interpretation of written or oral stories. Thus, there is a reference to the story of the destruction of Sodom and Gomorrah in 29:23. The implied context of 30:1–5 is the exile, with its promise that God will gather and bring back to the promised land those “who are exiled to the ends of the world” (v. 4). This does not mean, however, that these words were composed during the exile. Among the postexilic community was the knowledge that many Israelites remained in exile.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The chapters contain one problematic and several memorable passages. The NRSV translates 29:19 “thus bringing disaster on moist and dry alike,” with a note that the meaning of the Hebrew is uncertain. The Hebrew (29:18) has the sense of something (a severe storm?) sweeping away the fertile land together with the parched land. The phrase appears to be a way of indicating total disaster.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_169"
    }
  }, [_vm._v("30:11–14 is a noble, almost poetic, passage about the availability and accessibility of the commandment. The rendering of v. 14, “the word is very near to you,” raises the question as to what is meant by “the word.” Does it simply mean the commandment of v. 11? The NEB understandably has the rendering “it is a thing very near to you.” Heb. "), _c('i', [_vm._v("dabar")]), _vm._v(" can mean “word” and “thing”; yet the following phrase, “it is in your mouth,” points in the direction of “word” rather than “thing” despite the fact that its exact meaning is not clear. It is quite likely that ")]), _c('a', {
    attrs: {
      "id": "page_171"
    }
  }, [_vm._v("vv. 12–14 once existed independently and have been used here for a different purpose from that of their original context. We are given no clue as to why it should be objected that the word was too high in heaven or too far across the sea to be available. At the same time the enigmatic and poetic nature of the verses has made them attract the attention of later interpreters. In Bar 3:29–30 the verses are quoted in a hymn to Wisdom which uses them to argue for the inaccessibility of Wisdom. In Rom 10:6–8 Paul quotes them in order to maintain that the word of faith which he preaches is close to his readers.")])]), _c('a', {
    attrs: {
      "id": "page_171"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Chapter 30 ends with the call to choose life, which is defined as loving God and holding fast to him. This helps to put into perspective the difficult language of chs. 28–29, which appears to attempt to coerce faithfulness with threats. Ultimately, the appeal to love God is based on his promises to the ancestors, not on the consequences of disloyalty.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Deuteronomy 31:1–29")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("It is easy to recognize that several different types of material have been combined in this chapter. At the level of general content, the theme of the appointment of Joshua to succeed Moses begins in vv. 2–8 and is continued in vv. 14–15 and 23. The account is interrupted, first by vv. 9–13 where Moses commands that the law be read every seventh year at the festival of Booths. It is further interrupted by vv. 16–22 in which God commands Moses to write down a song and teach it to the Israelites so that it will be a witness against them when they serve other gods and are punished by God. The theme of the septennial reading of the law appears to be resumed in vv. 24–29, while v. 30 serves as the introduction to the Song of Moses in ch. 31 and can therefore be seen as resuming vv. 16–22. The results so far can be represented as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "PF"
  }, [_vm._v("Moses and Joshua (vv. 2–8, 14–15 and 23)")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("Moses and the reading of the law (vv. 9–13 and 24–29)")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("Moses and his song (vv. 16–22, 30).")]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("However, it is necessary to look deeper and to note that the first theme, at least, may combine material from different traditions. In 31:2–8 Moses himself introduces the matter of his succession by Joshua, in language that echoes earlier passages in Deuteronomy (cf. the reference to Sihon and Og in v. 4 with Deut 2:26–3:7). V. 14, however, indicates that it is God who intimates to Moses that his end is near and that he and Joshua must go to the tent of meeting—a location mentioned nowhere else in Deuteronomy but familiar from Exodus, Leviticus, and Numbers. Further, there is already an account of Joshua’s installation as Moses’ successor at Num 27:12–23. These duplications (within Deuteronomy 31 and between Deuteronomy and Numbers) no doubt reflect various stages and processes in the growth of the material to its present form. It has also been pointed out that vv. 16–22, dealing with Moses’ song, contain many phrases not otherwise found in Deuteronomy.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The origin of the “song” will be discussed in connection with ch. 32; but its appearance is anticipated in ch. 31 in language that is not characteristic of Deuteronomy but which has been embedded within the chapter and not merely appended. It should also be noted that the phrase “be strong and bold” is found at v. 7 and v. 23, in literature that is Deuteronomic (Josh 1:6). The chapter has therefore combined Deuteronomic and non-Deuteronomic material in order to introduce Joshua (who will feature in the continuation of the story in Joshua), the song of Moses, and the important periodic readings of the law. Gatherings to hear the law read are mentioned, elsewhere, in Neh 8:1–8. As throughout Deuteronomy, God’s faithfulness to his people (v. 8) is contrasted with the people’s potential disloyalty (vv. 16–22). Yet, as mentioned before, God does not require obedience only for his own sake but for the sake of the people, especially the weak and vulnerable, whose protection and support are enjoined in the law. It is no accident that the occasion of the septennial reading of the law is one in which, according to 15:1–11, debts are to be remitted (cf. 31:10, “the scheduled year of remission”).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Deuteronomy 31:30–32:51")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('b', [_vm._v("Chapter 32")]), _vm._v(" divides into three sections: the song (vv. 1–43), an account of Moses’ words following the song (vv. 44–47), and God’s command to Moses to ascend Mt. Nebo, where he will die.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The song is a noble poetic composition that echoes other parts of the OT while remaining unique. From the point of view of the Hebrew several verses are difficult (vv. 5a, 13b, 15a, 19, 26a, 31b, 43), while in vv. 6 and 7 there are awkward switches between the second person singular and plural. The literary figure of Moses is the speaker in vv. 1–19, 28–33, 36–38, and 43, while God is the speaker in vv. 20–27 (with the introduction “he said”), 34–35, and 39–42 (with no introduction). While these alternations, certainly from v. 28 onward, may be the result of later interpolations, the poem in its final state is not disjointed.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The purpose of the song, according to 31:19–22, was to confront the Israelites when they turned to other gods in the promised land. Whether it can be said with confidence that this was not the purpose of the author of the song (so Luyten in Lohfink 1985: 347) is debatable. What may seem to modern readers to be the purpose of a text cannot be assumed to be the view of ancient readers. Leaving aside speculations about the author’s purpose, the following general observations can be made.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_171"
    }
  }, [_vm._v("The poem begins as though it were the speech for the prosecution in a lawsuit (cf. Isa 1:2ff.) but soon becomes a résumé of Israel’s history reminiscent of Psalms 78, 105, and 106 (and cf. the similar opening of Psalm 78). Yet the review of the past makes no mention of the ancestors Abraham, Isaac, and Jacob (Jacob in vv. 9 and 15 is a name for Israel as a whole) nor of the exodus from Egypt. Instead (vv. 10–14), the emphasis is on how God discovered a people in the wilderness that needed to be sustained, and how he met that need. The material has echoes, at the level of theme, of Ezekiel 16 and its parable of the foundling, and it is tempting to see the popular story of an abandoned boy behind these verses. There is no hint ")]), _c('a', {
    attrs: {
      "id": "page_172"
    }
  }, [_vm._v("here, as against the traditions of the wilderness wanderings in Exodus, Numbers, and the opening chapters of Deuteronomy, that the wilderness was a place where the newly freed Israel constantly put God to the test. The language expressing how God cared for the people in the wilderness is vividly poetic.")])]), _c('a', {
    attrs: {
      "id": "page_172"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("This section is preceded by another remarkable one (32:4–6) which deals with creation not from the point of view of the origin of the material universe, but of a system of divine oversight of the peoples of the world. Here the text of the Hebrew at v. 8 is crucial. The traditional Hebrew text, followed by the AV and the RV (and still by the NIV) has, “according to the number of the children of Israel.” Several of the ancient versions together with a manuscript from Qumran have “gods” or “God” for Israel, and most modern translations follow this. The idea (cf. Psalm 82) is that God had appointed divine beings to care for the nations of the earth, reserving for himself the care of Israel. This takes the idea of God’s election of Israel back to creation. The traditional Hebrew text is probably an alteration to remove the reference to other gods. Jewish interpretation refers the verse to the scattering of the nations after the destruction of the tower of Babel and reckons the number of the children of Israel at seventy (Exod 1:5).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the passages that tell of Israel’s turning from God and their punishment (32:15–27) it is not possible to identify for certain the exact occasions of apostasy or of punishment. The threat to make Israel jealous with what is “no people” (v. 21) is too vague to be identified, although attempts have been made to link “no people” with the Assyrians or the Samaritans. There does not appear to be any explicit reference to the Babylonian exile, and the bulk of the poem may therefore predate the exile. Vv. 39–42 have strong resonances with Isa 41:4; 45:6–7; 48:12; and 63:3–6.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A notable feature in the poem is the space given to sentiments of compassion, especially for the future (32:36–42). This may help to give a rough idea of the date of the poem in its final form. If the first part echoes sentiments such as those found in Hosea 11 and Ezekiel 16 and the latter part sentiments of encouragement as found especially in Isaiah 40–55, the guess could be hazarded that the poem was composed any time in the decades prior to the Babylonian exile and that it was completed when hopes were high that the Babylonians would be defeated. The date of the poem is, however, less important than its unusual and powerful presentation of important theological themes.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("32:44–47")]), _vm._v(". Perhaps as though to emphasize that Joshua has already succeeded Moses, v. 44 attributes the song to Moses "), _c('i', [_vm._v("and")]), _vm._v(" Joshua (whose name is given in Hebrew as Hoshea; cf. Num 13:8). The immediately following verse, however, implies that only Moses has recited the song.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('b', [_vm._v("32:48–52")]), _vm._v(". The “very day” on which God commanded Moses to ascend Mt. Nebo (v. 48) may be referred back to 1:3 (the first day of the eleventh month of the fortieth year), the implication being that Moses addresses the people on that day and then dies on the mountain. The reason given for not allowing Moses to enter the promised land is referred back to the incident at Kadesh (Num 20:2–13), although the narrative in Numbers 20 does not make clear what Moses’ offense actually was.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Deuteronomy 33:1–29")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('b', [_vm._v("The Blessing of Moses")]), _vm._v(". The idea that the leader or ancestor should give a blessing at the end of his life is found in Gen 27:27–29, 39–40 (the blessing of Isaac) and Genesis 49 (the blessing of Jacob). Valedictory speeches are also attributed to Joshua (Joshua 24) and Samuel (1 Samuel 12). However, despite the similarities between Deuteronomy 33 and Genesis 49 in that both passages contain sayings that relate to individual tribes, Deuteronomy 33 sets the sayings within a hymnal framework (vv. 1–5, 26–29).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As the footnotes of modern translations indicate, there are many textual difficulties and variations between the Hebrew and the ancient versions. The present commentary is not the place to discuss these in detail, except as they touch on the matter of the date of the chapter. The difficulty of the text and its variants has been used as an argument for the antiquity of the passage. These phenomena can also be explained by the importance of the text within the literature (the blessing of "), _c('i', [_vm._v("Moses")]), _vm._v(") and the fact that it has led to enlargements and interpretations within the versions themselves. Beyerle (1997: 272–73) argues that the various ancient versions should be regarded as editions in themselves and should not be used to try to reconstruct an original text. The only textual comment that needs to be made is that readers familiar with older translations will search in vain in the main text of the NRSV for the words “The eternal God is your dwelling place, and underneath are the everlasting arms” (33:27, RSV).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Three broad issues affect the interpretation of the chapter: (a) whether the hymnic framework was independent of the sayings concerning the tribes, (b) how the sayings relate to those in Genesis 49 and whether they provide material for reconstructing ancient Israel’s history, and (c) what the chapter conveys in its key position at the close of Deuteronomy.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("(a) A widely held view is that the hymnic framework (33:2–5, 26–29) is independent of the sayings. Further, the similarities between v. 2, describing God’s coming from Sinai and Seir, and Judg 5:4–5, Ps 68:8, 17, and Hab 3:3 have led to the argument that the framework derives from an ancient theophany tradition (a tradition about God’s “appearing,” perhaps as part of traditions about holy war). However, the argument about the antiquity of the framework has to regard the reference to Moses in v. 4 as a later addition as well as adopting similar tactics in relation to Psalm 68 (the reference to the temple in Jerusalem [v. 29]) and Habakkuk 3 (taking it to be the addition of an ancient poem to the rest of the book, which dates from the late seventh century). It can just as plausibly be argued that the framework of Deuteronomy 33 is postexilic or that it is not to be separated from other material in the book. The rare designation for Israel, “Jeshurun” (vv. 5, 26), occurs elsewhere only in Deut 32:15 and Isa 44:2 (an exilic text).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_172"
    }
  }), _c('a', {
    attrs: {
      "id": "page_173"
    }
  }, [_vm._v("(b) It has been usual to read the sayings about the tribes in conjunction with Genesis 49, drawing historical conclusions from the differences. Thus Simeon (Gen 49:5) is absent from Deuteronomy 33, Levi is a secular tribe in Genesis 49 but a priestly one in Deut 33:8–11, while Reuben (Gen 49:3–4) gets only the briefest of references in Deut 33:6. These differences led to the view that in the period between the composition of Genesis 49 (in the 11th cent. "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") and Deuteronomy 33 (the 8th cent. "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") Simeon had disappeared, Levi had ceased to be a secular tribe, and Reuben had almost died out. The arguments presupposed the existence of a tribal confederacy in the premonarchic period, a view that is little supported today. More recent studies (e.g., Schorn 1997) have argued that the twelve-tribe concept is a late literary and theological creation and that ancient tribal history cannot be extracted from Genesis 49 and Deuteronomy 33.")])]), _c('a', {
    attrs: {
      "id": "page_173"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Whatever the truth of the latter opinions, two observations are necessary. First, it is northern tribes that are to the fore in Deuteronomy 33. The house of Joseph (i.e., the tribes of Ephraim and Manasseh which occupied the heartland of the Northern Kingdom, Israel, vv. 13–17) receives the longest treatment, while Judah gets only one verse (v. 7). Further, there are sayings about tribes that occupied areas north of the Jezreel valley as far as Dan, and possibly Transjordan (vv. 20–21). The whole of the Northern Kingdom was lost to the Assyrians in 722/721, which is why it has been argued that the sayings must date from before that loss. On the other hand, the opening chapters of 1 Chronicles (usually dated 400–350 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") contain genealogies of the northern tribes including Simeon and Reuben, indicating that interest in these groups or areas existed long after they had ceased to be part of Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The second point to be noted is that material in the sayings about tribes can be paralleled elsewhere in the OT. The material concerning Levi (33:8–11) can be paralleled in Exod 32:26–29, while the Joseph saying (33:13–17) has correspondences with Gen 49:25–26. The sayings can, in some, perhaps most, instances be regarded as literary compositions rather than fragments of ancient history preserved by word of mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("(c) The function of Deuteronomy 33 in its present context is twofold. It gives to Moses the status of someone entitled to give a blessing to the people. Up to this point in Deuteronomy Moses has almost entirely been a mouthpiece for God. Now he speaks in his own name, expressing hopes for the tribes that carry the authority of God’s spokesman. Moses is shown to be in full command of his powers at death (cf. 34:7), speaking with the authority of age and the vigor of one whose powers have not declined.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Second, the Blessing of Moses enables the book to end on the theme of blessing. In some cases (chs. 27–28) threats have outweighed promises. At the end, there are only promises, based on the conviction of the incomparability of the God of Israel, who is his people’s hope and salvation (33:26–29).")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Deuteronomy 34:1–12")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("What ch. 33 implies of Moses in poetry, ch. 34 sets forth in prose. Moses dies with unimpaired sight and undiminished vigor, having glimpsed the promised land from Mt. Nebo. Although his grave is said to be unknown (v. 6), his epitaph is unsurpassed in the Bible: “Never since has there arisen a prophet in Israel like Moses, whom the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" knew face to face. He was unequaled for all the signs and wonders that the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" sent him to perform …” (vv. 10–11).")]), _vm._v(" "), _c('p', {
    staticClass: "Bib1"
  }, [_c('b', [_c('i', [_vm._v("Bibliography")])]), _vm._v(". Beyerle, S. 1997, "), _c('i', [_vm._v("Der Mosesegen im Deuteronomium: Eine text-, kompositions- und formkritische Studie zu Deuteronomium 33")]), _vm._v(", BZAW 250, Berlin: Walter de Gruyter • Borowski, O. 1987, "), _c('i', [_vm._v("Agriculture in Iron Age Israel")]), _vm._v(", Winona Lake: Eisenbrauns • Braulik, G. 1 (1986) and 2 (1992), "), _c('i', [_vm._v("Deuteronomium")]), _vm._v(", Kommentar zum Alten Testament mit der Einheitsübersetzung, Würzburg: Echter • Crüsemann, F. 1997, "), _c('i', [_vm._v("Die Tora: Theologie und Sozialgeschichte des alttestamentlichen Gesetzes")]), _vm._v(", Gütersloh: Kaiser • Danby, H. 1993, "), _c('i', [_vm._v("The Mishnah, Translated from the Hebrew with Introduction and Brief Explanatory Notes")]), _vm._v(", Oxford: Oxford University • Driver, S. R. 3d ed. 1902, "), _c('i', [_vm._v("A Critical and Exegetical Commentary on Deuteronomy")]), _vm._v(", ICC, Edinburgh: T. & T. Clark • Hopkins, D. C. 1985, "), _c('i', [_vm._v("The Highlands of Canaan: Agricultural Life in the Early Iron Age")]), _vm._v(", The Social World of Biblical Antiquity Series 3, Sheffield: Almond • Labuschagne, C. 1a (1987), 1b (1987), 2 (1990), "), _c('i', [_vm._v("Deuteronomium")]), _vm._v(", De prediking van het Oude Testament, Nijkerk: Uitgeverij G. G. Callenbach • Labuschagne, C. 1993, "), _c('i', [_vm._v("Deuteronomium")]), _vm._v(", Belichting van het Bijbelboek, "), _c('span', {
    staticClass: "charSR"
  }, [_vm._v("ʾ")]), _vm._v("s-Hertogenbosch: Katholieke Bijbelstichting and Brugge: Uitgeverij Tabor • Lohfink, N., ed. 1985, "), _c('i', [_vm._v("Das Deuteronomium: Entstehung, Gestalt und Botschaft")]), _vm._v(", BETL 68, Leuven: University Press & Peeters • Mayes, A. D. H. 1979, "), _c('i', [_vm._v("Deuteronomy")]), _vm._v(", NCB, London: Oliphants • Nielsen, E. 1995, "), _c('i', [_vm._v("Deuteronomium")]), _vm._v(", HAT 1/6, Tübingen: J. C. B. Mohr • Committee of the Royal Anthropological Institution of Great Britain and Ireland. 6th ed. 1951, "), _c('i', [_vm._v("Notes and Queries on Anthropology")]), _vm._v(", London: Routledge & Kegan Paul • Otto, E. 1994, "), _c('i', [_vm._v("Theologische Ethik des Alten Testaments")]), _vm._v(", Stuttgart: Kohlhammer • Otto, E. 2000, "), _c('i', [_vm._v("Das Deuteronomium im Pentateuch und Hexateuch")]), _vm._v(", Tübingen: Mohr Siebeck • Pritchard, J. B. 3d ed. 1969, "), _c('i', [_vm._v("Ancient Near Eastern Texts Relating to the Old Testament")]), _vm._v(", Princeton: Princeton University • Rashi. 1946, "), _c('i', [_vm._v("Pentateuch with Targum Onkelos, Haphtoroth and Prayers for Sabbath and Rashi’s Commentary")]), _vm._v(", ed. M. Rosenbaum and A. M. Silberman, London: Shapiro, Vallentine & Co. • Schorn, U. 1997, "), _c('i', [_vm._v("Ruben und das System der zwölf Stämme Israels: Redaktionsgeschichtliche untersuchungen zur Bedeutung des Erstgeborenen Jakobs")]), _vm._v(", BZAW 248, Berlin: Walter de Gruyter • Steymans, H. U. 1995, "), _c('i', [_vm._v("Deuteronomium 28 und die")]), _vm._v(" adê "), _c('i', [_vm._v("zur Thronfolgeregelung Asarhaddons: Segen und Fluch im Alten Orient und in Israel")]), _vm._v(", OBO 145, Freiburg: Universitätsverlag and Göttingen: Vandenhoeck & Ruprecht • von Rad, G. 1964, "), _c('i', [_vm._v("Das fünfte Buch Mose: Deuteronomium")]), _vm._v(", ATD 8, Göttingen: Vandenhoeck & Ruprecht • Weinfeld, M. 1991, "), _c('i', [_vm._v("Deuteronomy 1–11")]), _vm._v(", AB 5, New York: Doubleday.")])])])])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(177),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(180),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(183),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(186),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(189),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(192),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(195),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(198),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(201),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(204),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(207),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(210),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(213),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(216),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(219),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(222),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(225),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(228),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(231),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(234),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(237),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(240),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(243),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(246),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(249),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(252),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(255),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(258),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(261),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(264),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(267),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(270),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(273),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(276),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(279),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(282),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(285),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(288),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(291),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(294),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(297),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(300),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(303),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(306),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(309),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(312),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(315),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(318),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(321),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(324),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(327),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(330),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(333),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(336),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(339),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781467426824',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(343)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(345);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 345 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.155631a42347571e7e68.js